
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5760"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5760"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3zqta", function(module, exports) {

$parcel$export(module.exports, "createExpression", () => create$4);
$parcel$export(module.exports, "template", () => create);
$parcel$export(module.exports, "createBinding", () => create$1);
/* Riot WIP, @license MIT */ 
var $fGGec = parcelRequire("fGGec");

var $8VupT = parcelRequire("8VupT");

var $f4jRS = parcelRequire("f4jRS");

var $dNFiL = parcelRequire("dNFiL");

var $3h6d1 = parcelRequire("3h6d1");

var $8kAdV = parcelRequire("8kAdV");

var $koC5P = parcelRequire("koC5P");
const HEAD_SYMBOL = Symbol();
const TAIL_SYMBOL = Symbol();
/**
 * Create the <template> fragments text nodes
 * @return {Object} {{head: Text, tail: Text}}
 */ function createHeadTailPlaceholders() {
    const head = document.createTextNode('');
    const tail = document.createTextNode('');
    head[HEAD_SYMBOL] = true;
    tail[TAIL_SYMBOL] = true;
    return {
        head: head,
        tail: tail
    };
}
/**
 * Create the template meta object in case of <template> fragments
 * @param   {TemplateChunk} componentTemplate - template chunk object
 * @returns {Object} the meta property that will be passed to the mount function of the TemplateChunk
 */ function createTemplateMeta(componentTemplate) {
    const fragment = componentTemplate.dom.cloneNode(true);
    const { head, tail } = createHeadTailPlaceholders();
    return {
        avoidDOMInjection: true,
        fragment: fragment,
        head: head,
        tail: tail,
        children: [
            head,
            ...Array.from(fragment.childNodes),
            tail
        ]
    };
}
/* c8 ignore start */ /**
 * ISC License
 *
 * Copyright (c) 2020, Andrea Giammarchi, @WebReflection
 *
 * Permission to use, copy, modify, and/or distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
 * REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
 * AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
 * INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
 * LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE
 * OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
 * PERFORMANCE OF THIS SOFTWARE.
 */ // fork of https://github.com/WebReflection/udomdiff version 1.1.0
// due to https://github.com/WebReflection/udomdiff/pull/2
/* eslint-disable */ /**
 * @param {Node[]} a The list of current/live children
 * @param {Node[]} b The list of future children
 * @param {(entry: Node, action: number) => Node} get
 * The callback invoked per each entry related DOM operation.
 * @param {Node} [before] The optional node used as anchor to insert before.
 * @returns {Node[]} The same list of future children.
 */ const udomdiff = (a, b, get, before)=>{
    const bLength = b.length;
    let aEnd = a.length;
    let bEnd = bLength;
    let aStart = 0;
    let bStart = 0;
    let map = null;
    while(aStart < aEnd || bStart < bEnd){
        // append head, tail, or nodes in between: fast path
        if (aEnd === aStart) {
            // we could be in a situation where the rest of nodes that
            // need to be added are not at the end, and in such case
            // the node to `insertBefore`, if the index is more than 0
            // must be retrieved, otherwise it's gonna be the first item.
            const node = bEnd < bLength ? bStart ? get(b[bStart - 1], -0).nextSibling : get(b[bEnd - bStart], 0) : before;
            while(bStart < bEnd)(0, $fGGec.insertBefore)(get(b[bStart++], 1), node);
        } else if (bEnd === bStart) while(aStart < aEnd){
            // remove the node only if it's unknown or not live
            if (!map || !map.has(a[aStart])) (0, $fGGec.removeChild)(get(a[aStart], -1));
            aStart++;
        }
        else if (a[aStart] === b[bStart]) {
            aStart++;
            bStart++;
        } else if (a[aEnd - 1] === b[bEnd - 1]) {
            aEnd--;
            bEnd--;
        } else if (a[aStart] === b[bEnd - 1] && b[bStart] === a[aEnd - 1]) {
            // this is a "shrink" operation that could happen in these cases:
            // [1, 2, 3, 4, 5]
            // [1, 4, 3, 2, 5]
            // or asymmetric too
            // [1, 2, 3, 4, 5]
            // [1, 2, 3, 5, 6, 4]
            const node = get(a[--aEnd], -1).nextSibling;
            (0, $fGGec.insertBefore)(get(b[bStart++], 1), get(a[aStart++], -1).nextSibling);
            (0, $fGGec.insertBefore)(get(b[--bEnd], 1), node);
            // mark the future index as identical (yeah, it's dirty, but cheap 👍)
            // The main reason to do this, is that when a[aEnd] will be reached,
            // the loop will likely be on the fast path, as identical to b[bEnd].
            // In the best case scenario, the next loop will skip the tail,
            // but in the worst one, this node will be considered as already
            // processed, bailing out pretty quickly from the map index check
            a[aEnd] = b[bEnd];
        } else {
            // the map requires an O(bEnd - bStart) operation once
            // to store all future nodes indexes for later purposes.
            // In the worst case scenario, this is a full O(N) cost,
            // and such scenario happens at least when all nodes are different,
            // but also if both first and last items of the lists are different
            if (!map) {
                map = new Map();
                let i = bStart;
                while(i < bEnd)map.set(b[i], i++);
            }
            // if it's a future node, hence it needs some handling
            if (map.has(a[aStart])) {
                // grab the index of such node, 'cause it might have been processed
                const index = map.get(a[aStart]);
                // if it's not already processed, look on demand for the next LCS
                if (bStart < index && index < bEnd) {
                    let i = aStart;
                    // counts the amount of nodes that are the same in the future
                    let sequence = 1;
                    while(++i < aEnd && i < bEnd && map.get(a[i]) === index + sequence)sequence++;
                    // effort decision here: if the sequence is longer than replaces
                    // needed to reach such sequence, which would brings again this loop
                    // to the fast path, prepend the difference before a sequence,
                    // and move only the future list index forward, so that aStart
                    // and bStart will be aligned again, hence on the fast path.
                    // An example considering aStart and bStart are both 0:
                    // a: [1, 2, 3, 4]
                    // b: [7, 1, 2, 3, 6]
                    // this would place 7 before 1 and, from that time on, 1, 2, and 3
                    // will be processed at zero cost
                    if (sequence > index - bStart) {
                        const node = get(a[aStart], 0);
                        while(bStart < index)(0, $fGGec.insertBefore)(get(b[bStart++], 1), node);
                    } else (0, $fGGec.replaceChild)(get(b[bStart++], 1), get(a[aStart++], -1));
                } else aStart++;
            } else (0, $fGGec.removeChild)(get(a[aStart++], -1));
        }
    }
    return b;
};
const UNMOUNT_SCOPE = Symbol('unmount');
const EachBinding = {
    // dynamic binding properties
    // childrenMap: null,
    // node: null,
    // root: null,
    // condition: null,
    // evaluate: null,
    // template: null,
    // isTemplateTag: false,
    nodes: [],
    // getKey: null,
    // indexName: null,
    // itemName: null,
    // afterPlaceholder: null,
    // placeholder: null,
    // API methods
    mount (scope, parentScope) {
        return this.update(scope, parentScope);
    },
    update (scope, parentScope) {
        const { placeholder, nodes, childrenMap } = this;
        const collection = scope === UNMOUNT_SCOPE ? null : this.evaluate(scope);
        const items = collection ? Array.from(collection) : [];
        // prepare the diffing
        const { newChildrenMap, batches, futureNodes } = createPatch(items, scope, parentScope, this);
        // patch the DOM only if there are new nodes
        udomdiff(nodes, futureNodes, patch(Array.from(childrenMap.values()), parentScope), placeholder);
        // trigger the mounts and the updates
        batches.forEach((fn)=>fn());
        // update the children map
        this.childrenMap = newChildrenMap;
        this.nodes = futureNodes;
        return this;
    },
    unmount (scope, parentScope) {
        this.update(UNMOUNT_SCOPE, parentScope);
        return this;
    }
};
/**
 * Patch the DOM while diffing
 * @param   {any[]} redundant - list of all the children (template, nodes, context) added via each
 * @param   {*} parentScope - scope of the parent template
 * @returns {Function} patch function used by domdiff
 */ function patch(redundant, parentScope) {
    return (item, info)=>{
        if (info < 0) {
            // get the last element added to the childrenMap saved previously
            const element = redundant[redundant.length - 1];
            if (element) {
                // get the nodes and the template in stored in the last child of the childrenMap
                const { template, nodes, context } = element;
                // remove the last node (notice <template> tags might have more children nodes)
                nodes.pop();
                // notice that we pass null as last argument because
                // the root node and its children will be removed by domdiff
                if (!nodes.length) {
                    // we have cleared all the children nodes and we can unmount this template
                    redundant.pop();
                    template.unmount(context, parentScope, null);
                }
            }
        }
        return item;
    };
}
/**
 * Check whether a template must be filtered from a loop
 * @param   {Function} condition - filter function
 * @param   {Object} context - argument passed to the filter function
 * @returns {boolean} true if this item should be skipped
 */ function mustFilterItem(condition, context) {
    return condition ? !condition(context) : false;
}
/**
 * Extend the scope of the looped template
 * @param   {Object} scope - current template scope
 * @param   {Object} options - options
 * @param   {string} options.itemName - key to identify the looped item in the new context
 * @param   {string} options.indexName - key to identify the index of the looped item
 * @param   {number} options.index - current index
 * @param   {*} options.item - collection item looped
 * @returns {Object} enhanced scope object
 */ function extendScope(scope, { itemName, indexName, index, item }) {
    (0, $3h6d1.defineProperty)(scope, itemName, item);
    if (indexName) (0, $3h6d1.defineProperty)(scope, indexName, index);
    return scope;
}
/**
 * Loop the current template items
 * @param   {Array} items - expression collection value
 * @param   {*} scope - template scope
 * @param   {*} parentScope - scope of the parent template
 * @param   {EachBinding} binding - each binding object instance
 * @returns {Object} data
 * @returns {Map} data.newChildrenMap - a Map containing the new children template structure
 * @returns {Array} data.batches - array containing the template lifecycle functions to trigger
 * @returns {Array} data.futureNodes - array containing the nodes we need to diff
 */ function createPatch(items, scope, parentScope, binding) {
    const { condition, template, childrenMap, itemName, getKey, indexName, root, isTemplateTag } = binding;
    const newChildrenMap = new Map();
    const batches = [];
    const futureNodes = [];
    items.forEach((item, index)=>{
        const context = extendScope(Object.create(scope), {
            itemName: itemName,
            indexName: indexName,
            index: index,
            item: item
        });
        const key = getKey ? getKey(context) : index;
        const oldItem = childrenMap.get(key);
        const nodes = [];
        if (mustFilterItem(condition, context)) return;
        const mustMount = !oldItem;
        const componentTemplate = oldItem ? oldItem.template : template.clone();
        const el = componentTemplate.el || root.cloneNode();
        const meta = isTemplateTag && mustMount ? createTemplateMeta(componentTemplate) : componentTemplate.meta;
        if (mustMount) batches.push(()=>componentTemplate.mount(el, context, parentScope, meta));
        else batches.push(()=>componentTemplate.update(context, parentScope));
        // create the collection of nodes to update or to add
        // in case of template tags we need to add all its children nodes
        if (isTemplateTag) nodes.push(...meta.children);
        else nodes.push(el);
        // delete the old item from the children map
        childrenMap.delete(key);
        futureNodes.push(...nodes);
        // update the children map
        newChildrenMap.set(key, {
            nodes: nodes,
            template: componentTemplate,
            context: context,
            index: index
        });
    });
    return {
        newChildrenMap: newChildrenMap,
        batches: batches,
        futureNodes: futureNodes
    };
}
function create$6(node, { evaluate, condition, itemName, indexName, getKey, template }) {
    const placeholder = document.createTextNode('');
    const root = node.cloneNode();
    (0, $fGGec.insertBefore)(placeholder, node);
    (0, $fGGec.removeChild)(node);
    return {
        ...EachBinding,
        childrenMap: new Map(),
        node: node,
        root: root,
        condition: condition,
        evaluate: evaluate,
        isTemplateTag: (0, $8kAdV.isTemplate)(root),
        template: template.createDOM(node),
        getKey: getKey,
        indexName: indexName,
        itemName: itemName,
        placeholder: placeholder
    };
}
/**
 * Binding responsible for the `if` directive
 */ const IfBinding = {
    // dynamic binding properties
    // node: null,
    // evaluate: null,
    // isTemplateTag: false,
    // placeholder: null,
    // template: null,
    // API methods
    mount (scope, parentScope) {
        return this.update(scope, parentScope);
    },
    update (scope, parentScope) {
        const value = !!this.evaluate(scope);
        const mustMount = !this.value && value;
        const mustUnmount = this.value && !value;
        const mount = ()=>{
            const pristine = this.node.cloneNode();
            (0, $fGGec.insertBefore)(pristine, this.placeholder);
            this.template = this.template.clone();
            this.template.mount(pristine, scope, parentScope);
        };
        switch(true){
            case mustMount:
                mount();
                break;
            case mustUnmount:
                this.unmount(scope);
                break;
            default:
                if (value) this.template.update(scope, parentScope);
        }
        this.value = value;
        return this;
    },
    unmount (scope, parentScope) {
        this.template.unmount(scope, parentScope, true);
        return this;
    }
};
function create$5(node, { evaluate, template }) {
    const placeholder = document.createTextNode('');
    (0, $fGGec.insertBefore)(placeholder, node);
    (0, $fGGec.removeChild)(node);
    return {
        ...IfBinding,
        node: node,
        evaluate: evaluate,
        placeholder: placeholder,
        template: template.createDOM(node)
    };
}
/* c8 ignore next */ const ElementProto = typeof Element === 'undefined' ? {} : Element.prototype;
const isNativeHtmlProperty = (0, $koC5P.memoize)((name)=>ElementProto.hasOwnProperty(name));
/**
 * Add all the attributes provided
 * @param   {HTMLElement} node - target node
 * @param   {Object} attributes - object containing the attributes names and values
 * @returns {undefined} sorry it's a void function :(
 */ function setAllAttributes(node, attributes) {
    Object.keys(attributes).forEach((name)=>attributeExpression({
            node: node,
            name: name
        }, attributes[name]));
}
/**
 * Remove all the attributes provided
 * @param   {HTMLElement} node - target node
 * @param   {Object} newAttributes - object containing all the new attribute names
 * @param   {Object} oldAttributes - object containing all the old attribute names
 * @returns {undefined} sorry it's a void function :(
 */ function removeAllAttributes(node, newAttributes, oldAttributes) {
    const newKeys = newAttributes ? Object.keys(newAttributes) : [];
    Object.keys(oldAttributes).filter((name)=>!newKeys.includes(name)).forEach((attribute)=>node.removeAttribute(attribute));
}
/**
 * Check whether the attribute value can be rendered
 * @param {*} value - expression value
 * @returns {boolean} true if we can render this attribute value
 */ function canRenderAttribute(value) {
    return [
        'string',
        'number',
        'boolean'
    ].includes(typeof value);
}
/**
 * Check whether the attribute should be removed
 * @param {*} value - expression value
 * @param   {boolean} isBoolean - flag to handle boolean attributes
 * @returns {boolean} boolean - true if the attribute can be removed}
 */ function shouldRemoveAttribute(value, isBoolean) {
    // boolean attributes should be removed if the value is falsy
    if (isBoolean) return !value && value !== 0;
    // otherwise we can try to render it
    return typeof value === 'undefined' || value === null;
}
/**
 * This methods handles the DOM attributes updates
 * @param   {HTMLElement} expression.node - target node
 * @param   {string} expression.name - attribute name
 * @param   {boolean} expression.isBoolean - flag to handle boolean attributes
 * @param   {*} expression.value - the old expression cached value
 * @param   {*} value - new expression value
 * @returns {undefined}
 */ function attributeExpression({ node, name, isBoolean: isBoolean$1, value: oldValue }, value) {
    // is it a spread operator? {...attributes}
    if (!name) {
        if (oldValue) // remove all the old attributes
        removeAllAttributes(node, value, oldValue);
        // is the value still truthy?
        if (value) setAllAttributes(node, value);
        return;
    }
    // store the attribute on the node to make it compatible with native custom elements
    if (!isNativeHtmlProperty(name) && ((0, $8kAdV.isBoolean)(value) || (0, $8kAdV.isObject)(value) || (0, $8kAdV.isFunction)(value))) node[name] = value;
    if (shouldRemoveAttribute(value, isBoolean$1)) node.removeAttribute(name);
    else if (canRenderAttribute(value)) node.setAttribute(name, normalizeValue(name, value, isBoolean$1));
}
/**
 * Get the value as string
 * @param   {string} name - attribute name
 * @param   {*} value - user input value
 * @param   {boolean} isBoolean - boolean attributes flag
 * @returns {string} input value as string
 */ function normalizeValue(name, value, isBoolean) {
    // be sure that expressions like selected={ true } will always be rendered as selected='selected'
    // fix https://github.com/riot/riot/issues/2975
    return value === true && isBoolean ? name : value;
}
const RE_EVENTS_PREFIX = /^on/;
const getCallbackAndOptions = (value)=>Array.isArray(value) ? value : [
        value,
        false
    ];
// see also https://medium.com/@WebReflection/dom-handleevent-a-cross-platform-standard-since-year-2000-5bf17287fd38
const EventListener = {
    handleEvent (event) {
        this[event.type](event);
    }
};
const ListenersWeakMap = new WeakMap();
const createListener = (node)=>{
    const listener = Object.create(EventListener);
    ListenersWeakMap.set(node, listener);
    return listener;
};
/**
 * Set a new event listener
 * @param   {HTMLElement} expression.node - target node
 * @param   {string} expression.name - event name
 * @param   {*} value - new expression value
 * @returns {value} the callback just received
 */ function eventExpression({ node, name }, value) {
    const normalizedEventName = name.replace(RE_EVENTS_PREFIX, '');
    const eventListener = ListenersWeakMap.get(node) || createListener(node);
    const [callback, options] = getCallbackAndOptions(value);
    const handler = eventListener[normalizedEventName];
    const mustRemoveEvent = handler && !callback;
    const mustAddEvent = callback && !handler;
    if (mustRemoveEvent) node.removeEventListener(normalizedEventName, eventListener);
    if (mustAddEvent) node.addEventListener(normalizedEventName, eventListener, options);
    eventListener[normalizedEventName] = callback;
}
/**
 * Normalize the user value in order to render a empty string in case of falsy values
 * @param   {*} value - user input value
 * @returns {string} hopefully a string
 */ function normalizeStringValue(value) {
    return (0, $8kAdV.isNil)(value) ? '' : value;
}
/**
 * Get the the target text node to update or create one from of a comment node
 * @param   {HTMLElement} node - any html element containing childNodes
 * @param   {number} childNodeIndex - index of the text node in the childNodes list
 * @returns {Text} the text node to update
 */ const getTextNode = (node, childNodeIndex)=>{
    return node.childNodes[childNodeIndex];
};
/**
 * This methods handles a simple text expression update
 * @param   {HTMLElement} expression.node - target node
 * @param   {*} value - new expression value
 * @returns {undefined}
 */ function textExpression({ node }, value) {
    node.data = normalizeStringValue(value);
}
/**
 * This methods handles the input fields value updates
 * @param   {HTMLElement} expression.node - target node
 * @param   {*} value - new expression value
 * @returns {undefined}
 */ function valueExpression({ node }, value) {
    node.value = normalizeStringValue(value);
}
/**
   This method handles the REF attribute expressions 
 * @param   {HTMLElement} expression.node - target node
 * @param   {*} expression.value - the old expression cached value
 * @param   {*} value - new expression value
 * @returns {undefined}
 */ function refExpression({ node, value: oldValue }, value) {
    // called on mount and update
    if (value) value(node);
    else oldValue(null);
}
const expressions = {
    [(0, $dNFiL.ATTRIBUTE)]: attributeExpression,
    [(0, $dNFiL.EVENT)]: eventExpression,
    [(0, $dNFiL.TEXT)]: textExpression,
    [(0, $dNFiL.VALUE)]: valueExpression,
    [(0, $dNFiL.REF)]: refExpression
};
const Expression = {
    // Static props
    // node: null,
    // value: null,
    // API methods
    /**
   * Mount the expression evaluating its initial value
   * @param   {*} scope - argument passed to the expression to evaluate its current values
   * @returns {Expression} self
   */ mount (scope) {
        // hopefully a pure function
        this.value = this.evaluate(scope);
        // IO() DOM updates
        expressions[this.type](this, this.value);
        return this;
    },
    /**
   * Update the expression if its value changed
   * @param   {*} scope - argument passed to the expression to evaluate its current values
   * @returns {Expression} self
   */ update (scope) {
        // pure function
        const value = this.evaluate(scope);
        if (this.value !== value) {
            // IO() DOM updates
            expressions[this.type](this, value);
            this.value = value;
        }
        return this;
    },
    /**
   * Expression teardown method
   * @returns {Expression} self
   */ unmount () {
        // unmount event and ref expressions
        if ([
            (0, $dNFiL.EVENT),
            (0, $dNFiL.REF)
        ].includes(this.type)) expressions[this.type](this, null);
        return this;
    }
};
function create$4(node, data) {
    return {
        ...Expression,
        ...data,
        node: data.type === (0, $dNFiL.TEXT) ? getTextNode(node, data.childNodeIndex) : node
    };
}
/**
 * Create a flat object having as keys a list of methods that if dispatched will propagate
 * on the whole collection
 * @param   {Array} collection - collection to iterate
 * @param   {Array<string>} methods - methods to execute on each item of the collection
 * @param   {*} context - context returned by the new methods created
 * @returns {Object} a new object to simplify the the nested methods dispatching
 */ function flattenCollectionMethods(collection, methods, context) {
    return methods.reduce((acc, method)=>{
        return {
            ...acc,
            [method]: (scope)=>{
                return collection.map((item)=>item[method](scope)) && context;
            }
        };
    }, {});
}
function create$3(node, { expressions }) {
    return flattenCollectionMethods(expressions.map((expression)=>create$4(node, expression)), [
        'mount',
        'update',
        'unmount'
    ]);
}
const extendParentScope = (attributes, scope, parentScope)=>{
    if (!attributes || !attributes.length) return parentScope;
    const expressions = attributes.map((attr)=>({
            ...attr,
            value: attr.evaluate(scope)
        }));
    return Object.assign(Object.create(parentScope || null), (0, $koC5P.evaluateAttributeExpressions)(expressions));
};
const findSlotById = (id, slots)=>slots?.find((slot)=>slot.id === id);
// this function is only meant to fix an edge case
// https://github.com/riot/riot/issues/2842
const getRealParent = (scope, parentScope)=>scope[0, $8VupT.PARENT_KEY_SYMBOL] || parentScope;
const SlotBinding = {
    // dynamic binding properties
    // node: null,
    // name: null,
    attributes: [],
    // templateData: null,
    // template: null,
    getTemplateScope (scope, parentScope) {
        return extendParentScope(this.attributes, scope, parentScope);
    },
    // API methods
    mount (scope, parentScope) {
        const templateData = scope.slots ? findSlotById(this.name, scope.slots) : false;
        const { parentNode } = this.node;
        // if the slot did not pass any content, we will use the self slot for optional fallback content (https://github.com/riot/riot/issues/3024)
        const realParent = templateData ? getRealParent(scope, parentScope) : scope;
        // if there is no html for the current slot detected we rely on the parent slots (https://github.com/riot/riot/issues/3055)
        this.templateData = templateData?.html ? templateData : findSlotById(this.name, realParent.slots);
        // override the template property if the slot needs to be replaced
        this.template = this.templateData && create(this.templateData.html, this.templateData.bindings).createDOM(parentNode) || // otherwise use the optional template fallback if provided by the compiler see also https://github.com/riot/riot/issues/3014
        this.template?.clone();
        if (this.template) {
            (0, $fGGec.cleanNode)(this.node);
            this.template.mount(this.node, this.getTemplateScope(scope, realParent), realParent);
            this.template.children = Array.from(this.node.childNodes);
        }
        moveSlotInnerContent(this.node);
        (0, $fGGec.removeChild)(this.node);
        return this;
    },
    update (scope, parentScope) {
        if (this.template) {
            const realParent = this.templateData ? getRealParent(scope, parentScope) : scope;
            this.template.update(this.getTemplateScope(scope, realParent), realParent);
        }
        return this;
    },
    unmount (scope, parentScope, mustRemoveRoot) {
        if (this.template) this.template.unmount(this.getTemplateScope(scope, parentScope), null, mustRemoveRoot);
        return this;
    }
};
/**
 * Move the inner content of the slots outside of them
 * @param   {HTMLElement} slot - slot node
 * @returns {undefined} it's a void method ¯\_(ツ)_/¯
 */ function moveSlotInnerContent(slot) {
    const child = slot && slot.firstChild;
    if (!child) return;
    (0, $fGGec.insertBefore)(child, slot);
    moveSlotInnerContent(slot);
}
/**
 * Create a single slot binding
 * @param   {HTMLElement} node - slot node
 * @param   {string} name - slot id
 * @param   {AttributeExpressionData[]} attributes - slot attributes
 * @returns {Object} Slot binding object
 */ function createSlot(node, { name, attributes, template }) {
    return {
        ...SlotBinding,
        attributes: attributes,
        template: template,
        node: node,
        name: name
    };
}
/**
 * Create a new tag object if it was registered before, otherwise fallback to the simple
 * template chunk
 * @param   {Function} component - component factory function
 * @param   {Array<Object>} slots - array containing the slots markup
 * @param   {Array} attributes - dynamic attributes that will be received by the tag element
 * @returns {TagImplementation|TemplateChunk} a tag implementation or a template chunk as fallback
 */ function getTag(component, slots = [], attributes = []) {
    // if this tag was registered before we will return its implementation
    if (component) return component({
        slots: slots,
        attributes: attributes
    });
    // otherwise we return a template chunk
    return create(slotsToMarkup(slots), [
        ...slotBindings(slots),
        {
            // the attributes should be registered as binding
            // if we fallback to a normal template chunk
            expressions: attributes.map((attr)=>{
                return {
                    type: (0, $dNFiL.ATTRIBUTE),
                    ...attr
                };
            })
        }
    ]);
}
/**
 * Merge all the slots bindings into a single array
 * @param   {Array<Object>} slots - slots collection
 * @returns {Array<Bindings>} flatten bindings array
 */ function slotBindings(slots) {
    return slots.reduce((acc, { bindings })=>acc.concat(bindings), []);
}
/**
 * Merge all the slots together in a single markup string
 * @param   {Array<Object>} slots - slots collection
 * @returns {string} markup of all the slots in a single string
 */ function slotsToMarkup(slots) {
    return slots.reduce((acc, slot)=>{
        return acc + slot.html;
    }, '');
}
const TagBinding = {
    // dynamic binding properties
    // node: null,
    // evaluate: null,
    // name: null,
    // slots: null,
    // tag: null,
    // attributes: null,
    // getComponent: null,
    mount (scope) {
        return this.update(scope);
    },
    update (scope, parentScope) {
        const name = this.evaluate(scope);
        // simple update
        if (name && name === this.name) this.tag.update(scope);
        else {
            // unmount the old tag if it exists
            this.unmount(scope, parentScope, true);
            // mount the new tag
            this.name = name;
            this.tag = getTag(this.getComponent(name), this.slots, this.attributes);
            this.tag.mount(this.node, scope);
        }
        return this;
    },
    unmount (scope, parentScope, keepRootTag) {
        if (this.tag) // keep the root tag
        this.tag.unmount(keepRootTag);
        return this;
    }
};
function create$2(node, { evaluate, getComponent, slots, attributes }) {
    return {
        ...TagBinding,
        node: node,
        evaluate: evaluate,
        slots: slots,
        attributes: attributes,
        getComponent: getComponent
    };
}
const bindings = {
    [(0, $f4jRS.IF)]: create$5,
    [(0, $f4jRS.SIMPLE)]: create$3,
    [(0, $f4jRS.EACH)]: create$6,
    [(0, $f4jRS.TAG)]: create$2,
    [(0, $f4jRS.SLOT)]: createSlot
};
/**
 * Text expressions in a template tag will get childNodeIndex value normalized
 * depending on the position of the <template> tag offset
 * @param   {Expression[]} expressions - riot expressions array
 * @param   {number} textExpressionsOffset - offset of the <template> tag
 * @returns {Expression[]} expressions containing the text expressions normalized
 */ function fixTextExpressionsOffset(expressions, textExpressionsOffset) {
    return expressions.map((e)=>e.type === (0, $dNFiL.TEXT) ? {
            ...e,
            childNodeIndex: e.childNodeIndex + textExpressionsOffset
        } : e);
}
/**
 * Bind a new expression object to a DOM node
 * @param   {HTMLElement} root - DOM node where to bind the expression
 * @param   {TagBindingData} binding - binding data
 * @param   {number|null} templateTagOffset - if it's defined we need to fix the text expressions childNodeIndex offset
 * @returns {Binding} Binding object
 */ function create$1(root, binding, templateTagOffset) {
    const { selector, type, redundantAttribute, expressions } = binding;
    // find the node to apply the bindings
    const node = selector ? root.querySelector(selector) : root;
    // remove eventually additional attributes created only to select this node
    if (redundantAttribute) node.removeAttribute(redundantAttribute);
    const bindingExpressions = expressions || [];
    // init the binding
    return (bindings[type] || bindings[0, $f4jRS.SIMPLE])(node, {
        ...binding,
        expressions: templateTagOffset && !selector ? fixTextExpressionsOffset(bindingExpressions, templateTagOffset) : bindingExpressions
    });
}
// in this case a simple innerHTML is enough
function createHTMLTree(html, root) {
    const template = (0, $8kAdV.isTemplate)(root) ? root : document.createElement('template');
    template.innerHTML = html;
    return template.content;
}
// for svg nodes we need a bit more work
/* c8 ignore start */ function createSVGTree(html, container) {
    // create the SVGNode
    const svgNode = container.ownerDocument.importNode(new window.DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg">${html}</svg>`, 'application/xml').documentElement, true);
    return svgNode;
}
/* c8 ignore end */ /**
 * Create the DOM that will be injected
 * @param {Object} root - DOM node to find out the context where the fragment will be created
 * @param   {string} html - DOM to create as string
 * @returns {HTMLDocumentFragment|HTMLElement} a new html fragment
 */ function createDOMTree(root, html) {
    /* c8 ignore next */ if ((0, $8kAdV.isSvg)(root)) return createSVGTree(html, root);
    return createHTMLTree(html, root);
}
/**
 * Inject the DOM tree into a target node
 * @param   {HTMLElement} el - target element
 * @param   {DocumentFragment|SVGElement} dom - dom tree to inject
 * @returns {undefined}
 */ function injectDOM(el, dom) {
    switch(true){
        case (0, $8kAdV.isSvg)(el):
            (0, $fGGec.moveChildren)(dom, el);
            break;
        case (0, $8kAdV.isTemplate)(el):
            el.parentNode.replaceChild(dom, el);
            break;
        default:
            el.appendChild(dom);
    }
}
/**
 * Create the Template DOM skeleton
 * @param   {HTMLElement} el - root node where the DOM will be injected
 * @param   {string|HTMLElement} html - HTML markup or HTMLElement that will be injected into the root node
 * @returns {?DocumentFragment} fragment that will be injected into the root node
 */ function createTemplateDOM(el, html) {
    return html && (typeof html === 'string' ? createDOMTree(el, html) : html);
}
/**
 * Get the offset of the <template> tag
 * @param {HTMLElement} parentNode - template tag parent node
 * @param {HTMLElement} el - the template tag we want to render
 * @param   {Object} meta - meta properties needed to handle the <template> tags in loops
 * @returns {number} offset of the <template> tag calculated from its siblings DOM nodes
 */ function getTemplateTagOffset(parentNode, el, meta) {
    const siblings = Array.from(parentNode.childNodes);
    return Math.max(siblings.indexOf(el), siblings.indexOf(meta.head) + 1, 0);
}
/**
 * Template Chunk model
 * @type {Object}
 */ const TemplateChunk = {
    // Static props
    // bindings: null,
    // bindingsData: null,
    // html: null,
    // isTemplateTag: false,
    // fragment: null,
    // children: null,
    // dom: null,
    // el: null,
    /**
   * Create the template DOM structure that will be cloned on each mount
   * @param   {HTMLElement} el - the root node
   * @returns {TemplateChunk} self
   */ createDOM (el) {
        // make sure that the DOM gets created before cloning the template
        this.dom = this.dom || createTemplateDOM(el, this.html) || document.createDocumentFragment();
        return this;
    },
    // API methods
    /**
   * Attach the template to a DOM node
   * @param   {HTMLElement} el - target DOM node
   * @param   {*} scope - template data
   * @param   {*} parentScope - scope of the parent template tag
   * @param   {Object} meta - meta properties needed to handle the <template> tags in loops
   * @returns {TemplateChunk} self
   */ mount (el, scope, parentScope, meta = {}) {
        if (!el) (0, $koC5P.panic)('Please provide DOM node to mount properly your template');
        if (this.el) this.unmount(scope);
        // <template> tags require a bit more work
        // the template fragment might be already created via meta outside of this call
        const { fragment, children, avoidDOMInjection } = meta;
        // <template> bindings of course can not have a root element
        // so we check the parent node to set the query selector bindings
        const { parentNode } = children ? children[0] : el;
        const isTemplateTag = (0, $8kAdV.isTemplate)(el);
        const templateTagOffset = isTemplateTag ? getTemplateTagOffset(parentNode, el, meta) : null;
        // create the DOM if it wasn't created before
        this.createDOM(el);
        // create the DOM of this template cloning the original DOM structure stored in this instance
        // notice that if a documentFragment was passed (via meta) we will use it instead
        const cloneNode = fragment || this.dom.cloneNode(true);
        // store root node
        // notice that for template tags the root note will be the parent tag
        this.el = isTemplateTag ? parentNode : el;
        // create the children array only for the <template> fragments
        this.children = isTemplateTag ? children || Array.from(cloneNode.childNodes) : null;
        // inject the DOM into the el only if a fragment is available
        if (!avoidDOMInjection && cloneNode) injectDOM(el, cloneNode);
        // create the bindings
        this.bindings = this.bindingsData.map((binding)=>create$1(this.el, binding, templateTagOffset));
        this.bindings.forEach((b)=>b.mount(scope, parentScope));
        // store the template meta properties
        this.meta = meta;
        return this;
    },
    /**
   * Update the template with fresh data
   * @param   {*} scope - template data
   * @param   {*} parentScope - scope of the parent template tag
   * @returns {TemplateChunk} self
   */ update (scope, parentScope) {
        this.bindings.forEach((b)=>b.update(scope, parentScope));
        return this;
    },
    /**
   * Remove the template from the node where it was initially mounted
   * @param   {*} scope - template data
   * @param   {*} parentScope - scope of the parent template tag
   * @param   {boolean|null} mustRemoveRoot - if true remove the root element,
   * if false or undefined clean the root tag content, if null don't touch the DOM
   * @returns {TemplateChunk} self
   */ unmount (scope, parentScope, mustRemoveRoot = false) {
        const el = this.el;
        if (!el) return this;
        this.bindings.forEach((b)=>b.unmount(scope, parentScope, mustRemoveRoot));
        switch(true){
            // pure components should handle the DOM unmount updates by themselves
            // for mustRemoveRoot === null don't touch the DOM
            case el[0, $8VupT.IS_PURE_SYMBOL] || mustRemoveRoot === null:
                break;
            // if children are declared, clear them
            // applicable for <template> and <slot/> bindings
            case Array.isArray(this.children):
                (0, $fGGec.clearChildren)(this.children);
                break;
            // clean the node children only
            case !mustRemoveRoot:
                (0, $fGGec.cleanNode)(el);
                break;
            // remove the root node only if the mustRemoveRoot is truly
            case !!mustRemoveRoot:
                (0, $fGGec.removeChild)(el);
                break;
        }
        this.el = null;
        return this;
    },
    /**
   * Clone the template chunk
   * @returns {TemplateChunk} a clone of this object resetting the this.el property
   */ clone () {
        return {
            ...this,
            meta: {},
            el: null
        };
    }
};
/**
 * Create a template chunk wiring also the bindings
 * @param   {string|HTMLElement} html - template string
 * @param   {BindingData[]} bindings - bindings collection
 * @returns {TemplateChunk} a new TemplateChunk copy
 */ function create(html, bindings = []) {
    return {
        ...TemplateChunk,
        html: html,
        bindingsData: bindings
    };
}

});
parcelRegister("fGGec", function(module, exports) {

$parcel$export(module.exports, "DOMattributesToObject", () => $b6bb88d9fb552988$export$f5c4414827140849);
$parcel$export(module.exports, "moveChildren", () => $b6bb88d9fb552988$export$434b8be66f8c2ac9);
$parcel$export(module.exports, "cleanNode", () => $b6bb88d9fb552988$export$9497debfa326231a);
$parcel$export(module.exports, "clearChildren", () => $b6bb88d9fb552988$export$da51b626bd37c807);
$parcel$export(module.exports, "removeChild", () => $b6bb88d9fb552988$export$7ae609f7af59e4f7);
$parcel$export(module.exports, "insertBefore", () => $b6bb88d9fb552988$export$86b68c7dbeb53c22);
$parcel$export(module.exports, "replaceChild", () => $b6bb88d9fb552988$export$46f78da0e790aab7);
/* Riot WIP, @license MIT */ 
var $ldAW2 = parcelRequire("ldAW2");
/**
 * Get all the element attributes as object
 * @param   {HTMLElement} element - DOM node we want to parse
 * @returns {Object} all the attributes found as a key value pairs
 */ function $b6bb88d9fb552988$export$f5c4414827140849(element) {
    return Array.from(element.attributes).reduce((acc, attribute)=>{
        acc[(0, $ldAW2.dashToCamelCase)(attribute.name)] = attribute.value;
        return acc;
    }, {});
}
/**
 * Move all the child nodes from a source tag to another
 * @param   {HTMLElement} source - source node
 * @param   {HTMLElement} target - target node
 * @returns {undefined} it's a void method ¯\_(ツ)_/¯
 */ // Ignore this helper because it's needed only for svg tags
function $b6bb88d9fb552988$export$434b8be66f8c2ac9(source, target) {
    // eslint-disable-next-line fp/no-loops
    while(source.firstChild)target.appendChild(source.firstChild);
}
/**
 * Remove the child nodes from any DOM node
 * @param   {HTMLElement} node - target node
 * @returns {undefined}
 */ function $b6bb88d9fb552988$export$9497debfa326231a(node) {
    // eslint-disable-next-line fp/no-loops
    while(node.firstChild)node.removeChild(node.firstChild);
}
/**
 * Clear multiple children in a node
 * @param   {HTMLElement[]} children - direct children nodes
 * @returns {undefined}
 */ function $b6bb88d9fb552988$export$da51b626bd37c807(children) {
    // eslint-disable-next-line fp/no-loops,fp/no-let
    for(let i = 0; i < children.length; i++)$b6bb88d9fb552988$export$7ae609f7af59e4f7(children[i]);
}
/**
 * Remove a node
 * @param {HTMLElement}node - node to remove
 * @returns {undefined}
 */ const $b6bb88d9fb552988$export$7ae609f7af59e4f7 = (node)=>node.remove();
/**
 * Insert before a node
 * @param {HTMLElement} newNode - node to insert
 * @param {HTMLElement} refNode - ref child
 * @returns {undefined}
 */ const $b6bb88d9fb552988$export$86b68c7dbeb53c22 = (newNode, refNode)=>refNode && refNode.parentNode && refNode.parentNode.insertBefore(newNode, refNode);
/**
 * Replace a node
 * @param {HTMLElement} newNode - new node to add to the DOM
 * @param {HTMLElement} replaced - node to replace
 * @returns {undefined}
 */ const $b6bb88d9fb552988$export$46f78da0e790aab7 = (newNode, replaced)=>replaced && replaced.parentNode && replaced.parentNode.replaceChild(newNode, replaced);

});
parcelRegister("ldAW2", function(module, exports) {

$parcel$export(module.exports, "camelToDashCase", () => $f7277666e0936a5c$export$6e116da553d9a4d8);
$parcel$export(module.exports, "dashToCamelCase", () => $f7277666e0936a5c$export$138f9917dd6248b4);
/* Riot WIP, @license MIT */ /**
 * Convert a string from camel case to dash-case
 * @param   {string} string - probably a component tag name
 * @returns {string} component name normalized
 */ function $f7277666e0936a5c$export$6e116da553d9a4d8(string) {
    return string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
/**
 * Convert a string containing dashes to camel case
 * @param   {string} string - input string
 * @returns {string} my-string -> myString
 */ function $f7277666e0936a5c$export$138f9917dd6248b4(string) {
    return string.replace(/-(\w)/g, (_, c)=>c.toUpperCase());
}

});


parcelRegister("8VupT", function(module, exports) {

$parcel$export(module.exports, "COMPONENTS_IMPLEMENTATION_MAP", () => $67fb3db5a3808819$export$7fb861b8a16b2c5e);
$parcel$export(module.exports, "DOM_COMPONENT_INSTANCE_PROPERTY", () => $67fb3db5a3808819$export$e681ba2bbc520092);
$parcel$export(module.exports, "PLUGINS_SET", () => $67fb3db5a3808819$export$b50a8212494d152);
$parcel$export(module.exports, "IS_DIRECTIVE", () => $67fb3db5a3808819$export$f6c8a57c22bed1ce);
$parcel$export(module.exports, "MOUNT_METHOD_KEY", () => $67fb3db5a3808819$export$5168d697e02447c0);
$parcel$export(module.exports, "UPDATE_METHOD_KEY", () => $67fb3db5a3808819$export$631a8600c6d6a92f);
$parcel$export(module.exports, "UNMOUNT_METHOD_KEY", () => $67fb3db5a3808819$export$ca8982e815a3faee);
$parcel$export(module.exports, "SHOULD_UPDATE_KEY", () => $67fb3db5a3808819$export$44b81687b13278e5);
$parcel$export(module.exports, "ON_BEFORE_MOUNT_KEY", () => $67fb3db5a3808819$export$d56fbe519e06c7b5);
$parcel$export(module.exports, "ON_MOUNTED_KEY", () => $67fb3db5a3808819$export$38c5193d35c2c953);
$parcel$export(module.exports, "ON_BEFORE_UPDATE_KEY", () => $67fb3db5a3808819$export$c64b6b434b66725f);
$parcel$export(module.exports, "ON_UPDATED_KEY", () => $67fb3db5a3808819$export$8b7376a033703125);
$parcel$export(module.exports, "ON_BEFORE_UNMOUNT_KEY", () => $67fb3db5a3808819$export$f4ca6732670723ac);
$parcel$export(module.exports, "ON_UNMOUNTED_KEY", () => $67fb3db5a3808819$export$d8611e9dbf9f1e4f);
$parcel$export(module.exports, "PROPS_KEY", () => $67fb3db5a3808819$export$bfbebb51095821d3);
$parcel$export(module.exports, "STATE_KEY", () => $67fb3db5a3808819$export$b56c47f66926ce06);
$parcel$export(module.exports, "SLOTS_KEY", () => $67fb3db5a3808819$export$9982265a62cce53e);
$parcel$export(module.exports, "ROOT_KEY", () => $67fb3db5a3808819$export$b4861ce6ec7db8f3);
$parcel$export(module.exports, "IS_PURE_SYMBOL", () => $67fb3db5a3808819$export$4857469bdae0a7f8);
$parcel$export(module.exports, "IS_COMPONENT_UPDATING", () => $67fb3db5a3808819$export$32deca042718281d);
$parcel$export(module.exports, "PARENT_KEY_SYMBOL", () => $67fb3db5a3808819$export$6615e4dd2821a46e);
$parcel$export(module.exports, "ATTRIBUTES_KEY_SYMBOL", () => $67fb3db5a3808819$export$bdaeca44250b1a18);
$parcel$export(module.exports, "TEMPLATE_KEY_SYMBOL", () => $67fb3db5a3808819$export$f201cab4277a5134);
/* Riot WIP, @license MIT */ // Riot.js constants that can be used across more modules
const $67fb3db5a3808819$export$7fb861b8a16b2c5e = new Map(), $67fb3db5a3808819$export$e681ba2bbc520092 = Symbol('riot-component'), $67fb3db5a3808819$export$b50a8212494d152 = new Set(), $67fb3db5a3808819$export$f6c8a57c22bed1ce = 'is', $67fb3db5a3808819$export$5168d697e02447c0 = 'mount', $67fb3db5a3808819$export$631a8600c6d6a92f = 'update', $67fb3db5a3808819$export$ca8982e815a3faee = 'unmount', $67fb3db5a3808819$export$44b81687b13278e5 = 'shouldUpdate', $67fb3db5a3808819$export$d56fbe519e06c7b5 = 'onBeforeMount', $67fb3db5a3808819$export$38c5193d35c2c953 = 'onMounted', $67fb3db5a3808819$export$c64b6b434b66725f = 'onBeforeUpdate', $67fb3db5a3808819$export$8b7376a033703125 = 'onUpdated', $67fb3db5a3808819$export$f4ca6732670723ac = 'onBeforeUnmount', $67fb3db5a3808819$export$d8611e9dbf9f1e4f = 'onUnmounted', $67fb3db5a3808819$export$bfbebb51095821d3 = 'props', $67fb3db5a3808819$export$b56c47f66926ce06 = 'state', $67fb3db5a3808819$export$9982265a62cce53e = 'slots', $67fb3db5a3808819$export$b4861ce6ec7db8f3 = 'root', $67fb3db5a3808819$export$4857469bdae0a7f8 = Symbol('pure'), $67fb3db5a3808819$export$32deca042718281d = Symbol('is_updating'), $67fb3db5a3808819$export$6615e4dd2821a46e = Symbol('parent'), $67fb3db5a3808819$export$bdaeca44250b1a18 = Symbol('attributes'), $67fb3db5a3808819$export$f201cab4277a5134 = Symbol('template');

});

parcelRegister("f4jRS", function(module, exports) {

$parcel$export(module.exports, "EACH", () => $af86a41686848fd6$export$1f15bedf49e15e92);
$parcel$export(module.exports, "IF", () => $af86a41686848fd6$export$5749f35ae68e5477);
$parcel$export(module.exports, "SIMPLE", () => $af86a41686848fd6$export$aca095bc476d426f);
$parcel$export(module.exports, "TAG", () => $af86a41686848fd6$export$2680f340d0781853);
$parcel$export(module.exports, "SLOT", () => $af86a41686848fd6$export$4dc770bbadfb72db);
$parcel$export(module.exports, "default", () => $af86a41686848fd6$export$2e2bcd8739ae039);
/* Riot WIP, @license MIT */ const $af86a41686848fd6$export$1f15bedf49e15e92 = 0;
const $af86a41686848fd6$export$5749f35ae68e5477 = 1;
const $af86a41686848fd6$export$aca095bc476d426f = 2;
const $af86a41686848fd6$export$2680f340d0781853 = 3;
const $af86a41686848fd6$export$4dc770bbadfb72db = 4;
const $af86a41686848fd6$export$2e2bcd8739ae039 = {
    EACH: $af86a41686848fd6$export$1f15bedf49e15e92,
    IF: $af86a41686848fd6$export$5749f35ae68e5477,
    SIMPLE: $af86a41686848fd6$export$aca095bc476d426f,
    TAG: $af86a41686848fd6$export$2680f340d0781853,
    SLOT: $af86a41686848fd6$export$4dc770bbadfb72db
};

});

parcelRegister("dNFiL", function(module, exports) {

$parcel$export(module.exports, "ATTRIBUTE", () => $a0bfe3a2f5ce6bb1$export$77a31abf1489fff);
$parcel$export(module.exports, "EVENT", () => $a0bfe3a2f5ce6bb1$export$e39a34cfd532e15);
$parcel$export(module.exports, "TEXT", () => $a0bfe3a2f5ce6bb1$export$d597759d33be802e);
$parcel$export(module.exports, "VALUE", () => $a0bfe3a2f5ce6bb1$export$764bd63f4c2043a2);
$parcel$export(module.exports, "REF", () => $a0bfe3a2f5ce6bb1$export$19039a9c5d174551);
$parcel$export(module.exports, "default", () => $a0bfe3a2f5ce6bb1$export$2e2bcd8739ae039);
/* Riot WIP, @license MIT */ const $a0bfe3a2f5ce6bb1$export$77a31abf1489fff = 0;
const $a0bfe3a2f5ce6bb1$export$e39a34cfd532e15 = 1;
const $a0bfe3a2f5ce6bb1$export$d597759d33be802e = 2;
const $a0bfe3a2f5ce6bb1$export$764bd63f4c2043a2 = 3;
const $a0bfe3a2f5ce6bb1$export$19039a9c5d174551 = 4;
const $a0bfe3a2f5ce6bb1$export$2e2bcd8739ae039 = {
    ATTRIBUTE: $a0bfe3a2f5ce6bb1$export$77a31abf1489fff,
    EVENT: $a0bfe3a2f5ce6bb1$export$e39a34cfd532e15,
    TEXT: $a0bfe3a2f5ce6bb1$export$d597759d33be802e,
    VALUE: $a0bfe3a2f5ce6bb1$export$764bd63f4c2043a2,
    REF: $a0bfe3a2f5ce6bb1$export$19039a9c5d174551
};

});

parcelRegister("3h6d1", function(module, exports) {

$parcel$export(module.exports, "defineProperty", () => $2627c697786f4493$export$fdab3c20aae16ddf);
$parcel$export(module.exports, "defineProperties", () => $2627c697786f4493$export$b61bda4fbca264f2);
$parcel$export(module.exports, "defineDefaults", () => $2627c697786f4493$export$60c9243e6eb9abf8);
$parcel$export(module.exports, "pick", () => $2627c697786f4493$export$357523c63a2253b9);
/* Riot WIP, @license MIT */ 
var $8kAdV = parcelRequire("8kAdV");
/**
 * Helper function to set an immutable property
 * @param   {Object} source - object where the new property will be set
 * @param   {string} key - object key where the new property will be stored
 * @param   {*} value - value of the new property
 * @param   {Object} options - set the property overriding the default options
 * @returns {Object} - the original object modified
 */ function $2627c697786f4493$export$fdab3c20aae16ddf(source, key, value, options = {}) {
    /* eslint-disable fp/no-mutating-methods */ Object.defineProperty(source, key, {
        value: value,
        enumerable: false,
        writable: false,
        configurable: true,
        ...options
    });
    /* eslint-enable fp/no-mutating-methods */ return source;
}
/**
 * Define multiple properties on a target object
 * @param   {Object} source - object where the new properties will be set
 * @param   {Object} properties - object containing as key pair the key + value properties
 * @param   {Object} options - set the property overriding the default options
 * @returns {Object} the original object modified
 */ function $2627c697786f4493$export$b61bda4fbca264f2(source, properties, options) {
    Object.entries(properties).forEach(([key, value])=>{
        $2627c697786f4493$export$fdab3c20aae16ddf(source, key, value, options);
    });
    return source;
}
/**
 * Define default properties if they don't exist on the source object
 * @param   {Object} source - object that will receive the default properties
 * @param   {Object} defaults - object containing additional optional keys
 * @returns {Object} the original object received enhanced
 */ function $2627c697786f4493$export$60c9243e6eb9abf8(source, defaults) {
    Object.entries(defaults).forEach(([key, value])=>{
        if (!source[key]) source[key] = value;
    });
    return source;
}
/**
 * Generate a new object picking only the properties from a given array
 * @param {Object} source - target object
 * @param {Array} keys - list of keys that we want to copy over to the new object
 * @return {Object} a new object conaining only the keys that we have picked from the keys array list
 */ function $2627c697786f4493$export$357523c63a2253b9(source, keys) {
    return (0, $8kAdV.isObject)(source) ? Object.fromEntries(keys.map((key)=>[
            key,
            source[key]
        ])) : source;
}

});
parcelRegister("8kAdV", function(module, exports) {

$parcel$export(module.exports, "isSvg", () => $610c4a388926c3ae$export$d6c18d944d9c6dc7);
$parcel$export(module.exports, "isTemplate", () => $610c4a388926c3ae$export$6306e0d85c68df69);
$parcel$export(module.exports, "isFunction", () => $610c4a388926c3ae$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isBoolean", () => $610c4a388926c3ae$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isObject", () => $610c4a388926c3ae$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isNil", () => $610c4a388926c3ae$export$984f70f9382f5d27);
/* Riot WIP, @license MIT */ /**
 * Quick type checking
 * @param   {*} element - anything
 * @param   {string} type - type definition
 * @returns {boolean} true if the type corresponds
 */ function $610c4a388926c3ae$export$3ef26b6206bb4811(element, type) {
    return typeof element === type;
}
/**
 * Check if an element is part of an svg
 * @param   {HTMLElement}  el - element to check
 * @returns {boolean} true if we are in an svg context
 */ function $610c4a388926c3ae$export$d6c18d944d9c6dc7(el) {
    const owner = el.ownerSVGElement;
    return !!owner || owner === null;
}
/**
 * Check if an element is a template tag
 * @param   {HTMLElement}  el - element to check
 * @returns {boolean} true if it's a <template>
 */ function $610c4a388926c3ae$export$6306e0d85c68df69(el) {
    return el.tagName.toLowerCase() === 'template';
}
/**
 * Check that will be passed if its argument is a function
 * @param   {*} value - value to check
 * @returns {boolean} - true if the value is a function
 */ function $610c4a388926c3ae$export$f6e2535fb5126e54(value) {
    return $610c4a388926c3ae$export$3ef26b6206bb4811(value, 'function');
}
/**
 * Check if a value is a Boolean
 * @param   {*}  value - anything
 * @returns {boolean} true only for the value is a boolean
 */ function $610c4a388926c3ae$export$f9ce7b637dfbe238(value) {
    return $610c4a388926c3ae$export$3ef26b6206bb4811(value, 'boolean');
}
/**
 * Check if a value is an Object
 * @param   {*}  value - anything
 * @returns {boolean} true only for the value is an object
 */ function $610c4a388926c3ae$export$a6cdc56e425d0d0a(value) {
    return !$610c4a388926c3ae$export$984f70f9382f5d27(value) && value.constructor === Object;
}
/**
 * Check if a value is null or undefined
 * @param   {*}  value - anything
 * @returns {boolean} true only for the 'undefined' and 'null' types
 */ function $610c4a388926c3ae$export$984f70f9382f5d27(value) {
    return value === null || value === undefined;
}
/**
 * Detect node js environment
 * @returns {boolean} true if the runtime is node
 */ function $610c4a388926c3ae$export$8ee0fc9ee280b4ee() {
    return typeof globalThis.process !== 'undefined';
}

});


parcelRegister("koC5P", function(module, exports) {

$parcel$export(module.exports, "panic", () => $ed93990181680b27$export$73d91aecc00f5458);
$parcel$export(module.exports, "memoize", () => $ed93990181680b27$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "evaluateAttributeExpressions", () => $ed93990181680b27$export$65ef383c5ae02cc4);
/* Riot WIP, @license MIT */ 
var $dNFiL = parcelRequire("dNFiL");

var $ldAW2 = parcelRequire("ldAW2");
/**
 * Throw an error with a descriptive message
 * @param   { string } message - error message
 * @param   { string } cause - optional error cause object
 * @returns { undefined } hoppla... at this point the program should stop working
 */ function $ed93990181680b27$export$73d91aecc00f5458(message, cause) {
    throw new Error(message, {
        cause: cause
    });
}
/**
 * Returns the memoized (cached) function.
 * // borrowed from https://www.30secondsofcode.org/js/s/memoize
 * @param {Function} fn - function to memoize
 * @returns {Function} memoize function
 */ function $ed93990181680b27$export$fc10aeed3a532e2a(fn) {
    const cache = new Map();
    const cached = (val)=>{
        return cache.has(val) ? cache.get(val) : cache.set(val, fn.call(this, val)) && cache.get(val);
    };
    cached.cache = cache;
    return cached;
}
/**
 * Evaluate a list of attribute expressions
 * @param   {Array} attributes - attribute expressions generated by the riot compiler
 * @returns {Object} key value pairs with the result of the computation
 */ function $ed93990181680b27$export$65ef383c5ae02cc4(attributes) {
    return attributes.reduce((acc, attribute)=>{
        const { value: value, type: type } = attribute;
        switch(true){
            // spread attribute
            case !attribute.name && type === (0, $dNFiL.ATTRIBUTE):
                return {
                    ...acc,
                    ...value
                };
            // value attribute
            case type === (0, $dNFiL.VALUE):
                acc.value = attribute.value;
                break;
            // normal attributes
            default:
                acc[(0, $ldAW2.dashToCamelCase)(attribute.name)] = attribute.value;
        }
        return acc;
    }, {});
}

});


parcelRegister("52ixw", function(module, exports) {
!function(e, a) {
    module.exports = a();
}(this, function() {
    "use strict";
    var E;
    function c() {
        return E.apply(null, arguments);
    }
    function F(e) {
        return e instanceof Array || "[object Array]" === Object.prototype.toString.call(e);
    }
    function z(e) {
        return null != e && "[object Object]" === Object.prototype.toString.call(e);
    }
    function l(e, a) {
        return Object.prototype.hasOwnProperty.call(e, a);
    }
    function N(e) {
        if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(e).length;
        for(var a in e)if (l(e, a)) return;
        return 1;
    }
    function L(e) {
        return void 0 === e;
    }
    function J(e) {
        return "number" == typeof e || "[object Number]" === Object.prototype.toString.call(e);
    }
    function R(e) {
        return e instanceof Date || "[object Date]" === Object.prototype.toString.call(e);
    }
    function C(e, a) {
        for(var t = [], s = e.length, n = 0; n < s; ++n)t.push(a(e[n], n));
        return t;
    }
    function I(e, a) {
        for(var t in a)l(a, t) && (e[t] = a[t]);
        return l(a, "toString") && (e.toString = a.toString), l(a, "valueOf") && (e.valueOf = a.valueOf), e;
    }
    function U(e, a, t, s) {
        return Na(e, a, t, s, !0).utc();
    }
    function Y(e) {
        return null == e._pf && (e._pf = {
            empty: !1,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: !1,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: !1,
            userInvalidated: !1,
            iso: !1,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: !1,
            weekdayMismatch: !1
        }), e._pf;
    }
    function G(e) {
        var a, t, s = e._d && !isNaN(e._d.getTime());
        return s && (a = Y(e), t = q.call(a.parsedDateParts, function(e) {
            return null != e;
        }), s = a.overflow < 0 && !a.empty && !a.invalidEra && !a.invalidMonth && !a.invalidWeekday && !a.weekdayMismatch && !a.nullInput && !a.invalidFormat && !a.userInvalidated && (!a.meridiem || a.meridiem && t), e._strict) && (s = s && 0 === a.charsLeftOver && 0 === a.unusedTokens.length && void 0 === a.bigHour), null != Object.isFrozen && Object.isFrozen(e) ? s : (e._isValid = s, e._isValid);
    }
    function V(e) {
        var a = U(NaN);
        return null != e ? I(Y(a), e) : Y(a).userInvalidated = !0, a;
    }
    var q = Array.prototype.some || function(e) {
        for(var a = Object(this), t = a.length >>> 0, s = 0; s < t; s++)if (s in a && e.call(this, a[s], s, a)) return !0;
        return !1;
    }, B = c.momentProperties = [], K = !1;
    function Z(e, a) {
        var t, s, n, r = B.length;
        if (L(a._isAMomentObject) || (e._isAMomentObject = a._isAMomentObject), L(a._i) || (e._i = a._i), L(a._f) || (e._f = a._f), L(a._l) || (e._l = a._l), L(a._strict) || (e._strict = a._strict), L(a._tzm) || (e._tzm = a._tzm), L(a._isUTC) || (e._isUTC = a._isUTC), L(a._offset) || (e._offset = a._offset), L(a._pf) || (e._pf = Y(a)), L(a._locale) || (e._locale = a._locale), 0 < r) for(t = 0; t < r; t++)L(n = a[s = B[t]]) || (e[s] = n);
        return e;
    }
    function $(e) {
        Z(this, e), this._d = new Date(null != e._d ? e._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === K && (K = !0, c.updateOffset(this), K = !1);
    }
    function Q(e) {
        return e instanceof $ || null != e && null != e._isAMomentObject;
    }
    function X(e) {
        !1 === c.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + e);
    }
    function e(r, d) {
        var _ = !0;
        return I(function() {
            if (null != c.deprecationHandler && c.deprecationHandler(null, r), _) {
                for(var e, a, t = [], s = arguments.length, n = 0; n < s; n++){
                    if (e = "", "object" == typeof arguments[n]) {
                        for(a in e += "\n[" + n + "] ", arguments[0])l(arguments[0], a) && (e += a + ": " + arguments[0][a] + ", ");
                        e = e.slice(0, -2);
                    } else e = arguments[n];
                    t.push(e);
                }
                X(r + "\nArguments: " + Array.prototype.slice.call(t).join("") + "\n" + (new Error).stack), _ = !1;
            }
            return d.apply(this, arguments);
        }, d);
    }
    var ee = {};
    function ae(e, a) {
        null != c.deprecationHandler && c.deprecationHandler(e, a), ee[e] || (X(a), ee[e] = !0);
    }
    function te(e) {
        return "undefined" != typeof Function && e instanceof Function || "[object Function]" === Object.prototype.toString.call(e);
    }
    function se(e, a) {
        var t, s = I({}, e);
        for(t in a)l(a, t) && (z(e[t]) && z(a[t]) ? (s[t] = {}, I(s[t], e[t]), I(s[t], a[t])) : null != a[t] ? s[t] = a[t] : delete s[t]);
        for(t in e)l(e, t) && !l(a, t) && z(e[t]) && (s[t] = I({}, s[t]));
        return s;
    }
    function ne(e) {
        null != e && this.set(e);
    }
    c.suppressDeprecationWarnings = !1, c.deprecationHandler = null;
    var re = Object.keys || function(e) {
        var a, t = [];
        for(a in e)l(e, a) && t.push(a);
        return t;
    };
    function de(e, a, t) {
        var s = "" + Math.abs(e);
        return (0 <= e ? t ? "+" : "" : "-") + Math.pow(10, Math.max(0, a - s.length)).toString().substr(1) + s;
    }
    var _e = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, ie = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, oe = {}, me = {};
    function s(e, a, t, s) {
        var n = "string" == typeof s ? function() {
            return this[s]();
        } : s;
        e && (me[e] = n), a && (me[a[0]] = function() {
            return de(n.apply(this, arguments), a[1], a[2]);
        }), t && (me[t] = function() {
            return this.localeData().ordinal(n.apply(this, arguments), e);
        });
    }
    function ue(e, a) {
        return e.isValid() ? (a = le(a, e.localeData()), oe[a] = oe[a] || function(s) {
            for(var e, n = s.match(_e), a = 0, r = n.length; a < r; a++)me[n[a]] ? n[a] = me[n[a]] : n[a] = (e = n[a]).match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
            return function(e) {
                for(var a = "", t = 0; t < r; t++)a += te(n[t]) ? n[t].call(e, s) : n[t];
                return a;
            };
        }(a), oe[a](e)) : e.localeData().invalidDate();
    }
    function le(e, a) {
        var t = 5;
        function s(e) {
            return a.longDateFormat(e) || e;
        }
        for(ie.lastIndex = 0; 0 <= t && ie.test(e);)e = e.replace(ie, s), ie.lastIndex = 0, --t;
        return e;
    }
    var Me = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function d(e) {
        return "string" == typeof e ? Me[e] || Me[e.toLowerCase()] : void 0;
    }
    function he(e) {
        var a, t, s = {};
        for(t in e)l(e, t) && (a = d(t)) && (s[a] = e[t]);
        return s;
    }
    var ce = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    var Le = /\d/, a = /\d\d/, Ye = /\d{3}/, t = /\d{4}/, n = /[+-]?\d{6}/, r = /\d\d?/, ye = /\d\d\d\d?/, _ = /\d\d\d\d\d\d?/, fe = /\d{1,3}/, i = /\d{1,4}/, o = /[+-]?\d{1,6}/, ke = /\d+/, pe = /[+-]?\d+/, De = /Z|[+-]\d\d:?\d\d/gi, Te = /Z|[+-]\d\d(?::?\d\d)?/gi, m = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, u = /^[1-9]\d?/, M = /^([1-9]\d|\d)/;
    function h(e, t, s) {
        be[e] = te(t) ? t : function(e, a) {
            return e && s ? s : t;
        };
    }
    function ge(e, a) {
        return l(be, e) ? be[e](a._strict, a._locale) : new RegExp(we(e.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(e, a, t, s, n) {
            return a || t || s || n;
        })));
    }
    function we(e) {
        return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function y(e) {
        return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
    }
    function f(e) {
        var e = +e, a = 0;
        return a = 0 != e && isFinite(e) ? y(e) : a;
    }
    var be = {}, He = {};
    function k(e, t) {
        var a, s, n = t;
        for("string" == typeof e && (e = [
            e
        ]), J(t) && (n = function(e, a) {
            a[t] = f(e);
        }), s = e.length, a = 0; a < s; a++)He[e[a]] = n;
    }
    function Se(e, n) {
        k(e, function(e, a, t, s) {
            t._w = t._w || {}, n(e, t._w, t, s);
        });
    }
    function ve(e) {
        return e % 4 == 0 && e % 100 != 0 || e % 400 == 0;
    }
    var p = 0, je = 1, xe = 2, D = 3, Pe = 4, Oe = 5, We = 6, Ae = 7, Ee = 8;
    function Fe(e) {
        return ve(e) ? 366 : 365;
    }
    s("Y", 0, 0, function() {
        var e = this.year();
        return e <= 9999 ? de(e, 4) : "+" + e;
    }), s(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    }), s(0, [
        "YYYY",
        4
    ], 0, "year"), s(0, [
        "YYYYY",
        5
    ], 0, "year"), s(0, [
        "YYYYYY",
        6,
        !0
    ], 0, "year"), h("Y", pe), h("YY", r, a), h("YYYY", i, t), h("YYYYY", o, n), h("YYYYYY", o, n), k([
        "YYYYY",
        "YYYYYY"
    ], p), k("YYYY", function(e, a) {
        a[p] = 2 === e.length ? c.parseTwoDigitYear(e) : f(e);
    }), k("YY", function(e, a) {
        a[p] = c.parseTwoDigitYear(e);
    }), k("Y", function(e, a) {
        a[p] = parseInt(e, 10);
    }), c.parseTwoDigitYear = function(e) {
        return f(e) + (68 < f(e) ? 1900 : 2e3);
    };
    var T, ze = Ne("FullYear", !0);
    function Ne(a, t) {
        return function(e) {
            return null != e ? (Re(this, a, e), c.updateOffset(this, t), this) : Je(this, a);
        };
    }
    function Je(e, a) {
        if (!e.isValid()) return NaN;
        var t = e._d, s = e._isUTC;
        switch(a){
            case "Milliseconds":
                return s ? t.getUTCMilliseconds() : t.getMilliseconds();
            case "Seconds":
                return s ? t.getUTCSeconds() : t.getSeconds();
            case "Minutes":
                return s ? t.getUTCMinutes() : t.getMinutes();
            case "Hours":
                return s ? t.getUTCHours() : t.getHours();
            case "Date":
                return s ? t.getUTCDate() : t.getDate();
            case "Day":
                return s ? t.getUTCDay() : t.getDay();
            case "Month":
                return s ? t.getUTCMonth() : t.getMonth();
            case "FullYear":
                return s ? t.getUTCFullYear() : t.getFullYear();
            default:
                return NaN;
        }
    }
    function Re(e, a, t) {
        var s, n, r;
        if (e.isValid() && !isNaN(t)) {
            switch(s = e._d, n = e._isUTC, a){
                case "Milliseconds":
                    return n ? s.setUTCMilliseconds(t) : s.setMilliseconds(t);
                case "Seconds":
                    return n ? s.setUTCSeconds(t) : s.setSeconds(t);
                case "Minutes":
                    return n ? s.setUTCMinutes(t) : s.setMinutes(t);
                case "Hours":
                    return n ? s.setUTCHours(t) : s.setHours(t);
                case "Date":
                    return n ? s.setUTCDate(t) : s.setDate(t);
                case "FullYear":
                    break;
                default:
                    return;
            }
            a = t, r = e.month(), e = 29 !== (e = e.date()) || 1 !== r || ve(a) ? e : 28, n ? s.setUTCFullYear(a, r, e) : s.setFullYear(a, r, e);
        }
    }
    function Ce(e, a) {
        var t;
        return isNaN(e) || isNaN(a) ? NaN : (t = (a % (t = 12) + t) % t, e += (a - t) / 12, 1 == t ? ve(e) ? 29 : 28 : 31 - t % 7 % 2);
    }
    T = Array.prototype.indexOf || function(e) {
        for(var a = 0; a < this.length; ++a)if (this[a] === e) return a;
        return -1;
    }, s("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    }), s("MMM", 0, 0, function(e) {
        return this.localeData().monthsShort(this, e);
    }), s("MMMM", 0, 0, function(e) {
        return this.localeData().months(this, e);
    }), h("M", r, u), h("MM", r, a), h("MMM", function(e, a) {
        return a.monthsShortRegex(e);
    }), h("MMMM", function(e, a) {
        return a.monthsRegex(e);
    }), k([
        "M",
        "MM"
    ], function(e, a) {
        a[je] = f(e) - 1;
    }), k([
        "MMM",
        "MMMM"
    ], function(e, a, t, s) {
        s = t._locale.monthsParse(e, s, t._strict);
        null != s ? a[je] = s : Y(t).invalidMonth = e;
    });
    var Ie = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), Ue = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), Ge = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, Ve = m, qe = m;
    function Be(e, a) {
        if (e.isValid()) {
            if ("string" == typeof a) {
                if (/^\d+$/.test(a)) a = f(a);
                else if (!J(a = e.localeData().monthsParse(a))) return;
            }
            var t = (t = e.date()) < 29 ? t : Math.min(t, Ce(e.year(), a));
            e._isUTC ? e._d.setUTCMonth(a, t) : e._d.setMonth(a, t);
        }
    }
    function Ke(e) {
        return null != e ? (Be(this, e), c.updateOffset(this, !0), this) : Je(this, "Month");
    }
    function Ze() {
        function e(e, a) {
            return a.length - e.length;
        }
        for(var a, t, s = [], n = [], r = [], d = 0; d < 12; d++)t = U([
            2e3,
            d
        ]), a = we(this.monthsShort(t, "")), t = we(this.months(t, "")), s.push(a), n.push(t), r.push(t), r.push(a);
        s.sort(e), n.sort(e), r.sort(e), this._monthsRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + s.join("|") + ")", "i");
    }
    function $e(e, a, t, s, n, r, d) {
        var _;
        return e < 100 && 0 <= e ? (_ = new Date(e + 400, a, t, s, n, r, d), isFinite(_.getFullYear()) && _.setFullYear(e)) : _ = new Date(e, a, t, s, n, r, d), _;
    }
    function Qe(e) {
        var a;
        return e < 100 && 0 <= e ? ((a = Array.prototype.slice.call(arguments))[0] = e + 400, a = new Date(Date.UTC.apply(null, a)), isFinite(a.getUTCFullYear()) && a.setUTCFullYear(e)) : a = new Date(Date.UTC.apply(null, arguments)), a;
    }
    function Xe(e, a, t) {
        t = 7 + a - t;
        return t - (7 + Qe(e, 0, t).getUTCDay() - a) % 7 - 1;
    }
    function ea(e, a, t, s, n) {
        var r, a = 1 + 7 * (a - 1) + (7 + t - s) % 7 + Xe(e, s, n), t = a <= 0 ? Fe(r = e - 1) + a : a > Fe(e) ? (r = e + 1, a - Fe(e)) : (r = e, a);
        return {
            year: r,
            dayOfYear: t
        };
    }
    function aa(e, a, t) {
        var s, n, r = Xe(e.year(), a, t), r = Math.floor((e.dayOfYear() - r - 1) / 7) + 1;
        return r < 1 ? s = r + ta(n = e.year() - 1, a, t) : r > ta(e.year(), a, t) ? (s = r - ta(e.year(), a, t), n = e.year() + 1) : (n = e.year(), s = r), {
            week: s,
            year: n
        };
    }
    function ta(e, a, t) {
        var s = Xe(e, a, t), a = Xe(e + 1, a, t);
        return (Fe(e) - s + a) / 7;
    }
    s("w", [
        "ww",
        2
    ], "wo", "week"), s("W", [
        "WW",
        2
    ], "Wo", "isoWeek"), h("w", r, u), h("ww", r, a), h("W", r, u), h("WW", r, a), Se([
        "w",
        "ww",
        "W",
        "WW"
    ], function(e, a, t, s) {
        a[s.substr(0, 1)] = f(e);
    });
    function sa(e, a) {
        return e.slice(a, 7).concat(e.slice(0, a));
    }
    s("d", 0, "do", "day"), s("dd", 0, 0, function(e) {
        return this.localeData().weekdaysMin(this, e);
    }), s("ddd", 0, 0, function(e) {
        return this.localeData().weekdaysShort(this, e);
    }), s("dddd", 0, 0, function(e) {
        return this.localeData().weekdays(this, e);
    }), s("e", 0, 0, "weekday"), s("E", 0, 0, "isoWeekday"), h("d", r), h("e", r), h("E", r), h("dd", function(e, a) {
        return a.weekdaysMinRegex(e);
    }), h("ddd", function(e, a) {
        return a.weekdaysShortRegex(e);
    }), h("dddd", function(e, a) {
        return a.weekdaysRegex(e);
    }), Se([
        "dd",
        "ddd",
        "dddd"
    ], function(e, a, t, s) {
        s = t._locale.weekdaysParse(e, s, t._strict);
        null != s ? a.d = s : Y(t).invalidWeekday = e;
    }), Se([
        "d",
        "e",
        "E"
    ], function(e, a, t, s) {
        a[s] = f(e);
    });
    var na = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), ra = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), da = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), _a = m, ia = m, oa = m;
    function ma() {
        function e(e, a) {
            return a.length - e.length;
        }
        for(var a, t, s, n = [], r = [], d = [], _ = [], i = 0; i < 7; i++)s = U([
            2e3,
            1
        ]).day(i), a = we(this.weekdaysMin(s, "")), t = we(this.weekdaysShort(s, "")), s = we(this.weekdays(s, "")), n.push(a), r.push(t), d.push(s), _.push(a), _.push(t), _.push(s);
        n.sort(e), r.sort(e), d.sort(e), _.sort(e), this._weekdaysRegex = new RegExp("^(" + _.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + d.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + n.join("|") + ")", "i");
    }
    function ua() {
        return this.hours() % 12 || 12;
    }
    function la(e, a) {
        s(e, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), a);
        });
    }
    function Ma(e, a) {
        return a._meridiemParse;
    }
    s("H", [
        "HH",
        2
    ], 0, "hour"), s("h", [
        "hh",
        2
    ], 0, ua), s("k", [
        "kk",
        2
    ], 0, function() {
        return this.hours() || 24;
    }), s("hmm", 0, 0, function() {
        return "" + ua.apply(this) + de(this.minutes(), 2);
    }), s("hmmss", 0, 0, function() {
        return "" + ua.apply(this) + de(this.minutes(), 2) + de(this.seconds(), 2);
    }), s("Hmm", 0, 0, function() {
        return "" + this.hours() + de(this.minutes(), 2);
    }), s("Hmmss", 0, 0, function() {
        return "" + this.hours() + de(this.minutes(), 2) + de(this.seconds(), 2);
    }), la("a", !0), la("A", !1), h("a", Ma), h("A", Ma), h("H", r, M), h("h", r, u), h("k", r, u), h("HH", r, a), h("hh", r, a), h("kk", r, a), h("hmm", ye), h("hmmss", _), h("Hmm", ye), h("Hmmss", _), k([
        "H",
        "HH"
    ], D), k([
        "k",
        "kk"
    ], function(e, a, t) {
        e = f(e);
        a[D] = 24 === e ? 0 : e;
    }), k([
        "a",
        "A"
    ], function(e, a, t) {
        t._isPm = t._locale.isPM(e), t._meridiem = e;
    }), k([
        "h",
        "hh"
    ], function(e, a, t) {
        a[D] = f(e), Y(t).bigHour = !0;
    }), k("hmm", function(e, a, t) {
        var s = e.length - 2;
        a[D] = f(e.substr(0, s)), a[Pe] = f(e.substr(s)), Y(t).bigHour = !0;
    }), k("hmmss", function(e, a, t) {
        var s = e.length - 4, n = e.length - 2;
        a[D] = f(e.substr(0, s)), a[Pe] = f(e.substr(s, 2)), a[Oe] = f(e.substr(n)), Y(t).bigHour = !0;
    }), k("Hmm", function(e, a, t) {
        var s = e.length - 2;
        a[D] = f(e.substr(0, s)), a[Pe] = f(e.substr(s));
    }), k("Hmmss", function(e, a, t) {
        var s = e.length - 4, n = e.length - 2;
        a[D] = f(e.substr(0, s)), a[Pe] = f(e.substr(s, 2)), a[Oe] = f(e.substr(n));
    });
    m = Ne("Hours", !0);
    var ha, ca = {
        calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L"
        },
        longDateFormat: {
            LTS: "h:mm:ss A",
            LT: "h:mm A",
            L: "MM/DD/YYYY",
            LL: "MMMM D, YYYY",
            LLL: "MMMM D, YYYY h:mm A",
            LLLL: "dddd, MMMM D, YYYY h:mm A"
        },
        invalidDate: "Invalid date",
        ordinal: "%d",
        dayOfMonthOrdinalParse: /\d{1,2}/,
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            w: "a week",
            ww: "%d weeks",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        },
        months: Ie,
        monthsShort: Ue,
        week: {
            dow: 0,
            doy: 6
        },
        weekdays: na,
        weekdaysMin: da,
        weekdaysShort: ra,
        meridiemParse: /[ap]\.?m?\.?/i
    }, g = {}, La = {};
    function Ya(e) {
        return e && e.toLowerCase().replace("_", "-");
    }
    function ya(e) {
        for(var a, t, s, n, r = 0; r < e.length;){
            for(a = (n = Ya(e[r]).split("-")).length, t = (t = Ya(e[r + 1])) ? t.split("-") : null; 0 < a;){
                if (s = fa(n.slice(0, a).join("-"))) return s;
                if (t && t.length >= a && function(e, a) {
                    for(var t = Math.min(e.length, a.length), s = 0; s < t; s += 1)if (e[s] !== a[s]) return s;
                    return t;
                }(n, t) >= a - 1) break;
                a--;
            }
            r++;
        }
        return ha;
    }
    function fa(a) {
        var e, t;
        if (void 0 === g[a] && true && module && module.exports && (t = a) && t.match("^[^/\\\\]*$")) try {
            e = ha._abbr, require("./locale/" + a), ka(e);
        } catch (e) {
            g[a] = null;
        }
        return g[a];
    }
    function ka(e, a) {
        return e && ((a = L(a) ? Da(e) : pa(e, a)) ? ha = a : "undefined" != typeof console && console.warn && console.warn("Locale " + e + " not found. Did you forget to load it?")), ha._abbr;
    }
    function pa(e, a) {
        if (null === a) return delete g[e], null;
        var t, s = ca;
        if (a.abbr = e, null != g[e]) ae("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), s = g[e]._config;
        else if (null != a.parentLocale) {
            if (null != g[a.parentLocale]) s = g[a.parentLocale]._config;
            else {
                if (null == (t = fa(a.parentLocale))) return La[a.parentLocale] || (La[a.parentLocale] = []), La[a.parentLocale].push({
                    name: e,
                    config: a
                }), null;
                s = t._config;
            }
        }
        return g[e] = new ne(se(s, a)), La[e] && La[e].forEach(function(e) {
            pa(e.name, e.config);
        }), ka(e), g[e];
    }
    function Da(e) {
        var a;
        if (!(e = e && e._locale && e._locale._abbr ? e._locale._abbr : e)) return ha;
        if (!F(e)) {
            if (a = fa(e)) return a;
            e = [
                e
            ];
        }
        return ya(e);
    }
    function Ta(e) {
        var a = e._a;
        return a && -2 === Y(e).overflow && (a = a[je] < 0 || 11 < a[je] ? je : a[xe] < 1 || a[xe] > Ce(a[p], a[je]) ? xe : a[D] < 0 || 24 < a[D] || 24 === a[D] && (0 !== a[Pe] || 0 !== a[Oe] || 0 !== a[We]) ? D : a[Pe] < 0 || 59 < a[Pe] ? Pe : a[Oe] < 0 || 59 < a[Oe] ? Oe : a[We] < 0 || 999 < a[We] ? We : -1, Y(e)._overflowDayOfYear && (a < p || xe < a) && (a = xe), Y(e)._overflowWeeks && -1 === a && (a = Ae), Y(e)._overflowWeekday && -1 === a && (a = Ee), Y(e).overflow = a), e;
    }
    var ga = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, wa = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, ba = /Z|[+-]\d\d(?::?\d\d)?/, Ha = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            !1
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            !1
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            !1
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            !1
        ],
        [
            "YYYY",
            /\d{4}/,
            !1
        ]
    ], Sa = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], va = /^\/?Date\((-?\d+)/i, ja = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, xa = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    function Pa(e) {
        var a, t, s, n, r, d, _ = e._i, i = ga.exec(_) || wa.exec(_), _ = Ha.length, o = Sa.length;
        if (i) {
            for(Y(e).iso = !0, a = 0, t = _; a < t; a++)if (Ha[a][1].exec(i[1])) {
                n = Ha[a][0], s = !1 !== Ha[a][2];
                break;
            }
            if (null == n) e._isValid = !1;
            else {
                if (i[3]) {
                    for(a = 0, t = o; a < t; a++)if (Sa[a][1].exec(i[3])) {
                        r = (i[2] || " ") + Sa[a][0];
                        break;
                    }
                    if (null == r) return void (e._isValid = !1);
                }
                if (s || null == r) {
                    if (i[4]) {
                        if (!ba.exec(i[4])) return void (e._isValid = !1);
                        d = "Z";
                    }
                    e._f = n + (r || "") + (d || ""), Fa(e);
                } else e._isValid = !1;
            }
        } else e._isValid = !1;
    }
    function Oa(e, a, t, s, n, r) {
        e = [
            function(e) {
                e = parseInt(e, 10);
                if (e <= 49) return 2e3 + e;
                if (e <= 999) return 1900 + e;
                return e;
            }(e),
            Ue.indexOf(a),
            parseInt(t, 10),
            parseInt(s, 10),
            parseInt(n, 10)
        ];
        return r && e.push(parseInt(r, 10)), e;
    }
    function Wa(e) {
        var a, t, s = ja.exec(e._i.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, ""));
        s ? (a = Oa(s[4], s[3], s[2], s[5], s[6], s[7]), function(e, a, t) {
            if (!e || ra.indexOf(e) === new Date(a[0], a[1], a[2]).getDay()) return 1;
            Y(t).weekdayMismatch = !0, t._isValid = !1;
        }(s[1], a, e) && (e._a = a, e._tzm = (a = s[8], t = s[9], s = s[10], a ? xa[a] : t ? 0 : 60 * (((a = parseInt(s, 10)) - (t = a % 100)) / 100) + t), e._d = Qe.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), Y(e).rfc2822 = !0)) : e._isValid = !1;
    }
    function Aa(e, a, t) {
        return null != e ? e : null != a ? a : t;
    }
    function Ea(e) {
        var a, t, s, n, r, d, _, i, o, m, u, l = [];
        if (!e._d) {
            for(s = e, n = new Date(c.now()), t = s._useUTC ? [
                n.getUTCFullYear(),
                n.getUTCMonth(),
                n.getUTCDate()
            ] : [
                n.getFullYear(),
                n.getMonth(),
                n.getDate()
            ], e._w && null == e._a[xe] && null == e._a[je] && (null != (n = (s = e)._w).GG || null != n.W || null != n.E ? (i = 1, o = 4, r = Aa(n.GG, s._a[p], aa(w(), 1, 4).year), d = Aa(n.W, 1), ((_ = Aa(n.E, 1)) < 1 || 7 < _) && (m = !0)) : (i = s._locale._week.dow, o = s._locale._week.doy, u = aa(w(), i, o), r = Aa(n.gg, s._a[p], u.year), d = Aa(n.w, u.week), null != n.d ? ((_ = n.d) < 0 || 6 < _) && (m = !0) : null != n.e ? (_ = n.e + i, (n.e < 0 || 6 < n.e) && (m = !0)) : _ = i), d < 1 || d > ta(r, i, o) ? Y(s)._overflowWeeks = !0 : null != m ? Y(s)._overflowWeekday = !0 : (u = ea(r, d, _, i, o), s._a[p] = u.year, s._dayOfYear = u.dayOfYear)), null != e._dayOfYear && (n = Aa(e._a[p], t[p]), (e._dayOfYear > Fe(n) || 0 === e._dayOfYear) && (Y(e)._overflowDayOfYear = !0), m = Qe(n, 0, e._dayOfYear), e._a[je] = m.getUTCMonth(), e._a[xe] = m.getUTCDate()), a = 0; a < 3 && null == e._a[a]; ++a)e._a[a] = l[a] = t[a];
            for(; a < 7; a++)e._a[a] = l[a] = null == e._a[a] ? 2 === a ? 1 : 0 : e._a[a];
            24 === e._a[D] && 0 === e._a[Pe] && 0 === e._a[Oe] && 0 === e._a[We] && (e._nextDay = !0, e._a[D] = 0), e._d = (e._useUTC ? Qe : $e).apply(null, l), r = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), null != e._tzm && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[D] = 24), e._w && void 0 !== e._w.d && e._w.d !== r && (Y(e).weekdayMismatch = !0);
        }
    }
    function Fa(e) {
        if (e._f === c.ISO_8601) Pa(e);
        else if (e._f === c.RFC_2822) Wa(e);
        else {
            e._a = [], Y(e).empty = !0;
            for(var a, t, s, n, r, d = "" + e._i, _ = d.length, i = 0, o = le(e._f, e._locale).match(_e) || [], m = o.length, u = 0; u < m; u++)t = o[u], (a = (d.match(ge(t, e)) || [])[0]) && (0 < (s = d.substr(0, d.indexOf(a))).length && Y(e).unusedInput.push(s), d = d.slice(d.indexOf(a) + a.length), i += a.length), me[t] ? (a ? Y(e).empty = !1 : Y(e).unusedTokens.push(t), s = t, r = e, null != (n = a) && l(He, s) && He[s](n, r._a, r, s)) : e._strict && !a && Y(e).unusedTokens.push(t);
            Y(e).charsLeftOver = _ - i, 0 < d.length && Y(e).unusedInput.push(d), e._a[D] <= 12 && !0 === Y(e).bigHour && 0 < e._a[D] && (Y(e).bigHour = void 0), Y(e).parsedDateParts = e._a.slice(0), Y(e).meridiem = e._meridiem, e._a[D] = function(e, a, t) {
                if (null == t) return a;
                return null != e.meridiemHour ? e.meridiemHour(a, t) : null != e.isPM ? ((e = e.isPM(t)) && a < 12 && (a += 12), a = e || 12 !== a ? a : 0) : a;
            }(e._locale, e._a[D], e._meridiem), null !== (_ = Y(e).era) && (e._a[p] = e._locale.erasConvertYear(_, e._a[p])), Ea(e), Ta(e);
        }
    }
    function za(e) {
        var a, t, s, n = e._i, r = e._f;
        if (e._locale = e._locale || Da(e._l), null === n || void 0 === r && "" === n) return V({
            nullInput: !0
        });
        if ("string" == typeof n && (e._i = n = e._locale.preparse(n)), Q(n)) return new $(Ta(n));
        if (R(n)) e._d = n;
        else if (F(r)) {
            var d, _, i, o, m, u, l = e, M = !1, h = l._f.length;
            if (0 === h) Y(l).invalidFormat = !0, l._d = new Date(NaN);
            else {
                for(o = 0; o < h; o++)m = 0, u = !1, d = Z({}, l), null != l._useUTC && (d._useUTC = l._useUTC), d._f = l._f[o], Fa(d), G(d) && (u = !0), m = (m += Y(d).charsLeftOver) + 10 * Y(d).unusedTokens.length, Y(d).score = m, M ? m < i && (i = m, _ = d) : (null == i || m < i || u) && (i = m, _ = d, u) && (M = !0);
                I(l, _ || d);
            }
        } else if (r) Fa(e);
        else if (L(r = (n = e)._i)) n._d = new Date(c.now());
        else R(r) ? n._d = new Date(r.valueOf()) : "string" == typeof r ? (t = n, null !== (a = va.exec(t._i)) ? t._d = new Date(+a[1]) : (Pa(t), !1 === t._isValid && (delete t._isValid, Wa(t), !1 === t._isValid) && (delete t._isValid, t._strict ? t._isValid = !1 : c.createFromInputFallback(t)))) : F(r) ? (n._a = C(r.slice(0), function(e) {
            return parseInt(e, 10);
        }), Ea(n)) : z(r) ? (a = n)._d || (s = void 0 === (t = he(a._i)).day ? t.date : t.day, a._a = C([
            t.year,
            t.month,
            s,
            t.hour,
            t.minute,
            t.second,
            t.millisecond
        ], function(e) {
            return e && parseInt(e, 10);
        }), Ea(a)) : J(r) ? n._d = new Date(r) : c.createFromInputFallback(n);
        return G(e) || (e._d = null), e;
    }
    function Na(e, a, t, s, n) {
        var r = {};
        return !0 !== a && !1 !== a || (s = a, a = void 0), !0 !== t && !1 !== t || (s = t, t = void 0), (z(e) && N(e) || F(e) && 0 === e.length) && (e = void 0), r._isAMomentObject = !0, r._useUTC = r._isUTC = n, r._l = t, r._i = e, r._f = a, r._strict = s, (n = new $(Ta(za(n = r))))._nextDay && (n.add(1, "d"), n._nextDay = void 0), n;
    }
    function w(e, a, t, s) {
        return Na(e, a, t, s, !1);
    }
    c.createFromInputFallback = e("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(e) {
        e._d = new Date(e._i + (e._useUTC ? " UTC" : ""));
    }), c.ISO_8601 = function() {}, c.RFC_2822 = function() {};
    ye = e("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var e = w.apply(null, arguments);
        return this.isValid() && e.isValid() ? e < this ? this : e : V();
    }), _ = e("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var e = w.apply(null, arguments);
        return this.isValid() && e.isValid() ? this < e ? this : e : V();
    });
    function Ja(e, a) {
        var t, s;
        if (!(a = 1 === a.length && F(a[0]) ? a[0] : a).length) return w();
        for(t = a[0], s = 1; s < a.length; ++s)a[s].isValid() && !a[s][e](t) || (t = a[s]);
        return t;
    }
    var Ra = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function Ca(e) {
        var e = he(e), a = e.year || 0, t = e.quarter || 0, s = e.month || 0, n = e.week || e.isoWeek || 0, r = e.day || 0, d = e.hour || 0, _ = e.minute || 0, i = e.second || 0, o = e.millisecond || 0;
        this._isValid = function(e) {
            var a, t, s = !1, n = Ra.length;
            for(a in e)if (l(e, a) && (-1 === T.call(Ra, a) || null != e[a] && isNaN(e[a]))) return !1;
            for(t = 0; t < n; ++t)if (e[Ra[t]]) {
                if (s) return !1;
                parseFloat(e[Ra[t]]) !== f(e[Ra[t]]) && (s = !0);
            }
            return !0;
        }(e), this._milliseconds = +o + 1e3 * i + 6e4 * _ + 1e3 * d * 3600, this._days = +r + 7 * n, this._months = +s + 3 * t + 12 * a, this._data = {}, this._locale = Da(), this._bubble();
    }
    function Ia(e) {
        return e instanceof Ca;
    }
    function Ua(e) {
        return e < 0 ? -1 * Math.round(-1 * e) : Math.round(e);
    }
    function Ga(e, t) {
        s(e, 0, 0, function() {
            var e = this.utcOffset(), a = "+";
            return e < 0 && (e = -e, a = "-"), a + de(~~(e / 60), 2) + t + de(~~e % 60, 2);
        });
    }
    Ga("Z", ":"), Ga("ZZ", ""), h("Z", Te), h("ZZ", Te), k([
        "Z",
        "ZZ"
    ], function(e, a, t) {
        t._useUTC = !0, t._tzm = qa(Te, e);
    });
    var Va = /([\+\-]|\d\d)/gi;
    function qa(e, a) {
        var a = (a || "").match(e);
        return null === a ? null : 0 === (a = 60 * (e = ((a[a.length - 1] || []) + "").match(Va) || [
            "-",
            0,
            0
        ])[1] + f(e[2])) ? 0 : "+" === e[0] ? a : -a;
    }
    function Ba(e, a) {
        var t;
        return a._isUTC ? (a = a.clone(), t = (Q(e) || R(e) ? e : w(e)).valueOf() - a.valueOf(), a._d.setTime(a._d.valueOf() + t), c.updateOffset(a, !1), a) : w(e).local();
    }
    function Ka(e) {
        return -Math.round(e._d.getTimezoneOffset());
    }
    function Za() {
        return !!this.isValid() && this._isUTC && 0 === this._offset;
    }
    c.updateOffset = function() {};
    var $a = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, Qa = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function Xa(e, a) {
        var t, s = e;
        return Ia(e) ? s = {
            ms: e._milliseconds,
            d: e._days,
            M: e._months
        } : J(e) || !isNaN(+e) ? (s = {}, a ? s[a] = +e : s.milliseconds = +e) : (a = $a.exec(e)) ? (t = "-" === a[1] ? -1 : 1, s = {
            y: 0,
            d: f(a[xe]) * t,
            h: f(a[D]) * t,
            m: f(a[Pe]) * t,
            s: f(a[Oe]) * t,
            ms: f(Ua(1e3 * a[We])) * t
        }) : (a = Qa.exec(e)) ? (t = "-" === a[1] ? -1 : 1, s = {
            y: et(a[2], t),
            M: et(a[3], t),
            w: et(a[4], t),
            d: et(a[5], t),
            h: et(a[6], t),
            m: et(a[7], t),
            s: et(a[8], t)
        }) : null == s ? s = {} : "object" == typeof s && ("from" in s || "to" in s) && (a = function(e, a) {
            var t;
            if (!e.isValid() || !a.isValid()) return {
                milliseconds: 0,
                months: 0
            };
            a = Ba(a, e), e.isBefore(a) ? t = at(e, a) : ((t = at(a, e)).milliseconds = -t.milliseconds, t.months = -t.months);
            return t;
        }(w(s.from), w(s.to)), (s = {}).ms = a.milliseconds, s.M = a.months), t = new Ca(s), Ia(e) && l(e, "_locale") && (t._locale = e._locale), Ia(e) && l(e, "_isValid") && (t._isValid = e._isValid), t;
    }
    function et(e, a) {
        e = e && parseFloat(e.replace(",", "."));
        return (isNaN(e) ? 0 : e) * a;
    }
    function at(e, a) {
        var t = {};
        return t.months = a.month() - e.month() + 12 * (a.year() - e.year()), e.clone().add(t.months, "M").isAfter(a) && --t.months, t.milliseconds = +a - +e.clone().add(t.months, "M"), t;
    }
    function tt(s, n) {
        return function(e, a) {
            var t;
            return null === a || isNaN(+a) || (ae(n, "moment()." + n + "(period, number) is deprecated. Please use moment()." + n + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), t = e, e = a, a = t), st(this, Xa(e, a), s), this;
        };
    }
    function st(e, a, t, s) {
        var n = a._milliseconds, r = Ua(a._days), a = Ua(a._months);
        e.isValid() && (s = null == s || s, a && Be(e, Je(e, "Month") + a * t), r && Re(e, "Date", Je(e, "Date") + r * t), n && e._d.setTime(e._d.valueOf() + n * t), s) && c.updateOffset(e, r || a);
    }
    Xa.fn = Ca.prototype, Xa.invalid = function() {
        return Xa(NaN);
    };
    Ie = tt(1, "add"), na = tt(-1, "subtract");
    function nt(e) {
        return "string" == typeof e || e instanceof String;
    }
    function rt(e) {
        return Q(e) || R(e) || nt(e) || J(e) || function(a) {
            var e = F(a), t = !1;
            e && (t = 0 === a.filter(function(e) {
                return !J(e) && nt(a);
            }).length);
            return e && t;
        }(e) || function(e) {
            var a, t, s = z(e) && !N(e), n = !1, r = [
                "years",
                "year",
                "y",
                "months",
                "month",
                "M",
                "days",
                "day",
                "d",
                "dates",
                "date",
                "D",
                "hours",
                "hour",
                "h",
                "minutes",
                "minute",
                "m",
                "seconds",
                "second",
                "s",
                "milliseconds",
                "millisecond",
                "ms"
            ], d = r.length;
            for(a = 0; a < d; a += 1)t = r[a], n = n || l(e, t);
            return s && n;
        }(e) || null == e;
    }
    function dt(e, a) {
        var t, s;
        return e.date() < a.date() ? -dt(a, e) : -((t = 12 * (a.year() - e.year()) + (a.month() - e.month())) + (a - (s = e.clone().add(t, "months")) < 0 ? (a - s) / (s - e.clone().add(t - 1, "months")) : (a - s) / (e.clone().add(1 + t, "months") - s))) || 0;
    }
    function _t(e) {
        return void 0 === e ? this._locale._abbr : (null != (e = Da(e)) && (this._locale = e), this);
    }
    c.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", c.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    da = e("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(e) {
        return void 0 === e ? this.localeData() : this.locale(e);
    });
    function it() {
        return this._locale;
    }
    var ot = 126227808e5;
    function mt(e, a) {
        return (e % a + a) % a;
    }
    function ut(e, a, t) {
        return e < 100 && 0 <= e ? new Date(e + 400, a, t) - ot : new Date(e, a, t).valueOf();
    }
    function lt(e, a, t) {
        return e < 100 && 0 <= e ? Date.UTC(e + 400, a, t) - ot : Date.UTC(e, a, t);
    }
    function Mt(e, a) {
        return a.erasAbbrRegex(e);
    }
    function ht() {
        for(var e, a, t, s = [], n = [], r = [], d = [], _ = this.eras(), i = 0, o = _.length; i < o; ++i)e = we(_[i].name), a = we(_[i].abbr), t = we(_[i].narrow), n.push(e), s.push(a), r.push(t), d.push(e), d.push(a), d.push(t);
        this._erasRegex = new RegExp("^(" + d.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp("^(" + r.join("|") + ")", "i");
    }
    function ct(e, a) {
        s(0, [
            e,
            e.length
        ], 0, a);
    }
    function Lt(e, a, t, s, n) {
        var r;
        return null == e ? aa(this, s, n).year : (r = ta(e, s, n), (function(e, a, t, s, n) {
            e = ea(e, a, t, s, n), a = Qe(e.year, 0, e.dayOfYear);
            return this.year(a.getUTCFullYear()), this.month(a.getUTCMonth()), this.date(a.getUTCDate()), this;
        }).call(this, e, a = r < a ? r : a, t, s, n));
    }
    s("N", 0, 0, "eraAbbr"), s("NN", 0, 0, "eraAbbr"), s("NNN", 0, 0, "eraAbbr"), s("NNNN", 0, 0, "eraName"), s("NNNNN", 0, 0, "eraNarrow"), s("y", [
        "y",
        1
    ], "yo", "eraYear"), s("y", [
        "yy",
        2
    ], 0, "eraYear"), s("y", [
        "yyy",
        3
    ], 0, "eraYear"), s("y", [
        "yyyy",
        4
    ], 0, "eraYear"), h("N", Mt), h("NN", Mt), h("NNN", Mt), h("NNNN", function(e, a) {
        return a.erasNameRegex(e);
    }), h("NNNNN", function(e, a) {
        return a.erasNarrowRegex(e);
    }), k([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(e, a, t, s) {
        s = t._locale.erasParse(e, s, t._strict);
        s ? Y(t).era = s : Y(t).invalidEra = e;
    }), h("y", ke), h("yy", ke), h("yyy", ke), h("yyyy", ke), h("yo", function(e, a) {
        return a._eraYearOrdinalRegex || ke;
    }), k([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], p), k([
        "yo"
    ], function(e, a, t, s) {
        var n;
        t._locale._eraYearOrdinalRegex && (n = e.match(t._locale._eraYearOrdinalRegex)), t._locale.eraYearOrdinalParse ? a[p] = t._locale.eraYearOrdinalParse(e, n) : a[p] = parseInt(e, 10);
    }), s(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    }), s(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    }), ct("gggg", "weekYear"), ct("ggggg", "weekYear"), ct("GGGG", "isoWeekYear"), ct("GGGGG", "isoWeekYear"), h("G", pe), h("g", pe), h("GG", r, a), h("gg", r, a), h("GGGG", i, t), h("gggg", i, t), h("GGGGG", o, n), h("ggggg", o, n), Se([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(e, a, t, s) {
        a[s.substr(0, 2)] = f(e);
    }), Se([
        "gg",
        "GG"
    ], function(e, a, t, s) {
        a[s] = c.parseTwoDigitYear(e);
    }), s("Q", 0, "Qo", "quarter"), h("Q", Le), k("Q", function(e, a) {
        a[je] = 3 * (f(e) - 1);
    }), s("D", [
        "DD",
        2
    ], "Do", "date"), h("D", r, u), h("DD", r, a), h("Do", function(e, a) {
        return e ? a._dayOfMonthOrdinalParse || a._ordinalParse : a._dayOfMonthOrdinalParseLenient;
    }), k([
        "D",
        "DD"
    ], xe), k("Do", function(e, a) {
        a[xe] = f(e.match(r)[0]);
    });
    i = Ne("Date", !0);
    s("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear"), h("DDD", fe), h("DDDD", Ye), k([
        "DDD",
        "DDDD"
    ], function(e, a, t) {
        t._dayOfYear = f(e);
    }), s("m", [
        "mm",
        2
    ], 0, "minute"), h("m", r, M), h("mm", r, a), k([
        "m",
        "mm"
    ], Pe);
    var Yt, t = Ne("Minutes", !1), o = (s("s", [
        "ss",
        2
    ], 0, "second"), h("s", r, M), h("ss", r, a), k([
        "s",
        "ss"
    ], Oe), Ne("Seconds", !1));
    for(s("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    }), s(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    }), s(0, [
        "SSS",
        3
    ], 0, "millisecond"), s(0, [
        "SSSS",
        4
    ], 0, function() {
        return 10 * this.millisecond();
    }), s(0, [
        "SSSSS",
        5
    ], 0, function() {
        return 100 * this.millisecond();
    }), s(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return 1e3 * this.millisecond();
    }), s(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return 1e4 * this.millisecond();
    }), s(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return 1e5 * this.millisecond();
    }), s(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return 1e6 * this.millisecond();
    }), h("S", fe, Le), h("SS", fe, a), h("SSS", fe, Ye), Yt = "SSSS"; Yt.length <= 9; Yt += "S")h(Yt, ke);
    function yt(e, a) {
        a[We] = f(1e3 * ("0." + e));
    }
    for(Yt = "S"; Yt.length <= 9; Yt += "S")k(Yt, yt);
    n = Ne("Milliseconds", !1), s("z", 0, 0, "zoneAbbr"), s("zz", 0, 0, "zoneName");
    u = $.prototype;
    function ft(e) {
        return e;
    }
    u.add = Ie, u.calendar = function(e, a) {
        1 === arguments.length && (arguments[0] ? rt(arguments[0]) ? (e = arguments[0], a = void 0) : function(e) {
            for(var a = z(e) && !N(e), t = !1, s = [
                "sameDay",
                "nextDay",
                "lastDay",
                "nextWeek",
                "lastWeek",
                "sameElse"
            ], n = 0; n < s.length; n += 1)t = t || l(e, s[n]);
            return a && t;
        }(arguments[0]) && (a = arguments[0], e = void 0) : a = e = void 0);
        var e = e || w(), t = Ba(e, this).startOf("day"), t = c.calendarFormat(this, t) || "sameElse", a = a && (te(a[t]) ? a[t].call(this, e) : a[t]);
        return this.format(a || this.localeData().calendar(t, this, w(e)));
    }, u.clone = function() {
        return new $(this);
    }, u.diff = function(e, a, t) {
        var s, n, r;
        if (!this.isValid()) return NaN;
        if (!(s = Ba(e, this)).isValid()) return NaN;
        switch(n = 6e4 * (s.utcOffset() - this.utcOffset()), a = d(a)){
            case "year":
                r = dt(this, s) / 12;
                break;
            case "month":
                r = dt(this, s);
                break;
            case "quarter":
                r = dt(this, s) / 3;
                break;
            case "second":
                r = (this - s) / 1e3;
                break;
            case "minute":
                r = (this - s) / 6e4;
                break;
            case "hour":
                r = (this - s) / 36e5;
                break;
            case "day":
                r = (this - s - n) / 864e5;
                break;
            case "week":
                r = (this - s - n) / 6048e5;
                break;
            default:
                r = this - s;
        }
        return t ? r : y(r);
    }, u.endOf = function(e) {
        var a, t;
        if (void 0 !== (e = d(e)) && "millisecond" !== e && this.isValid()) {
            switch(t = this._isUTC ? lt : ut, e){
                case "year":
                    a = t(this.year() + 1, 0, 1) - 1;
                    break;
                case "quarter":
                    a = t(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                    break;
                case "month":
                    a = t(this.year(), this.month() + 1, 1) - 1;
                    break;
                case "week":
                    a = t(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                    break;
                case "isoWeek":
                    a = t(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                    break;
                case "day":
                case "date":
                    a = t(this.year(), this.month(), this.date() + 1) - 1;
                    break;
                case "hour":
                    a = this._d.valueOf(), a += 36e5 - mt(a + (this._isUTC ? 0 : 6e4 * this.utcOffset()), 36e5) - 1;
                    break;
                case "minute":
                    a = this._d.valueOf(), a += 6e4 - mt(a, 6e4) - 1;
                    break;
                case "second":
                    a = this._d.valueOf(), a += 1e3 - mt(a, 1e3) - 1;
                    break;
            }
            this._d.setTime(a), c.updateOffset(this, !0);
        }
        return this;
    }, u.format = function(e) {
        return e = e || (this.isUtc() ? c.defaultFormatUtc : c.defaultFormat), e = ue(this, e), this.localeData().postformat(e);
    }, u.from = function(e, a) {
        return this.isValid() && (Q(e) && e.isValid() || w(e).isValid()) ? Xa({
            to: this,
            from: e
        }).locale(this.locale()).humanize(!a) : this.localeData().invalidDate();
    }, u.fromNow = function(e) {
        return this.from(w(), e);
    }, u.to = function(e, a) {
        return this.isValid() && (Q(e) && e.isValid() || w(e).isValid()) ? Xa({
            from: this,
            to: e
        }).locale(this.locale()).humanize(!a) : this.localeData().invalidDate();
    }, u.toNow = function(e) {
        return this.to(w(), e);
    }, u.get = function(e) {
        return te(this[e = d(e)]) ? this[e]() : this;
    }, u.invalidAt = function() {
        return Y(this).overflow;
    }, u.isAfter = function(e, a) {
        return e = Q(e) ? e : w(e), !(!this.isValid() || !e.isValid()) && ("millisecond" === (a = d(a) || "millisecond") ? this.valueOf() > e.valueOf() : e.valueOf() < this.clone().startOf(a).valueOf());
    }, u.isBefore = function(e, a) {
        return e = Q(e) ? e : w(e), !(!this.isValid() || !e.isValid()) && ("millisecond" === (a = d(a) || "millisecond") ? this.valueOf() < e.valueOf() : this.clone().endOf(a).valueOf() < e.valueOf());
    }, u.isBetween = function(e, a, t, s) {
        return e = Q(e) ? e : w(e), a = Q(a) ? a : w(a), !!(this.isValid() && e.isValid() && a.isValid()) && ("(" === (s = s || "()")[0] ? this.isAfter(e, t) : !this.isBefore(e, t)) && (")" === s[1] ? this.isBefore(a, t) : !this.isAfter(a, t));
    }, u.isSame = function(e, a) {
        var e = Q(e) ? e : w(e);
        return !(!this.isValid() || !e.isValid()) && ("millisecond" === (a = d(a) || "millisecond") ? this.valueOf() === e.valueOf() : (e = e.valueOf(), this.clone().startOf(a).valueOf() <= e && e <= this.clone().endOf(a).valueOf()));
    }, u.isSameOrAfter = function(e, a) {
        return this.isSame(e, a) || this.isAfter(e, a);
    }, u.isSameOrBefore = function(e, a) {
        return this.isSame(e, a) || this.isBefore(e, a);
    }, u.isValid = function() {
        return G(this);
    }, u.lang = da, u.locale = _t, u.localeData = it, u.max = _, u.min = ye, u.parsingFlags = function() {
        return I({}, Y(this));
    }, u.set = function(e, a) {
        if ("object" == typeof e) for(var t = function(e) {
            var a, t = [];
            for(a in e)l(e, a) && t.push({
                unit: a,
                priority: ce[a]
            });
            return t.sort(function(e, a) {
                return e.priority - a.priority;
            }), t;
        }(e = he(e)), s = t.length, n = 0; n < s; n++)this[t[n].unit](e[t[n].unit]);
        else if (te(this[e = d(e)])) return this[e](a);
        return this;
    }, u.startOf = function(e) {
        var a, t;
        if (void 0 !== (e = d(e)) && "millisecond" !== e && this.isValid()) {
            switch(t = this._isUTC ? lt : ut, e){
                case "year":
                    a = t(this.year(), 0, 1);
                    break;
                case "quarter":
                    a = t(this.year(), this.month() - this.month() % 3, 1);
                    break;
                case "month":
                    a = t(this.year(), this.month(), 1);
                    break;
                case "week":
                    a = t(this.year(), this.month(), this.date() - this.weekday());
                    break;
                case "isoWeek":
                    a = t(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                    break;
                case "day":
                case "date":
                    a = t(this.year(), this.month(), this.date());
                    break;
                case "hour":
                    a = this._d.valueOf(), a -= mt(a + (this._isUTC ? 0 : 6e4 * this.utcOffset()), 36e5);
                    break;
                case "minute":
                    a = this._d.valueOf(), a -= mt(a, 6e4);
                    break;
                case "second":
                    a = this._d.valueOf(), a -= mt(a, 1e3);
                    break;
            }
            this._d.setTime(a), c.updateOffset(this, !0);
        }
        return this;
    }, u.subtract = na, u.toArray = function() {
        var e = this;
        return [
            e.year(),
            e.month(),
            e.date(),
            e.hour(),
            e.minute(),
            e.second(),
            e.millisecond()
        ];
    }, u.toObject = function() {
        var e = this;
        return {
            years: e.year(),
            months: e.month(),
            date: e.date(),
            hours: e.hours(),
            minutes: e.minutes(),
            seconds: e.seconds(),
            milliseconds: e.milliseconds()
        };
    }, u.toDate = function() {
        return new Date(this.valueOf());
    }, u.toISOString = function(e) {
        var a;
        return this.isValid() ? (a = (e = !0 !== e) ? this.clone().utc() : this).year() < 0 || 9999 < a.year() ? ue(a, e ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : te(Date.prototype.toISOString) ? e ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", ue(a, "Z")) : ue(a, e ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ") : null;
    }, u.inspect = function() {
        var e, a, t;
        return this.isValid() ? (a = "moment", e = "", this.isLocal() || (a = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", e = "Z"), a = "[" + a + '("]', t = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", this.format(a + t + "-MM-DD[T]HH:mm:ss.SSS" + (e + '[")]'))) : "moment.invalid(/* " + this._i + " */)";
    }, "undefined" != typeof Symbol && null != Symbol.for && (u[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    }), u.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
    }, u.toString = function() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }, u.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
    }, u.valueOf = function() {
        return this._d.valueOf() - 6e4 * (this._offset || 0);
    }, u.creationData = function() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }, u.eraName = function() {
        for(var e, a = this.localeData().eras(), t = 0, s = a.length; t < s; ++t){
            if (e = this.clone().startOf("day").valueOf(), a[t].since <= e && e <= a[t].until) return a[t].name;
            if (a[t].until <= e && e <= a[t].since) return a[t].name;
        }
        return "";
    }, u.eraNarrow = function() {
        for(var e, a = this.localeData().eras(), t = 0, s = a.length; t < s; ++t){
            if (e = this.clone().startOf("day").valueOf(), a[t].since <= e && e <= a[t].until) return a[t].narrow;
            if (a[t].until <= e && e <= a[t].since) return a[t].narrow;
        }
        return "";
    }, u.eraAbbr = function() {
        for(var e, a = this.localeData().eras(), t = 0, s = a.length; t < s; ++t){
            if (e = this.clone().startOf("day").valueOf(), a[t].since <= e && e <= a[t].until) return a[t].abbr;
            if (a[t].until <= e && e <= a[t].since) return a[t].abbr;
        }
        return "";
    }, u.eraYear = function() {
        for(var e, a, t = this.localeData().eras(), s = 0, n = t.length; s < n; ++s)if (e = t[s].since <= t[s].until ? 1 : -1, a = this.clone().startOf("day").valueOf(), t[s].since <= a && a <= t[s].until || t[s].until <= a && a <= t[s].since) return (this.year() - c(t[s].since).year()) * e + t[s].offset;
        return this.year();
    }, u.year = ze, u.isLeapYear = function() {
        return ve(this.year());
    }, u.weekYear = function(e) {
        return Lt.call(this, e, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }, u.isoWeekYear = function(e) {
        return Lt.call(this, e, this.isoWeek(), this.isoWeekday(), 1, 4);
    }, u.quarter = u.quarters = function(e) {
        return null == e ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (e - 1) + this.month() % 3);
    }, u.month = Ke, u.daysInMonth = function() {
        return Ce(this.year(), this.month());
    }, u.week = u.weeks = function(e) {
        var a = this.localeData().week(this);
        return null == e ? a : this.add(7 * (e - a), "d");
    }, u.isoWeek = u.isoWeeks = function(e) {
        var a = aa(this, 1, 4).week;
        return null == e ? a : this.add(7 * (e - a), "d");
    }, u.weeksInYear = function() {
        var e = this.localeData()._week;
        return ta(this.year(), e.dow, e.doy);
    }, u.weeksInWeekYear = function() {
        var e = this.localeData()._week;
        return ta(this.weekYear(), e.dow, e.doy);
    }, u.isoWeeksInYear = function() {
        return ta(this.year(), 1, 4);
    }, u.isoWeeksInISOWeekYear = function() {
        return ta(this.isoWeekYear(), 1, 4);
    }, u.date = i, u.day = u.days = function(e) {
        var a, t, s;
        return this.isValid() ? (a = Je(this, "Day"), null != e ? (t = e, s = this.localeData(), e = "string" != typeof t ? t : isNaN(t) ? "number" == typeof (t = s.weekdaysParse(t)) ? t : null : parseInt(t, 10), this.add(e - a, "d")) : a) : null != e ? this : NaN;
    }, u.weekday = function(e) {
        var a;
        return this.isValid() ? (a = (this.day() + 7 - this.localeData()._week.dow) % 7, null == e ? a : this.add(e - a, "d")) : null != e ? this : NaN;
    }, u.isoWeekday = function(e) {
        var a, t;
        return this.isValid() ? null != e ? (a = e, t = this.localeData(), t = "string" == typeof a ? t.weekdaysParse(a) % 7 || 7 : isNaN(a) ? null : a, this.day(this.day() % 7 ? t : t - 7)) : this.day() || 7 : null != e ? this : NaN;
    }, u.dayOfYear = function(e) {
        var a = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return null == e ? a : this.add(e - a, "d");
    }, u.hour = u.hours = m, u.minute = u.minutes = t, u.second = u.seconds = o, u.millisecond = u.milliseconds = n, u.utcOffset = function(e, a, t) {
        var s, n = this._offset || 0;
        if (!this.isValid()) return null != e ? this : NaN;
        if (null == e) return this._isUTC ? n : Ka(this);
        if ("string" == typeof e) {
            if (null === (e = qa(Te, e))) return this;
        } else Math.abs(e) < 16 && !t && (e *= 60);
        return !this._isUTC && a && (s = Ka(this)), this._offset = e, this._isUTC = !0, null != s && this.add(s, "m"), n !== e && (!a || this._changeInProgress ? st(this, Xa(e - n, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, c.updateOffset(this, !0), this._changeInProgress = null)), this;
    }, u.utc = function(e) {
        return this.utcOffset(0, e);
    }, u.local = function(e) {
        return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e) && this.subtract(Ka(this), "m"), this;
    }, u.parseZone = function() {
        var e;
        return null != this._tzm ? this.utcOffset(this._tzm, !1, !0) : "string" == typeof this._i && (null != (e = qa(De, this._i)) ? this.utcOffset(e) : this.utcOffset(0, !0)), this;
    }, u.hasAlignedHourOffset = function(e) {
        return !!this.isValid() && (e = e ? w(e).utcOffset() : 0, (this.utcOffset() - e) % 60 == 0);
    }, u.isDST = function() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }, u.isLocal = function() {
        return !!this.isValid() && !this._isUTC;
    }, u.isUtcOffset = function() {
        return !!this.isValid() && this._isUTC;
    }, u.isUtc = Za, u.isUTC = Za, u.zoneAbbr = function() {
        return this._isUTC ? "UTC" : "";
    }, u.zoneName = function() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }, u.dates = e("dates accessor is deprecated. Use date instead.", i), u.months = e("months accessor is deprecated. Use month instead", Ke), u.years = e("years accessor is deprecated. Use year instead", ze), u.zone = e("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", function(e, a) {
        return null != e ? (this.utcOffset(e = "string" != typeof e ? -e : e, a), this) : -this.utcOffset();
    }), u.isDSTShifted = e("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", function() {
        var e, a;
        return L(this._isDSTShifted) && (Z(e = {}, this), (e = za(e))._a ? (a = (e._isUTC ? U : w)(e._a), this._isDSTShifted = this.isValid() && 0 < function(e, a, t) {
            for(var s = Math.min(e.length, a.length), n = Math.abs(e.length - a.length), r = 0, d = 0; d < s; d++)(t && e[d] !== a[d] || !t && f(e[d]) !== f(a[d])) && r++;
            return r + n;
        }(e._a, a.toArray())) : this._isDSTShifted = !1), this._isDSTShifted;
    });
    M = ne.prototype;
    function kt(e, a, t, s) {
        var n = Da(), s = U().set(s, a);
        return n[t](s, e);
    }
    function pt(e, a, t) {
        if (J(e) && (a = e, e = void 0), e = e || "", null != a) return kt(e, a, t, "month");
        for(var s = [], n = 0; n < 12; n++)s[n] = kt(e, n, t, "month");
        return s;
    }
    function Dt(e, a, t, s) {
        a = ("boolean" == typeof e ? J(a) && (t = a, a = void 0) : (a = e, e = !1, J(t = a) && (t = a, a = void 0)), a || "");
        var n, r = Da(), d = e ? r._week.dow : 0, _ = [];
        if (null != t) return kt(a, (t + d) % 7, s, "day");
        for(n = 0; n < 7; n++)_[n] = kt(a, (n + d) % 7, s, "day");
        return _;
    }
    M.calendar = function(e, a, t) {
        return te(e = this._calendar[e] || this._calendar.sameElse) ? e.call(a, t) : e;
    }, M.longDateFormat = function(e) {
        var a = this._longDateFormat[e], t = this._longDateFormat[e.toUpperCase()];
        return a || !t ? a : (this._longDateFormat[e] = t.match(_e).map(function(e) {
            return "MMMM" === e || "MM" === e || "DD" === e || "dddd" === e ? e.slice(1) : e;
        }).join(""), this._longDateFormat[e]);
    }, M.invalidDate = function() {
        return this._invalidDate;
    }, M.ordinal = function(e) {
        return this._ordinal.replace("%d", e);
    }, M.preparse = ft, M.postformat = ft, M.relativeTime = function(e, a, t, s) {
        var n = this._relativeTime[t];
        return te(n) ? n(e, a, t, s) : n.replace(/%d/i, e);
    }, M.pastFuture = function(e, a) {
        return te(e = this._relativeTime[0 < e ? "future" : "past"]) ? e(a) : e.replace(/%s/i, a);
    }, M.set = function(e) {
        var a, t;
        for(t in e)l(e, t) && (te(a = e[t]) ? this[t] = a : this["_" + t] = a);
        this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }, M.eras = function(e, a) {
        for(var t, s = this._eras || Da("en")._eras, n = 0, r = s.length; n < r; ++n){
            switch(typeof s[n].since){
                case "string":
                    t = c(s[n].since).startOf("day"), s[n].since = t.valueOf();
                    break;
            }
            switch(typeof s[n].until){
                case "undefined":
                    s[n].until = 1 / 0;
                    break;
                case "string":
                    t = c(s[n].until).startOf("day").valueOf(), s[n].until = t.valueOf();
                    break;
            }
        }
        return s;
    }, M.erasParse = function(e, a, t) {
        var s, n, r, d, _, i = this.eras();
        for(e = e.toUpperCase(), s = 0, n = i.length; s < n; ++s)if (r = i[s].name.toUpperCase(), d = i[s].abbr.toUpperCase(), _ = i[s].narrow.toUpperCase(), t) switch(a){
            case "N":
            case "NN":
            case "NNN":
                if (d === e) return i[s];
                break;
            case "NNNN":
                if (r === e) return i[s];
                break;
            case "NNNNN":
                if (_ === e) return i[s];
                break;
        }
        else if (0 <= [
            r,
            d,
            _
        ].indexOf(e)) return i[s];
    }, M.erasConvertYear = function(e, a) {
        var t = e.since <= e.until ? 1 : -1;
        return void 0 === a ? c(e.since).year() : c(e.since).year() + (a - e.offset) * t;
    }, M.erasAbbrRegex = function(e) {
        return l(this, "_erasAbbrRegex") || ht.call(this), e ? this._erasAbbrRegex : this._erasRegex;
    }, M.erasNameRegex = function(e) {
        return l(this, "_erasNameRegex") || ht.call(this), e ? this._erasNameRegex : this._erasRegex;
    }, M.erasNarrowRegex = function(e) {
        return l(this, "_erasNarrowRegex") || ht.call(this), e ? this._erasNarrowRegex : this._erasRegex;
    }, M.months = function(e, a) {
        return e ? (F(this._months) ? this._months : this._months[(this._months.isFormat || Ge).test(a) ? "format" : "standalone"])[e.month()] : F(this._months) ? this._months : this._months.standalone;
    }, M.monthsShort = function(e, a) {
        return e ? (F(this._monthsShort) ? this._monthsShort : this._monthsShort[Ge.test(a) ? "format" : "standalone"])[e.month()] : F(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
    }, M.monthsParse = function(e, a, t) {
        var s, n;
        if (this._monthsParseExact) return (function(e, a, t) {
            var s, n, r, e = e.toLocaleLowerCase();
            if (!this._monthsParse) for(this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], s = 0; s < 12; ++s)r = U([
                2e3,
                s
            ]), this._shortMonthsParse[s] = this.monthsShort(r, "").toLocaleLowerCase(), this._longMonthsParse[s] = this.months(r, "").toLocaleLowerCase();
            return t ? "MMM" === a ? -1 !== (n = T.call(this._shortMonthsParse, e)) ? n : null : -1 !== (n = T.call(this._longMonthsParse, e)) ? n : null : "MMM" === a ? -1 !== (n = T.call(this._shortMonthsParse, e)) || -1 !== (n = T.call(this._longMonthsParse, e)) ? n : null : -1 !== (n = T.call(this._longMonthsParse, e)) || -1 !== (n = T.call(this._shortMonthsParse, e)) ? n : null;
        }).call(this, e, a, t);
        for(this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), s = 0; s < 12; s++){
            if (n = U([
                2e3,
                s
            ]), t && !this._longMonthsParse[s] && (this._longMonthsParse[s] = new RegExp("^" + this.months(n, "").replace(".", "") + "$", "i"), this._shortMonthsParse[s] = new RegExp("^" + this.monthsShort(n, "").replace(".", "") + "$", "i")), t || this._monthsParse[s] || (n = "^" + this.months(n, "") + "|^" + this.monthsShort(n, ""), this._monthsParse[s] = new RegExp(n.replace(".", ""), "i")), t && "MMMM" === a && this._longMonthsParse[s].test(e)) return s;
            if (t && "MMM" === a && this._shortMonthsParse[s].test(e)) return s;
            if (!t && this._monthsParse[s].test(e)) return s;
        }
    }, M.monthsRegex = function(e) {
        return this._monthsParseExact ? (l(this, "_monthsRegex") || Ze.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (l(this, "_monthsRegex") || (this._monthsRegex = qe), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
    }, M.monthsShortRegex = function(e) {
        return this._monthsParseExact ? (l(this, "_monthsRegex") || Ze.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (l(this, "_monthsShortRegex") || (this._monthsShortRegex = Ve), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
    }, M.week = function(e) {
        return aa(e, this._week.dow, this._week.doy).week;
    }, M.firstDayOfYear = function() {
        return this._week.doy;
    }, M.firstDayOfWeek = function() {
        return this._week.dow;
    }, M.weekdays = function(e, a) {
        return a = F(this._weekdays) ? this._weekdays : this._weekdays[e && !0 !== e && this._weekdays.isFormat.test(a) ? "format" : "standalone"], !0 === e ? sa(a, this._week.dow) : e ? a[e.day()] : a;
    }, M.weekdaysMin = function(e) {
        return !0 === e ? sa(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
    }, M.weekdaysShort = function(e) {
        return !0 === e ? sa(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
    }, M.weekdaysParse = function(e, a, t) {
        var s, n;
        if (this._weekdaysParseExact) return (function(e, a, t) {
            var s, n, r, e = e.toLocaleLowerCase();
            if (!this._weekdaysParse) for(this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], s = 0; s < 7; ++s)r = U([
                2e3,
                1
            ]).day(s), this._minWeekdaysParse[s] = this.weekdaysMin(r, "").toLocaleLowerCase(), this._shortWeekdaysParse[s] = this.weekdaysShort(r, "").toLocaleLowerCase(), this._weekdaysParse[s] = this.weekdays(r, "").toLocaleLowerCase();
            return t ? "dddd" === a ? -1 !== (n = T.call(this._weekdaysParse, e)) ? n : null : "ddd" === a ? -1 !== (n = T.call(this._shortWeekdaysParse, e)) ? n : null : -1 !== (n = T.call(this._minWeekdaysParse, e)) ? n : null : "dddd" === a ? -1 !== (n = T.call(this._weekdaysParse, e)) || -1 !== (n = T.call(this._shortWeekdaysParse, e)) || -1 !== (n = T.call(this._minWeekdaysParse, e)) ? n : null : "ddd" === a ? -1 !== (n = T.call(this._shortWeekdaysParse, e)) || -1 !== (n = T.call(this._weekdaysParse, e)) || -1 !== (n = T.call(this._minWeekdaysParse, e)) ? n : null : -1 !== (n = T.call(this._minWeekdaysParse, e)) || -1 !== (n = T.call(this._weekdaysParse, e)) || -1 !== (n = T.call(this._shortWeekdaysParse, e)) ? n : null;
        }).call(this, e, a, t);
        for(this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), s = 0; s < 7; s++){
            if (n = U([
                2e3,
                1
            ]).day(s), t && !this._fullWeekdaysParse[s] && (this._fullWeekdaysParse[s] = new RegExp("^" + this.weekdays(n, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[s] = new RegExp("^" + this.weekdaysShort(n, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[s] = new RegExp("^" + this.weekdaysMin(n, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[s] || (n = "^" + this.weekdays(n, "") + "|^" + this.weekdaysShort(n, "") + "|^" + this.weekdaysMin(n, ""), this._weekdaysParse[s] = new RegExp(n.replace(".", ""), "i")), t && "dddd" === a && this._fullWeekdaysParse[s].test(e)) return s;
            if (t && "ddd" === a && this._shortWeekdaysParse[s].test(e)) return s;
            if (t && "dd" === a && this._minWeekdaysParse[s].test(e)) return s;
            if (!t && this._weekdaysParse[s].test(e)) return s;
        }
    }, M.weekdaysRegex = function(e) {
        return this._weekdaysParseExact ? (l(this, "_weekdaysRegex") || ma.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (l(this, "_weekdaysRegex") || (this._weekdaysRegex = _a), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
    }, M.weekdaysShortRegex = function(e) {
        return this._weekdaysParseExact ? (l(this, "_weekdaysRegex") || ma.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (l(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = ia), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
    }, M.weekdaysMinRegex = function(e) {
        return this._weekdaysParseExact ? (l(this, "_weekdaysRegex") || ma.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (l(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = oa), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
    }, M.isPM = function(e) {
        return "p" === (e + "").toLowerCase().charAt(0);
    }, M.meridiem = function(e, a, t) {
        return 11 < e ? t ? "pm" : "PM" : t ? "am" : "AM";
    }, ka("en", {
        eras: [
            {
                since: "0001-01-01",
                until: 1 / 0,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -1 / 0,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(e) {
            var a = e % 10;
            return e + (1 === f(e % 100 / 10) ? "th" : 1 == a ? "st" : 2 == a ? "nd" : 3 == a ? "rd" : "th");
        }
    }), c.lang = e("moment.lang is deprecated. Use moment.locale instead.", ka), c.langData = e("moment.langData is deprecated. Use moment.localeData instead.", Da);
    var Tt = Math.abs;
    function gt(e, a, t, s) {
        a = Xa(a, t);
        return e._milliseconds += s * a._milliseconds, e._days += s * a._days, e._months += s * a._months, e._bubble();
    }
    function wt(e) {
        return e < 0 ? Math.floor(e) : Math.ceil(e);
    }
    function bt(e) {
        return 4800 * e / 146097;
    }
    function Ht(e) {
        return 146097 * e / 4800;
    }
    function St(e) {
        return function() {
            return this.as(e);
        };
    }
    Le = St("ms"), a = St("s"), fe = St("m"), Ye = St("h"), Ie = St("d"), _ = St("w"), ye = St("M"), na = St("Q"), m = St("y"), t = Le;
    function vt(e) {
        return function() {
            return this.isValid() ? this._data[e] : NaN;
        };
    }
    var o = vt("milliseconds"), n = vt("seconds"), i = vt("minutes"), ze = vt("hours"), M = vt("days"), jt = vt("months"), xt = vt("years");
    var Pt = Math.round, Ot = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    function Wt(e, a, t, s) {
        var n = Xa(e).abs(), r = Pt(n.as("s")), d = Pt(n.as("m")), _ = Pt(n.as("h")), i = Pt(n.as("d")), o = Pt(n.as("M")), m = Pt(n.as("w")), n = Pt(n.as("y")), r = (r <= t.ss ? [
            "s",
            r
        ] : r < t.s && [
            "ss",
            r
        ]) || (d <= 1 ? [
            "m"
        ] : d < t.m && [
            "mm",
            d
        ]) || (_ <= 1 ? [
            "h"
        ] : _ < t.h && [
            "hh",
            _
        ]) || (i <= 1 ? [
            "d"
        ] : i < t.d && [
            "dd",
            i
        ]);
        return (r = (r = null != t.w ? r || (m <= 1 ? [
            "w"
        ] : m < t.w && [
            "ww",
            m
        ]) : r) || (o <= 1 ? [
            "M"
        ] : o < t.M && [
            "MM",
            o
        ]) || (n <= 1 ? [
            "y"
        ] : [
            "yy",
            n
        ]))[2] = a, r[3] = 0 < +e, r[4] = s, (function(e, a, t, s, n) {
            return n.relativeTime(a || 1, !!t, e, s);
        }).apply(null, r);
    }
    var At = Math.abs;
    function Et(e) {
        return (0 < e) - (e < 0) || +e;
    }
    function Ft() {
        var e, a, t, s, n, r, d, _, i, o, m;
        return this.isValid() ? (e = At(this._milliseconds) / 1e3, a = At(this._days), t = At(this._months), (_ = this.asSeconds()) ? (s = y(e / 60), n = y(s / 60), e %= 60, s %= 60, r = y(t / 12), t %= 12, d = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", i = Et(this._months) !== Et(_) ? "-" : "", o = Et(this._days) !== Et(_) ? "-" : "", m = Et(this._milliseconds) !== Et(_) ? "-" : "", (_ < 0 ? "-" : "") + "P" + (r ? i + r + "Y" : "") + (t ? i + t + "M" : "") + (a ? o + a + "D" : "") + (n || s || e ? "T" : "") + (n ? m + n + "H" : "") + (s ? m + s + "M" : "") + (e ? m + d + "S" : "")) : "P0D") : this.localeData().invalidDate();
    }
    function zt(e) {
        return 0 === e ? 0 : 1 === e ? 1 : 2 === e ? 2 : 3 <= e % 100 && e % 100 <= 10 ? 3 : 11 <= e % 100 ? 4 : 5;
    }
    function b(d) {
        return function(e, a, t, s) {
            var n = zt(e), r = Rt[d][zt(e)];
            return (r = 2 === n ? r[a ? 0 : 1] : r).replace(/%d/i, e);
        };
    }
    function Nt(e) {
        return 0 === e ? 0 : 1 === e ? 1 : 2 === e ? 2 : 3 <= e % 100 && e % 100 <= 10 ? 3 : 11 <= e % 100 ? 4 : 5;
    }
    function H(d) {
        return function(e, a, t, s) {
            var n = Nt(e), r = It[d][Nt(e)];
            return (r = 2 === n ? r[a ? 0 : 1] : r).replace(/%d/i, e);
        };
    }
    function Jt(e) {
        return 0 === e ? 0 : 1 === e ? 1 : 2 === e ? 2 : 3 <= e % 100 && e % 100 <= 10 ? 3 : 11 <= e % 100 ? 4 : 5;
    }
    function S(d) {
        return function(e, a, t, s) {
            var n = Jt(e), r = Zt[d][Jt(e)];
            return (r = 2 === n ? r[a ? 0 : 1] : r).replace(/%d/i, e);
        };
    }
    var v = Ca.prototype, Rt = (v.isValid = function() {
        return this._isValid;
    }, v.abs = function() {
        var e = this._data;
        return this._milliseconds = Tt(this._milliseconds), this._days = Tt(this._days), this._months = Tt(this._months), e.milliseconds = Tt(e.milliseconds), e.seconds = Tt(e.seconds), e.minutes = Tt(e.minutes), e.hours = Tt(e.hours), e.months = Tt(e.months), e.years = Tt(e.years), this;
    }, v.add = function(e, a) {
        return gt(this, e, a, 1);
    }, v.subtract = function(e, a) {
        return gt(this, e, a, -1);
    }, v.as = function(e) {
        if (!this.isValid()) return NaN;
        var a, t, s = this._milliseconds;
        if ("month" === (e = d(e)) || "quarter" === e || "year" === e) switch(a = this._days + s / 864e5, t = this._months + bt(a), e){
            case "month":
                return t;
            case "quarter":
                return t / 3;
            case "year":
                return t / 12;
        }
        else switch(a = this._days + Math.round(Ht(this._months)), e){
            case "week":
                return a / 7 + s / 6048e5;
            case "day":
                return a + s / 864e5;
            case "hour":
                return 24 * a + s / 36e5;
            case "minute":
                return 1440 * a + s / 6e4;
            case "second":
                return 86400 * a + s / 1e3;
            case "millisecond":
                return Math.floor(864e5 * a) + s;
            default:
                throw new Error("Unknown unit " + e);
        }
    }, v.asMilliseconds = Le, v.asSeconds = a, v.asMinutes = fe, v.asHours = Ye, v.asDays = Ie, v.asWeeks = _, v.asMonths = ye, v.asQuarters = na, v.asYears = m, v.valueOf = t, v._bubble = function() {
        var e = this._milliseconds, a = this._days, t = this._months, s = this._data;
        return 0 <= e && 0 <= a && 0 <= t || e <= 0 && a <= 0 && t <= 0 || (e += 864e5 * wt(Ht(t) + a), t = a = 0), s.milliseconds = e % 1e3, e = y(e / 1e3), s.seconds = e % 60, e = y(e / 60), s.minutes = e % 60, e = y(e / 60), s.hours = e % 24, a += y(e / 24), t += e = y(bt(a)), a -= wt(Ht(e)), e = y(t / 12), t %= 12, s.days = a, s.months = t, s.years = e, this;
    }, v.clone = function() {
        return Xa(this);
    }, v.get = function(e) {
        return e = d(e), this.isValid() ? this[e + "s"]() : NaN;
    }, v.milliseconds = o, v.seconds = n, v.minutes = i, v.hours = ze, v.days = M, v.weeks = function() {
        return y(this.days() / 7);
    }, v.months = jt, v.years = xt, v.humanize = function(e, a) {
        var t, s;
        return this.isValid() ? (t = !1, s = Ot, "object" == typeof e && (a = e, e = !1), "boolean" == typeof e && (t = e), "object" == typeof a && (s = Object.assign({}, Ot, a), null != a.s) && null == a.ss && (s.ss = a.s - 1), e = this.localeData(), a = Wt(this, !t, s, e), t && (a = e.pastFuture(+this, a)), e.postformat(a)) : this.localeData().invalidDate();
    }, v.toISOString = Ft, v.toString = Ft, v.toJSON = Ft, v.locale = _t, v.localeData = it, v.toIsoString = e("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", Ft), v.lang = da, s("X", 0, 0, "unix"), s("x", 0, 0, "valueOf"), h("x", pe), h("X", /[+-]?\d+(\.\d{1,3})?/), k("X", function(e, a, t) {
        t._d = new Date(1e3 * parseFloat(e));
    }), k("x", function(e, a, t) {
        t._d = new Date(f(e));
    }), c.version = "2.30.1", E = w, c.fn = u, c.min = function() {
        return Ja("isBefore", [].slice.call(arguments, 0));
    }, c.max = function() {
        return Ja("isAfter", [].slice.call(arguments, 0));
    }, c.now = function() {
        return Date.now ? Date.now() : +new Date;
    }, c.utc = U, c.unix = function(e) {
        return w(1e3 * e);
    }, c.months = function(e, a) {
        return pt(e, a, "months");
    }, c.isDate = R, c.locale = ka, c.invalid = V, c.duration = Xa, c.isMoment = Q, c.weekdays = function(e, a, t) {
        return Dt(e, a, t, "weekdays");
    }, c.parseZone = function() {
        return w.apply(null, arguments).parseZone();
    }, c.localeData = Da, c.isDuration = Ia, c.monthsShort = function(e, a) {
        return pt(e, a, "monthsShort");
    }, c.weekdaysMin = function(e, a, t) {
        return Dt(e, a, t, "weekdaysMin");
    }, c.defineLocale = pa, c.updateLocale = function(e, a) {
        var t, s;
        return null != a ? (s = ca, null != g[e] && null != g[e].parentLocale ? g[e].set(se(g[e]._config, a)) : (a = se(s = null != (t = fa(e)) ? t._config : s, a), null == t && (a.abbr = e), (s = new ne(a)).parentLocale = g[e], g[e] = s), ka(e)) : null != g[e] && (null != g[e].parentLocale ? (g[e] = g[e].parentLocale, e === ka() && ka(e)) : null != g[e] && delete g[e]), g[e];
    }, c.locales = function() {
        return re(g);
    }, c.weekdaysShort = function(e, a, t) {
        return Dt(e, a, t, "weekdaysShort");
    }, c.normalizeUnits = d, c.relativeTimeRounding = function(e) {
        return void 0 === e ? Pt : "function" == typeof e && (Pt = e, !0);
    }, c.relativeTimeThreshold = function(e, a) {
        return void 0 !== Ot[e] && (void 0 === a ? Ot[e] : (Ot[e] = a, "s" === e && (Ot.ss = a - 1), !0));
    }, c.calendarFormat = function(e, a) {
        return (e = e.diff(a, "days", !0)) < -6 ? "sameElse" : e < -1 ? "lastWeek" : e < 0 ? "lastDay" : e < 1 ? "sameDay" : e < 2 ? "nextDay" : e < 7 ? "nextWeek" : "sameElse";
    }, c.prototype = u, c.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    }, c.defineLocale("af", {
        months: "Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember".split("_"),
        monthsShort: "Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des".split("_"),
        weekdays: "Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag".split("_"),
        weekdaysShort: "Son_Maa_Din_Woe_Don_Vry_Sat".split("_"),
        weekdaysMin: "So_Ma_Di_Wo_Do_Vr_Sa".split("_"),
        meridiemParse: /vm|nm/i,
        isPM: function(e) {
            return /^nm$/i.test(e);
        },
        meridiem: function(e, a, t) {
            return e < 12 ? t ? "vm" : "VM" : t ? "nm" : "NM";
        },
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Vandag om] LT",
            nextDay: "[M\xf4re om] LT",
            nextWeek: "dddd [om] LT",
            lastDay: "[Gister om] LT",
            lastWeek: "[Laas] dddd [om] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "oor %s",
            past: "%s gelede",
            s: "'n paar sekondes",
            ss: "%d sekondes",
            m: "'n minuut",
            mm: "%d minute",
            h: "'n uur",
            hh: "%d ure",
            d: "'n dag",
            dd: "%d dae",
            M: "'n maand",
            MM: "%d maande",
            y: "'n jaar",
            yy: "%d jaar"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function(e) {
            return e + (1 === e || 8 === e || 20 <= e ? "ste" : "de");
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), {
        s: [
            "\u0623\u0642\u0644 \u0645\u0646 \u062b\u0627\u0646\u064a\u0629",
            "\u062b\u0627\u0646\u064a\u0629 \u0648\u0627\u062d\u062f\u0629",
            [
                "\u062b\u0627\u0646\u064a\u062a\u0627\u0646",
                "\u062b\u0627\u0646\u064a\u062a\u064a\u0646"
            ],
            "%d \u062b\u0648\u0627\u0646",
            "%d \u062b\u0627\u0646\u064a\u0629",
            "%d \u062b\u0627\u0646\u064a\u0629"
        ],
        m: [
            "\u0623\u0642\u0644 \u0645\u0646 \u062f\u0642\u064a\u0642\u0629",
            "\u062f\u0642\u064a\u0642\u0629 \u0648\u0627\u062d\u062f\u0629",
            [
                "\u062f\u0642\u064a\u0642\u062a\u0627\u0646",
                "\u062f\u0642\u064a\u0642\u062a\u064a\u0646"
            ],
            "%d \u062f\u0642\u0627\u0626\u0642",
            "%d \u062f\u0642\u064a\u0642\u0629",
            "%d \u062f\u0642\u064a\u0642\u0629"
        ],
        h: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629",
            "\u0633\u0627\u0639\u0629 \u0648\u0627\u062d\u062f\u0629",
            [
                "\u0633\u0627\u0639\u062a\u0627\u0646",
                "\u0633\u0627\u0639\u062a\u064a\u0646"
            ],
            "%d \u0633\u0627\u0639\u0627\u062a",
            "%d \u0633\u0627\u0639\u0629",
            "%d \u0633\u0627\u0639\u0629"
        ],
        d: [
            "\u0623\u0642\u0644 \u0645\u0646 \u064a\u0648\u0645",
            "\u064a\u0648\u0645 \u0648\u0627\u062d\u062f",
            [
                "\u064a\u0648\u0645\u0627\u0646",
                "\u064a\u0648\u0645\u064a\u0646"
            ],
            "%d \u0623\u064a\u0627\u0645",
            "%d \u064a\u0648\u0645\u064b\u0627",
            "%d \u064a\u0648\u0645"
        ],
        M: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631",
            "\u0634\u0647\u0631 \u0648\u0627\u062d\u062f",
            [
                "\u0634\u0647\u0631\u0627\u0646",
                "\u0634\u0647\u0631\u064a\u0646"
            ],
            "%d \u0623\u0634\u0647\u0631",
            "%d \u0634\u0647\u0631\u0627",
            "%d \u0634\u0647\u0631"
        ],
        y: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645",
            "\u0639\u0627\u0645 \u0648\u0627\u062d\u062f",
            [
                "\u0639\u0627\u0645\u0627\u0646",
                "\u0639\u0627\u0645\u064a\u0646"
            ],
            "%d \u0623\u0639\u0648\u0627\u0645",
            "%d \u0639\u0627\u0645\u064b\u0627",
            "%d \u0639\u0627\u0645"
        ]
    }), Le = [
        "\u062c\u0627\u0646\u0641\u064a",
        "\u0641\u064a\u0641\u0631\u064a",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064a\u0644",
        "\u0645\u0627\u064a",
        "\u062c\u0648\u0627\u0646",
        "\u062c\u0648\u064a\u0644\u064a\u0629",
        "\u0623\u0648\u062a",
        "\u0633\u0628\u062a\u0645\u0628\u0631",
        "\u0623\u0643\u062a\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062f\u064a\u0633\u0645\u0628\u0631"
    ], Ct = (c.defineLocale("ar-dz", {
        months: Le,
        monthsShort: Le,
        weekdays: "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),
        weekdaysShort: "\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),
        weekdaysMin: "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "D/\u200fM/\u200fYYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        meridiemParse: /\u0635|\u0645/,
        isPM: function(e) {
            return "\u0645" === e;
        },
        meridiem: function(e, a, t) {
            return e < 12 ? "\u0635" : "\u0645";
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063a\u062f\u064b\u0627 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0628\u0639\u062f %s",
            past: "\u0645\u0646\u0630 %s",
            s: b("s"),
            ss: b("s"),
            m: b("m"),
            mm: b("m"),
            h: b("h"),
            hh: b("h"),
            d: b("d"),
            dd: b("d"),
            M: b("M"),
            MM: b("M"),
            y: b("y"),
            yy: b("y")
        },
        postformat: function(e) {
            return e.replace(/,/g, "\u060c");
        },
        week: {
            dow: 0,
            doy: 4
        }
    }), c.defineLocale("ar-kw", {
        months: "\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split("_"),
        monthsShort: "\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split("_"),
        weekdays: "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062a\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),
        weekdaysShort: "\u0627\u062d\u062f_\u0627\u062a\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),
        weekdaysMin: "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0641\u064a %s",
            past: "\u0645\u0646\u0630 %s",
            s: "\u062b\u0648\u0627\u0646",
            ss: "%d \u062b\u0627\u0646\u064a\u0629",
            m: "\u062f\u0642\u064a\u0642\u0629",
            mm: "%d \u062f\u0642\u0627\u0626\u0642",
            h: "\u0633\u0627\u0639\u0629",
            hh: "%d \u0633\u0627\u0639\u0627\u062a",
            d: "\u064a\u0648\u0645",
            dd: "%d \u0623\u064a\u0627\u0645",
            M: "\u0634\u0647\u0631",
            MM: "%d \u0623\u0634\u0647\u0631",
            y: "\u0633\u0646\u0629",
            yy: "%d \u0633\u0646\u0648\u0627\u062a"
        },
        week: {
            dow: 0,
            doy: 12
        }
    }), {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        0: "0"
    }), It = {
        s: [
            "\u0623\u0642\u0644 \u0645\u0646 \u062b\u0627\u0646\u064a\u0629",
            "\u062b\u0627\u0646\u064a\u0629 \u0648\u0627\u062d\u062f\u0629",
            [
                "\u062b\u0627\u0646\u064a\u062a\u0627\u0646",
                "\u062b\u0627\u0646\u064a\u062a\u064a\u0646"
            ],
            "%d \u062b\u0648\u0627\u0646",
            "%d \u062b\u0627\u0646\u064a\u0629",
            "%d \u062b\u0627\u0646\u064a\u0629"
        ],
        m: [
            "\u0623\u0642\u0644 \u0645\u0646 \u062f\u0642\u064a\u0642\u0629",
            "\u062f\u0642\u064a\u0642\u0629 \u0648\u0627\u062d\u062f\u0629",
            [
                "\u062f\u0642\u064a\u0642\u062a\u0627\u0646",
                "\u062f\u0642\u064a\u0642\u062a\u064a\u0646"
            ],
            "%d \u062f\u0642\u0627\u0626\u0642",
            "%d \u062f\u0642\u064a\u0642\u0629",
            "%d \u062f\u0642\u064a\u0642\u0629"
        ],
        h: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629",
            "\u0633\u0627\u0639\u0629 \u0648\u0627\u062d\u062f\u0629",
            [
                "\u0633\u0627\u0639\u062a\u0627\u0646",
                "\u0633\u0627\u0639\u062a\u064a\u0646"
            ],
            "%d \u0633\u0627\u0639\u0627\u062a",
            "%d \u0633\u0627\u0639\u0629",
            "%d \u0633\u0627\u0639\u0629"
        ],
        d: [
            "\u0623\u0642\u0644 \u0645\u0646 \u064a\u0648\u0645",
            "\u064a\u0648\u0645 \u0648\u0627\u062d\u062f",
            [
                "\u064a\u0648\u0645\u0627\u0646",
                "\u064a\u0648\u0645\u064a\u0646"
            ],
            "%d \u0623\u064a\u0627\u0645",
            "%d \u064a\u0648\u0645\u064b\u0627",
            "%d \u064a\u0648\u0645"
        ],
        M: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631",
            "\u0634\u0647\u0631 \u0648\u0627\u062d\u062f",
            [
                "\u0634\u0647\u0631\u0627\u0646",
                "\u0634\u0647\u0631\u064a\u0646"
            ],
            "%d \u0623\u0634\u0647\u0631",
            "%d \u0634\u0647\u0631\u0627",
            "%d \u0634\u0647\u0631"
        ],
        y: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645",
            "\u0639\u0627\u0645 \u0648\u0627\u062d\u062f",
            [
                "\u0639\u0627\u0645\u0627\u0646",
                "\u0639\u0627\u0645\u064a\u0646"
            ],
            "%d \u0623\u0639\u0648\u0627\u0645",
            "%d \u0639\u0627\u0645\u064b\u0627",
            "%d \u0639\u0627\u0645"
        ]
    }, a = [
        "\u064a\u0646\u0627\u064a\u0631",
        "\u0641\u0628\u0631\u0627\u064a\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064a\u0644",
        "\u0645\u0627\u064a\u0648",
        "\u064a\u0648\u0646\u064a\u0648",
        "\u064a\u0648\u0644\u064a\u0648",
        "\u0623\u063a\u0633\u0637\u0633",
        "\u0633\u0628\u062a\u0645\u0628\u0631",
        "\u0623\u0643\u062a\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062f\u064a\u0633\u0645\u0628\u0631"
    ], Ut = (c.defineLocale("ar-ly", {
        months: a,
        monthsShort: a,
        weekdays: "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),
        weekdaysShort: "\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),
        weekdaysMin: "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "D/\u200fM/\u200fYYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        meridiemParse: /\u0635|\u0645/,
        isPM: function(e) {
            return "\u0645" === e;
        },
        meridiem: function(e, a, t) {
            return e < 12 ? "\u0635" : "\u0645";
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063a\u062f\u064b\u0627 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0628\u0639\u062f %s",
            past: "\u0645\u0646\u0630 %s",
            s: H("s"),
            ss: H("s"),
            m: H("m"),
            mm: H("m"),
            h: H("h"),
            hh: H("h"),
            d: H("d"),
            dd: H("d"),
            M: H("M"),
            MM: H("M"),
            y: H("y"),
            yy: H("y")
        },
        preparse: function(e) {
            return e.replace(/\u060c/g, ",");
        },
        postformat: function(e) {
            return e.replace(/\d/g, function(e) {
                return Ct[e];
            }).replace(/,/g, "\u060c");
        },
        week: {
            dow: 6,
            doy: 12
        }
    }), c.defineLocale("ar-ma", {
        months: "\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split("_"),
        monthsShort: "\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split("_"),
        weekdays: "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),
        weekdaysShort: "\u0627\u062d\u062f_\u0627\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),
        weekdaysMin: "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0641\u064a %s",
            past: "\u0645\u0646\u0630 %s",
            s: "\u062b\u0648\u0627\u0646",
            ss: "%d \u062b\u0627\u0646\u064a\u0629",
            m: "\u062f\u0642\u064a\u0642\u0629",
            mm: "%d \u062f\u0642\u0627\u0626\u0642",
            h: "\u0633\u0627\u0639\u0629",
            hh: "%d \u0633\u0627\u0639\u0627\u062a",
            d: "\u064a\u0648\u0645",
            dd: "%d \u0623\u064a\u0627\u0645",
            M: "\u0634\u0647\u0631",
            MM: "%d \u0623\u0634\u0647\u0631",
            y: "\u0633\u0646\u0629",
            yy: "%d \u0633\u0646\u0648\u0627\u062a"
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), {
        1: "\u0661",
        2: "\u0662",
        3: "\u0663",
        4: "\u0664",
        5: "\u0665",
        6: "\u0666",
        7: "\u0667",
        8: "\u0668",
        9: "\u0669",
        0: "\u0660"
    }), Gt = {
        "\u0661": "1",
        "\u0662": "2",
        "\u0663": "3",
        "\u0664": "4",
        "\u0665": "5",
        "\u0666": "6",
        "\u0667": "7",
        "\u0668": "8",
        "\u0669": "9",
        "\u0660": "0"
    }, Vt = (c.defineLocale("ar-ps", {
        months: "\u0643\u0627\u0646\u0648\u0646 \u0627\u0644\u062b\u0627\u0646\u064a_\u0634\u0628\u0627\u0637_\u0622\u0630\u0627\u0631_\u0646\u064a\u0633\u0627\u0646_\u0623\u064a\u0651\u0627\u0631_\u062d\u0632\u064a\u0631\u0627\u0646_\u062a\u0645\u0651\u0648\u0632_\u0622\u0628_\u0623\u064a\u0644\u0648\u0644_\u062a\u0634\u0631\u064a \u0627\u0644\u0623\u0648\u0651\u0644_\u062a\u0634\u0631\u064a\u0646 \u0627\u0644\u062b\u0627\u0646\u064a_\u0643\u0627\u0646\u0648\u0646 \u0627\u0644\u0623\u0648\u0651\u0644".split("_"),
        monthsShort: "\u0643\u0662_\u0634\u0628\u0627\u0637_\u0622\u0630\u0627\u0631_\u0646\u064a\u0633\u0627\u0646_\u0623\u064a\u0651\u0627\u0631_\u062d\u0632\u064a\u0631\u0627\u0646_\u062a\u0645\u0651\u0648\u0632_\u0622\u0628_\u0623\u064a\u0644\u0648\u0644_\u062a\u0661_\u062a\u0662_\u0643\u0661".split("_"),
        weekdays: "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),
        weekdaysShort: "\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),
        weekdaysMin: "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        meridiemParse: /\u0635|\u0645/,
        isPM: function(e) {
            return "\u0645" === e;
        },
        meridiem: function(e, a, t) {
            return e < 12 ? "\u0635" : "\u0645";
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0641\u064a %s",
            past: "\u0645\u0646\u0630 %s",
            s: "\u062b\u0648\u0627\u0646",
            ss: "%d \u062b\u0627\u0646\u064a\u0629",
            m: "\u062f\u0642\u064a\u0642\u0629",
            mm: "%d \u062f\u0642\u0627\u0626\u0642",
            h: "\u0633\u0627\u0639\u0629",
            hh: "%d \u0633\u0627\u0639\u0627\u062a",
            d: "\u064a\u0648\u0645",
            dd: "%d \u0623\u064a\u0627\u0645",
            M: "\u0634\u0647\u0631",
            MM: "%d \u0623\u0634\u0647\u0631",
            y: "\u0633\u0646\u0629",
            yy: "%d \u0633\u0646\u0648\u0627\u062a"
        },
        preparse: function(e) {
            return e.replace(/[\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g, function(e) {
                return Gt[e];
            }).split("").reverse().join("").replace(/[\u0661\u0662](?![\u062a\u0643])/g, function(e) {
                return Gt[e];
            }).split("").reverse().join("").replace(/\u060c/g, ",");
        },
        postformat: function(e) {
            return e.replace(/\d/g, function(e) {
                return Ut[e];
            }).replace(/,/g, "\u060c");
        },
        week: {
            dow: 0,
            doy: 6
        }
    }), {
        1: "\u0661",
        2: "\u0662",
        3: "\u0663",
        4: "\u0664",
        5: "\u0665",
        6: "\u0666",
        7: "\u0667",
        8: "\u0668",
        9: "\u0669",
        0: "\u0660"
    }), qt = {
        "\u0661": "1",
        "\u0662": "2",
        "\u0663": "3",
        "\u0664": "4",
        "\u0665": "5",
        "\u0666": "6",
        "\u0667": "7",
        "\u0668": "8",
        "\u0669": "9",
        "\u0660": "0"
    }, Bt = (c.defineLocale("ar-sa", {
        months: "\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a\u0648_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648_\u0623\u063a\u0633\u0637\u0633_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),
        monthsShort: "\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a\u0648_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648_\u0623\u063a\u0633\u0637\u0633_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),
        weekdays: "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),
        weekdaysShort: "\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),
        weekdaysMin: "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        meridiemParse: /\u0635|\u0645/,
        isPM: function(e) {
            return "\u0645" === e;
        },
        meridiem: function(e, a, t) {
            return e < 12 ? "\u0635" : "\u0645";
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0641\u064a %s",
            past: "\u0645\u0646\u0630 %s",
            s: "\u062b\u0648\u0627\u0646",
            ss: "%d \u062b\u0627\u0646\u064a\u0629",
            m: "\u062f\u0642\u064a\u0642\u0629",
            mm: "%d \u062f\u0642\u0627\u0626\u0642",
            h: "\u0633\u0627\u0639\u0629",
            hh: "%d \u0633\u0627\u0639\u0627\u062a",
            d: "\u064a\u0648\u0645",
            dd: "%d \u0623\u064a\u0627\u0645",
            M: "\u0634\u0647\u0631",
            MM: "%d \u0623\u0634\u0647\u0631",
            y: "\u0633\u0646\u0629",
            yy: "%d \u0633\u0646\u0648\u0627\u062a"
        },
        preparse: function(e) {
            return e.replace(/[\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g, function(e) {
                return qt[e];
            }).replace(/\u060c/g, ",");
        },
        postformat: function(e) {
            return e.replace(/\d/g, function(e) {
                return Vt[e];
            }).replace(/,/g, "\u060c");
        },
        week: {
            dow: 0,
            doy: 6
        }
    }), c.defineLocale("ar-tn", {
        months: "\u062c\u0627\u0646\u0641\u064a_\u0641\u064a\u0641\u0631\u064a_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064a\u0644_\u0645\u0627\u064a_\u062c\u0648\u0627\u0646_\u062c\u0648\u064a\u0644\u064a\u0629_\u0623\u0648\u062a_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),
        monthsShort: "\u062c\u0627\u0646\u0641\u064a_\u0641\u064a\u0641\u0631\u064a_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064a\u0644_\u0645\u0627\u064a_\u062c\u0648\u0627\u0646_\u062c\u0648\u064a\u0644\u064a\u0629_\u0623\u0648\u062a_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),
        weekdays: "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),
        weekdaysShort: "\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),
        weekdaysMin: "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0641\u064a %s",
            past: "\u0645\u0646\u0630 %s",
            s: "\u062b\u0648\u0627\u0646",
            ss: "%d \u062b\u0627\u0646\u064a\u0629",
            m: "\u062f\u0642\u064a\u0642\u0629",
            mm: "%d \u062f\u0642\u0627\u0626\u0642",
            h: "\u0633\u0627\u0639\u0629",
            hh: "%d \u0633\u0627\u0639\u0627\u062a",
            d: "\u064a\u0648\u0645",
            dd: "%d \u0623\u064a\u0627\u0645",
            M: "\u0634\u0647\u0631",
            MM: "%d \u0623\u0634\u0647\u0631",
            y: "\u0633\u0646\u0629",
            yy: "%d \u0633\u0646\u0648\u0627\u062a"
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), {
        1: "\u0661",
        2: "\u0662",
        3: "\u0663",
        4: "\u0664",
        5: "\u0665",
        6: "\u0666",
        7: "\u0667",
        8: "\u0668",
        9: "\u0669",
        0: "\u0660"
    }), Kt = {
        "\u0661": "1",
        "\u0662": "2",
        "\u0663": "3",
        "\u0664": "4",
        "\u0665": "5",
        "\u0666": "6",
        "\u0667": "7",
        "\u0668": "8",
        "\u0669": "9",
        "\u0660": "0"
    }, Zt = {
        s: [
            "\u0623\u0642\u0644 \u0645\u0646 \u062b\u0627\u0646\u064a\u0629",
            "\u062b\u0627\u0646\u064a\u0629 \u0648\u0627\u062d\u062f\u0629",
            [
                "\u062b\u0627\u0646\u064a\u062a\u0627\u0646",
                "\u062b\u0627\u0646\u064a\u062a\u064a\u0646"
            ],
            "%d \u062b\u0648\u0627\u0646",
            "%d \u062b\u0627\u0646\u064a\u0629",
            "%d \u062b\u0627\u0646\u064a\u0629"
        ],
        m: [
            "\u0623\u0642\u0644 \u0645\u0646 \u062f\u0642\u064a\u0642\u0629",
            "\u062f\u0642\u064a\u0642\u0629 \u0648\u0627\u062d\u062f\u0629",
            [
                "\u062f\u0642\u064a\u0642\u062a\u0627\u0646",
                "\u062f\u0642\u064a\u0642\u062a\u064a\u0646"
            ],
            "%d \u062f\u0642\u0627\u0626\u0642",
            "%d \u062f\u0642\u064a\u0642\u0629",
            "%d \u062f\u0642\u064a\u0642\u0629"
        ],
        h: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629",
            "\u0633\u0627\u0639\u0629 \u0648\u0627\u062d\u062f\u0629",
            [
                "\u0633\u0627\u0639\u062a\u0627\u0646",
                "\u0633\u0627\u0639\u062a\u064a\u0646"
            ],
            "%d \u0633\u0627\u0639\u0627\u062a",
            "%d \u0633\u0627\u0639\u0629",
            "%d \u0633\u0627\u0639\u0629"
        ],
        d: [
            "\u0623\u0642\u0644 \u0645\u0646 \u064a\u0648\u0645",
            "\u064a\u0648\u0645 \u0648\u0627\u062d\u062f",
            [
                "\u064a\u0648\u0645\u0627\u0646",
                "\u064a\u0648\u0645\u064a\u0646"
            ],
            "%d \u0623\u064a\u0627\u0645",
            "%d \u064a\u0648\u0645\u064b\u0627",
            "%d \u064a\u0648\u0645"
        ],
        M: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631",
            "\u0634\u0647\u0631 \u0648\u0627\u062d\u062f",
            [
                "\u0634\u0647\u0631\u0627\u0646",
                "\u0634\u0647\u0631\u064a\u0646"
            ],
            "%d \u0623\u0634\u0647\u0631",
            "%d \u0634\u0647\u0631\u0627",
            "%d \u0634\u0647\u0631"
        ],
        y: [
            "\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645",
            "\u0639\u0627\u0645 \u0648\u0627\u062d\u062f",
            [
                "\u0639\u0627\u0645\u0627\u0646",
                "\u0639\u0627\u0645\u064a\u0646"
            ],
            "%d \u0623\u0639\u0648\u0627\u0645",
            "%d \u0639\u0627\u0645\u064b\u0627",
            "%d \u0639\u0627\u0645"
        ]
    }, fe = [
        "\u064a\u0646\u0627\u064a\u0631",
        "\u0641\u0628\u0631\u0627\u064a\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064a\u0644",
        "\u0645\u0627\u064a\u0648",
        "\u064a\u0648\u0646\u064a\u0648",
        "\u064a\u0648\u0644\u064a\u0648",
        "\u0623\u063a\u0633\u0637\u0633",
        "\u0633\u0628\u062a\u0645\u0628\u0631",
        "\u0623\u0643\u062a\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062f\u064a\u0633\u0645\u0628\u0631"
    ], $t = (c.defineLocale("ar", {
        months: fe,
        monthsShort: fe,
        weekdays: "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),
        weekdaysShort: "\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),
        weekdaysMin: "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "D/\u200fM/\u200fYYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        meridiemParse: /\u0635|\u0645/,
        isPM: function(e) {
            return "\u0645" === e;
        },
        meridiem: function(e, a, t) {
            return e < 12 ? "\u0635" : "\u0645";
        },
        calendar: {
            sameDay: "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextDay: "[\u063a\u062f\u064b\u0627 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            nextWeek: "dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastDay: "[\u0623\u0645\u0633 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            lastWeek: "dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0628\u0639\u062f %s",
            past: "\u0645\u0646\u0630 %s",
            s: S("s"),
            ss: S("s"),
            m: S("m"),
            mm: S("m"),
            h: S("h"),
            hh: S("h"),
            d: S("d"),
            dd: S("d"),
            M: S("M"),
            MM: S("M"),
            y: S("y"),
            yy: S("y")
        },
        preparse: function(e) {
            return e.replace(/[\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g, function(e) {
                return Kt[e];
            }).replace(/\u060c/g, ",");
        },
        postformat: function(e) {
            return e.replace(/\d/g, function(e) {
                return Bt[e];
            }).replace(/,/g, "\u060c");
        },
        week: {
            dow: 6,
            doy: 12
        }
    }), {
        1: "-inci",
        5: "-inci",
        8: "-inci",
        70: "-inci",
        80: "-inci",
        2: "-nci",
        7: "-nci",
        20: "-nci",
        50: "-nci",
        3: "-\xfcnc\xfc",
        4: "-\xfcnc\xfc",
        100: "-\xfcnc\xfc",
        6: "-nc\u0131",
        9: "-uncu",
        10: "-uncu",
        30: "-uncu",
        60: "-\u0131nc\u0131",
        90: "-\u0131nc\u0131"
    });
    function Qt(e, a, t) {
        return "m" === t ? a ? "\u0445\u0432\u0456\u043b\u0456\u043d\u0430" : "\u0445\u0432\u0456\u043b\u0456\u043d\u0443" : "h" === t ? a ? "\u0433\u0430\u0434\u0437\u0456\u043d\u0430" : "\u0433\u0430\u0434\u0437\u0456\u043d\u0443" : e + " " + (e = +e, a = (a = ({
            ss: a ? "\u0441\u0435\u043a\u0443\u043d\u0434\u0430_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434" : "\u0441\u0435\u043a\u0443\u043d\u0434\u0443_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434",
            mm: a ? "\u0445\u0432\u0456\u043b\u0456\u043d\u0430_\u0445\u0432\u0456\u043b\u0456\u043d\u044b_\u0445\u0432\u0456\u043b\u0456\u043d" : "\u0445\u0432\u0456\u043b\u0456\u043d\u0443_\u0445\u0432\u0456\u043b\u0456\u043d\u044b_\u0445\u0432\u0456\u043b\u0456\u043d",
            hh: a ? "\u0433\u0430\u0434\u0437\u0456\u043d\u0430_\u0433\u0430\u0434\u0437\u0456\u043d\u044b_\u0433\u0430\u0434\u0437\u0456\u043d" : "\u0433\u0430\u0434\u0437\u0456\u043d\u0443_\u0433\u0430\u0434\u0437\u0456\u043d\u044b_\u0433\u0430\u0434\u0437\u0456\u043d",
            dd: "\u0434\u0437\u0435\u043d\u044c_\u0434\u043d\u0456_\u0434\u0437\u0451\u043d",
            MM: "\u043c\u0435\u0441\u044f\u0446_\u043c\u0435\u0441\u044f\u0446\u044b_\u043c\u0435\u0441\u044f\u0446\u0430\u045e",
            yy: "\u0433\u043e\u0434_\u0433\u0430\u0434\u044b_\u0433\u0430\u0434\u043e\u045e"
        })[t]).split("_"), e % 10 == 1 && e % 100 != 11 ? a[0] : 2 <= e % 10 && e % 10 <= 4 && (e % 100 < 10 || 20 <= e % 100) ? a[1] : a[2]);
    }
    c.defineLocale("az", {
        months: "yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr".split("_"),
        monthsShort: "yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek".split("_"),
        weekdays: "Bazar_Bazar ert\u0259si_\xc7\u0259r\u015f\u0259nb\u0259 ax\u015fam\u0131_\xc7\u0259r\u015f\u0259nb\u0259_C\xfcm\u0259 ax\u015fam\u0131_C\xfcm\u0259_\u015e\u0259nb\u0259".split("_"),
        weekdaysShort: "Baz_BzE_\xc7Ax_\xc7\u0259r_CAx_C\xfcm_\u015e\u0259n".split("_"),
        weekdaysMin: "Bz_BE_\xc7A_\xc7\u0259_CA_C\xfc_\u015e\u0259".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[bug\xfcn saat] LT",
            nextDay: "[sabah saat] LT",
            nextWeek: "[g\u0259l\u0259n h\u0259ft\u0259] dddd [saat] LT",
            lastDay: "[d\xfcn\u0259n] LT",
            lastWeek: "[ke\xe7\u0259n h\u0259ft\u0259] dddd [saat] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s sonra",
            past: "%s \u0259vv\u0259l",
            s: "bir ne\xe7\u0259 saniy\u0259",
            ss: "%d saniy\u0259",
            m: "bir d\u0259qiq\u0259",
            mm: "%d d\u0259qiq\u0259",
            h: "bir saat",
            hh: "%d saat",
            d: "bir g\xfcn",
            dd: "%d g\xfcn",
            M: "bir ay",
            MM: "%d ay",
            y: "bir il",
            yy: "%d il"
        },
        meridiemParse: /gec\u0259|s\u0259h\u0259r|g\xfcnd\xfcz|ax\u015fam/,
        isPM: function(e) {
            return /^(g\xfcnd\xfcz|ax\u015fam)$/.test(e);
        },
        meridiem: function(e, a, t) {
            return e < 4 ? "gec\u0259" : e < 12 ? "s\u0259h\u0259r" : e < 17 ? "g\xfcnd\xfcz" : "ax\u015fam";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(\u0131nc\u0131|inci|nci|\xfcnc\xfc|nc\u0131|uncu)/,
        ordinal: function(e) {
            var a;
            return 0 === e ? e + "-\u0131nc\u0131" : e + ($t[a = e % 10] || $t[e % 100 - a] || $t[100 <= e ? 100 : null]);
        },
        week: {
            dow: 1,
            doy: 7
        }
    }), c.defineLocale("be", {
        months: {
            format: "\u0441\u0442\u0443\u0434\u0437\u0435\u043d\u044f_\u043b\u044e\u0442\u0430\u0433\u0430_\u0441\u0430\u043a\u0430\u0432\u0456\u043a\u0430_\u043a\u0440\u0430\u0441\u0430\u0432\u0456\u043a\u0430_\u0442\u0440\u0430\u045e\u043d\u044f_\u0447\u044d\u0440\u0432\u0435\u043d\u044f_\u043b\u0456\u043f\u0435\u043d\u044f_\u0436\u043d\u0456\u045e\u043d\u044f_\u0432\u0435\u0440\u0430\u0441\u043d\u044f_\u043a\u0430\u0441\u0442\u0440\u044b\u0447\u043d\u0456\u043a\u0430_\u043b\u0456\u0441\u0442\u0430\u043f\u0430\u0434\u0430_\u0441\u043d\u0435\u0436\u043d\u044f".split("_"),
            standalone: "\u0441\u0442\u0443\u0434\u0437\u0435\u043d\u044c_\u043b\u044e\u0442\u044b_\u0441\u0430\u043a\u0430\u0432\u0456\u043a_\u043a\u0440\u0430\u0441\u0430\u0432\u0456\u043a_\u0442\u0440\u0430\u0432\u0435\u043d\u044c_\u0447\u044d\u0440\u0432\u0435\u043d\u044c_\u043b\u0456\u043f\u0435\u043d\u044c_\u0436\u043d\u0456\u0432\u0435\u043d\u044c_\u0432\u0435\u0440\u0430\u0441\u0435\u043d\u044c_\u043a\u0430\u0441\u0442\u0440\u044b\u0447\u043d\u0456\u043a_\u043b\u0456\u0441\u0442\u0430\u043f\u0430\u0434_\u0441\u043d\u0435\u0436\u0430\u043d\u044c".split("_")
        },
        monthsShort: "\u0441\u0442\u0443\u0434_\u043b\u044e\u0442_\u0441\u0430\u043a_\u043a\u0440\u0430\u0441_\u0442\u0440\u0430\u0432_\u0447\u044d\u0440\u0432_\u043b\u0456\u043f_\u0436\u043d\u0456\u0432_\u0432\u0435\u0440_\u043a\u0430\u0441\u0442_\u043b\u0456\u0441\u0442_\u0441\u043d\u0435\u0436".split("_"),
        weekdays: {
            format: "\u043d\u044f\u0434\u0437\u0435\u043b\u044e_\u043f\u0430\u043d\u044f\u0434\u0437\u0435\u043b\u0430\u043a_\u0430\u045e\u0442\u043e\u0440\u0430\u043a_\u0441\u0435\u0440\u0430\u0434\u0443_\u0447\u0430\u0446\u0432\u0435\u0440_\u043f\u044f\u0442\u043d\u0456\u0446\u0443_\u0441\u0443\u0431\u043e\u0442\u0443".split("_"),
            standalone: "\u043d\u044f\u0434\u0437\u0435\u043b\u044f_\u043f\u0430\u043d\u044f\u0434\u0437\u0435\u043b\u0430\u043a_\u0430\u045e\u0442\u043e\u0440\u0430\u043a_\u0441\u0435\u0440\u0430\u0434\u0430_\u0447\u0430\u0446\u0432\u0435\u0440_\u043f\u044f\u0442\u043d\u0456\u0446\u0430_\u0441\u0443\u0431\u043e\u0442\u0430".split("_"),
            isFormat: /\[ ?[\u0423\u0443\u045e] ?(?:\u043c\u0456\u043d\u0443\u043b\u0443\u044e|\u043d\u0430\u0441\u0442\u0443\u043f\u043d\u0443\u044e)? ?\] ?dddd/
        },
        weekdaysShort: "\u043d\u0434_\u043f\u043d_\u0430\u0442_\u0441\u0440_\u0447\u0446_\u043f\u0442_\u0441\u0431".split("_"),
        weekdaysMin: "\u043d\u0434_\u043f\u043d_\u0430\u0442_\u0441\u0440_\u0447\u0446_\u043f\u0442_\u0441\u0431".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY \u0433.",
            LLL: "D MMMM YYYY \u0433., HH:mm",
            LLLL: "dddd, D MMMM YYYY \u0433., HH:mm"
        },
        calendar: {
            sameDay: "[\u0421\u0451\u043d\u043d\u044f \u045e] LT",
            nextDay: "[\u0417\u0430\u045e\u0442\u0440\u0430 \u045e] LT",
            lastDay: "[\u0423\u0447\u043e\u0440\u0430 \u045e] LT",
            nextWeek: function() {
                return "[\u0423] dddd [\u045e] LT";
            },
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return "[\u0423 \u043c\u0456\u043d\u0443\u043b\u0443\u044e] dddd [\u045e] LT";
                    case 1:
                    case 2:
                    case 4:
                        return "[\u0423 \u043c\u0456\u043d\u0443\u043b\u044b] dddd [\u045e] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "\u043f\u0440\u0430\u0437 %s",
            past: "%s \u0442\u0430\u043c\u0443",
            s: "\u043d\u0435\u043a\u0430\u043b\u044c\u043a\u0456 \u0441\u0435\u043a\u0443\u043d\u0434",
            m: Qt,
            mm: Qt,
            h: Qt,
            hh: Qt,
            d: "\u0434\u0437\u0435\u043d\u044c",
            dd: Qt,
            M: "\u043c\u0435\u0441\u044f\u0446",
            MM: Qt,
            y: "\u0433\u043e\u0434",
            yy: Qt
        },
        meridiemParse: /\u043d\u043e\u0447\u044b|\u0440\u0430\u043d\u0456\u0446\u044b|\u0434\u043d\u044f|\u0432\u0435\u0447\u0430\u0440\u0430/,
        isPM: function(e) {
            return /^(\u0434\u043d\u044f|\u0432\u0435\u0447\u0430\u0440\u0430)$/.test(e);
        },
        meridiem: function(e, a, t) {
            return e < 4 ? "\u043d\u043e\u0447\u044b" : e < 12 ? "\u0440\u0430\u043d\u0456\u0446\u044b" : e < 17 ? "\u0434\u043d\u044f" : "\u0432\u0435\u0447\u0430\u0440\u0430";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(\u0456|\u044b|\u0433\u0430)/,
        ordinal: function(e, a) {
            switch(a){
                case "M":
                case "d":
                case "DDD":
                case "w":
                case "W":
                    return e % 10 != 2 && e % 10 != 3 || e % 100 == 12 || e % 100 == 13 ? e + "-\u044b" : e + "-\u0456";
                case "D":
                    return e + "-\u0433\u0430";
                default:
                    return e;
            }
        },
        week: {
            dow: 1,
            doy: 7
        }
    }), c.defineLocale("bg", {
        months: "\u044f\u043d\u0443\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0438\u043b_\u043c\u0430\u0439_\u044e\u043d\u0438_\u044e\u043b\u0438_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043f\u0442\u0435\u043c\u0432\u0440\u0438_\u043e\u043a\u0442\u043e\u043c\u0432\u0440\u0438_\u043d\u043e\u0435\u043c\u0432\u0440\u0438_\u0434\u0435\u043a\u0435\u043c\u0432\u0440\u0438".split("_"),
        monthsShort: "\u044f\u043d\u0443_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0439_\u044e\u043d\u0438_\u044e\u043b\u0438_\u0430\u0432\u0433_\u0441\u0435\u043f_\u043e\u043a\u0442_\u043d\u043e\u0435_\u0434\u0435\u043a".split("_"),
        weekdays: "\u043d\u0435\u0434\u0435\u043b\u044f_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u044f\u0434\u0430_\u0447\u0435\u0442\u0432\u044a\u0440\u0442\u044a\u043a_\u043f\u0435\u0442\u044a\u043a_\u0441\u044a\u0431\u043e\u0442\u0430".split("_"),
        weekdaysShort: "\u043d\u0435\u0434_\u043f\u043e\u043d_\u0432\u0442\u043e_\u0441\u0440\u044f_\u0447\u0435\u0442_\u043f\u0435\u0442_\u0441\u044a\u0431".split("_"),
        weekdaysMin: "\u043d\u0434_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "D.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY H:mm",
            LLLL: "dddd, D MMMM YYYY H:mm"
        },
        calendar: {
            sameDay: "[\u0414\u043d\u0435\u0441 \u0432] LT",
            nextDay: "[\u0423\u0442\u0440\u0435 \u0432] LT",
            nextWeek: "dddd [\u0432] LT",
            lastDay: "[\u0412\u0447\u0435\u0440\u0430 \u0432] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                    case 3:
                    case 6:
                        return "[\u041c\u0438\u043d\u0430\u043b\u0430\u0442\u0430] dddd [\u0432] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[\u041c\u0438\u043d\u0430\u043b\u0438\u044f] dddd [\u0432] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0441\u043b\u0435\u0434 %s",
            past: "\u043f\u0440\u0435\u0434\u0438 %s",
            s: "\u043d\u044f\u043a\u043e\u043b\u043a\u043e \u0441\u0435\u043a\u0443\u043d\u0434\u0438",
            ss: "%d \u0441\u0435\u043a\u0443\u043d\u0434\u0438",
            m: "\u043c\u0438\u043d\u0443\u0442\u0430",
            mm: "%d \u043c\u0438\u043d\u0443\u0442\u0438",
            h: "\u0447\u0430\u0441",
            hh: "%d \u0447\u0430\u0441\u0430",
            d: "\u0434\u0435\u043d",
            dd: "%d \u0434\u0435\u043d\u0430",
            w: "\u0441\u0435\u0434\u043c\u0438\u0446\u0430",
            ww: "%d \u0441\u0435\u0434\u043c\u0438\u0446\u0438",
            M: "\u043c\u0435\u0441\u0435\u0446",
            MM: "%d \u043c\u0435\u0441\u0435\u0446\u0430",
            y: "\u0433\u043e\u0434\u0438\u043d\u0430",
            yy: "%d \u0433\u043e\u0434\u0438\u043d\u0438"
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(\u0435\u0432|\u0435\u043d|\u0442\u0438|\u0432\u0438|\u0440\u0438|\u043c\u0438)/,
        ordinal: function(e) {
            var a = e % 10, t = e % 100;
            return 0 === e ? e + "-\u0435\u0432" : 0 == t ? e + "-\u0435\u043d" : 10 < t && t < 20 ? e + "-\u0442\u0438" : 1 == a ? e + "-\u0432\u0438" : 2 == a ? e + "-\u0440\u0438" : 7 == a || 8 == a ? e + "-\u043c\u0438" : e + "-\u0442\u0438";
        },
        week: {
            dow: 1,
            doy: 7
        }
    }), c.defineLocale("bm", {
        months: "Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_M\u025bkalo_Zuw\u025bnkalo_Zuluyekalo_Utikalo_S\u025btanburukalo_\u0254kut\u0254burukalo_Nowanburukalo_Desanburukalo".split("_"),
        monthsShort: "Zan_Few_Mar_Awi_M\u025b_Zuw_Zul_Uti_S\u025bt_\u0254ku_Now_Des".split("_"),
        weekdays: "Kari_Nt\u025bn\u025bn_Tarata_Araba_Alamisa_Juma_Sibiri".split("_"),
        weekdaysShort: "Kar_Nt\u025b_Tar_Ara_Ala_Jum_Sib".split("_"),
        weekdaysMin: "Ka_Nt_Ta_Ar_Al_Ju_Si".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "MMMM [tile] D [san] YYYY",
            LLL: "MMMM [tile] D [san] YYYY [l\u025br\u025b] HH:mm",
            LLLL: "dddd MMMM [tile] D [san] YYYY [l\u025br\u025b] HH:mm"
        },
        calendar: {
            sameDay: "[Bi l\u025br\u025b] LT",
            nextDay: "[Sini l\u025br\u025b] LT",
            nextWeek: "dddd [don l\u025br\u025b] LT",
            lastDay: "[Kunu l\u025br\u025b] LT",
            lastWeek: "dddd [t\u025bm\u025bnen l\u025br\u025b] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s k\u0254n\u0254",
            past: "a b\u025b %s b\u0254",
            s: "sanga dama dama",
            ss: "sekondi %d",
            m: "miniti kelen",
            mm: "miniti %d",
            h: "l\u025br\u025b kelen",
            hh: "l\u025br\u025b %d",
            d: "tile kelen",
            dd: "tile %d",
            M: "kalo kelen",
            MM: "kalo %d",
            y: "san kelen",
            yy: "san %d"
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    var Xt = {
        1: "\u09e7",
        2: "\u09e8",
        3: "\u09e9",
        4: "\u09ea",
        5: "\u09eb",
        6: "\u09ec",
        7: "\u09ed",
        8: "\u09ee",
        9: "\u09ef",
        0: "\u09e6"
    }, es = {
        "\u09e7": "1",
        "\u09e8": "2",
        "\u09e9": "3",
        "\u09ea": "4",
        "\u09eb": "5",
        "\u09ec": "6",
        "\u09ed": "7",
        "\u09ee": "8",
        "\u09ef": "9",
        "\u09e6": "0"
    }, as = (c.defineLocale("bn-bd", {
        months: "\u099c\u09be\u09a8\u09c1\u09df\u09be\u09b0\u09bf_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1\u09df\u09be\u09b0\u09bf_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f\u09c7\u09ae\u09cd\u09ac\u09b0_\u0985\u0995\u09cd\u099f\u09cb\u09ac\u09b0_\u09a8\u09ad\u09c7\u09ae\u09cd\u09ac\u09b0_\u09a1\u09bf\u09b8\u09c7\u09ae\u09cd\u09ac\u09b0".split("_"),
        monthsShort: "\u099c\u09be\u09a8\u09c1_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f_\u0985\u0995\u09cd\u099f\u09cb_\u09a8\u09ad\u09c7_\u09a1\u09bf\u09b8\u09c7".split("_"),
        weekdays: "\u09b0\u09ac\u09bf\u09ac\u09be\u09b0_\u09b8\u09cb\u09ae\u09ac\u09be\u09b0_\u09ae\u0999\u09cd\u0997\u09b2\u09ac\u09be\u09b0_\u09ac\u09c1\u09a7\u09ac\u09be\u09b0_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf\u09ac\u09be\u09b0_\u09b6\u09c1\u0995\u09cd\u09b0\u09ac\u09be\u09b0_\u09b6\u09a8\u09bf\u09ac\u09be\u09b0".split("_"),
        weekdaysShort: "\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split("_"),
        weekdaysMin: "\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split("_"),
        longDateFormat: {
            LT: "A h:mm \u09b8\u09ae\u09df",
            LTS: "A h:mm:ss \u09b8\u09ae\u09df",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm \u09b8\u09ae\u09df",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u09b8\u09ae\u09df"
        },
        calendar: {
            sameDay: "[\u0986\u099c] LT",
            nextDay: "[\u0986\u0997\u09be\u09ae\u09c0\u0995\u09be\u09b2] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0997\u09a4\u0995\u09be\u09b2] LT",
            lastWeek: "[\u0997\u09a4] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u09aa\u09b0\u09c7",
            past: "%s \u0986\u0997\u09c7",
            s: "\u0995\u09df\u09c7\u0995 \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",
            ss: "%d \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",
            m: "\u098f\u0995 \u09ae\u09bf\u09a8\u09bf\u099f",
            mm: "%d \u09ae\u09bf\u09a8\u09bf\u099f",
            h: "\u098f\u0995 \u0998\u09a8\u09cd\u099f\u09be",
            hh: "%d \u0998\u09a8\u09cd\u099f\u09be",
            d: "\u098f\u0995 \u09a6\u09bf\u09a8",
            dd: "%d \u09a6\u09bf\u09a8",
            M: "\u098f\u0995 \u09ae\u09be\u09b8",
            MM: "%d \u09ae\u09be\u09b8",
            y: "\u098f\u0995 \u09ac\u099b\u09b0",
            yy: "%d \u09ac\u099b\u09b0"
        },
        preparse: function(e) {
            return e.replace(/[\u09e7\u09e8\u09e9\u09ea\u09eb\u09ec\u09ed\u09ee\u09ef\u09e6]/g, function(e) {
                return es[e];
            });
        },
        postformat: function(e) {
            return e.replace(/\d/g, function(e) {
                return Xt[e];
            });
        },
        meridiemParse: /\u09b0\u09be\u09a4|\u09ad\u09cb\u09b0|\u09b8\u0995\u09be\u09b2|\u09a6\u09c1\u09aa\u09c1\u09b0|\u09ac\u09bf\u0995\u09be\u09b2|\u09b8\u09a8\u09cd\u09a7\u09cd\u09af\u09be|\u09b0\u09be\u09a4/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "\u09b0\u09be\u09a4" === a ? e < 4 ? e : e + 12 : "\u09ad\u09cb\u09b0" === a || "\u09b8\u0995\u09be\u09b2" === a ? e : "\u09a6\u09c1\u09aa\u09c1\u09b0" === a ? 3 <= e ? e : e + 12 : "\u09ac\u09bf\u0995\u09be\u09b2" === a || "\u09b8\u09a8\u09cd\u09a7\u09cd\u09af\u09be" === a ? e + 12 : void 0;
        },
        meridiem: function(e, a, t) {
            return e < 4 ? "\u09b0\u09be\u09a4" : e < 6 ? "\u09ad\u09cb\u09b0" : e < 12 ? "\u09b8\u0995\u09be\u09b2" : e < 15 ? "\u09a6\u09c1\u09aa\u09c1\u09b0" : e < 18 ? "\u09ac\u09bf\u0995\u09be\u09b2" : e < 20 ? "\u09b8\u09a8\u09cd\u09a7\u09cd\u09af\u09be" : "\u09b0\u09be\u09a4";
        },
        week: {
            dow: 0,
            doy: 6
        }
    }), {
        1: "\u09e7",
        2: "\u09e8",
        3: "\u09e9",
        4: "\u09ea",
        5: "\u09eb",
        6: "\u09ec",
        7: "\u09ed",
        8: "\u09ee",
        9: "\u09ef",
        0: "\u09e6"
    }), ts = {
        "\u09e7": "1",
        "\u09e8": "2",
        "\u09e9": "3",
        "\u09ea": "4",
        "\u09eb": "5",
        "\u09ec": "6",
        "\u09ed": "7",
        "\u09ee": "8",
        "\u09ef": "9",
        "\u09e6": "0"
    }, ss = (c.defineLocale("bn", {
        months: "\u099c\u09be\u09a8\u09c1\u09df\u09be\u09b0\u09bf_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1\u09df\u09be\u09b0\u09bf_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f\u09c7\u09ae\u09cd\u09ac\u09b0_\u0985\u0995\u09cd\u099f\u09cb\u09ac\u09b0_\u09a8\u09ad\u09c7\u09ae\u09cd\u09ac\u09b0_\u09a1\u09bf\u09b8\u09c7\u09ae\u09cd\u09ac\u09b0".split("_"),
        monthsShort: "\u099c\u09be\u09a8\u09c1_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f_\u0985\u0995\u09cd\u099f\u09cb_\u09a8\u09ad\u09c7_\u09a1\u09bf\u09b8\u09c7".split("_"),
        weekdays: "\u09b0\u09ac\u09bf\u09ac\u09be\u09b0_\u09b8\u09cb\u09ae\u09ac\u09be\u09b0_\u09ae\u0999\u09cd\u0997\u09b2\u09ac\u09be\u09b0_\u09ac\u09c1\u09a7\u09ac\u09be\u09b0_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf\u09ac\u09be\u09b0_\u09b6\u09c1\u0995\u09cd\u09b0\u09ac\u09be\u09b0_\u09b6\u09a8\u09bf\u09ac\u09be\u09b0".split("_"),
        weekdaysShort: "\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split("_"),
        weekdaysMin: "\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split("_"),
        longDateFormat: {
            LT: "A h:mm \u09b8\u09ae\u09df",
            LTS: "A h:mm:ss \u09b8\u09ae\u09df",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm \u09b8\u09ae\u09df",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u09b8\u09ae\u09df"
        },
        calendar: {
            sameDay: "[\u0986\u099c] LT",
            nextDay: "[\u0986\u0997\u09be\u09ae\u09c0\u0995\u09be\u09b2] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0997\u09a4\u0995\u09be\u09b2] LT",
            lastWeek: "[\u0997\u09a4] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u09aa\u09b0\u09c7",
            past: "%s \u0986\u0997\u09c7",
            s: "\u0995\u09df\u09c7\u0995 \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",
            ss: "%d \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",
            m: "\u098f\u0995 \u09ae\u09bf\u09a8\u09bf\u099f",
            mm: "%d \u09ae\u09bf\u09a8\u09bf\u099f",
            h: "\u098f\u0995 \u0998\u09a8\u09cd\u099f\u09be",
            hh: "%d \u0998\u09a8\u09cd\u099f\u09be",
            d: "\u098f\u0995 \u09a6\u09bf\u09a8",
            dd: "%d \u09a6\u09bf\u09a8",
            M: "\u098f\u0995 \u09ae\u09be\u09b8",
            MM: "%d \u09ae\u09be\u09b8",
            y: "\u098f\u0995 \u09ac\u099b\u09b0",
            yy: "%d \u09ac\u099b\u09b0"
        },
        preparse: function(e) {
            return e.replace(/[\u09e7\u09e8\u09e9\u09ea\u09eb\u09ec\u09ed\u09ee\u09ef\u09e6]/g, function(e) {
                return ts[e];
            });
        },
        postformat: function(e) {
            return e.replace(/\d/g, function(e) {
                return as[e];
            });
        },
        meridiemParse: /\u09b0\u09be\u09a4|\u09b8\u0995\u09be\u09b2|\u09a6\u09c1\u09aa\u09c1\u09b0|\u09ac\u09bf\u0995\u09be\u09b2|\u09b0\u09be\u09a4/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "\u09b0\u09be\u09a4" === a && 4 <= e || "\u09a6\u09c1\u09aa\u09c1\u09b0" === a && e < 5 || "\u09ac\u09bf\u0995\u09be\u09b2" === a ? e + 12 : e;
        },
        meridiem: function(e, a, t) {
            return e < 4 ? "\u09b0\u09be\u09a4" : e < 10 ? "\u09b8\u0995\u09be\u09b2" : e < 17 ? "\u09a6\u09c1\u09aa\u09c1\u09b0" : e < 20 ? "\u09ac\u09bf\u0995\u09be\u09b2" : "\u09b0\u09be\u09a4";
        },
        week: {
            dow: 0,
            doy: 6
        }
    }), {
        1: "\u0f21",
        2: "\u0f22",
        3: "\u0f23",
        4: "\u0f24",
        5: "\u0f25",
        6: "\u0f26",
        7: "\u0f27",
        8: "\u0f28",
        9: "\u0f29",
        0: "\u0f20"
    }), ns = {
        "\u0f21": "1",
        "\u0f22": "2",
        "\u0f23": "3",
        "\u0f24": "4",
        "\u0f25": "5",
        "\u0f26": "6",
        "\u0f27": "7",
        "\u0f28": "8",
        "\u0f29": "9",
        "\u0f20": "0"
    };
    function rs(e, a, t) {
        return e + " " + (t = ({
            mm: "munutenn",
            MM: "miz",
            dd: "devezh"
        })[t], 2 !== e ? t : void 0 !== (e = {
            m: "v",
            b: "v",
            d: "z"
        })[t.charAt(0)] ? e[t.charAt(0)] + t.substring(1) : t);
    }
    c.defineLocale("bo", {
        months: "\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0f44\u0f0b\u0f54\u0f7c_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f49\u0f72\u0f66\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f66\u0f74\u0f58\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f5e\u0f72\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f63\u0f94\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0fb2\u0f74\u0f42\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f62\u0f92\u0fb1\u0f51\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0f42\u0f74\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f42\u0f45\u0f72\u0f42\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f42\u0f49\u0f72\u0f66\u0f0b\u0f54".split("_"),
        monthsShort: "\u0f5f\u0fb3\u0f0b1_\u0f5f\u0fb3\u0f0b2_\u0f5f\u0fb3\u0f0b3_\u0f5f\u0fb3\u0f0b4_\u0f5f\u0fb3\u0f0b5_\u0f5f\u0fb3\u0f0b6_\u0f5f\u0fb3\u0f0b7_\u0f5f\u0fb3\u0f0b8_\u0f5f\u0fb3\u0f0b9_\u0f5f\u0fb3\u0f0b10_\u0f5f\u0fb3\u0f0b11_\u0f5f\u0fb3\u0f0b12".split("_"),
        monthsShortRegex: /^(\u0f5f\u0fb3\u0f0b\d{1,2})/,
        monthsParseExact: !0,
        weekdays: "\u0f42\u0f5f\u0f60\u0f0b\u0f49\u0f72\u0f0b\u0f58\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f5f\u0fb3\u0f0b\u0f56\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f58\u0f72\u0f42\u0f0b\u0f51\u0f58\u0f62\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f63\u0fb7\u0f42\u0f0b\u0f54\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f55\u0f74\u0f62\u0f0b\u0f56\u0f74_\u0f42\u0f5f\u0f60\u0f0b\u0f54\u0f0b\u0f66\u0f44\u0f66\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f66\u0fa4\u0f7a\u0f53\u0f0b\u0f54\u0f0b".split("_"),
        weekdaysShort: "\u0f49\u0f72\u0f0b\u0f58\u0f0b_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b_\u0f58\u0f72\u0f42\u0f0b\u0f51\u0f58\u0f62\u0f0b_\u0f63\u0fb7\u0f42\u0f0b\u0f54\u0f0b_\u0f55\u0f74\u0f62\u0f0b\u0f56\u0f74_\u0f54\u0f0b\u0f66\u0f44\u0f66\u0f0b_\u0f66\u0fa4\u0f7a\u0f53\u0f0b\u0f54\u0f0b".split("_"),
        weekdaysMin: "\u0f49\u0f72_\u0f5f\u0fb3_\u0f58\u0f72\u0f42_\u0f63\u0fb7\u0f42_\u0f55\u0f74\u0f62_\u0f66\u0f44\u0f66_\u0f66\u0fa4\u0f7a\u0f53".split("_"),
        longDateFormat: {
            LT: "A h:mm",
            LTS: "A h:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm",
            LLLL: "dddd, D MMMM YYYY, A h:mm"
        },
        calendar: {
            sameDay: "[\u0f51\u0f72\u0f0b\u0f62\u0f72\u0f44] LT",
            nextDay: "[\u0f66\u0f44\u0f0b\u0f49\u0f72\u0f53] LT",
            nextWeek: "[\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f55\u0fb2\u0f42\u0f0b\u0f62\u0f97\u0f7a\u0f66\u0f0b\u0f58], LT",
            lastDay: "[\u0f41\u0f0b\u0f66\u0f44] LT",
            lastWeek: "[\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f55\u0fb2\u0f42\u0f0b\u0f58\u0f50\u0f60\u0f0b\u0f58] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0f63\u0f0b",
            past: "%s \u0f66\u0f94\u0f53\u0f0b\u0f63",
            s: "\u0f63\u0f58\u0f0b\u0f66\u0f44",
            ss: "%d \u0f66\u0f90\u0f62\u0f0b\u0f46\u0f0d",
            m: "\u0f66\u0f90\u0f62\u0f0b\u0f58\u0f0b\u0f42\u0f45\u0f72\u0f42",
            mm: "%d \u0f66\u0f90\u0f62\u0f0b\u0f58",
            h: "\u0f46\u0f74\u0f0b\u0f5a\u0f7c\u0f51\u0f0b\u0f42\u0f45\u0f72\u0f42",
            hh: "%d \u0f46\u0f74\u0f0b\u0f5a\u0f7c\u0f51",
            d: "\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f45\u0f72\u0f42",
            dd: "%d \u0f49\u0f72\u0f53\u0f0b",
            M: "\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f45\u0f72\u0f42",
            MM: "%d \u0f5f\u0fb3\u0f0b\u0f56",
            y: "\u0f63\u0f7c\u0f0b\u0f42\u0f45\u0f72\u0f42",
            yy: "%d \u0f63\u0f7c"
        },
        preparse: function(e) {
            return e.replace(/[\u0f21\u0f22\u0f23\u0f24\u0f25\u0f26\u0f27\u0f28\u0f29\u0f20]/g, function(e) {
                return ns[e];
            });
        },
        postformat: function(e) {
            return e.replace(/\d/g, function(e) {
                return ss[e];
            });
        },
        meridiemParse: /\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c|\u0f5e\u0f7c\u0f42\u0f66\u0f0b\u0f40\u0f66|\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f74\u0f44|\u0f51\u0f42\u0f7c\u0f44\u0f0b\u0f51\u0f42|\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c" === a && 4 <= e || "\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f74\u0f44" === a && e < 5 || "\u0f51\u0f42\u0f7c\u0f44\u0f0b\u0f51\u0f42" === a ? e + 12 : e;
        },
        meridiem: function(e, a, t) {
            return e < 4 ? "\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c" : e < 10 ? "\u0f5e\u0f7c\u0f42\u0f66\u0f0b\u0f40\u0f66" : e < 17 ? "\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f74\u0f44" : e < 20 ? "\u0f51\u0f42\u0f7c\u0f44\u0f0b\u0f51\u0f42" : "\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c";
        },
        week: {
            dow: 0,
            doy: 6
        }
    });
    Ye = [
        /^gen/i,
        /^c[\u02bc\']hwe/i,
        /^meu/i,
        /^ebr/i,
        /^mae/i,
        /^(mez|eve)/i,
        /^gou/i,
        /^eos/i,
        /^gwe/i,
        /^her/i,
        /^du/i,
        /^ker/i
    ], Ie = /^(genver|c[\u02bc\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[\u02bc\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i, _ = [
        /^Su/i,
        /^Lu/i,
        /^Me([^r]|$)/i,
        /^Mer/i,
        /^Ya/i,
        /^Gw/i,
        /^Sa/i
    ];
    function ds(e, a, t) {
        var s = e + " ";
        switch(t){
            case "ss":
                return s += 1 === e ? "sekunda" : 2 === e || 3 === e || 4 === e ? "sekunde" : "sekundi";
            case "mm":
                return s += 1 !== e && (2 === e || 3 === e || 4 === e) ? "minute" : "minuta";
            case "h":
                return "jedan sat";
            case "hh":
                return s += 1 === e ? "sat" : 2 === e || 3 === e || 4 === e ? "sata" : "sati";
            case "dd":
                return s += 1 === e ? "dan" : "dana";
            case "MM":
                return s += 1 === e ? "mjesec" : 2 === e || 3 === e || 4 === e ? "mjeseca" : "mjeseci";
            case "yy":
                return s += 1 !== e && (2 === e || 3 === e || 4 === e) ? "godine" : "godina";
        }
    }
    c.defineLocale("br", {
        months: "Genver_C\u02bchwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu".split("_"),
        monthsShort: "Gen_C\u02bchwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker".split("_"),
        weekdays: "Sul_Lun_Meurzh_Merc\u02bcher_Yaou_Gwener_Sadorn".split("_"),
        weekdaysShort: "Sul_Lun_Meu_Mer_Yao_Gwe_Sad".split("_"),
        weekdaysMin: "Su_Lu_Me_Mer_Ya_Gw_Sa".split("_"),
        weekdaysParse: _,
        fullWeekdaysParse: [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[\u02bc\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i
        ],
        shortWeekdaysParse: [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i
        ],
        minWeekdaysParse: _,
        monthsRegex: Ie,
        monthsShortRegex: Ie,
        monthsStrictRegex: /^(genver|c[\u02bc\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex: /^(gen|c[\u02bc\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsParse: Ye,
        longMonthsParse: Ye,
        shortMonthsParse: Ye,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [a viz] MMMM YYYY",
            LLL: "D [a viz] MMMM YYYY HH:mm",
            LLLL: "dddd, D [a viz] MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Hiziv da] LT",
            nextDay: "[Warc\u02bchoazh da] LT",
            nextWeek: "dddd [da] LT",
            lastDay: "[Dec\u02bch da] LT",
            lastWeek: "dddd [paset da] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "a-benn %s",
            past: "%s \u02bczo",
            s: "un nebeud segondenno\xf9",
            ss: "%d eilenn",
            m: "ur vunutenn",
            mm: rs,
            h: "un eur",
            hh: "%d eur",
            d: "un devezh",
            dd: rs,
            M: "ur miz",
            MM: rs,
            y: "ur bloaz",
            yy: function(e) {
                switch(function e(a) {
                    if (9 < a) return e(a % 10);
                    return a;
                }(e)){
                    case 1:
                    case 3:
                    case 4:
                    case 5:
                    case 9:
                        return e + " bloaz";
                    default:
                        return e + " vloaz";
                }
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(a\xf1|vet)/,
        ordinal: function(e) {
            return e + (1 === e ? "a\xf1" : "vet");
        },
        week: {
            dow: 1,
            doy: 4
        },
        meridiemParse: /a.m.|g.m./,
        isPM: function(e) {
            return "g.m." === e;
        },
        meridiem: function(e, a, t) {
            return e < 12 ? "a.m." : "g.m.";
        }
    }), c.defineLocale("bs", {
        months: "januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar".split("_"),
        monthsShort: "jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.".split("_"),
        monthsParseExact: !0,
        weekdays: "nedjelja_ponedjeljak_utorak_srijeda_\u010detvrtak_petak_subota".split("_"),
        weekdaysShort: "ned._pon._uto._sri._\u010det._pet._sub.".split("_"),
        weekdaysMin: "ne_po_ut_sr_\u010de_pe_su".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm",
            LLLL: "dddd, D. MMMM YYYY H:mm"
        },
        calendar: {
            sameDay: "[danas u] LT",
            nextDay: "[sutra u] LT",
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[u] [nedjelju] [u] LT";
                    case 3:
                        return "[u] [srijedu] [u] LT";
                    case 6:
                        return "[u] [subotu] [u] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[u] dddd [u] LT";
                }
            },
            lastDay: "[ju\u010der u] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                    case 3:
                        return "[pro\u0161lu] dddd [u] LT";
                    case 6:
                        return "[pro\u0161le] [subote] [u] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[pro\u0161li] dddd [u] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "za %s",
            past: "prije %s",
            s: "par sekundi",
            ss: ds,
            m: function(e, a, t, s) {
                switch(t){
                    case "m":
                        return a ? "jedna minuta" : s ? "jednu minutu" : "jedne minute";
                }
            },
            mm: ds,
            h: ds,
            hh: ds,
            d: "dan",
            dd: ds,
            M: "mjesec",
            MM: ds,
            y: "godinu",
            yy: ds
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 7
        }
    }), c.defineLocale("ca", {
        months: {
            standalone: "gener_febrer_mar\xe7_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split("_"),
            format: "de gener_de febrer_de mar\xe7_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split("_"),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort: "gen._febr._mar\xe7_abr._maig_juny_jul._ag._set._oct._nov._des.".split("_"),
        monthsParseExact: !0,
        weekdays: "diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split("_"),
        weekdaysShort: "dg._dl._dt._dc._dj._dv._ds.".split("_"),
        weekdaysMin: "dg_dl_dt_dc_dj_dv_ds".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM [de] YYYY",
            ll: "D MMM YYYY",
            LLL: "D MMMM [de] YYYY [a les] H:mm",
            lll: "D MMM YYYY, H:mm",
            LLLL: "dddd D MMMM [de] YYYY [a les] H:mm",
            llll: "ddd D MMM YYYY, H:mm"
        },
        calendar: {
            sameDay: function() {
                return "[avui a " + (1 !== this.hours() ? "les" : "la") + "] LT";
            },
            nextDay: function() {
                return "[dem\xe0 a " + (1 !== this.hours() ? "les" : "la") + "] LT";
            },
            nextWeek: function() {
                return "dddd [a " + (1 !== this.hours() ? "les" : "la") + "] LT";
            },
            lastDay: function() {
                return "[ahir a " + (1 !== this.hours() ? "les" : "la") + "] LT";
            },
            lastWeek: function() {
                return "[el] dddd [passat a " + (1 !== this.hours() ? "les" : "la") + "] LT";
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "d'aqu\xed %s",
            past: "fa %s",
            s: "uns segons",
            ss: "%d segons",
            m: "un minut",
            mm: "%d minuts",
            h: "una hora",
            hh: "%d hores",
            d: "un dia",
            dd: "%d dies",
            M: "un mes",
            MM: "%d mesos",
            y: "un any",
            yy: "%d anys"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|\xe8|a)/,
        ordinal: function(e, a) {
            return e + ("w" !== a && "W" !== a ? 1 === e ? "r" : 2 === e ? "n" : 3 === e ? "r" : 4 === e ? "t" : "\xe8" : "a");
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    ye = {
        standalone: "leden_\xfanor_b\u0159ezen_duben_kv\u011bten_\u010derven_\u010dervenec_srpen_z\xe1\u0159\xed_\u0159\xedjen_listopad_prosinec".split("_"),
        format: "ledna_\xfanora_b\u0159ezna_dubna_kv\u011btna_\u010dervna_\u010dervence_srpna_z\xe1\u0159\xed_\u0159\xedjna_listopadu_prosince".split("_"),
        isFormat: /DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/
    }, na = "led_\xfano_b\u0159e_dub_kv\u011b_\u010dvn_\u010dvc_srp_z\xe1\u0159_\u0159\xedj_lis_pro".split("_"), m = [
        /^led/i,
        /^\xfano/i,
        /^b\u0159e/i,
        /^dub/i,
        /^kv\u011b/i,
        /^(\u010dvn|\u010derven$|\u010dervna)/i,
        /^(\u010dvc|\u010dervenec|\u010dervence)/i,
        /^srp/i,
        /^z\xe1\u0159/i,
        /^\u0159\xedj/i,
        /^lis/i,
        /^pro/i
    ], t = /^(leden|\xfanor|b\u0159ezen|duben|kv\u011bten|\u010dervenec|\u010dervence|\u010derven|\u010dervna|srpen|z\xe1\u0159\xed|\u0159\xedjen|listopad|prosinec|led|\xfano|b\u0159e|dub|kv\u011b|\u010dvn|\u010dvc|srp|z\xe1\u0159|\u0159\xedj|lis|pro)/i;
    function _s(e) {
        return 1 < e && e < 5 && 1 != ~~(e / 10);
    }
    function j(e, a, t, s) {
        var n = e + " ";
        switch(t){
            case "s":
                return a || s ? "p\xe1r sekund" : "p\xe1r sekundami";
            case "ss":
                return a || s ? n + (_s(e) ? "sekundy" : "sekund") : n + "sekundami";
            case "m":
                return a ? "minuta" : s ? "minutu" : "minutou";
            case "mm":
                return a || s ? n + (_s(e) ? "minuty" : "minut") : n + "minutami";
            case "h":
                return a ? "hodina" : s ? "hodinu" : "hodinou";
            case "hh":
                return a || s ? n + (_s(e) ? "hodiny" : "hodin") : n + "hodinami";
            case "d":
                return a || s ? "den" : "dnem";
            case "dd":
                return a || s ? n + (_s(e) ? "dny" : "dn\xed") : n + "dny";
            case "M":
                return a || s ? "m\u011bs\xedc" : "m\u011bs\xedcem";
            case "MM":
                return a || s ? n + (_s(e) ? "m\u011bs\xedce" : "m\u011bs\xedc\u016f") : n + "m\u011bs\xedci";
            case "y":
                return a || s ? "rok" : "rokem";
            case "yy":
                return a || s ? n + (_s(e) ? "roky" : "let") : n + "lety";
        }
    }
    function is(e, a, t, s) {
        e = {
            m: [
                "eine Minute",
                "einer Minute"
            ],
            h: [
                "eine Stunde",
                "einer Stunde"
            ],
            d: [
                "ein Tag",
                "einem Tag"
            ],
            dd: [
                e + " Tage",
                e + " Tagen"
            ],
            w: [
                "eine Woche",
                "einer Woche"
            ],
            M: [
                "ein Monat",
                "einem Monat"
            ],
            MM: [
                e + " Monate",
                e + " Monaten"
            ],
            y: [
                "ein Jahr",
                "einem Jahr"
            ],
            yy: [
                e + " Jahre",
                e + " Jahren"
            ]
        };
        return a ? e[t][0] : e[t][1];
    }
    function os(e, a, t, s) {
        e = {
            m: [
                "eine Minute",
                "einer Minute"
            ],
            h: [
                "eine Stunde",
                "einer Stunde"
            ],
            d: [
                "ein Tag",
                "einem Tag"
            ],
            dd: [
                e + " Tage",
                e + " Tagen"
            ],
            w: [
                "eine Woche",
                "einer Woche"
            ],
            M: [
                "ein Monat",
                "einem Monat"
            ],
            MM: [
                e + " Monate",
                e + " Monaten"
            ],
            y: [
                "ein Jahr",
                "einem Jahr"
            ],
            yy: [
                e + " Jahre",
                e + " Jahren"
            ]
        };
        return a ? e[t][0] : e[t][1];
    }
    function ms(e, a, t, s) {
        e = {
            m: [
                "eine Minute",
                "einer Minute"
            ],
            h: [
                "eine Stunde",
                "einer Stunde"
            ],
            d: [
                "ein Tag",
                "einem Tag"
            ],
            dd: [
                e + " Tage",
                e + " Tagen"
            ],
            w: [
                "eine Woche",
                "einer Woche"
            ],
            M: [
                "ein Monat",
                "einem Monat"
            ],
            MM: [
                e + " Monate",
                e + " Monaten"
            ],
            y: [
                "ein Jahr",
                "einem Jahr"
            ],
            yy: [
                e + " Jahre",
                e + " Jahren"
            ]
        };
        return a ? e[t][0] : e[t][1];
    }
    c.defineLocale("cs", {
        months: ye,
        monthsShort: na,
        monthsRegex: t,
        monthsShortRegex: t,
        monthsStrictRegex: /^(leden|ledna|\xfanora|\xfanor|b\u0159ezen|b\u0159ezna|duben|dubna|kv\u011bten|kv\u011btna|\u010dervenec|\u010dervence|\u010derven|\u010dervna|srpen|srpna|z\xe1\u0159\xed|\u0159\xedjen|\u0159\xedjna|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex: /^(led|\xfano|b\u0159e|dub|kv\u011b|\u010dvn|\u010dvc|srp|z\xe1\u0159|\u0159\xedj|lis|pro)/i,
        monthsParse: m,
        longMonthsParse: m,
        shortMonthsParse: m,
        weekdays: "ned\u011ble_pond\u011bl\xed_\xfater\xfd_st\u0159eda_\u010dtvrtek_p\xe1tek_sobota".split("_"),
        weekdaysShort: "ne_po_\xfat_st_\u010dt_p\xe1_so".split("_"),
        weekdaysMin: "ne_po_\xfat_st_\u010dt_p\xe1_so".split("_"),
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm",
            LLLL: "dddd D. MMMM YYYY H:mm",
            l: "D. M. YYYY"
        },
        calendar: {
            sameDay: "[dnes v] LT",
            nextDay: "[z\xedtra v] LT",
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[v ned\u011bli v] LT";
                    case 1:
                    case 2:
                        return "[v] dddd [v] LT";
                    case 3:
                        return "[ve st\u0159edu v] LT";
                    case 4:
                        return "[ve \u010dtvrtek v] LT";
                    case 5:
                        return "[v p\xe1tek v] LT";
                    case 6:
                        return "[v sobotu v] LT";
                }
            },
            lastDay: "[v\u010dera v] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[minulou ned\u011bli v] LT";
                    case 1:
                    case 2:
                        return "[minul\xe9] dddd [v] LT";
                    case 3:
                        return "[minulou st\u0159edu v] LT";
                    case 4:
                    case 5:
                        return "[minul\xfd] dddd [v] LT";
                    case 6:
                        return "[minulou sobotu v] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "za %s",
            past: "p\u0159ed %s",
            s: j,
            ss: j,
            m: j,
            mm: j,
            h: j,
            hh: j,
            d: j,
            dd: j,
            M: j,
            MM: j,
            y: j,
            yy: j
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("cv", {
        months: "\u043a\u04d1\u0440\u043b\u0430\u0447_\u043d\u0430\u0440\u04d1\u0441_\u043f\u0443\u0448_\u0430\u043a\u0430_\u043c\u0430\u0439_\u04ab\u04d7\u0440\u0442\u043c\u0435_\u0443\u0442\u04d1_\u04ab\u0443\u0440\u043b\u0430_\u0430\u0432\u04d1\u043d_\u044e\u043f\u0430_\u0447\u04f3\u043a_\u0440\u0430\u0448\u0442\u0430\u0432".split("_"),
        monthsShort: "\u043a\u04d1\u0440_\u043d\u0430\u0440_\u043f\u0443\u0448_\u0430\u043a\u0430_\u043c\u0430\u0439_\u04ab\u04d7\u0440_\u0443\u0442\u04d1_\u04ab\u0443\u0440_\u0430\u0432\u043d_\u044e\u043f\u0430_\u0447\u04f3\u043a_\u0440\u0430\u0448".split("_"),
        weekdays: "\u0432\u044b\u0440\u0441\u0430\u0440\u043d\u0438\u043a\u0443\u043d_\u0442\u0443\u043d\u0442\u0438\u043a\u0443\u043d_\u044b\u0442\u043b\u0430\u0440\u0438\u043a\u0443\u043d_\u044e\u043d\u043a\u0443\u043d_\u043a\u04d7\u04ab\u043d\u0435\u0440\u043d\u0438\u043a\u0443\u043d_\u044d\u0440\u043d\u0435\u043a\u0443\u043d_\u0448\u04d1\u043c\u0430\u0442\u043a\u0443\u043d".split("_"),
        weekdaysShort: "\u0432\u044b\u0440_\u0442\u0443\u043d_\u044b\u0442\u043b_\u044e\u043d_\u043a\u04d7\u04ab_\u044d\u0440\u043d_\u0448\u04d1\u043c".split("_"),
        weekdaysMin: "\u0432\u0440_\u0442\u043d_\u044b\u0442_\u044e\u043d_\u043a\u04ab_\u044d\u0440_\u0448\u043c".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD-MM-YYYY",
            LL: "YYYY [\u04ab\u0443\u043b\u0445\u0438] MMMM [\u0443\u0439\u04d1\u0445\u04d7\u043d] D[-\u043c\u04d7\u0448\u04d7]",
            LLL: "YYYY [\u04ab\u0443\u043b\u0445\u0438] MMMM [\u0443\u0439\u04d1\u0445\u04d7\u043d] D[-\u043c\u04d7\u0448\u04d7], HH:mm",
            LLLL: "dddd, YYYY [\u04ab\u0443\u043b\u0445\u0438] MMMM [\u0443\u0439\u04d1\u0445\u04d7\u043d] D[-\u043c\u04d7\u0448\u04d7], HH:mm"
        },
        calendar: {
            sameDay: "[\u041f\u0430\u044f\u043d] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
            nextDay: "[\u042b\u0440\u0430\u043d] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
            lastDay: "[\u04d6\u043d\u0435\u0440] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
            nextWeek: "[\u04aa\u0438\u0442\u0435\u0441] dddd LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
            lastWeek: "[\u0418\u0440\u0442\u043d\u04d7] dddd LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
            sameElse: "L"
        },
        relativeTime: {
            future: function(e) {
                return e + (/\u0441\u0435\u0445\u0435\u0442$/i.exec(e) ? "\u0440\u0435\u043d" : /\u04ab\u0443\u043b$/i.exec(e) ? "\u0442\u0430\u043d" : "\u0440\u0430\u043d");
            },
            past: "%s \u043a\u0430\u044f\u043b\u043b\u0430",
            s: "\u043f\u04d7\u0440-\u0438\u043a \u04ab\u0435\u043a\u043a\u0443\u043d\u0442",
            ss: "%d \u04ab\u0435\u043a\u043a\u0443\u043d\u0442",
            m: "\u043f\u04d7\u0440 \u043c\u0438\u043d\u0443\u0442",
            mm: "%d \u043c\u0438\u043d\u0443\u0442",
            h: "\u043f\u04d7\u0440 \u0441\u0435\u0445\u0435\u0442",
            hh: "%d \u0441\u0435\u0445\u0435\u0442",
            d: "\u043f\u04d7\u0440 \u043a\u0443\u043d",
            dd: "%d \u043a\u0443\u043d",
            M: "\u043f\u04d7\u0440 \u0443\u0439\u04d1\u0445",
            MM: "%d \u0443\u0439\u04d1\u0445",
            y: "\u043f\u04d7\u0440 \u04ab\u0443\u043b",
            yy: "%d \u04ab\u0443\u043b"
        },
        dayOfMonthOrdinalParse: /\d{1,2}-\u043c\u04d7\u0448/,
        ordinal: "%d-\u043c\u04d7\u0448",
        week: {
            dow: 1,
            doy: 7
        }
    }), c.defineLocale("cy", {
        months: "Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr".split("_"),
        monthsShort: "Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag".split("_"),
        weekdays: "Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn".split("_"),
        weekdaysShort: "Sul_Llun_Maw_Mer_Iau_Gwe_Sad".split("_"),
        weekdaysMin: "Su_Ll_Ma_Me_Ia_Gw_Sa".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Heddiw am] LT",
            nextDay: "[Yfory am] LT",
            nextWeek: "dddd [am] LT",
            lastDay: "[Ddoe am] LT",
            lastWeek: "dddd [diwethaf am] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "mewn %s",
            past: "%s yn \xf4l",
            s: "ychydig eiliadau",
            ss: "%d eiliad",
            m: "munud",
            mm: "%d munud",
            h: "awr",
            hh: "%d awr",
            d: "diwrnod",
            dd: "%d diwrnod",
            M: "mis",
            MM: "%d mis",
            y: "blwyddyn",
            yy: "%d flynedd"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        ordinal: function(e) {
            var a = "";
            return 20 < e ? a = 40 === e || 50 === e || 60 === e || 80 === e || 100 === e ? "fed" : "ain" : 0 < e && (a = [
                "",
                "af",
                "il",
                "ydd",
                "ydd",
                "ed",
                "ed",
                "ed",
                "fed",
                "fed",
                "fed",
                "eg",
                "fed",
                "eg",
                "eg",
                "fed",
                "eg",
                "eg",
                "fed",
                "eg",
                "fed"
            ][e]), e + a;
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("da", {
        months: "januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"),
        monthsShort: "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
        weekdays: "s\xf8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xf8rdag".split("_"),
        weekdaysShort: "s\xf8n_man_tir_ons_tor_fre_l\xf8r".split("_"),
        weekdaysMin: "s\xf8_ma_ti_on_to_fr_l\xf8".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY HH:mm",
            LLLL: "dddd [d.] D. MMMM YYYY [kl.] HH:mm"
        },
        calendar: {
            sameDay: "[i dag kl.] LT",
            nextDay: "[i morgen kl.] LT",
            nextWeek: "p\xe5 dddd [kl.] LT",
            lastDay: "[i g\xe5r kl.] LT",
            lastWeek: "[i] dddd[s kl.] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "om %s",
            past: "%s siden",
            s: "f\xe5 sekunder",
            ss: "%d sekunder",
            m: "et minut",
            mm: "%d minutter",
            h: "en time",
            hh: "%d timer",
            d: "en dag",
            dd: "%d dage",
            M: "en m\xe5ned",
            MM: "%d m\xe5neder",
            y: "et \xe5r",
            yy: "%d \xe5r"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("de-at", {
        months: "J\xe4nner_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
        monthsShort: "J\xe4n._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
        monthsParseExact: !0,
        weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
        weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
        weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY HH:mm",
            LLLL: "dddd, D. MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[heute um] LT [Uhr]",
            sameElse: "L",
            nextDay: "[morgen um] LT [Uhr]",
            nextWeek: "dddd [um] LT [Uhr]",
            lastDay: "[gestern um] LT [Uhr]",
            lastWeek: "[letzten] dddd [um] LT [Uhr]"
        },
        relativeTime: {
            future: "in %s",
            past: "vor %s",
            s: "ein paar Sekunden",
            ss: "%d Sekunden",
            m: is,
            mm: "%d Minuten",
            h: is,
            hh: "%d Stunden",
            d: is,
            dd: is,
            w: is,
            ww: "%d Wochen",
            M: is,
            MM: is,
            y: is,
            yy: is
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("de-ch", {
        months: "Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
        monthsShort: "Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
        monthsParseExact: !0,
        weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
        weekdaysShort: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
        weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY HH:mm",
            LLLL: "dddd, D. MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[heute um] LT [Uhr]",
            sameElse: "L",
            nextDay: "[morgen um] LT [Uhr]",
            nextWeek: "dddd [um] LT [Uhr]",
            lastDay: "[gestern um] LT [Uhr]",
            lastWeek: "[letzten] dddd [um] LT [Uhr]"
        },
        relativeTime: {
            future: "in %s",
            past: "vor %s",
            s: "ein paar Sekunden",
            ss: "%d Sekunden",
            m: os,
            mm: "%d Minuten",
            h: os,
            hh: "%d Stunden",
            d: os,
            dd: os,
            w: os,
            ww: "%d Wochen",
            M: os,
            MM: os,
            y: os,
            yy: os
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("de", {
        months: "Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
        monthsShort: "Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
        monthsParseExact: !0,
        weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
        weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
        weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY HH:mm",
            LLLL: "dddd, D. MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[heute um] LT [Uhr]",
            sameElse: "L",
            nextDay: "[morgen um] LT [Uhr]",
            nextWeek: "dddd [um] LT [Uhr]",
            lastDay: "[gestern um] LT [Uhr]",
            lastWeek: "[letzten] dddd [um] LT [Uhr]"
        },
        relativeTime: {
            future: "in %s",
            past: "vor %s",
            s: "ein paar Sekunden",
            ss: "%d Sekunden",
            m: ms,
            mm: "%d Minuten",
            h: ms,
            hh: "%d Stunden",
            d: ms,
            dd: ms,
            w: ms,
            ww: "%d Wochen",
            M: ms,
            MM: ms,
            y: ms,
            yy: ms
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    o = [
        "\u0796\u07ac\u0782\u07aa\u0787\u07a6\u0783\u07a9",
        "\u078a\u07ac\u0784\u07b0\u0783\u07aa\u0787\u07a6\u0783\u07a9",
        "\u0789\u07a7\u0783\u07a8\u0797\u07aa",
        "\u0787\u07ad\u0795\u07b0\u0783\u07a9\u078d\u07aa",
        "\u0789\u07ad",
        "\u0796\u07ab\u0782\u07b0",
        "\u0796\u07aa\u078d\u07a6\u0787\u07a8",
        "\u0787\u07af\u078e\u07a6\u0790\u07b0\u0793\u07aa",
        "\u0790\u07ac\u0795\u07b0\u0793\u07ac\u0789\u07b0\u0784\u07a6\u0783\u07aa",
        "\u0787\u07ae\u0786\u07b0\u0793\u07af\u0784\u07a6\u0783\u07aa",
        "\u0782\u07ae\u0788\u07ac\u0789\u07b0\u0784\u07a6\u0783\u07aa",
        "\u0791\u07a8\u0790\u07ac\u0789\u07b0\u0784\u07a6\u0783\u07aa"
    ], n = [
        "\u0787\u07a7\u078b\u07a8\u0787\u07b0\u078c\u07a6",
        "\u0780\u07af\u0789\u07a6",
        "\u0787\u07a6\u0782\u07b0\u078e\u07a7\u0783\u07a6",
        "\u0784\u07aa\u078b\u07a6",
        "\u0784\u07aa\u0783\u07a7\u0790\u07b0\u078a\u07a6\u078c\u07a8",
        "\u0780\u07aa\u0786\u07aa\u0783\u07aa",
        "\u0780\u07ae\u0782\u07a8\u0780\u07a8\u0783\u07aa"
    ];
    c.defineLocale("dv", {
        months: o,
        monthsShort: o,
        weekdays: n,
        weekdaysShort: n,
        weekdaysMin: "\u0787\u07a7\u078b\u07a8_\u0780\u07af\u0789\u07a6_\u0787\u07a6\u0782\u07b0_\u0784\u07aa\u078b\u07a6_\u0784\u07aa\u0783\u07a7_\u0780\u07aa\u0786\u07aa_\u0780\u07ae\u0782\u07a8".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "D/M/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        meridiemParse: /\u0789\u0786|\u0789\u078a/,
        isPM: function(e) {
            return "\u0789\u078a" === e;
        },
        meridiem: function(e, a, t) {
            return e < 12 ? "\u0789\u0786" : "\u0789\u078a";
        },
        calendar: {
            sameDay: "[\u0789\u07a8\u0787\u07a6\u078b\u07aa] LT",
            nextDay: "[\u0789\u07a7\u078b\u07a6\u0789\u07a7] LT",
            nextWeek: "dddd LT",
            lastDay: "[\u0787\u07a8\u0787\u07b0\u0794\u07ac] LT",
            lastWeek: "[\u078a\u07a7\u0787\u07a8\u078c\u07aa\u0788\u07a8] dddd LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u078c\u07ac\u0783\u07ad\u078e\u07a6\u0787\u07a8 %s",
            past: "\u0786\u07aa\u0783\u07a8\u0782\u07b0 %s",
            s: "\u0790\u07a8\u0786\u07aa\u0782\u07b0\u078c\u07aa\u0786\u07ae\u0785\u07ac\u0787\u07b0",
            ss: "d% \u0790\u07a8\u0786\u07aa\u0782\u07b0\u078c\u07aa",
            m: "\u0789\u07a8\u0782\u07a8\u0793\u07ac\u0787\u07b0",
            mm: "\u0789\u07a8\u0782\u07a8\u0793\u07aa %d",
            h: "\u078e\u07a6\u0791\u07a8\u0787\u07a8\u0783\u07ac\u0787\u07b0",
            hh: "\u078e\u07a6\u0791\u07a8\u0787\u07a8\u0783\u07aa %d",
            d: "\u078b\u07aa\u0788\u07a6\u0780\u07ac\u0787\u07b0",
            dd: "\u078b\u07aa\u0788\u07a6\u0790\u07b0 %d",
            M: "\u0789\u07a6\u0780\u07ac\u0787\u07b0",
            MM: "\u0789\u07a6\u0790\u07b0 %d",
            y: "\u0787\u07a6\u0780\u07a6\u0783\u07ac\u0787\u07b0",
            yy: "\u0787\u07a6\u0780\u07a6\u0783\u07aa %d"
        },
        preparse: function(e) {
            return e.replace(/\u060c/g, ",");
        },
        postformat: function(e) {
            return e.replace(/,/g, "\u060c");
        },
        week: {
            dow: 7,
            doy: 12
        }
    }), c.defineLocale("el", {
        monthsNominativeEl: "\u0399\u03b1\u03bd\u03bf\u03c5\u03ac\u03c1\u03b9\u03bf\u03c2_\u03a6\u03b5\u03b2\u03c1\u03bf\u03c5\u03ac\u03c1\u03b9\u03bf\u03c2_\u039c\u03ac\u03c1\u03c4\u03b9\u03bf\u03c2_\u0391\u03c0\u03c1\u03af\u03bb\u03b9\u03bf\u03c2_\u039c\u03ac\u03b9\u03bf\u03c2_\u0399\u03bf\u03cd\u03bd\u03b9\u03bf\u03c2_\u0399\u03bf\u03cd\u03bb\u03b9\u03bf\u03c2_\u0391\u03cd\u03b3\u03bf\u03c5\u03c3\u03c4\u03bf\u03c2_\u03a3\u03b5\u03c0\u03c4\u03ad\u03bc\u03b2\u03c1\u03b9\u03bf\u03c2_\u039f\u03ba\u03c4\u03ce\u03b2\u03c1\u03b9\u03bf\u03c2_\u039d\u03bf\u03ad\u03bc\u03b2\u03c1\u03b9\u03bf\u03c2_\u0394\u03b5\u03ba\u03ad\u03bc\u03b2\u03c1\u03b9\u03bf\u03c2".split("_"),
        monthsGenitiveEl: "\u0399\u03b1\u03bd\u03bf\u03c5\u03b1\u03c1\u03af\u03bf\u03c5_\u03a6\u03b5\u03b2\u03c1\u03bf\u03c5\u03b1\u03c1\u03af\u03bf\u03c5_\u039c\u03b1\u03c1\u03c4\u03af\u03bf\u03c5_\u0391\u03c0\u03c1\u03b9\u03bb\u03af\u03bf\u03c5_\u039c\u03b1\u0390\u03bf\u03c5_\u0399\u03bf\u03c5\u03bd\u03af\u03bf\u03c5_\u0399\u03bf\u03c5\u03bb\u03af\u03bf\u03c5_\u0391\u03c5\u03b3\u03bf\u03cd\u03c3\u03c4\u03bf\u03c5_\u03a3\u03b5\u03c0\u03c4\u03b5\u03bc\u03b2\u03c1\u03af\u03bf\u03c5_\u039f\u03ba\u03c4\u03c9\u03b2\u03c1\u03af\u03bf\u03c5_\u039d\u03bf\u03b5\u03bc\u03b2\u03c1\u03af\u03bf\u03c5_\u0394\u03b5\u03ba\u03b5\u03bc\u03b2\u03c1\u03af\u03bf\u03c5".split("_"),
        months: function(e, a) {
            return e ? ("string" == typeof a && /D/.test(a.substring(0, a.indexOf("MMMM"))) ? this._monthsGenitiveEl : this._monthsNominativeEl)[e.month()] : this._monthsNominativeEl;
        },
        monthsShort: "\u0399\u03b1\u03bd_\u03a6\u03b5\u03b2_\u039c\u03b1\u03c1_\u0391\u03c0\u03c1_\u039c\u03b1\u03ca_\u0399\u03bf\u03c5\u03bd_\u0399\u03bf\u03c5\u03bb_\u0391\u03c5\u03b3_\u03a3\u03b5\u03c0_\u039f\u03ba\u03c4_\u039d\u03bf\u03b5_\u0394\u03b5\u03ba".split("_"),
        weekdays: "\u039a\u03c5\u03c1\u03b9\u03b1\u03ba\u03ae_\u0394\u03b5\u03c5\u03c4\u03ad\u03c1\u03b1_\u03a4\u03c1\u03af\u03c4\u03b7_\u03a4\u03b5\u03c4\u03ac\u03c1\u03c4\u03b7_\u03a0\u03ad\u03bc\u03c0\u03c4\u03b7_\u03a0\u03b1\u03c1\u03b1\u03c3\u03ba\u03b5\u03c5\u03ae_\u03a3\u03ac\u03b2\u03b2\u03b1\u03c4\u03bf".split("_"),
        weekdaysShort: "\u039a\u03c5\u03c1_\u0394\u03b5\u03c5_\u03a4\u03c1\u03b9_\u03a4\u03b5\u03c4_\u03a0\u03b5\u03bc_\u03a0\u03b1\u03c1_\u03a3\u03b1\u03b2".split("_"),
        weekdaysMin: "\u039a\u03c5_\u0394\u03b5_\u03a4\u03c1_\u03a4\u03b5_\u03a0\u03b5_\u03a0\u03b1_\u03a3\u03b1".split("_"),
        meridiem: function(e, a, t) {
            return 11 < e ? t ? "\u03bc\u03bc" : "\u039c\u039c" : t ? "\u03c0\u03bc" : "\u03a0\u039c";
        },
        isPM: function(e) {
            return "\u03bc" === (e + "").toLowerCase()[0];
        },
        meridiemParse: /[\u03a0\u039c]\.?\u039c?\.?/i,
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY h:mm A",
            LLLL: "dddd, D MMMM YYYY h:mm A"
        },
        calendarEl: {
            sameDay: "[\u03a3\u03ae\u03bc\u03b5\u03c1\u03b1 {}] LT",
            nextDay: "[\u0391\u03cd\u03c1\u03b9\u03bf {}] LT",
            nextWeek: "dddd [{}] LT",
            lastDay: "[\u03a7\u03b8\u03b5\u03c2 {}] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 6:
                        return "[\u03c4\u03bf \u03c0\u03c1\u03bf\u03b7\u03b3\u03bf\u03cd\u03bc\u03b5\u03bd\u03bf] dddd [{}] LT";
                    default:
                        return "[\u03c4\u03b7\u03bd \u03c0\u03c1\u03bf\u03b7\u03b3\u03bf\u03cd\u03bc\u03b5\u03bd\u03b7] dddd [{}] LT";
                }
            },
            sameElse: "L"
        },
        calendar: function(e, a) {
            var t, e = this._calendarEl[e], s = a && a.hours();
            return t = e, (e = "undefined" != typeof Function && t instanceof Function || "[object Function]" === Object.prototype.toString.call(t) ? e.apply(a) : e).replace("{}", s % 12 == 1 ? "\u03c3\u03c4\u03b7" : "\u03c3\u03c4\u03b9\u03c2");
        },
        relativeTime: {
            future: "\u03c3\u03b5 %s",
            past: "%s \u03c0\u03c1\u03b9\u03bd",
            s: "\u03bb\u03af\u03b3\u03b1 \u03b4\u03b5\u03c5\u03c4\u03b5\u03c1\u03cc\u03bb\u03b5\u03c0\u03c4\u03b1",
            ss: "%d \u03b4\u03b5\u03c5\u03c4\u03b5\u03c1\u03cc\u03bb\u03b5\u03c0\u03c4\u03b1",
            m: "\u03ad\u03bd\u03b1 \u03bb\u03b5\u03c0\u03c4\u03cc",
            mm: "%d \u03bb\u03b5\u03c0\u03c4\u03ac",
            h: "\u03bc\u03af\u03b1 \u03ce\u03c1\u03b1",
            hh: "%d \u03ce\u03c1\u03b5\u03c2",
            d: "\u03bc\u03af\u03b1 \u03bc\u03ad\u03c1\u03b1",
            dd: "%d \u03bc\u03ad\u03c1\u03b5\u03c2",
            M: "\u03ad\u03bd\u03b1\u03c2 \u03bc\u03ae\u03bd\u03b1\u03c2",
            MM: "%d \u03bc\u03ae\u03bd\u03b5\u03c2",
            y: "\u03ad\u03bd\u03b1\u03c2 \u03c7\u03c1\u03cc\u03bd\u03bf\u03c2",
            yy: "%d \u03c7\u03c1\u03cc\u03bd\u03b9\u03b1"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\u03b7/,
        ordinal: "%d\u03b7",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("en-au", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY h:mm A",
            LLLL: "dddd, D MMMM YYYY h:mm A"
        },
        calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(e) {
            var a = e % 10;
            return e + (1 == ~~(e % 100 / 10) ? "th" : 1 == a ? "st" : 2 == a ? "nd" : 3 == a ? "rd" : "th");
        },
        week: {
            dow: 0,
            doy: 4
        }
    }), c.defineLocale("en-ca", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "YYYY-MM-DD",
            LL: "MMMM D, YYYY",
            LLL: "MMMM D, YYYY h:mm A",
            LLLL: "dddd, MMMM D, YYYY h:mm A"
        },
        calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(e) {
            var a = e % 10;
            return e + (1 == ~~(e % 100 / 10) ? "th" : 1 == a ? "st" : 2 == a ? "nd" : 3 == a ? "rd" : "th");
        }
    }), c.defineLocale("en-gb", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(e) {
            var a = e % 10;
            return e + (1 == ~~(e % 100 / 10) ? "th" : 1 == a ? "st" : 2 == a ? "nd" : 3 == a ? "rd" : "th");
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("en-ie", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(e) {
            var a = e % 10;
            return e + (1 == ~~(e % 100 / 10) ? "th" : 1 == a ? "st" : 2 == a ? "nd" : 3 == a ? "rd" : "th");
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("en-il", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(e) {
            var a = e % 10;
            return e + (1 == ~~(e % 100 / 10) ? "th" : 1 == a ? "st" : 2 == a ? "nd" : 3 == a ? "rd" : "th");
        }
    }), c.defineLocale("en-in", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY h:mm A",
            LLLL: "dddd, D MMMM YYYY h:mm A"
        },
        calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(e) {
            var a = e % 10;
            return e + (1 == ~~(e % 100 / 10) ? "th" : 1 == a ? "st" : 2 == a ? "nd" : 3 == a ? "rd" : "th");
        },
        week: {
            dow: 0,
            doy: 6
        }
    }), c.defineLocale("en-nz", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY h:mm A",
            LLLL: "dddd, D MMMM YYYY h:mm A"
        },
        calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(e) {
            var a = e % 10;
            return e + (1 == ~~(e % 100 / 10) ? "th" : 1 == a ? "st" : 2 == a ? "nd" : 3 == a ? "rd" : "th");
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("en-sg", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(e) {
            var a = e % 10;
            return e + (1 == ~~(e % 100 / 10) ? "th" : 1 == a ? "st" : 2 == a ? "nd" : 3 == a ? "rd" : "th");
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("eo", {
        months: "januaro_februaro_marto_aprilo_majo_junio_julio_a\u016dgusto_septembro_oktobro_novembro_decembro".split("_"),
        monthsShort: "jan_feb_mart_apr_maj_jun_jul_a\u016dg_sept_okt_nov_dec".split("_"),
        weekdays: "diman\u0109o_lundo_mardo_merkredo_\u0135a\u016ddo_vendredo_sabato".split("_"),
        weekdaysShort: "dim_lun_mard_merk_\u0135a\u016d_ven_sab".split("_"),
        weekdaysMin: "di_lu_ma_me_\u0135a_ve_sa".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "[la] D[-an de] MMMM, YYYY",
            LLL: "[la] D[-an de] MMMM, YYYY HH:mm",
            LLLL: "dddd[n], [la] D[-an de] MMMM, YYYY HH:mm",
            llll: "ddd, [la] D[-an de] MMM, YYYY HH:mm"
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function(e) {
            return "p" === e.charAt(0).toLowerCase();
        },
        meridiem: function(e, a, t) {
            return 11 < e ? t ? "p.t.m." : "P.T.M." : t ? "a.t.m." : "A.T.M.";
        },
        calendar: {
            sameDay: "[Hodia\u016d je] LT",
            nextDay: "[Morga\u016d je] LT",
            nextWeek: "dddd[n je] LT",
            lastDay: "[Hiera\u016d je] LT",
            lastWeek: "[pasintan] dddd[n je] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "post %s",
            past: "anta\u016d %s",
            s: "kelkaj sekundoj",
            ss: "%d sekundoj",
            m: "unu minuto",
            mm: "%d minutoj",
            h: "unu horo",
            hh: "%d horoj",
            d: "unu tago",
            dd: "%d tagoj",
            M: "unu monato",
            MM: "%d monatoj",
            y: "unu jaro",
            yy: "%d jaroj"
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: "%da",
        week: {
            dow: 1,
            doy: 7
        }
    });
    var us = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"), ls = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), i = [
        /^ene/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ], ze = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i, Ms = (c.defineLocale("es-do", {
        months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
        monthsShort: function(e, a) {
            return e ? (/-MMM-/.test(a) ? ls : us)[e.month()] : us;
        },
        monthsRegex: ze,
        monthsShortRegex: ze,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: i,
        longMonthsParse: i,
        shortMonthsParse: i,
        weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),
        weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),
        weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY h:mm A",
            LLLL: "dddd, D [de] MMMM [de] YYYY h:mm A"
        },
        calendar: {
            sameDay: function() {
                return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            nextDay: function() {
                return "[ma\xf1ana a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            nextWeek: function() {
                return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            lastDay: function() {
                return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            lastWeek: function() {
                return "[el] dddd [pasado a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "en %s",
            past: "hace %s",
            s: "unos segundos",
            ss: "%d segundos",
            m: "un minuto",
            mm: "%d minutos",
            h: "una hora",
            hh: "%d horas",
            d: "un d\xeda",
            dd: "%d d\xedas",
            w: "una semana",
            ww: "%d semanas",
            M: "un mes",
            MM: "%d meses",
            y: "un a\xf1o",
            yy: "%d a\xf1os"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\xba/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        }
    }), "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_")), hs = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), M = [
        /^ene/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ], jt = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i, cs = (c.defineLocale("es-mx", {
        months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
        monthsShort: function(e, a) {
            return e ? (/-MMM-/.test(a) ? hs : Ms)[e.month()] : Ms;
        },
        monthsRegex: jt,
        monthsShortRegex: jt,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: M,
        longMonthsParse: M,
        shortMonthsParse: M,
        weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),
        weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),
        weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY H:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
        },
        calendar: {
            sameDay: function() {
                return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            nextDay: function() {
                return "[ma\xf1ana a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            nextWeek: function() {
                return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            lastDay: function() {
                return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            lastWeek: function() {
                return "[el] dddd [pasado a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "en %s",
            past: "hace %s",
            s: "unos segundos",
            ss: "%d segundos",
            m: "un minuto",
            mm: "%d minutos",
            h: "una hora",
            hh: "%d horas",
            d: "un d\xeda",
            dd: "%d d\xedas",
            w: "una semana",
            ww: "%d semanas",
            M: "un mes",
            MM: "%d meses",
            y: "un a\xf1o",
            yy: "%d a\xf1os"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\xba/,
        ordinal: "%d\xba",
        week: {
            dow: 0,
            doy: 4
        },
        invalidDate: "Fecha inv\xe1lida"
    }), "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_")), Ls = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), xt = [
        /^ene/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ], v = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i, Ys = (c.defineLocale("es-us", {
        months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
        monthsShort: function(e, a) {
            return e ? (/-MMM-/.test(a) ? Ls : cs)[e.month()] : cs;
        },
        monthsRegex: v,
        monthsShortRegex: v,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: xt,
        longMonthsParse: xt,
        shortMonthsParse: xt,
        weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),
        weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),
        weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "MM/DD/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY h:mm A",
            LLLL: "dddd, D [de] MMMM [de] YYYY h:mm A"
        },
        calendar: {
            sameDay: function() {
                return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            nextDay: function() {
                return "[ma\xf1ana a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            nextWeek: function() {
                return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            lastDay: function() {
                return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            lastWeek: function() {
                return "[el] dddd [pasado a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "en %s",
            past: "hace %s",
            s: "unos segundos",
            ss: "%d segundos",
            m: "un minuto",
            mm: "%d minutos",
            h: "una hora",
            hh: "%d horas",
            d: "un d\xeda",
            dd: "%d d\xedas",
            w: "una semana",
            ww: "%d semanas",
            M: "un mes",
            MM: "%d meses",
            y: "un a\xf1o",
            yy: "%d a\xf1os"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\xba/,
        ordinal: "%d\xba",
        week: {
            dow: 0,
            doy: 6
        }
    }), "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_")), ys = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), da = [
        /^ene/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ], pe = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
    function fs(e, a, t, s) {
        e = {
            s: [
                "m\xf5ne sekundi",
                "m\xf5ni sekund",
                "paar sekundit"
            ],
            ss: [
                e + "sekundi",
                e + "sekundit"
            ],
            m: [
                "\xfche minuti",
                "\xfcks minut"
            ],
            mm: [
                e + " minuti",
                e + " minutit"
            ],
            h: [
                "\xfche tunni",
                "tund aega",
                "\xfcks tund"
            ],
            hh: [
                e + " tunni",
                e + " tundi"
            ],
            d: [
                "\xfche p\xe4eva",
                "\xfcks p\xe4ev"
            ],
            M: [
                "kuu aja",
                "kuu aega",
                "\xfcks kuu"
            ],
            MM: [
                e + " kuu",
                e + " kuud"
            ],
            y: [
                "\xfche aasta",
                "aasta",
                "\xfcks aasta"
            ],
            yy: [
                e + " aasta",
                e + " aastat"
            ]
        };
        return a ? e[t][2] || e[t][1] : s ? e[t][0] : e[t][1];
    }
    c.defineLocale("es", {
        months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
        monthsShort: function(e, a) {
            return e ? (/-MMM-/.test(a) ? ys : Ys)[e.month()] : Ys;
        },
        monthsRegex: pe,
        monthsShortRegex: pe,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: da,
        longMonthsParse: da,
        shortMonthsParse: da,
        weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),
        weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),
        weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY H:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
        },
        calendar: {
            sameDay: function() {
                return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            nextDay: function() {
                return "[ma\xf1ana a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            nextWeek: function() {
                return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            lastDay: function() {
                return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            lastWeek: function() {
                return "[el] dddd [pasado a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "en %s",
            past: "hace %s",
            s: "unos segundos",
            ss: "%d segundos",
            m: "un minuto",
            mm: "%d minutos",
            h: "una hora",
            hh: "%d horas",
            d: "un d\xeda",
            dd: "%d d\xedas",
            w: "una semana",
            ww: "%d semanas",
            M: "un mes",
            MM: "%d meses",
            y: "un a\xf1o",
            yy: "%d a\xf1os"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\xba/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        },
        invalidDate: "Fecha inv\xe1lida"
    }), c.defineLocale("et", {
        months: "jaanuar_veebruar_m\xe4rts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember".split("_"),
        monthsShort: "jaan_veebr_m\xe4rts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets".split("_"),
        weekdays: "p\xfchap\xe4ev_esmasp\xe4ev_teisip\xe4ev_kolmap\xe4ev_neljap\xe4ev_reede_laup\xe4ev".split("_"),
        weekdaysShort: "P_E_T_K_N_R_L".split("_"),
        weekdaysMin: "P_E_T_K_N_R_L".split("_"),
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm",
            LLLL: "dddd, D. MMMM YYYY H:mm"
        },
        calendar: {
            sameDay: "[T\xe4na,] LT",
            nextDay: "[Homme,] LT",
            nextWeek: "[J\xe4rgmine] dddd LT",
            lastDay: "[Eile,] LT",
            lastWeek: "[Eelmine] dddd LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s p\xe4rast",
            past: "%s tagasi",
            s: fs,
            ss: fs,
            m: fs,
            mm: fs,
            h: fs,
            hh: fs,
            d: fs,
            dd: "%d p\xe4eva",
            M: fs,
            MM: fs,
            y: fs,
            yy: fs
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("eu", {
        months: "urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua".split("_"),
        monthsShort: "urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.".split("_"),
        monthsParseExact: !0,
        weekdays: "igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata".split("_"),
        weekdaysShort: "ig._al._ar._az._og._ol._lr.".split("_"),
        weekdaysMin: "ig_al_ar_az_og_ol_lr".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "YYYY[ko] MMMM[ren] D[a]",
            LLL: "YYYY[ko] MMMM[ren] D[a] HH:mm",
            LLLL: "dddd, YYYY[ko] MMMM[ren] D[a] HH:mm",
            l: "YYYY-M-D",
            ll: "YYYY[ko] MMM D[a]",
            lll: "YYYY[ko] MMM D[a] HH:mm",
            llll: "ddd, YYYY[ko] MMM D[a] HH:mm"
        },
        calendar: {
            sameDay: "[gaur] LT[etan]",
            nextDay: "[bihar] LT[etan]",
            nextWeek: "dddd LT[etan]",
            lastDay: "[atzo] LT[etan]",
            lastWeek: "[aurreko] dddd LT[etan]",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s barru",
            past: "duela %s",
            s: "segundo batzuk",
            ss: "%d segundo",
            m: "minutu bat",
            mm: "%d minutu",
            h: "ordu bat",
            hh: "%d ordu",
            d: "egun bat",
            dd: "%d egun",
            M: "hilabete bat",
            MM: "%d hilabete",
            y: "urte bat",
            yy: "%d urte"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 7
        }
    });
    var ks = {
        1: "\u06f1",
        2: "\u06f2",
        3: "\u06f3",
        4: "\u06f4",
        5: "\u06f5",
        6: "\u06f6",
        7: "\u06f7",
        8: "\u06f8",
        9: "\u06f9",
        0: "\u06f0"
    }, ps = {
        "\u06f1": "1",
        "\u06f2": "2",
        "\u06f3": "3",
        "\u06f4": "4",
        "\u06f5": "5",
        "\u06f6": "6",
        "\u06f7": "7",
        "\u06f8": "8",
        "\u06f9": "9",
        "\u06f0": "0"
    }, Ds = (c.defineLocale("fa", {
        months: "\u0698\u0627\u0646\u0648\u06cc\u0647_\u0641\u0648\u0631\u06cc\u0647_\u0645\u0627\u0631\u0633_\u0622\u0648\u0631\u06cc\u0644_\u0645\u0647_\u0698\u0648\u0626\u0646_\u0698\u0648\u0626\u06cc\u0647_\u0627\u0648\u062a_\u0633\u067e\u062a\u0627\u0645\u0628\u0631_\u0627\u06a9\u062a\u0628\u0631_\u0646\u0648\u0627\u0645\u0628\u0631_\u062f\u0633\u0627\u0645\u0628\u0631".split("_"),
        monthsShort: "\u0698\u0627\u0646\u0648\u06cc\u0647_\u0641\u0648\u0631\u06cc\u0647_\u0645\u0627\u0631\u0633_\u0622\u0648\u0631\u06cc\u0644_\u0645\u0647_\u0698\u0648\u0626\u0646_\u0698\u0648\u0626\u06cc\u0647_\u0627\u0648\u062a_\u0633\u067e\u062a\u0627\u0645\u0628\u0631_\u0627\u06a9\u062a\u0628\u0631_\u0646\u0648\u0627\u0645\u0628\u0631_\u062f\u0633\u0627\u0645\u0628\u0631".split("_"),
        weekdays: "\u06cc\u06a9\u200c\u0634\u0646\u0628\u0647_\u062f\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200c\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067e\u0646\u062c\u200c\u0634\u0646\u0628\u0647_\u062c\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split("_"),
        weekdaysShort: "\u06cc\u06a9\u200c\u0634\u0646\u0628\u0647_\u062f\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200c\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067e\u0646\u062c\u200c\u0634\u0646\u0628\u0647_\u062c\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split("_"),
        weekdaysMin: "\u06cc_\u062f_\u0633_\u0686_\u067e_\u062c_\u0634".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        meridiemParse: /\u0642\u0628\u0644 \u0627\u0632 \u0638\u0647\u0631|\u0628\u0639\u062f \u0627\u0632 \u0638\u0647\u0631/,
        isPM: function(e) {
            return /\u0628\u0639\u062f \u0627\u0632 \u0638\u0647\u0631/.test(e);
        },
        meridiem: function(e, a, t) {
            return e < 12 ? "\u0642\u0628\u0644 \u0627\u0632 \u0638\u0647\u0631" : "\u0628\u0639\u062f \u0627\u0632 \u0638\u0647\u0631";
        },
        calendar: {
            sameDay: "[\u0627\u0645\u0631\u0648\u0632 \u0633\u0627\u0639\u062a] LT",
            nextDay: "[\u0641\u0631\u062f\u0627 \u0633\u0627\u0639\u062a] LT",
            nextWeek: "dddd [\u0633\u0627\u0639\u062a] LT",
            lastDay: "[\u062f\u06cc\u0631\u0648\u0632 \u0633\u0627\u0639\u062a] LT",
            lastWeek: "dddd [\u067e\u06cc\u0634] [\u0633\u0627\u0639\u062a] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u062f\u0631 %s",
            past: "%s \u067e\u06cc\u0634",
            s: "\u0686\u0646\u062f \u062b\u0627\u0646\u06cc\u0647",
            ss: "%d \u062b\u0627\u0646\u06cc\u0647",
            m: "\u06cc\u06a9 \u062f\u0642\u06cc\u0642\u0647",
            mm: "%d \u062f\u0642\u06cc\u0642\u0647",
            h: "\u06cc\u06a9 \u0633\u0627\u0639\u062a",
            hh: "%d \u0633\u0627\u0639\u062a",
            d: "\u06cc\u06a9 \u0631\u0648\u0632",
            dd: "%d \u0631\u0648\u0632",
            M: "\u06cc\u06a9 \u0645\u0627\u0647",
            MM: "%d \u0645\u0627\u0647",
            y: "\u06cc\u06a9 \u0633\u0627\u0644",
            yy: "%d \u0633\u0627\u0644"
        },
        preparse: function(e) {
            return e.replace(/[\u06f0-\u06f9]/g, function(e) {
                return ps[e];
            }).replace(/\u060c/g, ",");
        },
        postformat: function(e) {
            return e.replace(/\d/g, function(e) {
                return ks[e];
            }).replace(/,/g, "\u060c");
        },
        dayOfMonthOrdinalParse: /\d{1,2}\u0645/,
        ordinal: "%d\u0645",
        week: {
            dow: 6,
            doy: 12
        }
    }), "nolla yksi kaksi kolme nelj\xe4 viisi kuusi seitsem\xe4n kahdeksan yhdeks\xe4n".split(" ")), Ts = [
        "nolla",
        "yhden",
        "kahden",
        "kolmen",
        "nelj\xe4n",
        "viiden",
        "kuuden",
        Ds[7],
        Ds[8],
        Ds[9]
    ];
    function x(e, a, t, s) {
        var n = "";
        switch(t){
            case "s":
                return s ? "muutaman sekunnin" : "muutama sekunti";
            case "ss":
                n = s ? "sekunnin" : "sekuntia";
                break;
            case "m":
                return s ? "minuutin" : "minuutti";
            case "mm":
                n = s ? "minuutin" : "minuuttia";
                break;
            case "h":
                return s ? "tunnin" : "tunti";
            case "hh":
                n = s ? "tunnin" : "tuntia";
                break;
            case "d":
                return s ? "p\xe4iv\xe4n" : "p\xe4iv\xe4";
            case "dd":
                n = s ? "p\xe4iv\xe4n" : "p\xe4iv\xe4\xe4";
                break;
            case "M":
                return s ? "kuukauden" : "kuukausi";
            case "MM":
                n = s ? "kuukauden" : "kuukautta";
                break;
            case "y":
                return s ? "vuoden" : "vuosi";
            case "yy":
                n = s ? "vuoden" : "vuotta";
                break;
        }
        return t = s, n = (e < 10 ? (t ? Ts : Ds)[e] : e) + " " + n;
    }
    c.defineLocale("fi", {
        months: "tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kes\xe4kuu_hein\xe4kuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split("_"),
        monthsShort: "tammi_helmi_maalis_huhti_touko_kes\xe4_hein\xe4_elo_syys_loka_marras_joulu".split("_"),
        weekdays: "sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split("_"),
        weekdaysShort: "su_ma_ti_ke_to_pe_la".split("_"),
        weekdaysMin: "su_ma_ti_ke_to_pe_la".split("_"),
        longDateFormat: {
            LT: "HH.mm",
            LTS: "HH.mm.ss",
            L: "DD.MM.YYYY",
            LL: "Do MMMM[ta] YYYY",
            LLL: "Do MMMM[ta] YYYY, [klo] HH.mm",
            LLLL: "dddd, Do MMMM[ta] YYYY, [klo] HH.mm",
            l: "D.M.YYYY",
            ll: "Do MMM YYYY",
            lll: "Do MMM YYYY, [klo] HH.mm",
            llll: "ddd, Do MMM YYYY, [klo] HH.mm"
        },
        calendar: {
            sameDay: "[t\xe4n\xe4\xe4n] [klo] LT",
            nextDay: "[huomenna] [klo] LT",
            nextWeek: "dddd [klo] LT",
            lastDay: "[eilen] [klo] LT",
            lastWeek: "[viime] dddd[na] [klo] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s p\xe4\xe4st\xe4",
            past: "%s sitten",
            s: x,
            ss: x,
            m: x,
            mm: x,
            h: x,
            hh: x,
            d: x,
            dd: x,
            M: x,
            MM: x,
            y: x,
            yy: x
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("fil", {
        months: "Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),
        monthsShort: "Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),
        weekdays: "Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),
        weekdaysShort: "Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),
        weekdaysMin: "Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "MM/D/YYYY",
            LL: "MMMM D, YYYY",
            LLL: "MMMM D, YYYY HH:mm",
            LLLL: "dddd, MMMM DD, YYYY HH:mm"
        },
        calendar: {
            sameDay: "LT [ngayong araw]",
            nextDay: "[Bukas ng] LT",
            nextWeek: "LT [sa susunod na] dddd",
            lastDay: "LT [kahapon]",
            lastWeek: "LT [noong nakaraang] dddd",
            sameElse: "L"
        },
        relativeTime: {
            future: "sa loob ng %s",
            past: "%s ang nakalipas",
            s: "ilang segundo",
            ss: "%d segundo",
            m: "isang minuto",
            mm: "%d minuto",
            h: "isang oras",
            hh: "%d oras",
            d: "isang araw",
            dd: "%d araw",
            M: "isang buwan",
            MM: "%d buwan",
            y: "isang taon",
            yy: "%d taon"
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function(e) {
            return e;
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("fo", {
        months: "januar_februar_mars_apr\xedl_mai_juni_juli_august_september_oktober_november_desember".split("_"),
        monthsShort: "jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),
        weekdays: "sunnudagur_m\xe1nadagur_t\xfdsdagur_mikudagur_h\xf3sdagur_fr\xedggjadagur_leygardagur".split("_"),
        weekdaysShort: "sun_m\xe1n_t\xfds_mik_h\xf3s_fr\xed_ley".split("_"),
        weekdaysMin: "su_m\xe1_t\xfd_mi_h\xf3_fr_le".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D. MMMM, YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\xcd dag kl.] LT",
            nextDay: "[\xcd morgin kl.] LT",
            nextWeek: "dddd [kl.] LT",
            lastDay: "[\xcd gj\xe1r kl.] LT",
            lastWeek: "[s\xed\xf0stu] dddd [kl] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "um %s",
            past: "%s s\xed\xf0ani",
            s: "f\xe1 sekund",
            ss: "%d sekundir",
            m: "ein minuttur",
            mm: "%d minuttir",
            h: "ein t\xedmi",
            hh: "%d t\xedmar",
            d: "ein dagur",
            dd: "%d dagar",
            M: "ein m\xe1na\xf0ur",
            MM: "%d m\xe1na\xf0ir",
            y: "eitt \xe1r",
            yy: "%d \xe1r"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("fr-ca", {
        months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),
        monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),
        monthsParseExact: !0,
        weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Aujourd\u2019hui \xe0] LT",
            nextDay: "[Demain \xe0] LT",
            nextWeek: "dddd [\xe0] LT",
            lastDay: "[Hier \xe0] LT",
            lastWeek: "dddd [dernier \xe0] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "dans %s",
            past: "il y a %s",
            s: "quelques secondes",
            ss: "%d secondes",
            m: "une minute",
            mm: "%d minutes",
            h: "une heure",
            hh: "%d heures",
            d: "un jour",
            dd: "%d jours",
            M: "un mois",
            MM: "%d mois",
            y: "un an",
            yy: "%d ans"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function(e, a) {
            switch(a){
                default:
                case "M":
                case "Q":
                case "D":
                case "DDD":
                case "d":
                    return e + (1 === e ? "er" : "e");
                case "w":
                case "W":
                    return e + (1 === e ? "re" : "e");
            }
        }
    }), c.defineLocale("fr-ch", {
        months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),
        monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),
        monthsParseExact: !0,
        weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Aujourd\u2019hui \xe0] LT",
            nextDay: "[Demain \xe0] LT",
            nextWeek: "dddd [\xe0] LT",
            lastDay: "[Hier \xe0] LT",
            lastWeek: "dddd [dernier \xe0] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "dans %s",
            past: "il y a %s",
            s: "quelques secondes",
            ss: "%d secondes",
            m: "une minute",
            mm: "%d minutes",
            h: "une heure",
            hh: "%d heures",
            d: "un jour",
            dd: "%d jours",
            M: "un mois",
            MM: "%d mois",
            y: "un an",
            yy: "%d ans"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function(e, a) {
            switch(a){
                default:
                case "M":
                case "Q":
                case "D":
                case "DDD":
                case "d":
                    return e + (1 === e ? "er" : "e");
                case "w":
                case "W":
                    return e + (1 === e ? "re" : "e");
            }
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    var u = /(janv\.?|f\xe9vr\.?|mars|avr\.?|mai|juin|juil\.?|ao\xfbt|sept\.?|oct\.?|nov\.?|d\xe9c\.?|janvier|f\xe9vrier|mars|avril|mai|juin|juillet|ao\xfbt|septembre|octobre|novembre|d\xe9cembre)/i, Le = [
        /^janv/i,
        /^f\xe9vr/i,
        /^mars/i,
        /^avr/i,
        /^mai/i,
        /^juin/i,
        /^juil/i,
        /^ao\xfbt/i,
        /^sept/i,
        /^oct/i,
        /^nov/i,
        /^d\xe9c/i
    ], gs = (c.defineLocale("fr", {
        months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),
        monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),
        monthsRegex: u,
        monthsShortRegex: u,
        monthsStrictRegex: /^(janvier|f\xe9vrier|mars|avril|mai|juin|juillet|ao\xfbt|septembre|octobre|novembre|d\xe9cembre)/i,
        monthsShortStrictRegex: /(janv\.?|f\xe9vr\.?|mars|avr\.?|mai|juin|juil\.?|ao\xfbt|sept\.?|oct\.?|nov\.?|d\xe9c\.?)/i,
        monthsParse: Le,
        longMonthsParse: Le,
        shortMonthsParse: Le,
        weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Aujourd\u2019hui \xe0] LT",
            nextDay: "[Demain \xe0] LT",
            nextWeek: "dddd [\xe0] LT",
            lastDay: "[Hier \xe0] LT",
            lastWeek: "dddd [dernier \xe0] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "dans %s",
            past: "il y a %s",
            s: "quelques secondes",
            ss: "%d secondes",
            m: "une minute",
            mm: "%d minutes",
            h: "une heure",
            hh: "%d heures",
            d: "un jour",
            dd: "%d jours",
            w: "une semaine",
            ww: "%d semaines",
            M: "un mois",
            MM: "%d mois",
            y: "un an",
            yy: "%d ans"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function(e, a) {
            switch(a){
                case "D":
                    return e + (1 === e ? "er" : "");
                default:
                case "M":
                case "Q":
                case "DDD":
                case "d":
                    return e + (1 === e ? "er" : "e");
                case "w":
                case "W":
                    return e + (1 === e ? "re" : "e");
            }
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), "jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.".split("_")), ws = "jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_");
    c.defineLocale("fy", {
        months: "jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber".split("_"),
        monthsShort: function(e, a) {
            return e ? (/-MMM-/.test(a) ? ws : gs)[e.month()] : gs;
        },
        monthsParseExact: !0,
        weekdays: "snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon".split("_"),
        weekdaysShort: "si._mo._ti._wo._to._fr._so.".split("_"),
        weekdaysMin: "Si_Mo_Ti_Wo_To_Fr_So".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD-MM-YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[hjoed om] LT",
            nextDay: "[moarn om] LT",
            nextWeek: "dddd [om] LT",
            lastDay: "[juster om] LT",
            lastWeek: "[\xf4fr\xfbne] dddd [om] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "oer %s",
            past: "%s lyn",
            s: "in pear sekonden",
            ss: "%d sekonden",
            m: "ien min\xfat",
            mm: "%d minuten",
            h: "ien oere",
            hh: "%d oeren",
            d: "ien dei",
            dd: "%d dagen",
            M: "ien moanne",
            MM: "%d moannen",
            y: "ien jier",
            yy: "%d jierren"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function(e) {
            return e + (1 === e || 8 === e || 20 <= e ? "ste" : "de");
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("ga", {
        months: [
            "Ean\xe1ir",
            "Feabhra",
            "M\xe1rta",
            "Aibre\xe1n",
            "Bealtaine",
            "Meitheamh",
            "I\xfail",
            "L\xfanasa",
            "Me\xe1n F\xf3mhair",
            "Deireadh F\xf3mhair",
            "Samhain",
            "Nollaig"
        ],
        monthsShort: [
            "Ean",
            "Feabh",
            "M\xe1rt",
            "Aib",
            "Beal",
            "Meith",
            "I\xfail",
            "L\xfan",
            "M.F.",
            "D.F.",
            "Samh",
            "Noll"
        ],
        monthsParseExact: !0,
        weekdays: [
            "D\xe9 Domhnaigh",
            "D\xe9 Luain",
            "D\xe9 M\xe1irt",
            "D\xe9 C\xe9adaoin",
            "D\xe9ardaoin",
            "D\xe9 hAoine",
            "D\xe9 Sathairn"
        ],
        weekdaysShort: [
            "Domh",
            "Luan",
            "M\xe1irt",
            "C\xe9ad",
            "D\xe9ar",
            "Aoine",
            "Sath"
        ],
        weekdaysMin: [
            "Do",
            "Lu",
            "M\xe1",
            "C\xe9",
            "D\xe9",
            "A",
            "Sa"
        ],
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Inniu ag] LT",
            nextDay: "[Am\xe1rach ag] LT",
            nextWeek: "dddd [ag] LT",
            lastDay: "[Inn\xe9 ag] LT",
            lastWeek: "dddd [seo caite] [ag] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "i %s",
            past: "%s \xf3 shin",
            s: "c\xfapla soicind",
            ss: "%d soicind",
            m: "n\xf3im\xe9ad",
            mm: "%d n\xf3im\xe9ad",
            h: "uair an chloig",
            hh: "%d uair an chloig",
            d: "l\xe1",
            dd: "%d l\xe1",
            M: "m\xed",
            MM: "%d m\xedonna",
            y: "bliain",
            yy: "%d bliain"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function(e) {
            return e + (1 === e ? "d" : e % 10 == 2 ? "na" : "mh");
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    function P(e, a, t, s) {
        e = {
            s: [
                "\u0925\u094b\u0921\u092f\u093e \u0938\u0945\u0915\u0902\u0921\u093e\u0902\u0928\u0940",
                "\u0925\u094b\u0921\u0947 \u0938\u0945\u0915\u0902\u0921"
            ],
            ss: [
                e + " \u0938\u0945\u0915\u0902\u0921\u093e\u0902\u0928\u0940",
                e + " \u0938\u0945\u0915\u0902\u0921"
            ],
            m: [
                "\u090f\u0915\u093e \u092e\u093f\u0923\u091f\u093e\u0928",
                "\u090f\u0915 \u092e\u093f\u0928\u0942\u091f"
            ],
            mm: [
                e + " \u092e\u093f\u0923\u091f\u093e\u0902\u0928\u0940",
                e + " \u092e\u093f\u0923\u091f\u093e\u0902"
            ],
            h: [
                "\u090f\u0915\u093e \u0935\u0930\u093e\u0928",
                "\u090f\u0915 \u0935\u0930"
            ],
            hh: [
                e + " \u0935\u0930\u093e\u0902\u0928\u0940",
                e + " \u0935\u0930\u093e\u0902"
            ],
            d: [
                "\u090f\u0915\u093e \u0926\u093f\u0938\u093e\u0928",
                "\u090f\u0915 \u0926\u0940\u0938"
            ],
            dd: [
                e + " \u0926\u093f\u0938\u093e\u0902\u0928\u0940",
                e + " \u0926\u0940\u0938"
            ],
            M: [
                "\u090f\u0915\u093e \u092e\u094d\u0939\u092f\u0928\u094d\u092f\u093e\u0928",
                "\u090f\u0915 \u092e\u094d\u0939\u092f\u0928\u094b"
            ],
            MM: [
                e + " \u092e\u094d\u0939\u092f\u0928\u094d\u092f\u093e\u0928\u0940",
                e + " \u092e\u094d\u0939\u092f\u0928\u0947"
            ],
            y: [
                "\u090f\u0915\u093e \u0935\u0930\u094d\u0938\u093e\u0928",
                "\u090f\u0915 \u0935\u0930\u094d\u0938"
            ],
            yy: [
                e + " \u0935\u0930\u094d\u0938\u093e\u0902\u0928\u0940",
                e + " \u0935\u0930\u094d\u0938\u093e\u0902"
            ]
        };
        return s ? e[t][0] : e[t][1];
    }
    function bs(e, a, t, s) {
        e = {
            s: [
                "thoddea sekondamni",
                "thodde sekond"
            ],
            ss: [
                e + " sekondamni",
                e + " sekond"
            ],
            m: [
                "eka mintan",
                "ek minut"
            ],
            mm: [
                e + " mintamni",
                e + " mintam"
            ],
            h: [
                "eka voran",
                "ek vor"
            ],
            hh: [
                e + " voramni",
                e + " voram"
            ],
            d: [
                "eka disan",
                "ek dis"
            ],
            dd: [
                e + " disamni",
                e + " dis"
            ],
            M: [
                "eka mhoinean",
                "ek mhoino"
            ],
            MM: [
                e + " mhoineamni",
                e + " mhoine"
            ],
            y: [
                "eka vorsan",
                "ek voros"
            ],
            yy: [
                e + " vorsamni",
                e + " vorsam"
            ]
        };
        return s ? e[t][0] : e[t][1];
    }
    c.defineLocale("gd", {
        months: [
            "Am Faoilleach",
            "An Gearran",
            "Am M\xe0rt",
            "An Giblean",
            "An C\xe8itean",
            "An t-\xd2gmhios",
            "An t-Iuchar",
            "An L\xf9nastal",
            "An t-Sultain",
            "An D\xe0mhair",
            "An t-Samhain",
            "An D\xf9bhlachd"
        ],
        monthsShort: [
            "Faoi",
            "Gear",
            "M\xe0rt",
            "Gibl",
            "C\xe8it",
            "\xd2gmh",
            "Iuch",
            "L\xf9n",
            "Sult",
            "D\xe0mh",
            "Samh",
            "D\xf9bh"
        ],
        monthsParseExact: !0,
        weekdays: [
            "Did\xf2mhnaich",
            "Diluain",
            "Dim\xe0irt",
            "Diciadain",
            "Diardaoin",
            "Dihaoine",
            "Disathairne"
        ],
        weekdaysShort: [
            "Did",
            "Dil",
            "Dim",
            "Dic",
            "Dia",
            "Dih",
            "Dis"
        ],
        weekdaysMin: [
            "D\xf2",
            "Lu",
            "M\xe0",
            "Ci",
            "Ar",
            "Ha",
            "Sa"
        ],
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[An-diugh aig] LT",
            nextDay: "[A-m\xe0ireach aig] LT",
            nextWeek: "dddd [aig] LT",
            lastDay: "[An-d\xe8 aig] LT",
            lastWeek: "dddd [seo chaidh] [aig] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "ann an %s",
            past: "bho chionn %s",
            s: "beagan diogan",
            ss: "%d diogan",
            m: "mionaid",
            mm: "%d mionaidean",
            h: "uair",
            hh: "%d uairean",
            d: "latha",
            dd: "%d latha",
            M: "m\xecos",
            MM: "%d m\xecosan",
            y: "bliadhna",
            yy: "%d bliadhna"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function(e) {
            return e + (1 === e ? "d" : e % 10 == 2 ? "na" : "mh");
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("gl", {
        months: "xaneiro_febreiro_marzo_abril_maio_xu\xf1o_xullo_agosto_setembro_outubro_novembro_decembro".split("_"),
        monthsShort: "xan._feb._mar._abr._mai._xu\xf1._xul._ago._set._out._nov._dec.".split("_"),
        monthsParseExact: !0,
        weekdays: "domingo_luns_martes_m\xe9rcores_xoves_venres_s\xe1bado".split("_"),
        weekdaysShort: "dom._lun._mar._m\xe9r._xov._ven._s\xe1b.".split("_"),
        weekdaysMin: "do_lu_ma_m\xe9_xo_ve_s\xe1".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY H:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
        },
        calendar: {
            sameDay: function() {
                return "[hoxe " + (1 !== this.hours() ? "\xe1s" : "\xe1") + "] LT";
            },
            nextDay: function() {
                return "[ma\xf1\xe1 " + (1 !== this.hours() ? "\xe1s" : "\xe1") + "] LT";
            },
            nextWeek: function() {
                return "dddd [" + (1 !== this.hours() ? "\xe1s" : "a") + "] LT";
            },
            lastDay: function() {
                return "[onte " + (1 !== this.hours() ? "\xe1" : "a") + "] LT";
            },
            lastWeek: function() {
                return "[o] dddd [pasado " + (1 !== this.hours() ? "\xe1s" : "a") + "] LT";
            },
            sameElse: "L"
        },
        relativeTime: {
            future: function(e) {
                return 0 === e.indexOf("un") ? "n" + e : "en " + e;
            },
            past: "hai %s",
            s: "uns segundos",
            ss: "%d segundos",
            m: "un minuto",
            mm: "%d minutos",
            h: "unha hora",
            hh: "%d horas",
            d: "un d\xeda",
            dd: "%d d\xedas",
            M: "un mes",
            MM: "%d meses",
            y: "un ano",
            yy: "%d anos"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\xba/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("gom-deva", {
        months: {
            standalone: "\u091c\u093e\u0928\u0947\u0935\u093e\u0930\u0940_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u093e\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u090f\u092a\u094d\u0930\u0940\u0932_\u092e\u0947_\u091c\u0942\u0928_\u091c\u0941\u0932\u092f_\u0911\u0917\u0938\u094d\u091f_\u0938\u092a\u094d\u091f\u0947\u0902\u092c\u0930_\u0911\u0915\u094d\u091f\u094b\u092c\u0930_\u0928\u094b\u0935\u094d\u0939\u0947\u0902\u092c\u0930_\u0921\u093f\u0938\u0947\u0902\u092c\u0930".split("_"),
            format: "\u091c\u093e\u0928\u0947\u0935\u093e\u0930\u0940\u091a\u094d\u092f\u093e_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u093e\u0930\u0940\u091a\u094d\u092f\u093e_\u092e\u093e\u0930\u094d\u091a\u093e\u091a\u094d\u092f\u093e_\u090f\u092a\u094d\u0930\u0940\u0932\u093e\u091a\u094d\u092f\u093e_\u092e\u0947\u092f\u093e\u091a\u094d\u092f\u093e_\u091c\u0942\u0928\u093e\u091a\u094d\u092f\u093e_\u091c\u0941\u0932\u092f\u093e\u091a\u094d\u092f\u093e_\u0911\u0917\u0938\u094d\u091f\u093e\u091a\u094d\u092f\u093e_\u0938\u092a\u094d\u091f\u0947\u0902\u092c\u0930\u093e\u091a\u094d\u092f\u093e_\u0911\u0915\u094d\u091f\u094b\u092c\u0930\u093e\u091a\u094d\u092f\u093e_\u0928\u094b\u0935\u094d\u0939\u0947\u0902\u092c\u0930\u093e\u091a\u094d\u092f\u093e_\u0921\u093f\u0938\u0947\u0902\u092c\u0930\u093e\u091a\u094d\u092f\u093e".split("_"),
            isFormat: /MMMM(\s)+D[oD]?/
        },
        monthsShort: "\u091c\u093e\u0928\u0947._\u092b\u0947\u092c\u094d\u0930\u0941._\u092e\u093e\u0930\u094d\u091a_\u090f\u092a\u094d\u0930\u0940._\u092e\u0947_\u091c\u0942\u0928_\u091c\u0941\u0932._\u0911\u0917._\u0938\u092a\u094d\u091f\u0947\u0902._\u0911\u0915\u094d\u091f\u094b._\u0928\u094b\u0935\u094d\u0939\u0947\u0902._\u0921\u093f\u0938\u0947\u0902.".split("_"),
        monthsParseExact: !0,
        weekdays: "\u0906\u092f\u0924\u093e\u0930_\u0938\u094b\u092e\u093e\u0930_\u092e\u0902\u0917\u0933\u093e\u0930_\u092c\u0941\u0927\u0935\u093e\u0930_\u092c\u093f\u0930\u0947\u0938\u094d\u0924\u093e\u0930_\u0938\u0941\u0915\u094d\u0930\u093e\u0930_\u0936\u0947\u0928\u0935\u093e\u0930".split("_"),
        weekdaysShort: "\u0906\u092f\u0924._\u0938\u094b\u092e._\u092e\u0902\u0917\u0933._\u092c\u0941\u0927._\u092c\u094d\u0930\u0947\u0938\u094d\u0924._\u0938\u0941\u0915\u094d\u0930._\u0936\u0947\u0928.".split("_"),
        weekdaysMin: "\u0906_\u0938\u094b_\u092e\u0902_\u092c\u0941_\u092c\u094d\u0930\u0947_\u0938\u0941_\u0936\u0947".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "A h:mm [\u0935\u093e\u091c\u0924\u093e\u0902]",
            LTS: "A h:mm:ss [\u0935\u093e\u091c\u0924\u093e\u0902]",
            L: "DD-MM-YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY A h:mm [\u0935\u093e\u091c\u0924\u093e\u0902]",
            LLLL: "dddd, MMMM Do, YYYY, A h:mm [\u0935\u093e\u091c\u0924\u093e\u0902]",
            llll: "ddd, D MMM YYYY, A h:mm [\u0935\u093e\u091c\u0924\u093e\u0902]"
        },
        calendar: {
            sameDay: "[\u0906\u092f\u091c] LT",
            nextDay: "[\u092b\u093e\u0932\u094d\u092f\u093e\u0902] LT",
            nextWeek: "[\u092b\u0941\u0921\u0932\u094b] dddd[,] LT",
            lastDay: "[\u0915\u093e\u0932] LT",
            lastWeek: "[\u092b\u093e\u091f\u0932\u094b] dddd[,] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s",
            past: "%s \u0906\u0926\u0940\u0902",
            s: P,
            ss: P,
            m: P,
            mm: P,
            h: P,
            hh: P,
            d: P,
            dd: P,
            M: P,
            MM: P,
            y: P,
            yy: P
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\u0935\u0947\u0930)/,
        ordinal: function(e, a) {
            switch(a){
                case "D":
                    return e + "\u0935\u0947\u0930";
                default:
                case "M":
                case "Q":
                case "DDD":
                case "d":
                case "w":
                case "W":
                    return e;
            }
        },
        week: {
            dow: 0,
            doy: 3
        },
        meridiemParse: /\u0930\u093e\u0924\u0940|\u0938\u0915\u093e\u0933\u0940\u0902|\u0926\u0928\u092a\u093e\u0930\u093e\u0902|\u0938\u093e\u0902\u091c\u0947/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "\u0930\u093e\u0924\u0940" === a ? e < 4 ? e : e + 12 : "\u0938\u0915\u093e\u0933\u0940\u0902" === a ? e : "\u0926\u0928\u092a\u093e\u0930\u093e\u0902" === a ? 12 < e ? e : e + 12 : "\u0938\u093e\u0902\u091c\u0947" === a ? e + 12 : void 0;
        },
        meridiem: function(e, a, t) {
            return e < 4 ? "\u0930\u093e\u0924\u0940" : e < 12 ? "\u0938\u0915\u093e\u0933\u0940\u0902" : e < 16 ? "\u0926\u0928\u092a\u093e\u0930\u093e\u0902" : e < 20 ? "\u0938\u093e\u0902\u091c\u0947" : "\u0930\u093e\u0924\u0940";
        }
    }), c.defineLocale("gom-latn", {
        months: {
            standalone: "Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr".split("_"),
            format: "Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea".split("_"),
            isFormat: /MMMM(\s)+D[oD]?/
        },
        monthsShort: "Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.".split("_"),
        monthsParseExact: !0,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split("_"),
        weekdaysShort: "Ait._Som._Mon._Bud._Bre._Suk._Son.".split("_"),
        weekdaysMin: "Ai_Sm_Mo_Bu_Br_Su_Sn".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "A h:mm [vazta]",
            LTS: "A h:mm:ss [vazta]",
            L: "DD-MM-YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY A h:mm [vazta]",
            LLLL: "dddd, MMMM Do, YYYY, A h:mm [vazta]",
            llll: "ddd, D MMM YYYY, A h:mm [vazta]"
        },
        calendar: {
            sameDay: "[Aiz] LT",
            nextDay: "[Faleam] LT",
            nextWeek: "[Fuddlo] dddd[,] LT",
            lastDay: "[Kal] LT",
            lastWeek: "[Fattlo] dddd[,] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s",
            past: "%s adim",
            s: bs,
            ss: bs,
            m: bs,
            mm: bs,
            h: bs,
            hh: bs,
            d: bs,
            dd: bs,
            M: bs,
            MM: bs,
            y: bs,
            yy: bs
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function(e, a) {
            switch(a){
                case "D":
                    return e + "er";
                default:
                case "M":
                case "Q":
                case "DDD":
                case "d":
                case "w":
                case "W":
                    return e;
            }
        },
        week: {
            dow: 0,
            doy: 3
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "rati" === a ? e < 4 ? e : e + 12 : "sokallim" === a ? e : "donparam" === a ? 12 < e ? e : e + 12 : "sanje" === a ? e + 12 : void 0;
        },
        meridiem: function(e, a, t) {
            return e < 4 ? "rati" : e < 12 ? "sokallim" : e < 16 ? "donparam" : e < 20 ? "sanje" : "rati";
        }
    });
    var Hs = {
        1: "\u0ae7",
        2: "\u0ae8",
        3: "\u0ae9",
        4: "\u0aea",
        5: "\u0aeb",
        6: "\u0aec",
        7: "\u0aed",
        8: "\u0aee",
        9: "\u0aef",
        0: "\u0ae6"
    }, Ss = {
        "\u0ae7": "1",
        "\u0ae8": "2",
        "\u0ae9": "3",
        "\u0aea": "4",
        "\u0aeb": "5",
        "\u0aec": "6",
        "\u0aed": "7",
        "\u0aee": "8",
        "\u0aef": "9",
        "\u0ae6": "0"
    }, vs = (c.defineLocale("gu", {
        months: "\u0a9c\u0abe\u0aa8\u0acd\u0aaf\u0ac1\u0a86\u0ab0\u0ac0_\u0aab\u0ac7\u0aac\u0acd\u0ab0\u0ac1\u0a86\u0ab0\u0ac0_\u0aae\u0abe\u0ab0\u0acd\u0a9a_\u0a8f\u0aaa\u0acd\u0ab0\u0abf\u0ab2_\u0aae\u0ac7_\u0a9c\u0ac2\u0aa8_\u0a9c\u0ac1\u0ab2\u0abe\u0a88_\u0a91\u0a97\u0ab8\u0acd\u0a9f_\u0ab8\u0aaa\u0acd\u0a9f\u0ac7\u0aae\u0acd\u0aac\u0ab0_\u0a91\u0a95\u0acd\u0a9f\u0acd\u0aac\u0ab0_\u0aa8\u0ab5\u0ac7\u0aae\u0acd\u0aac\u0ab0_\u0aa1\u0abf\u0ab8\u0ac7\u0aae\u0acd\u0aac\u0ab0".split("_"),
        monthsShort: "\u0a9c\u0abe\u0aa8\u0acd\u0aaf\u0ac1._\u0aab\u0ac7\u0aac\u0acd\u0ab0\u0ac1._\u0aae\u0abe\u0ab0\u0acd\u0a9a_\u0a8f\u0aaa\u0acd\u0ab0\u0abf._\u0aae\u0ac7_\u0a9c\u0ac2\u0aa8_\u0a9c\u0ac1\u0ab2\u0abe._\u0a91\u0a97._\u0ab8\u0aaa\u0acd\u0a9f\u0ac7._\u0a91\u0a95\u0acd\u0a9f\u0acd._\u0aa8\u0ab5\u0ac7._\u0aa1\u0abf\u0ab8\u0ac7.".split("_"),
        monthsParseExact: !0,
        weekdays: "\u0ab0\u0ab5\u0abf\u0ab5\u0abe\u0ab0_\u0ab8\u0acb\u0aae\u0ab5\u0abe\u0ab0_\u0aae\u0a82\u0a97\u0ab3\u0ab5\u0abe\u0ab0_\u0aac\u0ac1\u0aa7\u0acd\u0ab5\u0abe\u0ab0_\u0a97\u0ac1\u0ab0\u0ac1\u0ab5\u0abe\u0ab0_\u0ab6\u0ac1\u0a95\u0acd\u0ab0\u0ab5\u0abe\u0ab0_\u0ab6\u0aa8\u0abf\u0ab5\u0abe\u0ab0".split("_"),
        weekdaysShort: "\u0ab0\u0ab5\u0abf_\u0ab8\u0acb\u0aae_\u0aae\u0a82\u0a97\u0ab3_\u0aac\u0ac1\u0aa7\u0acd_\u0a97\u0ac1\u0ab0\u0ac1_\u0ab6\u0ac1\u0a95\u0acd\u0ab0_\u0ab6\u0aa8\u0abf".split("_"),
        weekdaysMin: "\u0ab0_\u0ab8\u0acb_\u0aae\u0a82_\u0aac\u0ac1_\u0a97\u0ac1_\u0ab6\u0ac1_\u0ab6".split("_"),
        longDateFormat: {
            LT: "A h:mm \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",
            LTS: "A h:mm:ss \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7"
        },
        calendar: {
            sameDay: "[\u0a86\u0a9c] LT",
            nextDay: "[\u0a95\u0abe\u0ab2\u0ac7] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0a97\u0a87\u0a95\u0abe\u0ab2\u0ac7] LT",
            lastWeek: "[\u0aaa\u0abe\u0a9b\u0ab2\u0abe] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0aae\u0abe",
            past: "%s \u0aaa\u0ab9\u0ac7\u0ab2\u0abe",
            s: "\u0a85\u0aae\u0ac1\u0a95 \u0aaa\u0ab3\u0acb",
            ss: "%d \u0ab8\u0ac7\u0a95\u0a82\u0aa1",
            m: "\u0a8f\u0a95 \u0aae\u0abf\u0aa8\u0abf\u0a9f",
            mm: "%d \u0aae\u0abf\u0aa8\u0abf\u0a9f",
            h: "\u0a8f\u0a95 \u0a95\u0ab2\u0abe\u0a95",
            hh: "%d \u0a95\u0ab2\u0abe\u0a95",
            d: "\u0a8f\u0a95 \u0aa6\u0abf\u0ab5\u0ab8",
            dd: "%d \u0aa6\u0abf\u0ab5\u0ab8",
            M: "\u0a8f\u0a95 \u0aae\u0ab9\u0abf\u0aa8\u0acb",
            MM: "%d \u0aae\u0ab9\u0abf\u0aa8\u0acb",
            y: "\u0a8f\u0a95 \u0ab5\u0ab0\u0acd\u0ab7",
            yy: "%d \u0ab5\u0ab0\u0acd\u0ab7"
        },
        preparse: function(e) {
            return e.replace(/[\u0ae7\u0ae8\u0ae9\u0aea\u0aeb\u0aec\u0aed\u0aee\u0aef\u0ae6]/g, function(e) {
                return Ss[e];
            });
        },
        postformat: function(e) {
            return e.replace(/\d/g, function(e) {
                return Hs[e];
            });
        },
        meridiemParse: /\u0ab0\u0abe\u0aa4|\u0aac\u0aaa\u0acb\u0ab0|\u0ab8\u0ab5\u0abe\u0ab0|\u0ab8\u0abe\u0a82\u0a9c/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "\u0ab0\u0abe\u0aa4" === a ? e < 4 ? e : e + 12 : "\u0ab8\u0ab5\u0abe\u0ab0" === a ? e : "\u0aac\u0aaa\u0acb\u0ab0" === a ? 10 <= e ? e : e + 12 : "\u0ab8\u0abe\u0a82\u0a9c" === a ? e + 12 : void 0;
        },
        meridiem: function(e, a, t) {
            return e < 4 ? "\u0ab0\u0abe\u0aa4" : e < 10 ? "\u0ab8\u0ab5\u0abe\u0ab0" : e < 17 ? "\u0aac\u0aaa\u0acb\u0ab0" : e < 20 ? "\u0ab8\u0abe\u0a82\u0a9c" : "\u0ab0\u0abe\u0aa4";
        },
        week: {
            dow: 0,
            doy: 6
        }
    }), c.defineLocale("he", {
        months: "\u05d9\u05e0\u05d5\u05d0\u05e8_\u05e4\u05d1\u05e8\u05d5\u05d0\u05e8_\u05de\u05e8\u05e5_\u05d0\u05e4\u05e8\u05d9\u05dc_\u05de\u05d0\u05d9_\u05d9\u05d5\u05e0\u05d9_\u05d9\u05d5\u05dc\u05d9_\u05d0\u05d5\u05d2\u05d5\u05e1\u05d8_\u05e1\u05e4\u05d8\u05de\u05d1\u05e8_\u05d0\u05d5\u05e7\u05d8\u05d5\u05d1\u05e8_\u05e0\u05d5\u05d1\u05de\u05d1\u05e8_\u05d3\u05e6\u05de\u05d1\u05e8".split("_"),
        monthsShort: "\u05d9\u05e0\u05d5\u05f3_\u05e4\u05d1\u05e8\u05f3_\u05de\u05e8\u05e5_\u05d0\u05e4\u05e8\u05f3_\u05de\u05d0\u05d9_\u05d9\u05d5\u05e0\u05d9_\u05d9\u05d5\u05dc\u05d9_\u05d0\u05d5\u05d2\u05f3_\u05e1\u05e4\u05d8\u05f3_\u05d0\u05d5\u05e7\u05f3_\u05e0\u05d5\u05d1\u05f3_\u05d3\u05e6\u05de\u05f3".split("_"),
        weekdays: "\u05e8\u05d0\u05e9\u05d5\u05df_\u05e9\u05e0\u05d9_\u05e9\u05dc\u05d9\u05e9\u05d9_\u05e8\u05d1\u05d9\u05e2\u05d9_\u05d7\u05de\u05d9\u05e9\u05d9_\u05e9\u05d9\u05e9\u05d9_\u05e9\u05d1\u05ea".split("_"),
        weekdaysShort: "\u05d0\u05f3_\u05d1\u05f3_\u05d2\u05f3_\u05d3\u05f3_\u05d4\u05f3_\u05d5\u05f3_\u05e9\u05f3".split("_"),
        weekdaysMin: "\u05d0_\u05d1_\u05d2_\u05d3_\u05d4_\u05d5_\u05e9".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [\u05d1]MMMM YYYY",
            LLL: "D [\u05d1]MMMM YYYY HH:mm",
            LLLL: "dddd, D [\u05d1]MMMM YYYY HH:mm",
            l: "D/M/YYYY",
            ll: "D MMM YYYY",
            lll: "D MMM YYYY HH:mm",
            llll: "ddd, D MMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\u05d4\u05d9\u05d5\u05dd \u05d1\u05be]LT",
            nextDay: "[\u05de\u05d7\u05e8 \u05d1\u05be]LT",
            nextWeek: "dddd [\u05d1\u05e9\u05e2\u05d4] LT",
            lastDay: "[\u05d0\u05ea\u05de\u05d5\u05dc \u05d1\u05be]LT",
            lastWeek: "[\u05d1\u05d9\u05d5\u05dd] dddd [\u05d4\u05d0\u05d7\u05e8\u05d5\u05df \u05d1\u05e9\u05e2\u05d4] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u05d1\u05e2\u05d5\u05d3 %s",
            past: "\u05dc\u05e4\u05e0\u05d9 %s",
            s: "\u05de\u05e1\u05e4\u05e8 \u05e9\u05e0\u05d9\u05d5\u05ea",
            ss: "%d \u05e9\u05e0\u05d9\u05d5\u05ea",
            m: "\u05d3\u05e7\u05d4",
            mm: "%d \u05d3\u05e7\u05d5\u05ea",
            h: "\u05e9\u05e2\u05d4",
            hh: function(e) {
                return 2 === e ? "\u05e9\u05e2\u05ea\u05d9\u05d9\u05dd" : e + " \u05e9\u05e2\u05d5\u05ea";
            },
            d: "\u05d9\u05d5\u05dd",
            dd: function(e) {
                return 2 === e ? "\u05d9\u05d5\u05de\u05d9\u05d9\u05dd" : e + " \u05d9\u05de\u05d9\u05dd";
            },
            M: "\u05d7\u05d5\u05d3\u05e9",
            MM: function(e) {
                return 2 === e ? "\u05d7\u05d5\u05d3\u05e9\u05d9\u05d9\u05dd" : e + " \u05d7\u05d5\u05d3\u05e9\u05d9\u05dd";
            },
            y: "\u05e9\u05e0\u05d4",
            yy: function(e) {
                return 2 === e ? "\u05e9\u05e0\u05ea\u05d9\u05d9\u05dd" : e % 10 == 0 && 10 !== e ? e + " \u05e9\u05e0\u05d4" : e + " \u05e9\u05e0\u05d9\u05dd";
            }
        },
        meridiemParse: /\u05d0\u05d7\u05d4"\u05e6|\u05dc\u05e4\u05e0\u05d4"\u05e6|\u05d0\u05d7\u05e8\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd|\u05dc\u05e4\u05e0\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd|\u05dc\u05e4\u05e0\u05d5\u05ea \u05d1\u05d5\u05e7\u05e8|\u05d1\u05d1\u05d5\u05e7\u05e8|\u05d1\u05e2\u05e8\u05d1/i,
        isPM: function(e) {
            return /^(\u05d0\u05d7\u05d4"\u05e6|\u05d0\u05d7\u05e8\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd|\u05d1\u05e2\u05e8\u05d1)$/.test(e);
        },
        meridiem: function(e, a, t) {
            return e < 5 ? "\u05dc\u05e4\u05e0\u05d5\u05ea \u05d1\u05d5\u05e7\u05e8" : e < 10 ? "\u05d1\u05d1\u05d5\u05e7\u05e8" : e < 12 ? t ? '\u05dc\u05e4\u05e0\u05d4"\u05e6' : "\u05dc\u05e4\u05e0\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd" : e < 18 ? t ? '\u05d0\u05d7\u05d4"\u05e6' : "\u05d0\u05d7\u05e8\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd" : "\u05d1\u05e2\u05e8\u05d1";
        }
    }), {
        1: "\u0967",
        2: "\u0968",
        3: "\u0969",
        4: "\u096a",
        5: "\u096b",
        6: "\u096c",
        7: "\u096d",
        8: "\u096e",
        9: "\u096f",
        0: "\u0966"
    }), js = {
        "\u0967": "1",
        "\u0968": "2",
        "\u0969": "3",
        "\u096a": "4",
        "\u096b": "5",
        "\u096c": "6",
        "\u096d": "7",
        "\u096e": "8",
        "\u096f": "9",
        "\u0966": "0"
    }, a = [
        /^\u091c\u0928/i,
        /^\u092b\u093c\u0930|\u092b\u0930/i,
        /^\u092e\u093e\u0930\u094d\u091a/i,
        /^\u0905\u092a\u094d\u0930\u0948/i,
        /^\u092e\u0908/i,
        /^\u091c\u0942\u0928/i,
        /^\u091c\u0941\u0932/i,
        /^\u0905\u0917/i,
        /^\u0938\u093f\u0924\u0902|\u0938\u093f\u0924/i,
        /^\u0905\u0915\u094d\u091f\u0942/i,
        /^\u0928\u0935|\u0928\u0935\u0902/i,
        /^\u0926\u093f\u0938\u0902|\u0926\u093f\u0938/i
    ];
    function xs(e, a, t) {
        var s = e + " ";
        switch(t){
            case "ss":
                return s += 1 === e ? "sekunda" : 2 === e || 3 === e || 4 === e ? "sekunde" : "sekundi";
            case "m":
                return a ? "jedna minuta" : "jedne minute";
            case "mm":
                return s += 1 !== e && (2 === e || 3 === e || 4 === e) ? "minute" : "minuta";
            case "h":
                return a ? "jedan sat" : "jednog sata";
            case "hh":
                return s += 1 === e ? "sat" : 2 === e || 3 === e || 4 === e ? "sata" : "sati";
            case "dd":
                return s += 1 === e ? "dan" : "dana";
            case "MM":
                return s += 1 === e ? "mjesec" : 2 === e || 3 === e || 4 === e ? "mjeseca" : "mjeseci";
            case "yy":
                return s += 1 !== e && (2 === e || 3 === e || 4 === e) ? "godine" : "godina";
        }
    }
    c.defineLocale("hi", {
        months: {
            format: "\u091c\u0928\u0935\u0930\u0940_\u092b\u093c\u0930\u0935\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u0948\u0932_\u092e\u0908_\u091c\u0942\u0928_\u091c\u0941\u0932\u093e\u0908_\u0905\u0917\u0938\u094d\u0924_\u0938\u093f\u0924\u092e\u094d\u092c\u0930_\u0905\u0915\u094d\u091f\u0942\u092c\u0930_\u0928\u0935\u092e\u094d\u092c\u0930_\u0926\u093f\u0938\u092e\u094d\u092c\u0930".split("_"),
            standalone: "\u091c\u0928\u0935\u0930\u0940_\u092b\u0930\u0935\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u0948\u0932_\u092e\u0908_\u091c\u0942\u0928_\u091c\u0941\u0932\u093e\u0908_\u0905\u0917\u0938\u094d\u0924_\u0938\u093f\u0924\u0902\u092c\u0930_\u0905\u0915\u094d\u091f\u0942\u092c\u0930_\u0928\u0935\u0902\u092c\u0930_\u0926\u093f\u0938\u0902\u092c\u0930".split("_")
        },
        monthsShort: "\u091c\u0928._\u092b\u093c\u0930._\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u0948._\u092e\u0908_\u091c\u0942\u0928_\u091c\u0941\u0932._\u0905\u0917._\u0938\u093f\u0924._\u0905\u0915\u094d\u091f\u0942._\u0928\u0935._\u0926\u093f\u0938.".split("_"),
        weekdays: "\u0930\u0935\u093f\u0935\u093e\u0930_\u0938\u094b\u092e\u0935\u093e\u0930_\u092e\u0902\u0917\u0932\u0935\u093e\u0930_\u092c\u0941\u0927\u0935\u093e\u0930_\u0917\u0941\u0930\u0942\u0935\u093e\u0930_\u0936\u0941\u0915\u094d\u0930\u0935\u093e\u0930_\u0936\u0928\u093f\u0935\u093e\u0930".split("_"),
        weekdaysShort: "\u0930\u0935\u093f_\u0938\u094b\u092e_\u092e\u0902\u0917\u0932_\u092c\u0941\u0927_\u0917\u0941\u0930\u0942_\u0936\u0941\u0915\u094d\u0930_\u0936\u0928\u093f".split("_"),
        weekdaysMin: "\u0930_\u0938\u094b_\u092e\u0902_\u092c\u0941_\u0917\u0941_\u0936\u0941_\u0936".split("_"),
        longDateFormat: {
            LT: "A h:mm \u092c\u091c\u0947",
            LTS: "A h:mm:ss \u092c\u091c\u0947",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm \u092c\u091c\u0947",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u092c\u091c\u0947"
        },
        monthsParse: a,
        longMonthsParse: a,
        shortMonthsParse: [
            /^\u091c\u0928/i,
            /^\u092b\u093c\u0930/i,
            /^\u092e\u093e\u0930\u094d\u091a/i,
            /^\u0905\u092a\u094d\u0930\u0948/i,
            /^\u092e\u0908/i,
            /^\u091c\u0942\u0928/i,
            /^\u091c\u0941\u0932/i,
            /^\u0905\u0917/i,
            /^\u0938\u093f\u0924/i,
            /^\u0905\u0915\u094d\u091f\u0942/i,
            /^\u0928\u0935/i,
            /^\u0926\u093f\u0938/i
        ],
        monthsRegex: /^(\u091c\u0928\u0935\u0930\u0940|\u091c\u0928\.?|\u092b\u093c\u0930\u0935\u0930\u0940|\u092b\u0930\u0935\u0930\u0940|\u092b\u093c\u0930\.?|\u092e\u093e\u0930\u094d\u091a?|\u0905\u092a\u094d\u0930\u0948\u0932|\u0905\u092a\u094d\u0930\u0948\.?|\u092e\u0908?|\u091c\u0942\u0928?|\u091c\u0941\u0932\u093e\u0908|\u091c\u0941\u0932\.?|\u0905\u0917\u0938\u094d\u0924|\u0905\u0917\.?|\u0938\u093f\u0924\u092e\u094d\u092c\u0930|\u0938\u093f\u0924\u0902\u092c\u0930|\u0938\u093f\u0924\.?|\u0905\u0915\u094d\u091f\u0942\u092c\u0930|\u0905\u0915\u094d\u091f\u0942\.?|\u0928\u0935\u092e\u094d\u092c\u0930|\u0928\u0935\u0902\u092c\u0930|\u0928\u0935\.?|\u0926\u093f\u0938\u092e\u094d\u092c\u0930|\u0926\u093f\u0938\u0902\u092c\u0930|\u0926\u093f\u0938\.?)/i,
        monthsShortRegex: /^(\u091c\u0928\u0935\u0930\u0940|\u091c\u0928\.?|\u092b\u093c\u0930\u0935\u0930\u0940|\u092b\u0930\u0935\u0930\u0940|\u092b\u093c\u0930\.?|\u092e\u093e\u0930\u094d\u091a?|\u0905\u092a\u094d\u0930\u0948\u0932|\u0905\u092a\u094d\u0930\u0948\.?|\u092e\u0908?|\u091c\u0942\u0928?|\u091c\u0941\u0932\u093e\u0908|\u091c\u0941\u0932\.?|\u0905\u0917\u0938\u094d\u0924|\u0905\u0917\.?|\u0938\u093f\u0924\u092e\u094d\u092c\u0930|\u0938\u093f\u0924\u0902\u092c\u0930|\u0938\u093f\u0924\.?|\u0905\u0915\u094d\u091f\u0942\u092c\u0930|\u0905\u0915\u094d\u091f\u0942\.?|\u0928\u0935\u092e\u094d\u092c\u0930|\u0928\u0935\u0902\u092c\u0930|\u0928\u0935\.?|\u0926\u093f\u0938\u092e\u094d\u092c\u0930|\u0926\u093f\u0938\u0902\u092c\u0930|\u0926\u093f\u0938\.?)/i,
        monthsStrictRegex: /^(\u091c\u0928\u0935\u0930\u0940?|\u092b\u093c\u0930\u0935\u0930\u0940|\u092b\u0930\u0935\u0930\u0940?|\u092e\u093e\u0930\u094d\u091a?|\u0905\u092a\u094d\u0930\u0948\u0932?|\u092e\u0908?|\u091c\u0942\u0928?|\u091c\u0941\u0932\u093e\u0908?|\u0905\u0917\u0938\u094d\u0924?|\u0938\u093f\u0924\u092e\u094d\u092c\u0930|\u0938\u093f\u0924\u0902\u092c\u0930|\u0938\u093f\u0924?\.?|\u0905\u0915\u094d\u091f\u0942\u092c\u0930|\u0905\u0915\u094d\u091f\u0942\.?|\u0928\u0935\u092e\u094d\u092c\u0930|\u0928\u0935\u0902\u092c\u0930?|\u0926\u093f\u0938\u092e\u094d\u092c\u0930|\u0926\u093f\u0938\u0902\u092c\u0930?)/i,
        monthsShortStrictRegex: /^(\u091c\u0928\.?|\u092b\u093c\u0930\.?|\u092e\u093e\u0930\u094d\u091a?|\u0905\u092a\u094d\u0930\u0948\.?|\u092e\u0908?|\u091c\u0942\u0928?|\u091c\u0941\u0932\.?|\u0905\u0917\.?|\u0938\u093f\u0924\.?|\u0905\u0915\u094d\u091f\u0942\.?|\u0928\u0935\.?|\u0926\u093f\u0938\.?)/i,
        calendar: {
            sameDay: "[\u0906\u091c] LT",
            nextDay: "[\u0915\u0932] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0915\u0932] LT",
            lastWeek: "[\u092a\u093f\u091b\u0932\u0947] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u092e\u0947\u0902",
            past: "%s \u092a\u0939\u0932\u0947",
            s: "\u0915\u0941\u091b \u0939\u0940 \u0915\u094d\u0937\u0923",
            ss: "%d \u0938\u0947\u0915\u0902\u0921",
            m: "\u090f\u0915 \u092e\u093f\u0928\u091f",
            mm: "%d \u092e\u093f\u0928\u091f",
            h: "\u090f\u0915 \u0918\u0902\u091f\u093e",
            hh: "%d \u0918\u0902\u091f\u0947",
            d: "\u090f\u0915 \u0926\u093f\u0928",
            dd: "%d \u0926\u093f\u0928",
            M: "\u090f\u0915 \u092e\u0939\u0940\u0928\u0947",
            MM: "%d \u092e\u0939\u0940\u0928\u0947",
            y: "\u090f\u0915 \u0935\u0930\u094d\u0937",
            yy: "%d \u0935\u0930\u094d\u0937"
        },
        preparse: function(e) {
            return e.replace(/[\u0967\u0968\u0969\u096a\u096b\u096c\u096d\u096e\u096f\u0966]/g, function(e) {
                return js[e];
            });
        },
        postformat: function(e) {
            return e.replace(/\d/g, function(e) {
                return vs[e];
            });
        },
        meridiemParse: /\u0930\u093e\u0924|\u0938\u0941\u092c\u0939|\u0926\u094b\u092a\u0939\u0930|\u0936\u093e\u092e/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "\u0930\u093e\u0924" === a ? e < 4 ? e : e + 12 : "\u0938\u0941\u092c\u0939" === a ? e : "\u0926\u094b\u092a\u0939\u0930" === a ? 10 <= e ? e : e + 12 : "\u0936\u093e\u092e" === a ? e + 12 : void 0;
        },
        meridiem: function(e, a, t) {
            return e < 4 ? "\u0930\u093e\u0924" : e < 10 ? "\u0938\u0941\u092c\u0939" : e < 17 ? "\u0926\u094b\u092a\u0939\u0930" : e < 20 ? "\u0936\u093e\u092e" : "\u0930\u093e\u0924";
        },
        week: {
            dow: 0,
            doy: 6
        }
    }), c.defineLocale("hr", {
        months: {
            format: "sije\u010dnja_velja\u010de_o\u017eujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca".split("_"),
            standalone: "sije\u010danj_velja\u010da_o\u017eujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split("_")
        },
        monthsShort: "sij._velj._o\u017eu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split("_"),
        monthsParseExact: !0,
        weekdays: "nedjelja_ponedjeljak_utorak_srijeda_\u010detvrtak_petak_subota".split("_"),
        weekdaysShort: "ned._pon._uto._sri._\u010det._pet._sub.".split("_"),
        weekdaysMin: "ne_po_ut_sr_\u010de_pe_su".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "Do MMMM YYYY",
            LLL: "Do MMMM YYYY H:mm",
            LLLL: "dddd, Do MMMM YYYY H:mm"
        },
        calendar: {
            sameDay: "[danas u] LT",
            nextDay: "[sutra u] LT",
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[u] [nedjelju] [u] LT";
                    case 3:
                        return "[u] [srijedu] [u] LT";
                    case 6:
                        return "[u] [subotu] [u] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[u] dddd [u] LT";
                }
            },
            lastDay: "[ju\u010der u] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[pro\u0161lu] [nedjelju] [u] LT";
                    case 3:
                        return "[pro\u0161lu] [srijedu] [u] LT";
                    case 6:
                        return "[pro\u0161le] [subote] [u] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[pro\u0161li] dddd [u] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "za %s",
            past: "prije %s",
            s: "par sekundi",
            ss: xs,
            m: xs,
            mm: xs,
            h: xs,
            hh: xs,
            d: "dan",
            dd: xs,
            M: "mjesec",
            MM: xs,
            y: "godinu",
            yy: xs
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 7
        }
    });
    var Ps = "vas\xe1rnap h\xe9tf\u0151n kedden szerd\xe1n cs\xfct\xf6rt\xf6k\xf6n p\xe9nteken szombaton".split(" ");
    function Os(e, a, t, s) {
        var n = e;
        switch(t){
            case "s":
                return s || a ? "n\xe9h\xe1ny m\xe1sodperc" : "n\xe9h\xe1ny m\xe1sodperce";
            case "ss":
                return n + (s || a) ? " m\xe1sodperc" : " m\xe1sodperce";
            case "m":
                return "egy" + (s || a ? " perc" : " perce");
            case "mm":
                return n + (s || a ? " perc" : " perce");
            case "h":
                return "egy" + (s || a ? " \xf3ra" : " \xf3r\xe1ja");
            case "hh":
                return n + (s || a ? " \xf3ra" : " \xf3r\xe1ja");
            case "d":
                return "egy" + (s || a ? " nap" : " napja");
            case "dd":
                return n + (s || a ? " nap" : " napja");
            case "M":
                return "egy" + (s || a ? " h\xf3nap" : " h\xf3napja");
            case "MM":
                return n + (s || a ? " h\xf3nap" : " h\xf3napja");
            case "y":
                return "egy" + (s || a ? " \xe9v" : " \xe9ve");
            case "yy":
                return n + (s || a ? " \xe9v" : " \xe9ve");
        }
        return "";
    }
    function Ws(e) {
        return (e ? "" : "[m\xfalt] ") + "[" + Ps[this.day()] + "] LT[-kor]";
    }
    function As(e) {
        return e % 100 == 11 || e % 10 != 1;
    }
    function Es(e, a, t, s) {
        var n = e + " ";
        switch(t){
            case "s":
                return a || s ? "nokkrar sek\xfandur" : "nokkrum sek\xfandum";
            case "ss":
                return As(e) ? n + (a || s ? "sek\xfandur" : "sek\xfandum") : n + "sek\xfanda";
            case "m":
                return a ? "m\xedn\xfata" : "m\xedn\xfatu";
            case "mm":
                return As(e) ? n + (a || s ? "m\xedn\xfatur" : "m\xedn\xfatum") : a ? n + "m\xedn\xfata" : n + "m\xedn\xfatu";
            case "hh":
                return As(e) ? n + (a || s ? "klukkustundir" : "klukkustundum") : n + "klukkustund";
            case "d":
                return a ? "dagur" : s ? "dag" : "degi";
            case "dd":
                return As(e) ? a ? n + "dagar" : n + (s ? "daga" : "d\xf6gum") : a ? n + "dagur" : n + (s ? "dag" : "degi");
            case "M":
                return a ? "m\xe1nu\xf0ur" : s ? "m\xe1nu\xf0" : "m\xe1nu\xf0i";
            case "MM":
                return As(e) ? a ? n + "m\xe1nu\xf0ir" : n + (s ? "m\xe1nu\xf0i" : "m\xe1nu\xf0um") : a ? n + "m\xe1nu\xf0ur" : n + (s ? "m\xe1nu\xf0" : "m\xe1nu\xf0i");
            case "y":
                return a || s ? "\xe1r" : "\xe1ri";
            case "yy":
                return As(e) ? n + (a || s ? "\xe1r" : "\xe1rum") : n + (a || s ? "\xe1r" : "\xe1ri");
        }
    }
    c.defineLocale("hu", {
        months: "janu\xe1r_febru\xe1r_m\xe1rcius_\xe1prilis_m\xe1jus_j\xfanius_j\xfalius_augusztus_szeptember_okt\xf3ber_november_december".split("_"),
        monthsShort: "jan._feb._m\xe1rc._\xe1pr._m\xe1j._j\xfan._j\xfal._aug._szept._okt._nov._dec.".split("_"),
        monthsParseExact: !0,
        weekdays: "vas\xe1rnap_h\xe9tf\u0151_kedd_szerda_cs\xfct\xf6rt\xf6k_p\xe9ntek_szombat".split("_"),
        weekdaysShort: "vas_h\xe9t_kedd_sze_cs\xfct_p\xe9n_szo".split("_"),
        weekdaysMin: "v_h_k_sze_cs_p_szo".split("_"),
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "YYYY.MM.DD.",
            LL: "YYYY. MMMM D.",
            LLL: "YYYY. MMMM D. H:mm",
            LLLL: "YYYY. MMMM D., dddd H:mm"
        },
        meridiemParse: /de|du/i,
        isPM: function(e) {
            return "u" === e.charAt(1).toLowerCase();
        },
        meridiem: function(e, a, t) {
            return e < 12 ? !0 === t ? "de" : "DE" : !0 === t ? "du" : "DU";
        },
        calendar: {
            sameDay: "[ma] LT[-kor]",
            nextDay: "[holnap] LT[-kor]",
            nextWeek: function() {
                return Ws.call(this, !0);
            },
            lastDay: "[tegnap] LT[-kor]",
            lastWeek: function() {
                return Ws.call(this, !1);
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "%s m\xfalva",
            past: "%s",
            s: Os,
            ss: Os,
            m: Os,
            mm: Os,
            h: Os,
            hh: Os,
            d: Os,
            dd: Os,
            M: Os,
            MM: Os,
            y: Os,
            yy: Os
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("hy-am", {
        months: {
            format: "\u0570\u0578\u0582\u0576\u057e\u0561\u0580\u056b_\u0583\u0565\u057f\u0580\u057e\u0561\u0580\u056b_\u0574\u0561\u0580\u057f\u056b_\u0561\u057a\u0580\u056b\u056c\u056b_\u0574\u0561\u0575\u056b\u057d\u056b_\u0570\u0578\u0582\u0576\u056b\u057d\u056b_\u0570\u0578\u0582\u056c\u056b\u057d\u056b_\u0585\u0563\u0578\u057d\u057f\u0578\u057d\u056b_\u057d\u0565\u057a\u057f\u0565\u0574\u0562\u0565\u0580\u056b_\u0570\u0578\u056f\u057f\u0565\u0574\u0562\u0565\u0580\u056b_\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580\u056b_\u0564\u0565\u056f\u057f\u0565\u0574\u0562\u0565\u0580\u056b".split("_"),
            standalone: "\u0570\u0578\u0582\u0576\u057e\u0561\u0580_\u0583\u0565\u057f\u0580\u057e\u0561\u0580_\u0574\u0561\u0580\u057f_\u0561\u057a\u0580\u056b\u056c_\u0574\u0561\u0575\u056b\u057d_\u0570\u0578\u0582\u0576\u056b\u057d_\u0570\u0578\u0582\u056c\u056b\u057d_\u0585\u0563\u0578\u057d\u057f\u0578\u057d_\u057d\u0565\u057a\u057f\u0565\u0574\u0562\u0565\u0580_\u0570\u0578\u056f\u057f\u0565\u0574\u0562\u0565\u0580_\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580_\u0564\u0565\u056f\u057f\u0565\u0574\u0562\u0565\u0580".split("_")
        },
        monthsShort: "\u0570\u0576\u057e_\u0583\u057f\u0580_\u0574\u0580\u057f_\u0561\u057a\u0580_\u0574\u0575\u057d_\u0570\u0576\u057d_\u0570\u056c\u057d_\u0585\u0563\u057d_\u057d\u057a\u057f_\u0570\u056f\u057f_\u0576\u0574\u0562_\u0564\u056f\u057f".split("_"),
        weekdays: "\u056f\u056b\u0580\u0561\u056f\u056b_\u0565\u0580\u056f\u0578\u0582\u0577\u0561\u0562\u0569\u056b_\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056b_\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056b_\u0570\u056b\u0576\u0563\u0577\u0561\u0562\u0569\u056b_\u0578\u0582\u0580\u0562\u0561\u0569_\u0577\u0561\u0562\u0561\u0569".split("_"),
        weekdaysShort: "\u056f\u0580\u056f_\u0565\u0580\u056f_\u0565\u0580\u0584_\u0579\u0580\u0584_\u0570\u0576\u0563_\u0578\u0582\u0580\u0562_\u0577\u0562\u0569".split("_"),
        weekdaysMin: "\u056f\u0580\u056f_\u0565\u0580\u056f_\u0565\u0580\u0584_\u0579\u0580\u0584_\u0570\u0576\u0563_\u0578\u0582\u0580\u0562_\u0577\u0562\u0569".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY \u0569.",
            LLL: "D MMMM YYYY \u0569., HH:mm",
            LLLL: "dddd, D MMMM YYYY \u0569., HH:mm"
        },
        calendar: {
            sameDay: "[\u0561\u0575\u057d\u0585\u0580] LT",
            nextDay: "[\u057e\u0561\u0572\u0568] LT",
            lastDay: "[\u0565\u0580\u0565\u056f] LT",
            nextWeek: function() {
                return "dddd [\u0585\u0580\u0568 \u056a\u0561\u0574\u0568] LT";
            },
            lastWeek: function() {
                return "[\u0561\u0576\u0581\u0561\u056e] dddd [\u0585\u0580\u0568 \u056a\u0561\u0574\u0568] LT";
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0570\u0565\u057f\u0578",
            past: "%s \u0561\u057c\u0561\u057b",
            s: "\u0574\u056b \u0584\u0561\u0576\u056b \u057e\u0561\u0575\u0580\u056f\u0575\u0561\u0576",
            ss: "%d \u057e\u0561\u0575\u0580\u056f\u0575\u0561\u0576",
            m: "\u0580\u0578\u057a\u0565",
            mm: "%d \u0580\u0578\u057a\u0565",
            h: "\u056a\u0561\u0574",
            hh: "%d \u056a\u0561\u0574",
            d: "\u0585\u0580",
            dd: "%d \u0585\u0580",
            M: "\u0561\u0574\u056b\u057d",
            MM: "%d \u0561\u0574\u056b\u057d",
            y: "\u057f\u0561\u0580\u056b",
            yy: "%d \u057f\u0561\u0580\u056b"
        },
        meridiemParse: /\u0563\u056b\u0577\u0565\u0580\u057e\u0561|\u0561\u057c\u0561\u057e\u0578\u057f\u057e\u0561|\u0581\u0565\u0580\u0565\u056f\u057e\u0561|\u0565\u0580\u0565\u056f\u0578\u0575\u0561\u0576/,
        isPM: function(e) {
            return /^(\u0581\u0565\u0580\u0565\u056f\u057e\u0561|\u0565\u0580\u0565\u056f\u0578\u0575\u0561\u0576)$/.test(e);
        },
        meridiem: function(e) {
            return e < 4 ? "\u0563\u056b\u0577\u0565\u0580\u057e\u0561" : e < 12 ? "\u0561\u057c\u0561\u057e\u0578\u057f\u057e\u0561" : e < 17 ? "\u0581\u0565\u0580\u0565\u056f\u057e\u0561" : "\u0565\u0580\u0565\u056f\u0578\u0575\u0561\u0576";
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(\u056b\u0576|\u0580\u0564)/,
        ordinal: function(e, a) {
            switch(a){
                case "DDD":
                case "w":
                case "W":
                case "DDDo":
                    return 1 === e ? e + "-\u056b\u0576" : e + "-\u0580\u0564";
                default:
                    return e;
            }
        },
        week: {
            dow: 1,
            doy: 7
        }
    }), c.defineLocale("id", {
        months: "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des".split("_"),
        weekdays: "Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),
        weekdaysShort: "Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),
        weekdaysMin: "Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),
        longDateFormat: {
            LT: "HH.mm",
            LTS: "HH.mm.ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY [pukul] HH.mm",
            LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "pagi" === a ? e : "siang" === a ? 11 <= e ? e : e + 12 : "sore" === a || "malam" === a ? e + 12 : void 0;
        },
        meridiem: function(e, a, t) {
            return e < 11 ? "pagi" : e < 15 ? "siang" : e < 19 ? "sore" : "malam";
        },
        calendar: {
            sameDay: "[Hari ini pukul] LT",
            nextDay: "[Besok pukul] LT",
            nextWeek: "dddd [pukul] LT",
            lastDay: "[Kemarin pukul] LT",
            lastWeek: "dddd [lalu pukul] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "dalam %s",
            past: "%s yang lalu",
            s: "beberapa detik",
            ss: "%d detik",
            m: "semenit",
            mm: "%d menit",
            h: "sejam",
            hh: "%d jam",
            d: "sehari",
            dd: "%d hari",
            M: "sebulan",
            MM: "%d bulan",
            y: "setahun",
            yy: "%d tahun"
        },
        week: {
            dow: 0,
            doy: 6
        }
    }), c.defineLocale("is", {
        months: "jan\xfaar_febr\xfaar_mars_apr\xedl_ma\xed_j\xfan\xed_j\xfal\xed_\xe1g\xfast_september_okt\xf3ber_n\xf3vember_desember".split("_"),
        monthsShort: "jan_feb_mar_apr_ma\xed_j\xfan_j\xfal_\xe1g\xfa_sep_okt_n\xf3v_des".split("_"),
        weekdays: "sunnudagur_m\xe1nudagur_\xferi\xf0judagur_mi\xf0vikudagur_fimmtudagur_f\xf6studagur_laugardagur".split("_"),
        weekdaysShort: "sun_m\xe1n_\xferi_mi\xf0_fim_f\xf6s_lau".split("_"),
        weekdaysMin: "Su_M\xe1_\xder_Mi_Fi_F\xf6_La".split("_"),
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY [kl.] H:mm",
            LLLL: "dddd, D. MMMM YYYY [kl.] H:mm"
        },
        calendar: {
            sameDay: "[\xed dag kl.] LT",
            nextDay: "[\xe1 morgun kl.] LT",
            nextWeek: "dddd [kl.] LT",
            lastDay: "[\xed g\xe6r kl.] LT",
            lastWeek: "[s\xed\xf0asta] dddd [kl.] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "eftir %s",
            past: "fyrir %s s\xed\xf0an",
            s: Es,
            ss: Es,
            m: Es,
            mm: Es,
            h: "klukkustund",
            hh: Es,
            d: Es,
            dd: Es,
            M: Es,
            MM: Es,
            y: Es,
            yy: Es
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("it-ch", {
        months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
        monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
        weekdays: "domenica_luned\xec_marted\xec_mercoled\xec_gioved\xec_venerd\xec_sabato".split("_"),
        weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
        weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Oggi alle] LT",
            nextDay: "[Domani alle] LT",
            nextWeek: "dddd [alle] LT",
            lastDay: "[Ieri alle] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[la scorsa] dddd [alle] LT";
                    default:
                        return "[lo scorso] dddd [alle] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: function(e) {
                return (/^[0-9].+$/.test(e) ? "tra" : "in") + " " + e;
            },
            past: "%s fa",
            s: "alcuni secondi",
            ss: "%d secondi",
            m: "un minuto",
            mm: "%d minuti",
            h: "un'ora",
            hh: "%d ore",
            d: "un giorno",
            dd: "%d giorni",
            M: "un mese",
            MM: "%d mesi",
            y: "un anno",
            yy: "%d anni"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\xba/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("it", {
        months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
        monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
        weekdays: "domenica_luned\xec_marted\xec_mercoled\xec_gioved\xec_venerd\xec_sabato".split("_"),
        weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
        weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: function() {
                return "[Oggi a" + (1 < this.hours() ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
            },
            nextDay: function() {
                return "[Domani a" + (1 < this.hours() ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
            },
            nextWeek: function() {
                return "dddd [a" + (1 < this.hours() ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
            },
            lastDay: function() {
                return "[Ieri a" + (1 < this.hours() ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
            },
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[La scorsa] dddd [a" + (1 < this.hours() ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
                    default:
                        return "[Lo scorso] dddd [a" + (1 < this.hours() ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "tra %s",
            past: "%s fa",
            s: "alcuni secondi",
            ss: "%d secondi",
            m: "un minuto",
            mm: "%d minuti",
            h: "un'ora",
            hh: "%d ore",
            d: "un giorno",
            dd: "%d giorni",
            w: "una settimana",
            ww: "%d settimane",
            M: "un mese",
            MM: "%d mesi",
            y: "un anno",
            yy: "%d anni"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\xba/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("ja", {
        eras: [
            {
                since: "2019-05-01",
                offset: 1,
                name: "\u4ee4\u548c",
                narrow: "\u32ff",
                abbr: "R"
            },
            {
                since: "1989-01-08",
                until: "2019-04-30",
                offset: 1,
                name: "\u5e73\u6210",
                narrow: "\u337b",
                abbr: "H"
            },
            {
                since: "1926-12-25",
                until: "1989-01-07",
                offset: 1,
                name: "\u662d\u548c",
                narrow: "\u337c",
                abbr: "S"
            },
            {
                since: "1912-07-30",
                until: "1926-12-24",
                offset: 1,
                name: "\u5927\u6b63",
                narrow: "\u337d",
                abbr: "T"
            },
            {
                since: "1873-01-01",
                until: "1912-07-29",
                offset: 6,
                name: "\u660e\u6cbb",
                narrow: "\u337e",
                abbr: "M"
            },
            {
                since: "0001-01-01",
                until: "1873-12-31",
                offset: 1,
                name: "\u897f\u66a6",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -1 / 0,
                offset: 1,
                name: "\u7d00\u5143\u524d",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        eraYearOrdinalRegex: /(\u5143|\d+)\u5e74/,
        eraYearOrdinalParse: function(e, a) {
            return "\u5143" === a[1] ? 1 : parseInt(a[1] || e, 10);
        },
        months: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),
        monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),
        weekdays: "\u65e5\u66dc\u65e5_\u6708\u66dc\u65e5_\u706b\u66dc\u65e5_\u6c34\u66dc\u65e5_\u6728\u66dc\u65e5_\u91d1\u66dc\u65e5_\u571f\u66dc\u65e5".split("_"),
        weekdaysShort: "\u65e5_\u6708_\u706b_\u6c34_\u6728_\u91d1_\u571f".split("_"),
        weekdaysMin: "\u65e5_\u6708_\u706b_\u6c34_\u6728_\u91d1_\u571f".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY/MM/DD",
            LL: "YYYY\u5e74M\u6708D\u65e5",
            LLL: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
            LLLL: "YYYY\u5e74M\u6708D\u65e5 dddd HH:mm",
            l: "YYYY/MM/DD",
            ll: "YYYY\u5e74M\u6708D\u65e5",
            lll: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
            llll: "YYYY\u5e74M\u6708D\u65e5(ddd) HH:mm"
        },
        meridiemParse: /\u5348\u524d|\u5348\u5f8c/i,
        isPM: function(e) {
            return "\u5348\u5f8c" === e;
        },
        meridiem: function(e, a, t) {
            return e < 12 ? "\u5348\u524d" : "\u5348\u5f8c";
        },
        calendar: {
            sameDay: "[\u4eca\u65e5] LT",
            nextDay: "[\u660e\u65e5] LT",
            nextWeek: function(e) {
                return e.week() !== this.week() ? "[\u6765\u9031]dddd LT" : "dddd LT";
            },
            lastDay: "[\u6628\u65e5] LT",
            lastWeek: function(e) {
                return this.week() !== e.week() ? "[\u5148\u9031]dddd LT" : "dddd LT";
            },
            sameElse: "L"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\u65e5/,
        ordinal: function(e, a) {
            switch(a){
                case "y":
                    return 1 === e ? "\u5143\u5e74" : e + "\u5e74";
                case "d":
                case "D":
                case "DDD":
                    return e + "\u65e5";
                default:
                    return e;
            }
        },
        relativeTime: {
            future: "%s\u5f8c",
            past: "%s\u524d",
            s: "\u6570\u79d2",
            ss: "%d\u79d2",
            m: "1\u5206",
            mm: "%d\u5206",
            h: "1\u6642\u9593",
            hh: "%d\u6642\u9593",
            d: "1\u65e5",
            dd: "%d\u65e5",
            M: "1\u30f6\u6708",
            MM: "%d\u30f6\u6708",
            y: "1\u5e74",
            yy: "%d\u5e74"
        }
    }), c.defineLocale("jv", {
        months: "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des".split("_"),
        weekdays: "Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu".split("_"),
        weekdaysShort: "Min_Sen_Sel_Reb_Kem_Jem_Sep".split("_"),
        weekdaysMin: "Mg_Sn_Sl_Rb_Km_Jm_Sp".split("_"),
        longDateFormat: {
            LT: "HH.mm",
            LTS: "HH.mm.ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY [pukul] HH.mm",
            LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "enjing" === a ? e : "siyang" === a ? 11 <= e ? e : e + 12 : "sonten" === a || "ndalu" === a ? e + 12 : void 0;
        },
        meridiem: function(e, a, t) {
            return e < 11 ? "enjing" : e < 15 ? "siyang" : e < 19 ? "sonten" : "ndalu";
        },
        calendar: {
            sameDay: "[Dinten puniko pukul] LT",
            nextDay: "[Mbenjang pukul] LT",
            nextWeek: "dddd [pukul] LT",
            lastDay: "[Kala wingi pukul] LT",
            lastWeek: "dddd [kepengker pukul] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "wonten ing %s",
            past: "%s ingkang kepengker",
            s: "sawetawis detik",
            ss: "%d detik",
            m: "setunggal menit",
            mm: "%d menit",
            h: "setunggal jam",
            hh: "%d jam",
            d: "sedinten",
            dd: "%d dinten",
            M: "sewulan",
            MM: "%d wulan",
            y: "setaun",
            yy: "%d taun"
        },
        week: {
            dow: 1,
            doy: 7
        }
    }), c.defineLocale("ka", {
        months: "\u10d8\u10d0\u10dc\u10d5\u10d0\u10e0\u10d8_\u10d7\u10d4\u10d1\u10d4\u10e0\u10d5\u10d0\u10da\u10d8_\u10db\u10d0\u10e0\u10e2\u10d8_\u10d0\u10de\u10e0\u10d8\u10da\u10d8_\u10db\u10d0\u10d8\u10e1\u10d8_\u10d8\u10d5\u10dc\u10d8\u10e1\u10d8_\u10d8\u10d5\u10da\u10d8\u10e1\u10d8_\u10d0\u10d2\u10d5\u10d8\u10e1\u10e2\u10dd_\u10e1\u10d4\u10e5\u10e2\u10d4\u10db\u10d1\u10d4\u10e0\u10d8_\u10dd\u10e5\u10e2\u10dd\u10db\u10d1\u10d4\u10e0\u10d8_\u10dc\u10dd\u10d4\u10db\u10d1\u10d4\u10e0\u10d8_\u10d3\u10d4\u10d9\u10d4\u10db\u10d1\u10d4\u10e0\u10d8".split("_"),
        monthsShort: "\u10d8\u10d0\u10dc_\u10d7\u10d4\u10d1_\u10db\u10d0\u10e0_\u10d0\u10de\u10e0_\u10db\u10d0\u10d8_\u10d8\u10d5\u10dc_\u10d8\u10d5\u10da_\u10d0\u10d2\u10d5_\u10e1\u10d4\u10e5_\u10dd\u10e5\u10e2_\u10dc\u10dd\u10d4_\u10d3\u10d4\u10d9".split("_"),
        weekdays: {
            standalone: "\u10d9\u10d5\u10d8\u10e0\u10d0_\u10dd\u10e0\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10e1\u10d0\u10db\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10dd\u10d7\u10ee\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10ee\u10e3\u10d7\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10de\u10d0\u10e0\u10d0\u10e1\u10d9\u10d4\u10d5\u10d8_\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8".split("_"),
            format: "\u10d9\u10d5\u10d8\u10e0\u10d0\u10e1_\u10dd\u10e0\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10e1\u10d0\u10db\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10dd\u10d7\u10ee\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10ee\u10e3\u10d7\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10de\u10d0\u10e0\u10d0\u10e1\u10d9\u10d4\u10d5\u10e1_\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1".split("_"),
            isFormat: /(\u10ec\u10d8\u10dc\u10d0|\u10e8\u10d4\u10db\u10d3\u10d4\u10d2)/
        },
        weekdaysShort: "\u10d9\u10d5\u10d8_\u10dd\u10e0\u10e8_\u10e1\u10d0\u10db_\u10dd\u10d7\u10ee_\u10ee\u10e3\u10d7_\u10de\u10d0\u10e0_\u10e8\u10d0\u10d1".split("_"),
        weekdaysMin: "\u10d9\u10d5_\u10dd\u10e0_\u10e1\u10d0_\u10dd\u10d7_\u10ee\u10e3_\u10de\u10d0_\u10e8\u10d0".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\u10d3\u10e6\u10d4\u10e1] LT[-\u10d6\u10d4]",
            nextDay: "[\u10ee\u10d5\u10d0\u10da] LT[-\u10d6\u10d4]",
            lastDay: "[\u10d2\u10e3\u10e8\u10d8\u10dc] LT[-\u10d6\u10d4]",
            nextWeek: "[\u10e8\u10d4\u10db\u10d3\u10d4\u10d2] dddd LT[-\u10d6\u10d4]",
            lastWeek: "[\u10ec\u10d8\u10dc\u10d0] dddd LT-\u10d6\u10d4",
            sameElse: "L"
        },
        relativeTime: {
            future: function(e) {
                return e.replace(/(\u10ec\u10d0\u10db|\u10ec\u10e3\u10d7|\u10e1\u10d0\u10d0\u10d7|\u10ec\u10d4\u10da|\u10d3\u10e6|\u10d7\u10d5)(\u10d8|\u10d4)/, function(e, a, t) {
                    return "\u10d8" === t ? a + "\u10e8\u10d8" : a + t + "\u10e8\u10d8";
                });
            },
            past: function(e) {
                return /(\u10ec\u10d0\u10db\u10d8|\u10ec\u10e3\u10d7\u10d8|\u10e1\u10d0\u10d0\u10d7\u10d8|\u10d3\u10e6\u10d4|\u10d7\u10d5\u10d4)/.test(e) ? e.replace(/(\u10d8|\u10d4)$/, "\u10d8\u10e1 \u10ec\u10d8\u10dc") : /\u10ec\u10d4\u10da\u10d8/.test(e) ? e.replace(/\u10ec\u10d4\u10da\u10d8$/, "\u10ec\u10da\u10d8\u10e1 \u10ec\u10d8\u10dc") : e;
            },
            s: "\u10e0\u10d0\u10db\u10d3\u10d4\u10dc\u10d8\u10db\u10d4 \u10ec\u10d0\u10db\u10d8",
            ss: "%d \u10ec\u10d0\u10db\u10d8",
            m: "\u10ec\u10e3\u10d7\u10d8",
            mm: "%d \u10ec\u10e3\u10d7\u10d8",
            h: "\u10e1\u10d0\u10d0\u10d7\u10d8",
            hh: "%d \u10e1\u10d0\u10d0\u10d7\u10d8",
            d: "\u10d3\u10e6\u10d4",
            dd: "%d \u10d3\u10e6\u10d4",
            M: "\u10d7\u10d5\u10d4",
            MM: "%d \u10d7\u10d5\u10d4",
            y: "\u10ec\u10d4\u10da\u10d8",
            yy: "%d \u10ec\u10d4\u10da\u10d8"
        },
        dayOfMonthOrdinalParse: /0|1-\u10da\u10d8|\u10db\u10d4-\d{1,2}|\d{1,2}-\u10d4/,
        ordinal: function(e) {
            return 0 === e ? e : 1 === e ? e + "-\u10da\u10d8" : e < 20 || e <= 100 && e % 20 == 0 || e % 100 == 0 ? "\u10db\u10d4-" + e : e + "-\u10d4";
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    var Fs = {
        0: "-\u0448\u0456",
        1: "-\u0448\u0456",
        2: "-\u0448\u0456",
        3: "-\u0448\u0456",
        4: "-\u0448\u0456",
        5: "-\u0448\u0456",
        6: "-\u0448\u044b",
        7: "-\u0448\u0456",
        8: "-\u0448\u0456",
        9: "-\u0448\u044b",
        10: "-\u0448\u044b",
        20: "-\u0448\u044b",
        30: "-\u0448\u044b",
        40: "-\u0448\u044b",
        50: "-\u0448\u0456",
        60: "-\u0448\u044b",
        70: "-\u0448\u0456",
        80: "-\u0448\u0456",
        90: "-\u0448\u044b",
        100: "-\u0448\u0456"
    }, zs = (c.defineLocale("kk", {
        months: "\u049b\u0430\u04a3\u0442\u0430\u0440_\u0430\u049b\u043f\u0430\u043d_\u043d\u0430\u0443\u0440\u044b\u0437_\u0441\u04d9\u0443\u0456\u0440_\u043c\u0430\u043c\u044b\u0440_\u043c\u0430\u0443\u0441\u044b\u043c_\u0448\u0456\u043b\u0434\u0435_\u0442\u0430\u043c\u044b\u0437_\u049b\u044b\u0440\u043a\u04af\u0439\u0435\u043a_\u049b\u0430\u0437\u0430\u043d_\u049b\u0430\u0440\u0430\u0448\u0430_\u0436\u0435\u043b\u0442\u043e\u049b\u0441\u0430\u043d".split("_"),
        monthsShort: "\u049b\u0430\u04a3_\u0430\u049b\u043f_\u043d\u0430\u0443_\u0441\u04d9\u0443_\u043c\u0430\u043c_\u043c\u0430\u0443_\u0448\u0456\u043b_\u0442\u0430\u043c_\u049b\u044b\u0440_\u049b\u0430\u0437_\u049b\u0430\u0440_\u0436\u0435\u043b".split("_"),
        weekdays: "\u0436\u0435\u043a\u0441\u0435\u043d\u0431\u0456_\u0434\u04af\u0439\u0441\u0435\u043d\u0431\u0456_\u0441\u0435\u0439\u0441\u0435\u043d\u0431\u0456_\u0441\u04d9\u0440\u0441\u0435\u043d\u0431\u0456_\u0431\u0435\u0439\u0441\u0435\u043d\u0431\u0456_\u0436\u04b1\u043c\u0430_\u0441\u0435\u043d\u0431\u0456".split("_"),
        weekdaysShort: "\u0436\u0435\u043a_\u0434\u04af\u0439_\u0441\u0435\u0439_\u0441\u04d9\u0440_\u0431\u0435\u0439_\u0436\u04b1\u043c_\u0441\u0435\u043d".split("_"),
        weekdaysMin: "\u0436\u043a_\u0434\u0439_\u0441\u0439_\u0441\u0440_\u0431\u0439_\u0436\u043c_\u0441\u043d".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\u0411\u04af\u0433\u0456\u043d \u0441\u0430\u0493\u0430\u0442] LT",
            nextDay: "[\u0415\u0440\u0442\u0435\u04a3 \u0441\u0430\u0493\u0430\u0442] LT",
            nextWeek: "dddd [\u0441\u0430\u0493\u0430\u0442] LT",
            lastDay: "[\u041a\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442] LT",
            lastWeek: "[\u04e8\u0442\u043a\u0435\u043d \u0430\u043f\u0442\u0430\u043d\u044b\u04a3] dddd [\u0441\u0430\u0493\u0430\u0442] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0456\u0448\u0456\u043d\u0434\u0435",
            past: "%s \u0431\u04b1\u0440\u044b\u043d",
            s: "\u0431\u0456\u0440\u043d\u0435\u0448\u0435 \u0441\u0435\u043a\u0443\u043d\u0434",
            ss: "%d \u0441\u0435\u043a\u0443\u043d\u0434",
            m: "\u0431\u0456\u0440 \u043c\u0438\u043d\u0443\u0442",
            mm: "%d \u043c\u0438\u043d\u0443\u0442",
            h: "\u0431\u0456\u0440 \u0441\u0430\u0493\u0430\u0442",
            hh: "%d \u0441\u0430\u0493\u0430\u0442",
            d: "\u0431\u0456\u0440 \u043a\u04af\u043d",
            dd: "%d \u043a\u04af\u043d",
            M: "\u0431\u0456\u0440 \u0430\u0439",
            MM: "%d \u0430\u0439",
            y: "\u0431\u0456\u0440 \u0436\u044b\u043b",
            yy: "%d \u0436\u044b\u043b"
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(\u0448\u0456|\u0448\u044b)/,
        ordinal: function(e) {
            return e + (Fs[e] || Fs[e % 10] || Fs[100 <= e ? 100 : null]);
        },
        week: {
            dow: 1,
            doy: 7
        }
    }), {
        1: "\u17e1",
        2: "\u17e2",
        3: "\u17e3",
        4: "\u17e4",
        5: "\u17e5",
        6: "\u17e6",
        7: "\u17e7",
        8: "\u17e8",
        9: "\u17e9",
        0: "\u17e0"
    }), Ns = {
        "\u17e1": "1",
        "\u17e2": "2",
        "\u17e3": "3",
        "\u17e4": "4",
        "\u17e5": "5",
        "\u17e6": "6",
        "\u17e7": "7",
        "\u17e8": "8",
        "\u17e9": "9",
        "\u17e0": "0"
    }, Js = (c.defineLocale("km", {
        months: "\u1798\u1780\u179a\u17b6_\u1780\u17bb\u1798\u17d2\u1797\u17c8_\u1798\u17b8\u1793\u17b6_\u1798\u17c1\u179f\u17b6_\u17a7\u179f\u1797\u17b6_\u1798\u17b7\u1790\u17bb\u1793\u17b6_\u1780\u1780\u17d2\u1780\u178a\u17b6_\u179f\u17b8\u17a0\u17b6_\u1780\u1789\u17d2\u1789\u17b6_\u178f\u17bb\u179b\u17b6_\u179c\u17b7\u1785\u17d2\u1786\u17b7\u1780\u17b6_\u1792\u17d2\u1793\u17bc".split("_"),
        monthsShort: "\u1798\u1780\u179a\u17b6_\u1780\u17bb\u1798\u17d2\u1797\u17c8_\u1798\u17b8\u1793\u17b6_\u1798\u17c1\u179f\u17b6_\u17a7\u179f\u1797\u17b6_\u1798\u17b7\u1790\u17bb\u1793\u17b6_\u1780\u1780\u17d2\u1780\u178a\u17b6_\u179f\u17b8\u17a0\u17b6_\u1780\u1789\u17d2\u1789\u17b6_\u178f\u17bb\u179b\u17b6_\u179c\u17b7\u1785\u17d2\u1786\u17b7\u1780\u17b6_\u1792\u17d2\u1793\u17bc".split("_"),
        weekdays: "\u17a2\u17b6\u1791\u17b7\u178f\u17d2\u1799_\u1785\u17d0\u1793\u17d2\u1791_\u17a2\u1784\u17d2\u1782\u17b6\u179a_\u1796\u17bb\u1792_\u1796\u17d2\u179a\u17a0\u179f\u17d2\u1794\u178f\u17b7\u17cd_\u179f\u17bb\u1780\u17d2\u179a_\u179f\u17c5\u179a\u17cd".split("_"),
        weekdaysShort: "\u17a2\u17b6_\u1785_\u17a2_\u1796_\u1796\u17d2\u179a_\u179f\u17bb_\u179f".split("_"),
        weekdaysMin: "\u17a2\u17b6_\u1785_\u17a2_\u1796_\u1796\u17d2\u179a_\u179f\u17bb_\u179f".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        meridiemParse: /\u1796\u17d2\u179a\u17b9\u1780|\u179b\u17d2\u1784\u17b6\u1785/,
        isPM: function(e) {
            return "\u179b\u17d2\u1784\u17b6\u1785" === e;
        },
        meridiem: function(e, a, t) {
            return e < 12 ? "\u1796\u17d2\u179a\u17b9\u1780" : "\u179b\u17d2\u1784\u17b6\u1785";
        },
        calendar: {
            sameDay: "[\u1790\u17d2\u1784\u17c3\u1793\u17c1\u17c7 \u1798\u17c9\u17c4\u1784] LT",
            nextDay: "[\u179f\u17d2\u17a2\u17c2\u1780 \u1798\u17c9\u17c4\u1784] LT",
            nextWeek: "dddd [\u1798\u17c9\u17c4\u1784] LT",
            lastDay: "[\u1798\u17d2\u179f\u17b7\u179b\u1798\u17b7\u1789 \u1798\u17c9\u17c4\u1784] LT",
            lastWeek: "dddd [\u179f\u1794\u17d2\u178f\u17b6\u17a0\u17cd\u1798\u17bb\u1793] [\u1798\u17c9\u17c4\u1784] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s\u1791\u17c0\u178f",
            past: "%s\u1798\u17bb\u1793",
            s: "\u1794\u17c9\u17bb\u1793\u17d2\u1798\u17b6\u1793\u179c\u17b7\u1793\u17b6\u1791\u17b8",
            ss: "%d \u179c\u17b7\u1793\u17b6\u1791\u17b8",
            m: "\u1798\u17bd\u1799\u1793\u17b6\u1791\u17b8",
            mm: "%d \u1793\u17b6\u1791\u17b8",
            h: "\u1798\u17bd\u1799\u1798\u17c9\u17c4\u1784",
            hh: "%d \u1798\u17c9\u17c4\u1784",
            d: "\u1798\u17bd\u1799\u1790\u17d2\u1784\u17c3",
            dd: "%d \u1790\u17d2\u1784\u17c3",
            M: "\u1798\u17bd\u1799\u1781\u17c2",
            MM: "%d \u1781\u17c2",
            y: "\u1798\u17bd\u1799\u1786\u17d2\u1793\u17b6\u17c6",
            yy: "%d \u1786\u17d2\u1793\u17b6\u17c6"
        },
        dayOfMonthOrdinalParse: /\u1791\u17b8\d{1,2}/,
        ordinal: "\u1791\u17b8%d",
        preparse: function(e) {
            return e.replace(/[\u17e1\u17e2\u17e3\u17e4\u17e5\u17e6\u17e7\u17e8\u17e9\u17e0]/g, function(e) {
                return Ns[e];
            });
        },
        postformat: function(e) {
            return e.replace(/\d/g, function(e) {
                return zs[e];
            });
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), {
        1: "\u0ce7",
        2: "\u0ce8",
        3: "\u0ce9",
        4: "\u0cea",
        5: "\u0ceb",
        6: "\u0cec",
        7: "\u0ced",
        8: "\u0cee",
        9: "\u0cef",
        0: "\u0ce6"
    }), Rs = {
        "\u0ce7": "1",
        "\u0ce8": "2",
        "\u0ce9": "3",
        "\u0cea": "4",
        "\u0ceb": "5",
        "\u0cec": "6",
        "\u0ced": "7",
        "\u0cee": "8",
        "\u0cef": "9",
        "\u0ce6": "0"
    };
    function O(e, a, t, s) {
        e = {
            s: [
                "\xe7end san\xeeye",
                "\xe7end san\xeeyeyan"
            ],
            ss: [
                e + " san\xeeye",
                e + " san\xeeyeyan"
            ],
            m: [
                "deq\xeeqeyek",
                "deq\xeeqeyek\xea"
            ],
            mm: [
                e + " deq\xeeqe",
                e + " deq\xeeqeyan"
            ],
            h: [
                "saetek",
                "saetek\xea"
            ],
            hh: [
                e + " saet",
                e + " saetan"
            ],
            d: [
                "rojek",
                "rojek\xea"
            ],
            dd: [
                e + " roj",
                e + " rojan"
            ],
            w: [
                "hefteyek",
                "hefteyek\xea"
            ],
            ww: [
                e + " hefte",
                e + " hefteyan"
            ],
            M: [
                "mehek",
                "mehek\xea"
            ],
            MM: [
                e + " meh",
                e + " mehan"
            ],
            y: [
                "salek",
                "salek\xea"
            ],
            yy: [
                e + " sal",
                e + " salan"
            ]
        };
        return a ? e[t][0] : e[t][1];
    }
    c.defineLocale("kn", {
        months: "\u0c9c\u0ca8\u0cb5\u0cb0\u0cbf_\u0cab\u0cc6\u0cac\u0ccd\u0cb0\u0cb5\u0cb0\u0cbf_\u0cae\u0cbe\u0cb0\u0ccd\u0c9a\u0ccd_\u0c8f\u0caa\u0ccd\u0cb0\u0cbf\u0cb2\u0ccd_\u0cae\u0cc6\u0cd5_\u0c9c\u0cc2\u0ca8\u0ccd_\u0c9c\u0cc1\u0cb2\u0cc6\u0cd6_\u0c86\u0c97\u0cb8\u0ccd\u0c9f\u0ccd_\u0cb8\u0cc6\u0caa\u0ccd\u0c9f\u0cc6\u0c82\u0cac\u0cb0\u0ccd_\u0c85\u0c95\u0ccd\u0c9f\u0cc6\u0cc2\u0cd5\u0cac\u0cb0\u0ccd_\u0ca8\u0cb5\u0cc6\u0c82\u0cac\u0cb0\u0ccd_\u0ca1\u0cbf\u0cb8\u0cc6\u0c82\u0cac\u0cb0\u0ccd".split("_"),
        monthsShort: "\u0c9c\u0ca8_\u0cab\u0cc6\u0cac\u0ccd\u0cb0_\u0cae\u0cbe\u0cb0\u0ccd\u0c9a\u0ccd_\u0c8f\u0caa\u0ccd\u0cb0\u0cbf\u0cb2\u0ccd_\u0cae\u0cc6\u0cd5_\u0c9c\u0cc2\u0ca8\u0ccd_\u0c9c\u0cc1\u0cb2\u0cc6\u0cd6_\u0c86\u0c97\u0cb8\u0ccd\u0c9f\u0ccd_\u0cb8\u0cc6\u0caa\u0ccd\u0c9f\u0cc6\u0c82_\u0c85\u0c95\u0ccd\u0c9f\u0cc6\u0cc2\u0cd5_\u0ca8\u0cb5\u0cc6\u0c82_\u0ca1\u0cbf\u0cb8\u0cc6\u0c82".split("_"),
        monthsParseExact: !0,
        weekdays: "\u0cad\u0cbe\u0ca8\u0cc1\u0cb5\u0cbe\u0cb0_\u0cb8\u0cc6\u0cc2\u0cd5\u0cae\u0cb5\u0cbe\u0cb0_\u0cae\u0c82\u0c97\u0cb3\u0cb5\u0cbe\u0cb0_\u0cac\u0cc1\u0ca7\u0cb5\u0cbe\u0cb0_\u0c97\u0cc1\u0cb0\u0cc1\u0cb5\u0cbe\u0cb0_\u0cb6\u0cc1\u0c95\u0ccd\u0cb0\u0cb5\u0cbe\u0cb0_\u0cb6\u0ca8\u0cbf\u0cb5\u0cbe\u0cb0".split("_"),
        weekdaysShort: "\u0cad\u0cbe\u0ca8\u0cc1_\u0cb8\u0cc6\u0cc2\u0cd5\u0cae_\u0cae\u0c82\u0c97\u0cb3_\u0cac\u0cc1\u0ca7_\u0c97\u0cc1\u0cb0\u0cc1_\u0cb6\u0cc1\u0c95\u0ccd\u0cb0_\u0cb6\u0ca8\u0cbf".split("_"),
        weekdaysMin: "\u0cad\u0cbe_\u0cb8\u0cc6\u0cc2\u0cd5_\u0cae\u0c82_\u0cac\u0cc1_\u0c97\u0cc1_\u0cb6\u0cc1_\u0cb6".split("_"),
        longDateFormat: {
            LT: "A h:mm",
            LTS: "A h:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm",
            LLLL: "dddd, D MMMM YYYY, A h:mm"
        },
        calendar: {
            sameDay: "[\u0c87\u0c82\u0ca6\u0cc1] LT",
            nextDay: "[\u0ca8\u0cbe\u0cb3\u0cc6] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0ca8\u0cbf\u0ca8\u0ccd\u0ca8\u0cc6] LT",
            lastWeek: "[\u0c95\u0cc6\u0cc2\u0ca8\u0cc6\u0caf] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0ca8\u0c82\u0ca4\u0cb0",
            past: "%s \u0cb9\u0cbf\u0c82\u0ca6\u0cc6",
            s: "\u0c95\u0cc6\u0cb2\u0cb5\u0cc1 \u0c95\u0ccd\u0cb7\u0ca3\u0c97\u0cb3\u0cc1",
            ss: "%d \u0cb8\u0cc6\u0c95\u0cc6\u0c82\u0ca1\u0cc1\u0c97\u0cb3\u0cc1",
            m: "\u0c92\u0c82\u0ca6\u0cc1 \u0ca8\u0cbf\u0cae\u0cbf\u0cb7",
            mm: "%d \u0ca8\u0cbf\u0cae\u0cbf\u0cb7",
            h: "\u0c92\u0c82\u0ca6\u0cc1 \u0c97\u0c82\u0c9f\u0cc6",
            hh: "%d \u0c97\u0c82\u0c9f\u0cc6",
            d: "\u0c92\u0c82\u0ca6\u0cc1 \u0ca6\u0cbf\u0ca8",
            dd: "%d \u0ca6\u0cbf\u0ca8",
            M: "\u0c92\u0c82\u0ca6\u0cc1 \u0ca4\u0cbf\u0c82\u0c97\u0cb3\u0cc1",
            MM: "%d \u0ca4\u0cbf\u0c82\u0c97\u0cb3\u0cc1",
            y: "\u0c92\u0c82\u0ca6\u0cc1 \u0cb5\u0cb0\u0ccd\u0cb7",
            yy: "%d \u0cb5\u0cb0\u0ccd\u0cb7"
        },
        preparse: function(e) {
            return e.replace(/[\u0ce7\u0ce8\u0ce9\u0cea\u0ceb\u0cec\u0ced\u0cee\u0cef\u0ce6]/g, function(e) {
                return Rs[e];
            });
        },
        postformat: function(e) {
            return e.replace(/\d/g, function(e) {
                return Js[e];
            });
        },
        meridiemParse: /\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf|\u0cac\u0cc6\u0cb3\u0cbf\u0c97\u0ccd\u0c97\u0cc6|\u0cae\u0ca7\u0ccd\u0caf\u0cbe\u0cb9\u0ccd\u0ca8|\u0cb8\u0c82\u0c9c\u0cc6/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf" === a ? e < 4 ? e : e + 12 : "\u0cac\u0cc6\u0cb3\u0cbf\u0c97\u0ccd\u0c97\u0cc6" === a ? e : "\u0cae\u0ca7\u0ccd\u0caf\u0cbe\u0cb9\u0ccd\u0ca8" === a ? 10 <= e ? e : e + 12 : "\u0cb8\u0c82\u0c9c\u0cc6" === a ? e + 12 : void 0;
        },
        meridiem: function(e, a, t) {
            return e < 4 ? "\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf" : e < 10 ? "\u0cac\u0cc6\u0cb3\u0cbf\u0c97\u0ccd\u0c97\u0cc6" : e < 17 ? "\u0cae\u0ca7\u0ccd\u0caf\u0cbe\u0cb9\u0ccd\u0ca8" : e < 20 ? "\u0cb8\u0c82\u0c9c\u0cc6" : "\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf";
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\u0ca8\u0cc6\u0cd5)/,
        ordinal: function(e) {
            return e + "\u0ca8\u0cc6\u0cd5";
        },
        week: {
            dow: 0,
            doy: 6
        }
    }), c.defineLocale("ko", {
        months: "1\uc6d4_2\uc6d4_3\uc6d4_4\uc6d4_5\uc6d4_6\uc6d4_7\uc6d4_8\uc6d4_9\uc6d4_10\uc6d4_11\uc6d4_12\uc6d4".split("_"),
        monthsShort: "1\uc6d4_2\uc6d4_3\uc6d4_4\uc6d4_5\uc6d4_6\uc6d4_7\uc6d4_8\uc6d4_9\uc6d4_10\uc6d4_11\uc6d4_12\uc6d4".split("_"),
        weekdays: "\uc77c\uc694\uc77c_\uc6d4\uc694\uc77c_\ud654\uc694\uc77c_\uc218\uc694\uc77c_\ubaa9\uc694\uc77c_\uae08\uc694\uc77c_\ud1a0\uc694\uc77c".split("_"),
        weekdaysShort: "\uc77c_\uc6d4_\ud654_\uc218_\ubaa9_\uae08_\ud1a0".split("_"),
        weekdaysMin: "\uc77c_\uc6d4_\ud654_\uc218_\ubaa9_\uae08_\ud1a0".split("_"),
        longDateFormat: {
            LT: "A h:mm",
            LTS: "A h:mm:ss",
            L: "YYYY.MM.DD.",
            LL: "YYYY\ub144 MMMM D\uc77c",
            LLL: "YYYY\ub144 MMMM D\uc77c A h:mm",
            LLLL: "YYYY\ub144 MMMM D\uc77c dddd A h:mm",
            l: "YYYY.MM.DD.",
            ll: "YYYY\ub144 MMMM D\uc77c",
            lll: "YYYY\ub144 MMMM D\uc77c A h:mm",
            llll: "YYYY\ub144 MMMM D\uc77c dddd A h:mm"
        },
        calendar: {
            sameDay: "\uc624\ub298 LT",
            nextDay: "\ub0b4\uc77c LT",
            nextWeek: "dddd LT",
            lastDay: "\uc5b4\uc81c LT",
            lastWeek: "\uc9c0\ub09c\uc8fc dddd LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \ud6c4",
            past: "%s \uc804",
            s: "\uba87 \ucd08",
            ss: "%d\ucd08",
            m: "1\ubd84",
            mm: "%d\ubd84",
            h: "\ud55c \uc2dc\uac04",
            hh: "%d\uc2dc\uac04",
            d: "\ud558\ub8e8",
            dd: "%d\uc77c",
            M: "\ud55c \ub2ec",
            MM: "%d\ub2ec",
            y: "\uc77c \ub144",
            yy: "%d\ub144"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\uc77c|\uc6d4|\uc8fc)/,
        ordinal: function(e, a) {
            switch(a){
                case "d":
                case "D":
                case "DDD":
                    return e + "\uc77c";
                case "M":
                    return e + "\uc6d4";
                case "w":
                case "W":
                    return e + "\uc8fc";
                default:
                    return e;
            }
        },
        meridiemParse: /\uc624\uc804|\uc624\ud6c4/,
        isPM: function(e) {
            return "\uc624\ud6c4" === e;
        },
        meridiem: function(e, a, t) {
            return e < 12 ? "\uc624\uc804" : "\uc624\ud6c4";
        }
    }), c.defineLocale("ku-kmr", {
        months: "R\xeabendan_Sibat_Adar_N\xeesan_Gulan_Hez\xeeran_T\xeermeh_Tebax_\xcelon_Cotmeh_Mijdar_Berfanbar".split("_"),
        monthsShort: "R\xeab_Sib_Ada_N\xees_Gul_Hez_T\xeer_Teb_\xcelo_Cot_Mij_Ber".split("_"),
        monthsParseExact: !0,
        weekdays: "Yek\u015fem_Du\u015fem_S\xea\u015fem_\xc7ar\u015fem_P\xeanc\u015fem_\xcen_\u015eem\xee".split("_"),
        weekdaysShort: "Yek_Du_S\xea_\xc7ar_P\xean_\xcen_\u015eem".split("_"),
        weekdaysMin: "Ye_Du_S\xea_\xc7a_P\xea_\xcen_\u015ee".split("_"),
        meridiem: function(e, a, t) {
            return e < 12 ? t ? "bn" : "BN" : t ? "pn" : "PN";
        },
        meridiemParse: /bn|BN|pn|PN/,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "Do MMMM[a] YYYY[an]",
            LLL: "Do MMMM[a] YYYY[an] HH:mm",
            LLLL: "dddd, Do MMMM[a] YYYY[an] HH:mm",
            ll: "Do MMM[.] YYYY[an]",
            lll: "Do MMM[.] YYYY[an] HH:mm",
            llll: "ddd[.], Do MMM[.] YYYY[an] HH:mm"
        },
        calendar: {
            sameDay: "[\xcero di saet] LT [de]",
            nextDay: "[Sib\xea di saet] LT [de]",
            nextWeek: "dddd [di saet] LT [de]",
            lastDay: "[Duh di saet] LT [de]",
            lastWeek: "dddd[a bor\xee di saet] LT [de]",
            sameElse: "L"
        },
        relativeTime: {
            future: "di %s de",
            past: "ber\xee %s",
            s: O,
            ss: O,
            m: O,
            mm: O,
            h: O,
            hh: O,
            d: O,
            dd: O,
            w: O,
            ww: O,
            M: O,
            MM: O,
            y: O,
            yy: O
        },
        dayOfMonthOrdinalParse: /\d{1,2}(?:y\xea|\xea|\.)/,
        ordinal: function(e, a) {
            var a = a.toLowerCase();
            return a.includes("w") || a.includes("m") ? e + "." : e + (e = (a = "" + (a = e)).substring(a.length - 1), 12 == (a = 1 < a.length ? a.substring(a.length - 2) : "") || 13 == a || "2" != e && "3" != e && "50" != a && "70" != e && "80" != e ? "\xea" : "y\xea");
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    var Cs = {
        1: "\u0661",
        2: "\u0662",
        3: "\u0663",
        4: "\u0664",
        5: "\u0665",
        6: "\u0666",
        7: "\u0667",
        8: "\u0668",
        9: "\u0669",
        0: "\u0660"
    }, Is = {
        "\u0661": "1",
        "\u0662": "2",
        "\u0663": "3",
        "\u0664": "4",
        "\u0665": "5",
        "\u0666": "6",
        "\u0667": "7",
        "\u0668": "8",
        "\u0669": "9",
        "\u0660": "0"
    }, fe = [
        "\u06a9\u0627\u0646\u0648\u0646\u06cc \u062f\u0648\u0648\u06d5\u0645",
        "\u0634\u0648\u0628\u0627\u062a",
        "\u0626\u0627\u0632\u0627\u0631",
        "\u0646\u06cc\u0633\u0627\u0646",
        "\u0626\u0627\u06cc\u0627\u0631",
        "\u062d\u0648\u0632\u06d5\u06cc\u0631\u0627\u0646",
        "\u062a\u06d5\u0645\u0645\u0648\u0632",
        "\u0626\u0627\u0628",
        "\u0626\u06d5\u06cc\u0644\u0648\u0648\u0644",
        "\u062a\u0634\u0631\u06cc\u0646\u06cc \u06cc\u06d5\u0643\u06d5\u0645",
        "\u062a\u0634\u0631\u06cc\u0646\u06cc \u062f\u0648\u0648\u06d5\u0645",
        "\u0643\u0627\u0646\u0648\u0646\u06cc \u06cc\u06d5\u06a9\u06d5\u0645"
    ], Us = (c.defineLocale("ku", {
        months: fe,
        monthsShort: fe,
        weekdays: "\u06cc\u0647\u200c\u0643\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u062f\u0648\u0648\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u0633\u06ce\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u0686\u0648\u0627\u0631\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u067e\u06ce\u0646\u062c\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u0647\u0647\u200c\u06cc\u0646\u06cc_\u0634\u0647\u200c\u0645\u0645\u0647\u200c".split("_"),
        weekdaysShort: "\u06cc\u0647\u200c\u0643\u0634\u0647\u200c\u0645_\u062f\u0648\u0648\u0634\u0647\u200c\u0645_\u0633\u06ce\u0634\u0647\u200c\u0645_\u0686\u0648\u0627\u0631\u0634\u0647\u200c\u0645_\u067e\u06ce\u0646\u062c\u0634\u0647\u200c\u0645_\u0647\u0647\u200c\u06cc\u0646\u06cc_\u0634\u0647\u200c\u0645\u0645\u0647\u200c".split("_"),
        weekdaysMin: "\u06cc_\u062f_\u0633_\u0686_\u067e_\u0647_\u0634".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        meridiemParse: /\u0626\u06ce\u0648\u0627\u0631\u0647\u200c|\u0628\u0647\u200c\u06cc\u0627\u0646\u06cc/,
        isPM: function(e) {
            return /\u0626\u06ce\u0648\u0627\u0631\u0647\u200c/.test(e);
        },
        meridiem: function(e, a, t) {
            return e < 12 ? "\u0628\u0647\u200c\u06cc\u0627\u0646\u06cc" : "\u0626\u06ce\u0648\u0627\u0631\u0647\u200c";
        },
        calendar: {
            sameDay: "[\u0626\u0647\u200c\u0645\u0631\u06c6 \u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",
            nextDay: "[\u0628\u0647\u200c\u06cc\u0627\u0646\u06cc \u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",
            nextWeek: "dddd [\u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",
            lastDay: "[\u062f\u0648\u06ce\u0646\u06ce \u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",
            lastWeek: "dddd [\u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0644\u0647\u200c %s",
            past: "%s",
            s: "\u0686\u0647\u200c\u0646\u062f \u0686\u0631\u0643\u0647\u200c\u06cc\u0647\u200c\u0643",
            ss: "\u0686\u0631\u0643\u0647\u200c %d",
            m: "\u06cc\u0647\u200c\u0643 \u062e\u0648\u0644\u0647\u200c\u0643",
            mm: "%d \u062e\u0648\u0644\u0647\u200c\u0643",
            h: "\u06cc\u0647\u200c\u0643 \u0643\u0627\u062a\u0698\u0645\u06ce\u0631",
            hh: "%d \u0643\u0627\u062a\u0698\u0645\u06ce\u0631",
            d: "\u06cc\u0647\u200c\u0643 \u0695\u06c6\u0698",
            dd: "%d \u0695\u06c6\u0698",
            M: "\u06cc\u0647\u200c\u0643 \u0645\u0627\u0646\u06af",
            MM: "%d \u0645\u0627\u0646\u06af",
            y: "\u06cc\u0647\u200c\u0643 \u0633\u0627\u06b5",
            yy: "%d \u0633\u0627\u06b5"
        },
        preparse: function(e) {
            return e.replace(/[\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g, function(e) {
                return Is[e];
            }).replace(/\u060c/g, ",");
        },
        postformat: function(e) {
            return e.replace(/\d/g, function(e) {
                return Cs[e];
            }).replace(/,/g, "\u060c");
        },
        week: {
            dow: 6,
            doy: 12
        }
    }), {
        0: "-\u0447\u04af",
        1: "-\u0447\u0438",
        2: "-\u0447\u0438",
        3: "-\u0447\u04af",
        4: "-\u0447\u04af",
        5: "-\u0447\u0438",
        6: "-\u0447\u044b",
        7: "-\u0447\u0438",
        8: "-\u0447\u0438",
        9: "-\u0447\u0443",
        10: "-\u0447\u0443",
        20: "-\u0447\u044b",
        30: "-\u0447\u0443",
        40: "-\u0447\u044b",
        50: "-\u0447\u04af",
        60: "-\u0447\u044b",
        70: "-\u0447\u0438",
        80: "-\u0447\u0438",
        90: "-\u0447\u0443",
        100: "-\u0447\u04af"
    });
    function Gs(e, a, t, s) {
        var n = {
            m: [
                "eng Minutt",
                "enger Minutt"
            ],
            h: [
                "eng Stonn",
                "enger Stonn"
            ],
            d: [
                "een Dag",
                "engem Dag"
            ],
            M: [
                "ee Mount",
                "engem Mount"
            ],
            y: [
                "ee Joer",
                "engem Joer"
            ]
        };
        return a ? n[t][0] : n[t][1];
    }
    function Vs(e) {
        if (e = parseInt(e, 10), isNaN(e)) return !1;
        if (e < 0) return !0;
        if (e < 10) return 4 <= e && e <= 7;
        var a;
        if (e < 100) return Vs(0 == (a = e % 10) ? e / 10 : a);
        if (e < 1e4) {
            for(; 10 <= e;)e /= 10;
            return Vs(e);
        }
        return Vs(e /= 1e3);
    }
    c.defineLocale("ky", {
        months: "\u044f\u043d\u0432\u0430\u0440\u044c_\u0444\u0435\u0432\u0440\u0430\u043b\u044c_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b\u044c_\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044c_\u043e\u043a\u0442\u044f\u0431\u0440\u044c_\u043d\u043e\u044f\u0431\u0440\u044c_\u0434\u0435\u043a\u0430\u0431\u0440\u044c".split("_"),
        monthsShort: "\u044f\u043d\u0432_\u0444\u0435\u0432_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440_\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433_\u0441\u0435\u043d_\u043e\u043a\u0442_\u043d\u043e\u044f_\u0434\u0435\u043a".split("_"),
        weekdays: "\u0416\u0435\u043a\u0448\u0435\u043c\u0431\u0438_\u0414\u04af\u0439\u0448\u04e9\u043c\u0431\u04af_\u0428\u0435\u0439\u0448\u0435\u043c\u0431\u0438_\u0428\u0430\u0440\u0448\u0435\u043c\u0431\u0438_\u0411\u0435\u0439\u0448\u0435\u043c\u0431\u0438_\u0416\u0443\u043c\u0430_\u0418\u0448\u0435\u043c\u0431\u0438".split("_"),
        weekdaysShort: "\u0416\u0435\u043a_\u0414\u04af\u0439_\u0428\u0435\u0439_\u0428\u0430\u0440_\u0411\u0435\u0439_\u0416\u0443\u043c_\u0418\u0448\u0435".split("_"),
        weekdaysMin: "\u0416\u043a_\u0414\u0439_\u0428\u0439_\u0428\u0440_\u0411\u0439_\u0416\u043c_\u0418\u0448".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\u0411\u04af\u0433\u04af\u043d \u0441\u0430\u0430\u0442] LT",
            nextDay: "[\u042d\u0440\u0442\u0435\u04a3 \u0441\u0430\u0430\u0442] LT",
            nextWeek: "dddd [\u0441\u0430\u0430\u0442] LT",
            lastDay: "[\u041a\u0435\u0447\u044d\u044d \u0441\u0430\u0430\u0442] LT",
            lastWeek: "[\u04e8\u0442\u043a\u04e9\u043d \u0430\u043f\u0442\u0430\u043d\u044b\u043d] dddd [\u043a\u04af\u043d\u04af] [\u0441\u0430\u0430\u0442] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0438\u0447\u0438\u043d\u0434\u0435",
            past: "%s \u043c\u0443\u0440\u0443\u043d",
            s: "\u0431\u0438\u0440\u043d\u0435\u0447\u0435 \u0441\u0435\u043a\u0443\u043d\u0434",
            ss: "%d \u0441\u0435\u043a\u0443\u043d\u0434",
            m: "\u0431\u0438\u0440 \u043c\u04af\u043d\u04e9\u0442",
            mm: "%d \u043c\u04af\u043d\u04e9\u0442",
            h: "\u0431\u0438\u0440 \u0441\u0430\u0430\u0442",
            hh: "%d \u0441\u0430\u0430\u0442",
            d: "\u0431\u0438\u0440 \u043a\u04af\u043d",
            dd: "%d \u043a\u04af\u043d",
            M: "\u0431\u0438\u0440 \u0430\u0439",
            MM: "%d \u0430\u0439",
            y: "\u0431\u0438\u0440 \u0436\u044b\u043b",
            yy: "%d \u0436\u044b\u043b"
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(\u0447\u0438|\u0447\u044b|\u0447\u04af|\u0447\u0443)/,
        ordinal: function(e) {
            return e + (Us[e] || Us[e % 10] || Us[100 <= e ? 100 : null]);
        },
        week: {
            dow: 1,
            doy: 7
        }
    }), c.defineLocale("lb", {
        months: "Januar_Februar_M\xe4erz_Abr\xebll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
        monthsShort: "Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),
        monthsParseExact: !0,
        weekdays: "Sonndeg_M\xe9indeg_D\xebnschdeg_M\xebttwoch_Donneschdeg_Freideg_Samschdeg".split("_"),
        weekdaysShort: "So._M\xe9._D\xeb._M\xeb._Do._Fr._Sa.".split("_"),
        weekdaysMin: "So_M\xe9_D\xeb_M\xeb_Do_Fr_Sa".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "H:mm [Auer]",
            LTS: "H:mm:ss [Auer]",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm [Auer]",
            LLLL: "dddd, D. MMMM YYYY H:mm [Auer]"
        },
        calendar: {
            sameDay: "[Haut um] LT",
            sameElse: "L",
            nextDay: "[Muer um] LT",
            nextWeek: "dddd [um] LT",
            lastDay: "[G\xebschter um] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 2:
                    case 4:
                        return "[Leschten] dddd [um] LT";
                    default:
                        return "[Leschte] dddd [um] LT";
                }
            }
        },
        relativeTime: {
            future: function(e) {
                return Vs(e.substr(0, e.indexOf(" "))) ? "a " + e : "an " + e;
            },
            past: function(e) {
                return Vs(e.substr(0, e.indexOf(" "))) ? "viru " + e : "virun " + e;
            },
            s: "e puer Sekonnen",
            ss: "%d Sekonnen",
            m: Gs,
            mm: "%d Minutten",
            h: Gs,
            hh: "%d Stonnen",
            d: Gs,
            dd: "%d Deeg",
            M: Gs,
            MM: "%d M\xe9int",
            y: Gs,
            yy: "%d Joer"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("lo", {
        months: "\u0ea1\u0eb1\u0e87\u0e81\u0ead\u0e99_\u0e81\u0eb8\u0ea1\u0e9e\u0eb2_\u0ea1\u0eb5\u0e99\u0eb2_\u0ec0\u0ea1\u0eaa\u0eb2_\u0e9e\u0eb6\u0e94\u0eaa\u0eb0\u0e9e\u0eb2_\u0ea1\u0eb4\u0e96\u0eb8\u0e99\u0eb2_\u0e81\u0ecd\u0ea5\u0eb0\u0e81\u0ebb\u0e94_\u0eaa\u0eb4\u0e87\u0eab\u0eb2_\u0e81\u0eb1\u0e99\u0e8d\u0eb2_\u0e95\u0eb8\u0ea5\u0eb2_\u0e9e\u0eb0\u0e88\u0eb4\u0e81_\u0e97\u0eb1\u0e99\u0ea7\u0eb2".split("_"),
        monthsShort: "\u0ea1\u0eb1\u0e87\u0e81\u0ead\u0e99_\u0e81\u0eb8\u0ea1\u0e9e\u0eb2_\u0ea1\u0eb5\u0e99\u0eb2_\u0ec0\u0ea1\u0eaa\u0eb2_\u0e9e\u0eb6\u0e94\u0eaa\u0eb0\u0e9e\u0eb2_\u0ea1\u0eb4\u0e96\u0eb8\u0e99\u0eb2_\u0e81\u0ecd\u0ea5\u0eb0\u0e81\u0ebb\u0e94_\u0eaa\u0eb4\u0e87\u0eab\u0eb2_\u0e81\u0eb1\u0e99\u0e8d\u0eb2_\u0e95\u0eb8\u0ea5\u0eb2_\u0e9e\u0eb0\u0e88\u0eb4\u0e81_\u0e97\u0eb1\u0e99\u0ea7\u0eb2".split("_"),
        weekdays: "\u0ead\u0eb2\u0e97\u0eb4\u0e94_\u0e88\u0eb1\u0e99_\u0ead\u0eb1\u0e87\u0e84\u0eb2\u0e99_\u0e9e\u0eb8\u0e94_\u0e9e\u0eb0\u0eab\u0eb1\u0e94_\u0eaa\u0eb8\u0e81_\u0ec0\u0eaa\u0ebb\u0eb2".split("_"),
        weekdaysShort: "\u0e97\u0eb4\u0e94_\u0e88\u0eb1\u0e99_\u0ead\u0eb1\u0e87\u0e84\u0eb2\u0e99_\u0e9e\u0eb8\u0e94_\u0e9e\u0eb0\u0eab\u0eb1\u0e94_\u0eaa\u0eb8\u0e81_\u0ec0\u0eaa\u0ebb\u0eb2".split("_"),
        weekdaysMin: "\u0e97_\u0e88_\u0ead\u0e84_\u0e9e_\u0e9e\u0eab_\u0eaa\u0e81_\u0eaa".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "\u0ea7\u0eb1\u0e99dddd D MMMM YYYY HH:mm"
        },
        meridiemParse: /\u0e95\u0ead\u0e99\u0ec0\u0e8a\u0ebb\u0ec9\u0eb2|\u0e95\u0ead\u0e99\u0ec1\u0ea5\u0e87/,
        isPM: function(e) {
            return "\u0e95\u0ead\u0e99\u0ec1\u0ea5\u0e87" === e;
        },
        meridiem: function(e, a, t) {
            return e < 12 ? "\u0e95\u0ead\u0e99\u0ec0\u0e8a\u0ebb\u0ec9\u0eb2" : "\u0e95\u0ead\u0e99\u0ec1\u0ea5\u0e87";
        },
        calendar: {
            sameDay: "[\u0ea1\u0eb7\u0ec9\u0e99\u0eb5\u0ec9\u0ec0\u0ea7\u0ea5\u0eb2] LT",
            nextDay: "[\u0ea1\u0eb7\u0ec9\u0ead\u0eb7\u0ec8\u0e99\u0ec0\u0ea7\u0ea5\u0eb2] LT",
            nextWeek: "[\u0ea7\u0eb1\u0e99]dddd[\u0edc\u0ec9\u0eb2\u0ec0\u0ea7\u0ea5\u0eb2] LT",
            lastDay: "[\u0ea1\u0eb7\u0ec9\u0ea7\u0eb2\u0e99\u0e99\u0eb5\u0ec9\u0ec0\u0ea7\u0ea5\u0eb2] LT",
            lastWeek: "[\u0ea7\u0eb1\u0e99]dddd[\u0ec1\u0ea5\u0ec9\u0ea7\u0e99\u0eb5\u0ec9\u0ec0\u0ea7\u0ea5\u0eb2] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0ead\u0eb5\u0e81 %s",
            past: "%s\u0e9c\u0ec8\u0eb2\u0e99\u0ea1\u0eb2",
            s: "\u0e9a\u0ecd\u0ec8\u0ec0\u0e97\u0ebb\u0ec8\u0eb2\u0ec3\u0e94\u0ea7\u0eb4\u0e99\u0eb2\u0e97\u0eb5",
            ss: "%d \u0ea7\u0eb4\u0e99\u0eb2\u0e97\u0eb5",
            m: "1 \u0e99\u0eb2\u0e97\u0eb5",
            mm: "%d \u0e99\u0eb2\u0e97\u0eb5",
            h: "1 \u0e8a\u0ebb\u0ec8\u0ea7\u0ec2\u0ea1\u0e87",
            hh: "%d \u0e8a\u0ebb\u0ec8\u0ea7\u0ec2\u0ea1\u0e87",
            d: "1 \u0ea1\u0eb7\u0ec9",
            dd: "%d \u0ea1\u0eb7\u0ec9",
            M: "1 \u0ec0\u0e94\u0eb7\u0ead\u0e99",
            MM: "%d \u0ec0\u0e94\u0eb7\u0ead\u0e99",
            y: "1 \u0e9b\u0eb5",
            yy: "%d \u0e9b\u0eb5"
        },
        dayOfMonthOrdinalParse: /(\u0e97\u0eb5\u0ec8)\d{1,2}/,
        ordinal: function(e) {
            return "\u0e97\u0eb5\u0ec8" + e;
        }
    });
    var qs = {
        ss: "sekund\u0117_sekund\u017ei\u0173_sekundes",
        m: "minut\u0117_minut\u0117s_minut\u0119",
        mm: "minut\u0117s_minu\u010di\u0173_minutes",
        h: "valanda_valandos_valand\u0105",
        hh: "valandos_valand\u0173_valandas",
        d: "diena_dienos_dien\u0105",
        dd: "dienos_dien\u0173_dienas",
        M: "m\u0117nuo_m\u0117nesio_m\u0117nes\u012f",
        MM: "m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",
        y: "metai_met\u0173_metus",
        yy: "metai_met\u0173_metus"
    };
    function Bs(e, a, t, s) {
        return a ? Zs(t)[0] : s ? Zs(t)[1] : Zs(t)[2];
    }
    function Ks(e) {
        return e % 10 == 0 || 10 < e && e < 20;
    }
    function Zs(e) {
        return qs[e].split("_");
    }
    function $s(e, a, t, s) {
        var n = e + " ";
        return 1 === e ? n + Bs(0, a, t[0], s) : a ? n + (Ks(e) ? Zs(t)[1] : Zs(t)[0]) : s ? n + Zs(t)[1] : n + (Ks(e) ? Zs(t)[1] : Zs(t)[2]);
    }
    c.defineLocale("lt", {
        months: {
            format: "sausio_vasario_kovo_baland\u017eio_gegu\u017e\u0117s_bir\u017eelio_liepos_rugpj\u016b\u010dio_rugs\u0117jo_spalio_lapkri\u010dio_gruod\u017eio".split("_"),
            standalone: "sausis_vasaris_kovas_balandis_gegu\u017e\u0117_bir\u017eelis_liepa_rugpj\u016btis_rugs\u0117jis_spalis_lapkritis_gruodis".split("_"),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
        },
        monthsShort: "sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),
        weekdays: {
            format: "sekmadien\u012f_pirmadien\u012f_antradien\u012f_tre\u010diadien\u012f_ketvirtadien\u012f_penktadien\u012f_\u0161e\u0161tadien\u012f".split("_"),
            standalone: "sekmadienis_pirmadienis_antradienis_tre\u010diadienis_ketvirtadienis_penktadienis_\u0161e\u0161tadienis".split("_"),
            isFormat: /dddd HH:mm/
        },
        weekdaysShort: "Sek_Pir_Ant_Tre_Ket_Pen_\u0160e\u0161".split("_"),
        weekdaysMin: "S_P_A_T_K_Pn_\u0160".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "YYYY [m.] MMMM D [d.]",
            LLL: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
            LLLL: "YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",
            l: "YYYY-MM-DD",
            ll: "YYYY [m.] MMMM D [d.]",
            lll: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
            llll: "YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]"
        },
        calendar: {
            sameDay: "[\u0160iandien] LT",
            nextDay: "[Rytoj] LT",
            nextWeek: "dddd LT",
            lastDay: "[Vakar] LT",
            lastWeek: "[Pra\u0117jus\u012f] dddd LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "po %s",
            past: "prie\u0161 %s",
            s: function(e, a, t, s) {
                return a ? "kelios sekund\u0117s" : s ? "keli\u0173 sekund\u017ei\u0173" : "kelias sekundes";
            },
            ss: $s,
            m: Bs,
            mm: $s,
            h: Bs,
            hh: $s,
            d: Bs,
            dd: $s,
            M: Bs,
            MM: $s,
            y: Bs,
            yy: $s
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function(e) {
            return e + "-oji";
        },
        week: {
            dow: 1,
            doy: 4
        }
    });
    var Qs = {
        ss: "sekundes_sekund\u0113m_sekunde_sekundes".split("_"),
        m: "min\u016btes_min\u016bt\u0113m_min\u016bte_min\u016btes".split("_"),
        mm: "min\u016btes_min\u016bt\u0113m_min\u016bte_min\u016btes".split("_"),
        h: "stundas_stund\u0101m_stunda_stundas".split("_"),
        hh: "stundas_stund\u0101m_stunda_stundas".split("_"),
        d: "dienas_dien\u0101m_diena_dienas".split("_"),
        dd: "dienas_dien\u0101m_diena_dienas".split("_"),
        M: "m\u0113ne\u0161a_m\u0113ne\u0161iem_m\u0113nesis_m\u0113ne\u0161i".split("_"),
        MM: "m\u0113ne\u0161a_m\u0113ne\u0161iem_m\u0113nesis_m\u0113ne\u0161i".split("_"),
        y: "gada_gadiem_gads_gadi".split("_"),
        yy: "gada_gadiem_gads_gadi".split("_")
    };
    function Xs(e, a, t) {
        return t ? a % 10 == 1 && a % 100 != 11 ? e[2] : e[3] : a % 10 == 1 && a % 100 != 11 ? e[0] : e[1];
    }
    function en(e, a, t) {
        return e + " " + Xs(Qs[t], e, a);
    }
    function an(e, a, t) {
        return Xs(Qs[t], e, a);
    }
    c.defineLocale("lv", {
        months: "janv\u0101ris_febru\u0101ris_marts_apr\u012blis_maijs_j\u016bnijs_j\u016blijs_augusts_septembris_oktobris_novembris_decembris".split("_"),
        monthsShort: "jan_feb_mar_apr_mai_j\u016bn_j\u016bl_aug_sep_okt_nov_dec".split("_"),
        weekdays: "sv\u0113tdiena_pirmdiena_otrdiena_tre\u0161diena_ceturtdiena_piektdiena_sestdiena".split("_"),
        weekdaysShort: "Sv_P_O_T_C_Pk_S".split("_"),
        weekdaysMin: "Sv_P_O_T_C_Pk_S".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY.",
            LL: "YYYY. [gada] D. MMMM",
            LLL: "YYYY. [gada] D. MMMM, HH:mm",
            LLLL: "YYYY. [gada] D. MMMM, dddd, HH:mm"
        },
        calendar: {
            sameDay: "[\u0160odien pulksten] LT",
            nextDay: "[R\u012bt pulksten] LT",
            nextWeek: "dddd [pulksten] LT",
            lastDay: "[Vakar pulksten] LT",
            lastWeek: "[Pag\u0101ju\u0161\u0101] dddd [pulksten] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "p\u0113c %s",
            past: "pirms %s",
            s: function(e, a) {
                return a ? "da\u017eas sekundes" : "da\u017e\u0101m sekund\u0113m";
            },
            ss: en,
            m: an,
            mm: en,
            h: an,
            hh: en,
            d: an,
            dd: en,
            M: an,
            MM: en,
            y: an,
            yy: en
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    var tn = {
        words: {
            ss: [
                "sekund",
                "sekunda",
                "sekundi"
            ],
            m: [
                "jedan minut",
                "jednog minuta"
            ],
            mm: [
                "minut",
                "minuta",
                "minuta"
            ],
            h: [
                "jedan sat",
                "jednog sata"
            ],
            hh: [
                "sat",
                "sata",
                "sati"
            ],
            dd: [
                "dan",
                "dana",
                "dana"
            ],
            MM: [
                "mjesec",
                "mjeseca",
                "mjeseci"
            ],
            yy: [
                "godina",
                "godine",
                "godina"
            ]
        },
        correctGrammaticalCase: function(e, a) {
            return 1 === e ? a[0] : 2 <= e && e <= 4 ? a[1] : a[2];
        },
        translate: function(e, a, t) {
            var s = tn.words[t];
            return 1 === t.length ? a ? s[0] : s[1] : e + " " + tn.correctGrammaticalCase(e, s);
        }
    };
    function sn(e, a, t, s) {
        switch(t){
            case "s":
                return a ? "\u0445\u044d\u0434\u0445\u044d\u043d \u0441\u0435\u043a\u0443\u043d\u0434" : "\u0445\u044d\u0434\u0445\u044d\u043d \u0441\u0435\u043a\u0443\u043d\u0434\u044b\u043d";
            case "ss":
                return e + (a ? " \u0441\u0435\u043a\u0443\u043d\u0434" : " \u0441\u0435\u043a\u0443\u043d\u0434\u044b\u043d");
            case "m":
            case "mm":
                return e + (a ? " \u043c\u0438\u043d\u0443\u0442" : " \u043c\u0438\u043d\u0443\u0442\u044b\u043d");
            case "h":
            case "hh":
                return e + (a ? " \u0446\u0430\u0433" : " \u0446\u0430\u0433\u0438\u0439\u043d");
            case "d":
            case "dd":
                return e + (a ? " \u04e9\u0434\u04e9\u0440" : " \u04e9\u0434\u0440\u0438\u0439\u043d");
            case "M":
            case "MM":
                return e + (a ? " \u0441\u0430\u0440" : " \u0441\u0430\u0440\u044b\u043d");
            case "y":
            case "yy":
                return e + (a ? " \u0436\u0438\u043b" : " \u0436\u0438\u043b\u0438\u0439\u043d");
            default:
                return e;
        }
    }
    c.defineLocale("me", {
        months: "januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),
        monthsShort: "jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),
        monthsParseExact: !0,
        weekdays: "nedjelja_ponedjeljak_utorak_srijeda_\u010detvrtak_petak_subota".split("_"),
        weekdaysShort: "ned._pon._uto._sri._\u010det._pet._sub.".split("_"),
        weekdaysMin: "ne_po_ut_sr_\u010de_pe_su".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm",
            LLLL: "dddd, D. MMMM YYYY H:mm"
        },
        calendar: {
            sameDay: "[danas u] LT",
            nextDay: "[sjutra u] LT",
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[u] [nedjelju] [u] LT";
                    case 3:
                        return "[u] [srijedu] [u] LT";
                    case 6:
                        return "[u] [subotu] [u] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[u] dddd [u] LT";
                }
            },
            lastDay: "[ju\u010de u] LT",
            lastWeek: function() {
                return [
                    "[pro\u0161le] [nedjelje] [u] LT",
                    "[pro\u0161log] [ponedjeljka] [u] LT",
                    "[pro\u0161log] [utorka] [u] LT",
                    "[pro\u0161le] [srijede] [u] LT",
                    "[pro\u0161log] [\u010detvrtka] [u] LT",
                    "[pro\u0161log] [petka] [u] LT",
                    "[pro\u0161le] [subote] [u] LT"
                ][this.day()];
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "za %s",
            past: "prije %s",
            s: "nekoliko sekundi",
            ss: tn.translate,
            m: tn.translate,
            mm: tn.translate,
            h: tn.translate,
            hh: tn.translate,
            d: "dan",
            dd: tn.translate,
            M: "mjesec",
            MM: tn.translate,
            y: "godinu",
            yy: tn.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 7
        }
    }), c.defineLocale("mi", {
        months: "Kohi-t\u0101te_Hui-tanguru_Pout\u016b-te-rangi_Paenga-wh\u0101wh\u0101_Haratua_Pipiri_H\u014dngoingoi_Here-turi-k\u014dk\u0101_Mahuru_Whiringa-\u0101-nuku_Whiringa-\u0101-rangi_Hakihea".split("_"),
        monthsShort: "Kohi_Hui_Pou_Pae_Hara_Pipi_H\u014dngoi_Here_Mahu_Whi-nu_Whi-ra_Haki".split("_"),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: "R\u0101tapu_Mane_T\u016brei_Wenerei_T\u0101ite_Paraire_H\u0101tarei".split("_"),
        weekdaysShort: "Ta_Ma_T\u016b_We_T\u0101i_Pa_H\u0101".split("_"),
        weekdaysMin: "Ta_Ma_T\u016b_We_T\u0101i_Pa_H\u0101".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY [i] HH:mm",
            LLLL: "dddd, D MMMM YYYY [i] HH:mm"
        },
        calendar: {
            sameDay: "[i teie mahana, i] LT",
            nextDay: "[apopo i] LT",
            nextWeek: "dddd [i] LT",
            lastDay: "[inanahi i] LT",
            lastWeek: "dddd [whakamutunga i] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "i roto i %s",
            past: "%s i mua",
            s: "te h\u0113kona ruarua",
            ss: "%d h\u0113kona",
            m: "he meneti",
            mm: "%d meneti",
            h: "te haora",
            hh: "%d haora",
            d: "he ra",
            dd: "%d ra",
            M: "he marama",
            MM: "%d marama",
            y: "he tau",
            yy: "%d tau"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\xba/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("mk", {
        months: "\u0458\u0430\u043d\u0443\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0438\u043b_\u043c\u0430\u0458_\u0458\u0443\u043d\u0438_\u0458\u0443\u043b\u0438_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043f\u0442\u0435\u043c\u0432\u0440\u0438_\u043e\u043a\u0442\u043e\u043c\u0432\u0440\u0438_\u043d\u043e\u0435\u043c\u0432\u0440\u0438_\u0434\u0435\u043a\u0435\u043c\u0432\u0440\u0438".split("_"),
        monthsShort: "\u0458\u0430\u043d_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0458_\u0458\u0443\u043d_\u0458\u0443\u043b_\u0430\u0432\u0433_\u0441\u0435\u043f_\u043e\u043a\u0442_\u043d\u043e\u0435_\u0434\u0435\u043a".split("_"),
        weekdays: "\u043d\u0435\u0434\u0435\u043b\u0430_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0440\u0442\u043e\u043a_\u043f\u0435\u0442\u043e\u043a_\u0441\u0430\u0431\u043e\u0442\u0430".split("_"),
        weekdaysShort: "\u043d\u0435\u0434_\u043f\u043e\u043d_\u0432\u0442\u043e_\u0441\u0440\u0435_\u0447\u0435\u0442_\u043f\u0435\u0442_\u0441\u0430\u0431".split("_"),
        weekdaysMin: "\u043de_\u043fo_\u0432\u0442_\u0441\u0440_\u0447\u0435_\u043f\u0435_\u0441a".split("_"),
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "D.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY H:mm",
            LLLL: "dddd, D MMMM YYYY H:mm"
        },
        calendar: {
            sameDay: "[\u0414\u0435\u043d\u0435\u0441 \u0432\u043e] LT",
            nextDay: "[\u0423\u0442\u0440\u0435 \u0432\u043e] LT",
            nextWeek: "[\u0412\u043e] dddd [\u0432\u043e] LT",
            lastDay: "[\u0412\u0447\u0435\u0440\u0430 \u0432\u043e] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                    case 3:
                    case 6:
                        return "[\u0418\u0437\u043c\u0438\u043d\u0430\u0442\u0430\u0442\u0430] dddd [\u0432\u043e] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[\u0418\u0437\u043c\u0438\u043d\u0430\u0442\u0438\u043e\u0442] dddd [\u0432\u043e] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0437\u0430 %s",
            past: "\u043f\u0440\u0435\u0434 %s",
            s: "\u043d\u0435\u043a\u043e\u043b\u043a\u0443 \u0441\u0435\u043a\u0443\u043d\u0434\u0438",
            ss: "%d \u0441\u0435\u043a\u0443\u043d\u0434\u0438",
            m: "\u0435\u0434\u043d\u0430 \u043c\u0438\u043d\u0443\u0442\u0430",
            mm: "%d \u043c\u0438\u043d\u0443\u0442\u0438",
            h: "\u0435\u0434\u0435\u043d \u0447\u0430\u0441",
            hh: "%d \u0447\u0430\u0441\u0430",
            d: "\u0435\u0434\u0435\u043d \u0434\u0435\u043d",
            dd: "%d \u0434\u0435\u043d\u0430",
            M: "\u0435\u0434\u0435\u043d \u043c\u0435\u0441\u0435\u0446",
            MM: "%d \u043c\u0435\u0441\u0435\u0446\u0438",
            y: "\u0435\u0434\u043d\u0430 \u0433\u043e\u0434\u0438\u043d\u0430",
            yy: "%d \u0433\u043e\u0434\u0438\u043d\u0438"
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(\u0435\u0432|\u0435\u043d|\u0442\u0438|\u0432\u0438|\u0440\u0438|\u043c\u0438)/,
        ordinal: function(e) {
            var a = e % 10, t = e % 100;
            return 0 === e ? e + "-\u0435\u0432" : 0 == t ? e + "-\u0435\u043d" : 10 < t && t < 20 ? e + "-\u0442\u0438" : 1 == a ? e + "-\u0432\u0438" : 2 == a ? e + "-\u0440\u0438" : 7 == a || 8 == a ? e + "-\u043c\u0438" : e + "-\u0442\u0438";
        },
        week: {
            dow: 1,
            doy: 7
        }
    }), c.defineLocale("ml", {
        months: "\u0d1c\u0d28\u0d41\u0d35\u0d30\u0d3f_\u0d2b\u0d46\u0d2c\u0d4d\u0d30\u0d41\u0d35\u0d30\u0d3f_\u0d2e\u0d3e\u0d7c\u0d1a\u0d4d\u0d1a\u0d4d_\u0d0f\u0d2a\u0d4d\u0d30\u0d3f\u0d7d_\u0d2e\u0d47\u0d2f\u0d4d_\u0d1c\u0d42\u0d7a_\u0d1c\u0d42\u0d32\u0d48_\u0d13\u0d17\u0d38\u0d4d\u0d31\u0d4d\u0d31\u0d4d_\u0d38\u0d46\u0d2a\u0d4d\u0d31\u0d4d\u0d31\u0d02\u0d2c\u0d7c_\u0d12\u0d15\u0d4d\u0d1f\u0d4b\u0d2c\u0d7c_\u0d28\u0d35\u0d02\u0d2c\u0d7c_\u0d21\u0d3f\u0d38\u0d02\u0d2c\u0d7c".split("_"),
        monthsShort: "\u0d1c\u0d28\u0d41._\u0d2b\u0d46\u0d2c\u0d4d\u0d30\u0d41._\u0d2e\u0d3e\u0d7c._\u0d0f\u0d2a\u0d4d\u0d30\u0d3f._\u0d2e\u0d47\u0d2f\u0d4d_\u0d1c\u0d42\u0d7a_\u0d1c\u0d42\u0d32\u0d48._\u0d13\u0d17._\u0d38\u0d46\u0d2a\u0d4d\u0d31\u0d4d\u0d31._\u0d12\u0d15\u0d4d\u0d1f\u0d4b._\u0d28\u0d35\u0d02._\u0d21\u0d3f\u0d38\u0d02.".split("_"),
        monthsParseExact: !0,
        weekdays: "\u0d1e\u0d3e\u0d2f\u0d31\u0d3e\u0d34\u0d4d\u0d1a_\u0d24\u0d3f\u0d19\u0d4d\u0d15\u0d33\u0d3e\u0d34\u0d4d\u0d1a_\u0d1a\u0d4a\u0d35\u0d4d\u0d35\u0d3e\u0d34\u0d4d\u0d1a_\u0d2c\u0d41\u0d27\u0d28\u0d3e\u0d34\u0d4d\u0d1a_\u0d35\u0d4d\u0d2f\u0d3e\u0d34\u0d3e\u0d34\u0d4d\u0d1a_\u0d35\u0d46\u0d33\u0d4d\u0d33\u0d3f\u0d2f\u0d3e\u0d34\u0d4d\u0d1a_\u0d36\u0d28\u0d3f\u0d2f\u0d3e\u0d34\u0d4d\u0d1a".split("_"),
        weekdaysShort: "\u0d1e\u0d3e\u0d2f\u0d7c_\u0d24\u0d3f\u0d19\u0d4d\u0d15\u0d7e_\u0d1a\u0d4a\u0d35\u0d4d\u0d35_\u0d2c\u0d41\u0d27\u0d7b_\u0d35\u0d4d\u0d2f\u0d3e\u0d34\u0d02_\u0d35\u0d46\u0d33\u0d4d\u0d33\u0d3f_\u0d36\u0d28\u0d3f".split("_"),
        weekdaysMin: "\u0d1e\u0d3e_\u0d24\u0d3f_\u0d1a\u0d4a_\u0d2c\u0d41_\u0d35\u0d4d\u0d2f\u0d3e_\u0d35\u0d46_\u0d36".split("_"),
        longDateFormat: {
            LT: "A h:mm -\u0d28\u0d41",
            LTS: "A h:mm:ss -\u0d28\u0d41",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm -\u0d28\u0d41",
            LLLL: "dddd, D MMMM YYYY, A h:mm -\u0d28\u0d41"
        },
        calendar: {
            sameDay: "[\u0d07\u0d28\u0d4d\u0d28\u0d4d] LT",
            nextDay: "[\u0d28\u0d3e\u0d33\u0d46] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0d07\u0d28\u0d4d\u0d28\u0d32\u0d46] LT",
            lastWeek: "[\u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d",
            past: "%s \u0d2e\u0d41\u0d7b\u0d2a\u0d4d",
            s: "\u0d05\u0d7d\u0d2a \u0d28\u0d3f\u0d2e\u0d3f\u0d37\u0d19\u0d4d\u0d19\u0d7e",
            ss: "%d \u0d38\u0d46\u0d15\u0d4d\u0d15\u0d7b\u0d21\u0d4d",
            m: "\u0d12\u0d30\u0d41 \u0d2e\u0d3f\u0d28\u0d3f\u0d31\u0d4d\u0d31\u0d4d",
            mm: "%d \u0d2e\u0d3f\u0d28\u0d3f\u0d31\u0d4d\u0d31\u0d4d",
            h: "\u0d12\u0d30\u0d41 \u0d2e\u0d23\u0d3f\u0d15\u0d4d\u0d15\u0d42\u0d7c",
            hh: "%d \u0d2e\u0d23\u0d3f\u0d15\u0d4d\u0d15\u0d42\u0d7c",
            d: "\u0d12\u0d30\u0d41 \u0d26\u0d3f\u0d35\u0d38\u0d02",
            dd: "%d \u0d26\u0d3f\u0d35\u0d38\u0d02",
            M: "\u0d12\u0d30\u0d41 \u0d2e\u0d3e\u0d38\u0d02",
            MM: "%d \u0d2e\u0d3e\u0d38\u0d02",
            y: "\u0d12\u0d30\u0d41 \u0d35\u0d7c\u0d37\u0d02",
            yy: "%d \u0d35\u0d7c\u0d37\u0d02"
        },
        meridiemParse: /\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f|\u0d30\u0d3e\u0d35\u0d3f\u0d32\u0d46|\u0d09\u0d1a\u0d4d\u0d1a \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d|\u0d35\u0d48\u0d15\u0d41\u0d28\u0d4d\u0d28\u0d47\u0d30\u0d02|\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f/i,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f" === a && 4 <= e || "\u0d09\u0d1a\u0d4d\u0d1a \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d" === a || "\u0d35\u0d48\u0d15\u0d41\u0d28\u0d4d\u0d28\u0d47\u0d30\u0d02" === a ? e + 12 : e;
        },
        meridiem: function(e, a, t) {
            return e < 4 ? "\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f" : e < 12 ? "\u0d30\u0d3e\u0d35\u0d3f\u0d32\u0d46" : e < 17 ? "\u0d09\u0d1a\u0d4d\u0d1a \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d" : e < 20 ? "\u0d35\u0d48\u0d15\u0d41\u0d28\u0d4d\u0d28\u0d47\u0d30\u0d02" : "\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f";
        }
    }), c.defineLocale("mn", {
        months: "\u041d\u044d\u0433\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0425\u043e\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0414\u04e9\u0440\u04e9\u0432\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0417\u0443\u0440\u0433\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0414\u043e\u043b\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u041d\u0430\u0439\u043c\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0415\u0441\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0410\u0440\u0432\u0430\u043d \u043d\u044d\u0433\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0410\u0440\u0432\u0430\u043d \u0445\u043e\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440".split("_"),
        monthsShort: "1 \u0441\u0430\u0440_2 \u0441\u0430\u0440_3 \u0441\u0430\u0440_4 \u0441\u0430\u0440_5 \u0441\u0430\u0440_6 \u0441\u0430\u0440_7 \u0441\u0430\u0440_8 \u0441\u0430\u0440_9 \u0441\u0430\u0440_10 \u0441\u0430\u0440_11 \u0441\u0430\u0440_12 \u0441\u0430\u0440".split("_"),
        monthsParseExact: !0,
        weekdays: "\u041d\u044f\u043c_\u0414\u0430\u0432\u0430\u0430_\u041c\u044f\u0433\u043c\u0430\u0440_\u041b\u0445\u0430\u0433\u0432\u0430_\u041f\u04af\u0440\u044d\u0432_\u0411\u0430\u0430\u0441\u0430\u043d_\u0411\u044f\u043c\u0431\u0430".split("_"),
        weekdaysShort: "\u041d\u044f\u043c_\u0414\u0430\u0432_\u041c\u044f\u0433_\u041b\u0445\u0430_\u041f\u04af\u0440_\u0411\u0430\u0430_\u0411\u044f\u043c".split("_"),
        weekdaysMin: "\u041d\u044f_\u0414\u0430_\u041c\u044f_\u041b\u0445_\u041f\u04af_\u0411\u0430_\u0411\u044f".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "YYYY \u043e\u043d\u044b MMMM\u044b\u043d D",
            LLL: "YYYY \u043e\u043d\u044b MMMM\u044b\u043d D HH:mm",
            LLLL: "dddd, YYYY \u043e\u043d\u044b MMMM\u044b\u043d D HH:mm"
        },
        meridiemParse: /\u04ae\u04e8|\u04ae\u0425/i,
        isPM: function(e) {
            return "\u04ae\u0425" === e;
        },
        meridiem: function(e, a, t) {
            return e < 12 ? "\u04ae\u04e8" : "\u04ae\u0425";
        },
        calendar: {
            sameDay: "[\u04e8\u043d\u04e9\u04e9\u0434\u04e9\u0440] LT",
            nextDay: "[\u041c\u0430\u0440\u0433\u0430\u0430\u0448] LT",
            nextWeek: "[\u0418\u0440\u044d\u0445] dddd LT",
            lastDay: "[\u04e8\u0447\u0438\u0433\u0434\u04e9\u0440] LT",
            lastWeek: "[\u04e8\u043d\u0433\u04e9\u0440\u0441\u04e9\u043d] dddd LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0434\u0430\u0440\u0430\u0430",
            past: "%s \u04e9\u043c\u043d\u04e9",
            s: sn,
            ss: sn,
            m: sn,
            mm: sn,
            h: sn,
            hh: sn,
            d: sn,
            dd: sn,
            M: sn,
            MM: sn,
            y: sn,
            yy: sn
        },
        dayOfMonthOrdinalParse: /\d{1,2} \u04e9\u0434\u04e9\u0440/,
        ordinal: function(e, a) {
            switch(a){
                case "d":
                case "D":
                case "DDD":
                    return e + " \u04e9\u0434\u04e9\u0440";
                default:
                    return e;
            }
        }
    });
    var nn = {
        1: "\u0967",
        2: "\u0968",
        3: "\u0969",
        4: "\u096a",
        5: "\u096b",
        6: "\u096c",
        7: "\u096d",
        8: "\u096e",
        9: "\u096f",
        0: "\u0966"
    }, rn = {
        "\u0967": "1",
        "\u0968": "2",
        "\u0969": "3",
        "\u096a": "4",
        "\u096b": "5",
        "\u096c": "6",
        "\u096d": "7",
        "\u096e": "8",
        "\u096f": "9",
        "\u0966": "0"
    };
    function dn(e, a, t, s) {
        var n = "";
        if (a) switch(t){
            case "s":
                n = "\u0915\u093e\u0939\u0940 \u0938\u0947\u0915\u0902\u0926";
                break;
            case "ss":
                n = "%d \u0938\u0947\u0915\u0902\u0926";
                break;
            case "m":
                n = "\u090f\u0915 \u092e\u093f\u0928\u093f\u091f";
                break;
            case "mm":
                n = "%d \u092e\u093f\u0928\u093f\u091f\u0947";
                break;
            case "h":
                n = "\u090f\u0915 \u0924\u093e\u0938";
                break;
            case "hh":
                n = "%d \u0924\u093e\u0938";
                break;
            case "d":
                n = "\u090f\u0915 \u0926\u093f\u0935\u0938";
                break;
            case "dd":
                n = "%d \u0926\u093f\u0935\u0938";
                break;
            case "M":
                n = "\u090f\u0915 \u092e\u0939\u093f\u0928\u093e";
                break;
            case "MM":
                n = "%d \u092e\u0939\u093f\u0928\u0947";
                break;
            case "y":
                n = "\u090f\u0915 \u0935\u0930\u094d\u0937";
                break;
            case "yy":
                n = "%d \u0935\u0930\u094d\u0937\u0947";
                break;
        }
        else switch(t){
            case "s":
                n = "\u0915\u093e\u0939\u0940 \u0938\u0947\u0915\u0902\u0926\u093e\u0902";
                break;
            case "ss":
                n = "%d \u0938\u0947\u0915\u0902\u0926\u093e\u0902";
                break;
            case "m":
                n = "\u090f\u0915\u093e \u092e\u093f\u0928\u093f\u091f\u093e";
                break;
            case "mm":
                n = "%d \u092e\u093f\u0928\u093f\u091f\u093e\u0902";
                break;
            case "h":
                n = "\u090f\u0915\u093e \u0924\u093e\u0938\u093e";
                break;
            case "hh":
                n = "%d \u0924\u093e\u0938\u093e\u0902";
                break;
            case "d":
                n = "\u090f\u0915\u093e \u0926\u093f\u0935\u0938\u093e";
                break;
            case "dd":
                n = "%d \u0926\u093f\u0935\u0938\u093e\u0902";
                break;
            case "M":
                n = "\u090f\u0915\u093e \u092e\u0939\u093f\u0928\u094d\u092f\u093e";
                break;
            case "MM":
                n = "%d \u092e\u0939\u093f\u0928\u094d\u092f\u093e\u0902";
                break;
            case "y":
                n = "\u090f\u0915\u093e \u0935\u0930\u094d\u0937\u093e";
                break;
            case "yy":
                n = "%d \u0935\u0930\u094d\u0937\u093e\u0902";
                break;
        }
        return n.replace(/%d/i, e);
    }
    c.defineLocale("mr", {
        months: "\u091c\u093e\u0928\u0947\u0935\u093e\u0930\u0940_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u093e\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u090f\u092a\u094d\u0930\u093f\u0932_\u092e\u0947_\u091c\u0942\u0928_\u091c\u0941\u0932\u0948_\u0911\u0917\u0938\u094d\u091f_\u0938\u092a\u094d\u091f\u0947\u0902\u092c\u0930_\u0911\u0915\u094d\u091f\u094b\u092c\u0930_\u0928\u094b\u0935\u094d\u0939\u0947\u0902\u092c\u0930_\u0921\u093f\u0938\u0947\u0902\u092c\u0930".split("_"),
        monthsShort: "\u091c\u093e\u0928\u0947._\u092b\u0947\u092c\u094d\u0930\u0941._\u092e\u093e\u0930\u094d\u091a._\u090f\u092a\u094d\u0930\u093f._\u092e\u0947._\u091c\u0942\u0928._\u091c\u0941\u0932\u0948._\u0911\u0917._\u0938\u092a\u094d\u091f\u0947\u0902._\u0911\u0915\u094d\u091f\u094b._\u0928\u094b\u0935\u094d\u0939\u0947\u0902._\u0921\u093f\u0938\u0947\u0902.".split("_"),
        monthsParseExact: !0,
        weekdays: "\u0930\u0935\u093f\u0935\u093e\u0930_\u0938\u094b\u092e\u0935\u093e\u0930_\u092e\u0902\u0917\u0933\u0935\u093e\u0930_\u092c\u0941\u0927\u0935\u093e\u0930_\u0917\u0941\u0930\u0942\u0935\u093e\u0930_\u0936\u0941\u0915\u094d\u0930\u0935\u093e\u0930_\u0936\u0928\u093f\u0935\u093e\u0930".split("_"),
        weekdaysShort: "\u0930\u0935\u093f_\u0938\u094b\u092e_\u092e\u0902\u0917\u0933_\u092c\u0941\u0927_\u0917\u0941\u0930\u0942_\u0936\u0941\u0915\u094d\u0930_\u0936\u0928\u093f".split("_"),
        weekdaysMin: "\u0930_\u0938\u094b_\u092e\u0902_\u092c\u0941_\u0917\u0941_\u0936\u0941_\u0936".split("_"),
        longDateFormat: {
            LT: "A h:mm \u0935\u093e\u091c\u0924\u093e",
            LTS: "A h:mm:ss \u0935\u093e\u091c\u0924\u093e",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm \u0935\u093e\u091c\u0924\u093e",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u0935\u093e\u091c\u0924\u093e"
        },
        calendar: {
            sameDay: "[\u0906\u091c] LT",
            nextDay: "[\u0909\u0926\u094d\u092f\u093e] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0915\u093e\u0932] LT",
            lastWeek: "[\u092e\u093e\u0917\u0940\u0932] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s\u092e\u0927\u094d\u092f\u0947",
            past: "%s\u092a\u0942\u0930\u094d\u0935\u0940",
            s: dn,
            ss: dn,
            m: dn,
            mm: dn,
            h: dn,
            hh: dn,
            d: dn,
            dd: dn,
            M: dn,
            MM: dn,
            y: dn,
            yy: dn
        },
        preparse: function(e) {
            return e.replace(/[\u0967\u0968\u0969\u096a\u096b\u096c\u096d\u096e\u096f\u0966]/g, function(e) {
                return rn[e];
            });
        },
        postformat: function(e) {
            return e.replace(/\d/g, function(e) {
                return nn[e];
            });
        },
        meridiemParse: /\u092a\u0939\u093e\u091f\u0947|\u0938\u0915\u093e\u0933\u0940|\u0926\u0941\u092a\u093e\u0930\u0940|\u0938\u093e\u092f\u0902\u0915\u093e\u0933\u0940|\u0930\u093e\u0924\u094d\u0930\u0940/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "\u092a\u0939\u093e\u091f\u0947" === a || "\u0938\u0915\u093e\u0933\u0940" === a ? e : "\u0926\u0941\u092a\u093e\u0930\u0940" === a || "\u0938\u093e\u092f\u0902\u0915\u093e\u0933\u0940" === a || "\u0930\u093e\u0924\u094d\u0930\u0940" === a ? 12 <= e ? e : e + 12 : void 0;
        },
        meridiem: function(e, a, t) {
            return 0 <= e && e < 6 ? "\u092a\u0939\u093e\u091f\u0947" : e < 12 ? "\u0938\u0915\u093e\u0933\u0940" : e < 17 ? "\u0926\u0941\u092a\u093e\u0930\u0940" : e < 20 ? "\u0938\u093e\u092f\u0902\u0915\u093e\u0933\u0940" : "\u0930\u093e\u0924\u094d\u0930\u0940";
        },
        week: {
            dow: 0,
            doy: 6
        }
    }), c.defineLocale("ms-my", {
        months: "Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),
        monthsShort: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),
        weekdays: "Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),
        weekdaysShort: "Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),
        weekdaysMin: "Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),
        longDateFormat: {
            LT: "HH.mm",
            LTS: "HH.mm.ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY [pukul] HH.mm",
            LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "pagi" === a ? e : "tengahari" === a ? 11 <= e ? e : e + 12 : "petang" === a || "malam" === a ? e + 12 : void 0;
        },
        meridiem: function(e, a, t) {
            return e < 11 ? "pagi" : e < 15 ? "tengahari" : e < 19 ? "petang" : "malam";
        },
        calendar: {
            sameDay: "[Hari ini pukul] LT",
            nextDay: "[Esok pukul] LT",
            nextWeek: "dddd [pukul] LT",
            lastDay: "[Kelmarin pukul] LT",
            lastWeek: "dddd [lepas pukul] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "dalam %s",
            past: "%s yang lepas",
            s: "beberapa saat",
            ss: "%d saat",
            m: "seminit",
            mm: "%d minit",
            h: "sejam",
            hh: "%d jam",
            d: "sehari",
            dd: "%d hari",
            M: "sebulan",
            MM: "%d bulan",
            y: "setahun",
            yy: "%d tahun"
        },
        week: {
            dow: 1,
            doy: 7
        }
    }), c.defineLocale("ms", {
        months: "Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),
        monthsShort: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),
        weekdays: "Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),
        weekdaysShort: "Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),
        weekdaysMin: "Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),
        longDateFormat: {
            LT: "HH.mm",
            LTS: "HH.mm.ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY [pukul] HH.mm",
            LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "pagi" === a ? e : "tengahari" === a ? 11 <= e ? e : e + 12 : "petang" === a || "malam" === a ? e + 12 : void 0;
        },
        meridiem: function(e, a, t) {
            return e < 11 ? "pagi" : e < 15 ? "tengahari" : e < 19 ? "petang" : "malam";
        },
        calendar: {
            sameDay: "[Hari ini pukul] LT",
            nextDay: "[Esok pukul] LT",
            nextWeek: "dddd [pukul] LT",
            lastDay: "[Kelmarin pukul] LT",
            lastWeek: "dddd [lepas pukul] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "dalam %s",
            past: "%s yang lepas",
            s: "beberapa saat",
            ss: "%d saat",
            m: "seminit",
            mm: "%d minit",
            h: "sejam",
            hh: "%d jam",
            d: "sehari",
            dd: "%d hari",
            M: "sebulan",
            MM: "%d bulan",
            y: "setahun",
            yy: "%d tahun"
        },
        week: {
            dow: 1,
            doy: 7
        }
    }), c.defineLocale("mt", {
        months: "Jannar_Frar_Marzu_April_Mejju_\u0120unju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Di\u010bembru".split("_"),
        monthsShort: "Jan_Fra_Mar_Apr_Mej_\u0120un_Lul_Aww_Set_Ott_Nov_Di\u010b".split("_"),
        weekdays: "Il-\u0126add_It-Tnejn_It-Tlieta_L-Erbg\u0127a_Il-\u0126amis_Il-\u0120img\u0127a_Is-Sibt".split("_"),
        weekdaysShort: "\u0126ad_Tne_Tli_Erb_\u0126am_\u0120im_Sib".split("_"),
        weekdaysMin: "\u0126a_Tn_Tl_Er_\u0126a_\u0120i_Si".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Illum fil-]LT",
            nextDay: "[G\u0127ada fil-]LT",
            nextWeek: "dddd [fil-]LT",
            lastDay: "[Il-biera\u0127 fil-]LT",
            lastWeek: "dddd [li g\u0127adda] [fil-]LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "f\u2019 %s",
            past: "%s ilu",
            s: "ftit sekondi",
            ss: "%d sekondi",
            m: "minuta",
            mm: "%d minuti",
            h: "sieg\u0127a",
            hh: "%d sieg\u0127at",
            d: "\u0121urnata",
            dd: "%d \u0121ranet",
            M: "xahar",
            MM: "%d xhur",
            y: "sena",
            yy: "%d sni"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\xba/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        }
    });
    var _n = {
        1: "\u1041",
        2: "\u1042",
        3: "\u1043",
        4: "\u1044",
        5: "\u1045",
        6: "\u1046",
        7: "\u1047",
        8: "\u1048",
        9: "\u1049",
        0: "\u1040"
    }, on = {
        "\u1041": "1",
        "\u1042": "2",
        "\u1043": "3",
        "\u1044": "4",
        "\u1045": "5",
        "\u1046": "6",
        "\u1047": "7",
        "\u1048": "8",
        "\u1049": "9",
        "\u1040": "0"
    }, mn = (c.defineLocale("my", {
        months: "\u1007\u1014\u103a\u1014\u101d\u102b\u101b\u102e_\u1016\u1031\u1016\u1031\u102c\u103a\u101d\u102b\u101b\u102e_\u1019\u1010\u103a_\u1027\u1015\u103c\u102e_\u1019\u1031_\u1007\u103d\u1014\u103a_\u1007\u1030\u101c\u102d\u102f\u1004\u103a_\u101e\u103c\u1002\u102f\u1010\u103a_\u1005\u1000\u103a\u1010\u1004\u103a\u1018\u102c_\u1021\u1031\u102c\u1000\u103a\u1010\u102d\u102f\u1018\u102c_\u1014\u102d\u102f\u101d\u1004\u103a\u1018\u102c_\u1012\u102e\u1007\u1004\u103a\u1018\u102c".split("_"),
        monthsShort: "\u1007\u1014\u103a_\u1016\u1031_\u1019\u1010\u103a_\u1015\u103c\u102e_\u1019\u1031_\u1007\u103d\u1014\u103a_\u101c\u102d\u102f\u1004\u103a_\u101e\u103c_\u1005\u1000\u103a_\u1021\u1031\u102c\u1000\u103a_\u1014\u102d\u102f_\u1012\u102e".split("_"),
        weekdays: "\u1010\u1014\u1004\u103a\u1039\u1002\u1014\u103d\u1031_\u1010\u1014\u1004\u103a\u1039\u101c\u102c_\u1021\u1004\u103a\u1039\u1002\u102b_\u1017\u102f\u1012\u1039\u1013\u101f\u1030\u1038_\u1000\u103c\u102c\u101e\u1015\u1010\u1031\u1038_\u101e\u1031\u102c\u1000\u103c\u102c_\u1005\u1014\u1031".split("_"),
        weekdaysShort: "\u1014\u103d\u1031_\u101c\u102c_\u1002\u102b_\u101f\u1030\u1038_\u1000\u103c\u102c_\u101e\u1031\u102c_\u1014\u1031".split("_"),
        weekdaysMin: "\u1014\u103d\u1031_\u101c\u102c_\u1002\u102b_\u101f\u1030\u1038_\u1000\u103c\u102c_\u101e\u1031\u102c_\u1014\u1031".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\u101a\u1014\u1031.] LT [\u1019\u103e\u102c]",
            nextDay: "[\u1019\u1014\u1000\u103a\u1016\u103c\u1014\u103a] LT [\u1019\u103e\u102c]",
            nextWeek: "dddd LT [\u1019\u103e\u102c]",
            lastDay: "[\u1019\u1014\u1031.\u1000] LT [\u1019\u103e\u102c]",
            lastWeek: "[\u1015\u103c\u102e\u1038\u1001\u1032\u1037\u101e\u1031\u102c] dddd LT [\u1019\u103e\u102c]",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u101c\u102c\u1019\u100a\u103a\u1037 %s \u1019\u103e\u102c",
            past: "\u101c\u103d\u1014\u103a\u1001\u1032\u1037\u101e\u1031\u102c %s \u1000",
            s: "\u1005\u1000\u1039\u1000\u1014\u103a.\u1021\u1014\u100a\u103a\u1038\u1004\u101a\u103a",
            ss: "%d \u1005\u1000\u1039\u1000\u1014\u1037\u103a",
            m: "\u1010\u1005\u103a\u1019\u102d\u1014\u1005\u103a",
            mm: "%d \u1019\u102d\u1014\u1005\u103a",
            h: "\u1010\u1005\u103a\u1014\u102c\u101b\u102e",
            hh: "%d \u1014\u102c\u101b\u102e",
            d: "\u1010\u1005\u103a\u101b\u1000\u103a",
            dd: "%d \u101b\u1000\u103a",
            M: "\u1010\u1005\u103a\u101c",
            MM: "%d \u101c",
            y: "\u1010\u1005\u103a\u1014\u103e\u1005\u103a",
            yy: "%d \u1014\u103e\u1005\u103a"
        },
        preparse: function(e) {
            return e.replace(/[\u1041\u1042\u1043\u1044\u1045\u1046\u1047\u1048\u1049\u1040]/g, function(e) {
                return on[e];
            });
        },
        postformat: function(e) {
            return e.replace(/\d/g, function(e) {
                return _n[e];
            });
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("nb", {
        months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),
        monthsShort: "jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split("_"),
        monthsParseExact: !0,
        weekdays: "s\xf8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xf8rdag".split("_"),
        weekdaysShort: "s\xf8._ma._ti._on._to._fr._l\xf8.".split("_"),
        weekdaysMin: "s\xf8_ma_ti_on_to_fr_l\xf8".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY [kl.] HH:mm",
            LLLL: "dddd D. MMMM YYYY [kl.] HH:mm"
        },
        calendar: {
            sameDay: "[i dag kl.] LT",
            nextDay: "[i morgen kl.] LT",
            nextWeek: "dddd [kl.] LT",
            lastDay: "[i g\xe5r kl.] LT",
            lastWeek: "[forrige] dddd [kl.] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "om %s",
            past: "%s siden",
            s: "noen sekunder",
            ss: "%d sekunder",
            m: "ett minutt",
            mm: "%d minutter",
            h: "\xe9n time",
            hh: "%d timer",
            d: "\xe9n dag",
            dd: "%d dager",
            w: "\xe9n uke",
            ww: "%d uker",
            M: "\xe9n m\xe5ned",
            MM: "%d m\xe5neder",
            y: "ett \xe5r",
            yy: "%d \xe5r"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    }), {
        1: "\u0967",
        2: "\u0968",
        3: "\u0969",
        4: "\u096a",
        5: "\u096b",
        6: "\u096c",
        7: "\u096d",
        8: "\u096e",
        9: "\u096f",
        0: "\u0966"
    }), un = {
        "\u0967": "1",
        "\u0968": "2",
        "\u0969": "3",
        "\u096a": "4",
        "\u096b": "5",
        "\u096c": "6",
        "\u096d": "7",
        "\u096e": "8",
        "\u096f": "9",
        "\u0966": "0"
    }, ln = (c.defineLocale("ne", {
        months: "\u091c\u0928\u0935\u0930\u0940_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u093f\u0932_\u092e\u0908_\u091c\u0941\u0928_\u091c\u0941\u0932\u093e\u0908_\u0905\u0917\u0937\u094d\u091f_\u0938\u0947\u092a\u094d\u091f\u0947\u092e\u094d\u092c\u0930_\u0905\u0915\u094d\u091f\u094b\u092c\u0930_\u0928\u094b\u092d\u0947\u092e\u094d\u092c\u0930_\u0921\u093f\u0938\u0947\u092e\u094d\u092c\u0930".split("_"),
        monthsShort: "\u091c\u0928._\u092b\u0947\u092c\u094d\u0930\u0941._\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u093f._\u092e\u0908_\u091c\u0941\u0928_\u091c\u0941\u0932\u093e\u0908._\u0905\u0917._\u0938\u0947\u092a\u094d\u091f._\u0905\u0915\u094d\u091f\u094b._\u0928\u094b\u092d\u0947._\u0921\u093f\u0938\u0947.".split("_"),
        monthsParseExact: !0,
        weekdays: "\u0906\u0907\u0924\u092c\u093e\u0930_\u0938\u094b\u092e\u092c\u093e\u0930_\u092e\u0919\u094d\u0917\u0932\u092c\u093e\u0930_\u092c\u0941\u0927\u092c\u093e\u0930_\u092c\u093f\u0939\u093f\u092c\u093e\u0930_\u0936\u0941\u0915\u094d\u0930\u092c\u093e\u0930_\u0936\u0928\u093f\u092c\u093e\u0930".split("_"),
        weekdaysShort: "\u0906\u0907\u0924._\u0938\u094b\u092e._\u092e\u0919\u094d\u0917\u0932._\u092c\u0941\u0927._\u092c\u093f\u0939\u093f._\u0936\u0941\u0915\u094d\u0930._\u0936\u0928\u093f.".split("_"),
        weekdaysMin: "\u0906._\u0938\u094b._\u092e\u0902._\u092c\u0941._\u092c\u093f._\u0936\u0941._\u0936.".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "A\u0915\u094b h:mm \u092c\u091c\u0947",
            LTS: "A\u0915\u094b h:mm:ss \u092c\u091c\u0947",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A\u0915\u094b h:mm \u092c\u091c\u0947",
            LLLL: "dddd, D MMMM YYYY, A\u0915\u094b h:mm \u092c\u091c\u0947"
        },
        preparse: function(e) {
            return e.replace(/[\u0967\u0968\u0969\u096a\u096b\u096c\u096d\u096e\u096f\u0966]/g, function(e) {
                return un[e];
            });
        },
        postformat: function(e) {
            return e.replace(/\d/g, function(e) {
                return mn[e];
            });
        },
        meridiemParse: /\u0930\u093e\u0924\u093f|\u092c\u093f\u0939\u093e\u0928|\u0926\u093f\u0909\u0901\u0938\u094b|\u0938\u093e\u0901\u091d/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "\u0930\u093e\u0924\u093f" === a ? e < 4 ? e : e + 12 : "\u092c\u093f\u0939\u093e\u0928" === a ? e : "\u0926\u093f\u0909\u0901\u0938\u094b" === a ? 10 <= e ? e : e + 12 : "\u0938\u093e\u0901\u091d" === a ? e + 12 : void 0;
        },
        meridiem: function(e, a, t) {
            return e < 3 ? "\u0930\u093e\u0924\u093f" : e < 12 ? "\u092c\u093f\u0939\u093e\u0928" : e < 16 ? "\u0926\u093f\u0909\u0901\u0938\u094b" : e < 20 ? "\u0938\u093e\u0901\u091d" : "\u0930\u093e\u0924\u093f";
        },
        calendar: {
            sameDay: "[\u0906\u091c] LT",
            nextDay: "[\u092d\u094b\u0932\u093f] LT",
            nextWeek: "[\u0906\u0909\u0901\u0926\u094b] dddd[,] LT",
            lastDay: "[\u0939\u093f\u091c\u094b] LT",
            lastWeek: "[\u0917\u090f\u0915\u094b] dddd[,] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s\u092e\u093e",
            past: "%s \u0905\u0917\u093e\u0921\u093f",
            s: "\u0915\u0947\u0939\u0940 \u0915\u094d\u0937\u0923",
            ss: "%d \u0938\u0947\u0915\u0947\u0923\u094d\u0921",
            m: "\u090f\u0915 \u092e\u093f\u0928\u0947\u091f",
            mm: "%d \u092e\u093f\u0928\u0947\u091f",
            h: "\u090f\u0915 \u0918\u0923\u094d\u091f\u093e",
            hh: "%d \u0918\u0923\u094d\u091f\u093e",
            d: "\u090f\u0915 \u0926\u093f\u0928",
            dd: "%d \u0926\u093f\u0928",
            M: "\u090f\u0915 \u092e\u0939\u093f\u0928\u093e",
            MM: "%d \u092e\u0939\u093f\u0928\u093e",
            y: "\u090f\u0915 \u092c\u0930\u094d\u0937",
            yy: "%d \u092c\u0930\u094d\u0937"
        },
        week: {
            dow: 0,
            doy: 6
        }
    }), "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_")), Mn = "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"), _ = [
        /^jan/i,
        /^feb/i,
        /^(maart|mrt\.?)$/i,
        /^apr/i,
        /^mei$/i,
        /^jun[i.]?$/i,
        /^jul[i.]?$/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ], Ie = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i, hn = (c.defineLocale("nl-be", {
        months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
        monthsShort: function(e, a) {
            return e ? (/-MMM-/.test(a) ? Mn : ln)[e.month()] : ln;
        },
        monthsRegex: Ie,
        monthsShortRegex: Ie,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
        monthsParse: _,
        longMonthsParse: _,
        shortMonthsParse: _,
        weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
        weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
        weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[vandaag om] LT",
            nextDay: "[morgen om] LT",
            nextWeek: "dddd [om] LT",
            lastDay: "[gisteren om] LT",
            lastWeek: "[afgelopen] dddd [om] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "over %s",
            past: "%s geleden",
            s: "een paar seconden",
            ss: "%d seconden",
            m: "\xe9\xe9n minuut",
            mm: "%d minuten",
            h: "\xe9\xe9n uur",
            hh: "%d uur",
            d: "\xe9\xe9n dag",
            dd: "%d dagen",
            M: "\xe9\xe9n maand",
            MM: "%d maanden",
            y: "\xe9\xe9n jaar",
            yy: "%d jaar"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function(e) {
            return e + (1 === e || 8 === e || 20 <= e ? "ste" : "de");
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_")), cn = "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"), Ye = [
        /^jan/i,
        /^feb/i,
        /^(maart|mrt\.?)$/i,
        /^apr/i,
        /^mei$/i,
        /^jun[i.]?$/i,
        /^jul[i.]?$/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ], ye = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i, Ln = (c.defineLocale("nl", {
        months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
        monthsShort: function(e, a) {
            return e ? (/-MMM-/.test(a) ? cn : hn)[e.month()] : hn;
        },
        monthsRegex: ye,
        monthsShortRegex: ye,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
        monthsParse: Ye,
        longMonthsParse: Ye,
        shortMonthsParse: Ye,
        weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
        weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
        weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD-MM-YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[vandaag om] LT",
            nextDay: "[morgen om] LT",
            nextWeek: "dddd [om] LT",
            lastDay: "[gisteren om] LT",
            lastWeek: "[afgelopen] dddd [om] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "over %s",
            past: "%s geleden",
            s: "een paar seconden",
            ss: "%d seconden",
            m: "\xe9\xe9n minuut",
            mm: "%d minuten",
            h: "\xe9\xe9n uur",
            hh: "%d uur",
            d: "\xe9\xe9n dag",
            dd: "%d dagen",
            w: "\xe9\xe9n week",
            ww: "%d weken",
            M: "\xe9\xe9n maand",
            MM: "%d maanden",
            y: "\xe9\xe9n jaar",
            yy: "%d jaar"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function(e) {
            return e + (1 === e || 8 === e || 20 <= e ? "ste" : "de");
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("nn", {
        months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),
        monthsShort: "jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split("_"),
        monthsParseExact: !0,
        weekdays: "sundag_m\xe5ndag_tysdag_onsdag_torsdag_fredag_laurdag".split("_"),
        weekdaysShort: "su._m\xe5._ty._on._to._fr._lau.".split("_"),
        weekdaysMin: "su_m\xe5_ty_on_to_fr_la".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY [kl.] H:mm",
            LLLL: "dddd D. MMMM YYYY [kl.] HH:mm"
        },
        calendar: {
            sameDay: "[I dag klokka] LT",
            nextDay: "[I morgon klokka] LT",
            nextWeek: "dddd [klokka] LT",
            lastDay: "[I g\xe5r klokka] LT",
            lastWeek: "[F\xf8reg\xe5ande] dddd [klokka] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "om %s",
            past: "%s sidan",
            s: "nokre sekund",
            ss: "%d sekund",
            m: "eit minutt",
            mm: "%d minutt",
            h: "ein time",
            hh: "%d timar",
            d: "ein dag",
            dd: "%d dagar",
            w: "ei veke",
            ww: "%d veker",
            M: "ein m\xe5nad",
            MM: "%d m\xe5nader",
            y: "eit \xe5r",
            yy: "%d \xe5r"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("oc-lnc", {
        months: {
            standalone: "geni\xe8r_febri\xe8r_mar\xe7_abril_mai_junh_julhet_agost_setembre_oct\xf2bre_novembre_decembre".split("_"),
            format: "de geni\xe8r_de febri\xe8r_de mar\xe7_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'oct\xf2bre_de novembre_de decembre".split("_"),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort: "gen._febr._mar\xe7_abr._mai_junh_julh._ago._set._oct._nov._dec.".split("_"),
        monthsParseExact: !0,
        weekdays: "dimenge_diluns_dimars_dim\xe8cres_dij\xf2us_divendres_dissabte".split("_"),
        weekdaysShort: "dg._dl._dm._dc._dj._dv._ds.".split("_"),
        weekdaysMin: "dg_dl_dm_dc_dj_dv_ds".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM [de] YYYY",
            ll: "D MMM YYYY",
            LLL: "D MMMM [de] YYYY [a] H:mm",
            lll: "D MMM YYYY, H:mm",
            LLLL: "dddd D MMMM [de] YYYY [a] H:mm",
            llll: "ddd D MMM YYYY, H:mm"
        },
        calendar: {
            sameDay: "[u\xe8i a] LT",
            nextDay: "[deman a] LT",
            nextWeek: "dddd [a] LT",
            lastDay: "[i\xe8r a] LT",
            lastWeek: "dddd [passat a] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "d'aqu\xed %s",
            past: "fa %s",
            s: "unas segondas",
            ss: "%d segondas",
            m: "una minuta",
            mm: "%d minutas",
            h: "una ora",
            hh: "%d oras",
            d: "un jorn",
            dd: "%d jorns",
            M: "un mes",
            MM: "%d meses",
            y: "un an",
            yy: "%d ans"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|\xe8|a)/,
        ordinal: function(e, a) {
            return e + ("w" !== a && "W" !== a ? 1 === e ? "r" : 2 === e ? "n" : 3 === e ? "r" : 4 === e ? "t" : "\xe8" : "a");
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), {
        1: "\u0a67",
        2: "\u0a68",
        3: "\u0a69",
        4: "\u0a6a",
        5: "\u0a6b",
        6: "\u0a6c",
        7: "\u0a6d",
        8: "\u0a6e",
        9: "\u0a6f",
        0: "\u0a66"
    }), Yn = {
        "\u0a67": "1",
        "\u0a68": "2",
        "\u0a69": "3",
        "\u0a6a": "4",
        "\u0a6b": "5",
        "\u0a6c": "6",
        "\u0a6d": "7",
        "\u0a6e": "8",
        "\u0a6f": "9",
        "\u0a66": "0"
    }, yn = (c.defineLocale("pa-in", {
        months: "\u0a1c\u0a28\u0a35\u0a30\u0a40_\u0a2b\u0a3c\u0a30\u0a35\u0a30\u0a40_\u0a2e\u0a3e\u0a30\u0a1a_\u0a05\u0a2a\u0a4d\u0a30\u0a48\u0a32_\u0a2e\u0a08_\u0a1c\u0a42\u0a28_\u0a1c\u0a41\u0a32\u0a3e\u0a08_\u0a05\u0a17\u0a38\u0a24_\u0a38\u0a24\u0a70\u0a2c\u0a30_\u0a05\u0a15\u0a24\u0a42\u0a2c\u0a30_\u0a28\u0a35\u0a70\u0a2c\u0a30_\u0a26\u0a38\u0a70\u0a2c\u0a30".split("_"),
        monthsShort: "\u0a1c\u0a28\u0a35\u0a30\u0a40_\u0a2b\u0a3c\u0a30\u0a35\u0a30\u0a40_\u0a2e\u0a3e\u0a30\u0a1a_\u0a05\u0a2a\u0a4d\u0a30\u0a48\u0a32_\u0a2e\u0a08_\u0a1c\u0a42\u0a28_\u0a1c\u0a41\u0a32\u0a3e\u0a08_\u0a05\u0a17\u0a38\u0a24_\u0a38\u0a24\u0a70\u0a2c\u0a30_\u0a05\u0a15\u0a24\u0a42\u0a2c\u0a30_\u0a28\u0a35\u0a70\u0a2c\u0a30_\u0a26\u0a38\u0a70\u0a2c\u0a30".split("_"),
        weekdays: "\u0a10\u0a24\u0a35\u0a3e\u0a30_\u0a38\u0a4b\u0a2e\u0a35\u0a3e\u0a30_\u0a2e\u0a70\u0a17\u0a32\u0a35\u0a3e\u0a30_\u0a2c\u0a41\u0a27\u0a35\u0a3e\u0a30_\u0a35\u0a40\u0a30\u0a35\u0a3e\u0a30_\u0a38\u0a3c\u0a41\u0a71\u0a15\u0a30\u0a35\u0a3e\u0a30_\u0a38\u0a3c\u0a28\u0a40\u0a1a\u0a30\u0a35\u0a3e\u0a30".split("_"),
        weekdaysShort: "\u0a10\u0a24_\u0a38\u0a4b\u0a2e_\u0a2e\u0a70\u0a17\u0a32_\u0a2c\u0a41\u0a27_\u0a35\u0a40\u0a30_\u0a38\u0a3c\u0a41\u0a15\u0a30_\u0a38\u0a3c\u0a28\u0a40".split("_"),
        weekdaysMin: "\u0a10\u0a24_\u0a38\u0a4b\u0a2e_\u0a2e\u0a70\u0a17\u0a32_\u0a2c\u0a41\u0a27_\u0a35\u0a40\u0a30_\u0a38\u0a3c\u0a41\u0a15\u0a30_\u0a38\u0a3c\u0a28\u0a40".split("_"),
        longDateFormat: {
            LT: "A h:mm \u0a35\u0a1c\u0a47",
            LTS: "A h:mm:ss \u0a35\u0a1c\u0a47",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm \u0a35\u0a1c\u0a47",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u0a35\u0a1c\u0a47"
        },
        calendar: {
            sameDay: "[\u0a05\u0a1c] LT",
            nextDay: "[\u0a15\u0a32] LT",
            nextWeek: "[\u0a05\u0a17\u0a32\u0a3e] dddd, LT",
            lastDay: "[\u0a15\u0a32] LT",
            lastWeek: "[\u0a2a\u0a3f\u0a1b\u0a32\u0a47] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0a35\u0a3f\u0a71\u0a1a",
            past: "%s \u0a2a\u0a3f\u0a1b\u0a32\u0a47",
            s: "\u0a15\u0a41\u0a1d \u0a38\u0a15\u0a3f\u0a70\u0a1f",
            ss: "%d \u0a38\u0a15\u0a3f\u0a70\u0a1f",
            m: "\u0a07\u0a15 \u0a2e\u0a3f\u0a70\u0a1f",
            mm: "%d \u0a2e\u0a3f\u0a70\u0a1f",
            h: "\u0a07\u0a71\u0a15 \u0a18\u0a70\u0a1f\u0a3e",
            hh: "%d \u0a18\u0a70\u0a1f\u0a47",
            d: "\u0a07\u0a71\u0a15 \u0a26\u0a3f\u0a28",
            dd: "%d \u0a26\u0a3f\u0a28",
            M: "\u0a07\u0a71\u0a15 \u0a2e\u0a39\u0a40\u0a28\u0a3e",
            MM: "%d \u0a2e\u0a39\u0a40\u0a28\u0a47",
            y: "\u0a07\u0a71\u0a15 \u0a38\u0a3e\u0a32",
            yy: "%d \u0a38\u0a3e\u0a32"
        },
        preparse: function(e) {
            return e.replace(/[\u0a67\u0a68\u0a69\u0a6a\u0a6b\u0a6c\u0a6d\u0a6e\u0a6f\u0a66]/g, function(e) {
                return Yn[e];
            });
        },
        postformat: function(e) {
            return e.replace(/\d/g, function(e) {
                return Ln[e];
            });
        },
        meridiemParse: /\u0a30\u0a3e\u0a24|\u0a38\u0a35\u0a47\u0a30|\u0a26\u0a41\u0a2a\u0a39\u0a3f\u0a30|\u0a38\u0a3c\u0a3e\u0a2e/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "\u0a30\u0a3e\u0a24" === a ? e < 4 ? e : e + 12 : "\u0a38\u0a35\u0a47\u0a30" === a ? e : "\u0a26\u0a41\u0a2a\u0a39\u0a3f\u0a30" === a ? 10 <= e ? e : e + 12 : "\u0a38\u0a3c\u0a3e\u0a2e" === a ? e + 12 : void 0;
        },
        meridiem: function(e, a, t) {
            return e < 4 ? "\u0a30\u0a3e\u0a24" : e < 10 ? "\u0a38\u0a35\u0a47\u0a30" : e < 17 ? "\u0a26\u0a41\u0a2a\u0a39\u0a3f\u0a30" : e < 20 ? "\u0a38\u0a3c\u0a3e\u0a2e" : "\u0a30\u0a3e\u0a24";
        },
        week: {
            dow: 0,
            doy: 6
        }
    }), "stycze\u0144_luty_marzec_kwiecie\u0144_maj_czerwiec_lipiec_sierpie\u0144_wrzesie\u0144_pa\u017adziernik_listopad_grudzie\u0144".split("_")), fn = "stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_wrze\u015bnia_pa\u017adziernika_listopada_grudnia".split("_"), na = [
        /^sty/i,
        /^lut/i,
        /^mar/i,
        /^kwi/i,
        /^maj/i,
        /^cze/i,
        /^lip/i,
        /^sie/i,
        /^wrz/i,
        /^pa\u017a/i,
        /^lis/i,
        /^gru/i
    ];
    function kn(e) {
        return e % 10 < 5 && 1 < e % 10 && ~~(e / 10) % 10 != 1;
    }
    function pn(e, a, t) {
        var s = e + " ";
        switch(t){
            case "ss":
                return s + (kn(e) ? "sekundy" : "sekund");
            case "m":
                return a ? "minuta" : "minut\u0119";
            case "mm":
                return s + (kn(e) ? "minuty" : "minut");
            case "h":
                return a ? "godzina" : "godzin\u0119";
            case "hh":
                return s + (kn(e) ? "godziny" : "godzin");
            case "ww":
                return s + (kn(e) ? "tygodnie" : "tygodni");
            case "MM":
                return s + (kn(e) ? "miesi\u0105ce" : "miesi\u0119cy");
            case "yy":
                return s + (kn(e) ? "lata" : "lat");
        }
    }
    function Dn(e, a, t) {
        return e + (20 <= e % 100 || 100 <= e && e % 100 == 0 ? " de " : " ") + ({
            ss: "secunde",
            mm: "minute",
            hh: "ore",
            dd: "zile",
            ww: "s\u0103pt\u0103m\xe2ni",
            MM: "luni",
            yy: "ani"
        })[t];
    }
    function Tn(e, a, t) {
        return "m" === t ? a ? "\u043c\u0438\u043d\u0443\u0442\u0430" : "\u043c\u0438\u043d\u0443\u0442\u0443" : e + " " + (e = +e, a = (a = ({
            ss: a ? "\u0441\u0435\u043a\u0443\u043d\u0434\u0430_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434" : "\u0441\u0435\u043a\u0443\u043d\u0434\u0443_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434",
            mm: a ? "\u043c\u0438\u043d\u0443\u0442\u0430_\u043c\u0438\u043d\u0443\u0442\u044b_\u043c\u0438\u043d\u0443\u0442" : "\u043c\u0438\u043d\u0443\u0442\u0443_\u043c\u0438\u043d\u0443\u0442\u044b_\u043c\u0438\u043d\u0443\u0442",
            hh: "\u0447\u0430\u0441_\u0447\u0430\u0441\u0430_\u0447\u0430\u0441\u043e\u0432",
            dd: "\u0434\u0435\u043d\u044c_\u0434\u043d\u044f_\u0434\u043d\u0435\u0439",
            ww: "\u043d\u0435\u0434\u0435\u043b\u044f_\u043d\u0435\u0434\u0435\u043b\u0438_\u043d\u0435\u0434\u0435\u043b\u044c",
            MM: "\u043c\u0435\u0441\u044f\u0446_\u043c\u0435\u0441\u044f\u0446\u0430_\u043c\u0435\u0441\u044f\u0446\u0435\u0432",
            yy: "\u0433\u043e\u0434_\u0433\u043e\u0434\u0430_\u043b\u0435\u0442"
        })[t]).split("_"), e % 10 == 1 && e % 100 != 11 ? a[0] : 2 <= e % 10 && e % 10 <= 4 && (e % 100 < 10 || 20 <= e % 100) ? a[1] : a[2]);
    }
    c.defineLocale("pl", {
        months: function(e, a) {
            return e ? (/D MMMM/.test(a) ? fn : yn)[e.month()] : yn;
        },
        monthsShort: "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_pa\u017a_lis_gru".split("_"),
        monthsParse: na,
        longMonthsParse: na,
        shortMonthsParse: na,
        weekdays: "niedziela_poniedzia\u0142ek_wtorek_\u015broda_czwartek_pi\u0105tek_sobota".split("_"),
        weekdaysShort: "ndz_pon_wt_\u015br_czw_pt_sob".split("_"),
        weekdaysMin: "Nd_Pn_Wt_\u015ar_Cz_Pt_So".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Dzi\u015b o] LT",
            nextDay: "[Jutro o] LT",
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[W niedziel\u0119 o] LT";
                    case 2:
                        return "[We wtorek o] LT";
                    case 3:
                        return "[W \u015brod\u0119 o] LT";
                    case 6:
                        return "[W sobot\u0119 o] LT";
                    default:
                        return "[W] dddd [o] LT";
                }
            },
            lastDay: "[Wczoraj o] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[W zesz\u0142\u0105 niedziel\u0119 o] LT";
                    case 3:
                        return "[W zesz\u0142\u0105 \u015brod\u0119 o] LT";
                    case 6:
                        return "[W zesz\u0142\u0105 sobot\u0119 o] LT";
                    default:
                        return "[W zesz\u0142y] dddd [o] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "za %s",
            past: "%s temu",
            s: "kilka sekund",
            ss: pn,
            m: pn,
            mm: pn,
            h: pn,
            hh: pn,
            d: "1 dzie\u0144",
            dd: "%d dni",
            w: "tydzie\u0144",
            ww: pn,
            M: "miesi\u0105c",
            MM: pn,
            y: "rok",
            yy: pn
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("pt-br", {
        months: "janeiro_fevereiro_mar\xe7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),
        monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
        weekdays: "domingo_segunda-feira_ter\xe7a-feira_quarta-feira_quinta-feira_sexta-feira_s\xe1bado".split("_"),
        weekdaysShort: "dom_seg_ter_qua_qui_sex_s\xe1b".split("_"),
        weekdaysMin: "do_2\xaa_3\xaa_4\xaa_5\xaa_6\xaa_s\xe1".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY [\xe0s] HH:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY [\xe0s] HH:mm"
        },
        calendar: {
            sameDay: "[Hoje \xe0s] LT",
            nextDay: "[Amanh\xe3 \xe0s] LT",
            nextWeek: "dddd [\xe0s] LT",
            lastDay: "[Ontem \xe0s] LT",
            lastWeek: function() {
                return 0 === this.day() || 6 === this.day() ? "[\xdaltimo] dddd [\xe0s] LT" : "[\xdaltima] dddd [\xe0s] LT";
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "em %s",
            past: "h\xe1 %s",
            s: "poucos segundos",
            ss: "%d segundos",
            m: "um minuto",
            mm: "%d minutos",
            h: "uma hora",
            hh: "%d horas",
            d: "um dia",
            dd: "%d dias",
            M: "um m\xeas",
            MM: "%d meses",
            y: "um ano",
            yy: "%d anos"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\xba/,
        ordinal: "%d\xba",
        invalidDate: "Data inv\xe1lida"
    }), c.defineLocale("pt", {
        months: "janeiro_fevereiro_mar\xe7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),
        monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
        weekdays: "Domingo_Segunda-feira_Ter\xe7a-feira_Quarta-feira_Quinta-feira_Sexta-feira_S\xe1bado".split("_"),
        weekdaysShort: "Dom_Seg_Ter_Qua_Qui_Sex_S\xe1b".split("_"),
        weekdaysMin: "Do_2\xaa_3\xaa_4\xaa_5\xaa_6\xaa_S\xe1".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY HH:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Hoje \xe0s] LT",
            nextDay: "[Amanh\xe3 \xe0s] LT",
            nextWeek: "dddd [\xe0s] LT",
            lastDay: "[Ontem \xe0s] LT",
            lastWeek: function() {
                return 0 === this.day() || 6 === this.day() ? "[\xdaltimo] dddd [\xe0s] LT" : "[\xdaltima] dddd [\xe0s] LT";
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "em %s",
            past: "h\xe1 %s",
            s: "segundos",
            ss: "%d segundos",
            m: "um minuto",
            mm: "%d minutos",
            h: "uma hora",
            hh: "%d horas",
            d: "um dia",
            dd: "%d dias",
            w: "uma semana",
            ww: "%d semanas",
            M: "um m\xeas",
            MM: "%d meses",
            y: "um ano",
            yy: "%d anos"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\xba/,
        ordinal: "%d\xba",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("ro", {
        months: "ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split("_"),
        monthsShort: "ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split("_"),
        monthsParseExact: !0,
        weekdays: "duminic\u0103_luni_mar\u021bi_miercuri_joi_vineri_s\xe2mb\u0103t\u0103".split("_"),
        weekdaysShort: "Dum_Lun_Mar_Mie_Joi_Vin_S\xe2m".split("_"),
        weekdaysMin: "Du_Lu_Ma_Mi_Jo_Vi_S\xe2".split("_"),
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY H:mm",
            LLLL: "dddd, D MMMM YYYY H:mm"
        },
        calendar: {
            sameDay: "[azi la] LT",
            nextDay: "[m\xe2ine la] LT",
            nextWeek: "dddd [la] LT",
            lastDay: "[ieri la] LT",
            lastWeek: "[fosta] dddd [la] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "peste %s",
            past: "%s \xeen urm\u0103",
            s: "c\xe2teva secunde",
            ss: Dn,
            m: "un minut",
            mm: Dn,
            h: "o or\u0103",
            hh: Dn,
            d: "o zi",
            dd: Dn,
            w: "o s\u0103pt\u0103m\xe2n\u0103",
            ww: Dn,
            M: "o lun\u0103",
            MM: Dn,
            y: "un an",
            yy: Dn
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    t = [
        /^\u044f\u043d\u0432/i,
        /^\u0444\u0435\u0432/i,
        /^\u043c\u0430\u0440/i,
        /^\u0430\u043f\u0440/i,
        /^\u043c\u0430[\u0439\u044f]/i,
        /^\u0438\u044e\u043d/i,
        /^\u0438\u044e\u043b/i,
        /^\u0430\u0432\u0433/i,
        /^\u0441\u0435\u043d/i,
        /^\u043e\u043a\u0442/i,
        /^\u043d\u043e\u044f/i,
        /^\u0434\u0435\u043a/i
    ], c.defineLocale("ru", {
        months: {
            format: "\u044f\u043d\u0432\u0430\u0440\u044f_\u0444\u0435\u0432\u0440\u0430\u043b\u044f_\u043c\u0430\u0440\u0442\u0430_\u0430\u043f\u0440\u0435\u043b\u044f_\u043c\u0430\u044f_\u0438\u044e\u043d\u044f_\u0438\u044e\u043b\u044f_\u0430\u0432\u0433\u0443\u0441\u0442\u0430_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044f_\u043e\u043a\u0442\u044f\u0431\u0440\u044f_\u043d\u043e\u044f\u0431\u0440\u044f_\u0434\u0435\u043a\u0430\u0431\u0440\u044f".split("_"),
            standalone: "\u044f\u043d\u0432\u0430\u0440\u044c_\u0444\u0435\u0432\u0440\u0430\u043b\u044c_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b\u044c_\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044c_\u043e\u043a\u0442\u044f\u0431\u0440\u044c_\u043d\u043e\u044f\u0431\u0440\u044c_\u0434\u0435\u043a\u0430\u0431\u0440\u044c".split("_")
        },
        monthsShort: {
            format: "\u044f\u043d\u0432._\u0444\u0435\u0432\u0440._\u043c\u0430\u0440._\u0430\u043f\u0440._\u043c\u0430\u044f_\u0438\u044e\u043d\u044f_\u0438\u044e\u043b\u044f_\u0430\u0432\u0433._\u0441\u0435\u043d\u0442._\u043e\u043a\u0442._\u043d\u043e\u044f\u0431._\u0434\u0435\u043a.".split("_"),
            standalone: "\u044f\u043d\u0432._\u0444\u0435\u0432\u0440._\u043c\u0430\u0440\u0442_\u0430\u043f\u0440._\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433._\u0441\u0435\u043d\u0442._\u043e\u043a\u0442._\u043d\u043e\u044f\u0431._\u0434\u0435\u043a.".split("_")
        },
        weekdays: {
            standalone: "\u0432\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u044c\u0435_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043f\u044f\u0442\u043d\u0438\u0446\u0430_\u0441\u0443\u0431\u0431\u043e\u0442\u0430".split("_"),
            format: "\u0432\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u044c\u0435_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043f\u044f\u0442\u043d\u0438\u0446\u0443_\u0441\u0443\u0431\u0431\u043e\u0442\u0443".split("_"),
            isFormat: /\[ ?[\u0412\u0432] ?(?:\u043f\u0440\u043e\u0448\u043b\u0443\u044e|\u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0443\u044e|\u044d\u0442\u0443)? ?] ?dddd/
        },
        weekdaysShort: "\u0432\u0441_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),
        weekdaysMin: "\u0432\u0441_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),
        monthsParse: t,
        longMonthsParse: t,
        shortMonthsParse: t,
        monthsRegex: /^(\u044f\u043d\u0432\u0430\u0440[\u044c\u044f]|\u044f\u043d\u0432\.?|\u0444\u0435\u0432\u0440\u0430\u043b[\u044c\u044f]|\u0444\u0435\u0432\u0440?\.?|\u043c\u0430\u0440\u0442\u0430?|\u043c\u0430\u0440\.?|\u0430\u043f\u0440\u0435\u043b[\u044c\u044f]|\u0430\u043f\u0440\.?|\u043c\u0430[\u0439\u044f]|\u0438\u044e\u043d[\u044c\u044f]|\u0438\u044e\u043d\.?|\u0438\u044e\u043b[\u044c\u044f]|\u0438\u044e\u043b\.?|\u0430\u0432\u0433\u0443\u0441\u0442\u0430?|\u0430\u0432\u0433\.?|\u0441\u0435\u043d\u0442\u044f\u0431\u0440[\u044c\u044f]|\u0441\u0435\u043d\u0442?\.?|\u043e\u043a\u0442\u044f\u0431\u0440[\u044c\u044f]|\u043e\u043a\u0442\.?|\u043d\u043e\u044f\u0431\u0440[\u044c\u044f]|\u043d\u043e\u044f\u0431?\.?|\u0434\u0435\u043a\u0430\u0431\u0440[\u044c\u044f]|\u0434\u0435\u043a\.?)/i,
        monthsShortRegex: /^(\u044f\u043d\u0432\u0430\u0440[\u044c\u044f]|\u044f\u043d\u0432\.?|\u0444\u0435\u0432\u0440\u0430\u043b[\u044c\u044f]|\u0444\u0435\u0432\u0440?\.?|\u043c\u0430\u0440\u0442\u0430?|\u043c\u0430\u0440\.?|\u0430\u043f\u0440\u0435\u043b[\u044c\u044f]|\u0430\u043f\u0440\.?|\u043c\u0430[\u0439\u044f]|\u0438\u044e\u043d[\u044c\u044f]|\u0438\u044e\u043d\.?|\u0438\u044e\u043b[\u044c\u044f]|\u0438\u044e\u043b\.?|\u0430\u0432\u0433\u0443\u0441\u0442\u0430?|\u0430\u0432\u0433\.?|\u0441\u0435\u043d\u0442\u044f\u0431\u0440[\u044c\u044f]|\u0441\u0435\u043d\u0442?\.?|\u043e\u043a\u0442\u044f\u0431\u0440[\u044c\u044f]|\u043e\u043a\u0442\.?|\u043d\u043e\u044f\u0431\u0440[\u044c\u044f]|\u043d\u043e\u044f\u0431?\.?|\u0434\u0435\u043a\u0430\u0431\u0440[\u044c\u044f]|\u0434\u0435\u043a\.?)/i,
        monthsStrictRegex: /^(\u044f\u043d\u0432\u0430\u0440[\u044f\u044c]|\u0444\u0435\u0432\u0440\u0430\u043b[\u044f\u044c]|\u043c\u0430\u0440\u0442\u0430?|\u0430\u043f\u0440\u0435\u043b[\u044f\u044c]|\u043c\u0430[\u044f\u0439]|\u0438\u044e\u043d[\u044f\u044c]|\u0438\u044e\u043b[\u044f\u044c]|\u0430\u0432\u0433\u0443\u0441\u0442\u0430?|\u0441\u0435\u043d\u0442\u044f\u0431\u0440[\u044f\u044c]|\u043e\u043a\u0442\u044f\u0431\u0440[\u044f\u044c]|\u043d\u043e\u044f\u0431\u0440[\u044f\u044c]|\u0434\u0435\u043a\u0430\u0431\u0440[\u044f\u044c])/i,
        monthsShortStrictRegex: /^(\u044f\u043d\u0432\.|\u0444\u0435\u0432\u0440?\.|\u043c\u0430\u0440[\u0442.]|\u0430\u043f\u0440\.|\u043c\u0430[\u044f\u0439]|\u0438\u044e\u043d[\u044c\u044f.]|\u0438\u044e\u043b[\u044c\u044f.]|\u0430\u0432\u0433\.|\u0441\u0435\u043d\u0442?\.|\u043e\u043a\u0442\.|\u043d\u043e\u044f\u0431?\.|\u0434\u0435\u043a\.)/i,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY \u0433.",
            LLL: "D MMMM YYYY \u0433., H:mm",
            LLLL: "dddd, D MMMM YYYY \u0433., H:mm"
        },
        calendar: {
            sameDay: "[\u0421\u0435\u0433\u043e\u0434\u043d\u044f, \u0432] LT",
            nextDay: "[\u0417\u0430\u0432\u0442\u0440\u0430, \u0432] LT",
            lastDay: "[\u0412\u0447\u0435\u0440\u0430, \u0432] LT",
            nextWeek: function(e) {
                if (e.week() === this.week()) return 2 === this.day() ? "[\u0412\u043e] dddd, [\u0432] LT" : "[\u0412] dddd, [\u0432] LT";
                switch(this.day()){
                    case 0:
                        return "[\u0412 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0435\u0435] dddd, [\u0432] LT";
                    case 1:
                    case 2:
                    case 4:
                        return "[\u0412 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0439] dddd, [\u0432] LT";
                    case 3:
                    case 5:
                    case 6:
                        return "[\u0412 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0443\u044e] dddd, [\u0432] LT";
                }
            },
            lastWeek: function(e) {
                if (e.week() === this.week()) return 2 === this.day() ? "[\u0412\u043e] dddd, [\u0432] LT" : "[\u0412] dddd, [\u0432] LT";
                switch(this.day()){
                    case 0:
                        return "[\u0412 \u043f\u0440\u043e\u0448\u043b\u043e\u0435] dddd, [\u0432] LT";
                    case 1:
                    case 2:
                    case 4:
                        return "[\u0412 \u043f\u0440\u043e\u0448\u043b\u044b\u0439] dddd, [\u0432] LT";
                    case 3:
                    case 5:
                    case 6:
                        return "[\u0412 \u043f\u0440\u043e\u0448\u043b\u0443\u044e] dddd, [\u0432] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0447\u0435\u0440\u0435\u0437 %s",
            past: "%s \u043d\u0430\u0437\u0430\u0434",
            s: "\u043d\u0435\u0441\u043a\u043e\u043b\u044c\u043a\u043e \u0441\u0435\u043a\u0443\u043d\u0434",
            ss: Tn,
            m: Tn,
            mm: Tn,
            h: "\u0447\u0430\u0441",
            hh: Tn,
            d: "\u0434\u0435\u043d\u044c",
            dd: Tn,
            w: "\u043d\u0435\u0434\u0435\u043b\u044f",
            ww: Tn,
            M: "\u043c\u0435\u0441\u044f\u0446",
            MM: Tn,
            y: "\u0433\u043e\u0434",
            yy: Tn
        },
        meridiemParse: /\u043d\u043e\u0447\u0438|\u0443\u0442\u0440\u0430|\u0434\u043d\u044f|\u0432\u0435\u0447\u0435\u0440\u0430/i,
        isPM: function(e) {
            return /^(\u0434\u043d\u044f|\u0432\u0435\u0447\u0435\u0440\u0430)$/.test(e);
        },
        meridiem: function(e, a, t) {
            return e < 4 ? "\u043d\u043e\u0447\u0438" : e < 12 ? "\u0443\u0442\u0440\u0430" : e < 17 ? "\u0434\u043d\u044f" : "\u0432\u0435\u0447\u0435\u0440\u0430";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(\u0439|\u0433\u043e|\u044f)/,
        ordinal: function(e, a) {
            switch(a){
                case "M":
                case "d":
                case "DDD":
                    return e + "-\u0439";
                case "D":
                    return e + "-\u0433\u043e";
                case "w":
                case "W":
                    return e + "-\u044f";
                default:
                    return e;
            }
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), m = [
        "\u062c\u0646\u0648\u0631\u064a",
        "\u0641\u064a\u0628\u0631\u0648\u0631\u064a",
        "\u0645\u0627\u0631\u0686",
        "\u0627\u067e\u0631\u064a\u0644",
        "\u0645\u0626\u064a",
        "\u062c\u0648\u0646",
        "\u062c\u0648\u0644\u0627\u0621\u0650",
        "\u0622\u06af\u0633\u067d",
        "\u0633\u064a\u067e\u067d\u0645\u0628\u0631",
        "\u0622\u06aa\u067d\u0648\u0628\u0631",
        "\u0646\u0648\u0645\u0628\u0631",
        "\u068a\u0633\u0645\u0628\u0631"
    ], o = [
        "\u0622\u0686\u0631",
        "\u0633\u0648\u0645\u0631",
        "\u0627\u06b1\u0627\u0631\u0648",
        "\u0627\u0631\u0628\u0639",
        "\u062e\u0645\u064a\u0633",
        "\u062c\u0645\u0639",
        "\u0687\u0646\u0687\u0631"
    ], c.defineLocale("sd", {
        months: m,
        monthsShort: m,
        weekdays: o,
        weekdaysShort: o,
        weekdaysMin: o,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd\u060c D MMMM YYYY HH:mm"
        },
        meridiemParse: /\u0635\u0628\u062d|\u0634\u0627\u0645/,
        isPM: function(e) {
            return "\u0634\u0627\u0645" === e;
        },
        meridiem: function(e, a, t) {
            return e < 12 ? "\u0635\u0628\u062d" : "\u0634\u0627\u0645";
        },
        calendar: {
            sameDay: "[\u0627\u0684] LT",
            nextDay: "[\u0633\u0680\u0627\u06bb\u064a] LT",
            nextWeek: "dddd [\u0627\u06b3\u064a\u0646 \u0647\u0641\u062a\u064a \u062a\u064a] LT",
            lastDay: "[\u06aa\u0627\u0644\u0647\u0647] LT",
            lastWeek: "[\u06af\u0632\u0631\u064a\u0644 \u0647\u0641\u062a\u064a] dddd [\u062a\u064a] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u067e\u0648\u0621",
            past: "%s \u0627\u06b3",
            s: "\u0686\u0646\u062f \u0633\u064a\u06aa\u0646\u068a",
            ss: "%d \u0633\u064a\u06aa\u0646\u068a",
            m: "\u0647\u06aa \u0645\u0646\u067d",
            mm: "%d \u0645\u0646\u067d",
            h: "\u0647\u06aa \u06aa\u0644\u0627\u06aa",
            hh: "%d \u06aa\u0644\u0627\u06aa",
            d: "\u0647\u06aa \u068f\u064a\u0646\u0647\u0646",
            dd: "%d \u068f\u064a\u0646\u0647\u0646",
            M: "\u0647\u06aa \u0645\u0647\u064a\u0646\u0648",
            MM: "%d \u0645\u0647\u064a\u0646\u0627",
            y: "\u0647\u06aa \u0633\u0627\u0644",
            yy: "%d \u0633\u0627\u0644"
        },
        preparse: function(e) {
            return e.replace(/\u060c/g, ",");
        },
        postformat: function(e) {
            return e.replace(/,/g, "\u060c");
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("se", {
        months: "o\u0111\u0111ajagem\xe1nnu_guovvam\xe1nnu_njuk\u010dam\xe1nnu_cuo\u014bom\xe1nnu_miessem\xe1nnu_geassem\xe1nnu_suoidnem\xe1nnu_borgem\xe1nnu_\u010dak\u010dam\xe1nnu_golggotm\xe1nnu_sk\xe1bmam\xe1nnu_juovlam\xe1nnu".split("_"),
        monthsShort: "o\u0111\u0111j_guov_njuk_cuo_mies_geas_suoi_borg_\u010dak\u010d_golg_sk\xe1b_juov".split("_"),
        weekdays: "sotnabeaivi_vuoss\xe1rga_ma\u014b\u014beb\xe1rga_gaskavahkku_duorastat_bearjadat_l\xe1vvardat".split("_"),
        weekdaysShort: "sotn_vuos_ma\u014b_gask_duor_bear_l\xe1v".split("_"),
        weekdaysMin: "s_v_m_g_d_b_L".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "MMMM D. [b.] YYYY",
            LLL: "MMMM D. [b.] YYYY [ti.] HH:mm",
            LLLL: "dddd, MMMM D. [b.] YYYY [ti.] HH:mm"
        },
        calendar: {
            sameDay: "[otne ti] LT",
            nextDay: "[ihttin ti] LT",
            nextWeek: "dddd [ti] LT",
            lastDay: "[ikte ti] LT",
            lastWeek: "[ovddit] dddd [ti] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s gea\u017ees",
            past: "ma\u014bit %s",
            s: "moadde sekunddat",
            ss: "%d sekunddat",
            m: "okta minuhta",
            mm: "%d minuhtat",
            h: "okta diimmu",
            hh: "%d diimmut",
            d: "okta beaivi",
            dd: "%d beaivvit",
            M: "okta m\xe1nnu",
            MM: "%d m\xe1nut",
            y: "okta jahki",
            yy: "%d jagit"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("si", {
        months: "\u0da2\u0db1\u0dc0\u0dcf\u0dbb\u0dd2_\u0db4\u0dd9\u0db6\u0dbb\u0dc0\u0dcf\u0dbb\u0dd2_\u0db8\u0dcf\u0dbb\u0dca\u0dad\u0dd4_\u0d85\u0db4\u0dca\u200d\u0dbb\u0dda\u0dbd\u0dca_\u0db8\u0dd0\u0dba\u0dd2_\u0da2\u0dd6\u0db1\u0dd2_\u0da2\u0dd6\u0dbd\u0dd2_\u0d85\u0d9c\u0ddd\u0dc3\u0dca\u0dad\u0dd4_\u0dc3\u0dd0\u0db4\u0dca\u0dad\u0dd0\u0db8\u0dca\u0db6\u0dbb\u0dca_\u0d94\u0d9a\u0dca\u0dad\u0ddd\u0db6\u0dbb\u0dca_\u0db1\u0ddc\u0dc0\u0dd0\u0db8\u0dca\u0db6\u0dbb\u0dca_\u0daf\u0dd9\u0dc3\u0dd0\u0db8\u0dca\u0db6\u0dbb\u0dca".split("_"),
        monthsShort: "\u0da2\u0db1_\u0db4\u0dd9\u0db6_\u0db8\u0dcf\u0dbb\u0dca_\u0d85\u0db4\u0dca_\u0db8\u0dd0\u0dba\u0dd2_\u0da2\u0dd6\u0db1\u0dd2_\u0da2\u0dd6\u0dbd\u0dd2_\u0d85\u0d9c\u0ddd_\u0dc3\u0dd0\u0db4\u0dca_\u0d94\u0d9a\u0dca_\u0db1\u0ddc\u0dc0\u0dd0_\u0daf\u0dd9\u0dc3\u0dd0".split("_"),
        weekdays: "\u0d89\u0dbb\u0dd2\u0daf\u0dcf_\u0dc3\u0db3\u0dd4\u0daf\u0dcf_\u0d85\u0d9f\u0dc4\u0dbb\u0dd4\u0dc0\u0dcf\u0daf\u0dcf_\u0db6\u0daf\u0dcf\u0daf\u0dcf_\u0db6\u0dca\u200d\u0dbb\u0dc4\u0dc3\u0dca\u0db4\u0dad\u0dd2\u0db1\u0dca\u0daf\u0dcf_\u0dc3\u0dd2\u0d9a\u0dd4\u0dbb\u0dcf\u0daf\u0dcf_\u0dc3\u0dd9\u0db1\u0dc3\u0dd4\u0dbb\u0dcf\u0daf\u0dcf".split("_"),
        weekdaysShort: "\u0d89\u0dbb\u0dd2_\u0dc3\u0db3\u0dd4_\u0d85\u0d9f_\u0db6\u0daf\u0dcf_\u0db6\u0dca\u200d\u0dbb\u0dc4_\u0dc3\u0dd2\u0d9a\u0dd4_\u0dc3\u0dd9\u0db1".split("_"),
        weekdaysMin: "\u0d89_\u0dc3_\u0d85_\u0db6_\u0db6\u0dca\u200d\u0dbb_\u0dc3\u0dd2_\u0dc3\u0dd9".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "a h:mm",
            LTS: "a h:mm:ss",
            L: "YYYY/MM/DD",
            LL: "YYYY MMMM D",
            LLL: "YYYY MMMM D, a h:mm",
            LLLL: "YYYY MMMM D [\u0dc0\u0dd0\u0db1\u0dd2] dddd, a h:mm:ss"
        },
        calendar: {
            sameDay: "[\u0d85\u0daf] LT[\u0da7]",
            nextDay: "[\u0dc4\u0dd9\u0da7] LT[\u0da7]",
            nextWeek: "dddd LT[\u0da7]",
            lastDay: "[\u0d8a\u0dba\u0dda] LT[\u0da7]",
            lastWeek: "[\u0db4\u0dc3\u0dd4\u0d9c\u0dd2\u0dba] dddd LT[\u0da7]",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s\u0d9a\u0dd2\u0db1\u0dca",
            past: "%s\u0d9a\u0da7 \u0db4\u0dd9\u0dbb",
            s: "\u0dad\u0dad\u0dca\u0db4\u0dbb \u0d9a\u0dd2\u0dc4\u0dd2\u0db4\u0dba",
            ss: "\u0dad\u0dad\u0dca\u0db4\u0dbb %d",
            m: "\u0db8\u0dd2\u0db1\u0dd2\u0dad\u0dca\u0dad\u0dd4\u0dc0",
            mm: "\u0db8\u0dd2\u0db1\u0dd2\u0dad\u0dca\u0dad\u0dd4 %d",
            h: "\u0db4\u0dd0\u0dba",
            hh: "\u0db4\u0dd0\u0dba %d",
            d: "\u0daf\u0dd2\u0db1\u0dba",
            dd: "\u0daf\u0dd2\u0db1 %d",
            M: "\u0db8\u0dcf\u0dc3\u0dba",
            MM: "\u0db8\u0dcf\u0dc3 %d",
            y: "\u0dc0\u0dc3\u0dbb",
            yy: "\u0dc0\u0dc3\u0dbb %d"
        },
        dayOfMonthOrdinalParse: /\d{1,2} \u0dc0\u0dd0\u0db1\u0dd2/,
        ordinal: function(e) {
            return e + " \u0dc0\u0dd0\u0db1\u0dd2";
        },
        meridiemParse: /\u0db4\u0dd9\u0dbb \u0dc0\u0dbb\u0dd4|\u0db4\u0dc3\u0dca \u0dc0\u0dbb\u0dd4|\u0db4\u0dd9.\u0dc0|\u0db4.\u0dc0./,
        isPM: function(e) {
            return "\u0db4.\u0dc0." === e || "\u0db4\u0dc3\u0dca \u0dc0\u0dbb\u0dd4" === e;
        },
        meridiem: function(e, a, t) {
            return 11 < e ? t ? "\u0db4.\u0dc0." : "\u0db4\u0dc3\u0dca \u0dc0\u0dbb\u0dd4" : t ? "\u0db4\u0dd9.\u0dc0." : "\u0db4\u0dd9\u0dbb \u0dc0\u0dbb\u0dd4";
        }
    }), n = "janu\xe1r_febru\xe1r_marec_apr\xedl_m\xe1j_j\xfan_j\xfal_august_september_okt\xf3ber_november_december".split("_"), ze = "jan_feb_mar_apr_m\xe1j_j\xfan_j\xfal_aug_sep_okt_nov_dec".split("_");
    function gn(e) {
        return 1 < e && e < 5;
    }
    function wn(e, a, t, s) {
        var n = e + " ";
        switch(t){
            case "s":
                return a || s ? "p\xe1r sek\xfand" : "p\xe1r sekundami";
            case "ss":
                return a || s ? n + (gn(e) ? "sekundy" : "sek\xfand") : n + "sekundami";
            case "m":
                return a ? "min\xfata" : s ? "min\xfatu" : "min\xfatou";
            case "mm":
                return a || s ? n + (gn(e) ? "min\xfaty" : "min\xfat") : n + "min\xfatami";
            case "h":
                return a ? "hodina" : s ? "hodinu" : "hodinou";
            case "hh":
                return a || s ? n + (gn(e) ? "hodiny" : "hod\xedn") : n + "hodinami";
            case "d":
                return a || s ? "de\u0148" : "d\u0148om";
            case "dd":
                return a || s ? n + (gn(e) ? "dni" : "dn\xed") : n + "d\u0148ami";
            case "M":
                return a || s ? "mesiac" : "mesiacom";
            case "MM":
                return a || s ? n + (gn(e) ? "mesiace" : "mesiacov") : n + "mesiacmi";
            case "y":
                return a || s ? "rok" : "rokom";
            case "yy":
                return a || s ? n + (gn(e) ? "roky" : "rokov") : n + "rokmi";
        }
    }
    function bn(e, a, t, s) {
        var n = e + " ";
        switch(t){
            case "s":
                return a || s ? "nekaj sekund" : "nekaj sekundami";
            case "ss":
                return n += 1 === e ? a ? "sekundo" : "sekundi" : 2 === e ? a || s ? "sekundi" : "sekundah" : e < 5 ? a || s ? "sekunde" : "sekundah" : "sekund";
            case "m":
                return a ? "ena minuta" : "eno minuto";
            case "mm":
                return n += 1 === e ? a ? "minuta" : "minuto" : 2 === e ? a || s ? "minuti" : "minutama" : e < 5 ? a || s ? "minute" : "minutami" : a || s ? "minut" : "minutami";
            case "h":
                return a ? "ena ura" : "eno uro";
            case "hh":
                return n += 1 === e ? a ? "ura" : "uro" : 2 === e ? a || s ? "uri" : "urama" : e < 5 ? a || s ? "ure" : "urami" : a || s ? "ur" : "urami";
            case "d":
                return a || s ? "en dan" : "enim dnem";
            case "dd":
                return n += 1 === e ? a || s ? "dan" : "dnem" : 2 === e ? a || s ? "dni" : "dnevoma" : a || s ? "dni" : "dnevi";
            case "M":
                return a || s ? "en mesec" : "enim mesecem";
            case "MM":
                return n += 1 === e ? a || s ? "mesec" : "mesecem" : 2 === e ? a || s ? "meseca" : "mesecema" : e < 5 ? a || s ? "mesece" : "meseci" : a || s ? "mesecev" : "meseci";
            case "y":
                return a || s ? "eno leto" : "enim letom";
            case "yy":
                return n += 1 === e ? a || s ? "leto" : "letom" : 2 === e ? a || s ? "leti" : "letoma" : e < 5 ? a || s ? "leta" : "leti" : a || s ? "let" : "leti";
        }
    }
    c.defineLocale("sk", {
        months: n,
        monthsShort: ze,
        weekdays: "nede\u013ea_pondelok_utorok_streda_\u0161tvrtok_piatok_sobota".split("_"),
        weekdaysShort: "ne_po_ut_st_\u0161t_pi_so".split("_"),
        weekdaysMin: "ne_po_ut_st_\u0161t_pi_so".split("_"),
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm",
            LLLL: "dddd D. MMMM YYYY H:mm"
        },
        calendar: {
            sameDay: "[dnes o] LT",
            nextDay: "[zajtra o] LT",
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[v nede\u013eu o] LT";
                    case 1:
                    case 2:
                        return "[v] dddd [o] LT";
                    case 3:
                        return "[v stredu o] LT";
                    case 4:
                        return "[vo \u0161tvrtok o] LT";
                    case 5:
                        return "[v piatok o] LT";
                    case 6:
                        return "[v sobotu o] LT";
                }
            },
            lastDay: "[v\u010dera o] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[minul\xfa nede\u013eu o] LT";
                    case 1:
                    case 2:
                        return "[minul\xfd] dddd [o] LT";
                    case 3:
                        return "[minul\xfa stredu o] LT";
                    case 4:
                    case 5:
                        return "[minul\xfd] dddd [o] LT";
                    case 6:
                        return "[minul\xfa sobotu o] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "za %s",
            past: "pred %s",
            s: wn,
            ss: wn,
            m: wn,
            mm: wn,
            h: wn,
            hh: wn,
            d: wn,
            dd: wn,
            M: wn,
            MM: wn,
            y: wn,
            yy: wn
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("sl", {
        months: "januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split("_"),
        monthsShort: "jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split("_"),
        monthsParseExact: !0,
        weekdays: "nedelja_ponedeljek_torek_sreda_\u010detrtek_petek_sobota".split("_"),
        weekdaysShort: "ned._pon._tor._sre._\u010det._pet._sob.".split("_"),
        weekdaysMin: "ne_po_to_sr_\u010de_pe_so".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD. MM. YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm",
            LLLL: "dddd, D. MMMM YYYY H:mm"
        },
        calendar: {
            sameDay: "[danes ob] LT",
            nextDay: "[jutri ob] LT",
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[v] [nedeljo] [ob] LT";
                    case 3:
                        return "[v] [sredo] [ob] LT";
                    case 6:
                        return "[v] [soboto] [ob] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[v] dddd [ob] LT";
                }
            },
            lastDay: "[v\u010deraj ob] LT",
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[prej\u0161njo] [nedeljo] [ob] LT";
                    case 3:
                        return "[prej\u0161njo] [sredo] [ob] LT";
                    case 6:
                        return "[prej\u0161njo] [soboto] [ob] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[prej\u0161nji] dddd [ob] LT";
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "\u010dez %s",
            past: "pred %s",
            s: bn,
            ss: bn,
            m: bn,
            mm: bn,
            h: bn,
            hh: bn,
            d: bn,
            dd: bn,
            M: bn,
            MM: bn,
            y: bn,
            yy: bn
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 7
        }
    }), c.defineLocale("sq", {
        months: "Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_N\xebntor_Dhjetor".split("_"),
        monthsShort: "Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_N\xebn_Dhj".split("_"),
        weekdays: "E Diel_E H\xebn\xeb_E Mart\xeb_E M\xebrkur\xeb_E Enjte_E Premte_E Shtun\xeb".split("_"),
        weekdaysShort: "Die_H\xebn_Mar_M\xebr_Enj_Pre_Sht".split("_"),
        weekdaysMin: "D_H_Ma_M\xeb_E_P_Sh".split("_"),
        weekdaysParseExact: !0,
        meridiemParse: /PD|MD/,
        isPM: function(e) {
            return "M" === e.charAt(0);
        },
        meridiem: function(e, a, t) {
            return e < 12 ? "PD" : "MD";
        },
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Sot n\xeb] LT",
            nextDay: "[Nes\xebr n\xeb] LT",
            nextWeek: "dddd [n\xeb] LT",
            lastDay: "[Dje n\xeb] LT",
            lastWeek: "dddd [e kaluar n\xeb] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "n\xeb %s",
            past: "%s m\xeb par\xeb",
            s: "disa sekonda",
            ss: "%d sekonda",
            m: "nj\xeb minut\xeb",
            mm: "%d minuta",
            h: "nj\xeb or\xeb",
            hh: "%d or\xeb",
            d: "nj\xeb dit\xeb",
            dd: "%d dit\xeb",
            M: "nj\xeb muaj",
            MM: "%d muaj",
            y: "nj\xeb vit",
            yy: "%d vite"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    var W = {
        words: {
            ss: [
                "\u0441\u0435\u043a\u0443\u043d\u0434\u0430",
                "\u0441\u0435\u043a\u0443\u043d\u0434\u0435",
                "\u0441\u0435\u043a\u0443\u043d\u0434\u0438"
            ],
            m: [
                "\u0458\u0435\u0434\u0430\u043d \u043c\u0438\u043d\u0443\u0442",
                "\u0458\u0435\u0434\u043d\u043e\u0433 \u043c\u0438\u043d\u0443\u0442\u0430"
            ],
            mm: [
                "\u043c\u0438\u043d\u0443\u0442",
                "\u043c\u0438\u043d\u0443\u0442\u0430",
                "\u043c\u0438\u043d\u0443\u0442\u0430"
            ],
            h: [
                "\u0458\u0435\u0434\u0430\u043d \u0441\u0430\u0442",
                "\u0458\u0435\u0434\u043d\u043e\u0433 \u0441\u0430\u0442\u0430"
            ],
            hh: [
                "\u0441\u0430\u0442",
                "\u0441\u0430\u0442\u0430",
                "\u0441\u0430\u0442\u0438"
            ],
            d: [
                "\u0458\u0435\u0434\u0430\u043d \u0434\u0430\u043d",
                "\u0458\u0435\u0434\u043d\u043e\u0433 \u0434\u0430\u043d\u0430"
            ],
            dd: [
                "\u0434\u0430\u043d",
                "\u0434\u0430\u043d\u0430",
                "\u0434\u0430\u043d\u0430"
            ],
            M: [
                "\u0458\u0435\u0434\u0430\u043d \u043c\u0435\u0441\u0435\u0446",
                "\u0458\u0435\u0434\u043d\u043e\u0433 \u043c\u0435\u0441\u0435\u0446\u0430"
            ],
            MM: [
                "\u043c\u0435\u0441\u0435\u0446",
                "\u043c\u0435\u0441\u0435\u0446\u0430",
                "\u043c\u0435\u0441\u0435\u0446\u0438"
            ],
            y: [
                "\u0458\u0435\u0434\u043d\u0443 \u0433\u043e\u0434\u0438\u043d\u0443",
                "\u0458\u0435\u0434\u043d\u0435 \u0433\u043e\u0434\u0438\u043d\u0435"
            ],
            yy: [
                "\u0433\u043e\u0434\u0438\u043d\u0443",
                "\u0433\u043e\u0434\u0438\u043d\u0435",
                "\u0433\u043e\u0434\u0438\u043d\u0430"
            ]
        },
        correctGrammaticalCase: function(e, a) {
            return 1 <= e % 10 && e % 10 <= 4 && (e % 100 < 10 || 20 <= e % 100) ? e % 10 == 1 ? a[0] : a[1] : a[2];
        },
        translate: function(e, a, t, s) {
            var n = W.words[t];
            return 1 === t.length ? "y" === t && a ? "\u0458\u0435\u0434\u043d\u0430 \u0433\u043e\u0434\u0438\u043d\u0430" : s || a ? n[0] : n[1] : (s = W.correctGrammaticalCase(e, n), "yy" === t && a && "\u0433\u043e\u0434\u0438\u043d\u0443" === s ? e + " \u0433\u043e\u0434\u0438\u043d\u0430" : e + " " + s);
        }
    }, A = (c.defineLocale("sr-cyrl", {
        months: "\u0458\u0430\u043d\u0443\u0430\u0440_\u0444\u0435\u0431\u0440\u0443\u0430\u0440_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0438\u043b_\u043c\u0430\u0458_\u0458\u0443\u043d_\u0458\u0443\u043b_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043f\u0442\u0435\u043c\u0431\u0430\u0440_\u043e\u043a\u0442\u043e\u0431\u0430\u0440_\u043d\u043e\u0432\u0435\u043c\u0431\u0430\u0440_\u0434\u0435\u0446\u0435\u043c\u0431\u0430\u0440".split("_"),
        monthsShort: "\u0458\u0430\u043d._\u0444\u0435\u0431._\u043c\u0430\u0440._\u0430\u043f\u0440._\u043c\u0430\u0458_\u0458\u0443\u043d_\u0458\u0443\u043b_\u0430\u0432\u0433._\u0441\u0435\u043f._\u043e\u043a\u0442._\u043d\u043e\u0432._\u0434\u0435\u0446.".split("_"),
        monthsParseExact: !0,
        weekdays: "\u043d\u0435\u0434\u0435\u0459\u0430_\u043f\u043e\u043d\u0435\u0434\u0435\u0459\u0430\u043a_\u0443\u0442\u043e\u0440\u0430\u043a_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043a_\u043f\u0435\u0442\u0430\u043a_\u0441\u0443\u0431\u043e\u0442\u0430".split("_"),
        weekdaysShort: "\u043d\u0435\u0434._\u043f\u043e\u043d._\u0443\u0442\u043e._\u0441\u0440\u0435._\u0447\u0435\u0442._\u043f\u0435\u0442._\u0441\u0443\u0431.".split("_"),
        weekdaysMin: "\u043d\u0435_\u043f\u043e_\u0443\u0442_\u0441\u0440_\u0447\u0435_\u043f\u0435_\u0441\u0443".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "D. M. YYYY.",
            LL: "D. MMMM YYYY.",
            LLL: "D. MMMM YYYY. H:mm",
            LLLL: "dddd, D. MMMM YYYY. H:mm"
        },
        calendar: {
            sameDay: "[\u0434\u0430\u043d\u0430\u0441 \u0443] LT",
            nextDay: "[\u0441\u0443\u0442\u0440\u0430 \u0443] LT",
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[\u0443] [\u043d\u0435\u0434\u0435\u0459\u0443] [\u0443] LT";
                    case 3:
                        return "[\u0443] [\u0441\u0440\u0435\u0434\u0443] [\u0443] LT";
                    case 6:
                        return "[\u0443] [\u0441\u0443\u0431\u043e\u0442\u0443] [\u0443] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[\u0443] dddd [\u0443] LT";
                }
            },
            lastDay: "[\u0458\u0443\u0447\u0435 \u0443] LT",
            lastWeek: function() {
                return [
                    "[\u043f\u0440\u043e\u0448\u043b\u0435] [\u043d\u0435\u0434\u0435\u0459\u0435] [\u0443] LT",
                    "[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u043f\u043e\u043d\u0435\u0434\u0435\u0459\u043a\u0430] [\u0443] LT",
                    "[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u0443\u0442\u043e\u0440\u043a\u0430] [\u0443] LT",
                    "[\u043f\u0440\u043e\u0448\u043b\u0435] [\u0441\u0440\u0435\u0434\u0435] [\u0443] LT",
                    "[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u0447\u0435\u0442\u0432\u0440\u0442\u043a\u0430] [\u0443] LT",
                    "[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u043f\u0435\u0442\u043a\u0430] [\u0443] LT",
                    "[\u043f\u0440\u043e\u0448\u043b\u0435] [\u0441\u0443\u0431\u043e\u0442\u0435] [\u0443] LT"
                ][this.day()];
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0437\u0430 %s",
            past: "\u043f\u0440\u0435 %s",
            s: "\u043d\u0435\u043a\u043e\u043b\u0438\u043a\u043e \u0441\u0435\u043a\u0443\u043d\u0434\u0438",
            ss: W.translate,
            m: W.translate,
            mm: W.translate,
            h: W.translate,
            hh: W.translate,
            d: W.translate,
            dd: W.translate,
            M: W.translate,
            MM: W.translate,
            y: W.translate,
            yy: W.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 7
        }
    }), {
        words: {
            ss: [
                "sekunda",
                "sekunde",
                "sekundi"
            ],
            m: [
                "jedan minut",
                "jednog minuta"
            ],
            mm: [
                "minut",
                "minuta",
                "minuta"
            ],
            h: [
                "jedan sat",
                "jednog sata"
            ],
            hh: [
                "sat",
                "sata",
                "sati"
            ],
            d: [
                "jedan dan",
                "jednog dana"
            ],
            dd: [
                "dan",
                "dana",
                "dana"
            ],
            M: [
                "jedan mesec",
                "jednog meseca"
            ],
            MM: [
                "mesec",
                "meseca",
                "meseci"
            ],
            y: [
                "jednu godinu",
                "jedne godine"
            ],
            yy: [
                "godinu",
                "godine",
                "godina"
            ]
        },
        correctGrammaticalCase: function(e, a) {
            return 1 <= e % 10 && e % 10 <= 4 && (e % 100 < 10 || 20 <= e % 100) ? e % 10 == 1 ? a[0] : a[1] : a[2];
        },
        translate: function(e, a, t, s) {
            var n = A.words[t];
            return 1 === t.length ? "y" === t && a ? "jedna godina" : s || a ? n[0] : n[1] : (s = A.correctGrammaticalCase(e, n), "yy" === t && a && "godinu" === s ? e + " godina" : e + " " + s);
        }
    }), Hn = (c.defineLocale("sr", {
        months: "januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),
        monthsShort: "jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),
        monthsParseExact: !0,
        weekdays: "nedelja_ponedeljak_utorak_sreda_\u010detvrtak_petak_subota".split("_"),
        weekdaysShort: "ned._pon._uto._sre._\u010det._pet._sub.".split("_"),
        weekdaysMin: "ne_po_ut_sr_\u010de_pe_su".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "D. M. YYYY.",
            LL: "D. MMMM YYYY.",
            LLL: "D. MMMM YYYY. H:mm",
            LLLL: "dddd, D. MMMM YYYY. H:mm"
        },
        calendar: {
            sameDay: "[danas u] LT",
            nextDay: "[sutra u] LT",
            nextWeek: function() {
                switch(this.day()){
                    case 0:
                        return "[u] [nedelju] [u] LT";
                    case 3:
                        return "[u] [sredu] [u] LT";
                    case 6:
                        return "[u] [subotu] [u] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[u] dddd [u] LT";
                }
            },
            lastDay: "[ju\u010de u] LT",
            lastWeek: function() {
                return [
                    "[pro\u0161le] [nedelje] [u] LT",
                    "[pro\u0161log] [ponedeljka] [u] LT",
                    "[pro\u0161log] [utorka] [u] LT",
                    "[pro\u0161le] [srede] [u] LT",
                    "[pro\u0161log] [\u010detvrtka] [u] LT",
                    "[pro\u0161log] [petka] [u] LT",
                    "[pro\u0161le] [subote] [u] LT"
                ][this.day()];
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "za %s",
            past: "pre %s",
            s: "nekoliko sekundi",
            ss: A.translate,
            m: A.translate,
            mm: A.translate,
            h: A.translate,
            hh: A.translate,
            d: A.translate,
            dd: A.translate,
            M: A.translate,
            MM: A.translate,
            y: A.translate,
            yy: A.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 7
        }
    }), c.defineLocale("ss", {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split("_"),
        monthsShort: "Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo".split("_"),
        weekdays: "Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo".split("_"),
        weekdaysShort: "Lis_Umb_Lsb_Les_Lsi_Lsh_Umg".split("_"),
        weekdaysMin: "Li_Us_Lb_Lt_Ls_Lh_Ug".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY h:mm A",
            LLLL: "dddd, D MMMM YYYY h:mm A"
        },
        calendar: {
            sameDay: "[Namuhla nga] LT",
            nextDay: "[Kusasa nga] LT",
            nextWeek: "dddd [nga] LT",
            lastDay: "[Itolo nga] LT",
            lastWeek: "dddd [leliphelile] [nga] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "nga %s",
            past: "wenteka nga %s",
            s: "emizuzwana lomcane",
            ss: "%d mzuzwana",
            m: "umzuzu",
            mm: "%d emizuzu",
            h: "lihora",
            hh: "%d emahora",
            d: "lilanga",
            dd: "%d emalanga",
            M: "inyanga",
            MM: "%d tinyanga",
            y: "umnyaka",
            yy: "%d iminyaka"
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function(e, a, t) {
            return e < 11 ? "ekuseni" : e < 15 ? "emini" : e < 19 ? "entsambama" : "ebusuku";
        },
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "ekuseni" === a ? e : "emini" === a ? 11 <= e ? e : e + 12 : "entsambama" === a || "ebusuku" === a ? 0 === e ? 0 : e + 12 : void 0;
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: "%d",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("sv", {
        months: "januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"),
        monthsShort: "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
        weekdays: "s\xf6ndag_m\xe5ndag_tisdag_onsdag_torsdag_fredag_l\xf6rdag".split("_"),
        weekdaysShort: "s\xf6n_m\xe5n_tis_ons_tor_fre_l\xf6r".split("_"),
        weekdaysMin: "s\xf6_m\xe5_ti_on_to_fr_l\xf6".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY [kl.] HH:mm",
            LLLL: "dddd D MMMM YYYY [kl.] HH:mm",
            lll: "D MMM YYYY HH:mm",
            llll: "ddd D MMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Idag] LT",
            nextDay: "[Imorgon] LT",
            lastDay: "[Ig\xe5r] LT",
            nextWeek: "[P\xe5] dddd LT",
            lastWeek: "[I] dddd[s] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "om %s",
            past: "f\xf6r %s sedan",
            s: "n\xe5gra sekunder",
            ss: "%d sekunder",
            m: "en minut",
            mm: "%d minuter",
            h: "en timme",
            hh: "%d timmar",
            d: "en dag",
            dd: "%d dagar",
            M: "en m\xe5nad",
            MM: "%d m\xe5nader",
            y: "ett \xe5r",
            yy: "%d \xe5r"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function(e) {
            var a = e % 10;
            return e + (1 != ~~(e % 100 / 10) && (1 == a || 2 == a) ? ":a" : ":e");
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("sw", {
        months: "Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba".split("_"),
        monthsShort: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des".split("_"),
        weekdays: "Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi".split("_"),
        weekdaysShort: "Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos".split("_"),
        weekdaysMin: "J2_J3_J4_J5_Al_Ij_J1".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "hh:mm A",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[leo saa] LT",
            nextDay: "[kesho saa] LT",
            nextWeek: "[wiki ijayo] dddd [saat] LT",
            lastDay: "[jana] LT",
            lastWeek: "[wiki iliyopita] dddd [saat] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s baadaye",
            past: "tokea %s",
            s: "hivi punde",
            ss: "sekunde %d",
            m: "dakika moja",
            mm: "dakika %d",
            h: "saa limoja",
            hh: "masaa %d",
            d: "siku moja",
            dd: "siku %d",
            M: "mwezi mmoja",
            MM: "miezi %d",
            y: "mwaka mmoja",
            yy: "miaka %d"
        },
        week: {
            dow: 1,
            doy: 7
        }
    }), {
        1: "\u0be7",
        2: "\u0be8",
        3: "\u0be9",
        4: "\u0bea",
        5: "\u0beb",
        6: "\u0bec",
        7: "\u0bed",
        8: "\u0bee",
        9: "\u0bef",
        0: "\u0be6"
    }), Sn = {
        "\u0be7": "1",
        "\u0be8": "2",
        "\u0be9": "3",
        "\u0bea": "4",
        "\u0beb": "5",
        "\u0bec": "6",
        "\u0bed": "7",
        "\u0bee": "8",
        "\u0bef": "9",
        "\u0be6": "0"
    }, vn = (c.defineLocale("ta", {
        months: "\u0b9c\u0ba9\u0bb5\u0bb0\u0bbf_\u0baa\u0bbf\u0baa\u0bcd\u0bb0\u0bb5\u0bb0\u0bbf_\u0bae\u0bbe\u0bb0\u0bcd\u0b9a\u0bcd_\u0b8f\u0baa\u0bcd\u0bb0\u0bb2\u0bcd_\u0bae\u0bc7_\u0b9c\u0bc2\u0ba9\u0bcd_\u0b9c\u0bc2\u0bb2\u0bc8_\u0b86\u0b95\u0bb8\u0bcd\u0b9f\u0bcd_\u0b9a\u0bc6\u0baa\u0bcd\u0b9f\u0bc6\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b85\u0b95\u0bcd\u0b9f\u0bc7\u0bbe\u0baa\u0bb0\u0bcd_\u0ba8\u0bb5\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b9f\u0bbf\u0b9a\u0bae\u0bcd\u0baa\u0bb0\u0bcd".split("_"),
        monthsShort: "\u0b9c\u0ba9\u0bb5\u0bb0\u0bbf_\u0baa\u0bbf\u0baa\u0bcd\u0bb0\u0bb5\u0bb0\u0bbf_\u0bae\u0bbe\u0bb0\u0bcd\u0b9a\u0bcd_\u0b8f\u0baa\u0bcd\u0bb0\u0bb2\u0bcd_\u0bae\u0bc7_\u0b9c\u0bc2\u0ba9\u0bcd_\u0b9c\u0bc2\u0bb2\u0bc8_\u0b86\u0b95\u0bb8\u0bcd\u0b9f\u0bcd_\u0b9a\u0bc6\u0baa\u0bcd\u0b9f\u0bc6\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b85\u0b95\u0bcd\u0b9f\u0bc7\u0bbe\u0baa\u0bb0\u0bcd_\u0ba8\u0bb5\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b9f\u0bbf\u0b9a\u0bae\u0bcd\u0baa\u0bb0\u0bcd".split("_"),
        weekdays: "\u0b9e\u0bbe\u0baf\u0bbf\u0bb1\u0bcd\u0bb1\u0bc1\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0ba4\u0bbf\u0b99\u0bcd\u0b95\u0b9f\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0b9a\u0bc6\u0bb5\u0bcd\u0bb5\u0bbe\u0baf\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0baa\u0bc1\u0ba4\u0ba9\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0bb5\u0bbf\u0baf\u0bbe\u0bb4\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0bb5\u0bc6\u0bb3\u0bcd\u0bb3\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0b9a\u0ba9\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8".split("_"),
        weekdaysShort: "\u0b9e\u0bbe\u0baf\u0bbf\u0bb1\u0bc1_\u0ba4\u0bbf\u0b99\u0bcd\u0b95\u0bb3\u0bcd_\u0b9a\u0bc6\u0bb5\u0bcd\u0bb5\u0bbe\u0baf\u0bcd_\u0baa\u0bc1\u0ba4\u0ba9\u0bcd_\u0bb5\u0bbf\u0baf\u0bbe\u0bb4\u0ba9\u0bcd_\u0bb5\u0bc6\u0bb3\u0bcd\u0bb3\u0bbf_\u0b9a\u0ba9\u0bbf".split("_"),
        weekdaysMin: "\u0b9e\u0bbe_\u0ba4\u0bbf_\u0b9a\u0bc6_\u0baa\u0bc1_\u0bb5\u0bbf_\u0bb5\u0bc6_\u0b9a".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, HH:mm",
            LLLL: "dddd, D MMMM YYYY, HH:mm"
        },
        calendar: {
            sameDay: "[\u0b87\u0ba9\u0bcd\u0bb1\u0bc1] LT",
            nextDay: "[\u0ba8\u0bbe\u0bb3\u0bc8] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0ba8\u0bc7\u0bb1\u0bcd\u0bb1\u0bc1] LT",
            lastWeek: "[\u0b95\u0b9f\u0ba8\u0bcd\u0ba4 \u0bb5\u0bbe\u0bb0\u0bae\u0bcd] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0b87\u0bb2\u0bcd",
            past: "%s \u0bae\u0bc1\u0ba9\u0bcd",
            s: "\u0b92\u0bb0\u0bc1 \u0b9a\u0bbf\u0bb2 \u0bb5\u0bbf\u0ba8\u0bbe\u0b9f\u0bbf\u0b95\u0bb3\u0bcd",
            ss: "%d \u0bb5\u0bbf\u0ba8\u0bbe\u0b9f\u0bbf\u0b95\u0bb3\u0bcd",
            m: "\u0b92\u0bb0\u0bc1 \u0ba8\u0bbf\u0bae\u0bbf\u0b9f\u0bae\u0bcd",
            mm: "%d \u0ba8\u0bbf\u0bae\u0bbf\u0b9f\u0b99\u0bcd\u0b95\u0bb3\u0bcd",
            h: "\u0b92\u0bb0\u0bc1 \u0bae\u0ba3\u0bbf \u0ba8\u0bc7\u0bb0\u0bae\u0bcd",
            hh: "%d \u0bae\u0ba3\u0bbf \u0ba8\u0bc7\u0bb0\u0bae\u0bcd",
            d: "\u0b92\u0bb0\u0bc1 \u0ba8\u0bbe\u0bb3\u0bcd",
            dd: "%d \u0ba8\u0bbe\u0b9f\u0bcd\u0b95\u0bb3\u0bcd",
            M: "\u0b92\u0bb0\u0bc1 \u0bae\u0bbe\u0ba4\u0bae\u0bcd",
            MM: "%d \u0bae\u0bbe\u0ba4\u0b99\u0bcd\u0b95\u0bb3\u0bcd",
            y: "\u0b92\u0bb0\u0bc1 \u0bb5\u0bb0\u0bc1\u0b9f\u0bae\u0bcd",
            yy: "%d \u0b86\u0ba3\u0bcd\u0b9f\u0bc1\u0b95\u0bb3\u0bcd"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\u0bb5\u0ba4\u0bc1/,
        ordinal: function(e) {
            return e + "\u0bb5\u0ba4\u0bc1";
        },
        preparse: function(e) {
            return e.replace(/[\u0be7\u0be8\u0be9\u0bea\u0beb\u0bec\u0bed\u0bee\u0bef\u0be6]/g, function(e) {
                return Sn[e];
            });
        },
        postformat: function(e) {
            return e.replace(/\d/g, function(e) {
                return Hn[e];
            });
        },
        meridiemParse: /\u0baf\u0bbe\u0bae\u0bae\u0bcd|\u0bb5\u0bc8\u0b95\u0bb1\u0bc8|\u0b95\u0bbe\u0bb2\u0bc8|\u0ba8\u0ba3\u0bcd\u0baa\u0b95\u0bb2\u0bcd|\u0b8e\u0bb1\u0bcd\u0baa\u0bbe\u0b9f\u0bc1|\u0bae\u0bbe\u0bb2\u0bc8/,
        meridiem: function(e, a, t) {
            return e < 2 ? " \u0baf\u0bbe\u0bae\u0bae\u0bcd" : e < 6 ? " \u0bb5\u0bc8\u0b95\u0bb1\u0bc8" : e < 10 ? " \u0b95\u0bbe\u0bb2\u0bc8" : e < 14 ? " \u0ba8\u0ba3\u0bcd\u0baa\u0b95\u0bb2\u0bcd" : e < 18 ? " \u0b8e\u0bb1\u0bcd\u0baa\u0bbe\u0b9f\u0bc1" : e < 22 ? " \u0bae\u0bbe\u0bb2\u0bc8" : " \u0baf\u0bbe\u0bae\u0bae\u0bcd";
        },
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "\u0baf\u0bbe\u0bae\u0bae\u0bcd" === a ? e < 2 ? e : e + 12 : "\u0bb5\u0bc8\u0b95\u0bb1\u0bc8" === a || "\u0b95\u0bbe\u0bb2\u0bc8" === a || "\u0ba8\u0ba3\u0bcd\u0baa\u0b95\u0bb2\u0bcd" === a && 10 <= e ? e : e + 12;
        },
        week: {
            dow: 0,
            doy: 6
        }
    }), c.defineLocale("te", {
        months: "\u0c1c\u0c28\u0c35\u0c30\u0c3f_\u0c2b\u0c3f\u0c2c\u0c4d\u0c30\u0c35\u0c30\u0c3f_\u0c2e\u0c3e\u0c30\u0c4d\u0c1a\u0c3f_\u0c0f\u0c2a\u0c4d\u0c30\u0c3f\u0c32\u0c4d_\u0c2e\u0c47_\u0c1c\u0c42\u0c28\u0c4d_\u0c1c\u0c41\u0c32\u0c48_\u0c06\u0c17\u0c38\u0c4d\u0c1f\u0c41_\u0c38\u0c46\u0c2a\u0c4d\u0c1f\u0c46\u0c02\u0c2c\u0c30\u0c4d_\u0c05\u0c15\u0c4d\u0c1f\u0c4b\u0c2c\u0c30\u0c4d_\u0c28\u0c35\u0c02\u0c2c\u0c30\u0c4d_\u0c21\u0c3f\u0c38\u0c46\u0c02\u0c2c\u0c30\u0c4d".split("_"),
        monthsShort: "\u0c1c\u0c28._\u0c2b\u0c3f\u0c2c\u0c4d\u0c30._\u0c2e\u0c3e\u0c30\u0c4d\u0c1a\u0c3f_\u0c0f\u0c2a\u0c4d\u0c30\u0c3f._\u0c2e\u0c47_\u0c1c\u0c42\u0c28\u0c4d_\u0c1c\u0c41\u0c32\u0c48_\u0c06\u0c17._\u0c38\u0c46\u0c2a\u0c4d._\u0c05\u0c15\u0c4d\u0c1f\u0c4b._\u0c28\u0c35._\u0c21\u0c3f\u0c38\u0c46.".split("_"),
        monthsParseExact: !0,
        weekdays: "\u0c06\u0c26\u0c3f\u0c35\u0c3e\u0c30\u0c02_\u0c38\u0c4b\u0c2e\u0c35\u0c3e\u0c30\u0c02_\u0c2e\u0c02\u0c17\u0c33\u0c35\u0c3e\u0c30\u0c02_\u0c2c\u0c41\u0c27\u0c35\u0c3e\u0c30\u0c02_\u0c17\u0c41\u0c30\u0c41\u0c35\u0c3e\u0c30\u0c02_\u0c36\u0c41\u0c15\u0c4d\u0c30\u0c35\u0c3e\u0c30\u0c02_\u0c36\u0c28\u0c3f\u0c35\u0c3e\u0c30\u0c02".split("_"),
        weekdaysShort: "\u0c06\u0c26\u0c3f_\u0c38\u0c4b\u0c2e_\u0c2e\u0c02\u0c17\u0c33_\u0c2c\u0c41\u0c27_\u0c17\u0c41\u0c30\u0c41_\u0c36\u0c41\u0c15\u0c4d\u0c30_\u0c36\u0c28\u0c3f".split("_"),
        weekdaysMin: "\u0c06_\u0c38\u0c4b_\u0c2e\u0c02_\u0c2c\u0c41_\u0c17\u0c41_\u0c36\u0c41_\u0c36".split("_"),
        longDateFormat: {
            LT: "A h:mm",
            LTS: "A h:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm",
            LLLL: "dddd, D MMMM YYYY, A h:mm"
        },
        calendar: {
            sameDay: "[\u0c28\u0c47\u0c21\u0c41] LT",
            nextDay: "[\u0c30\u0c47\u0c2a\u0c41] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0c28\u0c3f\u0c28\u0c4d\u0c28] LT",
            lastWeek: "[\u0c17\u0c24] dddd, LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0c32\u0c4b",
            past: "%s \u0c15\u0c4d\u0c30\u0c3f\u0c24\u0c02",
            s: "\u0c15\u0c4a\u0c28\u0c4d\u0c28\u0c3f \u0c15\u0c4d\u0c37\u0c23\u0c3e\u0c32\u0c41",
            ss: "%d \u0c38\u0c46\u0c15\u0c28\u0c4d\u0c32\u0c41",
            m: "\u0c12\u0c15 \u0c28\u0c3f\u0c2e\u0c3f\u0c37\u0c02",
            mm: "%d \u0c28\u0c3f\u0c2e\u0c3f\u0c37\u0c3e\u0c32\u0c41",
            h: "\u0c12\u0c15 \u0c17\u0c02\u0c1f",
            hh: "%d \u0c17\u0c02\u0c1f\u0c32\u0c41",
            d: "\u0c12\u0c15 \u0c30\u0c4b\u0c1c\u0c41",
            dd: "%d \u0c30\u0c4b\u0c1c\u0c41\u0c32\u0c41",
            M: "\u0c12\u0c15 \u0c28\u0c46\u0c32",
            MM: "%d \u0c28\u0c46\u0c32\u0c32\u0c41",
            y: "\u0c12\u0c15 \u0c38\u0c02\u0c35\u0c24\u0c4d\u0c38\u0c30\u0c02",
            yy: "%d \u0c38\u0c02\u0c35\u0c24\u0c4d\u0c38\u0c30\u0c3e\u0c32\u0c41"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\u0c35/,
        ordinal: "%d\u0c35",
        meridiemParse: /\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f|\u0c09\u0c26\u0c2f\u0c02|\u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02|\u0c38\u0c3e\u0c2f\u0c02\u0c24\u0c4d\u0c30\u0c02/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f" === a ? e < 4 ? e : e + 12 : "\u0c09\u0c26\u0c2f\u0c02" === a ? e : "\u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02" === a ? 10 <= e ? e : e + 12 : "\u0c38\u0c3e\u0c2f\u0c02\u0c24\u0c4d\u0c30\u0c02" === a ? e + 12 : void 0;
        },
        meridiem: function(e, a, t) {
            return e < 4 ? "\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f" : e < 10 ? "\u0c09\u0c26\u0c2f\u0c02" : e < 17 ? "\u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02" : e < 20 ? "\u0c38\u0c3e\u0c2f\u0c02\u0c24\u0c4d\u0c30\u0c02" : "\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f";
        },
        week: {
            dow: 0,
            doy: 6
        }
    }), c.defineLocale("tet", {
        months: "Janeiru_Fevereiru_Marsu_Abril_Maiu_Ju\xf1u_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru".split("_"),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
        weekdays: "Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu".split("_"),
        weekdaysShort: "Dom_Seg_Ters_Kua_Kint_Sest_Sab".split("_"),
        weekdaysMin: "Do_Seg_Te_Ku_Ki_Ses_Sa".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[Ohin iha] LT",
            nextDay: "[Aban iha] LT",
            nextWeek: "dddd [iha] LT",
            lastDay: "[Horiseik iha] LT",
            lastWeek: "dddd [semana kotuk] [iha] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "iha %s",
            past: "%s liuba",
            s: "segundu balun",
            ss: "segundu %d",
            m: "minutu ida",
            mm: "minutu %d",
            h: "oras ida",
            hh: "oras %d",
            d: "loron ida",
            dd: "loron %d",
            M: "fulan ida",
            MM: "fulan %d",
            y: "tinan ida",
            yy: "tinan %d"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function(e) {
            var a = e % 10;
            return e + (1 == ~~(e % 100 / 10) ? "th" : 1 == a ? "st" : 2 == a ? "nd" : 3 == a ? "rd" : "th");
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), {
        0: "-\u0443\u043c",
        1: "-\u0443\u043c",
        2: "-\u044e\u043c",
        3: "-\u044e\u043c",
        4: "-\u0443\u043c",
        5: "-\u0443\u043c",
        6: "-\u0443\u043c",
        7: "-\u0443\u043c",
        8: "-\u0443\u043c",
        9: "-\u0443\u043c",
        10: "-\u0443\u043c",
        12: "-\u0443\u043c",
        13: "-\u0443\u043c",
        20: "-\u0443\u043c",
        30: "-\u044e\u043c",
        40: "-\u0443\u043c",
        50: "-\u0443\u043c",
        60: "-\u0443\u043c",
        70: "-\u0443\u043c",
        80: "-\u0443\u043c",
        90: "-\u0443\u043c",
        100: "-\u0443\u043c"
    }), jn = (c.defineLocale("tg", {
        months: {
            format: "\u044f\u043d\u0432\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0430\u043b\u0438_\u043c\u0430\u0440\u0442\u0438_\u0430\u043f\u0440\u0435\u043b\u0438_\u043c\u0430\u0439\u0438_\u0438\u044e\u043d\u0438_\u0438\u044e\u043b\u0438_\u0430\u0432\u0433\u0443\u0441\u0442\u0438_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u0438_\u043e\u043a\u0442\u044f\u0431\u0440\u0438_\u043d\u043e\u044f\u0431\u0440\u0438_\u0434\u0435\u043a\u0430\u0431\u0440\u0438".split("_"),
            standalone: "\u044f\u043d\u0432\u0430\u0440_\u0444\u0435\u0432\u0440\u0430\u043b_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440_\u043e\u043a\u0442\u044f\u0431\u0440_\u043d\u043e\u044f\u0431\u0440_\u0434\u0435\u043a\u0430\u0431\u0440".split("_")
        },
        monthsShort: "\u044f\u043d\u0432_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433_\u0441\u0435\u043d_\u043e\u043a\u0442_\u043d\u043e\u044f_\u0434\u0435\u043a".split("_"),
        weekdays: "\u044f\u043a\u0448\u0430\u043d\u0431\u0435_\u0434\u0443\u0448\u0430\u043d\u0431\u0435_\u0441\u0435\u0448\u0430\u043d\u0431\u0435_\u0447\u043e\u0440\u0448\u0430\u043d\u0431\u0435_\u043f\u0430\u043d\u04b7\u0448\u0430\u043d\u0431\u0435_\u04b7\u0443\u043c\u044a\u0430_\u0448\u0430\u043d\u0431\u0435".split("_"),
        weekdaysShort: "\u044f\u0448\u0431_\u0434\u0448\u0431_\u0441\u0448\u0431_\u0447\u0448\u0431_\u043f\u0448\u0431_\u04b7\u0443\u043c_\u0448\u043d\u0431".split("_"),
        weekdaysMin: "\u044f\u0448_\u0434\u0448_\u0441\u0448_\u0447\u0448_\u043f\u0448_\u04b7\u043c_\u0448\u0431".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\u0418\u043c\u0440\u04ef\u0437 \u0441\u043e\u0430\u0442\u0438] LT",
            nextDay: "[\u0424\u0430\u0440\u0434\u043e \u0441\u043e\u0430\u0442\u0438] LT",
            lastDay: "[\u0414\u0438\u0440\u04ef\u0437 \u0441\u043e\u0430\u0442\u0438] LT",
            nextWeek: "dddd[\u0438] [\u04b3\u0430\u0444\u0442\u0430\u0438 \u043e\u044f\u043d\u0434\u0430 \u0441\u043e\u0430\u0442\u0438] LT",
            lastWeek: "dddd[\u0438] [\u04b3\u0430\u0444\u0442\u0430\u0438 \u0433\u0443\u0437\u0430\u0448\u0442\u0430 \u0441\u043e\u0430\u0442\u0438] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0431\u0430\u044a\u0434\u0438 %s",
            past: "%s \u043f\u0435\u0448",
            s: "\u044f\u043a\u0447\u0430\u043d\u0434 \u0441\u043e\u043d\u0438\u044f",
            m: "\u044f\u043a \u0434\u0430\u049b\u0438\u049b\u0430",
            mm: "%d \u0434\u0430\u049b\u0438\u049b\u0430",
            h: "\u044f\u043a \u0441\u043e\u0430\u0442",
            hh: "%d \u0441\u043e\u0430\u0442",
            d: "\u044f\u043a \u0440\u04ef\u0437",
            dd: "%d \u0440\u04ef\u0437",
            M: "\u044f\u043a \u043c\u043e\u04b3",
            MM: "%d \u043c\u043e\u04b3",
            y: "\u044f\u043a \u0441\u043e\u043b",
            yy: "%d \u0441\u043e\u043b"
        },
        meridiemParse: /\u0448\u0430\u0431|\u0441\u0443\u0431\u04b3|\u0440\u04ef\u0437|\u0431\u0435\u0433\u043e\u04b3/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "\u0448\u0430\u0431" === a ? e < 4 ? e : e + 12 : "\u0441\u0443\u0431\u04b3" === a ? e : "\u0440\u04ef\u0437" === a ? 11 <= e ? e : e + 12 : "\u0431\u0435\u0433\u043e\u04b3" === a ? e + 12 : void 0;
        },
        meridiem: function(e, a, t) {
            return e < 4 ? "\u0448\u0430\u0431" : e < 11 ? "\u0441\u0443\u0431\u04b3" : e < 16 ? "\u0440\u04ef\u0437" : e < 19 ? "\u0431\u0435\u0433\u043e\u04b3" : "\u0448\u0430\u0431";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(\u0443\u043c|\u044e\u043c)/,
        ordinal: function(e) {
            return e + (vn[e] || vn[e % 10] || vn[100 <= e ? 100 : null]);
        },
        week: {
            dow: 1,
            doy: 7
        }
    }), c.defineLocale("th", {
        months: "\u0e21\u0e01\u0e23\u0e32\u0e04\u0e21_\u0e01\u0e38\u0e21\u0e20\u0e32\u0e1e\u0e31\u0e19\u0e18\u0e4c_\u0e21\u0e35\u0e19\u0e32\u0e04\u0e21_\u0e40\u0e21\u0e29\u0e32\u0e22\u0e19_\u0e1e\u0e24\u0e29\u0e20\u0e32\u0e04\u0e21_\u0e21\u0e34\u0e16\u0e38\u0e19\u0e32\u0e22\u0e19_\u0e01\u0e23\u0e01\u0e0e\u0e32\u0e04\u0e21_\u0e2a\u0e34\u0e07\u0e2b\u0e32\u0e04\u0e21_\u0e01\u0e31\u0e19\u0e22\u0e32\u0e22\u0e19_\u0e15\u0e38\u0e25\u0e32\u0e04\u0e21_\u0e1e\u0e24\u0e28\u0e08\u0e34\u0e01\u0e32\u0e22\u0e19_\u0e18\u0e31\u0e19\u0e27\u0e32\u0e04\u0e21".split("_"),
        monthsShort: "\u0e21.\u0e04._\u0e01.\u0e1e._\u0e21\u0e35.\u0e04._\u0e40\u0e21.\u0e22._\u0e1e.\u0e04._\u0e21\u0e34.\u0e22._\u0e01.\u0e04._\u0e2a.\u0e04._\u0e01.\u0e22._\u0e15.\u0e04._\u0e1e.\u0e22._\u0e18.\u0e04.".split("_"),
        monthsParseExact: !0,
        weekdays: "\u0e2d\u0e32\u0e17\u0e34\u0e15\u0e22\u0e4c_\u0e08\u0e31\u0e19\u0e17\u0e23\u0e4c_\u0e2d\u0e31\u0e07\u0e04\u0e32\u0e23_\u0e1e\u0e38\u0e18_\u0e1e\u0e24\u0e2b\u0e31\u0e2a\u0e1a\u0e14\u0e35_\u0e28\u0e38\u0e01\u0e23\u0e4c_\u0e40\u0e2a\u0e32\u0e23\u0e4c".split("_"),
        weekdaysShort: "\u0e2d\u0e32\u0e17\u0e34\u0e15\u0e22\u0e4c_\u0e08\u0e31\u0e19\u0e17\u0e23\u0e4c_\u0e2d\u0e31\u0e07\u0e04\u0e32\u0e23_\u0e1e\u0e38\u0e18_\u0e1e\u0e24\u0e2b\u0e31\u0e2a_\u0e28\u0e38\u0e01\u0e23\u0e4c_\u0e40\u0e2a\u0e32\u0e23\u0e4c".split("_"),
        weekdaysMin: "\u0e2d\u0e32._\u0e08._\u0e2d._\u0e1e._\u0e1e\u0e24._\u0e28._\u0e2a.".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY \u0e40\u0e27\u0e25\u0e32 H:mm",
            LLLL: "\u0e27\u0e31\u0e19dddd\u0e17\u0e35\u0e48 D MMMM YYYY \u0e40\u0e27\u0e25\u0e32 H:mm"
        },
        meridiemParse: /\u0e01\u0e48\u0e2d\u0e19\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07|\u0e2b\u0e25\u0e31\u0e07\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07/,
        isPM: function(e) {
            return "\u0e2b\u0e25\u0e31\u0e07\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07" === e;
        },
        meridiem: function(e, a, t) {
            return e < 12 ? "\u0e01\u0e48\u0e2d\u0e19\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07" : "\u0e2b\u0e25\u0e31\u0e07\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07";
        },
        calendar: {
            sameDay: "[\u0e27\u0e31\u0e19\u0e19\u0e35\u0e49 \u0e40\u0e27\u0e25\u0e32] LT",
            nextDay: "[\u0e1e\u0e23\u0e38\u0e48\u0e07\u0e19\u0e35\u0e49 \u0e40\u0e27\u0e25\u0e32] LT",
            nextWeek: "dddd[\u0e2b\u0e19\u0e49\u0e32 \u0e40\u0e27\u0e25\u0e32] LT",
            lastDay: "[\u0e40\u0e21\u0e37\u0e48\u0e2d\u0e27\u0e32\u0e19\u0e19\u0e35\u0e49 \u0e40\u0e27\u0e25\u0e32] LT",
            lastWeek: "[\u0e27\u0e31\u0e19]dddd[\u0e17\u0e35\u0e48\u0e41\u0e25\u0e49\u0e27 \u0e40\u0e27\u0e25\u0e32] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0e2d\u0e35\u0e01 %s",
            past: "%s\u0e17\u0e35\u0e48\u0e41\u0e25\u0e49\u0e27",
            s: "\u0e44\u0e21\u0e48\u0e01\u0e35\u0e48\u0e27\u0e34\u0e19\u0e32\u0e17\u0e35",
            ss: "%d \u0e27\u0e34\u0e19\u0e32\u0e17\u0e35",
            m: "1 \u0e19\u0e32\u0e17\u0e35",
            mm: "%d \u0e19\u0e32\u0e17\u0e35",
            h: "1 \u0e0a\u0e31\u0e48\u0e27\u0e42\u0e21\u0e07",
            hh: "%d \u0e0a\u0e31\u0e48\u0e27\u0e42\u0e21\u0e07",
            d: "1 \u0e27\u0e31\u0e19",
            dd: "%d \u0e27\u0e31\u0e19",
            w: "1 \u0e2a\u0e31\u0e1b\u0e14\u0e32\u0e2b\u0e4c",
            ww: "%d \u0e2a\u0e31\u0e1b\u0e14\u0e32\u0e2b\u0e4c",
            M: "1 \u0e40\u0e14\u0e37\u0e2d\u0e19",
            MM: "%d \u0e40\u0e14\u0e37\u0e2d\u0e19",
            y: "1 \u0e1b\u0e35",
            yy: "%d \u0e1b\u0e35"
        }
    }), {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'\xfcnji",
        4: "'\xfcnji",
        100: "'\xfcnji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy"
    }), xn = (c.defineLocale("tk", {
        months: "\xddanwar_Fewral_Mart_Aprel_Ma\xfd_I\xfdun_I\xfdul_Awgust_Sent\xfdabr_Okt\xfdabr_No\xfdabr_Dekabr".split("_"),
        monthsShort: "\xddan_Few_Mar_Apr_Ma\xfd_I\xfdn_I\xfdl_Awg_Sen_Okt_No\xfd_Dek".split("_"),
        weekdays: "\xddek\u015fenbe_Du\u015fenbe_Si\u015fenbe_\xc7ar\u015fenbe_Pen\u015fenbe_Anna_\u015eenbe".split("_"),
        weekdaysShort: "\xddek_Du\u015f_Si\u015f_\xc7ar_Pen_Ann_\u015een".split("_"),
        weekdaysMin: "\xddk_D\u015f_S\u015f_\xc7r_Pn_An_\u015en".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[bug\xfcn sagat] LT",
            nextDay: "[ertir sagat] LT",
            nextWeek: "[indiki] dddd [sagat] LT",
            lastDay: "[d\xfc\xfdn] LT",
            lastWeek: "[ge\xe7en] dddd [sagat] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s so\u0148",
            past: "%s \xf6\u0148",
            s: "birn\xe4\xe7e sekunt",
            m: "bir minut",
            mm: "%d minut",
            h: "bir sagat",
            hh: "%d sagat",
            d: "bir g\xfcn",
            dd: "%d g\xfcn",
            M: "bir a\xfd",
            MM: "%d a\xfd",
            y: "bir \xfdyl",
            yy: "%d \xfdyl"
        },
        ordinal: function(e, a) {
            switch(a){
                case "d":
                case "D":
                case "Do":
                case "DD":
                    return e;
                default:
                    var t;
                    return 0 === e ? e + "'unjy" : e + (jn[t = e % 10] || jn[e % 100 - t] || jn[100 <= e ? 100 : null]);
            }
        },
        week: {
            dow: 1,
            doy: 7
        }
    }), c.defineLocale("tl-ph", {
        months: "Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),
        monthsShort: "Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),
        weekdays: "Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),
        weekdaysShort: "Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),
        weekdaysMin: "Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "MM/D/YYYY",
            LL: "MMMM D, YYYY",
            LLL: "MMMM D, YYYY HH:mm",
            LLLL: "dddd, MMMM DD, YYYY HH:mm"
        },
        calendar: {
            sameDay: "LT [ngayong araw]",
            nextDay: "[Bukas ng] LT",
            nextWeek: "LT [sa susunod na] dddd",
            lastDay: "LT [kahapon]",
            lastWeek: "LT [noong nakaraang] dddd",
            sameElse: "L"
        },
        relativeTime: {
            future: "sa loob ng %s",
            past: "%s ang nakalipas",
            s: "ilang segundo",
            ss: "%d segundo",
            m: "isang minuto",
            mm: "%d minuto",
            h: "isang oras",
            hh: "%d oras",
            d: "isang araw",
            dd: "%d araw",
            M: "isang buwan",
            MM: "%d buwan",
            y: "isang taon",
            yy: "%d taon"
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function(e) {
            return e;
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), "pagh_wa\u2019_cha\u2019_wej_loS_vagh_jav_Soch_chorgh_Hut".split("_"));
    function Pn(e, a, t, s) {
        var n = function(e) {
            var a = Math.floor(e % 1e3 / 100), t = Math.floor(e % 100 / 10), e = e % 10, s = "";
            0 < a && (s += xn[a] + "vatlh");
            0 < t && (s += ("" !== s ? " " : "") + xn[t] + "maH");
            0 < e && (s += ("" !== s ? " " : "") + xn[e]);
            return "" === s ? "pagh" : s;
        }(e);
        switch(t){
            case "ss":
                return n + " lup";
            case "mm":
                return n + " tup";
            case "hh":
                return n + " rep";
            case "dd":
                return n + " jaj";
            case "MM":
                return n + " jar";
            case "yy":
                return n + " DIS";
        }
    }
    c.defineLocale("tlh", {
        months: "tera\u2019 jar wa\u2019_tera\u2019 jar cha\u2019_tera\u2019 jar wej_tera\u2019 jar loS_tera\u2019 jar vagh_tera\u2019 jar jav_tera\u2019 jar Soch_tera\u2019 jar chorgh_tera\u2019 jar Hut_tera\u2019 jar wa\u2019maH_tera\u2019 jar wa\u2019maH wa\u2019_tera\u2019 jar wa\u2019maH cha\u2019".split("_"),
        monthsShort: "jar wa\u2019_jar cha\u2019_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa\u2019maH_jar wa\u2019maH wa\u2019_jar wa\u2019maH cha\u2019".split("_"),
        monthsParseExact: !0,
        weekdays: "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),
        weekdaysShort: "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),
        weekdaysMin: "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[DaHjaj] LT",
            nextDay: "[wa\u2019leS] LT",
            nextWeek: "LLL",
            lastDay: "[wa\u2019Hu\u2019] LT",
            lastWeek: "LLL",
            sameElse: "L"
        },
        relativeTime: {
            future: function(e) {
                var a = e;
                return a = -1 !== e.indexOf("jaj") ? a.slice(0, -3) + "leS" : -1 !== e.indexOf("jar") ? a.slice(0, -3) + "waQ" : -1 !== e.indexOf("DIS") ? a.slice(0, -3) + "nem" : a + " pIq";
            },
            past: function(e) {
                var a = e;
                return a = -1 !== e.indexOf("jaj") ? a.slice(0, -3) + "Hu\u2019" : -1 !== e.indexOf("jar") ? a.slice(0, -3) + "wen" : -1 !== e.indexOf("DIS") ? a.slice(0, -3) + "ben" : a + " ret";
            },
            s: "puS lup",
            ss: Pn,
            m: "wa\u2019 tup",
            mm: Pn,
            h: "wa\u2019 rep",
            hh: Pn,
            d: "wa\u2019 jaj",
            dd: Pn,
            M: "wa\u2019 jar",
            MM: Pn,
            y: "wa\u2019 DIS",
            yy: Pn
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    });
    var On = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'\xfcnc\xfc",
        4: "'\xfcnc\xfc",
        100: "'\xfcnc\xfc",
        6: "'nc\u0131",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'\u0131nc\u0131",
        90: "'\u0131nc\u0131"
    };
    function Wn(e, a, t, s) {
        e = {
            s: [
                "viensas secunds",
                "'iensas secunds"
            ],
            ss: [
                e + " secunds",
                e + " secunds"
            ],
            m: [
                "'n m\xedut",
                "'iens m\xedut"
            ],
            mm: [
                e + " m\xeduts",
                e + " m\xeduts"
            ],
            h: [
                "'n \xfeora",
                "'iensa \xfeora"
            ],
            hh: [
                e + " \xfeoras",
                e + " \xfeoras"
            ],
            d: [
                "'n ziua",
                "'iensa ziua"
            ],
            dd: [
                e + " ziuas",
                e + " ziuas"
            ],
            M: [
                "'n mes",
                "'iens mes"
            ],
            MM: [
                e + " mesen",
                e + " mesen"
            ],
            y: [
                "'n ar",
                "'iens ar"
            ],
            yy: [
                e + " ars",
                e + " ars"
            ]
        };
        return s || a ? e[t][0] : e[t][1];
    }
    function An(e, a, t) {
        return "m" === t ? a ? "\u0445\u0432\u0438\u043b\u0438\u043d\u0430" : "\u0445\u0432\u0438\u043b\u0438\u043d\u0443" : "h" === t ? a ? "\u0433\u043e\u0434\u0438\u043d\u0430" : "\u0433\u043e\u0434\u0438\u043d\u0443" : e + " " + (e = +e, a = (a = ({
            ss: a ? "\u0441\u0435\u043a\u0443\u043d\u0434\u0430_\u0441\u0435\u043a\u0443\u043d\u0434\u0438_\u0441\u0435\u043a\u0443\u043d\u0434" : "\u0441\u0435\u043a\u0443\u043d\u0434\u0443_\u0441\u0435\u043a\u0443\u043d\u0434\u0438_\u0441\u0435\u043a\u0443\u043d\u0434",
            mm: a ? "\u0445\u0432\u0438\u043b\u0438\u043d\u0430_\u0445\u0432\u0438\u043b\u0438\u043d\u0438_\u0445\u0432\u0438\u043b\u0438\u043d" : "\u0445\u0432\u0438\u043b\u0438\u043d\u0443_\u0445\u0432\u0438\u043b\u0438\u043d\u0438_\u0445\u0432\u0438\u043b\u0438\u043d",
            hh: a ? "\u0433\u043e\u0434\u0438\u043d\u0430_\u0433\u043e\u0434\u0438\u043d\u0438_\u0433\u043e\u0434\u0438\u043d" : "\u0433\u043e\u0434\u0438\u043d\u0443_\u0433\u043e\u0434\u0438\u043d\u0438_\u0433\u043e\u0434\u0438\u043d",
            dd: "\u0434\u0435\u043d\u044c_\u0434\u043d\u0456_\u0434\u043d\u0456\u0432",
            MM: "\u043c\u0456\u0441\u044f\u0446\u044c_\u043c\u0456\u0441\u044f\u0446\u0456_\u043c\u0456\u0441\u044f\u0446\u0456\u0432",
            yy: "\u0440\u0456\u043a_\u0440\u043e\u043a\u0438_\u0440\u043e\u043a\u0456\u0432"
        })[t]).split("_"), e % 10 == 1 && e % 100 != 11 ? a[0] : 2 <= e % 10 && e % 10 <= 4 && (e % 100 < 10 || 20 <= e % 100) ? a[1] : a[2]);
    }
    function En(e) {
        return function() {
            return e + "\u043e" + (11 === this.hours() ? "\u0431" : "") + "] LT";
        };
    }
    c.defineLocale("tr", {
        months: "Ocak_\u015eubat_Mart_Nisan_May\u0131s_Haziran_Temmuz_A\u011fustos_Eyl\xfcl_Ekim_Kas\u0131m_Aral\u0131k".split("_"),
        monthsShort: "Oca_\u015eub_Mar_Nis_May_Haz_Tem_A\u011fu_Eyl_Eki_Kas_Ara".split("_"),
        weekdays: "Pazar_Pazartesi_Sal\u0131_\xc7ar\u015famba_Per\u015fembe_Cuma_Cumartesi".split("_"),
        weekdaysShort: "Paz_Pzt_Sal_\xc7ar_Per_Cum_Cmt".split("_"),
        weekdaysMin: "Pz_Pt_Sa_\xc7a_Pe_Cu_Ct".split("_"),
        meridiem: function(e, a, t) {
            return e < 12 ? t ? "\xf6\xf6" : "\xd6\xd6" : t ? "\xf6s" : "\xd6S";
        },
        meridiemParse: /\xf6\xf6|\xd6\xd6|\xf6s|\xd6S/,
        isPM: function(e) {
            return "\xf6s" === e || "\xd6S" === e;
        },
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[bug\xfcn saat] LT",
            nextDay: "[yar\u0131n saat] LT",
            nextWeek: "[gelecek] dddd [saat] LT",
            lastDay: "[d\xfcn] LT",
            lastWeek: "[ge\xe7en] dddd [saat] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s sonra",
            past: "%s \xf6nce",
            s: "birka\xe7 saniye",
            ss: "%d saniye",
            m: "bir dakika",
            mm: "%d dakika",
            h: "bir saat",
            hh: "%d saat",
            d: "bir g\xfcn",
            dd: "%d g\xfcn",
            w: "bir hafta",
            ww: "%d hafta",
            M: "bir ay",
            MM: "%d ay",
            y: "bir y\u0131l",
            yy: "%d y\u0131l"
        },
        ordinal: function(e, a) {
            switch(a){
                case "d":
                case "D":
                case "Do":
                case "DD":
                    return e;
                default:
                    var t;
                    return 0 === e ? e + "'\u0131nc\u0131" : e + (On[t = e % 10] || On[e % 100 - t] || On[100 <= e ? 100 : null]);
            }
        },
        week: {
            dow: 1,
            doy: 7
        }
    }), c.defineLocale("tzl", {
        months: "Januar_Fevraglh_Mar\xe7_Avr\xefu_Mai_G\xfcn_Julia_Guscht_Setemvar_Listop\xe4ts_Noemvar_Zecemvar".split("_"),
        monthsShort: "Jan_Fev_Mar_Avr_Mai_G\xfcn_Jul_Gus_Set_Lis_Noe_Zec".split("_"),
        weekdays: "S\xfaladi_L\xfane\xe7i_Maitzi_M\xe1rcuri_Xh\xfaadi_Vi\xe9ner\xe7i_S\xe1turi".split("_"),
        weekdaysShort: "S\xfal_L\xfan_Mai_M\xe1r_Xh\xfa_Vi\xe9_S\xe1t".split("_"),
        weekdaysMin: "S\xfa_L\xfa_Ma_M\xe1_Xh_Vi_S\xe1".split("_"),
        longDateFormat: {
            LT: "HH.mm",
            LTS: "HH.mm.ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM [dallas] YYYY",
            LLL: "D. MMMM [dallas] YYYY HH.mm",
            LLLL: "dddd, [li] D. MMMM [dallas] YYYY HH.mm"
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function(e) {
            return "d'o" === e.toLowerCase();
        },
        meridiem: function(e, a, t) {
            return 11 < e ? t ? "d'o" : "D'O" : t ? "d'a" : "D'A";
        },
        calendar: {
            sameDay: "[oxhi \xe0] LT",
            nextDay: "[dem\xe0 \xe0] LT",
            nextWeek: "dddd [\xe0] LT",
            lastDay: "[ieiri \xe0] LT",
            lastWeek: "[s\xfcr el] dddd [lasteu \xe0] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "osprei %s",
            past: "ja%s",
            s: Wn,
            ss: Wn,
            m: Wn,
            mm: Wn,
            h: Wn,
            hh: Wn,
            d: Wn,
            dd: Wn,
            M: Wn,
            MM: Wn,
            y: Wn,
            yy: Wn
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("tzm-latn", {
        months: "innayr_br\u02e4ayr\u02e4_mar\u02e4s\u02e4_ibrir_mayyw_ywnyw_ywlywz_\u0263w\u0161t_\u0161wtanbir_kt\u02e4wbr\u02e4_nwwanbir_dwjnbir".split("_"),
        monthsShort: "innayr_br\u02e4ayr\u02e4_mar\u02e4s\u02e4_ibrir_mayyw_ywnyw_ywlywz_\u0263w\u0161t_\u0161wtanbir_kt\u02e4wbr\u02e4_nwwanbir_dwjnbir".split("_"),
        weekdays: "asamas_aynas_asinas_akras_akwas_asimwas_asi\u1e0dyas".split("_"),
        weekdaysShort: "asamas_aynas_asinas_akras_akwas_asimwas_asi\u1e0dyas".split("_"),
        weekdaysMin: "asamas_aynas_asinas_akras_akwas_asimwas_asi\u1e0dyas".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[asdkh g] LT",
            nextDay: "[aska g] LT",
            nextWeek: "dddd [g] LT",
            lastDay: "[assant g] LT",
            lastWeek: "dddd [g] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "dadkh s yan %s",
            past: "yan %s",
            s: "imik",
            ss: "%d imik",
            m: "minu\u1e0d",
            mm: "%d minu\u1e0d",
            h: "sa\u025ba",
            hh: "%d tassa\u025bin",
            d: "ass",
            dd: "%d ossan",
            M: "ayowr",
            MM: "%d iyyirn",
            y: "asgas",
            yy: "%d isgasn"
        },
        week: {
            dow: 6,
            doy: 12
        }
    }), c.defineLocale("tzm", {
        months: "\u2d49\u2d4f\u2d4f\u2d30\u2d62\u2d54_\u2d31\u2d55\u2d30\u2d62\u2d55_\u2d4e\u2d30\u2d55\u2d5a_\u2d49\u2d31\u2d54\u2d49\u2d54_\u2d4e\u2d30\u2d62\u2d62\u2d53_\u2d62\u2d53\u2d4f\u2d62\u2d53_\u2d62\u2d53\u2d4d\u2d62\u2d53\u2d63_\u2d56\u2d53\u2d5b\u2d5c_\u2d5b\u2d53\u2d5c\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d3d\u2d5f\u2d53\u2d31\u2d55_\u2d4f\u2d53\u2d61\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d37\u2d53\u2d4a\u2d4f\u2d31\u2d49\u2d54".split("_"),
        monthsShort: "\u2d49\u2d4f\u2d4f\u2d30\u2d62\u2d54_\u2d31\u2d55\u2d30\u2d62\u2d55_\u2d4e\u2d30\u2d55\u2d5a_\u2d49\u2d31\u2d54\u2d49\u2d54_\u2d4e\u2d30\u2d62\u2d62\u2d53_\u2d62\u2d53\u2d4f\u2d62\u2d53_\u2d62\u2d53\u2d4d\u2d62\u2d53\u2d63_\u2d56\u2d53\u2d5b\u2d5c_\u2d5b\u2d53\u2d5c\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d3d\u2d5f\u2d53\u2d31\u2d55_\u2d4f\u2d53\u2d61\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d37\u2d53\u2d4a\u2d4f\u2d31\u2d49\u2d54".split("_"),
        weekdays: "\u2d30\u2d59\u2d30\u2d4e\u2d30\u2d59_\u2d30\u2d62\u2d4f\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4f\u2d30\u2d59_\u2d30\u2d3d\u2d54\u2d30\u2d59_\u2d30\u2d3d\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4e\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d39\u2d62\u2d30\u2d59".split("_"),
        weekdaysShort: "\u2d30\u2d59\u2d30\u2d4e\u2d30\u2d59_\u2d30\u2d62\u2d4f\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4f\u2d30\u2d59_\u2d30\u2d3d\u2d54\u2d30\u2d59_\u2d30\u2d3d\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4e\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d39\u2d62\u2d30\u2d59".split("_"),
        weekdaysMin: "\u2d30\u2d59\u2d30\u2d4e\u2d30\u2d59_\u2d30\u2d62\u2d4f\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4f\u2d30\u2d59_\u2d30\u2d3d\u2d54\u2d30\u2d59_\u2d30\u2d3d\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4e\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d39\u2d62\u2d30\u2d59".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[\u2d30\u2d59\u2d37\u2d45 \u2d34] LT",
            nextDay: "[\u2d30\u2d59\u2d3d\u2d30 \u2d34] LT",
            nextWeek: "dddd [\u2d34] LT",
            lastDay: "[\u2d30\u2d5a\u2d30\u2d4f\u2d5c \u2d34] LT",
            lastWeek: "dddd [\u2d34] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u2d37\u2d30\u2d37\u2d45 \u2d59 \u2d62\u2d30\u2d4f %s",
            past: "\u2d62\u2d30\u2d4f %s",
            s: "\u2d49\u2d4e\u2d49\u2d3d",
            ss: "%d \u2d49\u2d4e\u2d49\u2d3d",
            m: "\u2d4e\u2d49\u2d4f\u2d53\u2d3a",
            mm: "%d \u2d4e\u2d49\u2d4f\u2d53\u2d3a",
            h: "\u2d59\u2d30\u2d44\u2d30",
            hh: "%d \u2d5c\u2d30\u2d59\u2d59\u2d30\u2d44\u2d49\u2d4f",
            d: "\u2d30\u2d59\u2d59",
            dd: "%d o\u2d59\u2d59\u2d30\u2d4f",
            M: "\u2d30\u2d62o\u2d53\u2d54",
            MM: "%d \u2d49\u2d62\u2d62\u2d49\u2d54\u2d4f",
            y: "\u2d30\u2d59\u2d33\u2d30\u2d59",
            yy: "%d \u2d49\u2d59\u2d33\u2d30\u2d59\u2d4f"
        },
        week: {
            dow: 6,
            doy: 12
        }
    }), c.defineLocale("ug-cn", {
        months: "\u064a\u0627\u0646\u06cb\u0627\u0631_\u0641\u06d0\u06cb\u0631\u0627\u0644_\u0645\u0627\u0631\u062a_\u0626\u0627\u067e\u0631\u06d0\u0644_\u0645\u0627\u064a_\u0626\u0649\u064a\u06c7\u0646_\u0626\u0649\u064a\u06c7\u0644_\u0626\u0627\u06cb\u063a\u06c7\u0633\u062a_\u0633\u06d0\u0646\u062a\u06d5\u0628\u0649\u0631_\u0626\u06c6\u0643\u062a\u06d5\u0628\u0649\u0631_\u0646\u0648\u064a\u0627\u0628\u0649\u0631_\u062f\u06d0\u0643\u0627\u0628\u0649\u0631".split("_"),
        monthsShort: "\u064a\u0627\u0646\u06cb\u0627\u0631_\u0641\u06d0\u06cb\u0631\u0627\u0644_\u0645\u0627\u0631\u062a_\u0626\u0627\u067e\u0631\u06d0\u0644_\u0645\u0627\u064a_\u0626\u0649\u064a\u06c7\u0646_\u0626\u0649\u064a\u06c7\u0644_\u0626\u0627\u06cb\u063a\u06c7\u0633\u062a_\u0633\u06d0\u0646\u062a\u06d5\u0628\u0649\u0631_\u0626\u06c6\u0643\u062a\u06d5\u0628\u0649\u0631_\u0646\u0648\u064a\u0627\u0628\u0649\u0631_\u062f\u06d0\u0643\u0627\u0628\u0649\u0631".split("_"),
        weekdays: "\u064a\u06d5\u0643\u0634\u06d5\u0646\u0628\u06d5_\u062f\u06c8\u0634\u06d5\u0646\u0628\u06d5_\u0633\u06d5\u064a\u0634\u06d5\u0646\u0628\u06d5_\u0686\u0627\u0631\u0634\u06d5\u0646\u0628\u06d5_\u067e\u06d5\u064a\u0634\u06d5\u0646\u0628\u06d5_\u062c\u06c8\u0645\u06d5_\u0634\u06d5\u0646\u0628\u06d5".split("_"),
        weekdaysShort: "\u064a\u06d5_\u062f\u06c8_\u0633\u06d5_\u0686\u0627_\u067e\u06d5_\u062c\u06c8_\u0634\u06d5".split("_"),
        weekdaysMin: "\u064a\u06d5_\u062f\u06c8_\u0633\u06d5_\u0686\u0627_\u067e\u06d5_\u062c\u06c8_\u0634\u06d5".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "YYYY-\u064a\u0649\u0644\u0649M-\u0626\u0627\u064a\u0646\u0649\u06adD-\u0643\u06c8\u0646\u0649",
            LLL: "YYYY-\u064a\u0649\u0644\u0649M-\u0626\u0627\u064a\u0646\u0649\u06adD-\u0643\u06c8\u0646\u0649\u060c HH:mm",
            LLLL: "dddd\u060c YYYY-\u064a\u0649\u0644\u0649M-\u0626\u0627\u064a\u0646\u0649\u06adD-\u0643\u06c8\u0646\u0649\u060c HH:mm"
        },
        meridiemParse: /\u064a\u06d0\u0631\u0649\u0645 \u0643\u06d0\u0686\u06d5|\u0633\u06d5\u06be\u06d5\u0631|\u0686\u06c8\u0634\u062a\u0649\u0646 \u0628\u06c7\u0631\u06c7\u0646|\u0686\u06c8\u0634|\u0686\u06c8\u0634\u062a\u0649\u0646 \u0643\u06d0\u064a\u0649\u0646|\u0643\u06d5\u0686/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "\u064a\u06d0\u0631\u0649\u0645 \u0643\u06d0\u0686\u06d5" === a || "\u0633\u06d5\u06be\u06d5\u0631" === a || "\u0686\u06c8\u0634\u062a\u0649\u0646 \u0628\u06c7\u0631\u06c7\u0646" === a || "\u0686\u06c8\u0634\u062a\u0649\u0646 \u0643\u06d0\u064a\u0649\u0646" !== a && "\u0643\u06d5\u0686" !== a && 11 <= e ? e : e + 12;
        },
        meridiem: function(e, a, t) {
            e = 100 * e + a;
            return e < 600 ? "\u064a\u06d0\u0631\u0649\u0645 \u0643\u06d0\u0686\u06d5" : e < 900 ? "\u0633\u06d5\u06be\u06d5\u0631" : e < 1130 ? "\u0686\u06c8\u0634\u062a\u0649\u0646 \u0628\u06c7\u0631\u06c7\u0646" : e < 1230 ? "\u0686\u06c8\u0634" : e < 1800 ? "\u0686\u06c8\u0634\u062a\u0649\u0646 \u0643\u06d0\u064a\u0649\u0646" : "\u0643\u06d5\u0686";
        },
        calendar: {
            sameDay: "[\u0628\u06c8\u06af\u06c8\u0646 \u0633\u0627\u0626\u06d5\u062a] LT",
            nextDay: "[\u0626\u06d5\u062a\u06d5 \u0633\u0627\u0626\u06d5\u062a] LT",
            nextWeek: "[\u0643\u06d0\u0644\u06d5\u0631\u0643\u0649] dddd [\u0633\u0627\u0626\u06d5\u062a] LT",
            lastDay: "[\u062a\u06c6\u0646\u06c8\u06af\u06c8\u0646] LT",
            lastWeek: "[\u0626\u0627\u0644\u062f\u0649\u0646\u0642\u0649] dddd [\u0633\u0627\u0626\u06d5\u062a] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0643\u06d0\u064a\u0649\u0646",
            past: "%s \u0628\u06c7\u0631\u06c7\u0646",
            s: "\u0646\u06d5\u0686\u0686\u06d5 \u0633\u06d0\u0643\u0648\u0646\u062a",
            ss: "%d \u0633\u06d0\u0643\u0648\u0646\u062a",
            m: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06c7\u062a",
            mm: "%d \u0645\u0649\u0646\u06c7\u062a",
            h: "\u0628\u0649\u0631 \u0633\u0627\u0626\u06d5\u062a",
            hh: "%d \u0633\u0627\u0626\u06d5\u062a",
            d: "\u0628\u0649\u0631 \u0643\u06c8\u0646",
            dd: "%d \u0643\u06c8\u0646",
            M: "\u0628\u0649\u0631 \u0626\u0627\u064a",
            MM: "%d \u0626\u0627\u064a",
            y: "\u0628\u0649\u0631 \u064a\u0649\u0644",
            yy: "%d \u064a\u0649\u0644"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(-\u0643\u06c8\u0646\u0649|-\u0626\u0627\u064a|-\u06be\u06d5\u067e\u062a\u06d5)/,
        ordinal: function(e, a) {
            switch(a){
                case "d":
                case "D":
                case "DDD":
                    return e + "-\u0643\u06c8\u0646\u0649";
                case "w":
                case "W":
                    return e + "-\u06be\u06d5\u067e\u062a\u06d5";
                default:
                    return e;
            }
        },
        preparse: function(e) {
            return e.replace(/\u060c/g, ",");
        },
        postformat: function(e) {
            return e.replace(/,/g, "\u060c");
        },
        week: {
            dow: 1,
            doy: 7
        }
    }), c.defineLocale("uk", {
        months: {
            format: "\u0441\u0456\u0447\u043d\u044f_\u043b\u044e\u0442\u043e\u0433\u043e_\u0431\u0435\u0440\u0435\u0437\u043d\u044f_\u043a\u0432\u0456\u0442\u043d\u044f_\u0442\u0440\u0430\u0432\u043d\u044f_\u0447\u0435\u0440\u0432\u043d\u044f_\u043b\u0438\u043f\u043d\u044f_\u0441\u0435\u0440\u043f\u043d\u044f_\u0432\u0435\u0440\u0435\u0441\u043d\u044f_\u0436\u043e\u0432\u0442\u043d\u044f_\u043b\u0438\u0441\u0442\u043e\u043f\u0430\u0434\u0430_\u0433\u0440\u0443\u0434\u043d\u044f".split("_"),
            standalone: "\u0441\u0456\u0447\u0435\u043d\u044c_\u043b\u044e\u0442\u0438\u0439_\u0431\u0435\u0440\u0435\u0437\u0435\u043d\u044c_\u043a\u0432\u0456\u0442\u0435\u043d\u044c_\u0442\u0440\u0430\u0432\u0435\u043d\u044c_\u0447\u0435\u0440\u0432\u0435\u043d\u044c_\u043b\u0438\u043f\u0435\u043d\u044c_\u0441\u0435\u0440\u043f\u0435\u043d\u044c_\u0432\u0435\u0440\u0435\u0441\u0435\u043d\u044c_\u0436\u043e\u0432\u0442\u0435\u043d\u044c_\u043b\u0438\u0441\u0442\u043e\u043f\u0430\u0434_\u0433\u0440\u0443\u0434\u0435\u043d\u044c".split("_")
        },
        monthsShort: "\u0441\u0456\u0447_\u043b\u044e\u0442_\u0431\u0435\u0440_\u043a\u0432\u0456\u0442_\u0442\u0440\u0430\u0432_\u0447\u0435\u0440\u0432_\u043b\u0438\u043f_\u0441\u0435\u0440\u043f_\u0432\u0435\u0440_\u0436\u043e\u0432\u0442_\u043b\u0438\u0441\u0442_\u0433\u0440\u0443\u0434".split("_"),
        weekdays: function(e, a) {
            var t = {
                nominative: "\u043d\u0435\u0434\u0456\u043b\u044f_\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043e\u043a_\u0432\u0456\u0432\u0442\u043e\u0440\u043e\u043a_\u0441\u0435\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440_\u043f\u2019\u044f\u0442\u043d\u0438\u0446\u044f_\u0441\u0443\u0431\u043e\u0442\u0430".split("_"),
                accusative: "\u043d\u0435\u0434\u0456\u043b\u044e_\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043e\u043a_\u0432\u0456\u0432\u0442\u043e\u0440\u043e\u043a_\u0441\u0435\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440_\u043f\u2019\u044f\u0442\u043d\u0438\u0446\u044e_\u0441\u0443\u0431\u043e\u0442\u0443".split("_"),
                genitive: "\u043d\u0435\u0434\u0456\u043b\u0456_\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043a\u0430_\u0432\u0456\u0432\u0442\u043e\u0440\u043a\u0430_\u0441\u0435\u0440\u0435\u0434\u0438_\u0447\u0435\u0442\u0432\u0435\u0440\u0433\u0430_\u043f\u2019\u044f\u0442\u043d\u0438\u0446\u0456_\u0441\u0443\u0431\u043e\u0442\u0438".split("_")
            };
            return !0 === e ? t.nominative.slice(1, 7).concat(t.nominative.slice(0, 1)) : e ? t[/(\[[\u0412\u0432\u0423\u0443]\]) ?dddd/.test(a) ? "accusative" : /\[?(?:\u043c\u0438\u043d\u0443\u043b\u043e\u0457|\u043d\u0430\u0441\u0442\u0443\u043f\u043d\u043e\u0457)? ?\] ?dddd/.test(a) ? "genitive" : "nominative"][e.day()] : t.nominative;
        },
        weekdaysShort: "\u043d\u0434_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),
        weekdaysMin: "\u043d\u0434_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY \u0440.",
            LLL: "D MMMM YYYY \u0440., HH:mm",
            LLLL: "dddd, D MMMM YYYY \u0440., HH:mm"
        },
        calendar: {
            sameDay: En("[\u0421\u044c\u043e\u0433\u043e\u0434\u043d\u0456 "),
            nextDay: En("[\u0417\u0430\u0432\u0442\u0440\u0430 "),
            lastDay: En("[\u0412\u0447\u043e\u0440\u0430 "),
            nextWeek: En("[\u0423] dddd ["),
            lastWeek: function() {
                switch(this.day()){
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return En("[\u041c\u0438\u043d\u0443\u043b\u043e\u0457] dddd [").call(this);
                    case 1:
                    case 2:
                    case 4:
                        return En("[\u041c\u0438\u043d\u0443\u043b\u043e\u0433\u043e] dddd [").call(this);
                }
            },
            sameElse: "L"
        },
        relativeTime: {
            future: "\u0437\u0430 %s",
            past: "%s \u0442\u043e\u043c\u0443",
            s: "\u0434\u0435\u043a\u0456\u043b\u044c\u043a\u0430 \u0441\u0435\u043a\u0443\u043d\u0434",
            ss: An,
            m: An,
            mm: An,
            h: "\u0433\u043e\u0434\u0438\u043d\u0443",
            hh: An,
            d: "\u0434\u0435\u043d\u044c",
            dd: An,
            M: "\u043c\u0456\u0441\u044f\u0446\u044c",
            MM: An,
            y: "\u0440\u0456\u043a",
            yy: An
        },
        meridiemParse: /\u043d\u043e\u0447\u0456|\u0440\u0430\u043d\u043a\u0443|\u0434\u043d\u044f|\u0432\u0435\u0447\u043e\u0440\u0430/,
        isPM: function(e) {
            return /^(\u0434\u043d\u044f|\u0432\u0435\u0447\u043e\u0440\u0430)$/.test(e);
        },
        meridiem: function(e, a, t) {
            return e < 4 ? "\u043d\u043e\u0447\u0456" : e < 12 ? "\u0440\u0430\u043d\u043a\u0443" : e < 17 ? "\u0434\u043d\u044f" : "\u0432\u0435\u0447\u043e\u0440\u0430";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(\u0439|\u0433\u043e)/,
        ordinal: function(e, a) {
            switch(a){
                case "M":
                case "d":
                case "DDD":
                case "w":
                case "W":
                    return e + "-\u0439";
                case "D":
                    return e + "-\u0433\u043e";
                default:
                    return e;
            }
        },
        week: {
            dow: 1,
            doy: 7
        }
    });
    i = [
        "\u062c\u0646\u0648\u0631\u06cc",
        "\u0641\u0631\u0648\u0631\u06cc",
        "\u0645\u0627\u0631\u0686",
        "\u0627\u067e\u0631\u06cc\u0644",
        "\u0645\u0626\u06cc",
        "\u062c\u0648\u0646",
        "\u062c\u0648\u0644\u0627\u0626\u06cc",
        "\u0627\u06af\u0633\u062a",
        "\u0633\u062a\u0645\u0628\u0631",
        "\u0627\u06a9\u062a\u0648\u0628\u0631",
        "\u0646\u0648\u0645\u0628\u0631",
        "\u062f\u0633\u0645\u0628\u0631"
    ], jt = [
        "\u0627\u062a\u0648\u0627\u0631",
        "\u067e\u06cc\u0631",
        "\u0645\u0646\u06af\u0644",
        "\u0628\u062f\u06be",
        "\u062c\u0645\u0639\u0631\u0627\u062a",
        "\u062c\u0645\u0639\u06c1",
        "\u06c1\u0641\u062a\u06c1"
    ];
    return c.defineLocale("ur", {
        months: i,
        monthsShort: i,
        weekdays: jt,
        weekdaysShort: jt,
        weekdaysMin: jt,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd\u060c D MMMM YYYY HH:mm"
        },
        meridiemParse: /\u0635\u0628\u062d|\u0634\u0627\u0645/,
        isPM: function(e) {
            return "\u0634\u0627\u0645" === e;
        },
        meridiem: function(e, a, t) {
            return e < 12 ? "\u0635\u0628\u062d" : "\u0634\u0627\u0645";
        },
        calendar: {
            sameDay: "[\u0622\u062c \u0628\u0648\u0642\u062a] LT",
            nextDay: "[\u06a9\u0644 \u0628\u0648\u0642\u062a] LT",
            nextWeek: "dddd [\u0628\u0648\u0642\u062a] LT",
            lastDay: "[\u06af\u0630\u0634\u062a\u06c1 \u0631\u0648\u0632 \u0628\u0648\u0642\u062a] LT",
            lastWeek: "[\u06af\u0630\u0634\u062a\u06c1] dddd [\u0628\u0648\u0642\u062a] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s \u0628\u0639\u062f",
            past: "%s \u0642\u0628\u0644",
            s: "\u0686\u0646\u062f \u0633\u06cc\u06a9\u0646\u0688",
            ss: "%d \u0633\u06cc\u06a9\u0646\u0688",
            m: "\u0627\u06cc\u06a9 \u0645\u0646\u0679",
            mm: "%d \u0645\u0646\u0679",
            h: "\u0627\u06cc\u06a9 \u06af\u06be\u0646\u0679\u06c1",
            hh: "%d \u06af\u06be\u0646\u0679\u06d2",
            d: "\u0627\u06cc\u06a9 \u062f\u0646",
            dd: "%d \u062f\u0646",
            M: "\u0627\u06cc\u06a9 \u0645\u0627\u06c1",
            MM: "%d \u0645\u0627\u06c1",
            y: "\u0627\u06cc\u06a9 \u0633\u0627\u0644",
            yy: "%d \u0633\u0627\u0644"
        },
        preparse: function(e) {
            return e.replace(/\u060c/g, ",");
        },
        postformat: function(e) {
            return e.replace(/,/g, "\u060c");
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("uz-latn", {
        months: "Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr".split("_"),
        monthsShort: "Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek".split("_"),
        weekdays: "Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba".split("_"),
        weekdaysShort: "Yak_Dush_Sesh_Chor_Pay_Jum_Shan".split("_"),
        weekdaysMin: "Ya_Du_Se_Cho_Pa_Ju_Sha".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "D MMMM YYYY, dddd HH:mm"
        },
        calendar: {
            sameDay: "[Bugun soat] LT [da]",
            nextDay: "[Ertaga] LT [da]",
            nextWeek: "dddd [kuni soat] LT [da]",
            lastDay: "[Kecha soat] LT [da]",
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: "L"
        },
        relativeTime: {
            future: "Yaqin %s ichida",
            past: "Bir necha %s oldin",
            s: "soniya",
            ss: "%d soniya",
            m: "bir daqiqa",
            mm: "%d daqiqa",
            h: "bir soat",
            hh: "%d soat",
            d: "bir kun",
            dd: "%d kun",
            M: "bir oy",
            MM: "%d oy",
            y: "bir yil",
            yy: "%d yil"
        },
        week: {
            dow: 1,
            doy: 7
        }
    }), c.defineLocale("uz", {
        months: "\u044f\u043d\u0432\u0430\u0440_\u0444\u0435\u0432\u0440\u0430\u043b_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440_\u043e\u043a\u0442\u044f\u0431\u0440_\u043d\u043e\u044f\u0431\u0440_\u0434\u0435\u043a\u0430\u0431\u0440".split("_"),
        monthsShort: "\u044f\u043d\u0432_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433_\u0441\u0435\u043d_\u043e\u043a\u0442_\u043d\u043e\u044f_\u0434\u0435\u043a".split("_"),
        weekdays: "\u042f\u043a\u0448\u0430\u043d\u0431\u0430_\u0414\u0443\u0448\u0430\u043d\u0431\u0430_\u0421\u0435\u0448\u0430\u043d\u0431\u0430_\u0427\u043e\u0440\u0448\u0430\u043d\u0431\u0430_\u041f\u0430\u0439\u0448\u0430\u043d\u0431\u0430_\u0416\u0443\u043c\u0430_\u0428\u0430\u043d\u0431\u0430".split("_"),
        weekdaysShort: "\u042f\u043a\u0448_\u0414\u0443\u0448_\u0421\u0435\u0448_\u0427\u043e\u0440_\u041f\u0430\u0439_\u0416\u0443\u043c_\u0428\u0430\u043d".split("_"),
        weekdaysMin: "\u042f\u043a_\u0414\u0443_\u0421\u0435_\u0427\u043e_\u041f\u0430_\u0416\u0443_\u0428\u0430".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "D MMMM YYYY, dddd HH:mm"
        },
        calendar: {
            sameDay: "[\u0411\u0443\u0433\u0443\u043d \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",
            nextDay: "[\u042d\u0440\u0442\u0430\u0433\u0430] LT [\u0434\u0430]",
            nextWeek: "dddd [\u043a\u0443\u043d\u0438 \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",
            lastDay: "[\u041a\u0435\u0447\u0430 \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",
            lastWeek: "[\u0423\u0442\u0433\u0430\u043d] dddd [\u043a\u0443\u043d\u0438 \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",
            sameElse: "L"
        },
        relativeTime: {
            future: "\u042f\u043a\u0438\u043d %s \u0438\u0447\u0438\u0434\u0430",
            past: "\u0411\u0438\u0440 \u043d\u0435\u0447\u0430 %s \u043e\u043b\u0434\u0438\u043d",
            s: "\u0444\u0443\u0440\u0441\u0430\u0442",
            ss: "%d \u0444\u0443\u0440\u0441\u0430\u0442",
            m: "\u0431\u0438\u0440 \u0434\u0430\u043a\u0438\u043a\u0430",
            mm: "%d \u0434\u0430\u043a\u0438\u043a\u0430",
            h: "\u0431\u0438\u0440 \u0441\u043e\u0430\u0442",
            hh: "%d \u0441\u043e\u0430\u0442",
            d: "\u0431\u0438\u0440 \u043a\u0443\u043d",
            dd: "%d \u043a\u0443\u043d",
            M: "\u0431\u0438\u0440 \u043e\u0439",
            MM: "%d \u043e\u0439",
            y: "\u0431\u0438\u0440 \u0439\u0438\u043b",
            yy: "%d \u0439\u0438\u043b"
        },
        week: {
            dow: 1,
            doy: 7
        }
    }), c.defineLocale("vi", {
        months: "th\xe1ng 1_th\xe1ng 2_th\xe1ng 3_th\xe1ng 4_th\xe1ng 5_th\xe1ng 6_th\xe1ng 7_th\xe1ng 8_th\xe1ng 9_th\xe1ng 10_th\xe1ng 11_th\xe1ng 12".split("_"),
        monthsShort: "Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12".split("_"),
        monthsParseExact: !0,
        weekdays: "ch\u1ee7 nh\u1eadt_th\u1ee9 hai_th\u1ee9 ba_th\u1ee9 t\u01b0_th\u1ee9 n\u0103m_th\u1ee9 s\xe1u_th\u1ee9 b\u1ea3y".split("_"),
        weekdaysShort: "CN_T2_T3_T4_T5_T6_T7".split("_"),
        weekdaysMin: "CN_T2_T3_T4_T5_T6_T7".split("_"),
        weekdaysParseExact: !0,
        meridiemParse: /sa|ch/i,
        isPM: function(e) {
            return /^ch$/i.test(e);
        },
        meridiem: function(e, a, t) {
            return e < 12 ? t ? "sa" : "SA" : t ? "ch" : "CH";
        },
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM [n\u0103m] YYYY",
            LLL: "D MMMM [n\u0103m] YYYY HH:mm",
            LLLL: "dddd, D MMMM [n\u0103m] YYYY HH:mm",
            l: "DD/M/YYYY",
            ll: "D MMM YYYY",
            lll: "D MMM YYYY HH:mm",
            llll: "ddd, D MMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[H\xf4m nay l\xfac] LT",
            nextDay: "[Ng\xe0y mai l\xfac] LT",
            nextWeek: "dddd [tu\u1ea7n t\u1edbi l\xfac] LT",
            lastDay: "[H\xf4m qua l\xfac] LT",
            lastWeek: "dddd [tu\u1ea7n tr\u01b0\u1edbc l\xfac] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "%s t\u1edbi",
            past: "%s tr\u01b0\u1edbc",
            s: "v\xe0i gi\xe2y",
            ss: "%d gi\xe2y",
            m: "m\u1ed9t ph\xfat",
            mm: "%d ph\xfat",
            h: "m\u1ed9t gi\u1edd",
            hh: "%d gi\u1edd",
            d: "m\u1ed9t ng\xe0y",
            dd: "%d ng\xe0y",
            w: "m\u1ed9t tu\u1ea7n",
            ww: "%d tu\u1ea7n",
            M: "m\u1ed9t th\xe1ng",
            MM: "%d th\xe1ng",
            y: "m\u1ed9t n\u0103m",
            yy: "%d n\u0103m"
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function(e) {
            return e;
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("x-pseudo", {
        months: "J~\xe1\xf1\xfa\xe1~r\xfd_F~\xe9br\xfa~\xe1r\xfd_~M\xe1rc~h_\xc1p~r\xedl_~M\xe1\xfd_~J\xfa\xf1\xe9~_J\xfal~\xfd_\xc1\xfa~g\xfast~_S\xe9p~t\xe9mb~\xe9r_\xd3~ct\xf3b~\xe9r_\xd1~\xf3v\xe9m~b\xe9r_~D\xe9c\xe9~mb\xe9r".split("_"),
        monthsShort: "J~\xe1\xf1_~F\xe9b_~M\xe1r_~\xc1pr_~M\xe1\xfd_~J\xfa\xf1_~J\xfal_~\xc1\xfag_~S\xe9p_~\xd3ct_~\xd1\xf3v_~D\xe9c".split("_"),
        monthsParseExact: !0,
        weekdays: "S~\xfa\xf1d\xe1~\xfd_M\xf3~\xf1d\xe1\xfd~_T\xfa\xe9~sd\xe1\xfd~_W\xe9d~\xf1\xe9sd~\xe1\xfd_T~h\xfars~d\xe1\xfd_~Fr\xedd~\xe1\xfd_S~\xe1t\xfar~d\xe1\xfd".split("_"),
        weekdaysShort: "S~\xfa\xf1_~M\xf3\xf1_~T\xfa\xe9_~W\xe9d_~Th\xfa_~Fr\xed_~S\xe1t".split("_"),
        weekdaysMin: "S~\xfa_M\xf3~_T\xfa_~W\xe9_T~h_Fr~_S\xe1".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
            sameDay: "[T~\xf3d\xe1~\xfd \xe1t] LT",
            nextDay: "[T~\xf3m\xf3~rr\xf3~w \xe1t] LT",
            nextWeek: "dddd [\xe1t] LT",
            lastDay: "[\xdd~\xe9st~\xe9rd\xe1~\xfd \xe1t] LT",
            lastWeek: "[L~\xe1st] dddd [\xe1t] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "\xed~\xf1 %s",
            past: "%s \xe1~g\xf3",
            s: "\xe1 ~f\xe9w ~s\xe9c\xf3~\xf1ds",
            ss: "%d s~\xe9c\xf3\xf1~ds",
            m: "\xe1 ~m\xed\xf1~\xfat\xe9",
            mm: "%d m~\xed\xf1\xfa~t\xe9s",
            h: "\xe1~\xf1 h\xf3~\xfar",
            hh: "%d h~\xf3\xfars",
            d: "\xe1 ~d\xe1\xfd",
            dd: "%d d~\xe1\xfds",
            M: "\xe1 ~m\xf3\xf1~th",
            MM: "%d m~\xf3\xf1t~hs",
            y: "\xe1 ~\xfd\xe9\xe1r",
            yy: "%d \xfd~\xe9\xe1rs"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(e) {
            var a = e % 10;
            return e + (1 == ~~(e % 100 / 10) ? "th" : 1 == a ? "st" : 2 == a ? "nd" : 3 == a ? "rd" : "th");
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("yo", {
        months: "S\u1eb9\u0301r\u1eb9\u0301_E\u0300re\u0300le\u0300_\u1eb8r\u1eb9\u0300na\u0300_I\u0300gbe\u0301_E\u0300bibi_O\u0300ku\u0300du_Ag\u1eb9mo_O\u0300gu\u0301n_Owewe_\u1ecc\u0300wa\u0300ra\u0300_Be\u0301lu\u0301_\u1ecc\u0300p\u1eb9\u0300\u0300".split("_"),
        monthsShort: "S\u1eb9\u0301r_E\u0300rl_\u1eb8rn_I\u0300gb_E\u0300bi_O\u0300ku\u0300_Ag\u1eb9_O\u0300gu\u0301_Owe_\u1ecc\u0300wa\u0300_Be\u0301l_\u1ecc\u0300p\u1eb9\u0300\u0300".split("_"),
        weekdays: "A\u0300i\u0300ku\u0301_Aje\u0301_I\u0300s\u1eb9\u0301gun_\u1eccj\u1ecd\u0301ru\u0301_\u1eccj\u1ecd\u0301b\u1ecd_\u1eb8ti\u0300_A\u0300ba\u0301m\u1eb9\u0301ta".split("_"),
        weekdaysShort: "A\u0300i\u0300k_Aje\u0301_I\u0300s\u1eb9\u0301_\u1eccjr_\u1eccjb_\u1eb8ti\u0300_A\u0300ba\u0301".split("_"),
        weekdaysMin: "A\u0300i\u0300_Aj_I\u0300s_\u1eccr_\u1eccb_\u1eb8t_A\u0300b".split("_"),
        longDateFormat: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY h:mm A",
            LLLL: "dddd, D MMMM YYYY h:mm A"
        },
        calendar: {
            sameDay: "[O\u0300ni\u0300 ni] LT",
            nextDay: "[\u1ecc\u0300la ni] LT",
            nextWeek: "dddd [\u1eccs\u1eb9\u0300 to\u0301n'b\u1ecd] [ni] LT",
            lastDay: "[A\u0300na ni] LT",
            lastWeek: "dddd [\u1eccs\u1eb9\u0300 to\u0301l\u1ecd\u0301] [ni] LT",
            sameElse: "L"
        },
        relativeTime: {
            future: "ni\u0301 %s",
            past: "%s k\u1ecdja\u0301",
            s: "i\u0300s\u1eb9ju\u0301 aaya\u0301 die",
            ss: "aaya\u0301 %d",
            m: "i\u0300s\u1eb9ju\u0301 kan",
            mm: "i\u0300s\u1eb9ju\u0301 %d",
            h: "wa\u0301kati kan",
            hh: "wa\u0301kati %d",
            d: "\u1ecdj\u1ecd\u0301 kan",
            dd: "\u1ecdj\u1ecd\u0301 %d",
            M: "osu\u0300 kan",
            MM: "osu\u0300 %d",
            y: "\u1ecddu\u0301n kan",
            yy: "\u1ecddu\u0301n %d"
        },
        dayOfMonthOrdinalParse: /\u1ecdj\u1ecd\u0301\s\d{1,2}/,
        ordinal: "\u1ecdj\u1ecd\u0301 %d",
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("zh-cn", {
        months: "\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split("_"),
        monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),
        weekdays: "\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split("_"),
        weekdaysShort: "\u5468\u65e5_\u5468\u4e00_\u5468\u4e8c_\u5468\u4e09_\u5468\u56db_\u5468\u4e94_\u5468\u516d".split("_"),
        weekdaysMin: "\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY/MM/DD",
            LL: "YYYY\u5e74M\u6708D\u65e5",
            LLL: "YYYY\u5e74M\u6708D\u65e5Ah\u70b9mm\u5206",
            LLLL: "YYYY\u5e74M\u6708D\u65e5ddddAh\u70b9mm\u5206",
            l: "YYYY/M/D",
            ll: "YYYY\u5e74M\u6708D\u65e5",
            lll: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
            llll: "YYYY\u5e74M\u6708D\u65e5dddd HH:mm"
        },
        meridiemParse: /\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "\u51cc\u6668" === a || "\u65e9\u4e0a" === a || "\u4e0a\u5348" === a || "\u4e0b\u5348" !== a && "\u665a\u4e0a" !== a && 11 <= e ? e : e + 12;
        },
        meridiem: function(e, a, t) {
            e = 100 * e + a;
            return e < 600 ? "\u51cc\u6668" : e < 900 ? "\u65e9\u4e0a" : e < 1130 ? "\u4e0a\u5348" : e < 1230 ? "\u4e2d\u5348" : e < 1800 ? "\u4e0b\u5348" : "\u665a\u4e0a";
        },
        calendar: {
            sameDay: "[\u4eca\u5929]LT",
            nextDay: "[\u660e\u5929]LT",
            nextWeek: function(e) {
                return e.week() !== this.week() ? "[\u4e0b]dddLT" : "[\u672c]dddLT";
            },
            lastDay: "[\u6628\u5929]LT",
            lastWeek: function(e) {
                return this.week() !== e.week() ? "[\u4e0a]dddLT" : "[\u672c]dddLT";
            },
            sameElse: "L"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\u65e5|\u6708|\u5468)/,
        ordinal: function(e, a) {
            switch(a){
                case "d":
                case "D":
                case "DDD":
                    return e + "\u65e5";
                case "M":
                    return e + "\u6708";
                case "w":
                case "W":
                    return e + "\u5468";
                default:
                    return e;
            }
        },
        relativeTime: {
            future: "%s\u540e",
            past: "%s\u524d",
            s: "\u51e0\u79d2",
            ss: "%d \u79d2",
            m: "1 \u5206\u949f",
            mm: "%d \u5206\u949f",
            h: "1 \u5c0f\u65f6",
            hh: "%d \u5c0f\u65f6",
            d: "1 \u5929",
            dd: "%d \u5929",
            w: "1 \u5468",
            ww: "%d \u5468",
            M: "1 \u4e2a\u6708",
            MM: "%d \u4e2a\u6708",
            y: "1 \u5e74",
            yy: "%d \u5e74"
        },
        week: {
            dow: 1,
            doy: 4
        }
    }), c.defineLocale("zh-hk", {
        months: "\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split("_"),
        monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),
        weekdays: "\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split("_"),
        weekdaysShort: "\u9031\u65e5_\u9031\u4e00_\u9031\u4e8c_\u9031\u4e09_\u9031\u56db_\u9031\u4e94_\u9031\u516d".split("_"),
        weekdaysMin: "\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY/MM/DD",
            LL: "YYYY\u5e74M\u6708D\u65e5",
            LLL: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
            LLLL: "YYYY\u5e74M\u6708D\u65e5dddd HH:mm",
            l: "YYYY/M/D",
            ll: "YYYY\u5e74M\u6708D\u65e5",
            lll: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
            llll: "YYYY\u5e74M\u6708D\u65e5dddd HH:mm"
        },
        meridiemParse: /\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "\u51cc\u6668" === a || "\u65e9\u4e0a" === a || "\u4e0a\u5348" === a ? e : "\u4e2d\u5348" === a ? 11 <= e ? e : e + 12 : "\u4e0b\u5348" === a || "\u665a\u4e0a" === a ? e + 12 : void 0;
        },
        meridiem: function(e, a, t) {
            e = 100 * e + a;
            return e < 600 ? "\u51cc\u6668" : e < 900 ? "\u65e9\u4e0a" : e < 1200 ? "\u4e0a\u5348" : 1200 === e ? "\u4e2d\u5348" : e < 1800 ? "\u4e0b\u5348" : "\u665a\u4e0a";
        },
        calendar: {
            sameDay: "[\u4eca\u5929]LT",
            nextDay: "[\u660e\u5929]LT",
            nextWeek: "[\u4e0b]ddddLT",
            lastDay: "[\u6628\u5929]LT",
            lastWeek: "[\u4e0a]ddddLT",
            sameElse: "L"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\u65e5|\u6708|\u9031)/,
        ordinal: function(e, a) {
            switch(a){
                case "d":
                case "D":
                case "DDD":
                    return e + "\u65e5";
                case "M":
                    return e + "\u6708";
                case "w":
                case "W":
                    return e + "\u9031";
                default:
                    return e;
            }
        },
        relativeTime: {
            future: "%s\u5f8c",
            past: "%s\u524d",
            s: "\u5e7e\u79d2",
            ss: "%d \u79d2",
            m: "1 \u5206\u9418",
            mm: "%d \u5206\u9418",
            h: "1 \u5c0f\u6642",
            hh: "%d \u5c0f\u6642",
            d: "1 \u5929",
            dd: "%d \u5929",
            M: "1 \u500b\u6708",
            MM: "%d \u500b\u6708",
            y: "1 \u5e74",
            yy: "%d \u5e74"
        }
    }), c.defineLocale("zh-mo", {
        months: "\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split("_"),
        monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),
        weekdays: "\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split("_"),
        weekdaysShort: "\u9031\u65e5_\u9031\u4e00_\u9031\u4e8c_\u9031\u4e09_\u9031\u56db_\u9031\u4e94_\u9031\u516d".split("_"),
        weekdaysMin: "\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "YYYY\u5e74M\u6708D\u65e5",
            LLL: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
            LLLL: "YYYY\u5e74M\u6708D\u65e5dddd HH:mm",
            l: "D/M/YYYY",
            ll: "YYYY\u5e74M\u6708D\u65e5",
            lll: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
            llll: "YYYY\u5e74M\u6708D\u65e5dddd HH:mm"
        },
        meridiemParse: /\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "\u51cc\u6668" === a || "\u65e9\u4e0a" === a || "\u4e0a\u5348" === a ? e : "\u4e2d\u5348" === a ? 11 <= e ? e : e + 12 : "\u4e0b\u5348" === a || "\u665a\u4e0a" === a ? e + 12 : void 0;
        },
        meridiem: function(e, a, t) {
            e = 100 * e + a;
            return e < 600 ? "\u51cc\u6668" : e < 900 ? "\u65e9\u4e0a" : e < 1130 ? "\u4e0a\u5348" : e < 1230 ? "\u4e2d\u5348" : e < 1800 ? "\u4e0b\u5348" : "\u665a\u4e0a";
        },
        calendar: {
            sameDay: "[\u4eca\u5929] LT",
            nextDay: "[\u660e\u5929] LT",
            nextWeek: "[\u4e0b]dddd LT",
            lastDay: "[\u6628\u5929] LT",
            lastWeek: "[\u4e0a]dddd LT",
            sameElse: "L"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\u65e5|\u6708|\u9031)/,
        ordinal: function(e, a) {
            switch(a){
                case "d":
                case "D":
                case "DDD":
                    return e + "\u65e5";
                case "M":
                    return e + "\u6708";
                case "w":
                case "W":
                    return e + "\u9031";
                default:
                    return e;
            }
        },
        relativeTime: {
            future: "%s\u5167",
            past: "%s\u524d",
            s: "\u5e7e\u79d2",
            ss: "%d \u79d2",
            m: "1 \u5206\u9418",
            mm: "%d \u5206\u9418",
            h: "1 \u5c0f\u6642",
            hh: "%d \u5c0f\u6642",
            d: "1 \u5929",
            dd: "%d \u5929",
            M: "1 \u500b\u6708",
            MM: "%d \u500b\u6708",
            y: "1 \u5e74",
            yy: "%d \u5e74"
        }
    }), c.defineLocale("zh-tw", {
        months: "\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split("_"),
        monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),
        weekdays: "\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split("_"),
        weekdaysShort: "\u9031\u65e5_\u9031\u4e00_\u9031\u4e8c_\u9031\u4e09_\u9031\u56db_\u9031\u4e94_\u9031\u516d".split("_"),
        weekdaysMin: "\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY/MM/DD",
            LL: "YYYY\u5e74M\u6708D\u65e5",
            LLL: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
            LLLL: "YYYY\u5e74M\u6708D\u65e5dddd HH:mm",
            l: "YYYY/M/D",
            ll: "YYYY\u5e74M\u6708D\u65e5",
            lll: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
            llll: "YYYY\u5e74M\u6708D\u65e5dddd HH:mm"
        },
        meridiemParse: /\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,
        meridiemHour: function(e, a) {
            return 12 === e && (e = 0), "\u51cc\u6668" === a || "\u65e9\u4e0a" === a || "\u4e0a\u5348" === a ? e : "\u4e2d\u5348" === a ? 11 <= e ? e : e + 12 : "\u4e0b\u5348" === a || "\u665a\u4e0a" === a ? e + 12 : void 0;
        },
        meridiem: function(e, a, t) {
            e = 100 * e + a;
            return e < 600 ? "\u51cc\u6668" : e < 900 ? "\u65e9\u4e0a" : e < 1130 ? "\u4e0a\u5348" : e < 1230 ? "\u4e2d\u5348" : e < 1800 ? "\u4e0b\u5348" : "\u665a\u4e0a";
        },
        calendar: {
            sameDay: "[\u4eca\u5929] LT",
            nextDay: "[\u660e\u5929] LT",
            nextWeek: "[\u4e0b]dddd LT",
            lastDay: "[\u6628\u5929] LT",
            lastWeek: "[\u4e0a]dddd LT",
            sameElse: "L"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\u65e5|\u6708|\u9031)/,
        ordinal: function(e, a) {
            switch(a){
                case "d":
                case "D":
                case "DDD":
                    return e + "\u65e5";
                case "M":
                    return e + "\u6708";
                case "w":
                case "W":
                    return e + "\u9031";
                default:
                    return e;
            }
        },
        relativeTime: {
            future: "%s\u5f8c",
            past: "%s\u524d",
            s: "\u5e7e\u79d2",
            ss: "%d \u79d2",
            m: "1 \u5206\u9418",
            mm: "%d \u5206\u9418",
            h: "1 \u5c0f\u6642",
            hh: "%d \u5c0f\u6642",
            d: "1 \u5929",
            dd: "%d \u5929",
            M: "1 \u500b\u6708",
            MM: "%d \u500b\u6708",
            y: "1 \u5e74",
            yy: "%d \u5e74"
        }
    }), c.locale("en"), c;
});

});

parcelRegister("cAQNV", function(module, exports) {

$parcel$export(module.exports, "router", () => router);
$parcel$export(module.exports, "Route", () => routeHoc);
$parcel$export(module.exports, "Router", () => routerHoc);

var $4zYSa = parcelRequire("4zYSa");
var $jR26U = parcelRequire("jR26U");
/**
 * Tokenize input string.
 */ function lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
/**
 * Parse a string for the raw tokens.
 */ function parse(str, options) {
    if (options === void 0) options = {};
    var tokens = lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a;
    var defaultPattern = "[^".concat(escapeString(options.delimiter || "/#?"), "]+?");
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || defaultPattern,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? defaultPattern : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
/**
 * Compile a string to a template function for the path.
 */ function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function tokensToFunction(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 */ function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return pathToRegexp(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), flags(options));
}
/**
 * Create a path regexp from string input.
 */ function stringToRegexp(path, keys, options) {
    return tokensToRegexp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 */ function tokensToRegexp(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat(escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat(escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += escapeString(encode(token));
        else {
            var prefix = escapeString(encode(token.prefix));
            var suffix = escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else if (token.modifier === "+" || token.modifier === "*") route += "((?:".concat(token.pattern, ")").concat(token.modifier, ")");
                else route += "(".concat(token.pattern, ")").concat(token.modifier);
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, flags(options));
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 */ function pathToRegexp(path, keys, options) {
    if (path instanceof RegExp) return regexpToRegexp(path, keys);
    if (Array.isArray(path)) return arrayToRegexp(path, keys, options);
    return stringToRegexp(path, keys, options);
}
/**
 * Cancel token
 * @private
 * @type { Symbol }
 */ const CANCEL = Symbol();
/**
 * Helper that can be returned by ruit function to cancel the tasks chain
 * @returns { Symbol } internal private constant
 * @example
 *
 * ruit(
 *   100,
 *   num => Math.random() * num
 *   num => num > 50 ? ruit.cancel() : num
 *   num => num - 2
 * ).then(result => {
 *   console.log(result) // here we will get only number lower than 50
 * })
 *
 */ ruit.cancel = ()=>CANCEL;
/**
 * The same as ruit() but with the arguments inverted from right to left
 * @param   { * } tasks - list of tasks to process sequentially
 * @returns { Promise } a promise containing the result of the whole chain
 * @example
 *
 * const curry = f => a => b => f(a, b)
 * const add = (a, b) => a + b
 *
 * const addOne = curry(add)(1)
 *
 * const squareAsync = (num) => {
 *   return new Promise(r => {
 *     setTimeout(r, 500, num * 2)
 *   })
 * }
 *
 * // a -> a + a -> a * 2
 * // basically from right to left: 1 => 1 + 1 => 2 * 2
 * ruit.compose(squareAsync, addOne, 1).then(result => console.log(result)) // 4
 */ ruit.compose = (...tasks)=>ruit(...tasks.reverse());
/**
 * Serialize a list of sync and async tasks from left to right
 * @param   { * } tasks - list of tasks to process sequentially
 * @returns { Promise } a promise containing the result of the whole chain
 * @example
 *
 * const curry = f => a => b => f(a, b)
 * const add = (a, b) => a + b
 *
 * const addOne = curry(add)(1)
 *
 * const squareAsync = (num) => {
 *   return new Promise(r => {
 *     setTimeout(r, 500, num * 2)
 *   })
 * }
 *
 * // a -> a + a -> a * 2
 * // basically from left to right: 1 => 1 + 1 => 2 * 2
 * ruit(1, addOne, squareAsync).then(result => console.log(result)) // 4
 */ function ruit(...tasks) {
    return new Promise((resolve, reject)=>{
        return function run(queue, result) {
            if (!queue.length) return resolve(result);
            const [task, ...rest] = queue;
            const value = typeof task === 'function' ? task(result) : task;
            const done = (v)=>run(rest, v);
            // check against nil values
            if (value != null) {
                if (value === CANCEL) return;
                if (value.then) return value.then(done, reject);
            }
            return Promise.resolve(done(value));
        }(tasks);
    });
}
// Store the erre the API methods to handle the plugins installation
const API_METHODS = new Set();
const UNSUBSCRIBE_SYMBOL = Symbol();
const UNSUBSCRIBE_METHOD = 'off';
const CANCEL_METHOD = 'cancel';
/**
 * Factory function to create the stream generator
 * @private
 * @param {Set} modifiers - stream input modifiers
 * @returns {Generator} the stream generator
 */ function createStream(modifiers) {
    const stream = function* stream() {
        while(true){
            // get the initial stream value
            const input = yield;
            // run the input sequence
            yield ruit(input, ...modifiers);
        }
    }();
    // start the stream
    stream.next();
    return stream;
}
/**
 * Dispatch a value to several listeners
 * @private
 * @param   {Set} callbacks - callbacks collection
 * @param   {*} value - anything
 * @returns {Set} the callbacks received
 */ function dispatch(callbacks, value) {
    callbacks.forEach((f)=>{
        // unsubscribe the callback if erre.unsubscribe() will be returned
        if (f(value) === UNSUBSCRIBE_SYMBOL) callbacks.delete(f);
    });
    return callbacks;
}
/**
 * Throw a panic error
 * @param {string} message - error message
 * @returns {Error} an error object
 */ function panic$1(message) {
    throw new Error(message);
}
/**
 * Install an erre plugin adding it to the API
 * @param   {string} name - plugin name
 * @param   {Function} fn - new erre API method
 * @returns {Function} return the erre function
 */ erre.install = function(name, fn) {
    if (!name || typeof name !== 'string') panic$1('Please provide a name (as string) for your erre plugin');
    if (!fn || typeof fn !== 'function') panic$1('Please provide a function for your erre plugin');
    if (API_METHODS.has(name)) panic$1(`The ${name} is already part of the erre API, please provide a different name`);
    else {
        erre[name] = fn;
        API_METHODS.add(name);
    }
    return erre;
};
// alias for ruit canel to stop a stream chain
erre.install(CANCEL_METHOD, ruit.cancel);
// unsubscribe helper
erre.install(UNSUBSCRIBE_METHOD, ()=>UNSUBSCRIBE_SYMBOL);
/**
 * Stream constuction function
 * @param   {...Function} fns - stream modifiers
 * @returns {Object} erre instance
 */ function erre(...fns) {
    const [success, error, end, modifiers] = [
        new Set(),
        new Set(),
        new Set(),
        new Set(fns)
    ], generator = createStream(modifiers), stream = Object.create(generator), addToCollection = (collection)=>(fn)=>collection.add(fn) && stream, deleteFromCollection = (collection)=>(fn)=>collection.delete(fn) ? stream : panic$1('Couldn\'t remove handler passed by reference');
    return Object.assign(stream, {
        on: Object.freeze({
            value: addToCollection(success),
            error: addToCollection(error),
            end: addToCollection(end)
        }),
        off: Object.freeze({
            value: deleteFromCollection(success),
            error: deleteFromCollection(error),
            end: deleteFromCollection(end)
        }),
        connect: addToCollection(modifiers),
        push (input) {
            const { value, done } = stream.next(input);
            // dispatch the stream events
            if (!done) value.then((res)=>dispatch(success, res), (err)=>dispatch(error, err));
            return stream;
        },
        end () {
            // kill the stream
            generator.return();
            // dispatch the end event
            dispatch(end);
            [
                success,
                error,
                end,
                modifiers
            ].forEach((el)=>el.clear());
            return stream;
        },
        fork () {
            return erre(...modifiers);
        },
        next (input) {
            // get the input and run eventually the promise
            const result = generator.next(input);
            // pause to the next iteration
            generator.next();
            return result;
        }
    });
}
const isString = (str)=>typeof str === 'string';
const parseURL = (...args)=>new URL(...args);
/**
 * Replace the base path from a path
 * @param   {string} path - router path string
 * @returns {string} path cleaned up without the base
 */ const replaceBase = (path)=>path.replace(defaults.base, '');
/**
 * Try to match the current path or skip it
 * @param   {RegExp} pathRegExp - target path transformed by pathToRegexp
 * @returns {string|Symbol} if the path match we return it otherwise we cancel the stream
 */ const matchOrSkip = (pathRegExp)=>(path)=>match(path, pathRegExp) ? path : erre.cancel();
/**
 * Combine 2 streams connecting the events of dispatcherStream to the receiverStream
 * @param   {Stream} dispatcherStream - main stream dispatching events
 * @param   {Stream} receiverStream - sub stream receiving events from the dispatcher
 * @returns {Stream} receiverStream
 */ const joinStreams = (dispatcherStream, receiverStream)=>{
    dispatcherStream.on.value(receiverStream.push);
    receiverStream.on.end(()=>{
        dispatcherStream.off.value(receiverStream.push);
    });
    return receiverStream;
};
/**
 * Error handling function
 * @param   {Error} error - error to catch
 * @returns {void}
 */ /* c8 ignore start */ const panic$2 = (error)=>{
    if (defaults.silentErrors) return;
    throw new Error(error);
};
/* c8 ignore stop */ // make sure that the router will always receive strings params
const filterStrings = (str)=>isString(str) ? str : erre.cancel();
// create the streaming router
const router = erre(filterStrings).on.error(panic$2); // cast the values of this stream always to string
/**
 * Merge the user options with the defaults
 * @param   {Object} options - custom user options
 * @returns {Object} options object merged with defaults
 */ const mergeOptions = (options)=>({
        ...defaults,
        ...options
    });
/* @type {object} general configuration object */ const defaults = {
    base: 'https://localhost',
    silentErrors: false,
    // pathToRegexp options
    sensitive: false,
    strict: false,
    end: true,
    start: true,
    delimiter: '/#?',
    encode: undefined,
    endsWith: undefined,
    prefixes: './'
};
/**
 * Configure the router options overriding the defaults
 * @param {Object} options - custom user options to override
 * @returns {Object} new defaults
 */ const configure = (options)=>{
    Object.entries(options).forEach(([key, value])=>{
        if (Object.hasOwn(defaults, key)) defaults[key] = value;
    });
    return defaults;
};
/* {@link https://github.com/pillarjs/path-to-regexp#usage} */ const toRegexp = (path, keys, options)=>pathToRegexp(path, keys, mergeOptions(options));
/**
 * Convert a router entry to a real path computing the url parameters
 * @param   {string} path - router path string
 * @param   {Object} params - named matched parameters
 * @param   {Object} options - pathToRegexp options object
 * @returns {string} computed url string
 */ const toPath = (path, params, options)=>compile(path, mergeOptions(options))(params);
/**
 * Parse a string path generating an object containing
 * @param   {string} path - target path
 * @param   {RegExp} pathRegExp - path transformed to regexp via pathToRegexp
 * @param   {Object} options - object containing the base path
 * @returns {URL} url object enhanced with the `match` attribute
 */ const toURL = (path, pathRegExp, options = {})=>{
    const { base } = mergeOptions(options);
    const [, ...params] = pathRegExp.exec(path);
    const url = parseURL(path, base);
    // extend the url object adding the matched params
    url.params = params.reduce((acc, param, index)=>{
        const key = options.keys && options.keys[index];
        if (key) acc[key.name] = param ? decodeURIComponent(param) : param;
        return acc;
    }, {});
    return url;
};
/**
 * Return true if a path will be matched
 * @param   {string} path - target path
 * @param   {RegExp} pathRegExp - path transformed to regexp via pathToRegexp
 * @returns {boolean} true if the path matches the regexp
 */ const match = (path, pathRegExp)=>pathRegExp.test(path);
/**
 * Factory function to create an sequence of functions to pass to erre.js
 * This function will be used in the erre stream
 * @param   {RegExp} pathRegExp - path transformed to regexp via pathToRegexp
 * @param   {Object} options - pathToRegexp options object
 * @returns {Array} a functions array that will be used as stream pipe for erre.js
 */ const createURLStreamPipe = (pathRegExp, options)=>[
        decodeURI,
        replaceBase,
        matchOrSkip(pathRegExp),
        (path)=>toURL(path, pathRegExp, options)
    ];
/**
 * Create a fork of the main router stream
 * @param   {string} path - route to match
 * @param   {Object} options - pathToRegexp options object
 * @returns {Stream} new route stream
 */ function createRoute(path, options) {
    const keys = [];
    const pathRegExp = pathToRegexp(path, keys, options);
    const URLStream = erre(...createURLStreamPipe(pathRegExp, {
        ...options,
        keys: keys
    }));
    return joinStreams(router, URLStream).on.error(panic$2);
}
const WINDOW_EVENTS = 'popstate';
const CLICK_EVENT = 'click';
const DOWNLOAD_LINK_ATTRIBUTE = 'download';
const HREF_LINK_ATTRIBUTE = 'href';
const TARGET_SELF_LINK_ATTRIBUTE = '_self';
const LINK_TAG_NAME = 'A';
const HASH = '#';
const SLASH = '/';
const PATH_ATTRIBUTE = 'path';
const RE_ORIGIN = /^.+?\/\/+[^/]+/;
/**
 * Converts any DOM node/s to a loopable array
 * @param   { HTMLElement|NodeList } els - single html element or a node list
 * @returns { Array } always a loopable object
 */ function domToArray(els) {
    // can this object be already looped?
    if (!Array.isArray(els)) {
        // is it a node list?
        if (/^\[object (HTMLCollection|NodeList|Object)\]$/.test(Object.prototype.toString.call(els)) && typeof els.length === 'number') return Array.from(els);
        else // if it's a single node
        // it will be returned as "array" with one single entry
        return [
            els
        ];
    }
    // this object could be looped out of the box
    return els;
}
/**
 * Simple helper to find DOM nodes returning them as array like loopable object
 * @param   { string|DOMNodeList } selector - either the query or the DOM nodes to arraify
 * @param   { HTMLElement }        scope      - context defining where the query will search for the DOM nodes
 * @returns { Array } DOM nodes found as array
 */ function $(selector, scope) {
    return domToArray(typeof selector === 'string' ? document.querySelectorAll(selector) : selector);
}
const getCurrentRoute = ((currentRoute)=>{
    // listen the route changes events to store the current route
    router.on.value((r)=>currentRoute = r);
    return ()=>{
        return currentRoute;
    };
})(null);
/**
 * Normalize the return values, in case of a single value we avoid to return an array
 * @param   { Array } values - list of values we want to return
 * @returns { Array|string|boolean } either the whole list of values or the single one found
 * @private
 */ const normalize = (values)=>values.length === 1 ? values[0] : values;
/**
 * Parse all the nodes received to get/remove/check their attributes
 * @param   { HTMLElement|NodeList|Array } els    - DOM node/s to parse
 * @param   { string|Array }               name   - name or list of attributes
 * @param   { string }                     method - method that will be used to parse the attributes
 * @returns { Array|string } result of the parsing in a list or a single value
 * @private
 */ function parseNodes(els, name, method) {
    const names = typeof name === 'string' ? [
        name
    ] : name;
    return normalize(domToArray(els).map((el)=>{
        return normalize(names.map((n)=>el[method](n)));
    }));
}
/**
 * Get any attribute from a single or a list of DOM nodes
 * @param   { HTMLElement|NodeList|Array } els   - DOM node/s to parse
 * @param   { string|Array }               name  - name or list of attributes to get
 * @returns { Array|string } list of the attributes found
 *
 * @example
 *
 * import { get } from 'bianco.attr'
 *
 * const img = document.createElement('img')
 *
 * get(img, 'width') // => '200'
 *
 * // or also
 * get(img, ['width', 'height']) // => ['200', '300']
 *
 * // or also
 * get([img1, img2], ['width', 'height']) // => [['200', '300'], ['500', '200']]
 */ function get(els, name) {
    return parseNodes(els, name, 'getAttribute');
}
/**
 * Set any attribute on a single or a list of DOM nodes
 * @param   { HTMLElement|NodeList|Array } els   - DOM node/s to parse
 * @param   { string|Array }               name  - name or list of attributes to detect
 * @returns { boolean|Array } true or false or an array of boolean values
 * @example
 *
 * import { has } from 'bianco.attr'
 *
 * has(img, 'width') // false
 *
 * // or also
 * has(img, ['width', 'height']) // => [false, false]
 *
 * // or also
 * has([img1, img2], ['width', 'height']) // => [[false, false], [false, false]]
 */ function has(els, name) {
    return parseNodes(els, name, 'hasAttribute');
}
/**
 * Convert a string from camel case to dash-case
 * @param   {string} string - probably a component tag name
 * @returns {string} component name normalized
 */ /**
 * Convert a string containing dashes to camel case
 * @param   {string} string - input string
 * @returns {string} my-string -> myString
 */ function dashToCamelCase(string) {
    return string.replace(/-(\w)/g, (_, c)=>c.toUpperCase());
}
/**
 * Quick type checking
 * @param   {*} element - anything
 * @param   {string} type - type definition
 * @returns {boolean} true if the type corresponds
 */ /**
 * Check if a value is null or undefined
 * @param   {*}  value - anything
 * @returns {boolean} true only for the 'undefined' and 'null' types
 */ function isNil(value) {
    return value === null || value === undefined;
}
const getGlobal = ()=>getWindow() || $parcel$global;
const getWindow = ()=>typeof window === 'undefined' ? null : window;
const getDocument = ()=>typeof document === 'undefined' ? null : document;
const getHistory = ()=>typeof history === 'undefined' ? null : history;
const getLocation = ()=>{
    const win = getWindow();
    return win ? win.location : {};
};
const defer = (()=>{
    const globalScope = getGlobal();
    return globalScope.requestAnimationFrame || globalScope.setTimeout;
})();
const cancelDefer = (()=>{
    const globalScope = getGlobal();
    return globalScope.cancelAnimationFrame || globalScope.clearTimeout;
})();
const getAttribute = (attributes, name, context)=>{
    if (!attributes) return null;
    const normalizedAttributes = attributes.flatMap((attr)=>isNil(attr.name) ? Object.entries(attr.evaluate(context)).map(([key, value])=>({
                // evaluate each value of the spread attribute and store it into the array
                name: key,
                // create a nested evaluate function pointing to the original value of the spread object
                evaluate: ()=>value
            })) : attr);
    return normalizedAttributes.find((a)=>dashToCamelCase(a.name) === name);
};
const createDefaultSlot = (attributes = [])=>{
    const { template, bindingTypes, expressionTypes } = (0, $4zYSa.__).DOMBindings;
    return template(null, [
        {
            type: bindingTypes.SLOT,
            name: 'default',
            attributes: attributes.map((attr)=>({
                    ...attr,
                    type: expressionTypes.ATTRIBUTE
                }))
        }
    ]);
};
// True if the selector string is valid
const isValidQuerySelectorString = (selector)=>/^([a-zA-Z0-9-_*#.:[\]\s>+~()='"]|\\.)+$/.test(selector);
/**
 * Similar to compose but performs from left-to-right function composition.<br/>
 * {@link https://30secondsofcode.org/function#composeright see also}
 * @param   {...[function]} fns) - list of unary function
 * @returns {*} result of the computation
 */ /**
 * Performs right-to-left function composition.<br/>
 * Use Array.prototype.reduce() to perform right-to-left function composition.<br/>
 * The last (rightmost) function can accept one or more arguments; the remaining functions must be unary.<br/>
 * {@link https://30secondsofcode.org/function#compose original source code}
 * @param   {...[function]} fns) - list of unary function
 * @returns {*} result of the computation
 */ function compose(...fns) {
    return fns.reduce((f, g)=>(...args)=>f(g(...args)));
}
const getInitialRouteValue = (pathToRegexp, path, options)=>{
    const route = compose(...createURLStreamPipe(pathToRegexp, options).reverse())(path);
    return route.params ? route : null;
};
const clearDOMBetweenNodes = (first, last, includeBoundaries)=>{
    const clear = (node)=>{
        if (!node || node === last && !includeBoundaries) return;
        const { nextSibling } = node;
        node.remove();
        clear(nextSibling);
    };
    clear(includeBoundaries ? first : first.nextSibling);
};
const routeHoc$1 = ({ slots, attributes })=>{
    const placeholders = {
        before: document.createTextNode(''),
        after: document.createTextNode('')
    };
    return {
        mount (el, context) {
            // create the component state
            const currentRoute = getCurrentRoute();
            const path = getAttribute(attributes, PATH_ATTRIBUTE, context)?.evaluate(context) || get(el, PATH_ATTRIBUTE);
            const pathToRegexp = toRegexp(path, []);
            const state = {
                pathToRegexp: pathToRegexp,
                route: currentRoute && match(currentRoute, pathToRegexp) ? getInitialRouteValue(pathToRegexp, currentRoute, {}) : null
            };
            this.el = el;
            this.slot = createDefaultSlot([
                {
                    isBoolean: false,
                    name: 'route',
                    evaluate: ()=>this.state.route
                }
            ]);
            this.context = context;
            this.state = state;
            // set the route listeners
            this.boundOnBeforeRoute = this.onBeforeRoute.bind(this);
            this.boundOnRoute = this.onRoute.bind(this);
            router.on.value(this.boundOnBeforeRoute);
            this.stream = createRoute(path).on.value(this.boundOnRoute);
            // update the DOM
            el.replaceWith(placeholders.before);
            placeholders.before.parentNode.insertBefore(placeholders.after, placeholders.before.nextSibling);
            if (state.route) this.mountSlot();
        },
        update (context) {
            this.context = context;
            if (this.state.route) this.slot.update({}, context);
        },
        mountSlot () {
            const { route } = this.state;
            // insert the route root element after the before placeholder
            placeholders.before.parentNode.insertBefore(this.el, placeholders.before.nextSibling);
            this.callLifecycleProperty('onBeforeMount', route);
            this.slot.mount(this.el, {
                slots: slots
            }, this.context);
            this.callLifecycleProperty('onMounted', route);
        },
        clearDOM (includeBoundaries) {
            // remove all the DOM nodes between the placeholders
            clearDOMBetweenNodes(placeholders.before, placeholders.after, includeBoundaries);
        },
        unmount () {
            router.off.value(this.boundOnBeforeRoute);
            this.slot.unmount({}, this.context, true);
            this.clearDOM(true);
            this.stream.end();
        },
        onBeforeRoute (path) {
            const { route } = this.state;
            // this component was not mounted or the current path matches
            // we don't need to unmount this component
            if (!route || match(path, this.state.pathToRegexp)) return;
            this.callLifecycleProperty('onBeforeUnmount', route);
            this.slot.unmount({}, this.context, true);
            this.clearDOM(false);
            this.state.route = null;
            this.callLifecycleProperty('onUnmounted', route);
        },
        onRoute (route) {
            const prevRoute = this.state.route;
            this.state.route = route;
            // if this route component was already mounted we need to update it
            if (prevRoute) {
                this.callLifecycleProperty('onBeforeUpdate', route);
                this.slot.update({}, this.context);
                this.callLifecycleProperty('onUpdated', route);
            } else this.mountSlot();
            // emulate the default browser anchor links behaviour
            if (route.hash && isValidQuerySelectorString(route.hash)) $(route.hash)?.[0].scrollIntoView();
        },
        callLifecycleProperty (method, ...params) {
            const attr = getAttribute(attributes, method, this.context);
            if (attr) attr.evaluate(this.context)(...params);
        }
    };
};
var routeHoc = {
    css: null,
    exports: (0, $jR26U.pure)(routeHoc$1),
    template: null,
    name: 'route-hoc'
};
const normalizeInitialSlash = (str)=>str[0] === SLASH ? str : `${SLASH}${str}`;
const removeTrailingSlash = (str)=>str[str.length - 1] === SLASH ? str.substr(0, str.length - 1) : str;
const normalizeBase = (base)=>{
    const win = getWindow();
    const loc = win.location;
    const root = loc ? `${loc.protocol}//${loc.host}` : '';
    const { pathname } = loc ? loc : {};
    switch(true){
        // pure root url + pathname
        case Boolean(base) === false:
            return removeTrailingSlash(`${root}${pathname || ''}`);
        // full path base
        case /(www|http(s)?:)/.test(base):
            return base;
        // hash navigation
        case base[0] === HASH:
            return `${root}${pathname && pathname !== SLASH ? pathname : ''}${base}`;
        // root url with trailing slash
        case base === SLASH:
            return removeTrailingSlash(root);
        // custom pathname
        default:
            return removeTrailingSlash(`${root}${normalizeInitialSlash(base)}`);
    }
};
function setBase(base) {
    configure({
        base: normalizeBase(base)
    });
}
/**
 * Throw an error with a descriptive message
 * @param   { string } message - error message
 * @param   { string } cause - optional error cause object
 * @returns { undefined } hoppla... at this point the program should stop working
 */ function panic(message, cause) {
    throw new Error(message, {
        cause: cause
    });
}
/**
 * Split a string into several items separed by spaces
 * @param   { string } l - events list
 * @returns { Array } all the events detected
 * @private
 */ const split = (l)=>l.split(/\s/);
/**
 * Set a listener for all the events received separated by spaces
 * @param   { HTMLElement|NodeList|Array } els     - DOM node/s where the listeners will be bound
 * @param   { string }                     evList  - list of events we want to bind or unbind space separated
 * @param   { Function }                   cb      - listeners callback
 * @param   { string }                     method  - either 'addEventListener' or 'removeEventListener'
 * @param   { Object }                     options - event options (capture, once and passive)
 * @returns { undefined }
 * @private
 */ function manageEvents(els, evList, cb, method, options) {
    els = domToArray(els);
    split(evList).forEach((e)=>{
        els.forEach((el)=>el[method](e, cb, options || false));
    });
}
/**
 * Set a listener for all the events received separated by spaces
 * @param   { HTMLElement|Array } els    - DOM node/s where the listeners will be bound
 * @param   { string }            evList - list of events we want to bind space separated
 * @param   { Function }          cb     - listeners callback
 * @param   { Object }            options - event options (capture, once and passive)
 * @returns { HTMLElement|NodeList|Array } DOM node/s and first argument of the function
 */ function add(els, evList, cb, options) {
    manageEvents(els, evList, cb, 'addEventListener', options);
    return els;
}
/**
 * Remove all the listeners for the events received separated by spaces
 * @param   { HTMLElement|Array } els     - DOM node/s where the events will be unbind
 * @param   { string }            evList  - list of events we want unbind space separated
 * @param   { Function }          cb      - listeners callback
 * @param   { Object }             options - event options (capture, once and passive)
 * @returns { HTMLElement|NodeList|Array }  DOM node/s and first argument of the function
 */ function remove(els, evList, cb, options) {
    manageEvents(els, evList, cb, 'removeEventListener', options);
    return els;
}
const onWindowEvent = ()=>router.push(normalizePath(String(getLocation().href)));
const onRouterPush = (path)=>{
    const url = path.includes(defaults.base) ? path : defaults.base + path;
    const loc = getLocation();
    const hist = getHistory();
    const doc = getDocument();
    // update the browser history only if it's necessary
    if (hist && url !== loc.href) hist.pushState(null, doc.title, url);
};
const getLinkElement = (node)=>node && !isLinkNode(node) ? getLinkElement(node.parentNode) : node;
const isLinkNode = (node)=>node.nodeName === LINK_TAG_NAME;
const isCrossOriginLink = (path)=>path.indexOf(getLocation().href.match(RE_ORIGIN)[0]) === -1;
const isTargetSelfLink = (el)=>el.target && el.target !== TARGET_SELF_LINK_ATTRIBUTE;
const isEventForbidden = (event)=>event.which && event.which !== 1 || // not left click
    event.metaKey || event.ctrlKey || event.shiftKey || // or meta keys
    event.defaultPrevented; // or default prevented
const isForbiddenLink = (el)=>!el || !isLinkNode(el) || // not A tag
    has(el, DOWNLOAD_LINK_ATTRIBUTE) || // has download attr
    !has(el, HREF_LINK_ATTRIBUTE) || // has no href attr
    isTargetSelfLink(el) || isCrossOriginLink(el.href);
const normalizePath = (path)=>path.replace(defaults.base, '');
const isInBase = (path)=>!defaults.base || path.includes(defaults.base);
/**
 * Callback called anytime something will be clicked on the page
 * @param   {HTMLEvent} event - click event
 * @returns {undefined} void method
 */ const onClick = (event)=>{
    if (isEventForbidden(event)) return;
    const el = getLinkElement(event.target);
    if (isForbiddenLink(el) || !isInBase(el.href)) return;
    event.preventDefault();
    router.push(normalizePath(el.href));
};
/**
 * Link the rawth router to the DOM events
 * @param { HTMLElement } container - DOM node where the links are located
 * @returns {Function} teardown function
 */ function initDomListeners(container) {
    const win = getWindow();
    const root = container || getDocument();
    if (win) {
        add(win, WINDOW_EVENTS, onWindowEvent);
        add(root, CLICK_EVENT, onClick);
    }
    router.on.value(onRouterPush);
    return ()=>{
        if (win) {
            remove(win, WINDOW_EVENTS, onWindowEvent);
            remove(root, CLICK_EVENT, onClick);
        }
        router.off.value(onRouterPush);
    };
}
const BASE_ATTRIBUTE_NAME = 'base';
const INITIAL_ROUTE = 'initialRoute';
const ON_STARTED_ATTRIBUTE_NAME = 'onStarted';
const routerHoc$1 = ({ slots, attributes, props })=>{
    if (routerHoc$1.wasInitialized) panic('Multiple <router> components are not supported');
    return {
        slot: null,
        el: null,
        teardown: null,
        mount (el, context) {
            const initialRouteAttr = getAttribute(attributes, INITIAL_ROUTE, context);
            const initialRoute = initialRouteAttr ? initialRouteAttr.evaluate(context) : null;
            const currentRoute = getCurrentRoute();
            const onFirstRoute = ()=>{
                this.createSlot(context);
                router.off.value(onFirstRoute);
            };
            routerHoc$1.wasInitialized = true;
            this.el = el;
            this.teardown = initDomListeners(this.root);
            this.setBase(context);
            // mount the slots only if the current route was defined
            if (currentRoute && !initialRoute) this.createSlot(context);
            else {
                router.on.value(onFirstRoute);
                router.push(initialRoute || window.location.href);
            }
        },
        createSlot (context) {
            if (!slots || !slots.length) return;
            const onStartedAttr = getAttribute(attributes, ON_STARTED_ATTRIBUTE_NAME, context);
            this.slot = createDefaultSlot();
            this.slot.mount(this.el, {
                slots: slots
            }, context);
            if (onStartedAttr) onStartedAttr.evaluate(context)(getCurrentRoute());
        },
        update (context) {
            this.setBase(context);
            // defer the updates to avoid internal recursive update calls
            // see https://github.com/riot/route/issues/148
            if (this.slot) {
                cancelDefer(this.deferred);
                this.deferred = defer(()=>{
                    this.slot.update({}, context);
                });
            }
        },
        unmount (...args) {
            this.teardown();
            routerHoc$1.wasInitialized = false;
            if (this.slot) this.slot.unmount(...args);
        },
        getBase (context) {
            const baseAttr = getAttribute(attributes, BASE_ATTRIBUTE_NAME, context);
            return baseAttr ? baseAttr.evaluate(context) : this.el.getAttribute(BASE_ATTRIBUTE_NAME) || '/';
        },
        setBase (context) {
            setBase(props ? props.base : this.getBase(context));
        }
    };
};
// flag to avoid multiple router instances
routerHoc$1.wasInitialized = false;
var routerHoc = {
    css: null,
    exports: (0, $jR26U.pure)(routerHoc$1),
    template: null,
    name: 'router-hoc'
};

});
parcelRegister("4zYSa", function(module, exports) {

$parcel$export(module.exports, "__", () => $3559a65d0946bc0d$export$c6452175cea4361a);
/* Riot v9.4.7, @license MIT */ 
var $f4jRS = parcelRequire("f4jRS");

var $8VupT = parcelRequire("8VupT");

var $dNFiL = parcelRequire("dNFiL");

var $3zqta = parcelRequire("3zqta");

var $97yfF = parcelRequire("97yfF");
// expose some internal stuff that might be used from external tools
const $3559a65d0946bc0d$export$c6452175cea4361a = {
    cssManager: $97yfF.default,
    DOMBindings: {
        template: (0, $3zqta.template),
        createBinding: (0, $3zqta.createBinding),
        createExpression: (0, $3zqta.createExpression),
        bindingTypes: $f4jRS.default,
        expressionTypes: $dNFiL.default
    },
    globals: {
        PROPS_KEY: $8VupT.PROPS_KEY,
        STATE_KEY: $8VupT.STATE_KEY,
        IS_COMPONENT_UPDATING: $8VupT.IS_COMPONENT_UPDATING,
        ATTRIBUTES_KEY_SYMBOL: $8VupT.ATTRIBUTES_KEY_SYMBOL,
        COMPONENTS_IMPLEMENTATION_MAP: $8VupT.COMPONENTS_IMPLEMENTATION_MAP,
        PLUGINS_SET: $8VupT.PLUGINS_SET,
        DOM_COMPONENT_INSTANCE_PROPERTY: $8VupT.DOM_COMPONENT_INSTANCE_PROPERTY,
        PARENT_KEY_SYMBOL: $8VupT.PARENT_KEY_SYMBOL
    }
};

});
parcelRegister("97yfF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a3f562abea2c771$export$2e2bcd8739ae039);
/* Riot v9.4.7, @license MIT */ 
var $1NyWp = parcelRequire("1NyWp");

var $jpTAJ = parcelRequire("jpTAJ");
const $6a3f562abea2c771$export$4b82df7571cd9ace = new Map();
const $6a3f562abea2c771$export$766ac0573f5f6e15 = 'style[riot]';
// memoized curried function
const $6a3f562abea2c771$var$getStyleNode = ((style)=>{
    return ()=>{
        // lazy evaluation:
        // if this function was already called before
        // we return its cached result
        if (style) return style;
        // create a new style element or use an existing one
        // and cache it internally
        style = (0, $1NyWp.default)($6a3f562abea2c771$export$766ac0573f5f6e15)[0] || document.createElement('style');
        (0, $jpTAJ.set)(style, 'type', 'text/css');
        /* istanbul ignore next */ if (!style.parentNode) document.head.appendChild(style);
        return style;
    };
})();
/**
 * Object that will be used to inject and manage the css of every tag instance
 */ const $6a3f562abea2c771$export$2e2bcd8739ae039 = {
    CSS_BY_NAME: $6a3f562abea2c771$export$4b82df7571cd9ace,
    /**
   * Save a tag style to be later injected into DOM
   * @param { string } name - if it's passed we will map the css to a tagname
   * @param { string } css - css string
   * @returns {Object} self
   */ add (name, css) {
        if (!$6a3f562abea2c771$export$4b82df7571cd9ace.has(name)) {
            $6a3f562abea2c771$export$4b82df7571cd9ace.set(name, css);
            this.inject();
        }
        return this;
    },
    /**
   * Inject all previously saved tag styles into DOM
   * innerHTML seems slow: http://jsperf.com/riot-insert-style
   * @returns {Object} self
   */ inject () {
        $6a3f562abea2c771$var$getStyleNode().innerHTML = [
            ...$6a3f562abea2c771$export$4b82df7571cd9ace.values()
        ].join('\n');
        return this;
    },
    /**
   * Remove a tag style from the DOM
   * @param {string} name a registered tagname
   * @returns {Object} self
   */ remove (name) {
        if ($6a3f562abea2c771$export$4b82df7571cd9ace.has(name)) {
            $6a3f562abea2c771$export$4b82df7571cd9ace.delete(name);
            this.inject();
        }
        return this;
    }
};

});
parcelRegister("1NyWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $14f57898213ca2fd$export$2e2bcd8739ae039);
/* Riot WIP, @license MIT */ 
var $ch0LT = parcelRequire("ch0LT");
/**
 * Simple helper to find DOM nodes returning them as array like loopable object
 * @param   { string|DOMNodeList } selector - either the query or the DOM nodes to arraify
 * @param   { HTMLElement }        scope      - context defining where the query will search for the DOM nodes
 * @returns { Array } DOM nodes found as array
 */ function $14f57898213ca2fd$export$2e2bcd8739ae039(selector, scope) {
    return (0, $ch0LT.default)(typeof selector === 'string' ? (scope || document).querySelectorAll(selector) : selector);
}

});
parcelRegister("ch0LT", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ef7abc08ab92ece$export$2e2bcd8739ae039);
/* Riot WIP, @license MIT */ /**
 * Converts any DOM node/s to a loopable array
 * @param   { HTMLElement|NodeList } els - single html element or a node list
 * @returns { Array } always a loopable object
 */ function $8ef7abc08ab92ece$export$2e2bcd8739ae039(els) {
    // can this object be already looped?
    if (!Array.isArray(els)) {
        // is it a node list?
        if (/^\[object (HTMLCollection|NodeList|Object)\]$/.test(Object.prototype.toString.call(els)) && typeof els.length === 'number') return Array.from(els);
        else // if it's a single node
        // it will be returned as "array" with one single entry
        return [
            els
        ];
    }
    // this object could be looped out of the box
    return els;
}

});


parcelRegister("jpTAJ", function(module, exports) {

$parcel$export(module.exports, "set", () => $e22b79667f52c90c$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "get", () => $e22b79667f52c90c$export$3988ae62b71be9a3);
/* Riot WIP, @license MIT */ 
var $ch0LT = parcelRequire("ch0LT");
/**
 * Normalize the return values, in case of a single value we avoid to return an array
 * @param   { Array } values - list of values we want to return
 * @returns { Array|string|boolean } either the whole list of values or the single one found
 * @private
 */ const $e22b79667f52c90c$var$normalize = (values)=>values.length === 1 ? values[0] : values;
/**
 * Parse all the nodes received to get/remove/check their attributes
 * @param   { HTMLElement|NodeList|Array } els    - DOM node/s to parse
 * @param   { string|Array }               name   - name or list of attributes
 * @param   { string }                     method - method that will be used to parse the attributes
 * @returns { Array|string } result of the parsing in a list or a single value
 * @private
 */ function $e22b79667f52c90c$var$parseNodes(els, name, method) {
    const names = typeof name === 'string' ? [
        name
    ] : name;
    return $e22b79667f52c90c$var$normalize((0, $ch0LT.default)(els).map((el)=>{
        return $e22b79667f52c90c$var$normalize(names.map((n)=>el[method](n)));
    }));
}
/**
 * Set any attribute on a single or a list of DOM nodes
 * @param   { HTMLElement|NodeList|Array } els   - DOM node/s to parse
 * @param   { string|Object }              name  - either the name of the attribute to set
 *                                                 or a list of properties as object key - value
 * @param   { string }                     value - the new value of the attribute (optional)
 * @returns { HTMLElement|NodeList|Array } the original array of elements passed to this function
 *
 * @example
 *
 * import { set } from 'bianco.attr'
 *
 * const img = document.createElement('img')
 *
 * set(img, 'width', 100)
 *
 * // or also
 * set(img, {
 *   width: 300,
 *   height: 300
 * })
 *
 */ function $e22b79667f52c90c$export$adaa4cf7ef1b65be(els, name, value) {
    const attrs = typeof name === 'object' ? name : {
        [name]: value
    };
    const props = Object.keys(attrs);
    (0, $ch0LT.default)(els).forEach((el)=>{
        props.forEach((prop)=>el.setAttribute(prop, attrs[prop]));
    });
    return els;
}
/**
 * Get any attribute from a single or a list of DOM nodes
 * @param   { HTMLElement|NodeList|Array } els   - DOM node/s to parse
 * @param   { string|Array }               name  - name or list of attributes to get
 * @returns { Array|string } list of the attributes found
 *
 * @example
 *
 * import { get } from 'bianco.attr'
 *
 * const img = document.createElement('img')
 *
 * get(img, 'width') // => '200'
 *
 * // or also
 * get(img, ['width', 'height']) // => ['200', '300']
 *
 * // or also
 * get([img1, img2], ['width', 'height']) // => [['200', '300'], ['500', '200']]
 */ function $e22b79667f52c90c$export$3988ae62b71be9a3(els, name) {
    return $e22b79667f52c90c$var$parseNodes(els, name, 'getAttribute');
}

});



parcelRegister("jR26U", function(module, exports) {

$parcel$export(module.exports, "pure", () => $e7449aa0fe4278d9$export$48ec4a2b1cfc6557);
/* Riot v9.4.7, @license MIT */ 
var $8kAdV = parcelRequire("8kAdV");

var $8VupT = parcelRequire("8VupT");

var $koC5P = parcelRequire("koC5P");
/**
 * Lift a riot component Interface into a pure riot object
 * @param   {Function} func - RiotPureComponent factory function
 * @returns {Function} the lifted original function received as argument
 */ function $e7449aa0fe4278d9$export$48ec4a2b1cfc6557(func) {
    if (!(0, $8kAdV.isFunction)(func)) (0, $koC5P.panic)('riot.pure accepts only arguments of type "function"');
    func[0, $8VupT.IS_PURE_SYMBOL] = true;
    return func;
}

});


/* Riot v9.4.7, @license MIT */ /* Riot WIP, @license MIT */ /**
 * Similar to compose but performs from left-to-right function composition.<br/>
 * {@link https://30secondsofcode.org/function#composeright see also}
 * @param   {...[function]} fns) - list of unary function
 * @returns {*} result of the computation
 */ /**
 * Performs right-to-left function composition.<br/>
 * Use Array.prototype.reduce() to perform right-to-left function composition.<br/>
 * The last (rightmost) function can accept one or more arguments; the remaining functions must be unary.<br/>
 * {@link https://30secondsofcode.org/function#compose original source code}
 * @param   {...[function]} fns) - list of unary function
 * @returns {*} result of the computation
 */ function $7ba2b4a53f68798a$export$2e2bcd8739ae039(...fns) {
    return fns.reduce((f, g)=>(...args)=>f(g(...args)));
}


/* Riot v9.4.7, @license MIT */ 
var $8VupT = parcelRequire("8VupT");

var $ldAW2 = parcelRequire("ldAW2");
/* Riot WIP, @license MIT */ 
var $8kAdV = parcelRequire("8kAdV");
// does simply nothing
function $b9e74c7f16476471$export$8793edee2d425525() {
    return this;
}
/**
 * Autobind the methods of a source object to itself
 * @param   {Object} source - probably a riot tag instance
 * @param   {Array<string>} methods - list of the methods to autobind
 * @returns {Object} the original object received
 */ function $b9e74c7f16476471$export$62974dc8053cca49(source, methods) {
    methods.forEach((method)=>{
        source[method] = source[method].bind(source);
    });
    return source;
}
/**
 * Call the first argument received only if it's a function otherwise return it as it is
 * @param   {*} source - anything
 * @returns {*} anything
 */ function $b9e74c7f16476471$export$d5f47afc7eea6932(source) {
    return (0, $8kAdV.isFunction)(source) ? source.prototype && source.prototype.constructor ? new source() : source() : source;
}



var $koC5P = parcelRequire("koC5P");
/* Riot v9.4.7, @license MIT */ 
var $8VupT = parcelRequire("8VupT");

var $fGGec = parcelRequire("fGGec");

// Components without template use a mocked template interface with some basic functionalities to
// guarantee consistent rendering behaviour see https://github.com/riot/riot/issues/2984
const $772c4fd85a1a44c9$export$1164b28605be0644 = {
    [(0, $8VupT.MOUNT_METHOD_KEY)] (el) {
        this.el = el;
    },
    [(0, $8VupT.UPDATE_METHOD_KEY)]: (0, $b9e74c7f16476471$export$8793edee2d425525),
    [(0, $8VupT.UNMOUNT_METHOD_KEY)] (_, __, mustRemoveRoot = false) {
        if (mustRemoveRoot) (0, $fGGec.removeChild)(this.el);
        else if (!mustRemoveRoot) (0, $fGGec.cleanNode)(this.el);
    },
    clone () {
        return {
            ...this
        };
    },
    createDOM: (0, $b9e74c7f16476471$export$8793edee2d425525)
};


/* Riot v9.4.7, @license MIT */ 
var $3zqta = parcelRequire("3zqta");

var $dNFiL = parcelRequire("dNFiL");

var $f4jRS = parcelRequire("f4jRS");
/**
 * Factory function to create the component templates only once
 * @param   {Function} template - component template creation function
 * @param   {RiotComponentWrapper} componentWrapper - riot compiler generated object
 * @param   {Function} getChildComponent - getter function to return the children components
 * @returns {TemplateChunk} template chunk object
 */ function $9af6c12e4df6b737$export$11f2fea361a206f0(template, componentWrapper, getChildComponent) {
    return template((0, $3zqta.template), (0, $dNFiL.default), (0, $f4jRS.default), getChildComponent);
}


/* Riot v9.4.7, @license MIT */ 
var $8VupT = parcelRequire("8VupT");

var $koC5P = parcelRequire("koC5P");

var $3h6d1 = parcelRequire("3h6d1");
/* Riot v9.4.7, @license MIT */ 
var $8VupT = parcelRequire("8VupT");

const $cdd0d8946835c0fe$export$eeadd4fe5e45d811 = Object.freeze({
    [(0, $8VupT.MOUNT_METHOD_KEY)]: (0, $b9e74c7f16476471$export$8793edee2d425525),
    [(0, $8VupT.UPDATE_METHOD_KEY)]: (0, $b9e74c7f16476471$export$8793edee2d425525),
    [(0, $8VupT.UNMOUNT_METHOD_KEY)]: (0, $b9e74c7f16476471$export$8793edee2d425525)
});


/* Riot v9.4.7, @license MIT */ 
var $8VupT = parcelRequire("8VupT");
/**
 * Bind a DOM node to its component object
 * @param   {HTMLElement} node - html node mounted
 * @param   {Object} component - Riot.js component object
 * @returns {Object} the component object received as second argument
 */ const $35562c186b3ff5be$export$13a682bc648ea731 = (node, component)=>node[0, $8VupT.DOM_COMPONENT_INSTANCE_PROPERTY] = component;


/* Riot v9.4.7, @license MIT */ 
var $8VupT = parcelRequire("8VupT");
/**
 * Wrap the Riot.js core API methods using a mapping function
 * @param   {Function} mapFunction - lifting function
 * @returns {Object} an object having the { mount, update, unmount } functions
 */ function $86bc931490bdf2bd$export$c2b9b02153a7affa(mapFunction) {
    return [
        (0, $8VupT.MOUNT_METHOD_KEY),
        (0, $8VupT.UPDATE_METHOD_KEY),
        (0, $8VupT.UNMOUNT_METHOD_KEY)
    ].reduce((acc, method)=>{
        acc[method] = mapFunction(method);
        return acc;
    }, {});
}


/**
 * Create a pure component
 * @param   {Function} pureFactoryFunction - pure component factory function
 * @param   {Array} options.slots - component slots
 * @param   {Array} options.attributes - component attributes
 * @param   {Array} options.template - template factory function
 * @param   {Array} options.template - template factory function
 * @param   {any} options.props - initial component properties
 * @returns {Object} pure component object
 */ function $92f6c4cf9c901410$export$bcf29ba1633fa75c(pureFactoryFunction, { slots: slots, attributes: attributes, props: props, css: css, template: template }) {
    if (template) (0, $koC5P.panic)('Pure components can not have html');
    if (css) (0, $koC5P.panic)('Pure components do not have css');
    const component = (0, $3h6d1.defineDefaults)(pureFactoryFunction({
        slots: slots,
        attributes: attributes,
        props: props
    }), (0, $cdd0d8946835c0fe$export$eeadd4fe5e45d811));
    return (0, $86bc931490bdf2bd$export$c2b9b02153a7affa)((method)=>(...args)=>{
            // intercept the mount calls to bind the DOM node to the pure object created
            // see also https://github.com/riot/riot/issues/2806
            if (method === (0, $8VupT.MOUNT_METHOD_KEY)) {
                const [element] = args;
                // mark this node as pure element
                (0, $3h6d1.defineProperty)(element, (0, $8VupT.IS_PURE_SYMBOL), true);
                (0, $35562c186b3ff5be$export$13a682bc648ea731)(element, component);
            }
            component[method](...args);
            return component;
        });
}


/* Riot v9.4.7, @license MIT */ 
var $8VupT = parcelRequire("8VupT");

var $3h6d1 = parcelRequire("3h6d1");
/* Riot v9.4.7, @license MIT */ 
var $1NyWp = parcelRequire("1NyWp");
const $f7a7d86bb4745ded$export$32f93d47894fcbb3 = Object.freeze({
    // component helpers
    $ (selector) {
        return (0, $1NyWp.default)(selector, this.root)[0];
    },
    $$ (selector) {
        return (0, $1NyWp.default)(selector, this.root);
    }
});


/* Riot v9.4.7, @license MIT */ 
var $8VupT = parcelRequire("8VupT");

const $5aa24ee10826bdf2$export$1d962e041bb410fd = Object.freeze({
    [(0, $8VupT.SHOULD_UPDATE_KEY)]: (0, $b9e74c7f16476471$export$8793edee2d425525),
    [(0, $8VupT.ON_BEFORE_MOUNT_KEY)]: (0, $b9e74c7f16476471$export$8793edee2d425525),
    [(0, $8VupT.ON_MOUNTED_KEY)]: (0, $b9e74c7f16476471$export$8793edee2d425525),
    [(0, $8VupT.ON_BEFORE_UPDATE_KEY)]: (0, $b9e74c7f16476471$export$8793edee2d425525),
    [(0, $8VupT.ON_UPDATED_KEY)]: (0, $b9e74c7f16476471$export$8793edee2d425525),
    [(0, $8VupT.ON_BEFORE_UNMOUNT_KEY)]: (0, $b9e74c7f16476471$export$8793edee2d425525),
    [(0, $8VupT.ON_UNMOUNTED_KEY)]: (0, $b9e74c7f16476471$export$8793edee2d425525)
});



var $97yfF = parcelRequire("97yfF");
/* Riot WIP, @license MIT */ /**
 * Function to curry any javascript method
 * @param   {Function}  fn - the target function we want to curry
 * @param   {...[args]} acc - initial arguments
 * @returns {Function|*} it will return a function until the target function
 *                       will receive all of its arguments
 */ function $a6078fd441ea7a19$export$2e2bcd8739ae039(fn, ...acc) {
    return (...args)=>{
        args = [
            ...acc,
            ...args
        ];
        return args.length < fn.length ? $a6078fd441ea7a19$export$2e2bcd8739ae039(fn, ...args) : fn(...args);
    };
}


/* Riot v9.4.7, @license MIT */ 
var $8kAdV = parcelRequire("8kAdV");

var $8VupT = parcelRequire("8VupT");

var $fGGec = parcelRequire("fGGec");


var $koC5P = parcelRequire("koC5P");

var $3h6d1 = parcelRequire("3h6d1");
/* Riot v9.4.7, @license MIT */ 
var $8VupT = parcelRequire("8VupT");
/* Riot v9.4.7, @license MIT */ 
var $8VupT = parcelRequire("8VupT");

var $jpTAJ = parcelRequire("jpTAJ");
/**
 * Get the tag name of any DOM node
 * @param   {HTMLElement} element - DOM node we want to inspect
 * @returns {string} name to identify this dom node in riot
 */ function $18868db33d6e0d4a$export$7d9f7e9c1c02b41e(element) {
    return (0, $jpTAJ.get)(element, (0, $8VupT.IS_DIRECTIVE)) || element.tagName.toLowerCase();
}



var $jpTAJ = parcelRequire("jpTAJ");
/**
 * Add eventually the "is" attribute to link this DOM node to its css
 * @param {HTMLElement} element - target root node
 * @param {string} name - name of the component mounted
 * @returns {undefined} it's a void function
 */ function $70d03789717093c3$export$b1e7cc44c66b1d10(element, name) {
    if ((0, $18868db33d6e0d4a$export$7d9f7e9c1c02b41e)(element) !== name) (0, $jpTAJ.set)(element, (0, $8VupT.IS_DIRECTIVE), name);
}



/* Riot v9.4.7, @license MIT */ 
/**
 * Compute the component current state merging it with its previous state
 * @param   {Object} oldState - previous state object
 * @param   {Object} newState - new state given to the `update` call
 * @returns {Object} new object state
 */ function $d02d0c4220ab9a69$export$c38901fc82272303(oldState, newState) {
    return {
        ...oldState,
        ...(0, $b9e74c7f16476471$export$d5f47afc7eea6932)(newState)
    };
}


/* Riot v9.4.7, @license MIT */ 
var $fGGec = parcelRequire("fGGec");

/**
 * Evaluate the component properties either from its real attributes or from its initial user properties
 * @param   {HTMLElement} element - component root
 * @param   {Object}  initialProps - initial props
 * @returns {Object} component props key value pairs
 */ function $74941a00ae0ff2fa$export$7a75a69d6efa39f3(element, initialProps = {}) {
    return {
        ...(0, $fGGec.DOMattributesToObject)(element),
        ...(0, $b9e74c7f16476471$export$d5f47afc7eea6932)(initialProps)
    };
}


/* Riot v9.4.7, @license MIT */ 

var $3zqta = parcelRequire("3zqta");
/**
 * Create the bindings to update the component attributes
 * @param   {HTMLElement} node - node where we will bind the expressions
 * @param   {Array} attributes - list of attribute bindings
 * @returns {TemplateChunk} - template bindings object
 */ function $366376093a62b66a$export$31e380557e4223c9(node, attributes = []) {
    const expressions = attributes.map((a)=>(0, $3zqta.createExpression)(node, a));
    const binding = {};
    return Object.assign(binding, {
        expressions: expressions,
        ...(0, $86bc931490bdf2bd$export$c2b9b02153a7affa)((method)=>(scope)=>{
                expressions.forEach((e)=>e[method](scope));
                return binding;
            })
    });
}


/* Riot v9.4.7, @license MIT */ 
var $8VupT = parcelRequire("8VupT");
/**
 * Run the component instance through all the plugins set by the user
 * @param   {Object} component - component instance
 * @returns {Object} the component enhanced by the plugins
 */ function $44881c3572404721$export$c9f2a3c710939a17(component) {
    return [
        ...(0, $8VupT.PLUGINS_SET)
    ].reduce((c, fn)=>fn(c) || c, component);
}


/* Riot v9.4.7, @license MIT */ 

var $dNFiL = parcelRequire("dNFiL");

var $koC5P = parcelRequire("koC5P");
/**
 * Get the computed attribute names from the template instance
 * Since these attributes will not change we memoize the result of this computation
 * @param {TemplateChunk} template - template instance
 * @return {[]} list of attribute names that will be computed by the template expressions
 */ const $b72293b1b181ed84$export$e6df2a6c12fb95fe = (0, $koC5P.memoize)((template)=>{
    const firstBinding = template?.bindingsData?.[0];
    // if the first binding has the selector attribute it means that it doesn't belong to the root node
    if (firstBinding?.selector) return [];
    return firstBinding?.expressions?.reduce((acc, { name: name, type: type })=>type === (0, $dNFiL.default).ATTRIBUTE ? acc.concat([
            name
        ]) : acc, []) ?? [];
});


/**
 * Component creation factory function that will enhance the user provided API
 * @param   {Object} component - a component implementation previously defined
 * @param   {Array} options.slots - component slots generated via riot compiler
 * @param   {Array} options.attributes - attribute expressions generated via riot compiler
 * @returns {Riot.Component} a riot component instance
 */ function $c0d4a4e63564b38f$export$e8f3d389fde69f80(component, { slots: slots, attributes: attributes, props: props }) {
    return (0, $b9e74c7f16476471$export$62974dc8053cca49)((0, $44881c3572404721$export$c9f2a3c710939a17)((0, $3h6d1.defineProperties)((0, $8kAdV.isObject)(component) ? Object.create(component) : component, {
        mount (element, state = {}, parentScope) {
            // any element mounted passing through this function can't be a pure component
            (0, $3h6d1.defineProperty)(element, (0, $8VupT.IS_PURE_SYMBOL), false);
            this[0, $8VupT.PARENT_KEY_SYMBOL] = parentScope;
            this[0, $8VupT.ATTRIBUTES_KEY_SYMBOL] = (0, $366376093a62b66a$export$31e380557e4223c9)(element, attributes).mount(parentScope);
            (0, $3h6d1.defineProperty)(this, (0, $8VupT.PROPS_KEY), Object.freeze({
                ...(0, $74941a00ae0ff2fa$export$7a75a69d6efa39f3)(element, props),
                ...(0, $koC5P.evaluateAttributeExpressions)(this[0, $8VupT.ATTRIBUTES_KEY_SYMBOL].expressions)
            }));
            this[0, $8VupT.STATE_KEY] = (0, $d02d0c4220ab9a69$export$c38901fc82272303)(this[0, $8VupT.STATE_KEY], state);
            this[0, $8VupT.TEMPLATE_KEY_SYMBOL] = this.template.createDOM(element).clone();
            // link this object to the DOM node
            (0, $35562c186b3ff5be$export$13a682bc648ea731)(element, this);
            // add eventually the 'is' attribute
            component.name && (0, $70d03789717093c3$export$b1e7cc44c66b1d10)(element, component.name);
            // define the root element
            (0, $3h6d1.defineProperty)(this, (0, $8VupT.ROOT_KEY), element);
            // define the slots array
            (0, $3h6d1.defineProperty)(this, (0, $8VupT.SLOTS_KEY), slots);
            // before mount lifecycle event
            this[0, $8VupT.ON_BEFORE_MOUNT_KEY](this[0, $8VupT.PROPS_KEY], this[0, $8VupT.STATE_KEY]);
            // mount the template
            this[0, $8VupT.TEMPLATE_KEY_SYMBOL].mount(element, this, parentScope);
            this[0, $8VupT.ON_MOUNTED_KEY](this[0, $8VupT.PROPS_KEY], this[0, $8VupT.STATE_KEY]);
            return this;
        },
        update (state = {}, parentScope) {
            if (parentScope) {
                this[0, $8VupT.PARENT_KEY_SYMBOL] = parentScope;
                this[0, $8VupT.ATTRIBUTES_KEY_SYMBOL].update(parentScope);
            }
            // get the attribute names that don't belong to the the props object
            // this will avoid recursive props rendering https://github.com/riot/riot/issues/2994
            const computedAttributeNames = (0, $b72293b1b181ed84$export$e6df2a6c12fb95fe)(this[0, $8VupT.TEMPLATE_KEY_SYMBOL]);
            // filter out the computed attributes from the root node
            const staticRootAttributes = Array.from(this[0, $8VupT.ROOT_KEY].attributes).filter(({ name: name })=>!computedAttributeNames.includes(name));
            // evaluate the value of the static dom attributes
            const domNodeAttributes = (0, $fGGec.DOMattributesToObject)({
                attributes: staticRootAttributes
            });
            // Avoid adding the riot "is" directives to the component props
            // eslint-disable-next-line no-unused-vars
            const { [(0, $8VupT.IS_DIRECTIVE)]: _, ...newProps } = {
                ...domNodeAttributes,
                ...(0, $koC5P.evaluateAttributeExpressions)(this[0, $8VupT.ATTRIBUTES_KEY_SYMBOL].expressions)
            };
            if (this[0, $8VupT.SHOULD_UPDATE_KEY](newProps, this[0, $8VupT.PROPS_KEY]) === false) return;
            (0, $3h6d1.defineProperty)(this, (0, $8VupT.PROPS_KEY), Object.freeze({
                // only root components will merge their initial props with the new ones
                // children components will just get them overridden see also https://github.com/riot/riot/issues/2978
                ...parentScope ? (0, $3h6d1.pick)(this[0, $8VupT.PROPS_KEY], computedAttributeNames) : this[0, $8VupT.PROPS_KEY],
                ...newProps
            }));
            this[0, $8VupT.STATE_KEY] = (0, $d02d0c4220ab9a69$export$c38901fc82272303)(this[0, $8VupT.STATE_KEY], state);
            this[0, $8VupT.ON_BEFORE_UPDATE_KEY](this[0, $8VupT.PROPS_KEY], this[0, $8VupT.STATE_KEY]);
            // avoiding recursive updates
            // see also https://github.com/riot/riot/issues/2895
            if (!this[0, $8VupT.IS_COMPONENT_UPDATING]) {
                this[0, $8VupT.IS_COMPONENT_UPDATING] = true;
                this[0, $8VupT.TEMPLATE_KEY_SYMBOL].update(this, this[0, $8VupT.PARENT_KEY_SYMBOL]);
            }
            this[0, $8VupT.ON_UPDATED_KEY](this[0, $8VupT.PROPS_KEY], this[0, $8VupT.STATE_KEY]);
            this[0, $8VupT.IS_COMPONENT_UPDATING] = false;
            return this;
        },
        unmount (preserveRoot) {
            this[0, $8VupT.ON_BEFORE_UNMOUNT_KEY](this[0, $8VupT.PROPS_KEY], this[0, $8VupT.STATE_KEY]);
            this[0, $8VupT.ATTRIBUTES_KEY_SYMBOL].unmount();
            // if the preserveRoot is null the template html will be left untouched
            // in that case the DOM cleanup will happen differently from a parent node
            this[0, $8VupT.TEMPLATE_KEY_SYMBOL].unmount(this, this[0, $8VupT.PARENT_KEY_SYMBOL], preserveRoot === null ? null : !preserveRoot);
            this[0, $8VupT.ON_UNMOUNTED_KEY](this[0, $8VupT.PROPS_KEY], this[0, $8VupT.STATE_KEY]);
            return this;
        }
    })), Object.keys(component).filter((prop)=>(0, $8kAdV.isFunction)(component[prop])));
}


/**
 * Component definition function
 * @param   {Object} implementation - the component implementation will be generated via compiler
 * @param   {Object} component - the component initial properties
 * @returns {Object} a new component implementation object
 */ function $5971bdf1f1024ec7$export$35b384e1d9a985a8({ css: css, template: template, componentAPI: componentAPI, name: name }) {
    // add the component css into the DOM
    if (css && name) (0, $97yfF.default).add(name, css);
    return (0, $a6078fd441ea7a19$export$2e2bcd8739ae039)((0, $c0d4a4e63564b38f$export$e8f3d389fde69f80))((0, $3h6d1.defineProperties)(// set the component defaults without overriding the original component API
    (0, $3h6d1.defineDefaults)(componentAPI, {
        ...(0, $5aa24ee10826bdf2$export$1d962e041bb410fd),
        [(0, $8VupT.PROPS_KEY)]: {},
        [(0, $8VupT.STATE_KEY)]: {}
    }), {
        // defined during the component creation
        [(0, $8VupT.SLOTS_KEY)]: null,
        [(0, $8VupT.ROOT_KEY)]: null,
        // these properties should not be overriden
        ...(0, $f7a7d86bb4745ded$export$32f93d47894fcbb3),
        name: name,
        css: css,
        template: template
    }));
}


/**
 * Create the subcomponents that can be included inside a tag in runtime
 * @param   {Object} components - components imported in runtime
 * @returns {Object} all the components transformed into Riot.Component factory functions
 */ function $1fc427e8fe077837$var$createChildrenComponentsObject(components = {}) {
    return Object.entries((0, $b9e74c7f16476471$export$d5f47afc7eea6932)(components)).reduce((acc, [key, value])=>{
        acc[(0, $ldAW2.camelToDashCase)(key)] = $1fc427e8fe077837$export$947ce802869248c7(value);
        return acc;
    }, {});
}
/**
 * Create the getter function to render the child components
 * @param   {RiotComponentWrapper} componentWrapper - riot compiler generated object
 * @returns {Function} function returning the component factory function
 */ const $1fc427e8fe077837$var$createChildComponentGetter = (componentWrapper)=>{
    const childrenComponents = $1fc427e8fe077837$var$createChildrenComponentsObject(componentWrapper.exports ? componentWrapper.exports.components : {});
    return (name)=>{
        // improve support for recursive components
        if (name === componentWrapper.name) return $1fc427e8fe077837$var$memoizedCreateComponentFromWrapper(componentWrapper);
        // return the registered components
        return childrenComponents[name] || (0, $8VupT.COMPONENTS_IMPLEMENTATION_MAP).get(name);
    };
};
/**
 * Performance optimization for the recursive components
 * @param  {RiotComponentWrapper} componentWrapper - riot compiler generated object
 * @returns {Object} component like interface
 */ const $1fc427e8fe077837$var$memoizedCreateComponentFromWrapper = (0, $koC5P.memoize)($1fc427e8fe077837$export$947ce802869248c7);
/**
 * Create the component interface needed for the @riotjs/dom-bindings tag bindings
 * @param   {RiotComponentWrapper} componentWrapper - riot compiler generated object
 * @param   {string} componentWrapper.css - component css
 * @param   {Function} componentWrapper.template - function that will return the dom-bindings template function
 * @param   {Object} componentWrapper.exports - component interface
 * @param   {string} componentWrapper.name - component name
 * @returns {Object} component like interface
 */ function $1fc427e8fe077837$export$947ce802869248c7(componentWrapper) {
    const { css: css, template: template, exports: exports, name: name } = componentWrapper;
    const templateFn = template ? (0, $9af6c12e4df6b737$export$11f2fea361a206f0)(template, componentWrapper, $1fc427e8fe077837$var$createChildComponentGetter(componentWrapper)) : (0, $772c4fd85a1a44c9$export$1164b28605be0644);
    return ({ slots: slots, attributes: attributes, props: props })=>{
        // pure components rendering will be managed by the end user
        if (exports && exports[0, $8VupT.IS_PURE_SYMBOL]) return (0, $92f6c4cf9c901410$export$bcf29ba1633fa75c)(exports, {
            slots: slots,
            attributes: attributes,
            props: props,
            css: css,
            template: template
        });
        const componentAPI = (0, $b9e74c7f16476471$export$d5f47afc7eea6932)(exports) || {};
        const component = (0, $5971bdf1f1024ec7$export$35b384e1d9a985a8)({
            css: css,
            template: templateFn,
            componentAPI: componentAPI,
            name: name
        })({
            slots: slots,
            attributes: attributes,
            props: props
        });
        // notice that for the components created via tag binding
        // we need to invert the mount (state/parentScope) arguments
        // the template bindings will only forward the parentScope updates
        // and never deal with the component state
        return {
            mount (element, parentScope, state) {
                return component.mount(element, state, parentScope);
            },
            update (parentScope, state) {
                return component.update(state, parentScope);
            },
            unmount (preserveRoot) {
                return component.unmount(preserveRoot);
            }
        };
    };
}


/**
 * Helper method to create component without relying on the registered ones
 * @param   {Object} implementation - component implementation
 * @returns {Function} function that will allow you to mount a riot component on a DOM node
 */ function $5e14b8d5841bdab5$export$d8556a2a8f973135(implementation) {
    return (el, props, { slots: slots, attributes: attributes, parentScope: parentScope } = {})=>(0, $7ba2b4a53f68798a$export$2e2bcd8739ae039)((c)=>c.mount(el, parentScope), (c)=>c({
                props: props,
                slots: slots,
                attributes: attributes
            }), (0, $1fc427e8fe077837$export$947ce802869248c7))(implementation);
}

/* Riot v9.4.7, @license MIT */ 
var $8VupT = parcelRequire("8VupT");

var $koC5P = parcelRequire("koC5P");

/**
 * Register a custom tag by name
 * @param   {string} name - component name
 * @param   {Object} implementation - tag implementation
 * @returns {Map} map containing all the components implementations
 */ function $e7d6978190b9d367$export$6503ec6e8aabbaf(name, { css: css, template: template, exports: exports }) {
    if ((0, $8VupT.COMPONENTS_IMPLEMENTATION_MAP).has(name)) (0, $koC5P.panic)(`The component "${name}" was already registered`);
    (0, $8VupT.COMPONENTS_IMPLEMENTATION_MAP).set(name, (0, $1fc427e8fe077837$export$947ce802869248c7)({
        name: name,
        css: css,
        template: template,
        exports: exports
    }));
    return 0, $8VupT.COMPONENTS_IMPLEMENTATION_MAP;
}


var $6641b049ad84b098$exports = {};
"use strict";

var $52ixw = parcelRequire("52ixw");
Object.defineProperty($6641b049ad84b098$exports, "__esModule", {
    value: true
});
$6641b049ad84b098$exports.default = $52ixw;


// event-bus.js
var $fdc2ae01963aa852$exports = {};
(function(window1, undefined1) {
    const ALL_CALLBACKS = '*';
    const define = Object.defineProperties;
    const entries = Object.entries;
    const on = (callbacks, el)=>(event, fn)=>{
            if (callbacks.has(event)) callbacks.get(event).add(fn);
            else callbacks.set(event, new Set().add(fn));
            return el;
        };
    const deleteCallback = (callbacks, el, event, fn)=>{
        if (fn) {
            const fns = callbacks.get(event);
            if (fns) {
                fns.delete(fn);
                if (fns.size === 0) callbacks.delete(event);
            }
        } else callbacks.delete(event);
    };
    const off = (callbacks, el)=>(event, fn)=>{
            if (event === ALL_CALLBACKS && !fn) callbacks.clear();
            else deleteCallback(callbacks, el, event, fn);
            return el;
        };
    const one = (callbacks, el)=>(event, fn)=>{
            function on(...args) {
                el.off(event, on);
                fn.apply(el, args);
            }
            return el.on(event, on);
        };
    const trigger = (callbacks, el)=>(event, ...args)=>{
            const fns = callbacks.get(event);
            if (fns) fns.forEach((fn)=>fn.apply(el, args));
            if (callbacks.get(ALL_CALLBACKS) && event !== ALL_CALLBACKS) el.trigger(ALL_CALLBACKS, event, ...args);
            return el;
        };
    const observable = function(el) {
        const callbacks = new Map();
        const methods = {
            on: on,
            off: off,
            one: one,
            trigger: trigger
        };
        el = el || {};
        define(el, entries(methods).reduce((acc, [key, method])=>{
            acc[key] = {
                value: method(callbacks, el),
                enumerable: false,
                writable: false,
                configurable: false
            };
            return acc;
        }, {}));
        return el;
    };
    $fdc2ae01963aa852$exports = observable;
})(typeof window != 'undefined' ? window : undefined);


const $3583489fbc257081$var$eventBus = {};
(0, (/*@__PURE__*/$parcel$interopDefault($fdc2ae01963aa852$exports)))($3583489fbc257081$var$eventBus);
var $3583489fbc257081$export$2e2bcd8739ae039 = $3583489fbc257081$var$eventBus;


// constants.js
const $315dbc24fdcb29cb$export$fa3d5b535a2458a1 = {
    ITEMS: {
        CHANGED: 'ev_changed_items',
        CREATE: 'ev_create_item',
        DELETE: 'ev_delete_item',
        SEARCH: 'ev_search_items',
        REFRESH: 'ev_refresh_items'
    },
    COMBOBOX: {
        RESET: 'ev_reset_combobox',
        UPDATE: 'ev_update_combobox',
        SELECTED: 'ev_selected_combobox'
    },
    CHECKBOX: {
        RESET: 'ev_reset_checkbox',
        CHECK: 'ev_check_checkbox',
        CHECK_ALL: 'ev_checkall_checkbox'
    },
    INPUT: {
        RESET: 'ev_reset_input',
        UPDATE: 'ev_update_input',
        UPDATED: 'ev_updated_input',
        DELETE: 'ev_delete_input'
    },
    AUTH: {
        LOGIN_SUCCESS: 'ev_login_success',
        LOGIN_FAILED: 'ev_login_failed',
        LOGOUT: 'ev_logout',
        LOGOUT_SUCCESS: 'ev_logout_success',
        LOGOUT_FAILED: 'ev_logout_failed'
    },
    UI: {
        CHANGE_PAGE: 'ev_change_page',
        CLICK_BUTTON_GROUP: 'ev_click_button_group',
        OPEN_MODAL_ORE: 'ev_open_modal_ore',
        OPEN_MODAL_DELETE: 'ev_open_modal_delete',
        OPEN_MODAL_ERROR: 'ev_open_modal_error',
        //        OPEN_MODAL_PREMIO: 'ev_open_modal_premio',
        //        OPEN_MODAL_RESULT: 'ev_open_modal_result',
        //        OPEN_MODAL_RICHIESTA: 'ev_open_modal_richiesta',
        //        OPEN_MODAL_WAVE: 'ev_open_modal_wave',
        TOGGLE_ACCORDION: 'ev_toggle_accordion',
        UPDATE_BREADCRUMB: 'ev_update_breadcrumb',
        UPDATE_HEADING: 'ev_update_heading',
        UPDATE_SORTING: 'ev_update_sorting',
        UPDATE_NAV: 'ev_update_nav',
        UPDATE_TH: 'ev_update_th',
        UPDATE_TD: 'ev_update_td',
        GENERIC_ERROR: 'ev_generic_error'
    },
    FILE: {
        RESET: 'ev_reset_file',
        UPDATE: 'ev_update_file',
        UPDATED: 'ev_updated_file',
        LOADED_XLS: 'loaded_xls',
        LOADED_PDF: 'loaded_pdf'
    }
};
const $315dbc24fdcb29cb$export$f9ba527e25c2bc92 = {
    COMMESSE: 'key_commesse',
    TASK: 'key_task',
    ORE: 'key_ore',
    MODAL_ORE: 'key_modal_ore'
};
const $315dbc24fdcb29cb$export$1630b5343357e8b5 = {
    API_URL: 'https://nsg-api.originiagency.it/api',
    ACTIONS: 'actions',
    ASC: 'asc',
    CHECKBOX: 'cb',
    EDITABLE: 'editable',
    DATE: 'date',
    DATETIME: 'datetime',
    DESC: 'desc',
    HTML: 'html',
    NUMBER: 'number',
    N_ITEMS: 10
};
const $315dbc24fdcb29cb$export$92a1a3b7554e9387 = {
    COPY: 'copy',
    EDIT: 'edit',
    DELETE: 'delete',
    SEND_EMAIL: 'send_email'
};
const $315dbc24fdcb29cb$export$a4ad2735b021c132 = '20250418';


class $38b2f4a478272d56$var$StoreService {
    constructor(){
        this.cache = {};
    }
    // Funzione per recuperare l'utente attualmente loggato
    getUser() {
        return localStorage.getObject('utente');
    }
    async login(username, password) {
        try {
            const res = await fetch((0, $315dbc24fdcb29cb$export$1630b5343357e8b5).API_URL + '/auth/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: username,
                    password: password
                })
            });
            const data = await res.json();
            if (!res.ok) {
                console.error("\u274C Login fallita:", data.error);
                return;
            }
            localStorage.setObject('token', data.token);
            localStorage.setObject('utente', data.utente);
            return data;
        } catch (err) {
            console.error("\u274C Errore di rete o fetch:", err);
        }
    }
    async logout() {
        localStorage.setObject('token', null);
        localStorage.setObject('utente', null);
        return {
            logout: true
        };
    }
    async fetchComboboxData({ storageKey: storageKey, storeMethod: storeMethod, formatFn: formatFn }) {
        const cached = sessionStorage.getItem(storageKey);
        if (cached) try {
            return JSON.parse(cached);
        } catch (e) {
            console.warn(`Errore parsing cache ${storageKey}`, e);
        }
        const data = await storeMethod();
        if (!data?.items) return [];
        const formatted = data.items.map(formatFn);
        sessionStorage.setItem(storageKey, JSON.stringify(formatted));
        return formatted;
    }
    async fetchCommesse(sortColumn, sortDirection, page = 1, search_text = '', where = {}) {
        try {
            const limit = (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).N_ITEMS;
            const offset = (page - 1) * limit;
            const params = new URLSearchParams();
            params.set('limit', limit);
            params.set('offset', offset);
            if (sortColumn) params.set('sortField', sortColumn);
            if (sortDirection) params.set('sortDir', sortDirection);
            if (search_text) params.set('search', search_text);
            for (const [key, value] of Object.entries(where))params.set(`filter[${key}]`, value);
            const url = `${(0, $315dbc24fdcb29cb$export$1630b5343357e8b5).API_URL}/commesse?${params.toString()}`;
            const res = await this.fetchAuth(url);
            if (!res.ok) throw new Error('Errore nel recupero delle commesse');
            const data = await res.json();
            return data;
        } catch (e) {
            console.error(`Error in fetchCommesse: ${e.message}`, e);
            return {
                items: null,
                code: e.code,
                error: e.message
            };
        }
    }
    async fetchCommessa(id_commessa) {
        try {
            const url = `${(0, $315dbc24fdcb29cb$export$1630b5343357e8b5).API_URL}/commesse/${id_commessa}`;
            const res = await this.fetchAuth(url);
            if (!res.ok) throw new Error('Errore nel recupero della commessa');
            const data = await res.json();
            return data;
        } catch (e) {
            console.error(`Error in fetchCommessa: ${e.message}`, e);
            return {
                items: null,
                code: e.code,
                error: e.message
            };
        }
    }
    async fetchTask(sortColumn, sortDirection, page = 1, search_text = '', where = {}) {
        try {
            const limit = (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).N_ITEMS;
            const offset = (page - 1) * limit;
            const params = new URLSearchParams();
            params.set('limit', limit);
            params.set('offset', offset);
            if (sortColumn) params.set('sortField', sortColumn);
            if (sortDirection) params.set('sortDir', sortDirection);
            if (search_text) params.set('search', search_text);
            for (const [key, value] of Object.entries(where))params.set(`filter[${key}]`, value);
            const url = `${(0, $315dbc24fdcb29cb$export$1630b5343357e8b5).API_URL}/task?${params.toString()}`;
            const res = await this.fetchAuth(url);
            if (!res.ok) throw new Error('Errore nel recupero dei task');
            const data = await res.json();
            return data;
        } catch (e) {
            console.error(`Error in fetchTask: ${e.message}`, e);
            return {
                items: null,
                code: e.code,
                error: e.message
            };
        }
    }
    async fetchOre(sortColumn, sortDirection, page = 1, search_text = '', where = {}) {
        try {
            const limit = (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).N_ITEMS;
            const offset = (page - 1) * limit;
            const params = new URLSearchParams();
            params.set('limit', limit);
            params.set('offset', offset);
            if (sortColumn) params.set('sortField', sortColumn);
            if (sortDirection) params.set('sortDir', sortDirection);
            if (search_text) params.set('search', search_text);
            for (const [key, value] of Object.entries(where))params.set(`filter[${key}]`, value);
            const url = `${(0, $315dbc24fdcb29cb$export$1630b5343357e8b5).API_URL}/ore?${params.toString()}`;
            const res = await this.fetchAuth(url);
            if (!res.ok) throw new Error('Errore nel recupero delle ore');
            const data = await res.json();
            return data;
        } catch (e) {
            console.error(`Error in fetchOre: ${e.message}`, e);
            return {
                items: null,
                code: e.code,
                error: e.message
            };
        }
    }
    async fetchRisorse(sortColumn = '', sortDirection = 'asc', page = 0, search_text = '') {
        try {
            const params = new URLSearchParams();
            if (page > 0) {
                const limit = (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).N_ITEMS;
                const offset = (page - 1) * limit;
                params.set('limit', limit);
                params.set('offset', offset);
            }
            if (sortColumn) params.set('sortField', sortColumn);
            else params.set('sortField', 'cognome');
            if (sortDirection) params.set('sortDir', sortDirection);
            if (search_text) params.set('search', search_text);
            const url = `${(0, $315dbc24fdcb29cb$export$1630b5343357e8b5).API_URL}/risorse?${params.toString()}`;
            const res = await this.fetchAuth(url);
            if (!res.ok) throw new Error('Errore nel recupero delle risorse');
            const data = await res.json();
            return data;
        } catch (e) {
            console.error(`Error in fetchRisorse: ${e.message}`, e);
            return {
                items: null,
                code: e.code,
                error: e.message
            };
        }
    }
    async fetchStati() {
        try {
            const url = `${(0, $315dbc24fdcb29cb$export$1630b5343357e8b5).API_URL}/stati`;
            const res = await this.fetchAuth(url);
            if (!res.ok) throw new Error('Errore nel recupero degli stati');
            const data = await res.json();
            return data;
        } catch (e) {
            console.error(`Error in fetchStati: ${e.message}`, e);
            return {
                items: null,
                code: e.code,
                error: e.message
            };
        }
    }
    async fetchStatiTask() {
        try {
            const url = `${(0, $315dbc24fdcb29cb$export$1630b5343357e8b5).API_URL}/statitask`;
            const res = await this.fetchAuth(url);
            if (!res.ok) throw new Error('Errore nel recupero degli stati dei task');
            const data = await res.json();
            return data;
        } catch (e) {
            console.error(`Error in fetchStatiTask: ${e.message}`, e);
            return {
                items: null,
                code: e.code,
                error: e.message
            };
        }
    }
    async fetchSocieta() {
        try {
            const url = `${(0, $315dbc24fdcb29cb$export$1630b5343357e8b5).API_URL}/societa`;
            const res = await this.fetchAuth(url);
            if (!res.ok) throw new Error("Errore nel recupero delle societ\xe0");
            const data = await res.json();
            return data;
        } catch (e) {
            console.error(`Error in fetchSocieta: ${e.message}`, e);
            return {
                items: null,
                code: e.code,
                error: e.message
            };
        }
    }
    async saveTask(id, data) {
        try {
            const url = `${(0, $315dbc24fdcb29cb$export$1630b5343357e8b5).API_URL}/task/${id}`;
            const res = await this.fetchAuth(url, {
                method: 'PATCH',
                body: JSON.stringify(data)
            });
            if (!res.ok) throw new Error('Errore aggiornamento task');
            return {
                success: true
            };
        } catch (e) {
            console.error(`Error in saveTask: ${e.message}`, e);
            return {
                success: false,
                error: e.message
            };
        }
    }
    async saveOra(id, data) {
        try {
            let url = `${(0, $315dbc24fdcb29cb$export$1630b5343357e8b5).API_URL}/ore`;
            let method = null;
            if (id) {
                url += `/${id}`;
                method = 'PATCH';
            } else method = 'POST';
            const res = await this.fetchAuth(url, {
                method: method,
                body: JSON.stringify(data)
            });
            if (!res.ok) throw new Error('Errore aggiornamento ore');
            return {
                success: true
            };
        } catch (e) {
            console.error(`Error in saveTask: ${e.message}`, e);
            return {
                success: false,
                error: e.message
            };
        }
    }
    async deleteOra(id) {
        try {
            const url = `${(0, $315dbc24fdcb29cb$export$1630b5343357e8b5).API_URL}/ore/${id}`;
            const res = await this.fetchAuth(url, {
                method: 'DELETE'
            });
            if (!res.ok) throw new Error('Errore cancellazione ora');
            return {
                success: true
            };
        } catch (e) {
            console.error(`Error in saveTask: ${e.message}`, e);
            return {
                success: false,
                error: e.message
            };
        }
    }
    async fetchAuth(url, options = {}) {
        const token = localStorage.getObject('token');
        if (!token) throw new Error('Token mancante');
        const headers = {
            ...options.headers,
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        };
        const response = await fetch(url, {
            ...options,
            headers: headers
        });
        // Se il token è scaduto o non valido
        if (response.status === 401 || response.status === 403) try {
            const body = await response.json();
            if (body?.error?.includes('Token scaduto') || body?.error?.includes('Token mancante')) {
                localStorage.removeItem('token');
                localStorage.removeItem('utente');
                (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).AUTH.LOGOUT, {
                    reason: 'expired'
                });
            }
        } catch (e) {
            console.error("Errore durante la lettura dell\u2019errore", e);
        }
        return response;
    }
}
var $38b2f4a478272d56$export$2e2bcd8739ae039 = new $38b2f4a478272d56$var$StoreService();
Storage.prototype.setObject = function(key, value) {
    this.setItem(key, JSON.stringify(value));
};
Storage.prototype.getObject = function(key) {
    const value = this.getItem(key);
    return value && JSON.parse(value);
};




var $cAQNV = parcelRequire("cAQNV");




function $6bfc5a82c63db877$export$710bff049a503f9d(url) {
    const pathname = url.pathname;
    (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.UPDATE_NAV, {
        pathname: pathname
    });
}
function $6bfc5a82c63db877$export$e3ed16048dcc8c7c() {
    return (0, $38b2f4a478272d56$export$2e2bcd8739ae039).fetchComboboxData({
        storageKey: 'comboboxRisorse',
        storeMethod: (0, $38b2f4a478272d56$export$2e2bcd8739ae039).fetchRisorse.bind((0, $38b2f4a478272d56$export$2e2bcd8739ae039)),
        formatFn: (r)=>({
                value: r.id,
                label: r.nickname
            })
    });
}
function $6bfc5a82c63db877$export$42dace949d12e843() {
    return (0, $38b2f4a478272d56$export$2e2bcd8739ae039).fetchComboboxData({
        storageKey: 'comboboxStati',
        storeMethod: (0, $38b2f4a478272d56$export$2e2bcd8739ae039).fetchStati.bind((0, $38b2f4a478272d56$export$2e2bcd8739ae039)),
        formatFn: (s)=>({
                value: s.id,
                label: s.label
            })
    });
}
function $6bfc5a82c63db877$export$7659d5ac17afd4e5() {
    return (0, $38b2f4a478272d56$export$2e2bcd8739ae039).fetchComboboxData({
        storageKey: 'comboboxStatiTask',
        storeMethod: (0, $38b2f4a478272d56$export$2e2bcd8739ae039).fetchStatiTask.bind((0, $38b2f4a478272d56$export$2e2bcd8739ae039)),
        formatFn: (s)=>({
                value: s.id,
                label: s.label
            })
    });
}
function $6bfc5a82c63db877$export$9d5b4a605e86f953() {
    return (0, $38b2f4a478272d56$export$2e2bcd8739ae039).fetchComboboxData({
        storageKey: 'comboboxSocieta',
        storeMethod: (0, $38b2f4a478272d56$export$2e2bcd8739ae039).fetchSocieta.bind((0, $38b2f4a478272d56$export$2e2bcd8739ae039)),
        formatFn: (s)=>({
                value: s.id,
                label: s.label
            })
    });
}
function $6bfc5a82c63db877$export$e90fb89750dba83f(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $6bfc5a82c63db877$export$53f918f2b7d40673(societa) {
    let logo = "";
    switch(societa){
        case "NSG srl":
            logo = "/images/nsg.png";
            break;
        case "Noknok srl":
            logo = "/images/noknok.png";
            break;
    }
    return logo;
}
function $6bfc5a82c63db877$export$2953bd25a4acda3a() {
    const utente = (0, $38b2f4a478272d56$export$2e2bcd8739ae039).getUser();
    return utente["ID_Risorsa"];
}


const $422a886e660c1a9e$var$loc = window.location;
var $422a886e660c1a9e$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        base: `${$422a886e660c1a9e$var$loc.pathname}/`,
        beforeRoute: $6bfc5a82c63db877$export$710bff049a503f9d,
        onBeforeMount () {
            const user = (0, $38b2f4a478272d56$export$2e2bcd8739ae039).getUser();
            this.state = {
                user: user
            };
            const currentPath = window.location.hash;
            if (user && (!currentPath || currentPath === '#/' || currentPath === '#')) history.replaceState({}, '', '#/commesse');
        },
        async onMounted () {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).AUTH.LOGIN_SUCCESS, (user)=>{
                this.update({
                    user: user
                });
                const path = '#/commesse';
                history.pushState({}, '', path);
                (0, $cAQNV.router).push(path);
            });
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).AUTH.LOGOUT_SUCCESS, (e)=>{
                this.update({
                    user: null
                });
            });
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.GENERIC_ERROR, (e)=>{
                if (e.code === 209) (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).AUTH.LOGOUT, e);
                else {
                    console.error(e);
                    (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.OPEN_MODAL_ERROR, {
                        ckey: "error",
                        title: "Errore generico",
                        text: e.error
                    });
                }
            });
        },
        onBeforeUnmount () {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).AUTH.LOGIN_SUCCESS);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).AUTH.LOGOUT_SUCCESS);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.GENERIC_ERROR);
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<router expr0="expr0"></router>', [
            {
                type: bindingTypes.TAG,
                getComponent: getComponent,
                evaluate: (_scope)=>'router',
                slots: [
                    {
                        id: 'default',
                        html: '<div expr1="expr1"></div><div expr14="expr14"></div><modal-error expr17="expr17"></modal-error>',
                        bindings: [
                            {
                                type: bindingTypes.IF,
                                evaluate: (_scope)=>_scope.state.user,
                                redundantAttribute: 'expr1',
                                selector: '[expr1]',
                                template: template('<route expr2="expr2" path="#/commesse"></route><route expr6="expr6" path="#/commesse/:id_commessa"></route><route expr10="expr10" path="#/tasks"></route>', [
                                    {
                                        type: bindingTypes.TAG,
                                        getComponent: getComponent,
                                        evaluate: (_scope)=>'route',
                                        slots: [
                                            {
                                                id: 'default',
                                                html: '<main-navi expr3="expr3"></main-navi><main class="py-10 lg:pl-72"><div class="px-4 sm:px-6 lg:px-8"><commesse expr4="expr4"></commesse><my-footer expr5="expr5"></my-footer></div></main>',
                                                bindings: [
                                                    {
                                                        type: bindingTypes.TAG,
                                                        getComponent: getComponent,
                                                        evaluate: (_scope)=>'main-navi',
                                                        slots: [],
                                                        attributes: [],
                                                        redundantAttribute: 'expr3',
                                                        selector: '[expr3]'
                                                    },
                                                    {
                                                        type: bindingTypes.TAG,
                                                        getComponent: getComponent,
                                                        evaluate: (_scope)=>'commesse',
                                                        slots: [],
                                                        attributes: [],
                                                        redundantAttribute: 'expr4',
                                                        selector: '[expr4]'
                                                    },
                                                    {
                                                        type: bindingTypes.TAG,
                                                        getComponent: getComponent,
                                                        evaluate: (_scope)=>'my-footer',
                                                        slots: [],
                                                        attributes: [],
                                                        redundantAttribute: 'expr5',
                                                        selector: '[expr5]'
                                                    }
                                                ]
                                            }
                                        ],
                                        attributes: [],
                                        redundantAttribute: 'expr2',
                                        selector: '[expr2]'
                                    },
                                    {
                                        type: bindingTypes.TAG,
                                        getComponent: getComponent,
                                        evaluate: (_scope)=>'route',
                                        slots: [
                                            {
                                                id: 'default',
                                                html: '<main-navi expr7="expr7"></main-navi><main class="pt-10 lg:pl-72"><div class="px-4 sm:px-6 lg:px-8"><commessa expr8="expr8"></commessa><my-footer expr9="expr9"></my-footer></div></main>',
                                                bindings: [
                                                    {
                                                        type: bindingTypes.TAG,
                                                        getComponent: getComponent,
                                                        evaluate: (_scope)=>'main-navi',
                                                        slots: [],
                                                        attributes: [],
                                                        redundantAttribute: 'expr7',
                                                        selector: '[expr7]'
                                                    },
                                                    {
                                                        type: bindingTypes.TAG,
                                                        getComponent: getComponent,
                                                        evaluate: (_scope)=>'commessa',
                                                        slots: [],
                                                        attributes: [
                                                            {
                                                                type: expressionTypes.ATTRIBUTE,
                                                                isBoolean: false,
                                                                name: 'id_commessa',
                                                                evaluate: (_scope)=>_scope.route.params.id_commessa
                                                            }
                                                        ],
                                                        redundantAttribute: 'expr8',
                                                        selector: '[expr8]'
                                                    },
                                                    {
                                                        type: bindingTypes.TAG,
                                                        getComponent: getComponent,
                                                        evaluate: (_scope)=>'my-footer',
                                                        slots: [],
                                                        attributes: [],
                                                        redundantAttribute: 'expr9',
                                                        selector: '[expr9]'
                                                    }
                                                ]
                                            }
                                        ],
                                        attributes: [],
                                        redundantAttribute: 'expr6',
                                        selector: '[expr6]'
                                    },
                                    {
                                        type: bindingTypes.TAG,
                                        getComponent: getComponent,
                                        evaluate: (_scope)=>'route',
                                        slots: [
                                            {
                                                id: 'default',
                                                html: '<main-navi expr11="expr11"></main-navi><main class="py-10 lg:pl-72"><div class="px-4 sm:px-6 lg:px-8"><tasks expr12="expr12"></tasks><my-footer expr13="expr13"></my-footer></div></main>',
                                                bindings: [
                                                    {
                                                        type: bindingTypes.TAG,
                                                        getComponent: getComponent,
                                                        evaluate: (_scope)=>'main-navi',
                                                        slots: [],
                                                        attributes: [],
                                                        redundantAttribute: 'expr11',
                                                        selector: '[expr11]'
                                                    },
                                                    {
                                                        type: bindingTypes.TAG,
                                                        getComponent: getComponent,
                                                        evaluate: (_scope)=>'tasks',
                                                        slots: [],
                                                        attributes: [],
                                                        redundantAttribute: 'expr12',
                                                        selector: '[expr12]'
                                                    },
                                                    {
                                                        type: bindingTypes.TAG,
                                                        getComponent: getComponent,
                                                        evaluate: (_scope)=>'my-footer',
                                                        slots: [],
                                                        attributes: [],
                                                        redundantAttribute: 'expr13',
                                                        selector: '[expr13]'
                                                    }
                                                ]
                                            }
                                        ],
                                        attributes: [],
                                        redundantAttribute: 'expr10',
                                        selector: '[expr10]'
                                    }
                                ])
                            },
                            {
                                type: bindingTypes.IF,
                                evaluate: (_scope)=>!_scope.state.user,
                                redundantAttribute: 'expr14',
                                selector: '[expr14]',
                                template: template('<login expr15="expr15"></login><div class="px-4 sm:px-6 lg:px-8"><my-footer expr16="expr16"></my-footer></div>', [
                                    {
                                        type: bindingTypes.TAG,
                                        getComponent: getComponent,
                                        evaluate: (_scope)=>'login',
                                        slots: [],
                                        attributes: [],
                                        redundantAttribute: 'expr15',
                                        selector: '[expr15]'
                                    },
                                    {
                                        type: bindingTypes.TAG,
                                        getComponent: getComponent,
                                        evaluate: (_scope)=>'my-footer',
                                        slots: [],
                                        attributes: [],
                                        redundantAttribute: 'expr16',
                                        selector: '[expr16]'
                                    }
                                ])
                            },
                            {
                                type: bindingTypes.TAG,
                                getComponent: getComponent,
                                evaluate: (_scope)=>'modal-error',
                                slots: [],
                                attributes: [],
                                redundantAttribute: 'expr17',
                                selector: '[expr17]'
                            }
                        ]
                    }
                ],
                attributes: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'base',
                        evaluate: (_scope)=>_scope.base
                    }
                ],
                redundantAttribute: 'expr0',
                selector: '[expr0]'
            }
        ]),
    name: 'app'
};



var $c5cf553bae6e66d8$exports = {};
var $3f8c355ba50d873e$exports = {};

$parcel$defineInteropFlag($3f8c355ba50d873e$exports);

$parcel$export($3f8c355ba50d873e$exports, "default", () => $3f8c355ba50d873e$export$2e2bcd8739ae039);


var $3f8c355ba50d873e$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        onBeforeMount (props, state) {
            this.state = {
                closed: false
            };
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.TOGGLE_ACCORDION, this.handleToggleAccordion);
        },
        onBeforeUnmount (props, state) {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.TOGGLE_ACCORDION, this.handleToggleAccordion);
        },
        handleToggleAccordion (e) {
            if (e.ckey === this.props.ckey) this.update({
                closed: e.closed
            });
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<div expr18="expr18"><slot expr19="expr19"></slot></div>', [
            {
                redundantAttribute: 'expr18',
                selector: '[expr18]',
                expressions: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'class',
                        evaluate: (_scope)=>_scope.state.closed ? 'hidden' : 'block'
                    }
                ]
            },
            {
                type: bindingTypes.SLOT,
                attributes: [],
                name: 'default',
                template: null,
                redundantAttribute: 'expr19',
                selector: '[expr19]'
            }
        ]),
    name: 'accordion-body'
};


var $b26998206af91f57$exports = {};

$parcel$defineInteropFlag($b26998206af91f57$exports);

$parcel$export($b26998206af91f57$exports, "default", () => $b26998206af91f57$export$2e2bcd8739ae039);


var $b26998206af91f57$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        onBeforeMount (props, state) {
            this.state = {
                closed: false
            };
        },
        toggleAccordion () {
            const new_state = !this.state.closed;
            this.update({
                closed: new_state
            });
            (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.TOGGLE_ACCORDION, {
                ckey: this.props.ckey,
                closed: new_state
            });
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<button expr17="expr17" class="w-full flex justify-between items-center py-5"><slot expr18="expr18"></slot><span class="text-cyan-800 transition-transform duration-300"><svg expr19="expr19" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4"></svg><svg expr20="expr20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4"></svg></span></button>', [
            {
                redundantAttribute: 'expr17',
                selector: '[expr17]',
                expressions: [
                    {
                        type: expressionTypes.EVENT,
                        name: 'onclick',
                        evaluate: (_scope)=>_scope.toggleAccordion
                    }
                ]
            },
            {
                type: bindingTypes.SLOT,
                attributes: [],
                name: 'default',
                template: null,
                redundantAttribute: 'expr18',
                selector: '[expr18]'
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.state.closed,
                redundantAttribute: 'expr19',
                selector: '[expr19]',
                template: template('<path fill-rule="evenodd" d="M11.78 9.78a.75.75 0 0 1-1.06 0L8 7.06 5.28 9.78a.75.75 0 0 1-1.06-1.06l3.25-3.25a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1 0 1.06Z" clip-rule="evenodd"/>', [])
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>!_scope.state.closed,
                redundantAttribute: 'expr20',
                selector: '[expr20]',
                template: template('<path fill-rule="evenodd" d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"/>', [])
            }
        ]),
    name: 'accordion-title'
};


var $27e632b64d7184e3$exports = {};

$parcel$defineInteropFlag($27e632b64d7184e3$exports);

$parcel$export($27e632b64d7184e3$exports, "default", () => $27e632b64d7184e3$export$2e2bcd8739ae039);


var $27e632b64d7184e3$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        onBeforeMount (props, state) {
            this.state = {
                text: props.text
            };
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.UPDATE_BREADCRUMB, this.handleUpdateBreadcrumb);
        },
        onBeforeUnmount (props, state) {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.UPDATE_BREADCRUMB, this.handleUpdateBreadcrumb);
        },
        handleUpdateBreadcrumb (e) {
            if (e.ckey === this.props.ckey) this.update({
                text: e.text
            });
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<li><div class="flex items-center"><svg class="h-5 w-5 flex-shrink-0 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clip-rule="evenodd"/></svg><a expr63="expr63" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"> </a></div></li>', [
            {
                redundantAttribute: 'expr63',
                selector: '[expr63]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>_scope.state.text
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'href',
                        evaluate: (_scope)=>_scope.props.link
                    }
                ]
            }
        ]),
    name: 'breadcrumb-item'
};


var $5eb7052bb970cf6d$exports = {};

$parcel$defineInteropFlag($5eb7052bb970cf6d$exports);

$parcel$export($5eb7052bb970cf6d$exports, "default", () => $5eb7052bb970cf6d$export$2e2bcd8739ae039);
var $5eb7052bb970cf6d$export$2e2bcd8739ae039 = {
    css: null,
    exports: null,
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<nav class="hidden sm:flex mb-5" aria-label="Breadcrumb"><ol role="list" class="flex items-center space-x-4"><li><div class="flex"><a href="/#" class="text-sm font-medium text-gray-500 hover:text-gray-700">Progetti</a></div></li><slot expr21="expr21"></slot></ol></nav>', [
            {
                type: bindingTypes.SLOT,
                attributes: [],
                name: 'default',
                template: null,
                redundantAttribute: 'expr21',
                selector: '[expr21]'
            }
        ]),
    name: 'breadcrumb'
};


var $ae70fc2a1c30fe5d$exports = {};

$parcel$defineInteropFlag($ae70fc2a1c30fe5d$exports);

$parcel$export($ae70fc2a1c30fe5d$exports, "default", () => $ae70fc2a1c30fe5d$export$2e2bcd8739ae039);
var $ae70fc2a1c30fe5d$export$2e2bcd8739ae039 = {
    css: null,
    exports: null,
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<button expr64="expr64" type="button" class="text-sm font-semibold leading-6 text-gray-900" onclick="history.back()"> </button>', [
            {
                redundantAttribute: 'expr64',
                selector: '[expr64]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>_scope.props.text ? _scope.props.text : 'Indietro'
                    }
                ]
            }
        ]),
    name: 'button-back'
};


var $a841f4ce7a69f452$exports = {};

$parcel$defineInteropFlag($a841f4ce7a69f452$exports);

$parcel$export($a841f4ce7a69f452$exports, "default", () => $a841f4ce7a69f452$export$2e2bcd8739ae039);


var $a841f4ce7a69f452$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        onBeforeMount (props, state) {
            this.state = {
                isDropdownOpen: false
            };
        },
        toggleDropdown () {
            this.update({
                isDropdownOpen: !this.state.isDropdownOpen
            });
        },
        handleOptionSelect (option) {
            this.update({
                isDropdownOpen: false
            }); // Chiudi il menu
            (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.CLICK_BUTTON_GROUP, {
                ckey: this.props.ckey,
                action: option.action,
                data: this.props.row,
                params: option.params
            });
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<div class="inline-flex rounded-md shadow-sm"><button type="button" class="relative inline-flex items-center rounded-l-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10">Azioni</button><div class="relative -ml-px block"><button expr22="expr22" type="button" class="relative inline-flex items-center rounded-r-md bg-white px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10" id="option-menu-button" aria-expanded="true" aria-haspopup="true"><span class="sr-only">Open options</span><svg class="size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon"><path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"/></svg></button><div expr23="expr23" class="absolute right-0 z-10 -mr-1 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="option-menu-button" tabindex="-1"></div></div></div>', [
            {
                redundantAttribute: 'expr22',
                selector: '[expr22]',
                expressions: [
                    {
                        type: expressionTypes.EVENT,
                        name: 'onclick',
                        evaluate: (_scope)=>_scope.toggleDropdown
                    }
                ]
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.state.isDropdownOpen,
                redundantAttribute: 'expr23',
                selector: '[expr23]',
                template: template('<div class="py-1" role="none"><a expr24="expr24" class="block px-4 py-2 text-sm text-gray-700 text-left cursor-pointer" role="menuitem" tabindex="-1"></a></div>', [
                    {
                        type: bindingTypes.EACH,
                        getKey: null,
                        condition: null,
                        template: template(' ', [
                            {
                                expressions: [
                                    {
                                        type: expressionTypes.TEXT,
                                        childNodeIndex: 0,
                                        evaluate: (_scope)=>_scope.option.label
                                    },
                                    {
                                        type: expressionTypes.EVENT,
                                        name: 'onclick',
                                        evaluate: (_scope)=>()=>_scope.handleOptionSelect(_scope.option)
                                    }
                                ]
                            }
                        ]),
                        redundantAttribute: 'expr24',
                        selector: '[expr24]',
                        itemName: 'option',
                        indexName: null,
                        evaluate: (_scope)=>_scope.props.options
                    }
                ])
            }
        ]),
    name: 'button-group'
};


var $960c062c5376ce59$exports = {};

$parcel$defineInteropFlag($960c062c5376ce59$exports);

$parcel$export($960c062c5376ce59$exports, "default", () => $960c062c5376ce59$export$2e2bcd8739ae039);
var $960c062c5376ce59$export$2e2bcd8739ae039 = {
    css: null,
    exports: null,
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<button expr65="expr65" type="submit" class="rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"> </button>', [
            {
                redundantAttribute: 'expr65',
                selector: '[expr65]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>_scope.props.text ? _scope.props.text : 'Salva'
                    }
                ]
            }
        ]),
    name: 'button-submit'
};


var $7214133ecec21835$exports = {};

$parcel$defineInteropFlag($7214133ecec21835$exports);

$parcel$export($7214133ecec21835$exports, "default", () => $7214133ecec21835$export$2e2bcd8739ae039);


var $7214133ecec21835$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        onBeforeMount (props, state) {
            this.state = {
                items: [],
                depending_items: [],
                filtered_items: [],
                item_selected: '',
                item_selected_value: ''
            };
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.UPDATE, this.handleUpdateCombobox);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.SELECTED, this.handleSelectedCombobox);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.RESET, this.handleResetCombobox);
        },
        onBeforeUnmount (props, state) {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.UPDATE, this.handleUpdateCombobox);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.SELECTED, this.handleSelectedCombobox);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.RESET, this.handleResetCombobox);
        },
        handleUpdateCombobox (e) {
            if (e.ckey === this.props.ckey) {
                if (this.props.depends_on) this.update({
                    items: e.items,
                    depending_items: [],
                    filtered_items: []
                });
                else this.update({
                    items: e.items,
                    depending_items: e.items,
                    filtered_items: e.items
                });
            }
        },
        handleSelectedCombobox (e) {
            if (e.ckey === this.props.depends_on) {
                const items = this.state.items.filter((item)=>item.depending === e.value);
                this.update({
                    depending_items: items,
                    filtered_items: items,
                    item_selected: '',
                    item_selected_value: ''
                });
            }
        },
        handleResetCombobox (e) {
            if (e.ckey === this.props.ckey) this.reset_item();
        },
        select_item (e) {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.SELECTED, {
                ckey: this.props.ckey,
                value: e.target.value
            });
        },
        reset_item () {
            this.update({
                item_selected: '',
                item_selected_value: '',
                filtered_items: this.state.depending_items.length ? this.state.depending_items : this.state.items
            });
            this.$("select").value = "" // Resetta visivamente il valore del select
            ;
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<div><my-label expr25="expr25"></my-label><div expr26="expr26"><select expr27="expr27" class="bg-none col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"><option expr28="expr28" value></option><option expr29="expr29"></option></select><svg class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" data-slot="icon"><path fill-rule="evenodd" d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"/></svg></div></div>', [
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.props.label,
                redundantAttribute: 'expr25',
                selector: '[expr25]',
                template: template(null, [
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'my-label',
                        slots: [],
                        attributes: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'ckey',
                                evaluate: (_scope)=>_scope.props.ckey
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'label',
                                evaluate: (_scope)=>_scope.props.label
                            }
                        ]
                    }
                ])
            },
            {
                redundantAttribute: 'expr26',
                selector: '[expr26]',
                expressions: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'class',
                        evaluate: (_scope)=>[
                                _scope.props.label ? 'mt-2' : '',
                                ' grid grid-cols-1'
                            ].join('')
                    }
                ]
            },
            {
                redundantAttribute: 'expr27',
                selector: '[expr27]',
                expressions: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'id',
                        evaluate: (_scope)=>_scope.props.ckey
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'name',
                        evaluate: (_scope)=>_scope.props.ckey
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: true,
                        name: 'required',
                        evaluate: (_scope)=>_scope.props.is_required
                    },
                    {
                        type: expressionTypes.EVENT,
                        name: 'onchange',
                        evaluate: (_scope)=>_scope.select_item
                    }
                ]
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.props.placeholder,
                redundantAttribute: 'expr28',
                selector: '[expr28]',
                template: template(' ', [
                    {
                        expressions: [
                            {
                                type: expressionTypes.TEXT,
                                childNodeIndex: 0,
                                evaluate: (_scope)=>_scope.props.placeholder
                            }
                        ]
                    }
                ])
            },
            {
                type: bindingTypes.EACH,
                getKey: null,
                condition: null,
                template: template(' ', [
                    {
                        expressions: [
                            {
                                type: expressionTypes.TEXT,
                                childNodeIndex: 0,
                                evaluate: (_scope)=>_scope.item.label
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'value',
                                evaluate: (_scope)=>_scope.item.value
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: true,
                                name: 'selected',
                                evaluate: (_scope)=>_scope.item.value == _scope.props.value
                            }
                        ]
                    }
                ]),
                redundantAttribute: 'expr29',
                selector: '[expr29]',
                itemName: 'item',
                indexName: null,
                evaluate: (_scope)=>_scope.state.filtered_items
            }
        ]),
    name: 'combobox'
};


var $f7bce1e7df6e4bf1$exports = {};

$parcel$defineInteropFlag($f7bce1e7df6e4bf1$exports);

$parcel$export($f7bce1e7df6e4bf1$exports, "default", () => $f7bce1e7df6e4bf1$export$2e2bcd8739ae039);





var $f7bce1e7df6e4bf1$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        ACTIONS: (0, $315dbc24fdcb29cb$export$92a1a3b7554e9387),
        KEYS: (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92),
        getLogo: (0, $6bfc5a82c63db877$export$53f918f2b7d40673),
        onBeforeMount (props, state) {
            this.state = {
                commessa: null,
                columns_task: [
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).DATE,
                        label: 'Data',
                        field: 'data',
                        is_sortable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: 'Descrizione',
                        field: 'descrizione',
                        is_wrappable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: 'Note',
                        field: 'note',
                        is_wrappable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: 'Risorsa',
                        field: 'risorsa'
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).DATE,
                        label: 'Data inizio',
                        field: 'data_inizio',
                        is_sortable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).DATE,
                        label: 'Data fine',
                        field: 'data_fine',
                        is_sortable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).EDITABLE,
                        label: 'Stato',
                        field: 'stato'
                    }
                ],
                rows_task: [],
                total_rows_task: 0,
                current_page_task: 1,
                sort_column_task: 'data',
                sort_direction_task: 'asc',
                search_risorsa_task: '',
                search_stato_task: '',
                search_text_task: '',
                columns_ore: [
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).DATE,
                        label: 'Data',
                        field: 'data',
                        is_sortable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: 'Descrizione',
                        field: 'descrizione',
                        is_wrappable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: 'Note',
                        field: 'note',
                        is_wrappable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: 'Risorsa',
                        field: 'risorsa'
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: 'Ore',
                        field: 'quantita'
                    }
                ],
                rows_ore: [],
                total_rows_ore: 0,
                current_page_ore: 1,
                sort_column_ore: 'data',
                sort_direction_ore: 'asc',
                search_risorsa_ore: '',
                search_text_ore: '',
                page_size: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).N_ITEMS,
                currentTab: (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).TASK
            };
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.CHANGE_PAGE, this.handlePageChange);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.SORTING_CHANGE, this.handleSortChange);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.CLICK_BUTTON_GROUP, this.handleClickAction);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).ITEMS.REFRESH, this.handleRefresh);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).ITEMS.DELETE, this.handleDelete);
        },
        async onMounted (props, state) {
            const commessa = await (0, $38b2f4a478272d56$export$2e2bcd8739ae039).fetchCommessa(props.id_commessa);
            let percentOre = 0;
            if ((0, $6bfc5a82c63db877$export$e90fb89750dba83f)(commessa.oreTotali) && (0, $6bfc5a82c63db877$export$e90fb89750dba83f)(commessa.orePreventivate)) percentOre = parseFloat(commessa.oreTotali) / parseFloat(commessa.orePreventivate);
            this.update({
                commessa: commessa
            });
            (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.UPDATE, {
                ckey: 'perc_ore',
                value: percentOre
            });
            (0, $6bfc5a82c63db877$export$e3ed16048dcc8c7c)().then((risorse)=>{
                (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.UPDATE, {
                    ckey: 'filtro_risorsa_task',
                    items: risorse
                });
                (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.UPDATE, {
                    ckey: 'filtro_risorsa_ore',
                    items: risorse
                });
            });
            (0, $6bfc5a82c63db877$export$7659d5ac17afd4e5)().then((stati)=>{
                (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.UPDATE, {
                    ckey: 'filtro_stato_task',
                    items: stati
                });
            });
            this.fetchDataTask();
            this.fetchDataOre();
        },
        onBeforeUnmount (props, state) {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.CHANGE_PAGE, this.handlePageChange);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.SORTING_CHANGE, this.handleSortChange);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.CLICK_BUTTON_GROUP, this.handleClickAction);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).ITEMS.REFRESH, this.handleRefresh);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).ITEMS.DELETE, this.handleDelete);
        },
        handleRefresh (e) {
            if (e.ckey === (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).TASK) this.fetchDataTask();
            else if (e.ckey === (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).ORE) this.fetchDataOre();
        },
        async handleDelete (e) {
            switch(e.ckey){
                case (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).ORE:
                    await (0, $38b2f4a478272d56$export$2e2bcd8739ae039).deleteOra(e.item_id);
                    this.fetchDataOre();
                    break;
            }
        },
        handleClickAction (e) {
            if (e.ckey === (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).ORE) switch(e.action){
                case (0, $315dbc24fdcb29cb$export$92a1a3b7554e9387).EDIT:
                    (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.OPEN_MODAL_ORE, {
                        ckey: (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).ORE,
                        data: e.data
                    });
                    break;
                case (0, $315dbc24fdcb29cb$export$92a1a3b7554e9387).DELETE:
                    (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.OPEN_MODAL_DELETE, {
                        ckey: (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).ORE,
                        title: 'Cancellazione riga',
                        text: 'Sei sicuro di voler eliminare la riga?',
                        item_id: e.data.id
                    });
            }
        },
        create (e) {
            if (e.ckey === (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).ORE) (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.OPEN_MODAL_ORE, {
                ckey: (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).ORE,
                data: {
                    id_commessa: this.props.id_commessa
                }
            });
        },
        handlePageChange (e) {
            if (e.ckey === (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).TASK) {
                this.update({
                    current_page_task: e.page
                });
                this.fetchDataTask();
            } else if (e.ckey === (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).ORE) {
                this.update({
                    current_page_ore: e.page
                });
                this.fetchDataOre();
            }
        },
        handleSortChange (e) {
            if (e.ckey === (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).TASK) {
                this.update({
                    sort_column_task: e.column,
                    sort_direction_task: e.direction,
                    current_page_task: 1 // Torna alla prima pagina
                });
                this.fetchDataTask();
            } else if (e.ckey === (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).ORE) this.update({
                sort_column_ore: e.column,
                sort_direction_ore: e.direction,
                current_page_ore: 1 // Torna alla prima pagina
            });
        },
        async fetchDataTask () {
            const { sort_column_task: sort_column_task, sort_direction_task: sort_direction_task, current_page_task: current_page_task, search_risorsa_task: search_risorsa_task, search_stato_task: search_stato_task, search_text_task: search_text_task } = this.state;
            const where = {};
            if (search_risorsa_task) where.risorsa = search_risorsa_task;
            if (search_stato_task) where.stato = search_stato_task;
            where.id_commessa = this.props.id_commessa;
            const result = await (0, $38b2f4a478272d56$export$2e2bcd8739ae039).fetchTask(sort_column_task, sort_direction_task, current_page_task, search_text_task, where);
            if (result.items) {
                this.update({
                    rows_task: result.items,
                    total_rows_task: result.total
                });
                (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).ITEMS.CHANGED, {
                    ckey: (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).TASK,
                    items: {
                        count: this.state.total_rows_task,
                        results: this.state.rows_task
                    },
                    page: this.state.current_page_task
                });
                (0, $6bfc5a82c63db877$export$7659d5ac17afd4e5)().then((stati)=>{
                    result.items.forEach((row)=>{
                        (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.UPDATE, {
                            ckey: `stato_${row.id}`,
                            items: stati
                        });
                    });
                });
            } else console.error('Errore nel caricamento dei dati:', result.error);
        },
        async fetchDataOre () {
            const { sort_column_ore: sort_column_ore, sort_direction_ore: sort_direction_ore, current_page_ore: current_page_ore, search_risorsa_ore: search_risorsa_ore, search_text_ore: search_text_ore } = this.state;
            const where = {};
            if (search_risorsa_ore) where.risorsa = search_risorsa_ore;
            where.id_commessa = this.props.id_commessa;
            const result = await (0, $38b2f4a478272d56$export$2e2bcd8739ae039).fetchOre(sort_column_ore, sort_direction_ore, current_page_ore, search_text_ore, where);
            if (result.items) {
                this.update({
                    rows_ore: result.items,
                    total_rows_ore: result.total
                });
                (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).ITEMS.CHANGED, {
                    ckey: (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).ORE,
                    items: {
                        count: this.state.total_rows_ore,
                        results: this.state.rows_ore
                    },
                    page: this.state.current_page_ore
                });
            } else console.error('Errore nel caricamento dei dati:', result.error);
        },
        filterTask (e) {
            e.preventDefault(); // Evita il refresh della pagina
            const filtroRisorsa = document.getElementById('filtro_risorsa_task')?.value || '';
            const filtroStato = document.getElementById('filtro_stato_task')?.value || '';
            const searchText = document.getElementById('search_text_task')?.value || '';
            // Aggiorna lo stato con i filtri attivi
            this.update({
                search_risorsa_task: filtroRisorsa,
                search_stato_task: filtroStato,
                search_text_task: searchText,
                current_page_task: 1 // Reset alla prima pagina
            });
            // Effettua una nuova query
            this.fetchDataTask();
        },
        filterOre (e) {
            e.preventDefault(); // Evita il refresh della pagina
            const filtroRisorsa = document.getElementById('filtro_risorsa_ore')?.value || '';
            const searchText = document.getElementById('search_text_ore')?.value || '';
            // Aggiorna lo stato con i filtri attivi
            this.update({
                search_risorsa_ore: filtroRisorsa,
                search_text_ore: searchText,
                current_page_ore: 1 // Reset alla prima pagina
            });
            // Effettua una nuova query
            this.fetchDataOre();
        },
        splitRisorsa (risorse) {
            if (typeof risorse === 'string' && risorse.includes('\r')) risorse = risorse.replace(/\r/g, ', ');
            return risorse;
        },
        formatDate (d) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($6641b049ad84b098$exports))).utc(d).local().format('DD/MM/YYYY');
        },
        setCurrentTab (e) {
            let tab = null;
            if (e instanceof Event) tab = e.target.value;
            else if (typeof e === 'string' || e instanceof String) tab = e;
            if (tab === (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).TASK) {
                (0, $6bfc5a82c63db877$export$e3ed16048dcc8c7c)().then((risorse)=>{
                    (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.UPDATE, {
                        ckey: 'filtro_risorsa_task',
                        items: risorse
                    });
                });
                (0, $6bfc5a82c63db877$export$7659d5ac17afd4e5)().then((stati)=>{
                    (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.UPDATE, {
                        ckey: 'filtro_stato_task',
                        items: stati
                    });
                });
                (0, $6bfc5a82c63db877$export$7659d5ac17afd4e5)().then((stati)=>{
                    this.state.rows_task.forEach((row)=>{
                        (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.UPDATE, {
                            ckey: `stato_${row.id}`,
                            items: stati
                        });
                    });
                });
            } else if (tab === (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).ORE) (0, $6bfc5a82c63db877$export$e3ed16048dcc8c7c)().then((risorse)=>{
                (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.UPDATE, {
                    ckey: 'filtro_risorsa_ore',
                    items: risorse
                });
            });
            this.update({
                currentTab: tab
            });
        },
        async saveTask (row) {
            const id = row.id;
            const stato = this.$('#stato_' + id).value;
            const result = await (0, $38b2f4a478272d56$export$2e2bcd8739ae039).saveTask(id, {
                stato: stato
            });
            if (result.success) {
                // puoi aggiornare direttamente lo stato locale se vuoi evitare un refetch
                row.stato = stato;
                this.update();
            } else {
                (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.OPEN_MODAL_ERROR, {
                    ckey: "error",
                    title: "Errore nel salvataggio del task",
                    text: result.error
                });
                console.error(`\u{274C} Errore nel salvataggio: ${result.error}`);
            }
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<div class="bg-cyan-700 text-white rounded-lg p-8 mt-5"><div class="mt-6 flex flex-col gap-x-8 gap-y-20 lg:flex-row"><div class="lg:flex-1"><h2 class="text-lg font-bold flex gap-2 items-center"><span expr20="expr20"> </span><span expr21="expr21" class="font-medium text-black"> </span><img expr22="expr22"/></h2><h1 expr23="expr23" class="mt-2 text-2xl font-bold tracking-tight sm:text-3xl text-cyan-100"> </h1><h3 class="mt-2 text-lg flex gap-2 items-center text-black"><span expr24="expr24" class="font-black"> </span><span>/</span><span expr25="expr25" class="font-base"> </span></h3><p expr26="expr26" class="mt-8 text-base font-medium text-pretty"></p><p expr27="expr27" class="mt-4 text-base font-medium text-pretty"></p></div><div class="lg:flex lg:flex-none lg:justify-center"><dl class="w-64 space-y-8 xl:w-96 divide-y divide-cyan-200"><div class="px-4 py-1 mb-1 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-0"><dt class="text-sm font-cyan-50">Data di scadenza</dt><dd expr28="expr28" class="text-sm font-bold text-end"> </dd></div><div class="px-4 py-1 mb-1 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-0"><dt class="text-sm font-cyan-50">Account di riferimento</dt><dd expr29="expr29" class="text-sm font-semibold text-end"> </dd></div><div class="px-4 py-1 mb-1 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-0"><dt class="text-sm font-cyan-50">Risorse assegnate</dt><dd expr30="expr30" class="text-sm font-semibold text-end"> </dd></div><div class="px-4 py-1 mt-6 mb-1 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-0"><dt class="text-sm font-cyan-50"></dt><dd class="text-sm font-semibold text-end"><progress-bar expr31="expr31" ckey="perc_ore"></progress-bar><div expr32="expr32" class="pt-1"> <div expr33="expr33" class="text-black font-medium"> </div></div></dd></div></dl></div></div></div><div class="bg-white rounded-lg p-8 mt-5"><div class="mb-6"><div class="grid grid-cols-1 sm:hidden"><select expr34="expr34" class="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pr-8 pl-3 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"><option expr35="expr35">Task</option><option expr36="expr36">Ore</option></select><svg class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-500" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" data-slot="icon"><path fill-rule="evenodd" d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"/></svg></div><div class="hidden sm:block"><div class="border-b border-gray-200"><nav class="-mb-px flex space-x-8" aria-label="Tabs"><span expr37="expr37"><svg expr38="expr38" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"/></svg><span>Task</span></span><span expr39="expr39" "><svg expr40="expr40" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/></svg><span>Ore</span></span></nav></div></div></div><div expr41="expr41"></div><div expr51="expr51"></div><modal-delete expr59="expr59"></modal-delete><modal-ore expr60="expr60"></modal-ore><modal-result expr61="expr61"></modal-result><modal-error expr62="expr62"></modal-error></div>', [
            {
                redundantAttribute: 'expr20',
                selector: '[expr20]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>_scope.state.commessa ? _scope.state.commessa.numero : ''
                    }
                ]
            },
            {
                redundantAttribute: 'expr21',
                selector: '[expr21]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>[
                                'del ',
                                _scope.state.commessa && _scope.state.commessa.data ? _scope.formatDate(_scope.state.commessa.data) : ''
                            ].join('')
                    }
                ]
            },
            {
                redundantAttribute: 'expr22',
                selector: '[expr22]',
                expressions: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'src',
                        evaluate: (_scope)=>_scope.state.commessa && _scope.state.commessa.societa ? _scope.getLogo(_scope.state.commessa.societa) : ''
                    }
                ]
            },
            {
                redundantAttribute: 'expr23',
                selector: '[expr23]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>_scope.state.commessa ? _scope.state.commessa.titolo.length ? _scope.state.commessa.titolo : '' : 'Caricamento commessa in corso...'
                    }
                ]
            },
            {
                redundantAttribute: 'expr24',
                selector: '[expr24]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>_scope.state.commessa && _scope.state.commessa.cliente ? _scope.state.commessa.cliente : ''
                    }
                ]
            },
            {
                redundantAttribute: 'expr25',
                selector: '[expr25]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>_scope.state.commessa && _scope.state.commessa.categoria ? _scope.state.commessa.categoria : '-'
                    }
                ]
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.state.commessa && _scope.state.commessa.descrizione,
                redundantAttribute: 'expr26',
                selector: '[expr26]',
                template: template('<strong>DESCRIZIONE</strong><br/> ', [
                    {
                        expressions: [
                            {
                                type: expressionTypes.TEXT,
                                childNodeIndex: 2,
                                evaluate: (_scope)=>[
                                        _scope.state.commessa ? _scope.state.commessa.descrizione : ''
                                    ].join('')
                            }
                        ]
                    }
                ])
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.state.commessa && _scope.state.commessa.brief,
                redundantAttribute: 'expr27',
                selector: '[expr27]',
                template: template('<strong>BRIEF</strong><br/> ', [
                    {
                        expressions: [
                            {
                                type: expressionTypes.TEXT,
                                childNodeIndex: 2,
                                evaluate: (_scope)=>[
                                        _scope.state.commessa && _scope.state.commessa.brief
                                    ].join('')
                            }
                        ]
                    }
                ])
            },
            {
                redundantAttribute: 'expr28',
                selector: '[expr28]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>_scope.state.commessa && _scope.state.commessa.dataScadenza ? _scope.formatDate(_scope.state.commessa.dataScadenza) : '-'
                    }
                ]
            },
            {
                redundantAttribute: 'expr29',
                selector: '[expr29]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>_scope.state.commessa && _scope.state.commessa.account ? _scope.state.commessa.account : '-'
                    }
                ]
            },
            {
                redundantAttribute: 'expr30',
                selector: '[expr30]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>_scope.state.commessa && _scope.state.commessa.risorsa ? _scope.splitRisorsa(_scope.state.commessa.risorsa) : '-'
                    }
                ]
            },
            {
                type: bindingTypes.TAG,
                getComponent: getComponent,
                evaluate: (_scope)=>'progress-bar',
                slots: [],
                attributes: [],
                redundantAttribute: 'expr31',
                selector: '[expr31]'
            },
            {
                redundantAttribute: 'expr32',
                selector: '[expr32]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>[
                                _scope.state.commessa && _scope.state.commessa.oreTotali ? _scope.state.commessa.oreTotali : '0',
                                'h / ',
                                _scope.state.commessa && _scope.state.commessa.orePreventivate ? _scope.state.commessa.orePreventivate : '0',
                                'h'
                            ].join('')
                    }
                ]
            },
            {
                redundantAttribute: 'expr33',
                selector: '[expr33]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>_scope.state.commessa && _scope.state.commessa.deltaOre ? 'differenza: ' + _scope.state.commessa.deltaOre + 'h' : ''
                    }
                ]
            },
            {
                redundantAttribute: 'expr34',
                selector: '[expr34]',
                expressions: [
                    {
                        type: expressionTypes.EVENT,
                        name: 'onchange',
                        evaluate: (_scope)=>_scope.setCurrentTab.bind(_scope)
                    }
                ]
            },
            {
                redundantAttribute: 'expr35',
                selector: '[expr35]',
                expressions: [
                    {
                        type: expressionTypes.VALUE,
                        evaluate: (_scope)=>_scope.KEYS.TASK
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: true,
                        name: 'selected',
                        evaluate: (_scope)=>_scope.state.currentTab == _scope.KEYS.TASK
                    }
                ]
            },
            {
                redundantAttribute: 'expr36',
                selector: '[expr36]',
                expressions: [
                    {
                        type: expressionTypes.VALUE,
                        evaluate: (_scope)=>_scope.KEYS.ORE
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: true,
                        name: 'selected',
                        evaluate: (_scope)=>_scope.state.currentTab == _scope.KEYS.ORE
                    }
                ]
            },
            {
                redundantAttribute: 'expr37',
                selector: '[expr37]',
                expressions: [
                    {
                        type: expressionTypes.EVENT,
                        name: 'onclick',
                        evaluate: (_scope)=>_scope.setCurrentTab.bind(_scope, _scope.KEYS.TASK)
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'class',
                        evaluate: (_scope)=>[
                                'cursor-pointer group inline-flex items-center border-b-2 px-1 py-4 text-lg font-medium ',
                                _scope.state.currentTab == _scope.KEYS.TASK ? 'border-cyan-500 text-cyan-600' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                            ].join('')
                    }
                ]
            },
            {
                redundantAttribute: 'expr38',
                selector: '[expr38]',
                expressions: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'class',
                        evaluate: (_scope)=>[
                                'size-6 ',
                                _scope.state.currentTab == 'task' ? 'text-cyan-500' : 'text-gray-400 group-hover:text-gray-500'
                            ].join('')
                    }
                ]
            },
            {
                redundantAttribute: 'expr39',
                selector: '[expr39]',
                expressions: [
                    {
                        type: expressionTypes.EVENT,
                        name: 'onclick',
                        evaluate: (_scope)=>_scope.setCurrentTab.bind(_scope, _scope.KEYS.ORE)
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'class',
                        evaluate: (_scope)=>[
                                'cursor-pointer group inline-flex items-center border-b-2 px-1 py-4 text-lg font-medium ',
                                _scope.state.currentTab == _scope.KEYS.ORE ? 'border-cyan-500 text-cyan-600' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                            ].join('')
                    }
                ]
            },
            {
                redundantAttribute: 'expr40',
                selector: '[expr40]',
                expressions: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'class',
                        evaluate: (_scope)=>[
                                'size-6 ',
                                _scope.state.currentTab == 'ore' ? 'text-cyan-500' : 'text-gray-400 group-hover:text-gray-500'
                            ].join('')
                    }
                ]
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.state.currentTab == _scope.KEYS.TASK,
                redundantAttribute: 'expr41',
                selector: '[expr41]',
                template: template('<div class="flex justify-end"><div class="filters"><form expr42="expr42" class="flex gap-4 items-center" method="POST"><combobox expr43="expr43" label ckey="filtro_risorsa_task" placeholder="Filtra per risorsa..."></combobox><combobox expr44="expr44" label ckey="filtro_stato_task" placeholder="Filtra per stato..."></combobox><input-text expr45="expr45" ckey="search_text" placeholder="Cerca..."></input-text><my-button expr46="expr46" type="submit" is_square="1"></my-button></form></div></div><generic-table expr47="expr47" condensed="1"></generic-table>', [
                    {
                        redundantAttribute: 'expr42',
                        selector: '[expr42]',
                        expressions: [
                            {
                                type: expressionTypes.EVENT,
                                name: 'onsubmit',
                                evaluate: (_scope)=>_scope.filterTask
                            }
                        ]
                    },
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'combobox',
                        slots: [],
                        attributes: [],
                        redundantAttribute: 'expr43',
                        selector: '[expr43]'
                    },
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'combobox',
                        slots: [],
                        attributes: [],
                        redundantAttribute: 'expr44',
                        selector: '[expr44]'
                    },
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'input-text',
                        slots: [],
                        attributes: [],
                        redundantAttribute: 'expr45',
                        selector: '[expr45]'
                    },
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'my-button',
                        slots: [
                            {
                                id: 'default',
                                html: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"/></svg>',
                                bindings: []
                            }
                        ],
                        attributes: [],
                        redundantAttribute: 'expr46',
                        selector: '[expr46]'
                    },
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'generic-table',
                        slots: [
                            {
                                id: 'editable',
                                html: '<div expr48="expr48"></div>',
                                bindings: [
                                    {
                                        type: bindingTypes.IF,
                                        evaluate: (_scope)=>_scope.column.field === 'stato',
                                        redundantAttribute: 'expr48',
                                        selector: '[expr48]',
                                        template: template('<combobox expr49="expr49" label></combobox>', [
                                            {
                                                type: bindingTypes.TAG,
                                                getComponent: getComponent,
                                                evaluate: (_scope)=>'combobox',
                                                slots: [],
                                                attributes: [
                                                    {
                                                        type: expressionTypes.ATTRIBUTE,
                                                        isBoolean: false,
                                                        name: 'ckey',
                                                        evaluate: (_scope)=>[
                                                                'stato_',
                                                                _scope.row.id
                                                            ].join('')
                                                    },
                                                    {
                                                        type: expressionTypes.ATTRIBUTE,
                                                        isBoolean: false,
                                                        name: 'value',
                                                        evaluate: (_scope)=>_scope.row.stato
                                                    }
                                                ],
                                                redundantAttribute: 'expr49',
                                                selector: '[expr49]'
                                            }
                                        ])
                                    }
                                ]
                            },
                            {
                                id: 'actions',
                                html: '<my-button expr50="expr50" slot="actions" type="button"></my-button>',
                                bindings: [
                                    {
                                        type: bindingTypes.TAG,
                                        getComponent: getComponent,
                                        evaluate: (_scope)=>'my-button',
                                        slots: [
                                            {
                                                id: 'default',
                                                html: 'Salva',
                                                bindings: []
                                            }
                                        ],
                                        attributes: [
                                            {
                                                type: expressionTypes.ATTRIBUTE,
                                                isBoolean: false,
                                                name: 'ckey',
                                                evaluate: (_scope)=>_scope.KEYS.ORE
                                            },
                                            {
                                                type: expressionTypes.ATTRIBUTE,
                                                isBoolean: false,
                                                name: 'row',
                                                evaluate: (_scope)=>_scope.row
                                            },
                                            {
                                                type: expressionTypes.EVENT,
                                                name: 'onclick',
                                                evaluate: (_scope)=>_scope.saveTask.bind(_scope, _scope.row)
                                            }
                                        ],
                                        redundantAttribute: 'expr50',
                                        selector: '[expr50]'
                                    }
                                ]
                            }
                        ],
                        attributes: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'ckey',
                                evaluate: (_scope)=>_scope.KEYS.TASK
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'columns',
                                evaluate: (_scope)=>_scope.state.columns_task
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'rows',
                                evaluate: (_scope)=>_scope.state.rows_task
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'total_rows',
                                evaluate: (_scope)=>_scope.state.total_rows_task
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'page_size',
                                evaluate: (_scope)=>_scope.state.page_size
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'current_page',
                                evaluate: (_scope)=>_scope.state.current_page_task
                            }
                        ],
                        redundantAttribute: 'expr47',
                        selector: '[expr47]'
                    }
                ])
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.state.currentTab == _scope.KEYS.ORE,
                redundantAttribute: 'expr51',
                selector: '[expr51]',
                template: template('<div class="flex justify-between"><div class="add"><my-button expr52="expr52" type="button"></my-button></div><div class="filters"><form expr53="expr53" class="flex gap-4 items-center" method="POST"><combobox expr54="expr54" label ckey="filtro_risorsa_ore" placeholder="Filtra per risorsa..."></combobox><input-text expr55="expr55" ckey="search_text" placeholder="Cerca..."></input-text><my-button expr56="expr56" type="submit" is_square="1"></my-button></form></div></div><generic-table expr57="expr57" condensed="1"></generic-table>', [
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'my-button',
                        slots: [
                            {
                                id: 'default',
                                html: 'Aggiungi <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"/></svg>',
                                bindings: []
                            }
                        ],
                        attributes: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'ckey',
                                evaluate: (_scope)=>_scope.KEYS.ORE
                            },
                            {
                                type: expressionTypes.EVENT,
                                name: 'onclick',
                                evaluate: (_scope)=>_scope.create.bind(_scope, {
                                        ckey: _scope.KEYS.ORE
                                    })
                            }
                        ],
                        redundantAttribute: 'expr52',
                        selector: '[expr52]'
                    },
                    {
                        redundantAttribute: 'expr53',
                        selector: '[expr53]',
                        expressions: [
                            {
                                type: expressionTypes.EVENT,
                                name: 'onsubmit',
                                evaluate: (_scope)=>_scope.filterOre
                            }
                        ]
                    },
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'combobox',
                        slots: [],
                        attributes: [],
                        redundantAttribute: 'expr54',
                        selector: '[expr54]'
                    },
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'input-text',
                        slots: [],
                        attributes: [],
                        redundantAttribute: 'expr55',
                        selector: '[expr55]'
                    },
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'my-button',
                        slots: [
                            {
                                id: 'default',
                                html: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"/></svg>',
                                bindings: []
                            }
                        ],
                        attributes: [],
                        redundantAttribute: 'expr56',
                        selector: '[expr56]'
                    },
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'generic-table',
                        slots: [
                            {
                                id: 'actions',
                                html: '<button-group expr58="expr58" slot="actions"></button-group>',
                                bindings: [
                                    {
                                        type: bindingTypes.TAG,
                                        getComponent: getComponent,
                                        evaluate: (_scope)=>'button-group',
                                        slots: [],
                                        attributes: [
                                            {
                                                type: expressionTypes.ATTRIBUTE,
                                                isBoolean: false,
                                                name: 'ckey',
                                                evaluate: (_scope)=>_scope.KEYS.ORE
                                            },
                                            {
                                                type: expressionTypes.ATTRIBUTE,
                                                isBoolean: false,
                                                name: 'row',
                                                evaluate: (_scope)=>_scope.row
                                            },
                                            {
                                                type: expressionTypes.ATTRIBUTE,
                                                isBoolean: false,
                                                name: 'options',
                                                evaluate: (_scope)=>[
                                                        {
                                                            label: 'Modifica riga',
                                                            action: _scope.ACTIONS.EDIT
                                                        },
                                                        {
                                                            label: 'Elimina riga',
                                                            action: _scope.ACTIONS.DELETE
                                                        }
                                                    ]
                                            }
                                        ],
                                        redundantAttribute: 'expr58',
                                        selector: '[expr58]'
                                    }
                                ]
                            }
                        ],
                        attributes: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'ckey',
                                evaluate: (_scope)=>_scope.KEYS.ORE
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'columns',
                                evaluate: (_scope)=>_scope.state.columns_ore
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'rows',
                                evaluate: (_scope)=>_scope.state.rows_ore
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'total_rows',
                                evaluate: (_scope)=>_scope.state.total_rows_ore
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'page_size',
                                evaluate: (_scope)=>_scope.state.page_size
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'current_page',
                                evaluate: (_scope)=>_scope.state.current_page_ore
                            }
                        ],
                        redundantAttribute: 'expr57',
                        selector: '[expr57]'
                    }
                ])
            },
            {
                type: bindingTypes.TAG,
                getComponent: getComponent,
                evaluate: (_scope)=>'modal-delete',
                slots: [],
                attributes: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'ckey',
                        evaluate: (_scope)=>_scope.KEYS.ORE
                    }
                ],
                redundantAttribute: 'expr59',
                selector: '[expr59]'
            },
            {
                type: bindingTypes.TAG,
                getComponent: getComponent,
                evaluate: (_scope)=>'modal-ore',
                slots: [],
                attributes: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'ckey',
                        evaluate: (_scope)=>_scope.KEYS.ORE
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'id_commessa',
                        evaluate: (_scope)=>_scope.props.id_commessa
                    }
                ],
                redundantAttribute: 'expr60',
                selector: '[expr60]'
            },
            {
                type: bindingTypes.TAG,
                getComponent: getComponent,
                evaluate: (_scope)=>'modal-result',
                slots: [],
                attributes: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'ckey',
                        evaluate: (_scope)=>_scope.KEYS.ORE
                    }
                ],
                redundantAttribute: 'expr61',
                selector: '[expr61]'
            },
            {
                type: bindingTypes.TAG,
                getComponent: getComponent,
                evaluate: (_scope)=>'modal-error',
                slots: [],
                attributes: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'ckey',
                        evaluate: (_scope)=>_scope.KEYS.COMMESSA
                    }
                ],
                redundantAttribute: 'expr62',
                selector: '[expr62]'
            }
        ]),
    name: 'commessa'
};


var $fced7872121cab9a$exports = {};

$parcel$defineInteropFlag($fced7872121cab9a$exports);

$parcel$export($fced7872121cab9a$exports, "default", () => $fced7872121cab9a$export$2e2bcd8739ae039);





var $fced7872121cab9a$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        ACTIONS: (0, $315dbc24fdcb29cb$export$92a1a3b7554e9387),
        KEYS: (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92),
        onBeforeMount (props, state) {
            this.state = {
                columns: [
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: "Commessa n\xb0",
                        field: 'numero',
                        is_sortable: true,
                        is_link: true,
                        link_prefix: '#/commesse',
                        key_field: 'id_commessa'
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: "Societ\xe0",
                        field: 'societa',
                        is_sortable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: 'Stato',
                        field: 'stato',
                        is_sortable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).DATE,
                        label: 'Data limite',
                        field: 'data',
                        is_sortable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: 'Cliente',
                        field: 'cliente',
                        is_sortable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: 'Titolo',
                        field: 'titolo',
                        is_wrappable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: 'Descrizione',
                        field: 'descrizione',
                        is_wrappable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: 'Risorse',
                        field: 'risorsa'
                    }
                ],
                rows: [],
                total_rows: 0,
                current_page: 1,
                page_size: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).N_ITEMS,
                sort_column: 'numero',
                sort_direction: 'desc',
                search_risorsa: '',
                search_stato: '',
                search_societa: '',
                search_text: ''
            };
            //eventBus.on(EVENTS.COMBOBOX.SELECTED, this.handleComboboxSelected)
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.CHANGE_PAGE, this.handlePageChange);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.SORTING_CHANGE, this.handleSortChange);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.CLICK_BUTTON_GROUP, this.handleClickAction);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).ITEMS.REFRESH, this.handleRefresh);
        },
        async onMounted (props, state) {
            (0, $6bfc5a82c63db877$export$e3ed16048dcc8c7c)().then((risorse)=>{
                (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.UPDATE, {
                    ckey: 'filtro_risorsa',
                    items: risorse
                });
            });
            (0, $6bfc5a82c63db877$export$42dace949d12e843)().then((stati)=>{
                (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.UPDATE, {
                    ckey: 'filtro_stato',
                    items: stati
                });
            });
            (0, $6bfc5a82c63db877$export$9d5b4a605e86f953)().then((societa)=>{
                (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.UPDATE, {
                    ckey: 'filtro_societa',
                    items: societa
                });
            });
            this.fetchData();
        },
        onBeforeUnmount (props, state) {
            //eventBus.off(EVENTS.COMBOBOX.SELECTED, this.handleComboboxSelected)
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.CHANGE_PAGE, this.handlePageChange);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.SORTING_CHANGE, this.handleSortChange);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.CLICK_BUTTON_GROUP, this.handleClickAction);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).ITEMS.REFRESH, this.handleRefresh);
        },
        /*
     handleComboboxSelected(e) {
     switch (e.ckey) {
     case 'filtro_stato':
     this.update({
     search_stato: e.value
     })
     break
     case 'filtro_risorsa':
     this.update({
     search_risorsa: e.value
     })
     break
     }
     },
     */ handleRefresh (e) {
            if (e.ckey === (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).COMMESSE) this.fetchData();
        },
        handleClickAction (e) {
            if (e.ckey === (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).COMMESSE) switch(e.action){
                case (0, $315dbc24fdcb29cb$export$92a1a3b7554e9387).EDIT:
                    break;
            }
        },
        handlePageChange (e) {
            if (e.ckey === (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).COMMESSE) {
                this.update({
                    current_page: e.page
                });
                this.fetchData();
            }
        },
        handleSortChange (e) {
            if (e.ckey === (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).COMMESSE) {
                this.update({
                    sort_column: e.column,
                    sort_direction: e.direction,
                    current_page: 1 // Torna alla prima pagina
                });
                this.fetchData();
            }
        },
        async fetchData () {
            const { sort_column: sort_column, sort_direction: sort_direction, current_page: current_page, search_risorsa: search_risorsa, search_stato: search_stato, search_societa: search_societa, search_text: search_text } = this.state;
            const where = {};
            if (search_risorsa) where.risorsa = search_risorsa;
            if (search_stato) where.stato = search_stato;
            if (search_societa) where.societa = search_societa;
            const result = await (0, $38b2f4a478272d56$export$2e2bcd8739ae039).fetchCommesse(sort_column, sort_direction, current_page, search_text, where);
            if (result.items) {
                this.update({
                    rows: result.items,
                    total_rows: result.total
                });
                (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).ITEMS.CHANGED, {
                    ckey: (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).COMMESSE,
                    items: {
                        count: this.state.total_rows,
                        results: this.state.rows
                    },
                    page: this.state.current_page
                });
            } else console.error('Errore nel caricamento dei dati:', result.error);
        },
        filter (e) {
            e.preventDefault(); // Evita il refresh della pagina
            const filtroRisorsa = document.getElementById('filtro_risorsa')?.value || '';
            const filtroStato = document.getElementById('filtro_stato')?.value || '';
            const filtroSocieta = document.getElementById('filtro_societa')?.value || '';
            const searchText = document.getElementById('search_text')?.value || '';
            // Aggiorna lo stato con i filtri attivi
            this.update({
                search_risorsa: filtroRisorsa,
                search_stato: filtroStato,
                search_societa: filtroSocieta,
                search_text: searchText,
                current_page: 1 // Reset alla prima pagina
            });
            // Effettua una nuova query
            this.fetchData();
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<div class="bg-white rounded-lg p-8 mt-5"><div class="flex justify-between"><h2 class="text-2xl/8 font-bold text-custom sm:truncate sm:text-3xl sm:tracking-tight">Commesse</h2><div class="filters"><form expr44="expr44" class="flex gap-4 items-center" method="POST"><combobox expr45="expr45" label ckey="filtro_societa" placeholder="Filtra per societ\xe0..."></combobox><combobox expr46="expr46" label ckey="filtro_risorsa" placeholder="Filtra per risorsa..."></combobox><combobox expr47="expr47" label ckey="filtro_stato" placeholder="Filtra per stato..."></combobox><input-text expr48="expr48" ckey="search_text" placeholder="Cerca..."></input-text><my-button expr49="expr49" type="submit" is_square="1"></my-button></form></div></div><generic-table expr50="expr50" condensed="1"></generic-table></div>', [
            {
                redundantAttribute: 'expr44',
                selector: '[expr44]',
                expressions: [
                    {
                        type: expressionTypes.EVENT,
                        name: 'onsubmit',
                        evaluate: (_scope)=>_scope.filter
                    }
                ]
            },
            {
                type: bindingTypes.TAG,
                getComponent: getComponent,
                evaluate: (_scope)=>'combobox',
                slots: [],
                attributes: [],
                redundantAttribute: 'expr45',
                selector: '[expr45]'
            },
            {
                type: bindingTypes.TAG,
                getComponent: getComponent,
                evaluate: (_scope)=>'combobox',
                slots: [],
                attributes: [],
                redundantAttribute: 'expr46',
                selector: '[expr46]'
            },
            {
                type: bindingTypes.TAG,
                getComponent: getComponent,
                evaluate: (_scope)=>'combobox',
                slots: [],
                attributes: [],
                redundantAttribute: 'expr47',
                selector: '[expr47]'
            },
            {
                type: bindingTypes.TAG,
                getComponent: getComponent,
                evaluate: (_scope)=>'input-text',
                slots: [],
                attributes: [],
                redundantAttribute: 'expr48',
                selector: '[expr48]'
            },
            {
                type: bindingTypes.TAG,
                getComponent: getComponent,
                evaluate: (_scope)=>'my-button',
                slots: [
                    {
                        id: 'default',
                        html: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"/></svg>',
                        bindings: []
                    }
                ],
                attributes: [],
                redundantAttribute: 'expr49',
                selector: '[expr49]'
            },
            {
                type: bindingTypes.TAG,
                getComponent: getComponent,
                evaluate: (_scope)=>'generic-table',
                slots: [
                    {
                        id: 'actions',
                        html: '<span slot="actions"></span>',
                        bindings: []
                    }
                ],
                attributes: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'ckey',
                        evaluate: (_scope)=>_scope.KEYS.COMMESSE
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'columns',
                        evaluate: (_scope)=>_scope.state.columns
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'rows',
                        evaluate: (_scope)=>_scope.state.rows
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'total_rows',
                        evaluate: (_scope)=>_scope.state.total_rows
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'page_size',
                        evaluate: (_scope)=>_scope.state.page_size
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'current_page',
                        evaluate: (_scope)=>_scope.state.current_page
                    }
                ],
                redundantAttribute: 'expr50',
                selector: '[expr50]'
            }
        ]),
    name: 'commesse'
};


var $fde500233e5dd9c4$exports = {};

$parcel$defineInteropFlag($fde500233e5dd9c4$exports);

$parcel$export($fde500233e5dd9c4$exports, "default", () => $fde500233e5dd9c4$export$2e2bcd8739ae039);

var $fde500233e5dd9c4$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        async onMounted (props, state) {
            const progetto_id = this.props.progetto_id;
            const progetto = await (0, $38b2f4a478272d56$export$2e2bcd8739ae039).fetchProgettoById(progetto_id);
            // Se esiste un file CSS, iniettalo
            if (progetto && progetto.get('css')) this.injectCss(progetto.get('css').url());
        },
        injectCss (url) {
            // Rimuove eventuali stili precedenti
            const existingLink = document.getElementById('custom-css');
            let current_href = '';
            if (existingLink) {
                const current_href = existingLink.href;
                if (current_href != url) existingLink.href = url;
            } else {
                const link = document.createElement('link');
                link.id = 'custom-css';
                link.rel = 'stylesheet';
                link.type = 'text/css';
                link.href = url;
                link.media = 'all';
                document.head.appendChild(link);
            }
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template(null, [
            {
                expressions: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'class',
                        evaluate: (_scope)=>'px-1 py-1'
                    }
                ]
            }
        ]),
    name: 'css-switcher'
};


var $a4ad69f5498324d5$exports = {};

$parcel$defineInteropFlag($a4ad69f5498324d5$exports);

$parcel$export($a4ad69f5498324d5$exports, "default", () => $a4ad69f5498324d5$export$2e2bcd8739ae039);



var $a4ad69f5498324d5$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        CONFIG: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5),
        onBeforeMount (props, state) {
            this.state = {
                columns: props.columns
            };
        },
        handleSort (is_sortable, field, sortField) {
            if (is_sortable) {
                const newDirection = this.state.columns.find((c)=>c.field === field)?.sort_direction === 'asc' ? 'desc' : 'asc';
                // Aggiorna lo stato delle colonne
                const updatedColumns = this.state.columns.map((column)=>({
                        ...column,
                        sort_direction: column.field === field ? newDirection : null
                    }));
                this.update({
                    columns: updatedColumns
                });
                // Trigger dell'evento per il genitore
                (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.SORTING_CHANGE, {
                    ckey: this.props.ckey,
                    column: sortField || field,
                    direction: newDirection
                });
            }
        },
        getCellValue (row, column) {
            let value = row[column.field];
            // Format date columns
            if ((0, $315dbc24fdcb29cb$export$1630b5343357e8b5).DATE === column.type && value) return (0, (/*@__PURE__*/$parcel$interopDefault($6641b049ad84b098$exports))).utc(value).local().format('DD/MM/YYYY');
            else if ((0, $315dbc24fdcb29cb$export$1630b5343357e8b5).DATETIME === column.type && value) return (0, (/*@__PURE__*/$parcel$interopDefault($6641b049ad84b098$exports))).utc(value).local().format('DD/MM/YYYY HH:mm');
            // 🧠 Se il valore è una stringa e contiene \r, sostituire con <br>
            if (typeof value === 'string' && value.includes('\r')) value = value.replace(/\r/g, '<br>');
            if (typeof value === 'string' && value.includes('\n')) value = value.replace(/\n/g, '<br>');
            // 🔗 Se la colonna è is_link, costruisco il link corretto
            if (column.is_link && value) {
                const currentRoute = window.location.hash.split('/')[1] || '';
                const basePath = `#/${currentRoute}`;
                const linkPrefix = column.link_prefix || basePath;
                const key_field = column.key_field || 'id';
                value = `<a href="${linkPrefix}/${row[key_field]}" class="text-cyan-600 hover:text-cyan-800 font-bold">${value}</a>`;
            }
            const result = value !== undefined ? value : '';
            return result;
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<div class="mt-8 flow-root generic-table"><div class="-mx-4 -my-2 sm:-mx-6 lg:-mx-8"><div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8"><table class="table-auto min-w-full divide-y divide-gray-300"><thead><tr><th expr30="expr30" scope="col"></th><th class="relative py-3.5 pr-4 pl-3 text-right text-sm sm:pr-0"></th></tr></thead><tbody class="bg-white divide-y divide-gray-200"><tr expr36="expr36" class="even:bg-gray-50"></tr></tbody></table></div></div><div class="mt-4"><pagination expr43="expr43"></pagination></div></div>', [
            {
                type: bindingTypes.EACH,
                getKey: null,
                condition: null,
                template: template('<div expr31="expr31"></div><my-checkbox expr35="expr35" value="*"></my-checkbox>', [
                    {
                        expressions: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'class',
                                evaluate: (_scope)=>[
                                        _scope.index == 0 ? 'pr-3 pl-4 sm:pl-0' : 'px-3',
                                        ' py-3.5 text-left text-sm font-semibold text-gray-900'
                                    ].join('')
                            }
                        ]
                    },
                    {
                        type: bindingTypes.IF,
                        evaluate: (_scope)=>_scope.CONFIG.CHECKBOX != _scope.column.type,
                        redundantAttribute: 'expr31',
                        selector: '[expr31]',
                        template: template(' <svg expr32="expr32" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4"></svg>', [
                            {
                                expressions: [
                                    {
                                        type: expressionTypes.TEXT,
                                        childNodeIndex: 0,
                                        evaluate: (_scope)=>[
                                                _scope.column.label
                                            ].join('')
                                    },
                                    {
                                        type: expressionTypes.ATTRIBUTE,
                                        isBoolean: false,
                                        name: 'class',
                                        evaluate: (_scope)=>[
                                                'flex items-center justify-between whitespace-nowrap ',
                                                _scope.column.is_sortable ? 'cursor-pointer' : ''
                                            ].join('')
                                    },
                                    {
                                        type: expressionTypes.EVENT,
                                        name: 'onclick',
                                        evaluate: (_scope)=>()=>_scope.handleSort(_scope.column.is_sortable, _scope.column.field, _scope.column.sort_field)
                                    }
                                ]
                            },
                            {
                                type: bindingTypes.IF,
                                evaluate: (_scope)=>_scope.column.is_sortable,
                                redundantAttribute: 'expr32',
                                selector: '[expr32]',
                                template: template('<path expr33="expr33" d="M12 4l-6 8h12l-6-8z"/><path expr34="expr34" d="M12 20l-6-8h12l-6 8z"/>', [
                                    {
                                        type: bindingTypes.IF,
                                        evaluate: (_scope)=>_scope.column.sort_direction === 'asc',
                                        redundantAttribute: 'expr33',
                                        selector: '[expr33]',
                                        template: template(null, [])
                                    },
                                    {
                                        type: bindingTypes.IF,
                                        evaluate: (_scope)=>_scope.column.sort_direction === 'desc',
                                        redundantAttribute: 'expr34',
                                        selector: '[expr34]',
                                        template: template(null, [])
                                    }
                                ])
                            }
                        ])
                    },
                    {
                        type: bindingTypes.IF,
                        evaluate: (_scope)=>_scope.CONFIG.CHECKBOX == _scope.column.type,
                        redundantAttribute: 'expr35',
                        selector: '[expr35]',
                        template: template(null, [
                            {
                                type: bindingTypes.TAG,
                                getComponent: getComponent,
                                evaluate: (_scope)=>'my-checkbox',
                                slots: [],
                                attributes: [
                                    {
                                        type: expressionTypes.ATTRIBUTE,
                                        isBoolean: false,
                                        name: 'ckey',
                                        evaluate: (_scope)=>_scope.props.ckey
                                    },
                                    {
                                        type: expressionTypes.ATTRIBUTE,
                                        isBoolean: false,
                                        name: 'checked',
                                        evaluate: (_scope)=>_scope.props.all_selected
                                    }
                                ]
                            }
                        ])
                    }
                ]),
                redundantAttribute: 'expr30',
                selector: '[expr30]',
                itemName: 'column',
                indexName: 'index',
                evaluate: (_scope)=>_scope.state.columns
            },
            {
                type: bindingTypes.EACH,
                getKey: null,
                condition: null,
                template: template('<td expr37="expr37"></td><td class="relative py-4 pr-4 pl-3 text-right text-sm font-medium whitespace-nowrap sm:pr-0"><slot expr42="expr42" name="actions"></slot></td>', [
                    {
                        expressions: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'data_id',
                                evaluate: (_scope)=>_scope.row.id
                            }
                        ]
                    },
                    {
                        type: bindingTypes.EACH,
                        getKey: null,
                        condition: null,
                        template: template('<div expr38="expr38"></div><my-checkbox expr40="expr40"></my-checkbox><slot expr41="expr41" name="editable"></slot>', [
                            {
                                expressions: [
                                    {
                                        type: expressionTypes.ATTRIBUTE,
                                        isBoolean: false,
                                        name: 'class',
                                        evaluate: (_scope)=>[
                                                _scope.index == 0 ? 'pr-3 pl-4 sm:pl-0 font-medium text-gray-900' : ' text-gray-500 px-3',
                                                ' py-4 text-sm ',
                                                _scope.column.is_wrappable ? '' : 'whitespace-nowrap'
                                            ].join('')
                                    }
                                ]
                            },
                            {
                                type: bindingTypes.IF,
                                evaluate: (_scope)=>_scope.CONFIG.CHECKBOX != _scope.column.type && _scope.CONFIG.EDITABLE != _scope.column.type,
                                redundantAttribute: 'expr38',
                                selector: '[expr38]',
                                template: template('<raw expr39="expr39"></raw>', [
                                    {
                                        type: bindingTypes.TAG,
                                        getComponent: getComponent,
                                        evaluate: (_scope)=>'raw',
                                        slots: [],
                                        attributes: [
                                            {
                                                type: expressionTypes.ATTRIBUTE,
                                                isBoolean: false,
                                                name: 'html',
                                                evaluate: (_scope)=>_scope.getCellValue(_scope.row, _scope.column)
                                            }
                                        ],
                                        redundantAttribute: 'expr39',
                                        selector: '[expr39]'
                                    }
                                ])
                            },
                            {
                                type: bindingTypes.IF,
                                evaluate: (_scope)=>_scope.CONFIG.CHECKBOX == _scope.column.type,
                                redundantAttribute: 'expr40',
                                selector: '[expr40]',
                                template: template(null, [
                                    {
                                        type: bindingTypes.TAG,
                                        getComponent: getComponent,
                                        evaluate: (_scope)=>'my-checkbox',
                                        slots: [],
                                        attributes: [
                                            {
                                                type: expressionTypes.ATTRIBUTE,
                                                isBoolean: false,
                                                name: 'ckey',
                                                evaluate: (_scope)=>_scope.props.ckey
                                            },
                                            {
                                                type: expressionTypes.ATTRIBUTE,
                                                isBoolean: false,
                                                name: 'checked',
                                                evaluate: (_scope)=>_scope.getCellValue(_scope.row, _scope.column)
                                            },
                                            {
                                                type: expressionTypes.ATTRIBUTE,
                                                isBoolean: false,
                                                name: 'value',
                                                evaluate: (_scope)=>_scope.row.id
                                            }
                                        ]
                                    }
                                ])
                            },
                            {
                                type: bindingTypes.SLOT,
                                attributes: [
                                    {
                                        type: expressionTypes.ATTRIBUTE,
                                        isBoolean: false,
                                        name: 'row',
                                        evaluate: (_scope)=>_scope.row
                                    },
                                    {
                                        type: expressionTypes.ATTRIBUTE,
                                        isBoolean: false,
                                        name: 'column',
                                        evaluate: (_scope)=>_scope.column
                                    }
                                ],
                                name: 'editable',
                                template: null,
                                redundantAttribute: 'expr41',
                                selector: '[expr41]'
                            }
                        ]),
                        redundantAttribute: 'expr37',
                        selector: '[expr37]',
                        itemName: 'column',
                        indexName: 'index',
                        evaluate: (_scope)=>_scope.props.columns
                    },
                    {
                        type: bindingTypes.SLOT,
                        attributes: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'row',
                                evaluate: (_scope)=>_scope.row
                            }
                        ],
                        name: 'actions',
                        template: null,
                        redundantAttribute: 'expr42',
                        selector: '[expr42]'
                    }
                ]),
                redundantAttribute: 'expr36',
                selector: '[expr36]',
                itemName: 'row',
                indexName: null,
                evaluate: (_scope)=>_scope.props.rows
            },
            {
                type: bindingTypes.TAG,
                getComponent: getComponent,
                evaluate: (_scope)=>'pagination',
                slots: [],
                attributes: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'ckey',
                        evaluate: (_scope)=>_scope.props.ckey
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'total_rows',
                        evaluate: (_scope)=>_scope.props.total_rows
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'current_page',
                        evaluate: (_scope)=>_scope.props.current_page
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'page_size',
                        evaluate: (_scope)=>_scope.props.page_size
                    }
                ],
                redundantAttribute: 'expr43',
                selector: '[expr43]'
            }
        ]),
    name: 'generic-table'
};


var $be2b04ec9e9d6296$exports = {};

$parcel$defineInteropFlag($be2b04ec9e9d6296$exports);

$parcel$export($be2b04ec9e9d6296$exports, "default", () => $be2b04ec9e9d6296$export$2e2bcd8739ae039);



var $be2b04ec9e9d6296$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        onBeforeMount (props, state) {
            this.state = {
                text: props.text,
                search_text: '',
                has_upload_xls: false
            };
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.UPDATE_HEADING, this.handleUpdateHeading);
        },
        async onMounted (props, state) {
            const progetto_id = props.progetto_id;
            const progetto = await (0, $38b2f4a478272d56$export$2e2bcd8739ae039).fetchProgettoById(progetto_id);
            this.update({
                has_upload_xls: progetto.get('has_upload_xls')
            });
        },
        onBeforeUnmount (props, state) {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.UPDATE_HEADING, this.handleUpdateHeading);
        },
        edit (e) {
            this.update({
                search_text: e.target.value.toLowerCase()
            });
        },
        handleUpdateHeading (e) {
            if (e.ckey === this.props.ckey) this.update({
                text: e.text
            });
        },
        search (e) {
            e.preventDefault();
            (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).ITEMS.SEARCH, {
                ckey: this.props.ckey,
                search_text: this.state.search_text
            });
        },
        refresh (e) {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).ITEMS.REFRESH, {
                ckey: this.props.ckey
            });
        },
        create (e) {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).ITEMS.CREATE, {
                ckey: this.props.ckey
            });
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<div class="bg-gray-800 p-8 rounded-lg"><div><nav class="sm:hidden" aria-label="Back"><a href="#" class="flex items-center text-sm font-medium text-gray-400 hover:text-gray-200"><svg class="-ml-1 mr-1 size-5 shrink-0 text-gray-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon"><path fill-rule="evenodd" d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z" clip-rule="evenodd"/></svg>\n                    Indietro\n                </a></nav><breadcrumb expr71="expr71"></breadcrumb></div><div class="mt-2 md:flex md:items-center md:justify-between"><div class="min-w-0 flex-1"><h2 expr73="expr73" class="text-2xl/7 font-bold text-white sm:truncate sm:text-3xl sm:tracking-tight"> </h2></div></div></div>', [
            {
                type: bindingTypes.TAG,
                getComponent: getComponent,
                evaluate: (_scope)=>'breadcrumb',
                slots: [
                    {
                        id: 'default',
                        html: '<breadcrumb-item expr72="expr72" link></breadcrumb-item>',
                        bindings: [
                            {
                                type: bindingTypes.TAG,
                                getComponent: getComponent,
                                evaluate: (_scope)=>'breadcrumb-item',
                                slots: [],
                                attributes: [
                                    {
                                        type: expressionTypes.ATTRIBUTE,
                                        isBoolean: false,
                                        name: 'ckey',
                                        evaluate: (_scope)=>_scope.props.ckey
                                    },
                                    {
                                        type: expressionTypes.ATTRIBUTE,
                                        isBoolean: false,
                                        name: 'text',
                                        evaluate: (_scope)=>_scope.props.text
                                    }
                                ],
                                redundantAttribute: 'expr72',
                                selector: '[expr72]'
                            }
                        ]
                    }
                ],
                attributes: [],
                redundantAttribute: 'expr71',
                selector: '[expr71]'
            },
            {
                redundantAttribute: 'expr73',
                selector: '[expr73]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>_scope.props.text
                    }
                ]
            }
        ]),
    name: 'heading-page'
};


var $d5fbd27e39637ef7$exports = {};

$parcel$defineInteropFlag($d5fbd27e39637ef7$exports);

$parcel$export($d5fbd27e39637ef7$exports, "default", () => $d5fbd27e39637ef7$export$2e2bcd8739ae039);


var $d5fbd27e39637ef7$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        onBeforeMount (props, state) {
            this.state = {
                file: null,
                preview_url: props.preview_url ? props.preview_url : ''
            };
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.RESET, this.handleResetInput);
        },
        onBeforeUnmount (props, state) {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.RESET, this.handleResetInput);
        },
        handleResetInput (e) {
            if (e.ckey === this.props.ckey) {
                this.update({
                    file: null,
                    preview_url: ''
                });
                this.$("input").value = "";
            }
        },
        openFilePicker () {
            this.$('#' + this.props.ckey).click();
        },
        /** Gestisce la selezione del file */ handleFileUpload (e) {
            const file = e.target.files[0]; // Ottiene il file selezionato
            if (file) {
                const reader = new FileReader();
                reader.onload = ()=>{
                    this.update({
                        file: file,
                        preview_url: reader.result
                    });
                    (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.UPDATED, {
                        ckey: this.props.ckey,
                        value: file
                    });
                };
                reader.readAsDataURL(file);
            }
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<div><label expr51="expr51" class="block text-sm/6 font-medium text-gray-900"> </label><div class="mt-2 flex items-center gap-x-3"><img expr52="expr52" class="size-12 object-cover rounded-md" alt="Anteprima immagine"/><svg expr53="expr53" class="size-12 text-gray-300" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"></svg><button expr54="expr54" type="button" class="rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"> </button></div><input expr55="expr55" type="file" class="hidden"/><p expr56="expr56" class="mt-3 text-sm leading-6 text-gray-600"></p></div>', [
            {
                redundantAttribute: 'expr51',
                selector: '[expr51]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>_scope.props.label
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'for',
                        evaluate: (_scope)=>_scope.props.ckey
                    }
                ]
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.state.preview_url,
                redundantAttribute: 'expr52',
                selector: '[expr52]',
                template: template(null, [
                    {
                        expressions: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'src',
                                evaluate: (_scope)=>_scope.state.preview_url
                            }
                        ]
                    }
                ])
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>!_scope.state.preview_url,
                redundantAttribute: 'expr53',
                selector: '[expr53]',
                template: template('<path fill-rule="evenodd" d="M1.5 6a2.25 2.25 0 0 1 2.25-2.25h16.5A2.25 2.25 0 0 1 22.5 6v12a2.25 2.25 0 0 1-2.25 2.25H3.75A2.25 2.25 0 0 1 1.5 18V6ZM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0 0 21 18v-1.94l-2.69-2.689a1.5 1.5 0 0 0-2.12 0l-.88.879.97.97a.75.75 0 1 1-1.06 1.06l-5.16-5.159a1.5 1.5 0 0 0-2.12 0L3 16.061Zm10.125-7.81a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z" clip-rule="evenodd"/>', [])
            },
            {
                redundantAttribute: 'expr54',
                selector: '[expr54]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>[
                                _scope.state.preview_url ? "Cambia" : "Carica"
                            ].join('')
                    },
                    {
                        type: expressionTypes.EVENT,
                        name: 'onclick',
                        evaluate: (_scope)=>_scope.openFilePicker
                    }
                ]
            },
            {
                redundantAttribute: 'expr55',
                selector: '[expr55]',
                expressions: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'id',
                        evaluate: (_scope)=>_scope.props.ckey
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'accept',
                        evaluate: (_scope)=>_scope.props.accept
                    },
                    {
                        type: expressionTypes.EVENT,
                        name: 'onchange',
                        evaluate: (_scope)=>_scope.handleFileUpload
                    }
                ]
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.props.show_help,
                redundantAttribute: 'expr56',
                selector: '[expr56]',
                template: template('<slot expr57="expr57"></slot>', [
                    {
                        type: bindingTypes.SLOT,
                        attributes: [],
                        name: 'default',
                        template: null,
                        redundantAttribute: 'expr57',
                        selector: '[expr57]'
                    }
                ])
            }
        ]),
    name: 'input-file'
};


var $0a6df5d38cff0a58$exports = {};

$parcel$defineInteropFlag($0a6df5d38cff0a58$exports);

$parcel$export($0a6df5d38cff0a58$exports, "default", () => $0a6df5d38cff0a58$export$2e2bcd8739ae039);


var $0a6df5d38cff0a58$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        onBeforeMount (props, state) {
            this.state = {
                value: ''
            };
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.UPDATE, this.handleUpdateInput);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.RESET, this.handleResetInput);
        },
        onBeforeUnmount (props, state) {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.UPDATE, this.handleUpdateInput);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.RESET, this.handleResetInput);
        },
        edit (e) {
            this.update({
                value: e.target.value
            });
            (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.UPDATED, {
                ckey: this.props.ckey,
                value: e.target.value
            });
        },
        handleUpdateInput (e) {
            if (e.ckey === this.props.ckey) this.update({
                value: e.value
            });
        },
        handleResetInput (e) {
            if (e.ckey === this.props.ckey) {
                this.update({
                    value: ''
                });
                this.$("input").value = "";
                (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.UPDATED, {
                    ckey: this.props.ckey,
                    value: ''
                });
            }
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<div><label expr66="expr66" class="block text-sm/6 font-medium text-gray-900"></label><div expr67="expr67"><input expr68="expr68" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"/></div><p expr69="expr69" class="mt-3 text-sm/6 text-gray-600"></p></div>', [
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.props.label,
                redundantAttribute: 'expr66',
                selector: '[expr66]',
                template: template(' ', [
                    {
                        expressions: [
                            {
                                type: expressionTypes.TEXT,
                                childNodeIndex: 0,
                                evaluate: (_scope)=>_scope.props.label
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'for',
                                evaluate: (_scope)=>_scope.props.ckey
                            }
                        ]
                    }
                ])
            },
            {
                redundantAttribute: 'expr67',
                selector: '[expr67]',
                expressions: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'class',
                        evaluate: (_scope)=>_scope.props.label ? 'mt-2' : ''
                    }
                ]
            },
            {
                redundantAttribute: 'expr68',
                selector: '[expr68]',
                expressions: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'step',
                        evaluate: (_scope)=>_scope.props.step
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'autocomplete',
                        evaluate: (_scope)=>_scope.props.autocomplete
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'placeholder',
                        evaluate: (_scope)=>_scope.props.placeholder
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: true,
                        name: 'required',
                        evaluate: (_scope)=>_scope.props.is_required
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: true,
                        name: 'disabled',
                        evaluate: (_scope)=>_scope.props.is_disabled
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'type',
                        evaluate: (_scope)=>_scope.props.inputtype ? _scope.props.inputtype : 'text'
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'name',
                        evaluate: (_scope)=>_scope.props.ckey
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'id',
                        evaluate: (_scope)=>_scope.props.ckey
                    },
                    {
                        type: expressionTypes.VALUE,
                        evaluate: (_scope)=>_scope.props.value ? _scope.props.value : ''
                    },
                    {
                        type: expressionTypes.EVENT,
                        name: 'oninput',
                        evaluate: (_scope)=>_scope.edit
                    }
                ]
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.props.show_help,
                redundantAttribute: 'expr69',
                selector: '[expr69]',
                template: template('<slot expr70="expr70"></slot>', [
                    {
                        type: bindingTypes.SLOT,
                        attributes: [],
                        name: 'default',
                        template: null,
                        redundantAttribute: 'expr70',
                        selector: '[expr70]'
                    }
                ])
            }
        ]),
    name: 'input-text'
};


var $d36cc654f39a0d98$exports = {};

$parcel$defineInteropFlag($d36cc654f39a0d98$exports);

$parcel$export($d36cc654f39a0d98$exports, "default", () => $d36cc654f39a0d98$export$2e2bcd8739ae039);



var $d36cc654f39a0d98$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        KEYS: (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92),
        onBeforeMount (props, state) {
            this.state = {
                active: false,
                user: (0, $38b2f4a478272d56$export$2e2bcd8739ae039).getUser()
            };
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.UPDATE_NAV, this.handleUpdateNav);
        },
        onBeforeUnmount (props, state) {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.UPDATE_NAV, this.handleUpdateNav);
        },
        handleUpdateNav (e) {
            if (e.pathname === this.props.link) this.update({
                active: true
            });
            else this.update({
                active: false
            });
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<a expr58="expr58"><svg expr59="expr59" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"></svg><svg expr60="expr60" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"></svg> </a>', [
            {
                redundantAttribute: 'expr58',
                selector: '[expr58]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 2,
                        evaluate: (_scope)=>[
                                _scope.props.title
                            ].join('')
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'id',
                        evaluate: (_scope)=>_scope.props.id
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'href',
                        evaluate: (_scope)=>_scope.props.link
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'class',
                        evaluate: (_scope)=>[
                                _scope.state.active ? 'bg-cyan-700 text-white' : 'text-cyan-200 hover:text-white hover:bg-cyan-700',
                                ' group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
                            ].join('')
                    }
                ]
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.props.id === _scope.KEYS.COMMESSE,
                redundantAttribute: 'expr59',
                selector: '[expr59]',
                template: template('<path stroke-linecap="round" stroke-linejoin="round" d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"/>', [])
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.props.id === _scope.KEYS.TASK,
                redundantAttribute: 'expr60',
                selector: '[expr60]',
                template: template('<path stroke-linecap="round" stroke-linejoin="round" d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 0 1 0 3.75H5.625a1.875 1.875 0 0 1 0-3.75Z"/>', [])
            }
        ]),
    name: 'item-nav'
};


var $753e427c37b27179$exports = {};

$parcel$defineInteropFlag($753e427c37b27179$exports);

$parcel$export($753e427c37b27179$exports, "default", () => $753e427c37b27179$export$2e2bcd8739ae039);



var $753e427c37b27179$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        onBeforeMount (props, state) {
            document.documentElement.className = "h-full bg-white";
            document.body.classList = "h-full";
            // initial state
            this.state = {
                username: '',
                password: '',
                is_error: false,
                error_message: ''
            };
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).AUTH.LOGIN_FAILED, this.login_failed);
        },
        onBeforeUnmount () {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).AUTH.LOGIN_FAILED, this.login_failed);
        },
        edit (e) {
            if (this.state.is_error) this.update({
                is_error: false,
                error_message: '',
                [e.target.id]: e.target.value
            });
            else this.update({
                [e.target.id]: e.target.value
            });
        },
        async submit (e) {
            e.preventDefault();
            const result = await (0, $38b2f4a478272d56$export$2e2bcd8739ae039).login(this.state.username, this.state.password);
            if (result.utente) (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).AUTH.LOGIN_SUCCESS, result.utente);
            else this.update({
                is_error: true,
                error_message: result.error.message
            });
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<div class="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8"><div class="sm:mx-auto sm:w-full sm:max-w-sm"><img class="mx-auto h-16 w-auto" src="/images/logo.png" alt="NSG Design + NokNok"/></div><div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm"><form expr95="expr95" class="space-y-6" method="POST"><div><label for="username" class="block text-sm font-medium leading-6 text-gray-900">Username</label><div class="mt-2"><input expr96="expr96" id="username" name="username" type="email" autocomplete="email" required class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-cyan-600 sm:text-sm/6"/></div></div><div><div class="flex items-center justify-between"><label for="password" class="block text-sm font-medium leading-6 text-gray-900">Password</label></div><div class="mt-2"><input expr97="expr97" id="password" name="password" type="password" required class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-cyan-600 sm:text-sm/6"/></div></div><div><button type="submit" class="flex w-full justify-center rounded-md bg-cyan-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-cyan-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-600">Accedi</button></div></form></div><div expr98="expr98" class="rounded-md bg-red-50 p-4 mt-5"></div></div>', [
            {
                redundantAttribute: 'expr95',
                selector: '[expr95]',
                expressions: [
                    {
                        type: expressionTypes.EVENT,
                        name: 'onsubmit',
                        evaluate: (_scope)=>_scope.submit
                    }
                ]
            },
            {
                redundantAttribute: 'expr96',
                selector: '[expr96]',
                expressions: [
                    {
                        type: expressionTypes.EVENT,
                        name: 'oninput',
                        evaluate: (_scope)=>_scope.edit
                    },
                    {
                        type: expressionTypes.VALUE,
                        evaluate: (_scope)=>_scope.state.username
                    }
                ]
            },
            {
                redundantAttribute: 'expr97',
                selector: '[expr97]',
                expressions: [
                    {
                        type: expressionTypes.EVENT,
                        name: 'oninput',
                        evaluate: (_scope)=>_scope.edit
                    },
                    {
                        type: expressionTypes.VALUE,
                        evaluate: (_scope)=>_scope.state.password
                    }
                ]
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.state.is_error,
                redundantAttribute: 'expr98',
                selector: '[expr98]',
                template: template('<div class="flex"><div class="flex-shrink-0"><svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"/></svg></div><div class="ml-3"><h3 class="text-sm font-medium text-yellow-800">Attenzione</h3><div class="mt-2 text-sm text-yellow-700"><p>Errore di autenticazione:<br/><em expr99="expr99"> </em></p></div></div></div>', [
                    {
                        redundantAttribute: 'expr99',
                        selector: '[expr99]',
                        expressions: [
                            {
                                type: expressionTypes.TEXT,
                                childNodeIndex: 0,
                                evaluate: (_scope)=>_scope.state.error_message
                            }
                        ]
                    }
                ])
            }
        ]),
    name: 'login'
};


var $2c8400e83d6005e7$exports = {};

$parcel$defineInteropFlag($2c8400e83d6005e7$exports);

$parcel$export($2c8400e83d6005e7$exports, "default", () => $2c8400e83d6005e7$export$2e2bcd8739ae039);



var $2c8400e83d6005e7$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        onMounted () {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).AUTH.LOGOUT, ()=>{
                this.logout();
            });
        },
        async logout () {
            const result = await (0, $38b2f4a478272d56$export$2e2bcd8739ae039).logout();
            if (result.logout) (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).AUTH.LOGOUT_SUCCESS);
            else (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).AUTH.LOGOUT_FAILED, result.user);
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<a expr61="expr61" class="text-blue-200 hover:text-white hover:bg-blue-700 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold cursor-pointer"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6"><path stroke-linecap="round" stroke-linejoin="round" d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15"/></svg>\n        Logout\n    </a>', [
            {
                redundantAttribute: 'expr61',
                selector: '[expr61]',
                expressions: [
                    {
                        type: expressionTypes.EVENT,
                        name: 'onclick',
                        evaluate: (_scope)=>_scope.logout
                    }
                ]
            }
        ]),
    name: 'logout-button'
};


var $65fbaf88ca075162$exports = {};

$parcel$defineInteropFlag($65fbaf88ca075162$exports);

$parcel$export($65fbaf88ca075162$exports, "default", () => $65fbaf88ca075162$export$2e2bcd8739ae039);



var $65fbaf88ca075162$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        onBeforeMount (props, state) {
            this.state = {
                sidebar_visible: false,
                panel_hidden: true,
                current_item: null,
                user: (0, $38b2f4a478272d56$export$2e2bcd8739ae039).getUser(),
                item_navs: []
            };
        },
        async onMounted (props, state) {
            this.updateMenu();
        },
        toggle_sidebar () {
            this.update({
                transitioning: true,
                sidebar_visible: !this.state.sidebar_visible
            });
        },
        handleCloseSidebar () {
            this.update({
                transitioning: true,
                sidebar_visible: false
            });
        },
        handleTransitionEnd (e) {
            if (!this.state.sidebar_visible) this.update({
                transitioning: false
            });
        },
        updateMenu () {
            // Menu di base
            const baseMenu = [
                {
                    id: (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).COMMESSE,
                    title: 'Commesse',
                    link: '#/commesse'
                },
                {
                    id: (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).TASK,
                    title: 'Tasks',
                    link: '#/tasks'
                }
            ];
            // Aggiorna lo stato
            this.update({
                item_navs: baseMenu
            });
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<div><div expr0="expr0" id="offcanvas_menu" role="dialog" aria-modal="true"><div expr1="expr1"></div><div class="fixed inset-0 flex"><div expr2="expr2"><div expr3="expr3"><button expr4="expr4" type="button" class="-m-2.5 p-2.5"><span expr5="expr5" class="sr-only"> </span><svg class="size-6 text-white" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg></button></div><div class="flex grow flex-col gap-y-5 overflow-y-auto bg-cyan-600 px-6 pb-2"><div class="flex h-16 shrink-0 items-center"><img class="h-8 w-auto" src="/images/logo.png" alt="NSG + NokNok"/></div><nav class="flex flex-1 flex-col"><ul role="list" class="flex flex-1 flex-col gap-y-7"><li><ul role="list" class="-mx-2 space-y-1"><li expr6="expr6"></li><li><logout-button expr8="expr8"></logout-button></li></ul></li></ul></nav></div></div></div></div><div class="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col"><div class="flex grow flex-col gap-y-5 overflow-y-auto bg-cyan-600 px-6 pb-4"><div class="flex h-16 shrink-0 items-center"><img class="h-8 w-auto" src="/images/logo.png" alt="NSG + NokNok"/></div><nav class="flex flex-1 flex-col"><div class="flex flex-1 flex-col gap-y-7 justify-between"><ul role="list" class="flex flex-1 flex-col gap-y-7"><li><ul role="list" class="-mx-2 space-y-1"><li expr9="expr9"></li></ul></li></ul><li><ul role="list" class="-mx-2 space-y-1 pb-2"><li><logout-button expr11="expr11"></logout-button></li></ul></li></div></nav></div></div><div class="sticky top-0 z-40 flex items-center gap-x-6 bg-cyan-600 px-4 py-4 shadow-xs sm:px-6 lg:hidden"><button expr12="expr12" type="button" class="-m-2.5 p-2.5 text-cyan-200 lg:hidden"><span expr13="expr13" class="sr-only"> </span><svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"/></svg></button><div class="flex-1 text-sm font-semibold leading-6 text-white">Dashboard</div></div></div>', [
            {
                redundantAttribute: 'expr0',
                selector: '[expr0]',
                expressions: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'class',
                        evaluate: (_scope)=>[
                                'relative z-50 lg:hidden ',
                                !_scope.state.transitioning && !_scope.state.sidebar_visible ? 'hidden' : ''
                            ].join('')
                    },
                    {
                        type: expressionTypes.EVENT,
                        name: 'ontransitionend',
                        evaluate: (_scope)=>_scope.handleTransitionEnd
                    }
                ]
            },
            {
                redundantAttribute: 'expr1',
                selector: '[expr1]',
                expressions: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'class',
                        evaluate: (_scope)=>[
                                'fixed inset-0 bg-gray-900/80 transition-opacity ease-linear duration-300 ',
                                _scope.state.sidebar_visible ? 'opacity-100' : 'opacity-0'
                            ].join('')
                    }
                ]
            },
            {
                redundantAttribute: 'expr2',
                selector: '[expr2]',
                expressions: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'class',
                        evaluate: (_scope)=>[
                                'relative mr-16 flex w-full max-w-xs flex-1 transition ease-in-out duration-300 transform ',
                                _scope.state.sidebar_visible ? 'translate-x-0' : '-translate-x-full'
                            ].join('')
                    }
                ]
            },
            {
                redundantAttribute: 'expr3',
                selector: '[expr3]',
                expressions: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'class',
                        evaluate: (_scope)=>[
                                'absolute left-full top-0 flex w-16 justify-center pt-5 ease-in-out duration-300 ',
                                _scope.state.sidebar_visible ? 'opacity-100' : 'opacity-0'
                            ].join('')
                    }
                ]
            },
            {
                redundantAttribute: 'expr4',
                selector: '[expr4]',
                expressions: [
                    {
                        type: expressionTypes.EVENT,
                        name: 'onclick',
                        evaluate: (_scope)=>_scope.toggle_sidebar
                    }
                ]
            },
            {
                redundantAttribute: 'expr5',
                selector: '[expr5]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>[
                                _scope.state.sidebar_visible ? 'Chiudi' : 'Apri',
                                ' sidebar'
                            ].join('')
                    }
                ]
            },
            {
                type: bindingTypes.EACH,
                getKey: null,
                condition: null,
                template: template('<item-nav expr7="expr7"></item-nav>', [
                    {
                        expressions: [
                            {
                                type: expressionTypes.EVENT,
                                name: 'onclick',
                                evaluate: (_scope)=>_scope.handleCloseSidebar
                            }
                        ]
                    },
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'item-nav',
                        slots: [],
                        attributes: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'id',
                                evaluate: (_scope)=>_scope.item.id
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'title',
                                evaluate: (_scope)=>_scope.item.title
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'link',
                                evaluate: (_scope)=>_scope.item.link
                            }
                        ],
                        redundantAttribute: 'expr7',
                        selector: '[expr7]'
                    }
                ]),
                redundantAttribute: 'expr6',
                selector: '[expr6]',
                itemName: 'item',
                indexName: null,
                evaluate: (_scope)=>_scope.item_navs
            },
            {
                type: bindingTypes.TAG,
                getComponent: getComponent,
                evaluate: (_scope)=>'logout-button',
                slots: [],
                attributes: [],
                redundantAttribute: 'expr8',
                selector: '[expr8]'
            },
            {
                type: bindingTypes.EACH,
                getKey: null,
                condition: null,
                template: template('<item-nav expr10="expr10"></item-nav>', [
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'item-nav',
                        slots: [],
                        attributes: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'id',
                                evaluate: (_scope)=>_scope.item.id
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'title',
                                evaluate: (_scope)=>_scope.item.title
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'link',
                                evaluate: (_scope)=>_scope.item.link
                            }
                        ],
                        redundantAttribute: 'expr10',
                        selector: '[expr10]'
                    }
                ]),
                redundantAttribute: 'expr9',
                selector: '[expr9]',
                itemName: 'item',
                indexName: null,
                evaluate: (_scope)=>_scope.state.item_navs
            },
            {
                type: bindingTypes.TAG,
                getComponent: getComponent,
                evaluate: (_scope)=>'logout-button',
                slots: [],
                attributes: [],
                redundantAttribute: 'expr11',
                selector: '[expr11]'
            },
            {
                redundantAttribute: 'expr12',
                selector: '[expr12]',
                expressions: [
                    {
                        type: expressionTypes.EVENT,
                        name: 'onclick',
                        evaluate: (_scope)=>_scope.toggle_sidebar
                    }
                ]
            },
            {
                redundantAttribute: 'expr13',
                selector: '[expr13]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>[
                                _scope.state.sidebar_visible ? 'Chiudi' : 'Apri',
                                ' sidebar'
                            ].join('')
                    }
                ]
            }
        ]),
    name: 'main-navi'
};


var $7dea095c3e07eee6$exports = {};

$parcel$defineInteropFlag($7dea095c3e07eee6$exports);

$parcel$export($7dea095c3e07eee6$exports, "default", () => $7dea095c3e07eee6$export$2e2bcd8739ae039);


var $7dea095c3e07eee6$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        onBeforeMount (props, state) {
            this.state = {
                title: '',
                text: '',
                item_id: '',
                modal_visible: false
            };
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.OPEN_MODAL_DELETE, this.open_modal);
        },
        onBeforeUnmount (props, state) {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.OPEN_MODAL_DELETE, this.open_modal);
        },
        delete_item () {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).ITEMS.DELETE, {
                ckey: this.props.ckey,
                item_id: this.state.item_id
            });
            this.close_modal();
        },
        close_modal () {
            this.update({
                title: '',
                text: '',
                item_id: '',
                modal_visible: false
            });
        },
        open_modal (e) {
            if (e.ckey === this.props.ckey) this.update({
                title: e.title,
                text: e.text,
                item_id: e.item_id,
                modal_visible: true
            });
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true"><div expr71="expr71"></div><div expr72="expr72" class="fixed inset-0 z-10 w-screen overflow-y-auto"></div></div>', [
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.state.modal_visible,
                redundantAttribute: 'expr71',
                selector: '[expr71]',
                template: template(null, [
                    {
                        expressions: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'class',
                                evaluate: (_scope)=>[
                                        'fixed inset-0 bg-gray-500/75 transition-opacity ',
                                        _scope.state.modal_visible ? 'opacity-100 ease-in duration-200' : "opacity-0 ease-out \xec duration-300"
                                    ].join('')
                            }
                        ]
                    }
                ])
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.state.modal_visible,
                redundantAttribute: 'expr72',
                selector: '[expr72]',
                template: template('<div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"><div expr73="expr73"><div class="sm:flex sm:items-start"><div class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"><svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"/></svg></div><div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left"><h3 expr74="expr74" class="text-base font-semibold leading-6 text-gray-900" id="modal-title"> </h3><div class="mt-2"><p class="text-sm text-gray-500"><raw expr75="expr75"></raw></p></div></div></div><div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse"><button expr76="expr76" type="button" class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">Elimina</button><button expr77="expr77" type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Annulla</button></div></div></div>', [
                    {
                        redundantAttribute: 'expr73',
                        selector: '[expr73]',
                        expressions: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'class',
                                evaluate: (_scope)=>[
                                        'relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6 ',
                                        _scope.state.modal_visible ? 'ease-out duration-300 opacity-100 translate-y-0 sm:scale-100' : 'ease-in duration-200 opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
                                    ].join('')
                            }
                        ]
                    },
                    {
                        redundantAttribute: 'expr74',
                        selector: '[expr74]',
                        expressions: [
                            {
                                type: expressionTypes.TEXT,
                                childNodeIndex: 0,
                                evaluate: (_scope)=>_scope.state.title
                            }
                        ]
                    },
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'raw',
                        slots: [],
                        attributes: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'html',
                                evaluate: (_scope)=>_scope.state.text
                            }
                        ],
                        redundantAttribute: 'expr75',
                        selector: '[expr75]'
                    },
                    {
                        redundantAttribute: 'expr76',
                        selector: '[expr76]',
                        expressions: [
                            {
                                type: expressionTypes.EVENT,
                                name: 'onclick',
                                evaluate: (_scope)=>_scope.delete_item
                            }
                        ]
                    },
                    {
                        redundantAttribute: 'expr77',
                        selector: '[expr77]',
                        expressions: [
                            {
                                type: expressionTypes.EVENT,
                                name: 'onclick',
                                evaluate: (_scope)=>_scope.close_modal
                            }
                        ]
                    }
                ])
            }
        ]),
    name: 'modal-delete'
};


var $64fb74d683d53ebe$exports = {};

$parcel$defineInteropFlag($64fb74d683d53ebe$exports);

$parcel$export($64fb74d683d53ebe$exports, "default", () => $64fb74d683d53ebe$export$2e2bcd8739ae039);


var $64fb74d683d53ebe$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        onBeforeMount (props, state) {
            this.state = {
                title: '',
                text: '',
                modal_visible: false
            };
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.OPEN_MODAL_ERROR, this.open_modal);
        },
        onBeforeUnmount (props, state) {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.OPEN_MODAL_ERROR, this.open_modal);
        },
        close_modal () {
            this.update({
                title: '',
                text: '',
                modal_visible: false
            });
        },
        open_modal (e) {
            if (e.ckey === this.props.ckey) this.update({
                title: e.title,
                text: e.text,
                modal_visible: true
            });
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true"><div expr88="expr88"></div><div expr89="expr89" class="fixed inset-0 z-10 w-screen overflow-y-auto"></div></div>', [
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.state.modal_visible,
                redundantAttribute: 'expr88',
                selector: '[expr88]',
                template: template(null, [
                    {
                        expressions: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'class',
                                evaluate: (_scope)=>[
                                        'fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity ease-out duration-300 ',
                                        _scope.state.modal_visible ? 'opacity-100' : 'opacity-0'
                                    ].join('')
                            }
                        ]
                    }
                ])
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.state.modal_visible,
                redundantAttribute: 'expr89',
                selector: '[expr89]',
                template: template('<div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"><div expr90="expr90"><div class="sm:flex sm:items-start"><div class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"><svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"/></svg></div><div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left"><h3 expr91="expr91" class="text-base font-semibold leading-6 text-gray-900" id="modal-title"> </h3><div class="mt-2"><p class="text-sm text-gray-500"><raw expr92="expr92"></raw></p></div></div></div><div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse"><button expr93="expr93" type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Chiudi</button></div></div></div>', [
                    {
                        redundantAttribute: 'expr90',
                        selector: '[expr90]',
                        expressions: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'class',
                                evaluate: (_scope)=>[
                                        'relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6 ',
                                        _scope.state.modal_visible ? 'opacity-100 translate-y-0 sm:scale-100' : 'opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
                                    ].join('')
                            }
                        ]
                    },
                    {
                        redundantAttribute: 'expr91',
                        selector: '[expr91]',
                        expressions: [
                            {
                                type: expressionTypes.TEXT,
                                childNodeIndex: 0,
                                evaluate: (_scope)=>_scope.state.title
                            }
                        ]
                    },
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'raw',
                        slots: [],
                        attributes: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'html',
                                evaluate: (_scope)=>_scope.state.text
                            }
                        ],
                        redundantAttribute: 'expr92',
                        selector: '[expr92]'
                    },
                    {
                        redundantAttribute: 'expr93',
                        selector: '[expr93]',
                        expressions: [
                            {
                                type: expressionTypes.EVENT,
                                name: 'onclick',
                                evaluate: (_scope)=>_scope.close_modal
                            }
                        ]
                    }
                ])
            }
        ]),
    name: 'modal-error'
};


var $0a7605ecbf65b52d$exports = {};

$parcel$defineInteropFlag($0a7605ecbf65b52d$exports);

$parcel$export($0a7605ecbf65b52d$exports, "default", () => $0a7605ecbf65b52d$export$2e2bcd8739ae039);





var $0a7605ecbf65b52d$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        moment: (0, (/*@__PURE__*/$parcel$interopDefault($6641b049ad84b098$exports))),
        getIdRisorsa: (0, $6bfc5a82c63db877$export$2953bd25a4acda3a),
        onBeforeMount (props, state) {
            this.state = {
                id: '',
                id_commessa: props.id_commessa,
                data: '',
                quantita: '',
                descrizione: '',
                note: '',
                id_risorsa: '',
                risorsa: '',
                modal_visible: false
            };
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.OPEN_MODAL_ORE, this.open_modal);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.UPDATED, this.handleInputChanged);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.SELECTED, this.handleInputChanged);
        },
        onBeforeUnmount (props, state) {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.OPEN_MODAL_ORE, this.open_modal);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.UPDATED, this.handleInputChanged);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.SELECTED, this.handleInputChanged);
        },
        handleInputChanged (e) {
            switch(e.ckey){
                case "data":
                case "quantita":
                case "descrizione":
                case "note":
                case "risorsa":
                    this.update({
                        [e.ckey]: e.value
                    });
                    break;
                case "modal_risorsa_ore":
                    this.update({
                        "risorsa": e.value
                    });
                    break;
                default:
                    break;
            }
        },
        async submit (e) {
            e.preventDefault();
            const result = await (0, $38b2f4a478272d56$export$2e2bcd8739ae039).saveOra(this.state.id, {
                commessa: this.state.id_commessa,
                data: this.state.data,
                quantita: this.state.quantita,
                descrizione: this.state.descrizione,
                note: this.state.note,
                risorsa: this.state.risorsa
            });
            this.close_modal();
            if (result.success) (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).ITEMS.REFRESH, {
                ckey: (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).ORE
            });
            else (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).OPEN_MODAL_ERROR, {
                ckey: "error",
                title: "Errore nel salvataggio delle ore",
                text: result.error
            });
        },
        close_modal () {
            this.update({
                id: '',
                id_commessa: '',
                data: '',
                quantita: '',
                descrizione: '',
                note: '',
                id_risorsa: '',
                risorsa: '',
                modal_visible: false
            });
        },
        open_modal (e) {
            if (e.ckey === this.props.ckey) {
                (0, $6bfc5a82c63db877$export$e3ed16048dcc8c7c)().then((risorse)=>{
                    (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.UPDATE, {
                        ckey: 'modal_risorsa_ore',
                        items: risorse
                    });
                });
                this.update({
                    id: e.data.id,
                    id_commessa: e.data.id_commessa,
                    data: e.data.data ? e.data.data : (0, (/*@__PURE__*/$parcel$interopDefault($6641b049ad84b098$exports)))().format('YYYY-MM-DD'),
                    quantita: e.data.quantita,
                    descrizione: e.data.descrizione,
                    note: e.data.note,
                    id_risorsa: e.data.id_risorsa,
                    risorsa: e.data.risorsa ? e.data.risorsa : this.getIdRisorsa(),
                    modal_visible: true
                });
            }
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true"><div expr0="expr0"></div><div expr1="expr1" class="fixed inset-0 z-10 w-screen overflow-y-auto"></div></div>', [
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.state.modal_visible,
                redundantAttribute: 'expr0',
                selector: '[expr0]',
                template: template(null, [
                    {
                        expressions: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'class',
                                evaluate: (_scope)=>[
                                        'fixed inset-0 bg-gray-500/75 transition-opacity ',
                                        _scope.state.modal_visible ? 'opacity-100 ease-in duration-200' : "opacity-0 ease-out \xec duration-300"
                                    ].join('')
                            }
                        ]
                    }
                ])
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.state.modal_visible,
                redundantAttribute: 'expr1',
                selector: '[expr1]',
                template: template('<div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"><div expr2="expr2"><form expr3="expr3" method="POST"><div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left"><h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">Modifica attivit\xe0</h3><div class="grid grid-cols-2 gap-4 mt-6"><div class="col-span-1"><input-text expr4="expr4" label="Data" ckey="data" autocomplete="off" inputtype="date" is_required="required"></input-text></div><div class="col-span-1"><input-text expr5="expr5" label="Quantit\xe0" ckey="quantita" autocomplete="off" is_required="required"></input-text></div><div class="col-span-2"><my-textarea expr6="expr6" label="Descrizione" ckey="descrizione" autocomplete="off" is_required="required"></my-textarea></div><div class="col-span-2"><my-textarea expr7="expr7" label="Note" ckey="note" autocomplete="off" is_required="required"></my-textarea></div><div class="col-span-2"><combobox expr8="expr8" label="Risorsa" ckey="modal_risorsa_ore" is_required="required"></combobox></div></div></div><div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-2"><button type="submit" class="rounded-md bg-cyan-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-cyan-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-600">Salva</button><button expr9="expr9" type="button" class="rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-50">Annulla</button></div></form></div></div>', [
                    {
                        redundantAttribute: 'expr2',
                        selector: '[expr2]',
                        expressions: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'class',
                                evaluate: (_scope)=>[
                                        'relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6 ',
                                        _scope.state.modal_visible ? 'ease-out duration-300 opacity-100 translate-y-0 sm:scale-100' : 'ease-in duration-200 opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
                                    ].join('')
                            }
                        ]
                    },
                    {
                        redundantAttribute: 'expr3',
                        selector: '[expr3]',
                        expressions: [
                            {
                                type: expressionTypes.EVENT,
                                name: 'onsubmit',
                                evaluate: (_scope)=>_scope.submit
                            }
                        ]
                    },
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'input-text',
                        slots: [],
                        attributes: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'value',
                                evaluate: (_scope)=>_scope.state.data
                            }
                        ],
                        redundantAttribute: 'expr4',
                        selector: '[expr4]'
                    },
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'input-text',
                        slots: [],
                        attributes: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'value',
                                evaluate: (_scope)=>_scope.state.quantita
                            }
                        ],
                        redundantAttribute: 'expr5',
                        selector: '[expr5]'
                    },
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'my-textarea',
                        slots: [],
                        attributes: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'value',
                                evaluate: (_scope)=>_scope.state.descrizione
                            }
                        ],
                        redundantAttribute: 'expr6',
                        selector: '[expr6]'
                    },
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'my-textarea',
                        slots: [],
                        attributes: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'value',
                                evaluate: (_scope)=>_scope.state.note
                            }
                        ],
                        redundantAttribute: 'expr7',
                        selector: '[expr7]'
                    },
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'combobox',
                        slots: [],
                        attributes: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'value',
                                evaluate: (_scope)=>_scope.state.id_risorsa
                            }
                        ],
                        redundantAttribute: 'expr8',
                        selector: '[expr8]'
                    },
                    {
                        redundantAttribute: 'expr9',
                        selector: '[expr9]',
                        expressions: [
                            {
                                type: expressionTypes.EVENT,
                                name: 'onclick',
                                evaluate: (_scope)=>_scope.close_modal
                            }
                        ]
                    }
                ])
            }
        ]),
    name: 'modal-ore'
};


var $75d85ae6320b9446$exports = {};

$parcel$defineInteropFlag($75d85ae6320b9446$exports);

$parcel$export($75d85ae6320b9446$exports, "default", () => $75d85ae6320b9446$export$2e2bcd8739ae039);


var $75d85ae6320b9446$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        onBeforeMount (props, state) {
            this.state = {
                has_errors: false,
                title: '',
                text: '',
                modal_visible: false
            };
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.OPEN_MODAL_RESULT, this.open_modal);
        },
        onBeforeUnmount (props, state) {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.OPEN_MODAL_ERROR, this.open_modal);
        },
        close_modal () {
            this.update({
                title: '',
                text: '',
                modal_visible: false
            });
        },
        open_modal (e) {
            if (e.ckey === this.props.ckey) this.update({
                title: e.title,
                text: e.text,
                has_errors: e.has_errors,
                modal_visible: true
            });
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true"><div expr62="expr62"></div><div expr63="expr63" class="fixed inset-0 z-10 w-screen overflow-y-auto"></div></div>', [
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.state.modal_visible,
                redundantAttribute: 'expr62',
                selector: '[expr62]',
                template: template(null, [
                    {
                        expressions: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'class',
                                evaluate: (_scope)=>[
                                        'fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity ease-out duration-300 ',
                                        _scope.state.modal_visible ? 'opacity-100' : 'opacity-0'
                                    ].join('')
                            }
                        ]
                    }
                ])
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.state.modal_visible,
                redundantAttribute: 'expr63',
                selector: '[expr63]',
                template: template('<div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"><div expr64="expr64"><div class="sm:flex sm:items-start"><div expr65="expr65" class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"></div><div expr66="expr66" class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10"></div><div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left"><h3 expr67="expr67" class="text-base font-semibold leading-6 text-gray-900" id="modal-title"> </h3><div expr68="expr68" class="mt-2"></div></div></div><div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse"><button expr70="expr70" type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Chiudi</button></div></div></div>', [
                    {
                        redundantAttribute: 'expr64',
                        selector: '[expr64]',
                        expressions: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'class',
                                evaluate: (_scope)=>[
                                        'relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6 ',
                                        _scope.state.modal_visible ? 'opacity-100 translate-y-0 sm:scale-100' : 'opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
                                    ].join('')
                            }
                        ]
                    },
                    {
                        type: bindingTypes.IF,
                        evaluate: (_scope)=>_scope.state.has_errors,
                        redundantAttribute: 'expr65',
                        selector: '[expr65]',
                        template: template('<svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"/></svg>', [])
                    },
                    {
                        type: bindingTypes.IF,
                        evaluate: (_scope)=>!_scope.state.has_errors,
                        redundantAttribute: 'expr66',
                        selector: '[expr66]',
                        template: template('<svg class="size-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"/></svg>', [])
                    },
                    {
                        redundantAttribute: 'expr67',
                        selector: '[expr67]',
                        expressions: [
                            {
                                type: expressionTypes.TEXT,
                                childNodeIndex: 0,
                                evaluate: (_scope)=>_scope.state.title
                            }
                        ]
                    },
                    {
                        type: bindingTypes.IF,
                        evaluate: (_scope)=>_scope.state.text,
                        redundantAttribute: 'expr68',
                        selector: '[expr68]',
                        template: template('<p class="text-sm text-gray-500"><raw expr69="expr69"></raw></p>', [
                            {
                                type: bindingTypes.TAG,
                                getComponent: getComponent,
                                evaluate: (_scope)=>'raw',
                                slots: [],
                                attributes: [
                                    {
                                        type: expressionTypes.ATTRIBUTE,
                                        isBoolean: false,
                                        name: 'html',
                                        evaluate: (_scope)=>_scope.state.text
                                    }
                                ],
                                redundantAttribute: 'expr69',
                                selector: '[expr69]'
                            }
                        ])
                    },
                    {
                        redundantAttribute: 'expr70',
                        selector: '[expr70]',
                        expressions: [
                            {
                                type: expressionTypes.EVENT,
                                name: 'onclick',
                                evaluate: (_scope)=>_scope.close_modal
                            }
                        ]
                    }
                ])
            }
        ]),
    name: 'modal-result'
};


var $42da252a95c62ff0$exports = {};

$parcel$defineInteropFlag($42da252a95c62ff0$exports);

$parcel$export($42da252a95c62ff0$exports, "default", () => $42da252a95c62ff0$export$2e2bcd8739ae039);
var $42da252a95c62ff0$export$2e2bcd8739ae039 = {
    css: null,
    exports: null,
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<button expr100="expr100" class="inline-flex items-center gap-x-1.5 rounded-md bg-cyan-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-cyan-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-600"><slot expr101="expr101"></slot></button>', [
            {
                redundantAttribute: 'expr100',
                selector: '[expr100]',
                expressions: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'type',
                        evaluate: (_scope)=>_scope.props.type
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: true,
                        name: 'disabled',
                        evaluate: (_scope)=>_scope.props.is_disabled
                    }
                ]
            },
            {
                type: bindingTypes.SLOT,
                attributes: [],
                name: 'default',
                template: null,
                redundantAttribute: 'expr101',
                selector: '[expr101]'
            }
        ]),
    name: 'my-button'
};


var $7a41a012652c63f3$exports = {};

$parcel$defineInteropFlag($7a41a012652c63f3$exports);

$parcel$export($7a41a012652c63f3$exports, "default", () => $7a41a012652c63f3$export$2e2bcd8739ae039);


var $7a41a012652c63f3$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        onBeforeMount (props, state) {
            this.state = {
                checked: props.checked ?? false
            };
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).CHECKBOX.RESET, this.handleResetCheckbox);
        },
        onBeforeUnmount (props, state) {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).CHECKBOX.RESET, this.handleResetCheckbox);
        },
        handleResetCheckbox (e) {
            if (e.ckey === this.props.ckey) {
                this.update({
                    checked: false
                });
                this.$("input").checked = false;
            }
        },
        handleChange (e) {
            const checked = e.target.checked;
            // Trigger eventi per comunicare la modifica al genitore
            if (this.props.value === '*') (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).CHECKBOX.CHECK_ALL, {
                ckey: this.props.ckey,
                checked: checked
            });
            else (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).CHECKBOX.CHECK, {
                ckey: this.props.ckey,
                value: this.props.value,
                checked: checked
            });
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<input expr78="expr78" type="checkbox"/>', [
            {
                redundantAttribute: 'expr78',
                selector: '[expr78]',
                expressions: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: true,
                        name: 'checked',
                        evaluate: (_scope)=>_scope.state.checked
                    },
                    {
                        type: expressionTypes.VALUE,
                        evaluate: (_scope)=>_scope.props.value
                    },
                    {
                        type: expressionTypes.EVENT,
                        name: 'onchange',
                        evaluate: (_scope)=>_scope.handleChange
                    }
                ]
            }
        ]),
    name: 'my-checkbox'
};


var $1c6e53c08ab0a86e$exports = {};

$parcel$defineInteropFlag($1c6e53c08ab0a86e$exports);

$parcel$export($1c6e53c08ab0a86e$exports, "default", () => $1c6e53c08ab0a86e$export$2e2bcd8739ae039);

var $1c6e53c08ab0a86e$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        VERSION: $315dbc24fdcb29cb$export$a4ad2735b021c132
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<footer class="px-8 mt-5"><div class="py-12 md:flex md:items-center md:justify-between"><div class="flex justify-center gap-x-6 md:order-2"><span expr94="expr94" class="mt-8 text-center text-sm/6 text-gray-500"> </span></div><p class="mt-8 text-center text-sm/6 text-gray-600 md:order-1 md:mt-0">&copy; 2025 <a href="https://www.originiagency.it" target="_blank">Origini srls</a>, Inc. All rights reserved.</p></div></footer>', [
            {
                redundantAttribute: 'expr94',
                selector: '[expr94]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>[
                                'Version ',
                                _scope.VERSION
                            ].join('')
                    }
                ]
            }
        ]),
    name: 'my-footer'
};


var $8b0922ca846c25f2$exports = {};

$parcel$defineInteropFlag($8b0922ca846c25f2$exports);

$parcel$export($8b0922ca846c25f2$exports, "default", () => $8b0922ca846c25f2$export$2e2bcd8739ae039);
var $8b0922ca846c25f2$export$2e2bcd8739ae039 = {
    css: null,
    exports: null,
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<label expr79="expr79" class="block text-sm/6 font-medium text-gray-900 w-full"> </label>', [
            {
                redundantAttribute: 'expr79',
                selector: '[expr79]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>_scope.props.label
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'for',
                        evaluate: (_scope)=>_scope.props.ckey
                    }
                ]
            }
        ]),
    name: 'my-label'
};


var $625521e3c1312feb$exports = {};

$parcel$defineInteropFlag($625521e3c1312feb$exports);

$parcel$export($625521e3c1312feb$exports, "default", () => $625521e3c1312feb$export$2e2bcd8739ae039);


var $625521e3c1312feb$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        onBeforeMount (props, state) {
            this.state = {
                value: ''
            };
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.UPDATE, this.handleUpdateInput);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.RESET, this.handleResetInput);
        },
        onBeforeUnmount (props, state) {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.UPDATE, this.handleUpdateInput);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.RESET, this.handleResetInput);
        },
        edit (e) {
            this.update({
                value: e.target.value
            });
            (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.UPDATED, {
                ckey: this.props.ckey,
                value: e.target.value
            });
        },
        handleUpdateInput (e) {
            if (e.ckey === this.props.ckey) this.update({
                value: e.value
            });
        },
        handleResetInput (e) {
            if (e.ckey === this.props.ckey) {
                this.update({
                    value: ''
                });
                this.$("textarea").value = "";
                (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.UPDATED, {
                    ckey: this.props.ckey,
                    value: ''
                });
            }
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<div><label expr103="expr103" class="block text-sm/6 font-medium text-gray-900"></label><div expr104="expr104"><textarea expr105="expr105" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-cyan-600 sm:text-sm/6"> </textarea></div><p expr106="expr106" class="mt-3 text-sm leading-6 text-gray-600"></p></div>', [
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.props.label,
                redundantAttribute: 'expr103',
                selector: '[expr103]',
                template: template(' ', [
                    {
                        expressions: [
                            {
                                type: expressionTypes.TEXT,
                                childNodeIndex: 0,
                                evaluate: (_scope)=>_scope.props.label
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'for',
                                evaluate: (_scope)=>_scope.props.ckey
                            }
                        ]
                    }
                ])
            },
            {
                redundantAttribute: 'expr104',
                selector: '[expr104]',
                expressions: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'class',
                        evaluate: (_scope)=>_scope.props.label ? 'mt-2' : ''
                    }
                ]
            },
            {
                redundantAttribute: 'expr105',
                selector: '[expr105]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>[
                                _scope.props.value ? _scope.props.value : ''
                            ].join('')
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'rows',
                        evaluate: (_scope)=>_scope.props.rows || 3
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'placeholder',
                        evaluate: (_scope)=>_scope.props.placeholder
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: true,
                        name: 'required',
                        evaluate: (_scope)=>_scope.props.is_required
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: true,
                        name: 'disabled',
                        evaluate: (_scope)=>_scope.props.is_disabled
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'name',
                        evaluate: (_scope)=>_scope.props.ckey
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'id',
                        evaluate: (_scope)=>_scope.props.ckey
                    },
                    {
                        type: expressionTypes.EVENT,
                        name: 'oninput',
                        evaluate: (_scope)=>_scope.edit
                    }
                ]
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.props.show_help,
                redundantAttribute: 'expr106',
                selector: '[expr106]',
                template: template('<slot expr107="expr107"></slot>', [
                    {
                        type: bindingTypes.SLOT,
                        attributes: [],
                        name: 'default',
                        template: null,
                        redundantAttribute: 'expr107',
                        selector: '[expr107]'
                    }
                ])
            }
        ]),
    name: 'my-textarea'
};


var $7376bb48008a8a86$exports = {};

$parcel$defineInteropFlag($7376bb48008a8a86$exports);

$parcel$export($7376bb48008a8a86$exports, "default", () => $7376bb48008a8a86$export$2e2bcd8739ae039);


var $7376bb48008a8a86$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        onBeforeMount (props, state) {
            this.state = {
                total_pages: 0,
                pages_to_show: [
                    1
                ],
                current_page: props.current_page
            };
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).ITEMS.CHANGED, this.handlePaginationItemsChanged);
        },
        onBeforeUnmount (props, state) {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).ITEMS.CHANGED, this.handlePaginationItemsChanged);
        },
        previous () {
            if (this.state.current_page > 1) this.changePage(this.state.current_page - 1);
        },
        next () {
            const totalPages = Math.ceil(this.props.total_rows / this.props.page_size);
            if (this.state.current_page < totalPages) this.changePage(this.state.current_page + 1);
        },
        changePage (p) {
            if (!isNaN(p)) (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.CHANGE_PAGE, {
                ckey: this.props.ckey,
                page: p
            });
        },
        updatePagesToShow (total_rows, currentPage) {
            const totalPages = Math.ceil(total_rows / this.props.page_size);
            let pagesToShow = [];
            if (totalPages <= 1) // Se c'è solo una pagina, mostriamo solo quella
            pagesToShow = [
                1
            ];
            else {
                // Aggiungi sempre la prima pagina
                pagesToShow.push(1);
                if (currentPage > 2) // Aggiungi puntini se necessario
                pagesToShow.push('...');
                if (currentPage > 1 && currentPage < totalPages) // Mostra la pagina corrente solo se non è la prima o l'ultima
                pagesToShow.push(currentPage);
                if (currentPage < totalPages - 1) // Aggiungi puntini se necessario
                pagesToShow.push('...');
                // Aggiungi sempre l'ultima pagina
                pagesToShow.push(totalPages);
            }
            this.update({
                total_pages: totalPages,
                pages_to_show: pagesToShow,
                current_page: currentPage
            });
            return pagesToShow;
        },
        handlePaginationItemsChanged (e) {
            if (e.ckey === this.props.ckey) this.updatePagesToShow(e.items.count, e.page);
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<div class="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6"><div class="flex flex-1 justify-between sm:hidden"><span expr80="expr80" class="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">Precedente</span><span expr81="expr81" class="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">Successiva</span></div><div class="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between"><div><p class="text-sm text-gray-700">\n                    Visualizza da\n                    <span expr82="expr82" class="font-medium"> </span>\n                    a\n                    <span expr83="expr83" class="font-medium"> </span>\n                    di\n                    <span expr84="expr84" class="font-medium"> </span>\n                    risultati\n                </p></div><div><nav class="isolate inline-flex -space-x-px rounded-md shadow-xs" aria-label="Pagination"><span expr85="expr85" class="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"><span class="sr-only">Precedente</span><svg class="size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon"><path fill-rule="evenodd" d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z" clip-rule="evenodd"/></svg></span><span expr86="expr86"></span><span expr87="expr87" class="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"><span class="sr-only">Successiva</span><svg class="size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon"><path fill-rule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"/></svg></span></nav></div></div></div>', [
            {
                redundantAttribute: 'expr80',
                selector: '[expr80]',
                expressions: [
                    {
                        type: expressionTypes.EVENT,
                        name: 'onclick',
                        evaluate: (_scope)=>_scope.previous
                    }
                ]
            },
            {
                redundantAttribute: 'expr81',
                selector: '[expr81]',
                expressions: [
                    {
                        type: expressionTypes.EVENT,
                        name: 'onclick',
                        evaluate: (_scope)=>_scope.next
                    }
                ]
            },
            {
                redundantAttribute: 'expr82',
                selector: '[expr82]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>_scope.props.page_size * (_scope.state.current_page - 1) + 1
                    }
                ]
            },
            {
                redundantAttribute: 'expr83',
                selector: '[expr83]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>_scope.props.page_size * _scope.state.current_page < _scope.props.total_rows ? _scope.props.page_size * _scope.state.current_page : _scope.props.total_rows
                    }
                ]
            },
            {
                redundantAttribute: 'expr84',
                selector: '[expr84]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>_scope.props.total_rows
                    }
                ]
            },
            {
                redundantAttribute: 'expr85',
                selector: '[expr85]',
                expressions: [
                    {
                        type: expressionTypes.EVENT,
                        name: 'onclick',
                        evaluate: (_scope)=>_scope.previous
                    }
                ]
            },
            {
                type: bindingTypes.EACH,
                getKey: null,
                condition: null,
                template: template(' ', [
                    {
                        expressions: [
                            {
                                type: expressionTypes.TEXT,
                                childNodeIndex: 0,
                                evaluate: (_scope)=>_scope.i
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'class',
                                evaluate: (_scope)=>[
                                        'relative inline-flex items-center px-4 py-2 text-sm font-semibold ',
                                        _scope.state.current_page === _scope.i ? 'z-10 bg-cyan-600 text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-600' : 'text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:outline-offset-0'
                                    ].join('')
                            },
                            {
                                type: expressionTypes.EVENT,
                                name: 'onclick',
                                evaluate: (_scope)=>_scope.changePage.bind(_scope, _scope.i)
                            }
                        ]
                    }
                ]),
                redundantAttribute: 'expr86',
                selector: '[expr86]',
                itemName: 'i',
                indexName: null,
                evaluate: (_scope)=>_scope.state.pages_to_show
            },
            {
                redundantAttribute: 'expr87',
                selector: '[expr87]',
                expressions: [
                    {
                        type: expressionTypes.EVENT,
                        name: 'onclick',
                        evaluate: (_scope)=>_scope.next
                    }
                ]
            }
        ]),
    name: 'pagination'
};


var $04f0a522226a58a9$exports = {};

$parcel$defineInteropFlag($04f0a522226a58a9$exports);

$parcel$export($04f0a522226a58a9$exports, "default", () => $04f0a522226a58a9$export$2e2bcd8739ae039);


var $04f0a522226a58a9$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        onBeforeMount (props) {
            let progress = props.progress ? props.progress * 100 : 0;
            this.state = {
                value: progress,
                color: "gray"
            };
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.UPDATE, this.handleUpdateProgress);
        },
        onBeforeUnmount (props, state) {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.UPDATE, this.handleUpdateProgress);
        },
        handleUpdateProgress (e) {
            if (e.ckey === this.props.ckey) {
                let value = e.value * 100;
                if (value > 100) value = 100;
                let color = '';
                if (value < 50) color = 'green';
                else if (value < 90) color = 'yellow';
                else color = 'red';
                this.update({
                    value: value,
                    color: color
                });
            }
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<div><div class="bg-red-500 hidden"></div><div class="bg-yellow-500 hidden"></div><div class="bg-green-500 hidden"></div><div class="w-full bg-gray-200 rounded-full h-4 overflow-hidden"><div expr102="expr102"></div></div></div>', [
            {
                redundantAttribute: 'expr102',
                selector: '[expr102]',
                expressions: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'class',
                        evaluate: (_scope)=>[
                                'h-full transition-all duration-300 bg-',
                                _scope.state.color,
                                '-500'
                            ].join('')
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'style',
                        evaluate: (_scope)=>[
                                'width: ',
                                _scope.state.value,
                                ' %;'
                            ].join('')
                    }
                ]
            }
        ]),
    name: 'progress-bar'
};


var $a269e4b6cc9d3dbc$exports = {};

$parcel$defineInteropFlag($a269e4b6cc9d3dbc$exports);

$parcel$export($a269e4b6cc9d3dbc$exports, "default", () => $a269e4b6cc9d3dbc$export$2e2bcd8739ae039);
var $a269e4b6cc9d3dbc$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        setInnerHTML () {
            this.root.innerHTML = this.props.html;
        },
        onMounted () {
            this.setInnerHTML();
        },
        onUpdated () {
            this.setInnerHTML();
        }
    },
    template: null,
    name: 'raw'
};


var $e4e39bdf8889a327$exports = {};

$parcel$defineInteropFlag($e4e39bdf8889a327$exports);

$parcel$export($e4e39bdf8889a327$exports, "default", () => $e4e39bdf8889a327$export$2e2bcd8739ae039);


var $e4e39bdf8889a327$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        onBeforeMount (props, state) {
            let tags = [];
            if (Array.isArray(props.value)) tags = props.value;
            else if ((typeof props.value === 'string' || props.value instanceof String) && props.value.length > 0) tags = props.value.split(",").map(function(item) {
                return item.trim();
            });
            this.state = {
                tags: tags,
                value: '' // Input corrente
            };
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.UPDATE, this.handleUpdateInput);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.RESET, this.handleResetInput);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.DELETE, this.handleDeleteTag);
        },
        onBeforeUnmount (props, state) {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.UPDATE, this.handleUpdateInput);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.RESET, this.handleResetInput);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.DELETE, this.handleDeleteTag);
        },
        handleInput (e) {
            const value = e.target.value;
            // Permetti solo numeri e un singolo punto
            const filteredValue = value.replace(/[^0-9.]/g, '').replace(/\.(?=.*\.)/g, ''); // Filtra i caratteri non consentiti e rimuovi punti multipli
            if (filteredValue !== value) this.$("input").value = filteredValue; // Aggiorna visivamente l'input
            this.update({
                value: filteredValue
            });
        },
        handleEnter (e) {
            if (e.key === 'Enter') {
                e.preventDefault(); // Evita l'invio del form
                const tag = this.state.value.trim();
                if (tag) {
                    this.addTag(tag); // Aggiungi il tag
                    this.update({
                        value: ''
                    }); // Resetta l'input
                }
            }
        },
        handleUpdateInput (e) {
            if (e.ckey === this.props.ckey) this.update({
                value: e.value
            });
        },
        handleResetInput (e) {
            if (e.ckey === this.props.ckey) {
                this.update({
                    tags: [],
                    value: ''
                });
                this.$("input").value = ""; // Resetta visivamente l'input
                (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.UPDATED, {
                    ckey: this.props.ckey,
                    value: []
                });
            }
        },
        handleDeleteTag (e) {
            // Verifica che l'evento sia destinato a questo componente
            if (e.ckey === this.props.ckey) {
                this.update({
                    tags: this.state.tags.filter((tag)=>tag !== e.text)
                });
                (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.UPDATED, {
                    ckey: this.props.ckey,
                    value: this.state.tags
                });
            }
        },
        addTag (tag) {
            if (!this.state.tags.includes(tag)) {
                this.update({
                    tags: [
                        ...this.state.tags,
                        tag
                    ]
                });
                (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.UPDATED, {
                    ckey: this.props.ckey,
                    value: this.state.tags
                });
            }
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<div class="relative"><label expr108="expr108" class="block text-sm font-medium leading-6 text-gray-900"></label><div expr109="expr109"><tag expr110="expr110"></tag><input expr111="expr111" class="flex-grow bg-transparent border-none outline-none focus:ring-0 sm:text-sm"/></div><p expr112="expr112" class="mt-3 text-sm leading-6 text-gray-600"></p></div>', [
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.props.label,
                redundantAttribute: 'expr108',
                selector: '[expr108]',
                template: template(' ', [
                    {
                        expressions: [
                            {
                                type: expressionTypes.TEXT,
                                childNodeIndex: 0,
                                evaluate: (_scope)=>_scope.props.label
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'for',
                                evaluate: (_scope)=>_scope.props.ckey
                            }
                        ]
                    }
                ])
            },
            {
                redundantAttribute: 'expr109',
                selector: '[expr109]',
                expressions: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'class',
                        evaluate: (_scope)=>[
                                'flex flex-wrap items-center gap-2 bg-gray-100 p-2 rounded-lg ',
                                _scope.props.label ? 'mt-2' : ''
                            ].join('')
                    }
                ]
            },
            {
                type: bindingTypes.EACH,
                getKey: null,
                condition: null,
                template: template(null, [
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'tag',
                        slots: [],
                        attributes: [
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'text',
                                evaluate: (_scope)=>_scope.tag
                            },
                            {
                                type: expressionTypes.ATTRIBUTE,
                                isBoolean: false,
                                name: 'ckey',
                                evaluate: (_scope)=>_scope.props.ckey
                            }
                        ]
                    }
                ]),
                redundantAttribute: 'expr110',
                selector: '[expr110]',
                itemName: 'tag',
                indexName: null,
                evaluate: (_scope)=>_scope.state.tags
            },
            {
                redundantAttribute: 'expr111',
                selector: '[expr111]',
                expressions: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'placeholder',
                        evaluate: (_scope)=>_scope.props.placeholder
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: true,
                        name: 'disabled',
                        evaluate: (_scope)=>_scope.props.is_disabled
                    },
                    {
                        type: expressionTypes.EVENT,
                        name: 'onkeydown',
                        evaluate: (_scope)=>_scope.handleEnter
                    },
                    {
                        type: expressionTypes.EVENT,
                        name: 'oninput',
                        evaluate: (_scope)=>_scope.handleInput
                    },
                    {
                        type: expressionTypes.VALUE,
                        evaluate: (_scope)=>_scope.state.value
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'name',
                        evaluate: (_scope)=>_scope.props.ckey
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'id',
                        evaluate: (_scope)=>_scope.props.ckey
                    }
                ]
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.props.show_help,
                redundantAttribute: 'expr112',
                selector: '[expr112]',
                template: template('<slot expr113="expr113"></slot>', [
                    {
                        type: bindingTypes.SLOT,
                        attributes: [],
                        name: 'default',
                        template: null,
                        redundantAttribute: 'expr113',
                        selector: '[expr113]'
                    }
                ])
            }
        ]),
    name: 'tag-area'
};


var $af24260d11ec7121$exports = {};

$parcel$defineInteropFlag($af24260d11ec7121$exports);

$parcel$export($af24260d11ec7121$exports, "default", () => $af24260d11ec7121$export$2e2bcd8739ae039);


var $af24260d11ec7121$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        deleteTag () {
            (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).INPUT.DELETE, {
                ckey: this.props.ckey,
                text: this.props.text.trim()
            });
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<div expr88="expr88" class="inline-flex items-center gap-x-1.5 rounded-full px-2 py-1 text-xs font-medium text-gray-900 ring-1 ring-inset ring-gray-200"> <button expr89="expr89" type="button" class="inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2"><span class="sr-only">Cancella</span><svg class="size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon"><path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z"/></svg></button></div>', [
            {
                redundantAttribute: 'expr88',
                selector: '[expr88]',
                expressions: [
                    {
                        type: expressionTypes.TEXT,
                        childNodeIndex: 0,
                        evaluate: (_scope)=>[
                                _scope.props.text.trim()
                            ].join('')
                    }
                ]
            },
            {
                redundantAttribute: 'expr89',
                selector: '[expr89]',
                expressions: [
                    {
                        type: expressionTypes.EVENT,
                        name: 'onclick',
                        evaluate: (_scope)=>_scope.deleteTag
                    }
                ]
            }
        ]),
    name: 'tag'
};


var $d1c77b8d9b0ba046$exports = {};

$parcel$defineInteropFlag($d1c77b8d9b0ba046$exports);

$parcel$export($d1c77b8d9b0ba046$exports, "default", () => $d1c77b8d9b0ba046$export$2e2bcd8739ae039);
var $d1c77b8d9b0ba046$export$2e2bcd8739ae039 = {
    css: null,
    exports: null,
    template: null,
    name: 'task'
};


var $e93362008c2a2742$exports = {};

$parcel$defineInteropFlag($e93362008c2a2742$exports);

$parcel$export($e93362008c2a2742$exports, "default", () => $e93362008c2a2742$export$2e2bcd8739ae039);





var $e93362008c2a2742$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        ACTIONS: (0, $315dbc24fdcb29cb$export$92a1a3b7554e9387),
        KEYS: (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92),
        onBeforeMount (props, state) {
            this.state = {
                columns: [
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: "Commessa n\xb0",
                        field: 'numero',
                        is_sortable: true,
                        is_link: true,
                        link_prefix: '#/commesse',
                        key_field: 'id_commessa'
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: 'Stato della commessa',
                        field: 'stato_commessa',
                        is_sortable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: 'Cliente',
                        field: 'cliente',
                        is_sortable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: "Societ\xe0",
                        field: 'societa',
                        is_sortable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).DATE,
                        label: 'Data',
                        field: 'data',
                        is_sortable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: 'Descrizione',
                        field: 'descrizione',
                        is_wrappable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: 'Note',
                        field: 'note',
                        is_wrappable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: 'Risorsa',
                        field: 'risorsa'
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).DATE,
                        label: 'Data inizio',
                        field: 'data_inizio',
                        is_sortable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).DATE,
                        label: 'Data fine',
                        field: 'data_fine',
                        is_sortable: true
                    },
                    {
                        type: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).TEXT,
                        label: 'Stato del task',
                        field: 'stato',
                        is_sortable: true
                    }
                ],
                rows: [],
                total_rows: 0,
                current_page: 1,
                page_size: (0, $315dbc24fdcb29cb$export$1630b5343357e8b5).N_ITEMS,
                sort_column: 'numero',
                sort_direction: 'desc',
                search_stato: '',
                search_societa: '',
                search_text: ''
            };
            //eventBus.on(EVENTS.COMBOBOX.SELECTED, this.handleComboboxSelected)
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.CHANGE_PAGE, this.handlePageChange);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.SORTING_CHANGE, this.handleSortChange);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.CLICK_BUTTON_GROUP, this.handleClickAction);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).on((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).ITEMS.REFRESH, this.handleRefresh);
        },
        async onMounted (props, state) {
            (0, $6bfc5a82c63db877$export$7659d5ac17afd4e5)().then((stati)=>{
                (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.UPDATE, {
                    ckey: 'filtro_stato_task',
                    items: stati
                });
            });
            (0, $6bfc5a82c63db877$export$9d5b4a605e86f953)().then((societa)=>{
                (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).COMBOBOX.UPDATE, {
                    ckey: 'filtro_societa',
                    items: societa
                });
            });
            this.fetchData();
        },
        onBeforeUnmount (props, state) {
            //eventBus.off(EVENTS.COMBOBOX.SELECTED, this.handleComboboxSelected)
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.CHANGE_PAGE, this.handlePageChange);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.SORTING_CHANGE, this.handleSortChange);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).UI.CLICK_BUTTON_GROUP, this.handleClickAction);
            (0, $3583489fbc257081$export$2e2bcd8739ae039).off((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).ITEMS.REFRESH, this.handleRefresh);
        },
        handleRefresh (e) {
            if (e.ckey === (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).TASK) this.fetchData();
        },
        handlePageChange (e) {
            if (e.ckey === (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).TASK) {
                this.update({
                    current_page: e.page
                });
                this.fetchData();
            }
        },
        handleSortChange (e) {
            if (e.ckey === (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).TASK) {
                this.update({
                    sort_column: e.column,
                    sort_direction: e.direction,
                    current_page: 1 // Torna alla prima pagina
                });
                this.fetchData();
            }
        },
        async fetchData () {
            const { sort_column: sort_column, sort_direction: sort_direction, current_page: current_page, search_risorsa: search_risorsa, search_stato: search_stato, search_societa: search_societa, search_text: search_text } = this.state;
            const where = {};
            if (search_stato) where.stato = search_stato;
            if (search_societa) where.societa = search_societa;
            const result = await (0, $38b2f4a478272d56$export$2e2bcd8739ae039).fetchTask(sort_column, sort_direction, current_page, search_text, where);
            if (result.items) {
                this.update({
                    rows: result.items,
                    total_rows: result.total
                });
                (0, $3583489fbc257081$export$2e2bcd8739ae039).trigger((0, $315dbc24fdcb29cb$export$fa3d5b535a2458a1).ITEMS.CHANGED, {
                    ckey: (0, $315dbc24fdcb29cb$export$f9ba527e25c2bc92).TASK,
                    items: {
                        count: this.state.total_rows,
                        results: this.state.rows
                    },
                    page: this.state.current_page
                });
            } else console.error('Errore nel caricamento dei dati:', result.error);
        },
        filter (e) {
            e.preventDefault(); // Evita il refresh della pagina
            const filtroStato = document.getElementById('filtro_stato')?.value || '';
            const filtroSocieta = document.getElementById('filtro_societa')?.value || '';
            const searchText = document.getElementById('search_text')?.value || '';
            // Aggiorna lo stato con i filtri attivi
            this.update({
                search_stato: filtroStato,
                search_societa: filtroSocieta,
                search_text: searchText,
                current_page: 1 // Reset alla prima pagina
            });
            // Effettua una nuova query
            this.fetchData();
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<div class="bg-white rounded-lg p-8 mt-5"><div class="flex justify-between"><h2 class="text-2xl/8 font-bold text-custom sm:truncate sm:text-3xl sm:tracking-tight">I tuoi task</h2><div class="filters"><form expr10="expr10" class="flex gap-4 items-center" method="POST"><combobox expr11="expr11" label ckey="filtro_societa" placeholder="Filtra per societ\xe0..."></combobox><combobox expr12="expr12" label ckey="filtro_stato_task" placeholder="Filtra per stato task..."></combobox><input-text expr13="expr13" ckey="search_text" placeholder="Cerca..."></input-text><my-button expr14="expr14" type="submit" is_square="1"></my-button></form></div></div><generic-table expr15="expr15" condensed="1"></generic-table></div>', [
            {
                redundantAttribute: 'expr10',
                selector: '[expr10]',
                expressions: [
                    {
                        type: expressionTypes.EVENT,
                        name: 'onsubmit',
                        evaluate: (_scope)=>_scope.filter
                    }
                ]
            },
            {
                type: bindingTypes.TAG,
                getComponent: getComponent,
                evaluate: (_scope)=>'combobox',
                slots: [],
                attributes: [],
                redundantAttribute: 'expr11',
                selector: '[expr11]'
            },
            {
                type: bindingTypes.TAG,
                getComponent: getComponent,
                evaluate: (_scope)=>'combobox',
                slots: [],
                attributes: [],
                redundantAttribute: 'expr12',
                selector: '[expr12]'
            },
            {
                type: bindingTypes.TAG,
                getComponent: getComponent,
                evaluate: (_scope)=>'input-text',
                slots: [],
                attributes: [],
                redundantAttribute: 'expr13',
                selector: '[expr13]'
            },
            {
                type: bindingTypes.TAG,
                getComponent: getComponent,
                evaluate: (_scope)=>'my-button',
                slots: [
                    {
                        id: 'default',
                        html: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"/></svg>',
                        bindings: []
                    }
                ],
                attributes: [],
                redundantAttribute: 'expr14',
                selector: '[expr14]'
            },
            {
                type: bindingTypes.TAG,
                getComponent: getComponent,
                evaluate: (_scope)=>'generic-table',
                slots: [
                    {
                        id: 'actions',
                        html: '<button-group expr16="expr16" slot="actions"></button-group>',
                        bindings: [
                            {
                                type: bindingTypes.TAG,
                                getComponent: getComponent,
                                evaluate: (_scope)=>'button-group',
                                slots: [],
                                attributes: [
                                    {
                                        type: expressionTypes.ATTRIBUTE,
                                        isBoolean: false,
                                        name: 'ckey',
                                        evaluate: (_scope)=>_scope.KEYS.TASK
                                    },
                                    {
                                        type: expressionTypes.ATTRIBUTE,
                                        isBoolean: false,
                                        name: 'row',
                                        evaluate: (_scope)=>_scope.row
                                    },
                                    {
                                        type: expressionTypes.ATTRIBUTE,
                                        isBoolean: false,
                                        name: 'options',
                                        evaluate: (_scope)=>[].join('')
                                    }
                                ],
                                redundantAttribute: 'expr16',
                                selector: '[expr16]'
                            }
                        ]
                    }
                ],
                attributes: [
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'ckey',
                        evaluate: (_scope)=>_scope.KEYS.TASK
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'columns',
                        evaluate: (_scope)=>_scope.state.columns
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'rows',
                        evaluate: (_scope)=>_scope.state.rows
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'total_rows',
                        evaluate: (_scope)=>_scope.state.total_rows
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'page_size',
                        evaluate: (_scope)=>_scope.state.page_size
                    },
                    {
                        type: expressionTypes.ATTRIBUTE,
                        isBoolean: false,
                        name: 'current_page',
                        evaluate: (_scope)=>_scope.state.current_page
                    }
                ],
                redundantAttribute: 'expr15',
                selector: '[expr15]'
            }
        ]),
    name: 'tasks'
};


$c5cf553bae6e66d8$exports = {
    "accordion-body": $3f8c355ba50d873e$exports,
    "accordion-title": $b26998206af91f57$exports,
    "breadcrumb-item": $27e632b64d7184e3$exports,
    "breadcrumb": $5eb7052bb970cf6d$exports,
    "button-back": $ae70fc2a1c30fe5d$exports,
    "button-group": $a841f4ce7a69f452$exports,
    "button-submit": $960c062c5376ce59$exports,
    "combobox": $7214133ecec21835$exports,
    "commessa": $f7bce1e7df6e4bf1$exports,
    "commesse": $fced7872121cab9a$exports,
    "css-switcher": $fde500233e5dd9c4$exports,
    "generic-table": $a4ad69f5498324d5$exports,
    "heading-page": $be2b04ec9e9d6296$exports,
    "input-file": $d5fbd27e39637ef7$exports,
    "input-text": $0a6df5d38cff0a58$exports,
    "item-nav": $d36cc654f39a0d98$exports,
    "login": $753e427c37b27179$exports,
    "logout-button": $2c8400e83d6005e7$exports,
    "main-navi": $65fbaf88ca075162$exports,
    "modal-delete": $7dea095c3e07eee6$exports,
    "modal-error": $64fb74d683d53ebe$exports,
    "modal-ore": $0a7605ecbf65b52d$exports,
    "modal-result": $75d85ae6320b9446$exports,
    "my-button": $42da252a95c62ff0$exports,
    "my-checkbox": $7a41a012652c63f3$exports,
    "my-footer": $1c6e53c08ab0a86e$exports,
    "my-label": $8b0922ca846c25f2$exports,
    "my-textarea": $625521e3c1312feb$exports,
    "pagination": $7376bb48008a8a86$exports,
    "progress-bar": $04f0a522226a58a9$exports,
    "raw": $a269e4b6cc9d3dbc$exports,
    "tag-area": $e4e39bdf8889a327$exports,
    "tag": $af24260d11ec7121$exports,
    "task": $d1c77b8d9b0ba046$exports,
    "tasks": $e93362008c2a2742$exports
};


var $ea8b5be144bee4e5$export$2e2bcd8739ae039 = ()=>{
    Object.entries($c5cf553bae6e66d8$exports).map(([name, component])=>{
        (0, $e7d6978190b9d367$export$6503ec6e8aabbaf)(name, component.default);
        return {
            name: name,
            component: component
        };
    });
};



var $cAQNV = parcelRequire("cAQNV");

// Registra i componenti globali come header, footer, ecc
(0, $ea8b5be144bee4e5$export$2e2bcd8739ae039)();
// Registra globalmente Router e Route
$e7d6978190b9d367$export$6503ec6e8aabbaf('router', (0, $cAQNV.Router));
$e7d6978190b9d367$export$6503ec6e8aabbaf('route', (0, $cAQNV.Route));
// Monta il componente principale dell'applicazione
const $2b6e161c9edcf319$var$mountApp = $5e14b8d5841bdab5$export$d8556a2a8f973135((0, $422a886e660c1a9e$export$2e2bcd8739ae039));
//const mountApp = riot.component(Demo)
const $2b6e161c9edcf319$var$app = $2b6e161c9edcf319$var$mountApp(document.getElementById('root'));


//# sourceMappingURL=nsg.originiagency.it.f251ce39.js.map
